{
  "level": "mt09",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt09",
    "objects": "AREAS.E3:mt09.e3",
    "mesh": "TREES.E3:mt09.e3"
  },
  "spawn_point": {
    "position": [
      314.4898682510609,
      -3102.5964417762966,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      314.4898682510609,
      -3002.5964417762966,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -6158.31884765625,
      -4598.06396484375,
      -300.0
    ],
    "bbox_max": [
      2014.793212890625,
      6871.484375,
      1832.025390625
    ],
    "vertex_count": 6558,
    "vertices": [
      [
        -3714.021240234375,
        -2323.5537109375,
        1179.0999755859375
      ],
      [
        -5545.396484375,
        4741.14404296875,
        334.12945556640625
      ],
      [
        -6158.31884765625,
        3750.8916015625,
        976.300048828125
      ],
      [
        -5532.32763671875,
        4687.75390625,
        347.8716735839844
      ],
      [
        -5504.708984375,
        4729.087890625,
        -22.699951171875
      ],
      [
        -3347.652587890625,
        -3101.035888671875,
        -300.0
      ],
      [
        -3642.102783203125,
        -2017.578125,
        -300.0
      ],
      [
        -5704.521484375,
        4430.04736328125,
        976.300048828125
      ],
      [
        -5573.5615234375,
        4626.04296875,
        901.1307983398438
      ],
      [
        -3756.713134765625,
        8.120121955871582,
        -300.0
      ],
      [
        -3921.887939453125,
        1500.0,
        -300.0
      ],
      [
        -3921.887939453125,
        1500.0,
        -300.0
      ],
      [
        -4008.181640625,
        2279.415283203125,
        -300.0
      ],
      [
        -3457.04638671875,
        -2698.510498046875,
        -300.0
      ],
      [
        -3756.713134765625,
        8.120121002197266,
        -300.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        -11.839269638061523
      ],
      [
        -5532.32763671875,
        4687.75390625,
        347.87164306640625
      ],
      [
        -5174.01171875,
        5224.01171875,
        -11.83929443359375
      ],
      [
        -5158.470703125,
        5234.39599609375,
        -22.699951171875
      ],
      [
        -4474.53173828125,
        4475.62646484375,
        150.0
      ],
      [
        -4591.423828125,
        5531.40869140625,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        150.0
      ],
      [
        -4599.86376953125,
        5607.64453125,
        150.0
      ],
      [
        -4485.7236328125,
        5683.91064453125,
        -0.000560760498046875
      ],
      [
        -4478.6357421875,
        5688.64697265625,
        -22.699951171875
      ],
      [
        -5174.01171875,
        5224.01171875,
        150.00001525878906
      ],
      [
        -5335.22314453125,
        4982.7412109375,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        671.79443359375
      ],
      [
        -5174.01171875,
        5224.01171875,
        671.7944946289062
      ],
      [
        -4901.7099609375,
        5405.95751953125,
        546.6788940429688
      ],
      [
        -3613.51416015625,
        20.37681770324707,
        -300.0
      ],
      [
        -3777.33154296875,
        1500.0,
        -300.0
      ],
      [
        -3777.331787109375,
        1500.0,
        -300.0
      ],
      [
        -3875.56787109375,
        2387.280029296875,
        -300.0
      ],
      [
        -3262.646728515625,
        -3148.702880859375,
        -300.0
      ],
      [
        -3613.51416015625,
        20.376815795898438,
        -300.0
      ],
      [
        -3861.632568359375,
        2261.417236328125,
        -300.0
      ],
      [
        -4468.451171875,
        5695.4521484375,
        -22.699951171875
      ],
      [
        -662.673828125,
        272.9451904296875,
        -300.0
      ],
      [
        -1124.694091796875,
        1500.0,
        -300.0
      ],
      [
        -1124.694091796875,
        1500.0,
        -300.0
      ],
      [
        -1912.4608154296875,
        3592.1884765625,
        -300.0
      ],
      [
        -313.68585205078125,
        -653.9140625,
        -300.0
      ],
      [
        -662.6739501953125,
        272.9451599121094,
        -300.0
      ],
      [
        -2916.7197265625,
        3191.259765625,
        124.0964126586914
      ],
      [
        -3179.85791015625,
        3702.7177734375,
        150.0
      ],
      [
        -4020.92431640625,
        5936.4619140625,
        150.0
      ],
      [
        -2650.559326171875,
        3351.3662109375,
        4.254161834716797
      ],
      [
        -2916.7197265625,
        3191.259765625,
        124.09642028808594
      ],
      [
        -4038.378662109375,
        5982.8173828125,
        150.0
      ],
      [
        -3662.5146484375,
        6233.96142578125,
        -22.699951171875
      ],
      [
        -4599.8642578125,
        5607.64453125,
        150.0
      ],
      [
        -69.49658203125,
        -3472.765869140625,
        0.0
      ],
      [
        -567.3336181640625,
        -2150.5869140625,
        0.0
      ],
      [
        -567.3335571289062,
        -2150.5869140625,
        0.0
      ],
      [
        -648.318115234375,
        -1935.504638671875,
        0.0
      ],
      [
        -1609.538818359375,
        -106.08950805664062,
        100.0
      ],
      [
        -1881.255859375,
        615.5494384765625,
        100.0
      ],
      [
        -2150.26611328125,
        1330.0,
        100.0
      ],
      [
        -1877.8707275390625,
        1330.0,
        0.0
      ],
      [
        -2720.0,
        1330.0,
        100.0
      ],
      [
        -390.7595520019531,
        -2699.2919921875,
        11.023937225341797
      ],
      [
        -497.7729187011719,
        -2442.438232421875,
        14.805465698242188
      ],
      [
        -292.56121826171875,
        -2917.358642578125,
        5.11700439453125
      ],
      [
        -329.32183837890625,
        -2846.7548828125,
        8.852845191955566
      ],
      [
        -334.9900817871094,
        -2835.53662109375,
        3.064664363861084
      ],
      [
        -292.2781066894531,
        -2917.978271484375,
        5.0987548828125
      ],
      [
        -292.56121826171875,
        -2917.358642578125,
        5.117009162902832
      ],
      [
        -334.9900817871094,
        -2835.53662109375,
        3.064878463745117
      ],
      [
        -335.3236389160156,
        -2835.39892578125,
        1.4134142398834229
      ],
      [
        -335.3236389160156,
        -2835.39892578125,
        1.413412094116211
      ],
      [
        -335.6207275390625,
        -2835.25341796875,
        0.0
      ],
      [
        -292.2781066894531,
        -2917.978271484375,
        5.098724842071533
      ],
      [
        -292.18988037109375,
        -2918.07177734375,
        5.079243183135986
      ],
      [
        -450.536376953125,
        -2460.782470703125,
        0.0
      ],
      [
        -485.1326599121094,
        -2440.3291015625,
        9.873533248901367
      ],
      [
        -352.1466064453125,
        -2722.090576171875,
        0.0
      ],
      [
        -384.03460693359375,
        -2703.2626953125,
        9.103973388671875
      ],
      [
        -390.7595520019531,
        -2699.2919921875,
        11.023941040039062
      ],
      [
        -384.03460693359375,
        -2703.2626953125,
        9.103975296020508
      ],
      [
        -269.1846923828125,
        -2942.424560546875,
        0.0
      ],
      [
        -480.08074951171875,
        -2382.317138671875,
        0.0
      ],
      [
        -542.4313354492188,
        -2341.778076171875,
        0.0
      ],
      [
        -542.46337890625,
        -2341.63623046875,
        0.16411590576171875
      ],
      [
        -499.9072265625,
        -2365.748046875,
        4.988278388977051
      ],
      [
        -499.9072570800781,
        -2365.748046875,
        4.988278388977051
      ],
      [
        -542.46337890625,
        -2341.63623046875,
        0.16411671042442322
      ],
      [
        -540.2335815429688,
        -2340.52392578125,
        16.305919647216797
      ],
      [
        -506.6995544433594,
        -2420.4609375,
        15.044661521911621
      ],
      [
        -485.1326599121094,
        -2440.3291015625,
        9.87353515625
      ],
      [
        -506.69952392578125,
        -2420.4609375,
        15.044677734375
      ],
      [
        -507.00762939453125,
        -2420.27294921875,
        15.131795883178711
      ],
      [
        -563.8067626953125,
        -2541.61572265625,
        52.75651931762695
      ],
      [
        -476.63665771484375,
        -2762.5009765625,
        51.287872314453125
      ],
      [
        -563.8067626953125,
        -2541.61572265625,
        52.75653076171875
      ],
      [
        -645.8916015625,
        -2424.538818359375,
        66.70760345458984
      ],
      [
        -998.4295654296875,
        -2068.663818359375,
        100.0
      ],
      [
        -989.39013671875,
        -2052.855712890625,
        100.0
      ],
      [
        -956.9907836914062,
        -2109.678466796875,
        100.0
      ],
      [
        -998.4295654296875,
        -2068.663818359375,
        100.00000762939453
      ],
      [
        -476.63665771484375,
        -2762.5009765625,
        51.287872314453125
      ],
      [
        -465.1822814941406,
        -2792.019775390625,
        51.16314697265625
      ],
      [
        -464.95758056640625,
        -2792.09521484375,
        51.09109115600586
      ],
      [
        -465.1822814941406,
        -2792.019775390625,
        51.16314697265625
      ],
      [
        -837.638427734375,
        -2158.8701171875,
        100.0
      ],
      [
        -804.9539184570312,
        -2192.13916015625,
        0.0
      ],
      [
        -809.6333618164062,
        -2190.9951171875,
        94.53701782226562
      ],
      [
        -835.8177490234375,
        -2160.974609375,
        100.0
      ],
      [
        -989.39013671875,
        -2052.855712890625,
        100.0
      ],
      [
        -952.0017700195312,
        -2059.164794921875,
        100.0
      ],
      [
        -734.2352905273438,
        -2298.534912109375,
        81.7224349975586
      ],
      [
        -736.9662475585938,
        -2295.762939453125,
        82.34185791015625
      ],
      [
        -730.8558959960938,
        -2298.567626953125,
        0.0
      ],
      [
        -895.05859375,
        -2087.986083984375,
        0.0
      ],
      [
        -909.219970703125,
        -2074.339599609375,
        60.354286193847656
      ],
      [
        -736.9662475585938,
        -2295.762939453125,
        82.34185791015625
      ],
      [
        -737.7894287109375,
        -2293.465576171875,
        82.32648468017578
      ],
      [
        -736.849853515625,
        -2292.069580078125,
        35.78874588012695
      ],
      [
        -736.849853515625,
        -2292.069580078125,
        35.78873825073242
      ],
      [
        -736.4619750976562,
        -2290.515380859375,
        0.0
      ],
      [
        -930.3984375,
        -2064.103271484375,
        100.0
      ],
      [
        -952.0017700195312,
        -2059.164794921875,
        100.0
      ],
      [
        -912.9091186523438,
        -2070.869140625,
        77.9502944946289
      ],
      [
        -930.3984375,
        -2064.103271484375,
        100.0
      ],
      [
        -916.883544921875,
        -2067.269775390625,
        100.0
      ],
      [
        -909.219970703125,
        -2074.339599609375,
        60.354286193847656
      ],
      [
        -912.9091186523438,
        -2070.869140625,
        77.9502944946289
      ],
      [
        -874.2844848632812,
        -2092.55859375,
        0.0
      ],
      [
        -882.4772338867188,
        -2083.308837890625,
        42.681663513183594
      ],
      [
        -882.4772338867188,
        -2083.308837890625,
        42.68165969848633
      ],
      [
        -889.1314697265625,
        -2076.03125,
        81.32788848876953
      ],
      [
        -889.1314086914062,
        -2076.03125,
        81.32788848876953
      ],
      [
        -891.9275512695312,
        -2073.11669921875,
        100.0
      ],
      [
        -710.732177734375,
        -2163.8203125,
        0.0
      ],
      [
        -812.0902709960938,
        -2094.26025390625,
        82.06751251220703
      ],
      [
        -791.312744140625,
        -2106.671875,
        76.15544891357422
      ],
      [
        -712.3984375,
        -2160.820068359375,
        12.31456184387207
      ],
      [
        -712.3984375,
        -2160.820068359375,
        12.314563751220703
      ],
      [
        -791.312744140625,
        -2106.671875,
        76.15544128417969
      ],
      [
        -720.233154296875,
        -2145.23828125,
        55.392127990722656
      ],
      [
        -771.92236328125,
        -2234.230712890625,
        86.669189453125
      ],
      [
        -659.8509521484375,
        -2403.476806640625,
        68.9208984375
      ],
      [
        -694.7425537109375,
        -2341.754150390625,
        73.1982421875
      ],
      [
        -704.1259765625,
        -2329.094970703125,
        74.8931884765625
      ],
      [
        -739.3873901367188,
        -2289.005859375,
        82.296630859375
      ],
      [
        -752.3124389648438,
        -2256.71337890625,
        82.57786560058594
      ],
      [
        -739.3873901367188,
        -2289.005859375,
        82.29664611816406
      ],
      [
        -699.4259033203125,
        -2333.46923828125,
        73.77235412597656
      ],
      [
        -704.1259765625,
        -2329.094970703125,
        74.89317321777344
      ],
      [
        -699.1726684570312,
        -2333.704833984375,
        73.71197509765625
      ],
      [
        -694.7425537109375,
        -2341.754150390625,
        73.1982421875
      ],
      [
        -699.1726684570312,
        -2333.704833984375,
        73.71197509765625
      ],
      [
        -659.8509521484375,
        -2403.476806640625,
        68.92090606689453
      ],
      [
        -645.8916015625,
        -2424.538818359375,
        66.70761108398438
      ],
      [
        -833.8198852539062,
        -2088.039306640625,
        89.18482971191406
      ],
      [
        -812.0902709960938,
        -2094.26025390625,
        82.06751251220703
      ],
      [
        -752.9208374023438,
        -2255.193359375,
        82.59112548828125
      ],
      [
        -771.92236328125,
        -2234.230712890625,
        86.66918182373047
      ],
      [
        -752.9208374023438,
        -2255.193359375,
        82.59110260009766
      ],
      [
        -833.81982421875,
        -2088.039306640625,
        89.18482971191406
      ],
      [
        -866.6705932617188,
        -2079.0341796875,
        100.0
      ],
      [
        -337.7999267578125,
        -2834.813232421875,
        10.3145751953125
      ],
      [
        -335.0601501464844,
        -2835.733642578125,
        9.436009407043457
      ],
      [
        -334.97283935546875,
        -2835.57080078125,
        3.0822858810424805
      ],
      [
        -543.6614990234375,
        -2338.3798828125,
        17.26797866821289
      ],
      [
        -602.19873046875,
        -2296.641845703125,
        32.98837661743164
      ],
      [
        -689.1589965820312,
        -2162.098388671875,
        46.31494140625
      ],
      [
        -676.2098388671875,
        -2187.470947265625,
        45.06836700439453
      ],
      [
        -636.162353515625,
        -2275.20458984375,
        23.676090240478516
      ],
      [
        -543.6614990234375,
        -2338.3798828125,
        17.267974853515625
      ],
      [
        -689.1589965820312,
        -2162.098388671875,
        46.31494140625
      ],
      [
        -655.5964965820312,
        -2241.480224609375,
        44.966552734375
      ],
      [
        -636.0657348632812,
        -2272.493896484375,
        42.083526611328125
      ],
      [
        -655.5964965820312,
        -2241.480224609375,
        44.966556549072266
      ],
      [
        -659.0798950195312,
        -2236.3203125,
        45.532135009765625
      ],
      [
        -602.19873046875,
        -2296.641845703125,
        32.98837661743164
      ],
      [
        -633.2545166015625,
        -2276.9580078125,
        41.668548583984375
      ],
      [
        -633.2545166015625,
        -2276.9580078125,
        41.66855239868164
      ],
      [
        -497.7729187011719,
        -2442.438232421875,
        14.805472373962402
      ],
      [
        -508.0791015625,
        -2421.639404296875,
        15.71405029296875
      ],
      [
        -508.0791320800781,
        -2421.639404296875,
        15.714020729064941
      ],
      [
        -508.69366455078125,
        -2419.84130859375,
        15.6910400390625
      ],
      [
        -508.50347900390625,
        -2419.360107421875,
        15.554757118225098
      ],
      [
        -508.6936340332031,
        -2419.84130859375,
        15.691069602966309
      ],
      [
        -508.50347900390625,
        -2419.360107421875,
        15.55474853515625
      ],
      [
        -335.11419677734375,
        -2835.6298828125,
        9.44146728515625
      ],
      [
        -337.7999267578125,
        -2834.813232421875,
        10.314589500427246
      ],
      [
        -335.11419677734375,
        -2835.6298828125,
        9.44150161743164
      ],
      [
        -2422.66162109375,
        1330.0,
        200.0
      ],
      [
        -957.5567016601562,
        -2110.5556640625,
        137.72267150878906
      ],
      [
        -1020.9271850585938,
        -2048.39306640625,
        152.39418029785156
      ],
      [
        -929.2406005859375,
        -2061.882080078125,
        120.59938049316406
      ],
      [
        -1014.0064697265625,
        -2040.4329833984375,
        148.753173828125
      ],
      [
        -983.4622802734375,
        -2047.3272705078125,
        138.49298095703125
      ],
      [
        -1020.9271850585938,
        -2048.39306640625,
        152.3941650390625
      ],
      [
        -1014.0064697265625,
        -2040.4329833984375,
        148.753173828125
      ],
      [
        -929.2406005859375,
        -2061.882080078125,
        120.59938049316406
      ],
      [
        -983.4622802734375,
        -2047.3272705078125,
        138.49298095703125
      ],
      [
        -837.6484985351562,
        -2158.875732421875,
        100.3819580078125
      ],
      [
        -2708.39404296875,
        6871.484375,
        0.0
      ],
      [
        -3711.9189453125,
        6200.95068359375,
        0.0
      ],
      [
        -424.9492492675781,
        4036.23583984375,
        150.0
      ],
      [
        -2480.3212890625,
        6869.3154296875,
        150.0
      ],
      [
        -2708.39404296875,
        6871.484375,
        150.0
      ],
      [
        -4038.37890625,
        5982.8173828125,
        150.0
      ],
      [
        1759.1138916015625,
        -2825.67236328125,
        100.0
      ],
      [
        1976.828125,
        -3322.8564453125,
        100.0
      ],
      [
        29.061641693115234,
        -3206.073486328125,
        100.0
      ],
      [
        232.30113220214844,
        -3504.326171875,
        100.0
      ],
      [
        -30.455476760864258,
        -3137.776123046875,
        100.0
      ],
      [
        -211.47071838378906,
        -3008.524169921875,
        100.0
      ],
      [
        787.9160766601562,
        -4420.2060546875,
        100.0
      ],
      [
        729.4486083984375,
        -4312.38916015625,
        100.0
      ],
      [
        207.70118713378906,
        -3615.822509765625,
        100.0
      ],
      [
        232.30113220214844,
        -3504.326171875,
        100.0
      ],
      [
        271.6065368652344,
        -3707.400146484375,
        100.0
      ],
      [
        204.65553283691406,
        -3632.149169921875,
        100.0
      ],
      [
        382.968505859375,
        -3725.4296875,
        100.0
      ],
      [
        283.3534240722656,
        -3719.764892578125,
        100.0
      ],
      [
        387.8497619628906,
        -3723.18310546875,
        0.0
      ],
      [
        283.3534240722656,
        -3719.764892578125,
        100.0
      ],
      [
        271.6065368652344,
        -3707.400146484375,
        100.0
      ],
      [
        204.65553283691406,
        -3632.149169921875,
        100.0
      ],
      [
        207.70118713378906,
        -3615.822509765625,
        100.0
      ],
      [
        728.837158203125,
        -4223.58056640625,
        0.0
      ],
      [
        720.5958862304688,
        -4295.87158203125,
        100.0
      ],
      [
        726.4815063476562,
        -4229.533203125,
        100.0
      ],
      [
        787.9160766601562,
        -4420.2060546875,
        100.0
      ],
      [
        815.3750610351562,
        -4427.73583984375,
        100.0
      ],
      [
        720.5958862304688,
        -4295.87158203125,
        100.0
      ],
      [
        729.4486083984375,
        -4312.38916015625,
        100.0
      ],
      [
        756.310302734375,
        -4272.7587890625,
        94.172119140625
      ],
      [
        756.1282958984375,
        -4265.43603515625,
        19.196945190429688
      ],
      [
        755.313232421875,
        -4262.43359375,
        0.0
      ],
      [
        756.1282958984375,
        -4265.43603515625,
        19.196945190429688
      ],
      [
        -381.2264404296875,
        -2686.581298828125,
        100.0
      ],
      [
        -419.0001525878906,
        -2596.448486328125,
        100.0
      ],
      [
        -282.2563171386719,
        -2746.064208984375,
        66.50694274902344
      ],
      [
        -305.09869384765625,
        -2727.182861328125,
        100.0
      ],
      [
        -292.8008728027344,
        -2733.74169921875,
        100.0
      ],
      [
        -381.2264404296875,
        -2686.581298828125,
        100.0
      ],
      [
        -305.09869384765625,
        -2727.182861328125,
        100.0
      ],
      [
        -269.94976806640625,
        -2757.86572265625,
        0.0
      ],
      [
        -282.2563171386719,
        -2746.064208984375,
        66.50694274902344
      ],
      [
        -495.3668212890625,
        -2431.851806640625,
        50.84193420410156
      ],
      [
        -490.261474609375,
        -2435.604248046875,
        11.103279113769531
      ],
      [
        -507.0077819824219,
        -2420.27294921875,
        15.1318359375
      ],
      [
        -495.3667907714844,
        -2431.851806640625,
        50.84194564819336
      ],
      [
        -495.2618713378906,
        -2432.39990234375,
        55.0307502746582
      ],
      [
        -223.589599609375,
        -2995.22216796875,
        100.0
      ],
      [
        -274.785888671875,
        -2940.561279296875,
        100.00000762939453
      ],
      [
        -293.4440612792969,
        -2918.3369140625,
        44.0506591796875
      ],
      [
        -211.47071838378906,
        -3008.524169921875,
        100.0
      ],
      [
        -223.589599609375,
        -2995.22216796875,
        100.0
      ],
      [
        -5.412925720214844,
        -3155.48193359375,
        100.0
      ],
      [
        -30.455474853515625,
        -3137.776123046875,
        100.0
      ],
      [
        -295.7951354980469,
        -2913.1083984375,
        43.09381866455078
      ],
      [
        -329.3223571777344,
        -2846.75390625,
        8.852900505065918
      ],
      [
        -293.4440612792969,
        -2918.3369140625,
        44.05067443847656
      ],
      [
        -295.7951354980469,
        -2913.1083984375,
        43.09382629394531
      ],
      [
        -565.5453491210938,
        -2541.905517578125,
        100.0
      ],
      [
        -489.2601318359375,
        -2735.3369140625,
        100.0
      ],
      [
        -565.5453491210938,
        -2541.905517578125,
        100.0
      ],
      [
        -639.9016723632812,
        -2435.106201171875,
        100.0
      ],
      [
        -489.2601318359375,
        -2735.3369140625,
        100.0
      ],
      [
        -466.93536376953125,
        -2792.896240234375,
        100.0
      ],
      [
        -835.8177490234375,
        -2160.974609375,
        100.0
      ],
      [
        -809.6333618164062,
        -2190.9951171875,
        94.53701782226562
      ],
      [
        -809.90380859375,
        -2190.928955078125,
        100.0
      ],
      [
        -734.9911499023438,
        -2298.52734375,
        100.0
      ],
      [
        -737.4099731445312,
        -2296.04931640625,
        100.0
      ],
      [
        -734.2352905273438,
        -2298.534912109375,
        81.7224349975586
      ],
      [
        -737.4099731445312,
        -2296.04931640625,
        100.0
      ],
      [
        -738.1463012695312,
        -2293.99560546875,
        100.0
      ],
      [
        -737.7894287109375,
        -2293.465576171875,
        82.32648468017578
      ],
      [
        -466.5007019042969,
        -2793.04638671875,
        100.0
      ],
      [
        -466.93536376953125,
        -2792.896240234375,
        100.0
      ],
      [
        -464.95758056640625,
        -2792.09521484375,
        51.09109115600586
      ],
      [
        -724.39501953125,
        -2136.9609375,
        78.2761001586914
      ],
      [
        -811.104736328125,
        -2092.4970703125,
        100.0
      ],
      [
        -726.2146606445312,
        -2134.50732421875,
        100.0
      ],
      [
        -724.39501953125,
        -2136.9609375,
        78.2761001586914
      ],
      [
        -720.233154296875,
        -2145.23828125,
        55.392127990722656
      ],
      [
        -816.5322875976562,
        -2092.988525390625,
        83.52244567871094
      ],
      [
        -660.733642578125,
        -2403.52734375,
        100.0
      ],
      [
        -693.5823364257812,
        -2345.208740234375,
        100.0
      ],
      [
        -775.1787719726562,
        -2231.068115234375,
        100.0
      ],
      [
        -706.2094116210938,
        -2328.01416015625,
        100.0
      ],
      [
        -740.3533325195312,
        -2287.839599609375,
        100.0
      ],
      [
        -752.6417236328125,
        -2257.118896484375,
        100.0
      ],
      [
        -752.3124389648438,
        -2256.71337890625,
        82.57786560058594
      ],
      [
        -740.3533325195312,
        -2287.839599609375,
        100.0
      ],
      [
        -699.9646606445312,
        -2333.877685546875,
        100.0
      ],
      [
        -706.2094116210938,
        -2328.01416015625,
        100.0
      ],
      [
        -699.4259033203125,
        -2333.46923828125,
        73.77235412597656
      ],
      [
        -753.378173828125,
        -2255.27783203125,
        100.0
      ],
      [
        -775.1787719726562,
        -2231.068115234375,
        100.0
      ],
      [
        -753.378173828125,
        -2255.27783203125,
        100.0
      ],
      [
        -838.9634399414062,
        -2086.62939453125,
        90.87821197509766
      ],
      [
        -866.6705932617188,
        -2079.0341796875,
        100.0
      ],
      [
        -839.9876708984375,
        -2085.28564453125,
        100.0
      ],
      [
        -660.733642578125,
        -2403.52734375,
        100.0
      ],
      [
        -639.9016723632812,
        -2435.106201171875,
        100.0
      ],
      [
        -699.62255859375,
        -2334.198974609375,
        100.0
      ],
      [
        -693.5823364257812,
        -2345.208740234375,
        100.0
      ],
      [
        -699.62255859375,
        -2334.198974609375,
        100.0
      ],
      [
        -834.4826049804688,
        -2087.857666015625,
        89.40303039550781
      ],
      [
        -835.6233520507812,
        -2086.30810546875,
        100.0
      ],
      [
        -822.662353515625,
        -2089.3447265625,
        100.0
      ],
      [
        -822.662353515625,
        -2089.3447265625,
        100.0
      ],
      [
        -811.104736328125,
        -2092.4970703125,
        100.0
      ],
      [
        -419.0001525878906,
        -2596.448486328125,
        100.00001525878906
      ],
      [
        -489.93206787109375,
        -2453.637939453125,
        100.0
      ],
      [
        -489.9320983886719,
        -2453.637939453125,
        100.0
      ],
      [
        -493.81695556640625,
        -2442.234130859375,
        100.0
      ],
      [
        -493.8169250488281,
        -2442.234130859375,
        100.0
      ],
      [
        -494.392822265625,
        -2436.940673828125,
        89.73331451416016
      ],
      [
        -492.83447265625,
        -2440.193603515625,
        100.0
      ],
      [
        -494.3927917480469,
        -2436.940673828125,
        89.73331451416016
      ],
      [
        -362.7503356933594,
        -2828.910888671875,
        100.0
      ],
      [
        -300.6409606933594,
        -2906.739501953125,
        100.0
      ],
      [
        -336.30511474609375,
        -2838.052734375,
        100.00001525878906
      ],
      [
        -335.0601501464844,
        -2835.733642578125,
        9.436009407043457
      ],
      [
        -295.1187744140625,
        -2918.852294921875,
        100.0
      ],
      [
        -300.6409606933594,
        -2906.739501953125,
        100.00001525878906
      ],
      [
        -293.3972473144531,
        -2920.6904296875,
        100.00000762939453
      ],
      [
        -295.1187744140625,
        -2918.852294921875,
        100.00000762939453
      ],
      [
        -292.7136535644531,
        -2919.20703125,
        46.240901947021484
      ],
      [
        -336.8768310546875,
        -2836.95166015625,
        100.0
      ],
      [
        -362.7503356933594,
        -2828.910888671875,
        100.0
      ],
      [
        -336.8768310546875,
        -2836.95166015625,
        100.00001525878906
      ],
      [
        -579.6734008789062,
        -2308.50341796875,
        54.787139892578125
      ],
      [
        -629.0099487304688,
        -2274.531494140625,
        100.0
      ],
      [
        -589.16552734375,
        -2298.828125,
        100.0
      ],
      [
        -629.0099487304688,
        -2274.531494140625,
        100.0
      ],
      [
        -647.9369506835938,
        -2244.9111328125,
        100.0
      ],
      [
        -716.7096557617188,
        -2140.853271484375,
        77.03016662597656
      ],
      [
        -714.1131591796875,
        -2148.558837890625,
        53.60438537597656
      ],
      [
        -716.7096557617188,
        -2140.853271484375,
        77.03016662597656
      ],
      [
        -714.90673828125,
        -2140.103515625,
        100.0
      ],
      [
        -702.4977416992188,
        -2146.244384765625,
        100.0
      ],
      [
        -684.5930786132812,
        -2156.800048828125,
        78.86669158935547
      ],
      [
        -702.4977416992188,
        -2146.244384765625,
        100.0
      ],
      [
        -687.770263671875,
        -2154.12646484375,
        100.0
      ],
      [
        -647.9369506835938,
        -2244.9111328125,
        100.00000762939453
      ],
      [
        -655.7601928710938,
        -2233.501220703125,
        100.0
      ],
      [
        -723.8789672851562,
        -2137.222412109375,
        78.19243621826172
      ],
      [
        -722.3139038085938,
        -2136.437744140625,
        100.0
      ],
      [
        -723.8789672851562,
        -2137.222412109375,
        78.19243621826172
      ],
      [
        -722.3239135742188,
        -2141.080078125,
        66.8880386352539
      ],
      [
        -570.3208618164062,
        -2319.371337890625,
        24.427444458007812
      ],
      [
        -579.6734008789062,
        -2308.50341796875,
        54.78714370727539
      ],
      [
        1939.6932373046875,
        -3385.396484375,
        100.0
      ],
      [
        1758.7371826171875,
        -3675.006591796875,
        100.0
      ],
      [
        73.42620086669922,
        -3119.670654296875,
        100.0
      ],
      [
        216.80609130859375,
        -3288.1298828125,
        100.0
      ],
      [
        -1850.0,
        1330.0,
        100.0
      ],
      [
        -2150.26611328125,
        1330.0,
        100.0
      ],
      [
        -2663.149658203125,
        3382.115234375,
        100.0
      ],
      [
        -2863.203369140625,
        3223.451904296875,
        100.0
      ],
      [
        -392.8196105957031,
        -2425.170654296875,
        56.183597564697266
      ],
      [
        -537.8623046875,
        -2330.7607421875,
        100.0
      ],
      [
        -412.5116882324219,
        -2411.125732421875,
        100.0
      ],
      [
        -684.153076171875,
        -2156.062255859375,
        100.0
      ],
      [
        -558.556884765625,
        -2317.492919921875,
        100.0
      ],
      [
        -544.6834106445312,
        -2325.952880859375,
        100.0
      ],
      [
        -537.8623046875,
        -2330.7607421875,
        100.0
      ],
      [
        -542.5712890625,
        -2327.388427734375,
        100.0
      ],
      [
        -542.5712890625,
        -2327.388427734375,
        100.0
      ],
      [
        -544.6834106445312,
        -2325.952880859375,
        100.0
      ],
      [
        -565.2019653320312,
        -2313.44091796875,
        100.0
      ],
      [
        -377.20721435546875,
        -2436.873779296875,
        19.15047264099121
      ],
      [
        -392.8196105957031,
        -2425.170654296875,
        56.183597564697266
      ],
      [
        -392.8873596191406,
        -2439.067138671875,
        0.0
      ],
      [
        -378.0712890625,
        -2437.6767578125,
        15.339889526367188
      ],
      [
        -377.20721435546875,
        -2436.873779296875,
        19.15047264099121
      ],
      [
        -378.0712890625,
        -2437.6767578125,
        15.339889526367188
      ],
      [
        -360.5828857421875,
        -2447.981689453125,
        21.301130294799805
      ],
      [
        -392.76824951171875,
        -2424.856689453125,
        66.89019775390625
      ],
      [
        -368.32086181640625,
        -2455.599853515625,
        0.0
      ],
      [
        -360.08795166015625,
        -2451.3544921875,
        13.21284294128418
      ],
      [
        -392.76824951171875,
        -2424.856689453125,
        66.89019775390625
      ],
      [
        -404.895263671875,
        -2416.557861328125,
        83.05286407470703
      ],
      [
        -360.5828857421875,
        -2447.981689453125,
        21.301130294799805
      ],
      [
        -360.08795166015625,
        -2451.3544921875,
        13.21284294128418
      ],
      [
        -91.83806610107422,
        -2475.97119140625,
        100.0
      ],
      [
        128.55201721191406,
        -2507.998046875,
        100.0
      ],
      [
        -376.2373046875,
        -2436.734130859375,
        43.47489547729492
      ],
      [
        -392.609375,
        -2423.885498046875,
        100.0
      ],
      [
        -376.7135009765625,
        -2434.573486328125,
        100.0
      ],
      [
        -392.609375,
        -2423.885498046875,
        100.0
      ],
      [
        -274.94073486328125,
        -2505.205078125,
        32.380496978759766
      ],
      [
        -295.439697265625,
        -2489.22021484375,
        100.00000762939453
      ],
      [
        -194.14488220214844,
        -2507.82373046875,
        37.1044807434082
      ],
      [
        -160.4607696533203,
        -2495.35205078125,
        100.0
      ],
      [
        -111.46427917480469,
        -2481.011474609375,
        100.0
      ],
      [
        -194.14488220214844,
        -2507.82373046875,
        37.1044807434082
      ],
      [
        -188.47286987304688,
        -2511.519287109375,
        21.661537170410156
      ],
      [
        -180.17478942871094,
        -2516.718505859375,
        0.0
      ],
      [
        -188.47286987304688,
        -2511.519287109375,
        21.661535263061523
      ],
      [
        -91.83806610107422,
        -2475.97119140625,
        100.0
      ],
      [
        -111.46427917480469,
        -2481.011474609375,
        100.0
      ],
      [
        -274.94073486328125,
        -2505.205078125,
        32.380496978759766
      ],
      [
        -281.3318176269531,
        -2511.255126953125,
        3.8976612091064453
      ],
      [
        -284.549072265625,
        -2511.976806640625,
        0.0
      ],
      [
        -281.3318176269531,
        -2511.255126953125,
        3.897660732269287
      ],
      [
        -479.8042907714844,
        -2447.493896484375,
        100.0
      ],
      [
        -423.21405029296875,
        -2498.310546875,
        33.09273147583008
      ],
      [
        -441.97967529296875,
        -2482.563232421875,
        100.0
      ],
      [
        -492.4397888183594,
        -2439.373779296875,
        100.0
      ],
      [
        -479.80426025390625,
        -2447.493896484375,
        100.0
      ],
      [
        -492.4398193359375,
        -2439.373779296875,
        100.0
      ],
      [
        -387.7213134765625,
        -2507.2900390625,
        0.0
      ],
      [
        -423.2140808105469,
        -2498.310546875,
        33.09272766113281
      ],
      [
        538.8607788085938,
        -2532.531005859375,
        75.69832611083984
      ],
      [
        133.38990783691406,
        -2508.701171875,
        100.0
      ],
      [
        545.50390625,
        -2534.708984375,
        67.26963806152344
      ],
      [
        545.7724609375,
        -2534.514892578125,
        68.196044921875
      ],
      [
        545.50390625,
        -2534.708984375,
        67.26963806152344
      ],
      [
        545.7724609375,
        -2534.514892578125,
        68.196044921875
      ],
      [
        545.647216796875,
        -2534.449462890625,
        68.46411895751953
      ],
      [
        542.2547607421875,
        -2532.6787109375,
        75.72715759277344
      ],
      [
        542.2547607421875,
        -2532.6787109375,
        75.72715759277344
      ],
      [
        538.8607788085938,
        -2532.531005859375,
        75.69832611083984
      ],
      [
        202.48260498046875,
        -2519.083251953125,
        100.0
      ],
      [
        527.6738891601562,
        -2531.49365234375,
        100.0
      ],
      [
        184.1158905029297,
        -2516.07275390625,
        100.0
      ],
      [
        -428.56591796875,
        -2495.0,
        100.0
      ],
      [
        -425.2187805175781,
        -2496.628173828125,
        40.24041748046875
      ],
      [
        -190.32208251953125,
        -2504.092041015625,
        100.0
      ],
      [
        -187.78782653808594,
        -2505.469970703125,
        48.974464416503906
      ],
      [
        -278.9546813964844,
        -2502.074951171875,
        45.62123107910156
      ],
      [
        -278.3159484863281,
        -2500.73388671875,
        100.00000762939453
      ],
      [
        202.48260498046875,
        -2519.083251953125,
        100.0
      ],
      [
        184.1158905029297,
        -2516.07275390625,
        100.0
      ],
      [
        1302.58544921875,
        -2836.690185546875,
        100.0
      ],
      [
        1422.0576171875,
        -2793.21337890625,
        100.0
      ],
      [
        1752.200927734375,
        -2826.90478515625,
        71.02210235595703
      ],
      [
        1649.934814453125,
        -2846.877685546875,
        0.0
      ],
      [
        1422.0576171875,
        -2793.21337890625,
        100.0
      ],
      [
        1586.376953125,
        -2741.73876953125,
        100.0
      ],
      [
        1599.915771484375,
        -2736.48974609375,
        100.0
      ],
      [
        1586.376953125,
        -2741.73876953125,
        100.0
      ],
      [
        1599.915771484375,
        -2736.48974609375,
        100.0
      ],
      [
        1601.1317138671875,
        -2737.116455078125,
        100.0
      ],
      [
        1752.0833740234375,
        -2814.926025390625,
        100.0
      ],
      [
        1754.8433837890625,
        -2816.247802734375,
        100.0
      ],
      [
        1752.0833740234375,
        -2814.926025390625,
        100.0
      ],
      [
        1754.8433837890625,
        -2816.247802734375,
        100.0
      ],
      [
        1754.9029541015625,
        -2816.37939453125,
        100.0
      ],
      [
        1756.59716796875,
        -2820.1181640625,
        100.0
      ],
      [
        1757.2171630859375,
        -2821.983642578125,
        91.74354553222656
      ],
      [
        754.7578735351562,
        -2631.499267578125,
        85.39134216308594
      ],
      [
        738.4486083984375,
        -2624.998291015625,
        55.76939392089844
      ],
      [
        754.7578735351562,
        -2631.499267578125,
        85.39134979248047
      ],
      [
        749.0469360351562,
        -2629.49169921875,
        74.25576782226562
      ],
      [
        738.4486083984375,
        -2624.998291015625,
        55.76939392089844
      ],
      [
        749.0469360351562,
        -2629.49169921875,
        74.25576782226562
      ],
      [
        754.9293212890625,
        -2631.02783203125,
        100.0
      ],
      [
        963.1213989257812,
        -2847.664306640625,
        100.0
      ],
      [
        545.647216796875,
        -2534.449462890625,
        68.46414184570312
      ],
      [
        746.97509765625,
        -2628.61328125,
        70.64186096191406
      ],
      [
        -119.34107971191406,
        -2585.182373046875,
        100.0
      ],
      [
        -76.62802124023438,
        -2645.3701171875,
        100.0
      ],
      [
        -270.15826416015625,
        -2641.868896484375,
        100.0
      ],
      [
        -126.16167449951172,
        -2911.70751953125,
        0.0
      ],
      [
        -126.13088989257812,
        -2867.301025390625,
        100.0
      ],
      [
        -116.50020599365234,
        -2888.488525390625,
        100.00000762939453
      ],
      [
        -183.79403686523438,
        -2744.0830078125,
        100.0
      ],
      [
        -126.13088989257812,
        -2867.301025390625,
        100.00000762939453
      ],
      [
        -183.79403686523438,
        -2744.0830078125,
        100.0
      ],
      [
        -249.4220428466797,
        -2744.892333984375,
        88.51737213134766
      ],
      [
        -247.44180297851562,
        -2742.678466796875,
        100.0
      ],
      [
        -249.4220428466797,
        -2744.892333984375,
        88.51737976074219
      ],
      [
        -268.0494079589844,
        -2758.006591796875,
        0.0
      ],
      [
        12.728614807128906,
        -2771.5576171875,
        100.0
      ],
      [
        -76.62801361083984,
        -2645.3701171875,
        100.0
      ],
      [
        12.728614807128906,
        -2771.5576171875,
        100.0
      ],
      [
        13.097672462463379,
        -2771.8046875,
        100.0
      ],
      [
        -119.34107971191406,
        -2585.182373046875,
        100.0
      ],
      [
        -243.77239990234375,
        -2633.727783203125,
        100.0
      ],
      [
        -247.44158935546875,
        -2520.810302734375,
        100.0
      ],
      [
        -247.44158935546875,
        -2520.810302734375,
        100.00000762939453
      ],
      [
        -273.6312255859375,
        -2503.8837890625,
        100.0
      ],
      [
        -273.6312561035156,
        -2503.8837890625,
        100.00000762939453
      ],
      [
        -275.4774169921875,
        -2505.713134765625,
        29.988645553588867
      ],
      [
        -258.9478759765625,
        -2528.280029296875,
        1.2501134872436523
      ],
      [
        -259.85284423828125,
        -2528.596923828125,
        0.0
      ],
      [
        -258.9478759765625,
        -2528.280029296875,
        1.2501134872436523
      ],
      [
        -270.15826416015625,
        -2641.868896484375,
        100.0
      ],
      [
        -243.77239990234375,
        -2633.727783203125,
        100.0
      ],
      [
        542.4085693359375,
        -2532.137939453125,
        100.0
      ],
      [
        741.9876098632812,
        -2625.5380859375,
        100.0
      ],
      [
        754.9293212890625,
        -2631.02783203125,
        100.0
      ],
      [
        741.9876098632812,
        -2625.5380859375,
        100.0
      ],
      [
        99.65169525146484,
        -2830.41943359375,
        100.0
      ],
      [
        230.8407440185547,
        -2898.67626953125,
        0.0
      ],
      [
        167.94493103027344,
        -2878.10595703125,
        100.0
      ],
      [
        53.733036041259766,
        -2799.00146484375,
        100.0
      ],
      [
        99.65169525146484,
        -2830.41943359375,
        100.0
      ],
      [
        53.73303985595703,
        -2799.00146484375,
        100.0
      ],
      [
        542.4085693359375,
        -2532.137939453125,
        100.0
      ],
      [
        527.6738891601562,
        -2531.49365234375,
        100.0
      ],
      [
        963.1213989257812,
        -2847.664306640625,
        100.0
      ],
      [
        964.4151000976562,
        -2849.033935546875,
        100.0
      ],
      [
        133.05445861816406,
        -3072.275146484375,
        100.0
      ],
      [
        346.1912841796875,
        -3131.479736328125,
        100.0
      ],
      [
        466.1919250488281,
        -3620.677490234375,
        0.0
      ],
      [
        481.91595458984375,
        -3599.611572265625,
        100.0
      ],
      [
        682.0857543945312,
        -3691.26171875,
        100.0
      ],
      [
        884.703125,
        -3338.1015625,
        100.0
      ],
      [
        694.3810424804688,
        -3269.954345703125,
        100.0
      ],
      [
        1021.2090454101562,
        -3526.953369140625,
        100.0
      ],
      [
        919.1904907226562,
        -3378.362548828125,
        100.0
      ],
      [
        19.614755630493164,
        -3033.381591796875,
        40.90336608886719
      ],
      [
        46.83256149291992,
        -3058.502197265625,
        100.0
      ],
      [
        73.42620849609375,
        -3119.670654296875,
        100.0
      ],
      [
        4.2593994140625,
        -3024.006591796875,
        0.0
      ],
      [
        884.703125,
        -3338.1015625,
        100.0
      ],
      [
        919.1904907226562,
        -3378.362548828125,
        100.0
      ],
      [
        32.66470718383789,
        -3044.38916015625,
        100.0
      ],
      [
        46.83256149291992,
        -3058.502197265625,
        100.0
      ],
      [
        19.614755630493164,
        -3033.381591796875,
        40.90336608886719
      ],
      [
        1212.235595703125,
        -3435.015380859375,
        0.0
      ],
      [
        1205.651611328125,
        -3453.021240234375,
        100.0
      ],
      [
        1078.841552734375,
        -3506.834228515625,
        100.0
      ],
      [
        1701.3076171875,
        -3610.1337890625,
        0.0
      ],
      [
        1740.637939453125,
        -3658.743408203125,
        100.0
      ],
      [
        1706.7811279296875,
        -3632.45703125,
        100.0
      ],
      [
        1758.7371826171875,
        -3675.006591796875,
        100.0
      ],
      [
        1740.637939453125,
        -3658.743408203125,
        100.0
      ],
      [
        1021.2090454101562,
        -3526.953369140625,
        100.0
      ],
      [
        1078.841552734375,
        -3506.834228515625,
        100.0
      ],
      [
        1413.2799072265625,
        -3486.064697265625,
        100.0
      ],
      [
        1246.6353759765625,
        -3435.62939453125,
        100.0
      ],
      [
        1609.0491943359375,
        -3569.94140625,
        100.0
      ],
      [
        1462.089599609375,
        -3500.836669921875,
        100.0
      ],
      [
        1658.6072998046875,
        -3595.05517578125,
        100.0
      ],
      [
        1658.6072998046875,
        -3595.05517578125,
        100.0
      ],
      [
        1609.0491943359375,
        -3569.94140625,
        100.0
      ],
      [
        1246.6353759765625,
        -3435.62939453125,
        100.0
      ],
      [
        686.9929809570312,
        -3263.8212890625,
        82.87269592285156
      ],
      [
        694.3810424804688,
        -3269.954345703125,
        100.0
      ],
      [
        687.480712890625,
        -3266.39990234375,
        100.0
      ],
      [
        1452.395263671875,
        -3496.278076171875,
        100.0
      ],
      [
        1413.2799072265625,
        -3486.064697265625,
        100.0
      ],
      [
        1452.395263671875,
        -3496.278076171875,
        100.0
      ],
      [
        640.3934936523438,
        -3242.14501953125,
        100.0
      ],
      [
        649.7892456054688,
        -3203.320068359375,
        0.0
      ],
      [
        638.2070922851562,
        -3215.491943359375,
        100.0
      ],
      [
        638.0684814453125,
        -3212.556396484375,
        100.0
      ],
      [
        640.3934936523438,
        -3242.14501953125,
        100.0
      ],
      [
        638.2070922851562,
        -3215.491943359375,
        100.0
      ],
      [
        803.0175170898438,
        -4009.5986328125,
        17.247533798217773
      ],
      [
        761.3662719726562,
        -3791.687744140625,
        100.0
      ],
      [
        802.8320922851562,
        -3976.660400390625,
        100.0
      ],
      [
        761.3662719726562,
        -3791.687744140625,
        100.0
      ],
      [
        751.8825073242188,
        -3730.33984375,
        100.0
      ],
      [
        747.0010986328125,
        -3727.60693359375,
        100.0
      ],
      [
        751.8825073242188,
        -3730.33984375,
        100.0
      ],
      [
        682.0857543945312,
        -3691.26171875,
        100.0
      ],
      [
        800.9765625,
        -4014.0205078125,
        0.0
      ],
      [
        803.0175170898438,
        -4009.5986328125,
        17.247535705566406
      ],
      [
        1090.228271484375,
        -2844.948486328125,
        100.0
      ],
      [
        1299.334716796875,
        -2837.873046875,
        100.0
      ],
      [
        1751.481689453125,
        -2829.4951171875,
        68.1942367553711
      ],
      [
        1651.5008544921875,
        -2847.716064453125,
        0.0
      ],
      [
        1299.334716796875,
        -2837.873046875,
        100.0
      ],
      [
        964.5720825195312,
        -2849.2001953125,
        100.0
      ],
      [
        1757.6160888671875,
        -2822.366943359375,
        100.0
      ],
      [
        1757.966796875,
        -2823.44140625,
        95.00662994384766
      ],
      [
        -40.876319885253906,
        -2948.48388671875,
        100.0
      ],
      [
        52.34999084472656,
        -2935.236083984375,
        100.00000762939453
      ],
      [
        173.83953857421875,
        -2882.221923828125,
        100.0
      ],
      [
        -110.41657257080078,
        -2901.87255859375,
        100.0
      ],
      [
        -91.95228576660156,
        -2912.87255859375,
        100.00000762939453
      ],
      [
        -110.41657257080078,
        -2901.87255859375,
        100.00000762939453
      ],
      [
        -40.876319885253906,
        -2948.48388671875,
        100.00000762939453
      ],
      [
        -91.95228576660156,
        -2912.87255859375,
        100.0
      ],
      [
        173.83953857421875,
        -2882.221923828125,
        100.0
      ],
      [
        232.01698303222656,
        -2909.704833984375,
        100.0
      ],
      [
        52.34999084472656,
        -2935.236083984375,
        100.0
      ],
      [
        227.6385040283203,
        -2922.44677734375,
        100.0
      ],
      [
        1090.228271484375,
        -2844.948486328125,
        100.0
      ],
      [
        967.4459838867188,
        -2852.242919921875,
        100.0
      ],
      [
        967.4459838867188,
        -2852.242919921875,
        100.0
      ],
      [
        227.6385040283203,
        -2922.44677734375,
        100.0
      ],
      [
        234.75198364257812,
        -2920.01318359375,
        100.0
      ],
      [
        241.15911865234375,
        -2914.023681640625,
        100.0
      ],
      [
        234.75198364257812,
        -2920.01318359375,
        100.0
      ],
      [
        241.10792541503906,
        -2915.669921875,
        100.0
      ],
      [
        241.10792541503906,
        -2915.669921875,
        100.0
      ],
      [
        241.15911865234375,
        -2914.023681640625,
        100.0
      ],
      [
        346.1912841796875,
        -3131.479736328125,
        100.0
      ],
      [
        502.7949523925781,
        -3170.630126953125,
        100.0
      ],
      [
        649.5947875976562,
        -3199.202392578125,
        0.0
      ],
      [
        637.6810302734375,
        -3204.351318359375,
        100.0
      ],
      [
        502.7949523925781,
        -3170.630126953125,
        100.0
      ],
      [
        611.2384033203125,
        -3093.0771484375,
        100.0
      ],
      [
        631.8307495117188,
        -3080.4638671875,
        100.0
      ],
      [
        631.8307495117188,
        -3080.4638671875,
        100.0
      ],
      [
        611.2384033203125,
        -3093.0771484375,
        100.0
      ],
      [
        1976.828125,
        -3322.8564453125,
        100.0
      ],
      [
        1939.6932373046875,
        -3385.396484375,
        100.0
      ],
      [
        1759.1138916015625,
        -2825.67236328125,
        100.0
      ],
      [
        133.05445861816406,
        -3072.275146484375,
        100.0
      ],
      [
        47.97587203979492,
        -3044.462158203125,
        100.0
      ],
      [
        25.294330596923828,
        -3037.047119140625,
        100.0
      ],
      [
        15.48095989227295,
        -3027.271728515625,
        100.0
      ],
      [
        47.97587203979492,
        -3044.462158203125,
        100.0
      ],
      [
        15.48095703125,
        -3027.271728515625,
        100.0
      ],
      [
        809.4983520507812,
        -4006.3974609375,
        100.0
      ],
      [
        769.688232421875,
        -4222.96875,
        100.0
      ],
      [
        345.0784606933594,
        -3445.783447265625,
        100.0
      ],
      [
        216.80609130859375,
        -3288.1298828125,
        100.0
      ],
      [
        456.5915222167969,
        -3616.28173828125,
        0.0
      ],
      [
        463.3052673339844,
        -3591.09033203125,
        100.0
      ],
      [
        809.4983520507812,
        -4006.3974609375,
        100.0
      ],
      [
        635.197265625,
        -3831.5546875,
        12.6880464553833
      ],
      [
        648.4840087890625,
        -3852.1279296875,
        0.0
      ],
      [
        623.7564086914062,
        -3821.736572265625,
        0.0
      ],
      [
        633.6099243164062,
        -3830.215087890625,
        10.859649658203125
      ],
      [
        633.6099243164062,
        -3830.215087890625,
        10.859651565551758
      ],
      [
        635.197265625,
        -3831.5546875,
        12.68804931640625
      ],
      [
        742.4443969726562,
        -4049.611083984375,
        100.0
      ],
      [
        729.767822265625,
        -3995.305419921875,
        100.0
      ],
      [
        631.803466796875,
        -3834.495849609375,
        100.0
      ],
      [
        416.7092590332031,
        -3548.9794921875,
        100.0
      ],
      [
        345.0784606933594,
        -3445.783447265625,
        100.0
      ],
      [
        528.4906616210938,
        -3746.773193359375,
        0.0
      ],
      [
        616.5324096679688,
        -3822.729248046875,
        100.0
      ],
      [
        594.922119140625,
        -3805.724365234375,
        100.0
      ],
      [
        744.4066772460938,
        -4035.668701171875,
        60.31206130981445
      ],
      [
        743.85986328125,
        -4020.2939453125,
        100.0
      ],
      [
        743.94287109375,
        -4018.573974609375,
        100.0
      ],
      [
        448.5495300292969,
        -3584.334228515625,
        100.0
      ],
      [
        416.7092590332031,
        -3548.9794921875,
        100.0
      ],
      [
        448.5495300292969,
        -3584.334228515625,
        100.0
      ],
      [
        616.5324096679688,
        -3822.729248046875,
        100.0
      ],
      [
        631.803466796875,
        -3834.495849609375,
        100.0
      ],
      [
        476.6596374511719,
        -3730.757568359375,
        100.0
      ],
      [
        503.9828186035156,
        -3734.165283203125,
        100.0
      ],
      [
        503.9828186035156,
        -3734.165283203125,
        100.0
      ],
      [
        476.6596374511719,
        -3730.757568359375,
        100.0
      ],
      [
        742.4443969726562,
        -4049.611083984375,
        100.0
      ],
      [
        -0.47167110443115234,
        -3158.9755859375,
        100.0
      ],
      [
        29.061635971069336,
        -3206.073486328125,
        100.0
      ],
      [
        -0.47167086601257324,
        -3158.9755859375,
        100.0
      ],
      [
        -255.75247192382812,
        -2749.34912109375,
        58.4351692199707
      ],
      [
        -279.61212158203125,
        -2740.77587890625,
        100.0
      ],
      [
        -261.8863220214844,
        -2742.0888671875,
        100.00000762939453
      ],
      [
        -279.61212158203125,
        -2740.77587890625,
        100.00000762939453
      ],
      [
        -256.6742248535156,
        -2742.474853515625,
        100.00000762939453
      ],
      [
        -256.6742248535156,
        -2742.474853515625,
        100.0
      ],
      [
        744.1162109375,
        -4014.984375,
        100.0
      ],
      [
        729.767822265625,
        -3995.305419921875,
        100.0
      ],
      [
        744.1162109375,
        -4014.984375,
        100.0
      ],
      [
        756.5209350585938,
        -4272.58740234375,
        100.0
      ],
      [
        769.688232421875,
        -4222.96875,
        100.0
      ],
      [
        1770.6002197265625,
        -2848.01171875,
        150.0
      ],
      [
        1978.01318359375,
        -3321.67138671875,
        150.0
      ],
      [
        -1850.0,
        1330.0,
        150.0
      ],
      [
        -2286.4638671875,
        1330.0,
        150.0
      ],
      [
        -2975.73193359375,
        3160.589599609375,
        150.0
      ],
      [
        42.20012664794922,
        -3230.05908203125,
        150.0
      ],
      [
        229.76663208007812,
        -3505.311767578125,
        150.0
      ],
      [
        -47.07554626464844,
        -3127.61328125,
        150.0
      ],
      [
        -212.98477172851562,
        -3009.147705078125,
        150.0
      ],
      [
        787.1046142578125,
        -4420.7470703125,
        150.0
      ],
      [
        732.9417114257812,
        -4320.8681640625,
        150.0
      ],
      [
        207.06373596191406,
        -3608.2099609375,
        150.0
      ],
      [
        229.76663208007812,
        -3505.311767578125,
        150.0
      ],
      [
        380.52789306640625,
        -3726.552978515625,
        150.0
      ],
      [
        282.137451171875,
        -3720.957763671875,
        150.0
      ],
      [
        382.968505859375,
        -3725.4296875,
        100.0
      ],
      [
        264.51708984375,
        -3702.41064453125,
        150.0
      ],
      [
        202.49526977539062,
        -3632.699951171875,
        150.0
      ],
      [
        282.137451171875,
        -3720.957763671875,
        150.0
      ],
      [
        264.51708984375,
        -3702.41064453125,
        150.0
      ],
      [
        202.49526977539062,
        -3632.699951171875,
        150.0
      ],
      [
        207.06373596191406,
        -3608.2099609375,
        150.0
      ],
      [
        726.4815063476562,
        -4229.533203125,
        100.0
      ],
      [
        719.6626586914062,
        -4296.091796875,
        150.0
      ],
      [
        725.3037109375,
        -4232.509765625,
        150.0
      ],
      [
        787.1046142578125,
        -4420.7470703125,
        150.0
      ],
      [
        828.2930908203125,
        -4432.0419921875,
        150.0
      ],
      [
        719.6626586914062,
        -4296.091796875,
        150.0
      ],
      [
        732.9417114257812,
        -4320.8681640625,
        150.0
      ],
      [
        -376.2108154296875,
        -2679.906494140625,
        150.0
      ],
      [
        -479.16693115234375,
        -2472.6201171875,
        150.0
      ],
      [
        -292.8008728027344,
        -2733.74169921875,
        100.0
      ],
      [
        -296.072998046875,
        -2729.91796875,
        110.39322662353516
      ],
      [
        -304.1618347167969,
        -2720.46533203125,
        136.08628845214844
      ],
      [
        -296.072998046875,
        -2729.91796875,
        110.39322662353516
      ],
      [
        -371.7124938964844,
        -2691.655517578125,
        100.0
      ],
      [
        -479.16693115234375,
        -2472.6201171875,
        149.99998474121094
      ],
      [
        -486.78936767578125,
        -2452.812255859375,
        139.82672119140625
      ],
      [
        -484.3882141113281,
        -2457.293212890625,
        150.0
      ],
      [
        -486.7893981933594,
        -2452.812255859375,
        139.82623291015625
      ],
      [
        -492.83447265625,
        -2440.193603515625,
        100.0
      ],
      [
        -304.1618347167969,
        -2720.46533203125,
        136.08628845214844
      ],
      [
        -376.2108154296875,
        -2679.906494140625,
        150.0
      ],
      [
        -306.0428161621094,
        -2719.01416015625,
        150.0
      ],
      [
        -9.511959075927734,
        -3154.171875,
        150.0
      ],
      [
        -47.07554626464844,
        -3127.61328125,
        150.0
      ],
      [
        -5.41292667388916,
        -3155.48193359375,
        100.0
      ],
      [
        -212.83958435058594,
        -3009.087890625,
        145.20553588867188
      ],
      [
        -217.75363159179688,
        -3001.6279296875,
        100.0
      ],
      [
        -567.3854370117188,
        -2542.212158203125,
        150.0
      ],
      [
        -502.21734619140625,
        -2707.45458984375,
        150.0
      ],
      [
        -567.3854370117188,
        -2542.212158203125,
        150.0
      ],
      [
        -630.9057006835938,
        -2450.97705078125,
        150.0
      ],
      [
        -502.21734619140625,
        -2707.45458984375,
        150.0
      ],
      [
        -468.7301940917969,
        -2793.793701171875,
        150.0
      ],
      [
        -957.7409057617188,
        -2110.841064453125,
        150.0
      ],
      [
        -1010.5860595703125,
        -2058.537109375,
        150.0
      ],
      [
        -927.5880126953125,
        -2058.711669921875,
        150.0
      ],
      [
        -992.8670043945312,
        -2043.78857421875,
        150.0
      ],
      [
        -838.9564208984375,
        -2159.602294921875,
        150.0
      ],
      [
        -809.9034423828125,
        -2190.929443359375,
        100.0
      ],
      [
        -812.3786010742188,
        -2190.323974609375,
        150.0
      ],
      [
        -737.0582275390625,
        -2298.5078125,
        150.0
      ],
      [
        -738.6663208007812,
        -2296.8603515625,
        150.0
      ],
      [
        -734.9911499023438,
        -2298.52734375,
        100.0
      ],
      [
        -1014.635986328125,
        -2040.115234375,
        150.0
      ],
      [
        -992.8670043945312,
        -2043.78857421875,
        150.0
      ],
      [
        -1014.635986328125,
        -2040.115234375,
        150.0
      ],
      [
        -1016.3764038085938,
        -2043.1588134765625,
        150.0
      ],
      [
        -738.6663208007812,
        -2296.8603515625,
        150.0
      ],
      [
        -739.15576171875,
        -2295.4951171875,
        150.0
      ],
      [
        -738.1463012695312,
        -2293.995361328125,
        100.0
      ],
      [
        -920.051025390625,
        -2064.401123046875,
        117.573974609375
      ],
      [
        -927.5880126953125,
        -2058.711669921875,
        150.0
      ],
      [
        -925.8958129882812,
        -2059.108154296875,
        150.0
      ],
      [
        -893.2371826171875,
        -2071.75146484375,
        108.74629211425781
      ],
      [
        -899.41455078125,
        -2065.3125,
        150.0
      ],
      [
        -468.078125,
        -2794.01904296875,
        150.0
      ],
      [
        -468.7301940917969,
        -2793.793701171875,
        150.0
      ],
      [
        -466.5007019042969,
        -2793.04638671875,
        100.0
      ],
      [
        -809.4187622070312,
        -2089.757080078125,
        150.0
      ],
      [
        -734.0372314453125,
        -2127.061767578125,
        150.0
      ],
      [
        -729.8462524414062,
        -2129.61083984375,
        143.35594177246094
      ],
      [
        -726.2146606445312,
        -2134.50732421875,
        100.0
      ],
      [
        -896.7640991210938,
        -2065.93359375,
        150.0
      ],
      [
        -809.4187622070312,
        -2089.757080078125,
        150.0
      ],
      [
        -896.7640991210938,
        -2065.93359375,
        150.0
      ],
      [
        -662.1536865234375,
        -2403.6083984375,
        150.0
      ],
      [
        -691.41796875,
        -2351.653564453125,
        150.0
      ],
      [
        -787.3925170898438,
        -2219.205810546875,
        150.0
      ],
      [
        -710.3585815429688,
        -2325.861572265625,
        150.0
      ],
      [
        -743.0813598632812,
        -2284.5458984375,
        150.0
      ],
      [
        -753.5869140625,
        -2258.281982421875,
        150.0
      ],
      [
        -752.641845703125,
        -2257.11865234375,
        100.0
      ],
      [
        -743.0813598632812,
        -2284.5458984375,
        150.0
      ],
      [
        -700.9912109375,
        -2334.6572265625,
        150.0
      ],
      [
        -710.3585815429688,
        -2325.861572265625,
        150.0
      ],
      [
        -699.9646606445312,
        -2333.877685546875,
        100.0
      ],
      [
        -754.691650390625,
        -2255.520263671875,
        150.0
      ],
      [
        -787.3925170898438,
        -2219.205810546875,
        150.0
      ],
      [
        -754.691650390625,
        -2255.520263671875,
        150.0
      ],
      [
        -662.1536865234375,
        -2403.6083984375,
        150.0
      ],
      [
        -630.9057006835938,
        -2450.97705078125,
        150.0
      ],
      [
        -700.4783325195312,
        -2335.138916015625,
        150.0
      ],
      [
        -691.41796875,
        -2351.653564453125,
        150.0
      ],
      [
        -700.4783325195312,
        -2335.138916015625,
        150.0
      ],
      [
        -729.8462524414062,
        -2129.61083984375,
        143.35594177246094
      ],
      [
        -734.0372314453125,
        -2127.061767578125,
        150.0
      ],
      [
        -730.3295288085938,
        -2129.046142578125,
        150.0
      ],
      [
        -376.6602783203125,
        -2825.620361328125,
        150.0
      ],
      [
        -231.1630859375,
        -2989.194580078125,
        150.0
      ],
      [
        -296.61541748046875,
        -2919.312744140625,
        150.0
      ],
      [
        -212.98477172851562,
        -3009.147705078125,
        150.0
      ],
      [
        -231.1630859375,
        -2989.194580078125,
        150.0
      ],
      [
        -304.8987121582031,
        -2901.1435546875,
        149.99996948242188
      ],
      [
        -336.9926452636719,
        -2839.3330078125,
        150.0
      ],
      [
        -336.30511474609375,
        -2838.052734375,
        100.00001525878906
      ],
      [
        -296.61541748046875,
        -2919.312744140625,
        150.0
      ],
      [
        -304.8987121582031,
        -2901.1435546875,
        150.0
      ],
      [
        -625.37158203125,
        -2272.45166015625,
        150.0
      ],
      [
        -599.6627197265625,
        -2288.128662109375,
        150.0
      ],
      [
        -589.16552734375,
        -2298.828125,
        100.0
      ],
      [
        -687.770263671875,
        -2154.12646484375,
        100.0
      ],
      [
        -695.2870483398438,
        -2147.800537109375,
        150.0
      ],
      [
        -625.37158203125,
        -2272.45166015625,
        150.0
      ],
      [
        -640.9779052734375,
        -2248.028076171875,
        150.0
      ],
      [
        -713.5335083007812,
        -2139.5322265625,
        117.49517822265625
      ],
      [
        -714.90673828125,
        -2140.103515625,
        100.0
      ],
      [
        -640.9779052734375,
        -2248.028076171875,
        150.0
      ],
      [
        -652.7127685546875,
        -2230.913330078125,
        150.00001525878906
      ],
      [
        -720.2892456054688,
        -2135.42333984375,
        128.20516967773438
      ],
      [
        -722.3139038085938,
        -2136.437744140625,
        100.0
      ],
      [
        -337.85003662109375,
        -2837.681640625,
        150.0
      ],
      [
        -376.6602783203125,
        -2825.620361328125,
        150.0
      ],
      [
        -337.85003662109375,
        -2837.681640625,
        150.0
      ],
      [
        1917.209228515625,
        -3424.0732421875,
        150.0
      ],
      [
        1755.602783203125,
        -3682.71533203125,
        150.0
      ],
      [
        203.69203186035156,
        -2517.873779296875,
        150.0
      ],
      [
        504.65728759765625,
        -2529.359619140625,
        150.0
      ],
      [
        160.30667114257812,
        -2510.762939453125,
        150.0
      ],
      [
        -91.03118896484375,
        -2474.238525390625,
        150.0
      ],
      [
        -392.3694763183594,
        -2422.4189453125,
        150.0
      ],
      [
        -512.486328125,
        -2345.409423828125,
        150.0
      ],
      [
        -555.8399658203125,
        -2314.851318359375,
        150.0
      ],
      [
        -558.556884765625,
        -2317.492919921875,
        100.0
      ],
      [
        -593.4502563476562,
        -2294.4609375,
        120.40879821777344
      ],
      [
        -683.1119995117188,
        -2154.31640625,
        150.0
      ],
      [
        -512.486328125,
        -2345.409423828125,
        150.0
      ],
      [
        -542.415771484375,
        -2323.975830078125,
        150.0
      ],
      [
        -542.415771484375,
        -2323.975830078125,
        150.0
      ],
      [
        -555.8399658203125,
        -2314.851318359375,
        150.0
      ],
      [
        -392.3694763183594,
        -2422.4189453125,
        150.0
      ],
      [
        -377.13458251953125,
        -2432.66259765625,
        150.0
      ],
      [
        -376.7134704589844,
        -2434.573486328125,
        100.0
      ],
      [
        -293.9805908203125,
        -2488.573486328125,
        150.0
      ],
      [
        -278.1846618652344,
        -2500.4580078125,
        111.18811798095703
      ],
      [
        -278.31597900390625,
        -2500.73388671875,
        100.00000762939453
      ],
      [
        -192.80422973632812,
        -2502.74169921875,
        150.0
      ],
      [
        -126.83592987060547,
        -2483.43359375,
        150.0
      ],
      [
        -190.32196044921875,
        -2504.092041015625,
        100.0
      ],
      [
        -278.18463134765625,
        -2500.4580078125,
        111.1881103515625
      ],
      [
        -293.9805908203125,
        -2488.573486328125,
        150.00001525878906
      ],
      [
        -277.0323181152344,
        -2499.527099609375,
        150.00001525878906
      ],
      [
        203.69203186035156,
        -2517.873779296875,
        150.0
      ],
      [
        160.30667114257812,
        -2510.762939453125,
        150.0
      ],
      [
        -91.03118896484375,
        -2474.238525390625,
        150.0
      ],
      [
        -126.83592987060547,
        -2483.43359375,
        150.0
      ],
      [
        -463.9752502441406,
        -2463.404052734375,
        150.0
      ],
      [
        -428.566162109375,
        -2494.999755859375,
        100.0
      ],
      [
        -431.3668518066406,
        -2493.63720703125,
        150.0
      ],
      [
        -482.9284973144531,
        -2451.223876953125,
        150.0
      ],
      [
        -463.9752197265625,
        -2463.404052734375,
        150.0
      ],
      [
        -484.99420166015625,
        -2455.514404296875,
        150.00001525878906
      ],
      [
        -482.92852783203125,
        -2451.223876953125,
        150.0
      ],
      [
        -484.9942321777344,
        -2455.514404296875,
        150.0
      ],
      [
        755.5160522460938,
        -2629.414306640625,
        150.0
      ],
      [
        950.5065307617188,
        -2832.313720703125,
        150.0
      ],
      [
        967.517578125,
        -2852.23876953125,
        100.0
      ],
      [
        968.48828125,
        -2851.024658203125,
        150.0
      ],
      [
        1285.57861328125,
        -2832.186767578125,
        150.0
      ],
      [
        1294.5499267578125,
        -2831.575439453125,
        150.0
      ],
      [
        1568.2418212890625,
        -2745.838623046875,
        150.0
      ],
      [
        1599.721435546875,
        -2733.634033203125,
        150.0
      ],
      [
        1568.2418212890625,
        -2745.838623046875,
        150.0
      ],
      [
        1285.57861328125,
        -2832.186767578125,
        150.0
      ],
      [
        1294.5499267578125,
        -2831.575439453125,
        150.0
      ],
      [
        1601.1317138671875,
        -2737.116455078125,
        100.0
      ],
      [
        1599.721435546875,
        -2733.634033203125,
        150.0
      ],
      [
        1602.5487060546875,
        -2735.09130859375,
        150.0
      ],
      [
        1735.9102783203125,
        -2806.58935546875,
        100.0
      ],
      [
        1738.69189453125,
        -2805.267822265625,
        150.0
      ],
      [
        1316.8963623046875,
        -2831.482177734375,
        100.0
      ],
      [
        1744.6431884765625,
        -2808.33544921875,
        150.0
      ],
      [
        1754.835205078125,
        -2813.84716796875,
        139.5871124267578
      ],
      [
        1744.6431884765625,
        -2808.33544921875,
        150.0
      ],
      [
        1751.6458740234375,
        -2811.689208984375,
        150.0
      ],
      [
        1754.835205078125,
        -2813.84716796875,
        139.5871124267578
      ],
      [
        1755.01416015625,
        -2814.3955078125,
        137.03912353515625
      ],
      [
        1754.9029541015625,
        -2816.37939453125,
        100.0
      ],
      [
        1757.6160888671875,
        -2822.366943359375,
        100.0
      ],
      [
        1978.01318359375,
        -3321.67138671875,
        150.0
      ],
      [
        1917.209228515625,
        -3424.0732421875,
        150.0
      ],
      [
        1754.8330078125,
        -2813.215576171875,
        150.0
      ],
      [
        1770.6002197265625,
        -2848.01171875,
        150.0
      ],
      [
        1754.8330078125,
        -2813.215576171875,
        150.0
      ],
      [
        1758.60791015625,
        -3675.324462890625,
        102.06121063232422
      ],
      [
        1754.9068603515625,
        -3671.564697265625,
        100.0
      ],
      [
        352.902587890625,
        -3438.67822265625,
        150.0
      ],
      [
        160.49404907226562,
        -3202.197998046875,
        150.0
      ],
      [
        -40.316280364990234,
        -2940.929931640625,
        150.0
      ],
      [
        209.3941650390625,
        -2922.710693359375,
        150.0
      ],
      [
        542.725341796875,
        -2531.02392578125,
        150.0
      ],
      [
        728.277099609375,
        -2617.859375,
        150.0
      ],
      [
        755.5160522460938,
        -2629.414306640625,
        150.0
      ],
      [
        728.277099609375,
        -2617.859375,
        150.0
      ],
      [
        -428.3454895019531,
        -2495.204345703125,
        100.0
      ],
      [
        -270.4595642089844,
        -2642.82373046875,
        150.0
      ],
      [
        -368.8689270019531,
        -2551.582763671875,
        150.0
      ],
      [
        -124.75054931640625,
        -2858.90234375,
        128.2156219482422
      ],
      [
        -126.85667419433594,
        -2865.750244140625,
        100.00000762939453
      ],
      [
        -73.27311706542969,
        -2919.40283203125,
        136.49221801757812
      ],
      [
        -49.245452880859375,
        -2942.648681640625,
        100.00000762939453
      ],
      [
        -84.01172637939453,
        -2918.408935546875,
        100.0
      ],
      [
        -40.316280364990234,
        -2940.929931640625,
        150.0
      ],
      [
        -40.850746154785156,
        -2940.5732421875,
        150.0
      ],
      [
        -40.85074996948242,
        -2940.5732421875,
        150.0
      ],
      [
        -73.27311706542969,
        -2919.40283203125,
        136.49221801757812
      ],
      [
        -65.88924407958984,
        -2923.960693359375,
        150.0
      ],
      [
        -124.75054931640625,
        -2858.90234375,
        128.2156219482422
      ],
      [
        -181.17271423339844,
        -2738.758544921875,
        150.0
      ],
      [
        -132.21392822265625,
        -2842.4443359375,
        150.0
      ],
      [
        -223.37704467773438,
        -2737.630615234375,
        128.3785400390625
      ],
      [
        -226.6180877685547,
        -2743.13818359375,
        100.0
      ],
      [
        -223.37704467773438,
        -2737.630615234375,
        128.3785400390625
      ],
      [
        -217.66452026367188,
        -2737.420654296875,
        150.0
      ],
      [
        -185.04052734375,
        -2738.56201171875,
        150.0
      ],
      [
        -181.17271423339844,
        -2738.758544921875,
        150.0
      ],
      [
        -185.04052734375,
        -2738.56201171875,
        150.0
      ],
      [
        8.17422103881836,
        -2779.62451171875,
        150.0
      ],
      [
        -100.3984375,
        -2626.30078125,
        150.0
      ],
      [
        -270.4595642089844,
        -2642.82373046875,
        150.0
      ],
      [
        -121.8170166015625,
        -2596.96142578125,
        150.0
      ],
      [
        -113.429931640625,
        -2593.511962890625,
        100.0
      ],
      [
        -121.81702423095703,
        -2596.96142578125,
        150.0
      ],
      [
        -121.27578735351562,
        -2596.818115234375,
        150.0
      ],
      [
        -247.3546600341797,
        -2518.7080078125,
        150.0
      ],
      [
        -247.3546600341797,
        -2518.7080078125,
        150.0
      ],
      [
        128.6957244873047,
        -2862.373291015625,
        150.0
      ],
      [
        229.67507934570312,
        -2910.076171875,
        150.0
      ],
      [
        209.3941650390625,
        -2922.710693359375,
        150.0
      ],
      [
        220.0643768310547,
        -2919.060302734375,
        150.0
      ],
      [
        220.0643768310547,
        -2919.060302734375,
        150.0
      ],
      [
        229.59829711914062,
        -2912.54541015625,
        150.0
      ],
      [
        229.59829711914062,
        -2912.54541015625,
        150.0
      ],
      [
        229.67507934570312,
        -2910.076171875,
        150.0
      ],
      [
        92.195556640625,
        -2836.88671875,
        150.0
      ],
      [
        128.6957244873047,
        -2862.373291015625,
        150.0
      ],
      [
        92.195556640625,
        -2836.88671875,
        150.0
      ],
      [
        23.317581176757812,
        -2789.759765625,
        150.0
      ],
      [
        8.17422103881836,
        -2779.62451171875,
        150.0
      ],
      [
        23.317577362060547,
        -2789.759765625,
        150.0
      ],
      [
        542.725341796875,
        -2531.02392578125,
        150.0
      ],
      [
        504.65728759765625,
        -2529.359619140625,
        150.0
      ],
      [
        968.196533203125,
        -2851.0419921875,
        150.0
      ],
      [
        950.5065307617188,
        -2832.313720703125,
        150.0
      ],
      [
        968.196533203125,
        -2851.0419921875,
        150.0
      ],
      [
        -120.46661376953125,
        -2596.603759765625,
        150.0
      ],
      [
        -100.3984375,
        -2626.30078125,
        150.0
      ],
      [
        -120.46661376953125,
        -2596.603759765625,
        150.0
      ],
      [
        466.6619873046875,
        -3578.49462890625,
        149.99998474121094
      ],
      [
        651.7716674804688,
        -3663.24951171875,
        150.0
      ],
      [
        463.3051452636719,
        -3591.09033203125,
        100.0
      ],
      [
        267.62884521484375,
        -3115.903076171875,
        150.0
      ],
      [
        502.53436279296875,
        -3174.62841796875,
        150.0
      ],
      [
        881.236572265625,
        -3347.0419921875,
        150.0
      ],
      [
        715.9491577148438,
        -3287.85888671875,
        150.0
      ],
      [
        1019.3123779296875,
        -3533.1953125,
        150.0
      ],
      [
        932.9675903320312,
        -3407.433349609375,
        150.0
      ],
      [
        881.236572265625,
        -3347.0419921875,
        150.0
      ],
      [
        932.9675903320312,
        -3407.433349609375,
        150.0
      ],
      [
        69.86077880859375,
        -3079.755859375,
        150.0
      ],
      [
        80.17649841308594,
        -3103.483154296875,
        150.0
      ],
      [
        66.1789321899414,
        -3103.0009765625,
        100.0
      ],
      [
        52.043949127197266,
        -3062.008056640625,
        150.0
      ],
      [
        69.86077880859375,
        -3079.755859375,
        150.0
      ],
      [
        44.33879089355469,
        -3056.01806640625,
        100.0
      ],
      [
        1202.3592529296875,
        -3462.024169921875,
        150.0
      ],
      [
        1105.7611083984375,
        -3503.0166015625,
        150.0
      ],
      [
        1205.651611328125,
        -3453.021240234375,
        100.0
      ],
      [
        1706.7811279296875,
        -3632.45703125,
        100.0
      ],
      [
        1728.4539794921875,
        -3658.32080078125,
        150.0
      ],
      [
        1709.51806640625,
        -3643.619140625,
        150.0
      ],
      [
        1755.602783203125,
        -3682.71533203125,
        150.0
      ],
      [
        1728.4539794921875,
        -3658.32080078125,
        150.0
      ],
      [
        1019.3123779296875,
        -3533.1953125,
        150.0
      ],
      [
        1105.7611083984375,
        -3503.0166015625,
        150.0
      ],
      [
        1446.6124267578125,
        -3500.812744140625,
        150.0
      ],
      [
        1581.4024658203125,
        -3564.19482421875,
        150.0
      ],
      [
        1387.939453125,
        -3485.492431640625,
        150.0
      ],
      [
        1247.3350830078125,
        -3442.938232421875,
        150.0
      ],
      [
        1655.739501953125,
        -3601.865478515625,
        150.0
      ],
      [
        1581.4024658203125,
        -3564.19482421875,
        150.0
      ],
      [
        1655.739501953125,
        -3601.865478515625,
        150.0
      ],
      [
        1247.3350830078125,
        -3442.938232421875,
        150.0
      ],
      [
        687.480712890625,
        -3266.39990234375,
        100.0
      ],
      [
        715.9491577148438,
        -3287.85888671875,
        150.0
      ],
      [
        688.9057006835938,
        -3273.9287109375,
        150.0
      ],
      [
        634.9678344726562,
        -3246.144775390625,
        150.0
      ],
      [
        1446.6124267578125,
        -3500.812744140625,
        150.0
      ],
      [
        1387.939453125,
        -3485.492431640625,
        150.0
      ],
      [
        634.9678344726562,
        -3246.144775390625,
        150.0
      ],
      [
        631.7510986328125,
        -3206.932373046875,
        150.0
      ],
      [
        632.1046142578125,
        -3206.760986328125,
        146.80604553222656
      ],
      [
        637.6810302734375,
        -3204.351318359375,
        100.0
      ],
      [
        632.1046142578125,
        -3206.760986328125,
        146.80604553222656
      ],
      [
        127.50820922851562,
        -3076.980712890625,
        150.0
      ],
      [
        267.62884521484375,
        -3115.903076171875,
        150.0
      ],
      [
        43.705684661865234,
        -3053.701904296875,
        150.0
      ],
      [
        32.66484832763672,
        -3044.38916015625,
        100.0
      ],
      [
        502.53436279296875,
        -3174.62841796875,
        150.0
      ],
      [
        595.2847290039062,
        -3108.29833984375,
        150.0
      ],
      [
        626.1732177734375,
        -3089.37841796875,
        150.0
      ],
      [
        631.6881713867188,
        -3206.165283203125,
        150.0
      ],
      [
        626.1732177734375,
        -3089.37841796875,
        150.0
      ],
      [
        595.2847290039062,
        -3108.29833984375,
        150.0
      ],
      [
        631.6881713867188,
        -3206.165283203125,
        150.0
      ],
      [
        127.50820922851562,
        -3076.980712890625,
        150.0
      ],
      [
        71.57574462890625,
        -3058.69580078125,
        150.0
      ],
      [
        37.5537109375,
        -3047.57373046875,
        150.0
      ],
      [
        25.294631958007812,
        -3037.04736328125,
        100.0
      ],
      [
        22.833377838134766,
        -3032.910400390625,
        150.0
      ],
      [
        71.57574462890625,
        -3058.69580078125,
        150.0
      ],
      [
        22.8333740234375,
        -3032.910400390625,
        150.0
      ],
      [
        813.4141845703125,
        -4004.46337890625,
        150.0
      ],
      [
        770.6924438476562,
        -3813.888427734375,
        150.0
      ],
      [
        770.6924438476562,
        -3813.888427734375,
        150.0
      ],
      [
        756.466796875,
        -3721.866455078125,
        150.0
      ],
      [
        749.1446533203125,
        -3717.766845703125,
        150.0
      ],
      [
        756.466796875,
        -3721.866455078125,
        150.0
      ],
      [
        747.0010986328125,
        -3727.60693359375,
        100.0
      ],
      [
        651.7716674804688,
        -3663.24951171875,
        149.99998474121094
      ],
      [
        813.4141845703125,
        -4004.46337890625,
        150.0
      ],
      [
        813.383056640625,
        -4004.6328125,
        150.0
      ],
      [
        807.9715576171875,
        -4014.703369140625,
        100.0
      ],
      [
        778.0789794921875,
        -4196.6904296875,
        150.0
      ],
      [
        84.0410385131836,
        -3112.3720703125,
        150.0
      ],
      [
        160.49404907226562,
        -3202.197998046875,
        150.0
      ],
      [
        84.0410385131836,
        -3112.3720703125,
        150.0
      ],
      [
        -107.30953216552734,
        -2895.8125,
        129.1079559326172
      ],
      [
        -115.40731048583984,
        -2878.03759765625,
        150.0
      ],
      [
        -104.64932250976562,
        -2898.7607421875,
        129.5564422607422
      ],
      [
        -105.62356567382812,
        -2898.462158203125,
        127.41638946533203
      ],
      [
        -104.64932250976562,
        -2898.7607421875,
        129.5564422607422
      ],
      [
        -89.85394287109375,
        -2908.060546875,
        150.0
      ],
      [
        -106.06298065185547,
        -2898.548828125,
        125.89128112792969
      ],
      [
        -105.62356567382812,
        -2898.462158203125,
        127.41638946533203
      ],
      [
        -102.68457794189453,
        -2906.478759765625,
        100.0
      ],
      [
        -107.30953216552734,
        -2895.8125,
        129.1079559326172
      ],
      [
        -107.31792449951172,
        -2896.27294921875,
        127.91844177246094
      ],
      [
        -107.36421203613281,
        -2898.805908203125,
        121.37503814697266
      ],
      [
        -109.77278900146484,
        -2902.256103515625,
        100.0
      ],
      [
        -107.68672180175781,
        -2898.86962890625,
        120.25569915771484
      ],
      [
        -107.31792449951172,
        -2896.27294921875,
        127.9184341430664
      ],
      [
        -107.68672180175781,
        -2898.86962890625,
        120.25569915771484
      ],
      [
        -242.3101806640625,
        -2736.942138671875,
        129.7554931640625
      ],
      [
        -247.44180297851562,
        -2742.6787109375,
        100.0
      ],
      [
        -242.3101806640625,
        -2736.942138671875,
        129.7554931640625
      ],
      [
        -235.62464904785156,
        -2736.792236328125,
        150.0
      ],
      [
        720.9573974609375,
        -3985.717529296875,
        150.0
      ],
      [
        629.8599853515625,
        -3836.18017578125,
        150.0
      ],
      [
        739.9722900390625,
        -4067.17626953125,
        150.0
      ],
      [
        502.4081726074219,
        -3736.264892578125,
        150.0
      ],
      [
        606.9534301757812,
        -3818.5302734375,
        150.0
      ],
      [
        461.42340087890625,
        -3731.1533203125,
        150.0
      ],
      [
        743.94287109375,
        -4018.573974609375,
        100.0
      ],
      [
        739.9722900390625,
        -4067.17626953125,
        150.0
      ],
      [
        742.2200317382812,
        -4020.620361328125,
        150.0
      ],
      [
        502.4081726074219,
        -3736.264892578125,
        150.0
      ],
      [
        461.42340087890625,
        -3731.1533203125,
        150.0
      ],
      [
        410.4580383300781,
        -3521.596435546875,
        150.0
      ],
      [
        352.902587890625,
        -3438.67822265625,
        150.0
      ],
      [
        458.21844482421875,
        -3574.628662109375,
        150.0
      ],
      [
        410.4580383300781,
        -3521.596435546875,
        150.0
      ],
      [
        458.21844482421875,
        -3574.628662109375,
        149.99998474121094
      ],
      [
        611.6952514648438,
        -3820.60888671875,
        125.2488021850586
      ],
      [
        629.8599853515625,
        -3836.18017578125,
        150.0
      ],
      [
        627.6203002929688,
        -3834.45458984375,
        150.0
      ],
      [
        -2.0998406410217285,
        -3159.412353515625,
        150.0
      ],
      [
        42.20011901855469,
        -3230.05908203125,
        150.0
      ],
      [
        -2.0998401641845703,
        -3159.412353515625,
        150.0
      ],
      [
        -263.4755859375,
        -2740.207763671875,
        110.76881408691406
      ],
      [
        -261.8863220214844,
        -2742.0888671875,
        100.00000762939453
      ],
      [
        -266.8736572265625,
        -2736.049072265625,
        131.54193115234375
      ],
      [
        -263.4755859375,
        -2740.207763671875,
        110.76881408691406
      ],
      [
        -266.8736572265625,
        -2736.049072265625,
        131.54193115234375
      ],
      [
        -267.0494689941406,
        -2735.9775390625,
        134.9861297607422
      ],
      [
        -270.6280212402344,
        -2735.56787109375,
        150.0
      ],
      [
        -267.81591796875,
        -2735.666259765625,
        150.0
      ],
      [
        -280.040771484375,
        -2733.50634765625,
        150.0
      ],
      [
        -276.7245788574219,
        -2735.3544921875,
        150.0
      ],
      [
        -276.9766845703125,
        -2735.345703125,
        150.0
      ],
      [
        -280.040771484375,
        -2733.50634765625,
        150.0
      ],
      [
        -276.9766845703125,
        -2735.345703125,
        150.0
      ],
      [
        606.9534301757812,
        -3818.5302734375,
        150.0
      ],
      [
        -106.15278625488281,
        -2897.24658203125,
        150.0
      ],
      [
        -108.65835571289062,
        -2892.33056640625,
        150.0
      ],
      [
        -108.65835571289062,
        -2892.33056640625,
        150.0
      ],
      [
        -106.15278625488281,
        -2897.24658203125,
        150.0
      ],
      [
        -107.4236068725586,
        -2897.01708984375,
        125.72265625
      ],
      [
        758.3280029296875,
        -4271.1181640625,
        150.0
      ],
      [
        778.0789794921875,
        -4196.6904296875,
        150.0
      ],
      [
        742.47998046875,
        -4015.236083984375,
        150.0
      ],
      [
        720.9573974609375,
        -3985.717529296875,
        150.0
      ],
      [
        742.47998046875,
        -4015.236083984375,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        714.574951171875
      ],
      [
        -2708.39404296875,
        6871.484375,
        182.8954315185547
      ],
      [
        -5174.01171875,
        5224.01171875,
        714.574951171875
      ],
      [
        -5331.83740234375,
        4987.80859375,
        762.3843994140625
      ],
      [
        -362.4698486328125,
        -2639.94140625,
        844.3678588867188
      ],
      [
        -351.6449279785156,
        -2614.790283203125,
        840.1456909179688
      ],
      [
        -35.91261672973633,
        -2925.689697265625,
        827.048828125
      ],
      [
        24.348968505859375,
        -2906.363525390625,
        816.2604370117188
      ],
      [
        -318.67523193359375,
        -2635.6806640625,
        837.5585327148438
      ],
      [
        -351.6448974609375,
        -2614.790283203125,
        840.1456909179688
      ],
      [
        24.348989486694336,
        -2906.363525390625,
        816.2603759765625
      ],
      [
        66.33380126953125,
        -2879.6328125,
        807.3463134765625
      ],
      [
        202.6788330078125,
        -2905.23779296875,
        266.9432067871094
      ],
      [
        79.55073547363281,
        -2848.33544921875,
        460.603515625
      ],
      [
        225.14236450195312,
        -2908.51806640625,
        169.73486328125
      ],
      [
        -91.89059448242188,
        -2884.895751953125,
        830.8804321289062
      ],
      [
        -170.6421356201172,
        -2740.3857421875,
        807.2107543945312
      ],
      [
        -165.17123413085938,
        -2743.185546875,
        814.5003051757812
      ],
      [
        -148.8699951171875,
        -2764.08740234375,
        826.4266967773438
      ],
      [
        202.6788330078125,
        -2905.23779296875,
        266.9432373046875
      ],
      [
        225.14234924316406,
        -2908.51806640625,
        169.73489379882812
      ],
      [
        -91.89059448242188,
        -2884.895751953125,
        830.8804321289062
      ],
      [
        -37.998291015625,
        -2924.48193359375,
        827.2244262695312
      ],
      [
        -37.998291015625,
        -2924.48193359375,
        827.2244262695312
      ],
      [
        -35.91261672973633,
        -2925.689697265625,
        827.048828125
      ],
      [
        -159.21490478515625,
        -2746.3408203125,
        826.0592041015625
      ],
      [
        -148.8699951171875,
        -2764.08740234375,
        826.4266967773438
      ],
      [
        -165.17123413085938,
        -2743.185546875,
        814.5003051757812
      ],
      [
        -1.0362458229064941,
        -2793.6044921875,
        434.9576721191406
      ],
      [
        39.70861053466797,
        -2826.348876953125,
        492.12506103515625
      ],
      [
        -232.06524658203125,
        -2630.9775390625,
        150.0
      ],
      [
        -212.57278442382812,
        -2624.96337890625,
        150.0
      ],
      [
        -228.95838928222656,
        -2632.7734375,
        309.8157653808594
      ],
      [
        -174.85557556152344,
        -2725.597900390625,
        815.7214965820312
      ],
      [
        -168.10862731933594,
        -2731.083740234375,
        825.7432861328125
      ],
      [
        -174.85557556152344,
        -2725.597900390625,
        815.7214965820312
      ],
      [
        -178.71194458007812,
        -2723.851318359375,
        822.09619140625
      ],
      [
        79.55073547363281,
        -2848.33544921875,
        460.6034851074219
      ],
      [
        39.70861053466797,
        -2826.348876953125,
        492.12506103515625
      ],
      [
        -1.036245346069336,
        -2793.6044921875,
        434.9576416015625
      ],
      [
        -8.389850616455078,
        -2766.552978515625,
        240.40988159179688
      ],
      [
        -8.389846801757812,
        -2766.552978515625,
        240.40985107421875
      ],
      [
        -13.905780792236328,
        -2755.377197265625,
        173.9114227294922
      ],
      [
        -13.905776977539062,
        -2755.377197265625,
        173.9114227294922
      ],
      [
        -11.330795288085938,
        -2755.734130859375,
        162.60202026367188
      ],
      [
        7.863937854766846,
        -2779.186279296875,
        150.0
      ],
      [
        -8.461507797241211,
        -2756.1318359375,
        150.0
      ],
      [
        -186.89276123046875,
        -2738.263671875,
        162.3270263671875
      ],
      [
        -240.532470703125,
        -2633.590087890625,
        150.0
      ],
      [
        -234.54879760742188,
        -2635.43798828125,
        364.3414001464844
      ],
      [
        -178.720947265625,
        -2723.84716796875,
        822.111083984375
      ],
      [
        -186.89276123046875,
        -2738.263671875,
        162.32699584960938
      ],
      [
        -187.0667724609375,
        -2738.4912109375,
        150.0
      ],
      [
        -357.4794006347656,
        -2654.389404296875,
        845.1654052734375
      ],
      [
        -362.4698791503906,
        -2639.94140625,
        844.3678588867188
      ],
      [
        -379.1385498046875,
        -2674.011962890625,
        150.0
      ],
      [
        -357.4794006347656,
        -2654.389404296875,
        845.1654052734375
      ],
      [
        -331.2705993652344,
        -2672.5068359375,
        843.2679443359375
      ],
      [
        -271.87200927734375,
        -2711.452880859375,
        838.744873046875
      ],
      [
        -331.27056884765625,
        -2672.5068359375,
        843.2679443359375
      ],
      [
        -271.87200927734375,
        -2711.452880859375,
        838.744873046875
      ],
      [
        -205.5291290283203,
        -2721.14453125,
        830.1307983398438
      ],
      [
        -203.51712036132812,
        -2721.63427734375,
        828.4257202148438
      ],
      [
        -198.43910217285156,
        -2725.718017578125,
        803.1287841796875
      ],
      [
        -272.0412902832031,
        -2667.3046875,
        834.1177368164062
      ],
      [
        -318.67523193359375,
        -2635.6806640625,
        837.5585327148438
      ],
      [
        -203.51712036132812,
        -2721.63427734375,
        828.4257202148438
      ],
      [
        -205.52914428710938,
        -2721.14453125,
        830.1307983398438
      ],
      [
        -203.9866485595703,
        -2721.23583984375,
        829.9163818359375
      ],
      [
        -269.4703063964844,
        -2666.8583984375,
        833.6973266601562
      ],
      [
        -272.0412902832031,
        -2667.3046875,
        834.1177368164062
      ],
      [
        -196.44049072265625,
        -2727.325439453125,
        793.17236328125
      ],
      [
        -181.90737915039062,
        -2733.1796875,
        484.4303894042969
      ],
      [
        -196.44049072265625,
        -2727.325439453125,
        793.17236328125
      ],
      [
        -278.3383483886719,
        -2951.648681640625,
        461.4501037597656
      ],
      [
        -286.71929931640625,
        -2944.978515625,
        516.7809448242188
      ],
      [
        -304.2544250488281,
        -2921.663330078125,
        405.2056884765625
      ],
      [
        -261.2692565917969,
        -2957.051025390625,
        150.0
      ],
      [
        -286.71929931640625,
        -2944.978515625,
        516.7809448242188
      ],
      [
        -278.3383483886719,
        -2951.648681640625,
        461.4501037597656
      ],
      [
        -282.8677978515625,
        -2950.291259765625,
        540.5281982421875
      ],
      [
        -304.2544250488281,
        -2921.663330078125,
        405.2056884765625
      ],
      [
        -323.0094299316406,
        -2877.3408203125,
        362.6800537109375
      ],
      [
        -323.0094299316406,
        -2877.3408203125,
        362.6800537109375
      ],
      [
        -340.8389587402344,
        -2839.92333984375,
        303.56024169921875
      ],
      [
        -340.8389587402344,
        -2839.92333984375,
        303.5602111816406
      ],
      [
        -356.8122253417969,
        -2831.78857421875,
        150.0
      ],
      [
        -181.55667114257812,
        -2722.562744140625,
        826.798583984375
      ],
      [
        -353.7283935546875,
        -2847.56494140625,
        864.9747924804688
      ],
      [
        -354.8207092285156,
        -2847.17236328125,
        865.092041015625
      ],
      [
        -317.4518737792969,
        -2927.37158203125,
        868.1151733398438
      ],
      [
        -318.201171875,
        -2926.55029296875,
        868.137451171875
      ],
      [
        -318.201171875,
        -2926.55029296875,
        868.137451171875
      ],
      [
        -320.4237365722656,
        -2920.833740234375,
        867.85791015625
      ],
      [
        -299.7966003417969,
        -2934.570556640625,
        603.116943359375
      ],
      [
        -297.8014831542969,
        -2930.243408203125,
        446.265380859375
      ],
      [
        -301.7523193359375,
        -2944.58154296875,
        867.6483764648438
      ],
      [
        -300.4662780761719,
        -2937.811279296875,
        690.1046142578125
      ],
      [
        -300.4662780761719,
        -2937.811279296875,
        690.1046142578125
      ],
      [
        -299.7966003417969,
        -2934.570556640625,
        603.116943359375
      ],
      [
        -352.2510681152344,
        -2848.095947265625,
        864.816162109375
      ],
      [
        -326.9071960449219,
        -2904.157958984375,
        867.0424194335938
      ],
      [
        -352.2510681152344,
        -2848.095947265625,
        864.816162109375
      ],
      [
        -326.9071960449219,
        -2904.157958984375,
        867.04248046875
      ],
      [
        -301.6617736816406,
        -2944.680908203125,
        867.6456909179688
      ],
      [
        -291.5008239746094,
        -2947.704345703125,
        691.2490844726562
      ],
      [
        -291.5008239746094,
        -2947.704345703125,
        691.2490844726562
      ],
      [
        -534.6368408203125,
        -2637.69189453125,
        275.1019592285156
      ],
      [
        -508.76104736328125,
        -2729.926025390625,
        506.04541015625
      ],
      [
        -549.0830078125,
        -2588.620361328125,
        150.0
      ],
      [
        -534.6368408203125,
        -2637.69189453125,
        275.1019287109375
      ],
      [
        -392.1784973144531,
        -2833.74560546875,
        869.10302734375
      ],
      [
        -439.453857421875,
        -2818.809326171875,
        874.3952026367188
      ],
      [
        -485.4504089355469,
        -2801.845947265625,
        696.421875
      ],
      [
        -392.178466796875,
        -2833.74560546875,
        869.1029663085938
      ],
      [
        -485.4504089355469,
        -2801.845947265625,
        696.421875
      ],
      [
        -494.71826171875,
        -2772.468017578125,
        619.49169921875
      ],
      [
        -508.76104736328125,
        -2729.926025390625,
        506.04541015625
      ],
      [
        -494.71826171875,
        -2772.468017578125,
        619.49169921875
      ],
      [
        218.1004638671875,
        -2503.46533203125,
        745.6693725585938
      ],
      [
        231.30743408203125,
        -2504.015869140625,
        743.809326171875
      ],
      [
        167.01559448242188,
        -2494.908935546875,
        752.1870727539062
      ],
      [
        218.1004638671875,
        -2503.46533203125,
        745.6693725585938
      ],
      [
        167.01559448242188,
        -2494.908935546875,
        752.1871337890625
      ],
      [
        -81.97344207763672,
        -2451.421142578125,
        783.7666015625
      ],
      [
        -397.05926513671875,
        -2419.412109375,
        150.0
      ],
      [
        -450.96990966796875,
        -2384.848876953125,
        150.0
      ],
      [
        -395.01861572265625,
        -2413.303466796875,
        378.86181640625
      ],
      [
        -230.0,
        -2425.67529296875,
        800.0
      ],
      [
        -225.0,
        -2426.521728515625,
        800.0
      ],
      [
        -217.5,
        -2418.680908203125,
        800.0
      ],
      [
        -233.99099731445312,
        -2425.0,
        800.0
      ],
      [
        -235.0,
        -2424.829345703125,
        800.0
      ],
      [
        -225.79293823242188,
        -2407.25,
        800.0
      ],
      [
        -215.0,
        -2402.0,
        797.8793334960938
      ],
      [
        -210.5,
        -2402.0,
        797.2257690429688
      ],
      [
        -195.5,
        -2402.0,
        795.0472412109375
      ],
      [
        -191.0,
        -2402.0,
        794.3937377929688
      ],
      [
        -210.5,
        -2385.0,
        795.4345703125
      ],
      [
        -215.0,
        -2385.0,
        796.088134765625
      ],
      [
        -195.5,
        -2385.0,
        793.2559814453125
      ],
      [
        -191.0,
        -2385.0,
        792.6024780273438
      ],
      [
        -195.5,
        -2360.5,
        790.674560546875
      ],
      [
        -210.5,
        -2360.5,
        792.8530883789062
      ],
      [
        -210.5,
        -2385.0,
        795.4345703125
      ],
      [
        -210.5,
        -2373.0,
        794.170166015625
      ],
      [
        -195.5,
        -2373.0,
        791.9916381835938
      ],
      [
        -195.5,
        -2385.0,
        793.2559814453125
      ],
      [
        -210.5,
        -2373.0,
        794.170166015625
      ],
      [
        -207.0,
        -2373.0,
        793.661865234375
      ],
      [
        -199.0,
        -2373.0,
        792.5000610351562
      ],
      [
        -195.5,
        -2373.0,
        791.9916381835938
      ],
      [
        -207.0,
        -2371.5,
        793.5038452148438
      ],
      [
        -207.0,
        -2373.0,
        793.661865234375
      ],
      [
        -199.0,
        -2373.0,
        792.5
      ],
      [
        -199.0,
        -2371.5,
        792.3419189453125
      ],
      [
        -207.76231384277344,
        -2380.5,
        794.5628051757812
      ],
      [
        -207.96583557128906,
        -2377.0,
        794.2235717773438
      ],
      [
        -210.5,
        -2380.5,
        794.9603881835938
      ],
      [
        -207.76231384277344,
        -2380.5,
        794.5628051757812
      ],
      [
        -197.0861053466797,
        -2377.0,
        792.6434936523438
      ],
      [
        -197.32847595214844,
        -2380.5,
        793.0474853515625
      ],
      [
        -196.09799194335938,
        -2377.0,
        792.5
      ],
      [
        -195.5,
        -2377.82421875,
        792.5
      ],
      [
        -197.32847595214844,
        -2380.5,
        793.0474853515625
      ],
      [
        -195.5,
        -2380.5,
        792.7819213867188
      ],
      [
        -210.5,
        -2402.0,
        797.2257690429688
      ],
      [
        -210.5,
        -2390.0,
        795.9613647460938
      ],
      [
        -195.5,
        -2390.0,
        793.7828369140625
      ],
      [
        -195.5,
        -2402.0,
        795.0472412109375
      ],
      [
        -206.77374267578125,
        -2397.5,
        796.21044921875
      ],
      [
        -206.97726440429688,
        -2394.0,
        795.8712158203125
      ],
      [
        -210.5,
        -2397.5,
        796.7515869140625
      ],
      [
        -206.77374267578125,
        -2397.5,
        796.21044921875
      ],
      [
        -198.26341247558594,
        -2394.0,
        794.6056518554688
      ],
      [
        -198.50579833984375,
        -2397.5,
        795.0096435546875
      ],
      [
        -198.50579833984375,
        -2397.5,
        795.0096435546875
      ],
      [
        -195.5,
        -2397.5,
        794.5731201171875
      ],
      [
        -195.5,
        -2419.0,
        796.8385009765625
      ],
      [
        -191.0,
        -2419.0,
        796.1849365234375
      ],
      [
        -206.94015502929688,
        -2419.0,
        798.5
      ],
      [
        -200.0548858642578,
        -2419.0,
        797.5
      ],
      [
        -206.94015502929688,
        -2419.0,
        798.5
      ],
      [
        -213.88975524902344,
        -2419.0,
        799.5093383789062
      ],
      [
        -195.5,
        -2407.0,
        795.5740356445312
      ],
      [
        -195.5,
        -2419.0,
        796.8385009765625
      ],
      [
        -208.76077270507812,
        -2407.0,
        797.5
      ],
      [
        -200.0548858642578,
        -2419.0,
        797.5
      ],
      [
        -199.4407196044922,
        -2411.0,
        796.56787109375
      ],
      [
        -199.68312072753906,
        -2414.5,
        796.9718627929688
      ],
      [
        -199.68312072753906,
        -2414.5,
        796.9718627929688
      ],
      [
        -195.5,
        -2414.5,
        796.3643188476562
      ],
      [
        -195.5,
        -2432.368408203125,
        780.0
      ],
      [
        -195.5,
        -2424.0,
        797.3652954101562
      ],
      [
        -195.5,
        -2425.2783203125,
        797.5
      ],
      [
        -195.5,
        -2431.62109375,
        797.5
      ],
      [
        -210.5,
        -2429.08251953125,
        797.5
      ],
      [
        -210.5,
        -2429.829833984375,
        780.0
      ],
      [
        -213.3900604248047,
        -2424.0,
        799.9635620117188
      ],
      [
        -213.88975524902344,
        -2419.0,
        799.5093383789062
      ],
      [
        -195.5,
        -2432.368408203125,
        780.0
      ],
      [
        -210.5,
        -2429.829833984375,
        780.0
      ],
      [
        -195.5,
        -2431.62109375,
        797.5
      ],
      [
        -195.5,
        -2425.2783203125,
        797.5
      ],
      [
        -196.4273681640625,
        -2424.0,
        797.5
      ],
      [
        -210.5,
        -2429.08251953125,
        797.5
      ],
      [
        -200.0,
        -2430.859375,
        797.5
      ],
      [
        -197.33596801757812,
        -2431.5,
        793.0599365234375
      ],
      [
        -197.33596801757812,
        -2431.5,
        793.0599365234375
      ],
      [
        -196.21461486816406,
        -2431.5,
        797.5
      ],
      [
        -206.0,
        -2429.843994140625,
        797.5
      ],
      [
        -209.0,
        -2429.5498046875,
        792.5
      ],
      [
        -210.5,
        -2429.296142578125,
        792.5
      ],
      [
        -209.0,
        -2429.5498046875,
        792.5
      ],
      [
        -235.0,
        -2424.69384765625,
        803.1751708984375
      ],
      [
        -235.0,
        -2407.25,
        801.337158203125
      ],
      [
        -235.0,
        -2424.829345703125,
        800.0
      ],
      [
        -225.79302978515625,
        -2407.25,
        800.0
      ],
      [
        -235.0,
        -2407.25,
        801.337158203125
      ],
      [
        -230.0,
        -2425.0,
        802.4812622070312
      ],
      [
        -233.24667358398438,
        -2425.0,
        802.9528198242188
      ],
      [
        -233.9909210205078,
        -2425.0,
        800.0
      ],
      [
        -217.5,
        -2425.0,
        800.6658325195312
      ],
      [
        -225.0,
        -2425.0,
        801.7550659179688
      ],
      [
        -230.0,
        -2425.56689453125,
        802.541015625
      ],
      [
        -230.0,
        -2425.0,
        802.4812622070312
      ],
      [
        -230.0,
        -2425.67529296875,
        800.0
      ],
      [
        -225.0,
        -2426.521728515625,
        800.0
      ],
      [
        -225.0,
        -2425.0,
        801.7550659179688
      ],
      [
        -225.0,
        -2426.4404296875,
        801.9068603515625
      ],
      [
        -217.5,
        -2418.680908203125,
        800.0
      ],
      [
        -217.5,
        -2425.0,
        800.6658325195312
      ],
      [
        -88.94692993164062,
        -2452.038330078125,
        784.8444213867188
      ],
      [
        -81.97344207763672,
        -2451.421142578125,
        783.7666015625
      ],
      [
        -210.5,
        -2431.759765625,
        797.5
      ],
      [
        -210.5,
        -2432.25244140625,
        780.0
      ],
      [
        -230.0,
        -2428.493408203125,
        800.0
      ],
      [
        -225.0,
        -2429.312744140625,
        800.0
      ],
      [
        -230.0,
        -2428.4130859375,
        802.8408813476562
      ],
      [
        -230.0,
        -2428.493408203125,
        800.0
      ],
      [
        -235.0,
        -2425.0,
        803.2074584960938
      ],
      [
        -235.0,
        -2425.0,
        803.2074584960938
      ],
      [
        -225.0,
        -2429.312744140625,
        800.0
      ],
      [
        -225.0,
        -2429.25048828125,
        802.2029418945312
      ],
      [
        -195.5,
        -2434.710693359375,
        780.0
      ],
      [
        -195.5,
        -2434.218017578125,
        797.5
      ],
      [
        -195.5,
        -2434.218017578125,
        797.5
      ],
      [
        -210.5,
        -2431.759765625,
        797.5
      ],
      [
        -195.5,
        -2434.710693359375,
        780.0
      ],
      [
        -210.5,
        -2432.25244140625,
        780.0
      ],
      [
        -393.7957458496094,
        -2413.92529296875,
        383.8638610839844
      ],
      [
        -378.3543701171875,
        -2423.147705078125,
        402.36541748046875
      ],
      [
        -391.1797790527344,
        -2415.2333984375,
        394.5289611816406
      ],
      [
        -378.3916931152344,
        -2421.510009765625,
        446.47821044921875
      ],
      [
        -210.5,
        -2432.920654296875,
        797.5
      ],
      [
        -210.5,
        -2433.568115234375,
        780.0
      ],
      [
        -393.7957458496094,
        -2413.92529296875,
        383.8638610839844
      ],
      [
        -392.69354248046875,
        -2414.40576171875,
        388.2456970214844
      ],
      [
        -230.0,
        -2429.88330078125,
        802.9957885742188
      ],
      [
        -230.0,
        -2429.994140625,
        800.0
      ],
      [
        -225.0,
        -2430.0,
        802.2819213867188
      ],
      [
        -225.0,
        -2430.0,
        802.2819213867188
      ],
      [
        -225.0,
        -2430.6337890625,
        802.3486938476562
      ],
      [
        -225.0,
        -2430.734130859375,
        799.6328735351562
      ],
      [
        -229.959228515625,
        -2430.0,
        800.0
      ],
      [
        -230.0,
        -2429.994140625,
        800.0
      ],
      [
        -229.959228515625,
        -2430.0,
        800.0
      ],
      [
        -225.0,
        -2430.734130859375,
        799.6328735351562
      ],
      [
        -391.1797790527344,
        -2415.2333984375,
        394.5291748046875
      ],
      [
        -392.0885314941406,
        -2414.696044921875,
        390.6929626464844
      ],
      [
        -392.69354248046875,
        -2414.40576171875,
        388.2456970214844
      ],
      [
        -392.0885009765625,
        -2414.696044921875,
        390.6929016113281
      ],
      [
        -195.5,
        -2435.74755859375,
        780.0
      ],
      [
        -195.5,
        -2435.10009765625,
        797.5
      ],
      [
        -195.5,
        -2435.74755859375,
        780.0
      ],
      [
        -210.5,
        -2433.568115234375,
        780.0
      ],
      [
        -195.5,
        -2435.10009765625,
        797.5
      ],
      [
        -210.5,
        -2432.920654296875,
        797.5
      ],
      [
        -378.3543701171875,
        -2423.147705078125,
        402.36541748046875
      ],
      [
        -378.44415283203125,
        -2423.404296875,
        395.07733154296875
      ],
      [
        -378.89312744140625,
        -2424.687255859375,
        358.636962890625
      ],
      [
        -377.13458251953125,
        -2432.66259765625,
        150.0
      ],
      [
        -378.89312744140625,
        -2424.687255859375,
        358.6369934082031
      ],
      [
        -208.477294921875,
        -2491.6484375,
        567.9466552734375
      ],
      [
        -205.5115966796875,
        -2495.83056640625,
        405.9115295410156
      ],
      [
        -266.0561828613281,
        -2490.66552734375,
        519.583740234375
      ],
      [
        -277.0323181152344,
        -2499.527099609375,
        150.00001525878906
      ],
      [
        -208.477294921875,
        -2491.6484375,
        567.9466552734375
      ],
      [
        -228.87188720703125,
        -2489.7099609375,
        614.1401977539062
      ],
      [
        -250.5918731689453,
        -2487.6455078125,
        663.3368530273438
      ],
      [
        -264.0294494628906,
        -2489.029296875,
        587.814208984375
      ],
      [
        -311.013427734375,
        -2453.052978515625,
        717.7734985351562
      ],
      [
        -283.4491271972656,
        -2456.341064453125,
        813.5462036132812
      ],
      [
        -255.26904296875,
        -2470.118408203125,
        810.9051513671875
      ],
      [
        -240.31146240234375,
        -2488.814208984375,
        632.4262084960938
      ],
      [
        -240.85797119140625,
        -2488.57080078125,
        641.2897338867188
      ],
      [
        -231.35443115234375,
        -2466.121826171875,
        807.0108032226562
      ],
      [
        -229.4999542236328,
        -2464.475830078125,
        806.5680541992188
      ],
      [
        -240.25204467773438,
        -2488.963623046875,
        626.5665893554688
      ],
      [
        -240.31146240234375,
        -2488.814208984375,
        632.4262084960938
      ],
      [
        -209.6476287841797,
        -2436.0,
        780.0
      ],
      [
        -208.26608276367188,
        -2433.892578125,
        780.0
      ],
      [
        -220.13795471191406,
        -2452.0,
        780.0
      ],
      [
        -210.30337524414062,
        -2437.0,
        780.0
      ],
      [
        -221.12147521972656,
        -2453.5,
        780.0
      ],
      [
        -226.5,
        -2461.703369140625,
        780.0
      ],
      [
        -226.32618713378906,
        -2461.5,
        778.5
      ],
      [
        -229.0,
        -2465.578125,
        778.5
      ],
      [
        -229.0,
        -2465.578125,
        778.5
      ],
      [
        -229.0,
        -2461.5,
        780.0
      ],
      [
        -229.0,
        -2465.5166015625,
        780.0
      ],
      [
        -221.48646545410156,
        -2453.5,
        793.590087890625
      ],
      [
        -221.5143280029297,
        -2453.5,
        794.6275024414062
      ],
      [
        -221.48646545410156,
        -2453.5,
        793.590087890625
      ],
      [
        -221.1214599609375,
        -2453.5,
        780.0
      ],
      [
        -221.5143280029297,
        -2453.5,
        794.6275024414062
      ],
      [
        -221.5377197265625,
        -2453.5,
        795.5
      ],
      [
        -230.0,
        -2430.0,
        803.0081176757812
      ],
      [
        -230.0,
        -2445.0,
        804.588623046875
      ],
      [
        -230.0,
        -2430.0,
        803.0081176757812
      ],
      [
        -222.5,
        -2445.0,
        803.4993286132812
      ],
      [
        -230.0,
        -2445.0,
        804.588623046875
      ],
      [
        -222.5,
        -2445.0,
        796.25
      ],
      [
        -222.5,
        -2445.0,
        796.25
      ],
      [
        -222.5,
        -2440.0,
        796.25
      ],
      [
        -225.0,
        -2440.0,
        803.3355712890625
      ],
      [
        -222.5,
        -2440.0,
        796.25
      ],
      [
        -225.0,
        -2440.0,
        803.3355712890625
      ],
      [
        -222.5,
        -2440.0,
        802.9724731445312
      ],
      [
        -210.5,
        -2437.0,
        780.0
      ],
      [
        -210.6271209716797,
        -2437.0,
        792.0530395507812
      ],
      [
        -210.5,
        -2437.0,
        787.320556640625
      ],
      [
        -210.6271514892578,
        -2437.0,
        792.0530395507812
      ],
      [
        -210.71978759765625,
        -2437.0,
        795.5
      ],
      [
        -220.542724609375,
        -2452.0,
        795.0718383789062
      ],
      [
        -220.52806091308594,
        -2452.0,
        794.5261840820312
      ],
      [
        -220.52806091308594,
        -2452.0,
        794.5261840820312
      ],
      [
        -220.13795471191406,
        -2452.0,
        780.0
      ],
      [
        -220.55421447753906,
        -2452.0,
        795.5
      ],
      [
        -220.542724609375,
        -2452.0,
        795.0718383789062
      ],
      [
        -212.4594268798828,
        -2439.653564453125,
        795.5
      ],
      [
        -215.0,
        -2443.528564453125,
        795.5
      ],
      [
        -210.71971130371094,
        -2437.0,
        795.5
      ],
      [
        -212.4594268798828,
        -2439.653564453125,
        795.5
      ],
      [
        -215.96469116210938,
        -2445.0,
        795.5
      ],
      [
        -220.55421447753906,
        -2452.0,
        795.5
      ],
      [
        -215.0,
        -2440.0,
        801.8832397460938
      ],
      [
        -215.9848175048828,
        -2445.0,
        796.25
      ],
      [
        -215.96469116210938,
        -2445.0,
        795.5
      ],
      [
        -216.15487670898438,
        -2445.0,
        802.5778198242188
      ],
      [
        -215.9848175048828,
        -2445.0,
        796.25
      ],
      [
        -215.0,
        -2443.528564453125,
        795.5
      ],
      [
        -215.0,
        -2443.498046875,
        796.25
      ],
      [
        -215.0,
        -2443.498046875,
        796.25
      ],
      [
        -215.0,
        -2440.0,
        801.8832397460938
      ],
      [
        -215.0,
        -2443.2529296875,
        802.2260131835938
      ],
      [
        -217.0880889892578,
        -2447.0,
        788.5
      ],
      [
        -213.0,
        -2440.764892578125,
        788.5
      ],
      [
        -216.8597412109375,
        -2447.0,
        780.0
      ],
      [
        -217.0880889892578,
        -2447.0,
        788.5
      ],
      [
        -213.0,
        -2440.764892578125,
        788.5
      ],
      [
        -213.0,
        -2441.113037109375,
        780.0
      ],
      [
        -226.5,
        -2461.703369140625,
        780.0
      ],
      [
        -226.5,
        -2461.068603515625,
        795.5
      ],
      [
        -229.0,
        -2464.8203125,
        797.0
      ],
      [
        -229.0,
        -2464.8203125,
        797.0
      ],
      [
        -226.82305908203125,
        -2461.5,
        797.0
      ],
      [
        -226.5,
        -2461.068603515625,
        795.5
      ],
      [
        -221.5377197265625,
        -2453.5,
        795.5
      ],
      [
        -226.18492126464844,
        -2461.10009765625,
        783.0
      ],
      [
        -226.10430908203125,
        -2461.10009765625,
        780.0
      ],
      [
        -226.5,
        -2461.10009765625,
        794.7322387695312
      ],
      [
        -226.4401397705078,
        -2461.10009765625,
        792.4999389648438
      ],
      [
        -226.5,
        -2461.58056640625,
        783.0
      ],
      [
        -226.18492126464844,
        -2461.10009765625,
        783.0
      ],
      [
        -226.4401397705078,
        -2461.10009765625,
        792.4999389648438
      ],
      [
        -226.5,
        -2461.19140625,
        792.4999389648438
      ],
      [
        -210.11761474609375,
        -2436.0,
        797.5
      ],
      [
        -210.09754943847656,
        -2436.0,
        796.7526245117188
      ],
      [
        -210.09754943847656,
        -2436.0,
        796.7526245117188
      ],
      [
        -209.6476287841797,
        -2436.0,
        780.0
      ],
      [
        -210.30335998535156,
        -2437.0,
        780.0
      ],
      [
        -208.3075408935547,
        -2433.2392578125,
        797.5
      ],
      [
        -210.11761474609375,
        -2436.0,
        797.5
      ],
      [
        -240.25204467773438,
        -2488.963623046875,
        626.5665893554688
      ],
      [
        -228.03346252441406,
        -2465.486572265625,
        778.5
      ],
      [
        -239.92828369140625,
        -2488.98486328125,
        626.2130737304688
      ],
      [
        -195.5,
        -2435.837646484375,
        780.0
      ],
      [
        -195.67889404296875,
        -2436.0,
        780.0
      ],
      [
        -213.30995178222656,
        -2452.0,
        780.0
      ],
      [
        -196.7808837890625,
        -2437.0,
        780.0
      ],
      [
        -214.96298217773438,
        -2453.5,
        780.0
      ],
      [
        -226.5,
        -2463.9697265625,
        780.0
      ],
      [
        -223.64068603515625,
        -2461.5,
        778.5
      ],
      [
        -228.03358459472656,
        -2465.486572265625,
        778.5
      ],
      [
        -224.29991149902344,
        -2462.62548828125,
        772.1786499023438
      ],
      [
        -224.38064575195312,
        -2462.17138671875,
        778.5
      ],
      [
        -223.04331970214844,
        -2461.5,
        772.0
      ],
      [
        -224.29991149902344,
        -2462.62548828125,
        772.1786499023438
      ],
      [
        -214.57559204101562,
        -2452.0,
        793.7665405273438
      ],
      [
        -214.3656005859375,
        -2452.0,
        791.4830322265625
      ],
      [
        -214.3656005859375,
        -2452.0,
        791.4830322265625
      ],
      [
        -213.3099365234375,
        -2452.0,
        780.0
      ],
      [
        -214.7349395751953,
        -2452.0,
        795.5
      ],
      [
        -214.57559204101562,
        -2452.0,
        793.7665405273438
      ],
      [
        -216.02093505859375,
        -2453.5,
        791.5079345703125
      ],
      [
        -216.22264099121094,
        -2453.5,
        793.7014770507812
      ],
      [
        -216.02093505859375,
        -2453.5,
        791.5079345703125
      ],
      [
        -214.9629669189453,
        -2453.5,
        780.0
      ],
      [
        -216.22264099121094,
        -2453.5,
        793.7014770507812
      ],
      [
        -216.38796997070312,
        -2453.5,
        795.5
      ],
      [
        -226.5,
        -2462.551513671875,
        797.0
      ],
      [
        -226.5,
        -2461.59521484375,
        804.0
      ],
      [
        -226.5,
        -2462.456787109375,
        798.1354370117188
      ],
      [
        -226.5,
        -2463.9697265625,
        780.0
      ],
      [
        -226.5,
        -2462.6767578125,
        795.5
      ],
      [
        -227.62997436523438,
        -2462.730712890625,
        797.0
      ],
      [
        -226.5,
        -2461.5,
        797.0
      ],
      [
        -226.5,
        -2462.551513671875,
        797.0
      ],
      [
        -226.5885772705078,
        -2462.6318359375,
        797.0
      ],
      [
        -226.5,
        -2462.6767578125,
        795.5
      ],
      [
        -216.38796997070312,
        -2453.5,
        795.5
      ],
      [
        -226.5,
        -2462.551513671875,
        797.0
      ],
      [
        -225.34124755859375,
        -2461.5,
        797.0
      ],
      [
        -225.34124755859375,
        -2461.5,
        797.0
      ],
      [
        -226.5,
        -2461.59521484375,
        804.0
      ],
      [
        -225.98477172851562,
        -2461.5,
        804.0
      ],
      [
        -226.04180908203125,
        -2461.5517578125,
        804.0
      ],
      [
        -225.800048828125,
        -2463.084228515625,
        783.0
      ],
      [
        -224.60009765625,
        -2462.245849609375,
        780.0
      ],
      [
        -226.5,
        -2463.719482421875,
        783.0
      ],
      [
        -225.800048828125,
        -2463.084228515625,
        783.0
      ],
      [
        -224.73223876953125,
        -2461.10009765625,
        795.1695556640625
      ],
      [
        -225.800048828125,
        -2462.291748046875,
        792.4999389648438
      ],
      [
        -224.73223876953125,
        -2461.10009765625,
        795.1695556640625
      ],
      [
        -224.7626190185547,
        -2461.10009765625,
        795.4999389648438
      ],
      [
        -225.800048828125,
        -2462.291748046875,
        792.4999389648438
      ],
      [
        -226.5,
        -2462.927001953125,
        792.4999389648438
      ],
      [
        -197.02700805664062,
        -2436.0,
        794.6641235351562
      ],
      [
        -197.2877197265625,
        -2436.0,
        797.5
      ],
      [
        -195.67889404296875,
        -2436.0,
        780.0
      ],
      [
        -197.02700805664062,
        -2436.0,
        794.6641235351562
      ],
      [
        -199.12646484375,
        -2437.83544921875,
        795.5
      ],
      [
        -209.09255981445312,
        -2446.879638671875,
        795.5
      ],
      [
        -198.2058868408203,
        -2437.0,
        795.5
      ],
      [
        -199.12646484375,
        -2437.83544921875,
        795.5
      ],
      [
        -209.09255981445312,
        -2446.879638671875,
        795.5
      ],
      [
        -214.73495483398438,
        -2452.0,
        795.5
      ],
      [
        -215.0,
        -2445.0,
        802.4100952148438
      ],
      [
        -215.0,
        -2445.0,
        802.4100952148438
      ],
      [
        -196.78082275390625,
        -2437.0,
        780.0
      ],
      [
        -197.8700408935547,
        -2437.0,
        791.8474731445312
      ],
      [
        -198.2058868408203,
        -2437.0,
        795.5
      ],
      [
        -197.8700408935547,
        -2437.0,
        791.8474731445312
      ],
      [
        -196.18617248535156,
        -2435.00048828125,
        797.5
      ],
      [
        -197.28770446777344,
        -2436.0,
        797.5
      ],
      [
        -195.5,
        -2435.837646484375,
        780.0
      ],
      [
        -195.5,
        -2435.67578125,
        781.9389038085938
      ],
      [
        -229.0,
        -2466.363525390625,
        778.5
      ],
      [
        -226.5,
        -2461.967529296875,
        804.0
      ],
      [
        -226.5,
        -2461.967529296875,
        804.0
      ],
      [
        -229.0,
        -2466.363525390625,
        778.5
      ],
      [
        -228.87188720703125,
        -2489.7099609375,
        614.1401977539062
      ],
      [
        -228.03358459472656,
        -2465.486572265625,
        778.5
      ],
      [
        -189.5,
        -2461.832763671875,
        778.5
      ],
      [
        -193.0,
        -2461.9443359375,
        780.0
      ],
      [
        -226.5,
        -2465.120849609375,
        780.0
      ],
      [
        -170.04864501953125,
        -2458.0,
        780.0
      ],
      [
        -189.5,
        -2461.6123046875,
        780.0
      ],
      [
        -189.1387481689453,
        -2461.578125,
        780.0
      ],
      [
        -145.0,
        -2453.30517578125,
        780.0
      ],
      [
        -137.0,
        -2451.8056640625,
        780.0
      ],
      [
        -189.5,
        -2461.6123046875,
        780.0
      ],
      [
        -189.5,
        -2461.832763671875,
        778.5
      ],
      [
        -226.5,
        -2462.84375,
        795.5
      ],
      [
        -193.0,
        -2459.667236328125,
        795.5
      ],
      [
        -196.57691955566406,
        -2436.0,
        795.5
      ],
      [
        -197.10385131835938,
        -2436.0,
        795.5
      ],
      [
        -195.5,
        -2436.0,
        795.5
      ],
      [
        -196.57691955566406,
        -2436.0,
        795.5
      ],
      [
        -226.5,
        -2462.62353515625,
        797.0
      ],
      [
        -214.6508331298828,
        -2461.5,
        797.0
      ],
      [
        -226.5885772705078,
        -2462.6318359375,
        797.0
      ],
      [
        -214.65086364746094,
        -2461.5,
        797.0
      ],
      [
        -226.5,
        -2462.62353515625,
        797.0
      ],
      [
        -226.5,
        -2462.456787109375,
        798.1361083984375
      ],
      [
        -226.04180908203125,
        -2461.5517578125,
        804.0
      ],
      [
        -225.49600219726562,
        -2461.5,
        804.0
      ],
      [
        -195.5,
        -2435.174072265625,
        795.5
      ],
      [
        -195.5,
        -2436.0,
        795.5
      ],
      [
        -193.0,
        -2461.810791015625,
        780.9083862304688
      ],
      [
        -193.0,
        -2461.6328125,
        782.1192626953125
      ],
      [
        -193.0,
        -2460.045654296875,
        792.9254150390625
      ],
      [
        -193.0,
        -2459.881591796875,
        794.0404663085938
      ],
      [
        -193.0,
        -2461.6328125,
        782.1192626953125
      ],
      [
        -193.0,
        -2460.045654296875,
        792.9254150390625
      ],
      [
        -193.0,
        -2461.9443359375,
        780.0
      ],
      [
        -193.0,
        -2461.810791015625,
        780.9083862304688
      ],
      [
        -193.0,
        -2459.881591796875,
        794.0404663085938
      ],
      [
        -193.0,
        -2459.667236328125,
        795.5
      ],
      [
        -189.5,
        -2461.2451171875,
        782.5
      ],
      [
        -171.7123260498047,
        -2458.0,
        782.5
      ],
      [
        -188.5418243408203,
        -2461.154052734375,
        782.5
      ],
      [
        -145.0,
        -2452.9931640625,
        782.5
      ],
      [
        -137.0,
        -2451.49365234375,
        782.5
      ],
      [
        -189.5,
        -2461.606689453125,
        780.0379028320312
      ],
      [
        -189.5,
        -2461.60986328125,
        780.0156860351562
      ],
      [
        -189.5,
        -2461.5,
        780.7650756835938
      ],
      [
        -189.5,
        -2461.606689453125,
        780.0379028320312
      ],
      [
        -189.5,
        -2461.60986328125,
        780.0156860351562
      ],
      [
        -189.5,
        -2461.6123046875,
        780.0
      ],
      [
        -189.5,
        -2461.6123046875,
        780.0
      ],
      [
        -189.5,
        -2461.2451171875,
        782.5
      ],
      [
        -145.0,
        -2453.30517578125,
        780.0
      ],
      [
        -145.0,
        -2452.9931640625,
        782.5
      ],
      [
        -137.0,
        -2451.49365234375,
        782.5
      ],
      [
        -137.0,
        -2451.8056640625,
        780.0
      ],
      [
        -226.5,
        -2465.120849609375,
        780.0
      ],
      [
        -226.5,
        -2462.84375,
        795.5
      ],
      [
        -224.60009765625,
        -2462.663818359375,
        795.4999389648438
      ],
      [
        -225.800048828125,
        -2463.21826171875,
        792.4999389648438
      ],
      [
        -225.800048828125,
        -2463.21826171875,
        792.4999389648438
      ],
      [
        -226.5,
        -2463.284423828125,
        792.4999389648438
      ],
      [
        -217.60023498535156,
        -2462.0,
        795.5
      ],
      [
        -216.05404663085938,
        -2462.0,
        794.5
      ],
      [
        -216.05406188964844,
        -2462.0,
        794.5
      ],
      [
        -220.5,
        -2462.421630859375,
        794.5
      ],
      [
        -220.5,
        -2462.421630859375,
        794.5
      ],
      [
        -221.5,
        -2462.369873046875,
        795.5
      ],
      [
        -194.5,
        -2460.030029296875,
        794.0
      ],
      [
        -193.0,
        -2459.8876953125,
        794.0
      ],
      [
        -194.5,
        -2460.030029296875,
        794.0
      ],
      [
        -194.5,
        -2459.8095703125,
        795.5
      ],
      [
        -223.71275329589844,
        -2465.92822265625,
        772.702880859375
      ],
      [
        -193.82656860351562,
        -2463.1591796875,
        772.2633666992188
      ],
      [
        -223.71275329589844,
        -2465.92822265625,
        772.702880859375
      ],
      [
        -223.861572265625,
        -2465.091064453125,
        778.5
      ],
      [
        -193.64280700683594,
        -2462.2255859375,
        778.5
      ],
      [
        -193.82656860351562,
        -2463.1591796875,
        772.2633666992188
      ],
      [
        -217.5,
        -2468.1015625,
        753.896728515625
      ],
      [
        -220.5,
        -2468.3603515625,
        754.0732421875
      ],
      [
        -197.5,
        -2466.37841796875,
        752.7197265625
      ],
      [
        -200.5,
        -2466.636962890625,
        752.8963012695312
      ],
      [
        -220.5,
        -2468.3603515625,
        754.0732421875
      ],
      [
        -220.5,
        -2468.9677734375,
        749.939208984375
      ],
      [
        -217.5,
        -2468.708984375,
        749.7625732421875
      ],
      [
        -217.5,
        -2468.1015625,
        753.896728515625
      ],
      [
        -220.5,
        -2468.9677734375,
        749.939208984375
      ],
      [
        -217.5,
        -2468.708984375,
        749.7625732421875
      ],
      [
        -200.5,
        -2466.636962890625,
        752.8963012695312
      ],
      [
        -200.5,
        -2467.244140625,
        748.7620239257812
      ],
      [
        -197.5,
        -2466.984619140625,
        748.5941162109375
      ],
      [
        -197.5,
        -2466.37841796875,
        752.7197265625
      ],
      [
        -197.5574951171875,
        -2466.99072265625,
        748.5889282226562
      ],
      [
        -200.5,
        -2467.244140625,
        748.7620239257812
      ],
      [
        -229.0,
        -2469.236328125,
        778.5
      ],
      [
        -226.5,
        -2466.647705078125,
        795.5
      ],
      [
        -193.0,
        -2460.36865234375,
        795.5
      ],
      [
        -226.5,
        -2466.46044921875,
        797.0
      ],
      [
        -214.0,
        -2464.11767578125,
        797.0
      ],
      [
        -200.0345001220703,
        -2461.5,
        797.0
      ],
      [
        -204.0,
        -2462.2431640625,
        797.0
      ],
      [
        -229.0,
        -2466.928955078125,
        797.0
      ],
      [
        -200.03457641601562,
        -2461.5,
        797.0
      ],
      [
        -229.0,
        -2464.945556640625,
        795.5
      ],
      [
        -229.0,
        -2466.928955078125,
        797.0
      ],
      [
        -229.0,
        -2467.115966796875,
        795.5
      ],
      [
        -206.2315673828125,
        -2462.661376953125,
        797.0
      ],
      [
        -229.4999542236328,
        -2464.475830078125,
        806.5680541992188
      ],
      [
        -212.5105743408203,
        -2462.972412109375,
        803.9422607421875
      ],
      [
        -219.5,
        -2463.632568359375,
        804.0
      ],
      [
        -214.0,
        -2463.39794921875,
        797.0
      ],
      [
        -226.5,
        -2464.296142578125,
        804.0
      ],
      [
        -219.5,
        -2463.632568359375,
        804.0
      ],
      [
        -226.5,
        -2464.5830078125,
        797.0
      ],
      [
        -226.5,
        -2464.296142578125,
        804.0
      ],
      [
        -201.8528289794922,
        -2461.5,
        799.7327880859375
      ],
      [
        -200.0345001220703,
        -2461.5,
        797.0
      ],
      [
        -204.0,
        -2462.2431640625,
        797.0
      ],
      [
        -201.8528289794922,
        -2461.5,
        799.7327880859375
      ],
      [
        -219.5,
        -2464.275634765625,
        804.0
      ],
      [
        -214.0,
        -2464.11767578125,
        797.0
      ],
      [
        -226.5,
        -2466.46044921875,
        797.0
      ],
      [
        -226.5,
        -2465.587646484375,
        804.0
      ],
      [
        -226.5,
        -2465.587646484375,
        804.0
      ],
      [
        -219.5,
        -2464.275634765625,
        804.0
      ],
      [
        -193.0,
        -2462.301513671875,
        780.0
      ],
      [
        -226.5,
        -2468.58056640625,
        780.0
      ],
      [
        -189.5,
        -2461.645751953125,
        780.0
      ],
      [
        -229.0,
        -2469.236328125,
        778.5
      ],
      [
        -229.0,
        -2466.238525390625,
        780.0
      ],
      [
        -229.0,
        -2469.04931640625,
        780.0
      ],
      [
        -189.5,
        -2461.645751953125,
        780.0
      ],
      [
        -226.5,
        -2468.58056640625,
        780.0
      ],
      [
        -226.5,
        -2466.647705078125,
        795.5
      ],
      [
        -193.0,
        -2462.183837890625,
        780.9429321289062
      ],
      [
        -193.0,
        -2462.0263671875,
        782.205810546875
      ],
      [
        -193.0,
        -2460.716552734375,
        792.710693359375
      ],
      [
        -193.0,
        -2460.56640625,
        793.9136352539062
      ],
      [
        -193.0,
        -2462.0263671875,
        782.205810546875
      ],
      [
        -193.0,
        -2460.716552734375,
        792.710693359375
      ],
      [
        -193.0,
        -2462.301513671875,
        780.0
      ],
      [
        -193.0,
        -2462.183837890625,
        780.9429321289062
      ],
      [
        -193.0,
        -2460.56640625,
        793.9136352539062
      ],
      [
        -193.0,
        -2460.36865234375,
        795.5
      ],
      [
        -189.5,
        -2461.639404296875,
        780.0494995117188
      ],
      [
        -189.5,
        -2461.64306640625,
        780.0204467773438
      ],
      [
        -189.5,
        -2461.5,
        781.1678466796875
      ],
      [
        -189.5,
        -2461.639404296875,
        780.0494995117188
      ],
      [
        -189.5,
        -2461.64306640625,
        780.0204467773438
      ],
      [
        -189.5,
        -2461.645751953125,
        780.0
      ],
      [
        -189.5,
        -2461.645751953125,
        780.0
      ],
      [
        -189.5,
        -2461.333740234375,
        782.5
      ],
      [
        -189.5,
        -2461.333740234375,
        782.5
      ],
      [
        -201.7031707763672,
        -2462.0,
        795.5
      ],
      [
        -201.0382080078125,
        -2462.0,
        794.5
      ],
      [
        -201.0382080078125,
        -2462.0,
        794.5
      ],
      [
        -209.04136657714844,
        -2463.5,
        794.5
      ],
      [
        -209.04136657714844,
        -2463.5,
        794.5
      ],
      [
        -209.70628356933594,
        -2463.5,
        795.5
      ],
      [
        -224.60009765625,
        -2463.5,
        795.4999389648438
      ],
      [
        -225.00006103515625,
        -2462.8486328125,
        794.5
      ],
      [
        -225.00006103515625,
        -2463.5,
        794.5
      ],
      [
        -225.00006103515625,
        -2464.5,
        794.5
      ],
      [
        -226.5,
        -2464.5,
        794.5
      ],
      [
        -225.00006103515625,
        -2464.5,
        794.5
      ],
      [
        -194.5,
        -2460.8369140625,
        794.0
      ],
      [
        -194.5,
        -2460.64990234375,
        795.5
      ],
      [
        -194.5,
        -2460.8369140625,
        794.0
      ],
      [
        -193.0,
        -2460.5556640625,
        794.0
      ],
      [
        -223.19955444335938,
        -2468.81494140625,
        773.1610717773438
      ],
      [
        -193.8791046142578,
        -2463.426025390625,
        772.3057250976562
      ],
      [
        -223.19955444335938,
        -2468.81494140625,
        773.1610717773438
      ],
      [
        -223.3140869140625,
        -2468.170654296875,
        778.5
      ],
      [
        -193.7212371826172,
        -2462.6240234375,
        778.5
      ],
      [
        -193.8791046142578,
        -2463.426025390625,
        772.3057250976562
      ],
      [
        -217.5,
        -2470.51123046875,
        750.993408203125
      ],
      [
        -217.5,
        -2469.98828125,
        755.185302734375
      ],
      [
        -220.5,
        -2470.506591796875,
        755.5391845703125
      ],
      [
        -220.5,
        -2471.029296875,
        751.3472900390625
      ],
      [
        -217.5,
        -2469.98828125,
        755.185302734375
      ],
      [
        -220.5,
        -2470.506591796875,
        755.5391845703125
      ],
      [
        -220.5,
        -2471.029296875,
        751.3472900390625
      ],
      [
        -217.5,
        -2470.51123046875,
        750.993408203125
      ],
      [
        -200.5,
        -2467.05224609375,
        753.1799926757812
      ],
      [
        -200.5,
        -2467.5751953125,
        748.988037109375
      ],
      [
        -197.5,
        -2467.056884765625,
        748.6341552734375
      ],
      [
        -197.5,
        -2466.5341796875,
        752.8260498046875
      ],
      [
        -197.5,
        -2466.5341796875,
        752.8260498046875
      ],
      [
        -200.5,
        -2467.05224609375,
        753.1799926757812
      ],
      [
        -200.5,
        -2467.5751953125,
        748.988037109375
      ],
      [
        -197.5,
        -2467.056884765625,
        748.6341552734375
      ],
      [
        -194.91184997558594,
        -2461.415283203125,
        801.2222290039062
      ],
      [
        -193.0355987548828,
        -2461.2490234375,
        800.9322509765625
      ],
      [
        -194.91184997558594,
        -2461.415283203125,
        801.2222290039062
      ],
      [
        -193.0355987548828,
        -2461.2490234375,
        800.9322509765625
      ],
      [
        -186.48707580566406,
        -2460.669677734375,
        799.9201049804688
      ],
      [
        -186.48709106445312,
        -2460.669677734375,
        799.9200439453125
      ],
      [
        -189.5,
        -2461.77099609375,
        780.0
      ],
      [
        -162.0,
        -2459.1630859375,
        780.0
      ],
      [
        -145.0,
        -2457.551513671875,
        780.0
      ],
      [
        -137.0,
        -2456.792724609375,
        780.0
      ],
      [
        -189.5,
        -2461.668701171875,
        782.5
      ],
      [
        -162.0,
        -2459.060791015625,
        782.5
      ],
      [
        -145.0,
        -2457.448974609375,
        782.5
      ],
      [
        -137.0,
        -2456.6904296875,
        782.5
      ],
      [
        -137.0,
        -2456.6904296875,
        782.5
      ],
      [
        -137.0,
        -2456.792724609375,
        780.0
      ],
      [
        -145.0,
        -2457.551513671875,
        780.0
      ],
      [
        -145.0,
        -2457.448974609375,
        782.5
      ],
      [
        -189.5,
        -2461.76708984375,
        780.0948486328125
      ],
      [
        -189.5,
        -2461.76953125,
        780.0385131835938
      ],
      [
        -189.5,
        -2461.5,
        782.5
      ],
      [
        -189.5,
        -2461.76708984375,
        780.0948486328125
      ],
      [
        -189.5,
        -2461.66845703125,
        782.5
      ],
      [
        -189.5,
        -2461.76953125,
        780.0385131835938
      ],
      [
        -189.5,
        -2461.77099609375,
        780.0
      ],
      [
        -189.5,
        -2461.77099609375,
        780.0
      ],
      [
        -189.5,
        -2461.668701171875,
        782.5
      ],
      [
        -162.0,
        -2459.060791015625,
        782.5
      ],
      [
        -162.0,
        -2459.1630859375,
        780.0
      ],
      [
        -193.0,
        -2462.005859375,
        782.3699951171875
      ],
      [
        -193.0,
        -2461.98974609375,
        782.5
      ],
      [
        -193.0,
        -2462.00048828125,
        782.5
      ],
      [
        -193.0,
        -2461.46826171875,
        795.5
      ],
      [
        -204.8724822998047,
        -2462.593994140625,
        795.5
      ],
      [
        -193.9868621826172,
        -2461.5,
        797.0
      ],
      [
        -204.0,
        -2462.449462890625,
        797.0
      ],
      [
        -206.2283935546875,
        -2462.660888671875,
        797.0
      ],
      [
        -193.98561096191406,
        -2461.5,
        797.0
      ],
      [
        -200.085205078125,
        -2461.5,
        801.9824829101562
      ],
      [
        -193.9868621826172,
        -2461.5,
        797.0
      ],
      [
        -195.8740692138672,
        -2461.5,
        801.370849609375
      ],
      [
        -204.0,
        -2462.449462890625,
        797.0
      ],
      [
        -200.085205078125,
        -2461.5,
        801.9824829101562
      ],
      [
        -200.0576934814453,
        -2461.870361328125,
        802.0175170898438
      ],
      [
        -193.0,
        -2461.59375,
        792.4299926757812
      ],
      [
        -193.0,
        -2461.540283203125,
        793.7332763671875
      ],
      [
        -193.0,
        -2461.59375,
        792.4299926757812
      ],
      [
        -193.0,
        -2461.540283203125,
        793.7332763671875
      ],
      [
        -193.0,
        -2461.46826171875,
        795.5
      ],
      [
        -189.5,
        -2461.5,
        786.614990234375
      ],
      [
        -198.61032104492188,
        -2462.0,
        795.5
      ],
      [
        -198.2743682861328,
        -2462.0,
        794.7256469726562
      ],
      [
        -203.96652221679688,
        -2462.548828125,
        794.5
      ],
      [
        -198.5,
        -2462.03076171875,
        794.5
      ],
      [
        -198.2743682861328,
        -2462.0,
        794.7256469726562
      ],
      [
        -198.5,
        -2462.03076171875,
        794.5
      ],
      [
        -194.5,
        -2461.671630859375,
        794.0
      ],
      [
        -193.0,
        -2461.529541015625,
        794.0
      ],
      [
        -194.5,
        -2461.671630859375,
        794.0
      ],
      [
        -194.5,
        -2461.6103515625,
        795.5
      ],
      [
        -189.5,
        -2461.77099609375,
        780.0
      ],
      [
        -244.37255859375,
        -2487.005126953125,
        698.291015625
      ],
      [
        -242.75209045410156,
        -2476.238037109375,
        809.7320556640625
      ],
      [
        -242.75209045410156,
        -2476.238037109375,
        809.7320556640625
      ],
      [
        -244.37255859375,
        -2487.005126953125,
        698.291015625
      ],
      [
        -229.0,
        -2485.577880859375,
        778.5
      ],
      [
        -212.33071899414062,
        -2486.2138671875,
        778.5
      ],
      [
        -189.5,
        -2480.350830078125,
        778.5
      ],
      [
        -193.0,
        -2481.203857421875,
        780.0
      ],
      [
        -212.35694885253906,
        -2486.1748046875,
        780.0
      ],
      [
        -226.5,
        -2485.635009765625,
        780.0
      ],
      [
        -189.5,
        -2480.304931640625,
        780.0
      ],
      [
        -162.0,
        -2473.24267578125,
        780.0
      ],
      [
        -145.0,
        -2468.876953125,
        780.0
      ],
      [
        -137.0,
        -2466.822509765625,
        780.0
      ],
      [
        -189.5,
        -2480.304931640625,
        780.0
      ],
      [
        -189.5,
        -2480.350830078125,
        778.5
      ],
      [
        -229.0,
        -2485.577880859375,
        778.5
      ],
      [
        -229.0,
        -2469.04931640625,
        780.0
      ],
      [
        -229.0,
        -2485.540283203125,
        780.0
      ],
      [
        -226.5,
        -2485.20849609375,
        797.0
      ],
      [
        -214.0,
        -2485.685546875,
        797.0
      ],
      [
        -204.0,
        -2483.510009765625,
        797.0
      ],
      [
        -191.5,
        -2480.2998046875,
        797.0
      ],
      [
        -229.0,
        -2485.11328125,
        797.0
      ],
      [
        -189.5,
        -2479.786376953125,
        797.0
      ],
      [
        -212.66876220703125,
        -2485.736572265625,
        797.0
      ],
      [
        -226.5,
        -2485.24609375,
        795.5
      ],
      [
        -212.64161682128906,
        -2485.775146484375,
        795.5
      ],
      [
        -193.0,
        -2480.73095703125,
        795.5
      ],
      [
        -229.0,
        -2467.115966796875,
        795.5
      ],
      [
        -229.0,
        -2485.11328125,
        797.0
      ],
      [
        -229.0,
        -2485.15087890625,
        795.5
      ],
      [
        -189.5,
        -2465.53857421875,
        795.5
      ],
      [
        -189.5,
        -2463.947265625,
        795.5
      ],
      [
        -189.5,
        -2463.947265625,
        795.5
      ],
      [
        -189.5,
        -2461.5,
        795.5
      ],
      [
        -189.5,
        -2479.786376953125,
        797.0
      ],
      [
        -189.5,
        -2465.53857421875,
        795.5
      ],
      [
        -189.5,
        -2479.832275390625,
        795.5
      ],
      [
        -195.0,
        -2481.641357421875,
        782.5
      ],
      [
        -193.0,
        -2481.12744140625,
        782.5
      ],
      [
        -189.5,
        -2480.228759765625,
        782.5
      ],
      [
        -193.0,
        -2481.12744140625,
        782.5
      ],
      [
        -189.5,
        -2480.228759765625,
        782.5
      ],
      [
        -162.0,
        -2473.16650390625,
        782.5
      ],
      [
        -145.0,
        -2468.80078125,
        782.5
      ],
      [
        -137.0,
        -2466.746337890625,
        782.5
      ],
      [
        -189.5,
        -2468.54541015625,
        782.5
      ],
      [
        -189.5,
        -2461.66845703125,
        782.5
      ],
      [
        -189.5,
        -2468.54541015625,
        782.5
      ],
      [
        -189.5,
        -2480.304931640625,
        780.0
      ],
      [
        -189.5,
        -2480.228759765625,
        782.5
      ],
      [
        -189.5,
        -2480.304931640625,
        780.0
      ],
      [
        -189.5,
        -2480.228759765625,
        782.5
      ],
      [
        -162.0,
        -2473.16650390625,
        782.5
      ],
      [
        -162.0,
        -2473.24267578125,
        780.0
      ],
      [
        -145.0,
        -2468.876953125,
        780.0
      ],
      [
        -145.0,
        -2468.80078125,
        782.5
      ],
      [
        -137.0,
        -2466.746337890625,
        782.5
      ],
      [
        -137.0,
        -2466.822509765625,
        780.0
      ],
      [
        -193.0,
        -2463.363525390625,
        782.5
      ],
      [
        -193.0,
        -2463.363525390625,
        782.5
      ],
      [
        -193.0,
        -2462.00048828125,
        782.5
      ],
      [
        -193.0,
        -2481.12744140625,
        782.5
      ],
      [
        -193.0,
        -2481.203857421875,
        780.0
      ],
      [
        -226.5,
        -2485.635009765625,
        780.0
      ],
      [
        -226.5,
        -2485.572265625,
        782.5
      ],
      [
        -226.5,
        -2468.268798828125,
        782.5
      ],
      [
        -229.0,
        -2468.737548828125,
        782.5
      ],
      [
        -229.0,
        -2485.4775390625,
        782.5
      ],
      [
        -225.6000518798828,
        -2480.5,
        782.5
      ],
      [
        -225.6000518798828,
        -2477.10009765625,
        782.5
      ],
      [
        -226.5,
        -2477.10009765625,
        782.5
      ],
      [
        -225.6000518798828,
        -2477.10009765625,
        782.5
      ],
      [
        -226.5,
        -2480.5,
        782.5
      ],
      [
        -225.6000518798828,
        -2480.5,
        782.5
      ],
      [
        -197.0,
        -2482.216064453125,
        780.5
      ],
      [
        -195.0,
        -2481.702392578125,
        780.5
      ],
      [
        -197.0,
        -2482.231201171875,
        780.0
      ],
      [
        -197.0,
        -2482.216064453125,
        780.5
      ],
      [
        -195.0,
        -2481.702392578125,
        780.5
      ],
      [
        -195.0,
        -2481.717529296875,
        780.0
      ],
      [
        -196.0,
        -2481.928466796875,
        781.5
      ],
      [
        -194.0,
        -2481.414794921875,
        781.5
      ],
      [
        -196.0,
        -2481.943603515625,
        781.0
      ],
      [
        -194.0,
        -2481.429931640625,
        781.0
      ],
      [
        -196.0,
        -2481.943603515625,
        781.0
      ],
      [
        -196.0,
        -2481.928466796875,
        781.5
      ],
      [
        -194.0,
        -2481.414794921875,
        781.5
      ],
      [
        -194.0,
        -2481.429931640625,
        781.0
      ],
      [
        -195.0,
        -2481.656494140625,
        782.0
      ],
      [
        -193.0,
        -2481.142822265625,
        782.0
      ],
      [
        -195.0,
        -2481.656494140625,
        782.0
      ],
      [
        -195.0,
        -2481.641357421875,
        782.5
      ],
      [
        -226.5,
        -2485.24609375,
        795.5
      ],
      [
        -194.5,
        -2481.161865234375,
        794.0
      ],
      [
        -194.5,
        -2481.1162109375,
        795.5
      ],
      [
        -193.0,
        -2480.883544921875,
        790.5
      ],
      [
        -193.0,
        -2480.73095703125,
        795.5
      ],
      [
        -189.5,
        -2479.98486328125,
        790.5
      ],
      [
        -189.5,
        -2479.98486328125,
        790.5
      ],
      [
        -193.0,
        -2480.883544921875,
        790.5
      ],
      [
        -189.5,
        -2479.847412109375,
        795.0
      ],
      [
        -183.30148315429688,
        -2478.305908203125,
        793.3470458984375
      ],
      [
        -183.30148315429688,
        -2478.305908203125,
        793.3470458984375
      ],
      [
        -183.22999572753906,
        -2478.343994140625,
        791.5
      ],
      [
        -183.22999572753906,
        -2478.343994140625,
        791.5
      ],
      [
        -189.5,
        -2479.9541015625,
        791.5
      ],
      [
        -194.5,
        -2481.161865234375,
        794.0
      ],
      [
        -193.0,
        -2480.776611328125,
        794.0
      ],
      [
        -224.60009765625,
        -2479.5,
        795.4999389648438
      ],
      [
        -224.60009765625,
        -2478.0,
        795.4999389648438
      ],
      [
        -225.00006103515625,
        -2478.0,
        794.5
      ],
      [
        -225.00006103515625,
        -2479.5,
        794.5
      ],
      [
        -225.00006103515625,
        -2480.5,
        794.5
      ],
      [
        -226.5,
        -2480.5,
        794.5
      ],
      [
        -225.00006103515625,
        -2480.5,
        794.5
      ],
      [
        -225.00006103515625,
        -2477.10009765625,
        794.5
      ],
      [
        -226.5,
        -2477.10009765625,
        794.5
      ],
      [
        -225.00006103515625,
        -2477.10009765625,
        794.5
      ],
      [
        -219.5,
        -2485.2998046875,
        804.0
      ],
      [
        -214.0,
        -2485.685546875,
        797.0
      ],
      [
        -226.5,
        -2485.032470703125,
        804.0
      ],
      [
        -219.5,
        -2485.2998046875,
        804.0
      ],
      [
        -226.5,
        -2485.20849609375,
        797.0
      ],
      [
        -226.5,
        -2485.032470703125,
        804.0
      ],
      [
        -204.0,
        -2483.510009765625,
        797.0
      ],
      [
        -198.56900024414062,
        -2481.904541015625,
        803.9121704101562
      ],
      [
        -191.5,
        -2480.1259765625,
        802.6981201171875
      ],
      [
        -191.5,
        -2461.5,
        800.735595703125
      ],
      [
        -191.5,
        -2480.2998046875,
        797.0
      ],
      [
        -191.5,
        -2461.5,
        800.735595703125
      ],
      [
        -190.5,
        -2479.90576171875,
        801.5
      ],
      [
        -190.0,
        -2479.914794921875,
        797.0
      ],
      [
        -191.5,
        -2480.16259765625,
        801.5
      ],
      [
        -190.5,
        -2479.90576171875,
        801.5
      ],
      [
        -220.14772033691406,
        -2485.981201171875,
        775.8858642578125
      ],
      [
        -212.28367614746094,
        -2486.280029296875,
        775.9332885742188
      ],
      [
        -197.64071655273438,
        -2482.53759765625,
        775.3392944335938
      ],
      [
        -197.62074279785156,
        -2482.436279296875,
        778.5
      ],
      [
        -197.64071655273438,
        -2482.53759765625,
        775.3392944335938
      ],
      [
        -220.14772033691406,
        -2485.981201171875,
        775.8858642578125
      ],
      [
        -220.15945434570312,
        -2485.9150390625,
        778.5
      ],
      [
        -200.5,
        -2483.603271484375,
        764.4843139648438
      ],
      [
        -200.5,
        -2483.7392578125,
        760.0280151367188
      ],
      [
        -197.5,
        -2482.8486328125,
        763.96875
      ],
      [
        -200.5,
        -2483.603271484375,
        764.4843139648438
      ],
      [
        -197.5,
        -2482.984619140625,
        759.5125732421875
      ],
      [
        -197.5,
        -2482.8486328125,
        763.96875
      ],
      [
        -200.5,
        -2483.7392578125,
        760.0280151367188
      ],
      [
        -197.5,
        -2482.984619140625,
        759.5125732421875
      ],
      [
        -217.5,
        -2486.43408203125,
        761.86865234375
      ],
      [
        -217.5,
        -2486.32177734375,
        766.3409423828125
      ],
      [
        -217.5,
        -2486.32177734375,
        766.3409423828125
      ],
      [
        -220.5,
        -2486.209228515625,
        766.2639770507812
      ],
      [
        -220.5,
        -2486.209228515625,
        766.2639770507812
      ],
      [
        -220.5,
        -2486.321533203125,
        761.7916870117188
      ],
      [
        -220.5,
        -2486.321533203125,
        761.7916870117188
      ],
      [
        -217.5,
        -2486.43408203125,
        761.86865234375
      ],
      [
        -266.0561828613281,
        -2490.66552734375,
        519.583740234375
      ],
      [
        -315.125,
        -2452.5625,
        703.48779296875
      ],
      [
        -264.8418273925781,
        -2489.113037109375,
        583.2484130859375
      ],
      [
        -264.8418273925781,
        -2489.113037109375,
        583.2484130859375
      ],
      [
        -315.125,
        -2452.5625,
        703.4877319335938
      ],
      [
        -205.51158142089844,
        -2495.83056640625,
        405.9114990234375
      ],
      [
        -192.80422973632812,
        -2502.74169921875,
        150.0
      ],
      [
        -195.0,
        -2486.774658203125,
        782.5
      ],
      [
        -193.0,
        -2486.85107421875,
        782.5
      ],
      [
        -189.5,
        -2486.984619140625,
        782.5
      ],
      [
        -193.0,
        -2486.85107421875,
        782.5
      ],
      [
        -189.5,
        -2486.98486328125,
        782.5
      ],
      [
        -162.0,
        -2488.0341796875,
        782.5
      ],
      [
        -145.0,
        -2488.68310546875,
        782.5
      ],
      [
        -137.0,
        -2488.98828125,
        782.5
      ],
      [
        -193.0,
        -2486.913818359375,
        780.0
      ],
      [
        -189.5,
        -2487.04736328125,
        780.0
      ],
      [
        -162.0,
        -2488.096923828125,
        780.0
      ],
      [
        -145.0,
        -2488.74560546875,
        780.0
      ],
      [
        -137.0,
        -2489.051025390625,
        780.0
      ],
      [
        -137.0,
        -2488.98828125,
        782.5
      ],
      [
        -137.0,
        -2489.051025390625,
        780.0
      ],
      [
        -145.0,
        -2488.74560546875,
        780.0
      ],
      [
        -145.0,
        -2488.68310546875,
        782.5
      ],
      [
        -162.0,
        -2488.0341796875,
        782.5
      ],
      [
        -162.0,
        -2488.096923828125,
        780.0
      ],
      [
        -189.5,
        -2487.04736328125,
        780.0
      ],
      [
        -189.5,
        -2486.984619140625,
        782.5
      ],
      [
        -189.5,
        -2487.04736328125,
        780.0
      ],
      [
        -189.5,
        -2486.98486328125,
        782.5
      ],
      [
        -193.0,
        -2486.85107421875,
        782.5
      ],
      [
        -193.0,
        -2486.913818359375,
        780.0
      ],
      [
        -195.0,
        -2486.787109375,
        782.0
      ],
      [
        -193.0,
        -2486.86376953125,
        782.0
      ],
      [
        -195.0,
        -2486.787109375,
        782.0
      ],
      [
        -195.0,
        -2486.774658203125,
        782.5
      ],
      [
        -196.0,
        -2486.774169921875,
        781.0
      ],
      [
        -194.0,
        -2486.850341796875,
        781.0
      ],
      [
        -196.0,
        -2486.761474609375,
        781.5
      ],
      [
        -194.0,
        -2486.837646484375,
        781.5
      ],
      [
        -194.0,
        -2486.837646484375,
        781.5
      ],
      [
        -194.0,
        -2486.850341796875,
        781.0
      ],
      [
        -196.0,
        -2486.774169921875,
        781.0
      ],
      [
        -196.0,
        -2486.761474609375,
        781.5
      ],
      [
        -197.0,
        -2486.74853515625,
        780.5
      ],
      [
        -195.0,
        -2486.82470703125,
        780.5
      ],
      [
        -195.0,
        -2486.82470703125,
        780.5
      ],
      [
        -195.0,
        -2486.837158203125,
        780.0
      ],
      [
        -197.0,
        -2486.760986328125,
        780.0
      ],
      [
        -197.0,
        -2486.74853515625,
        780.5
      ],
      [
        -189.5,
        -2487.085205078125,
        778.5
      ],
      [
        -189.5,
        -2487.04736328125,
        780.0
      ],
      [
        -189.5,
        -2487.085205078125,
        778.5
      ],
      [
        -198.48057556152344,
        -2486.8046875,
        776.0166015625
      ],
      [
        -198.46839904785156,
        -2486.742919921875,
        778.5
      ],
      [
        -198.48057556152344,
        -2486.8046875,
        776.0166015625
      ],
      [
        -197.5,
        -2487.1845703125,
        762.381103515625
      ],
      [
        -197.5,
        -2487.072265625,
        766.8534545898438
      ],
      [
        -200.5,
        -2486.95947265625,
        766.7764892578125
      ],
      [
        -200.5,
        -2487.07177734375,
        762.3041381835938
      ],
      [
        -197.5,
        -2487.072265625,
        766.8534545898438
      ],
      [
        -200.5,
        -2486.95947265625,
        766.7764892578125
      ],
      [
        -200.5,
        -2487.07177734375,
        762.3041381835938
      ],
      [
        -197.5,
        -2487.1845703125,
        762.381103515625
      ],
      [
        -204.0,
        -2486.0673828125,
        797.0
      ],
      [
        -191.5,
        -2486.54443359375,
        797.0
      ],
      [
        -189.5,
        -2486.62060546875,
        797.0
      ],
      [
        -189.5,
        -2486.62060546875,
        797.0
      ],
      [
        -189.5,
        -2486.78369140625,
        790.5
      ],
      [
        -193.0,
        -2486.52490234375,
        795.5
      ],
      [
        -193.0,
        -2486.650390625,
        790.5
      ],
      [
        -193.0,
        -2486.52490234375,
        795.5
      ],
      [
        -189.5,
        -2486.78369140625,
        790.5
      ],
      [
        -193.0,
        -2486.650390625,
        790.5
      ],
      [
        -194.5,
        -2486.5048828125,
        794.0
      ],
      [
        -193.0,
        -2486.5625,
        794.0
      ],
      [
        -194.5,
        -2486.5048828125,
        794.0
      ],
      [
        -194.5,
        -2486.46728515625,
        795.5
      ],
      [
        -163.800048828125,
        -2487.864990234375,
        786.5
      ],
      [
        -163.300048828125,
        -2487.884033203125,
        786.5
      ],
      [
        -163.300048828125,
        -2487.871337890625,
        787.0
      ],
      [
        -163.300048828125,
        -2487.884033203125,
        786.5
      ],
      [
        -163.800048828125,
        -2487.852294921875,
        787.0
      ],
      [
        -163.300048828125,
        -2487.871337890625,
        787.0
      ],
      [
        -163.800048828125,
        -2487.864990234375,
        786.5
      ],
      [
        -163.800048828125,
        -2487.852294921875,
        787.0
      ],
      [
        -163.552490234375,
        -2487.974853515625,
        782.5
      ],
      [
        -163.552490234375,
        -2487.87451171875,
        786.5
      ],
      [
        -163.552490234375,
        -2487.87451171875,
        786.5
      ],
      [
        -163.552490234375,
        -2487.974853515625,
        782.5
      ],
      [
        -142.0,
        -2485.0,
        796.0226440429688
      ],
      [
        -142.0,
        -2487.0,
        796.2333374023438
      ],
      [
        -142.0,
        -2487.0,
        796.2333374023438
      ],
      [
        -140.0,
        -2487.0,
        795.94287109375
      ],
      [
        -142.0,
        -2485.0,
        796.0226440429688
      ],
      [
        -140.0,
        -2485.0,
        795.732177734375
      ],
      [
        -140.0,
        -2487.0,
        795.94287109375
      ],
      [
        -140.0,
        -2485.0,
        795.732177734375
      ],
      [
        -182.0,
        -2487.007080078125,
        793.0
      ],
      [
        -182.0,
        -2487.044677734375,
        791.5
      ],
      [
        -189.5,
        -2486.670654296875,
        795.0
      ],
      [
        -182.0,
        -2487.007080078125,
        793.0
      ],
      [
        -189.5,
        -2486.758544921875,
        791.5
      ],
      [
        -182.0,
        -2487.044677734375,
        791.5
      ],
      [
        -165.12408447265625,
        -2487.8759765625,
        784.0601806640625
      ],
      [
        -164.5,
        -2487.93896484375,
        782.5
      ],
      [
        -169.5,
        -2487.748046875,
        782.5
      ],
      [
        -168.72901916503906,
        -2487.72900390625,
        784.427490234375
      ],
      [
        -168.72901916503906,
        -2487.72900390625,
        784.427490234375
      ],
      [
        -165.12408447265625,
        -2487.8759765625,
        784.0601806640625
      ],
      [
        -168.0,
        -2485.0,
        797.0
      ],
      [
        -168.0,
        -2487.0,
        797.0
      ],
      [
        -168.0,
        -2485.0,
        797.0
      ],
      [
        -166.0,
        -2485.0,
        797.0
      ],
      [
        -168.0,
        -2487.0,
        797.0
      ],
      [
        -166.0,
        -2487.0,
        797.0
      ],
      [
        -166.0,
        -2487.0,
        797.0
      ],
      [
        -166.0,
        -2485.0,
        797.0
      ],
      [
        -204.0,
        -2486.0673828125,
        797.0
      ],
      [
        -198.5,
        -2482.8330078125,
        804.0
      ],
      [
        -198.5,
        -2486.101318359375,
        804.0
      ],
      [
        -191.5,
        -2486.384521484375,
        803.3575439453125
      ],
      [
        -191.5,
        -2486.54443359375,
        797.0
      ],
      [
        -198.5,
        -2486.101318359375,
        804.0
      ],
      [
        -198.5,
        -2482.8330078125,
        804.0
      ],
      [
        -196.06138610839844,
        -2486.1943359375,
        804.0
      ],
      [
        -190.5,
        -2486.469482421875,
        801.5
      ],
      [
        -190.0,
        -2486.6015625,
        797.0
      ],
      [
        -191.5,
        -2486.43115234375,
        801.5
      ],
      [
        -190.5,
        -2486.469482421875,
        801.5
      ],
      [
        -168.0,
        -2485.0,
        799.7987060546875
      ],
      [
        -168.0,
        -2487.0,
        800.0094604492188
      ],
      [
        -168.0,
        -2487.0,
        800.0094604492188
      ],
      [
        -166.0,
        -2487.0,
        799.718994140625
      ],
      [
        -168.0,
        -2485.0,
        799.7987060546875
      ],
      [
        -166.0,
        -2485.0,
        799.5082397460938
      ],
      [
        -166.0,
        -2487.0,
        799.718994140625
      ],
      [
        -166.0,
        -2485.0,
        799.5082397460938
      ],
      [
        546.2076416015625,
        -2518.778076171875,
        699.6304321289062
      ],
      [
        231.3074188232422,
        -2504.015869140625,
        743.809326171875
      ],
      [
        78.89598083496094,
        -2871.634765625,
        804.6791381835938
      ],
      [
        79.65071105957031,
        -2858.506103515625,
        803.1862182617188
      ],
      [
        -10.657630920410156,
        -2807.21484375,
        810.8976440429688
      ],
      [
        -30.098533630371094,
        -2775.635009765625,
        810.3937377929688
      ],
      [
        -128.99732971191406,
        -2631.072265625,
        809.5252075195312
      ],
      [
        -30.098535537719727,
        -2775.635009765625,
        810.3937377929688
      ],
      [
        -128.99732971191406,
        -2631.072265625,
        809.5252075195312
      ],
      [
        -198.81744384765625,
        -2654.5947265625,
        822.1439819335938
      ],
      [
        -172.77281188964844,
        -2723.082275390625,
        825.57763671875
      ],
      [
        -172.77281188964844,
        -2723.082275390625,
        825.57763671875
      ],
      [
        -198.81744384765625,
        -2654.5947265625,
        822.1439819335938
      ],
      [
        -10.657630920410156,
        -2807.21484375,
        810.897705078125
      ],
      [
        8.90438461303711,
        -2801.59326171875,
        448.90496826171875
      ],
      [
        11.735824584960938,
        -2815.966064453125,
        673.62255859375
      ],
      [
        -9.408008575439453,
        -2808.1181640625,
        810.8114013671875
      ],
      [
        9.69339370727539,
        -2819.087158203125,
        809.1929931640625
      ],
      [
        -9.408012390136719,
        -2808.1181640625,
        810.8114013671875
      ],
      [
        11.735822677612305,
        -2815.966064453125,
        673.62255859375
      ],
      [
        72.44955444335938,
        -2855.12451171875,
        803.875732421875
      ],
      [
        79.65071868896484,
        -2858.506103515625,
        803.1861572265625
      ],
      [
        78.89598083496094,
        -2871.634765625,
        804.6791381835938
      ],
      [
        72.44955444335938,
        -2855.12451171875,
        803.875732421875
      ],
      [
        546.2076416015625,
        -2518.778076171875,
        699.6304321289062
      ],
      [
        578.4073486328125,
        -2533.9248046875,
        696.5499267578125
      ],
      [
        761.7142944335938,
        -2612.369140625,
        678.1928100585938
      ],
      [
        578.4073486328125,
        -2533.9248046875,
        696.5499267578125
      ],
      [
        761.7142944335938,
        -2612.369140625,
        678.1928100585938
      ],
      [
        775.3273315429688,
        -2626.5556640625,
        677.7105102539062
      ],
      [
        757.5983276367188,
        -2631.5810546875,
        150.0
      ],
      [
        803.9168701171875,
        -2656.349853515625,
        676.6976318359375
      ],
      [
        832.5137329101562,
        -2709.53515625,
        150.0
      ],
      [
        -264.0294494628906,
        -2489.029296875,
        587.814208984375
      ],
      [
        -239.92828369140625,
        -2488.98486328125,
        626.2130737304688
      ],
      [
        -214.20103454589844,
        -2491.1044921875,
        580.9108276367188
      ],
      [
        -226.5,
        -2485.3447265625,
        797.0
      ],
      [
        -226.5,
        -2485.164794921875,
        798.7378540039062
      ],
      [
        -226.5,
        -2486.433837890625,
        780.0
      ],
      [
        -226.5,
        -2485.98388671875,
        790.8328857421875
      ],
      [
        -226.5,
        -2485.50048828125,
        795.5
      ],
      [
        -229.0,
        -2486.063232421875,
        778.5
      ],
      [
        -229.0,
        -2485.422607421875,
        784.6851196289062
      ],
      [
        -229.0,
        -2486.063232421875,
        778.5
      ],
      [
        -227.49098205566406,
        -2486.786376953125,
        778.5
      ],
      [
        -226.5,
        -2486.496337890625,
        778.5
      ],
      [
        -226.5,
        -2485.67333984375,
        778.5
      ],
      [
        -226.8091278076172,
        -2485.19677734375,
        797.0
      ],
      [
        -226.5,
        -2485.20849609375,
        797.0
      ],
      [
        -226.5,
        -2485.344970703125,
        797.0
      ],
      [
        -226.5,
        -2486.433837890625,
        780.0
      ],
      [
        -224.08543395996094,
        -2485.727294921875,
        780.0
      ],
      [
        -224.01219177246094,
        -2485.768310546875,
        778.5
      ],
      [
        -226.5,
        -2485.3447265625,
        797.0
      ],
      [
        -226.00363159179688,
        -2485.582763671875,
        797.0
      ],
      [
        -224.9295196533203,
        -2485.268310546875,
        797.0
      ],
      [
        -224.93019104003906,
        -2485.2685546875,
        797.0
      ],
      [
        -226.0038299560547,
        -2485.582763671875,
        797.0
      ],
      [
        -225.56472778320312,
        -2485.068115234375,
        804.0
      ],
      [
        -225.2774200439453,
        -2485.0791015625,
        804.0
      ],
      [
        -225.44155883789062,
        -2485.127197265625,
        804.0
      ],
      [
        -226.5,
        -2485.50048828125,
        795.5
      ],
      [
        -226.12477111816406,
        -2485.68017578125,
        795.5
      ],
      [
        -224.8556671142578,
        -2485.308837890625,
        795.5
      ],
      [
        -229.0,
        -2487.22802734375,
        778.5
      ],
      [
        -229.0,
        -2486.459716796875,
        797.0
      ],
      [
        -226.5,
        -2485.72802734375,
        797.0
      ],
      [
        -229.0,
        -2486.459716796875,
        797.0
      ],
      [
        -226.5,
        -2485.7900390625,
        795.5
      ],
      [
        -229.0,
        -2487.22802734375,
        778.5
      ],
      [
        -226.5,
        -2485.7900390625,
        795.5
      ],
      [
        -226.5,
        -2485.72802734375,
        797.0
      ],
      [
        -226.5,
        -2485.43701171875,
        804.0
      ],
      [
        -226.5,
        -2485.43701171875,
        804.0
      ],
      [
        -229.0,
        -2490.494873046875,
        778.5
      ],
      [
        -229.0,
        -2489.930419921875,
        797.0
      ],
      [
        -229.0,
        -2490.494873046875,
        778.5
      ],
      [
        -212.33059692382812,
        -2486.214111328125,
        778.5
      ],
      [
        -226.5,
        -2489.288330078125,
        797.0
      ],
      [
        -214.0,
        -2486.078125,
        797.0
      ],
      [
        -229.0,
        -2489.930419921875,
        797.0
      ],
      [
        -212.6690216064453,
        -2485.736572265625,
        797.0
      ],
      [
        -226.5,
        -2489.806884765625,
        780.0
      ],
      [
        -226.5,
        -2489.333984375,
        795.5
      ],
      [
        -226.5,
        -2489.333984375,
        795.5
      ],
      [
        -212.641357421875,
        -2485.775146484375,
        795.5
      ],
      [
        -226.5,
        -2489.806884765625,
        780.0
      ],
      [
        -212.3572235107422,
        -2486.175048828125,
        780.0
      ],
      [
        -219.5,
        -2487.277099609375,
        804.0
      ],
      [
        -214.0,
        -2486.078125,
        797.0
      ],
      [
        -226.5,
        -2489.288330078125,
        797.0
      ],
      [
        -226.5,
        -2489.074951171875,
        804.0
      ],
      [
        -226.5,
        -2489.074951171875,
        804.0
      ],
      [
        -219.5,
        -2487.277099609375,
        804.0
      ],
      [
        -219.75509643554688,
        -2488.189697265625,
        776.2364501953125
      ],
      [
        -212.28367614746094,
        -2486.280029296875,
        775.9332885742188
      ],
      [
        -219.75509643554688,
        -2488.189697265625,
        776.2364501953125
      ],
      [
        -219.76681518554688,
        -2488.12353515625,
        778.5
      ],
      [
        -220.5,
        -2488.634765625,
        767.9205932617188
      ],
      [
        -220.5,
        -2488.7705078125,
        763.46435546875
      ],
      [
        -217.5,
        -2488.01611328125,
        762.9490966796875
      ],
      [
        -217.5,
        -2487.880126953125,
        767.4052124023438
      ],
      [
        -220.5,
        -2488.7705078125,
        763.46435546875
      ],
      [
        -217.5,
        -2488.01611328125,
        762.9490966796875
      ],
      [
        -217.5,
        -2487.880126953125,
        767.4052124023438
      ],
      [
        -220.5,
        -2488.634765625,
        767.9205932617188
      ],
      [
        -189.5,
        -2497.363525390625,
        782.5
      ],
      [
        -189.5,
        -2497.363525390625,
        782.5
      ],
      [
        -189.5,
        -2498.5,
        782.5
      ],
      [
        -219.0,
        -2508.5,
        780.0
      ],
      [
        -199.0,
        -2508.5,
        780.0
      ],
      [
        -220.75,
        -2506.75,
        782.5
      ],
      [
        -219.0,
        -2508.5,
        780.0
      ],
      [
        -220.75,
        -2506.75,
        780.0
      ],
      [
        -199.0,
        -2508.5,
        780.0
      ],
      [
        -197.33750915527344,
        -2506.75,
        782.5
      ],
      [
        -197.33750915527344,
        -2506.75,
        780.0
      ],
      [
        -193.0,
        -2499.0,
        782.5
      ],
      [
        -191.63455200195312,
        -2500.746826171875,
        780.0
      ],
      [
        -189.5,
        -2498.5,
        782.5
      ],
      [
        -189.5,
        -2498.5,
        780.0
      ],
      [
        -191.63455200195312,
        -2500.746826171875,
        780.0
      ],
      [
        -193.0,
        -2497.636474609375,
        782.5
      ],
      [
        -193.0,
        -2497.636474609375,
        782.5
      ],
      [
        -193.0,
        -2499.0,
        782.5
      ],
      [
        -229.0,
        -2490.44921875,
        780.0
      ],
      [
        -229.0,
        -2490.372802734375,
        782.5
      ],
      [
        -229.0,
        -2498.5,
        782.5
      ],
      [
        -229.0,
        -2498.5,
        780.0
      ],
      [
        -226.810791015625,
        -2500.689208984375,
        780.0
      ],
      [
        -229.0,
        -2498.5,
        780.0
      ],
      [
        -229.0,
        -2498.5,
        782.5
      ],
      [
        -226.810791015625,
        -2500.689208984375,
        780.0
      ],
      [
        -226.5,
        -2498.0,
        782.5
      ],
      [
        -226.5,
        -2489.730712890625,
        782.5
      ],
      [
        -226.5,
        -2498.0,
        782.5
      ],
      [
        -225.618408203125,
        -2499.577880859375,
        782.5
      ],
      [
        -225.24974060058594,
        -2499.1826171875,
        780.0
      ],
      [
        -225.24974060058594,
        -2499.1826171875,
        782.5
      ],
      [
        -222.693115234375,
        -2502.305908203125,
        782.5
      ],
      [
        -222.34385681152344,
        -2501.931396484375,
        782.5
      ],
      [
        -222.34385681152344,
        -2501.931396484375,
        780.0
      ],
      [
        -223.53271484375,
        -2498.514404296875,
        782.5
      ],
      [
        -224.936279296875,
        -2498.846435546875,
        782.5
      ],
      [
        -223.53271484375,
        -2498.514404296875,
        782.5
      ],
      [
        -221.777587890625,
        -2500.151123046875,
        782.5
      ],
      [
        -222.010986328125,
        -2501.574462890625,
        782.5
      ],
      [
        -221.777587890625,
        -2500.151123046875,
        782.5
      ],
      [
        -222.010986328125,
        -2501.574462890625,
        782.5
      ],
      [
        -224.936279296875,
        -2498.846435546875,
        782.5
      ],
      [
        -225.6000518798828,
        -2496.5,
        782.5
      ],
      [
        -225.6000518798828,
        -2493.10009765625,
        782.5
      ],
      [
        -226.5,
        -2493.10009765625,
        782.5
      ],
      [
        -225.6000518798828,
        -2493.10009765625,
        782.5
      ],
      [
        -226.5,
        -2496.5,
        782.5
      ],
      [
        -225.6000518798828,
        -2496.5,
        782.5
      ],
      [
        -200.5,
        -2493.0,
        770.902099609375
      ],
      [
        -200.5,
        -2493.0,
        766.3530883789062
      ],
      [
        -197.5,
        -2493.0,
        770.9020385742188
      ],
      [
        -200.5,
        -2493.0,
        770.902099609375
      ],
      [
        -217.5,
        -2493.0,
        766.3530883789062
      ],
      [
        -217.5,
        -2493.0,
        770.9020385742188
      ],
      [
        -220.5,
        -2493.0,
        770.9020385742188
      ],
      [
        -220.5,
        -2493.0,
        766.3530883789062
      ],
      [
        -217.5,
        -2493.0,
        770.9020385742188
      ],
      [
        -220.5,
        -2493.0,
        770.9020385742188
      ],
      [
        -197.5,
        -2502.5,
        776.0
      ],
      [
        -197.5,
        -2502.5,
        778.5
      ],
      [
        -197.5,
        -2498.5,
        776.0
      ],
      [
        -197.5,
        -2502.5,
        776.0
      ],
      [
        -197.5,
        -2498.5,
        778.5
      ],
      [
        -197.5,
        -2498.5,
        776.0
      ],
      [
        -164.0,
        -2522.76025390625,
        786.5
      ],
      [
        -164.0,
        -2522.76025390625,
        787.0
      ],
      [
        -164.0,
        -2523.26025390625,
        787.0
      ],
      [
        -164.0,
        -2523.26025390625,
        786.5
      ],
      [
        -163.10009765625,
        -2523.26025390625,
        787.0
      ],
      [
        -163.10009765625,
        -2522.76025390625,
        787.0
      ],
      [
        -163.10009765625,
        -2522.76025390625,
        786.5
      ],
      [
        -163.10009765625,
        -2523.26025390625,
        786.5
      ],
      [
        -188.5,
        -2522.76025390625,
        786.5
      ],
      [
        -188.5,
        -2522.76025390625,
        787.0
      ],
      [
        -188.5,
        -2523.26025390625,
        787.0
      ],
      [
        -188.5,
        -2523.26025390625,
        786.5
      ],
      [
        -187.60009765625,
        -2523.26025390625,
        787.0
      ],
      [
        -187.60009765625,
        -2522.76025390625,
        787.0
      ],
      [
        -187.60009765625,
        -2522.76025390625,
        786.5
      ],
      [
        -187.60009765625,
        -2523.26025390625,
        786.5
      ],
      [
        -164.0,
        -2523.26025390625,
        782.5
      ],
      [
        -164.0,
        -2522.9892578125,
        782.5
      ],
      [
        -164.0,
        -2522.9892578125,
        786.5
      ],
      [
        -163.10009765625,
        -2522.98876953125,
        782.5
      ],
      [
        -163.10009765625,
        -2523.26025390625,
        782.5
      ],
      [
        -163.10009765625,
        -2522.98876953125,
        786.5
      ],
      [
        -187.60009765625,
        -2523.0,
        782.5
      ],
      [
        -187.60009765625,
        -2523.26025390625,
        782.5
      ],
      [
        -187.60009765625,
        -2523.0,
        786.5
      ],
      [
        -188.5,
        -2523.26025390625,
        782.5
      ],
      [
        -188.5,
        -2523.000244140625,
        782.5
      ],
      [
        -188.5,
        -2523.000244140625,
        786.5
      ],
      [
        -187.60009765625,
        -2522.76025390625,
        782.5
      ],
      [
        -188.5,
        -2522.76025390625,
        782.5
      ],
      [
        -164.0,
        -2522.76025390625,
        782.5
      ],
      [
        -163.10009765625,
        -2522.76025390625,
        782.5
      ],
      [
        -164.0,
        -2523.5,
        787.0
      ],
      [
        -164.0,
        -2523.5,
        787.0
      ],
      [
        -163.10009765625,
        -2523.5,
        787.0
      ],
      [
        -163.10009765625,
        -2523.5,
        787.0
      ],
      [
        -188.5,
        -2523.5,
        787.0
      ],
      [
        -187.60009765625,
        -2523.5,
        787.0
      ],
      [
        -188.5,
        -2523.5,
        787.0
      ],
      [
        -187.60009765625,
        -2523.5,
        787.0
      ],
      [
        -164.0,
        -2522.76025390625,
        789.2999877929688
      ],
      [
        -163.10009765625,
        -2522.76025390625,
        789.2999877929688
      ],
      [
        -164.0,
        -2522.76025390625,
        789.2999877929688
      ],
      [
        -163.10009765625,
        -2522.76025390625,
        789.2999877929688
      ],
      [
        -188.5,
        -2522.76025390625,
        789.2999877929688
      ],
      [
        -187.60009765625,
        -2522.76025390625,
        789.2999877929688
      ],
      [
        -188.5,
        -2522.76025390625,
        789.2999877929688
      ],
      [
        -187.60009765625,
        -2522.76025390625,
        789.2999877929688
      ],
      [
        -188.300048828125,
        -2498.5,
        786.5
      ],
      [
        -188.300048828125,
        -2498.5,
        787.0
      ],
      [
        -187.800048828125,
        -2498.5,
        787.0
      ],
      [
        -187.800048828125,
        -2498.5,
        786.5
      ],
      [
        -188.300048828125,
        -2497.5,
        787.0
      ],
      [
        -188.300048828125,
        -2497.5,
        786.5
      ],
      [
        -187.800048828125,
        -2497.5,
        786.5
      ],
      [
        -187.800048828125,
        -2497.5,
        787.0
      ],
      [
        -188.300048828125,
        -2522.5,
        787.0
      ],
      [
        -188.300048828125,
        -2522.5,
        786.5
      ],
      [
        -187.800048828125,
        -2522.5,
        786.5
      ],
      [
        -187.800048828125,
        -2522.5,
        787.0
      ],
      [
        -187.800048828125,
        -2498.5,
        782.5
      ],
      [
        -188.042724609375,
        -2498.5,
        782.5
      ],
      [
        -188.042724609375,
        -2498.5,
        786.5
      ],
      [
        -188.042724609375,
        -2497.5,
        782.5
      ],
      [
        -187.800048828125,
        -2497.5,
        782.5
      ],
      [
        -188.042724609375,
        -2497.5,
        786.5
      ],
      [
        -188.042724609375,
        -2522.5,
        782.5
      ],
      [
        -187.800048828125,
        -2522.5,
        782.5
      ],
      [
        -188.042724609375,
        -2522.5,
        786.5
      ],
      [
        -188.300048828125,
        -2498.5,
        782.5
      ],
      [
        -188.300048828125,
        -2497.5,
        782.5
      ],
      [
        -188.300048828125,
        -2522.5,
        782.5
      ],
      [
        -188.300048828125,
        -2497.280029296875,
        791.5
      ],
      [
        -187.800048828125,
        -2496.97998046875,
        791.5
      ],
      [
        -187.800048828125,
        -2486.823486328125,
        791.5
      ],
      [
        -188.300048828125,
        -2486.804443359375,
        791.5
      ],
      [
        -187.800048828125,
        -2496.97998046875,
        794.546630859375
      ],
      [
        -188.300048828125,
        -2497.280029296875,
        794.6799926757812
      ],
      [
        -188.300048828125,
        -2486.724365234375,
        794.6799926757812
      ],
      [
        -187.800048828125,
        -2486.746826171875,
        794.546630859375
      ],
      [
        -187.800048828125,
        -2496.97998046875,
        791.5
      ],
      [
        -188.300048828125,
        -2497.280029296875,
        791.5
      ],
      [
        -188.300048828125,
        -2497.280029296875,
        794.6799926757812
      ],
      [
        -187.800048828125,
        -2496.97998046875,
        794.546630859375
      ],
      [
        -188.300048828125,
        -2498.5,
        789.2999877929688
      ],
      [
        -187.800048828125,
        -2498.5,
        789.2999877929688
      ],
      [
        -187.800048828125,
        -2497.5,
        789.2999877929688
      ],
      [
        -188.300048828125,
        -2497.5,
        789.2999877929688
      ],
      [
        -187.800048828125,
        -2498.5,
        789.2999877929688
      ],
      [
        -188.300048828125,
        -2498.5,
        789.2999877929688
      ],
      [
        -188.300048828125,
        -2497.5,
        789.2999877929688
      ],
      [
        -187.800048828125,
        -2497.5,
        789.2999877929688
      ],
      [
        -187.800048828125,
        -2522.5,
        789.2999877929688
      ],
      [
        -188.300048828125,
        -2522.5,
        789.2999877929688
      ],
      [
        -188.300048828125,
        -2522.5,
        789.2999877929688
      ],
      [
        -187.800048828125,
        -2522.5,
        789.2999877929688
      ],
      [
        -187.800048828125,
        -2522.76025390625,
        789.2999877929688
      ],
      [
        -188.300048828125,
        -2522.76025390625,
        789.2999877929688
      ],
      [
        -163.800048828125,
        -2522.5,
        786.5
      ],
      [
        -163.300048828125,
        -2522.5,
        786.5
      ],
      [
        -163.300048828125,
        -2522.5,
        787.0
      ],
      [
        -163.800048828125,
        -2522.5,
        787.0
      ],
      [
        -163.10009765625,
        -2522.5,
        786.5
      ],
      [
        -163.10009765625,
        -2522.5,
        787.0
      ],
      [
        -164.0,
        -2522.5,
        787.0
      ],
      [
        -164.0,
        -2522.5,
        786.5
      ],
      [
        -163.552490234375,
        -2522.5,
        782.5
      ],
      [
        -163.552490234375,
        -2522.5,
        786.5
      ],
      [
        -142.0,
        -2518.0,
        797.0
      ],
      [
        -142.0,
        -2520.0,
        797.0
      ],
      [
        -142.0,
        -2518.0,
        797.0
      ],
      [
        -140.0,
        -2518.0,
        797.0
      ],
      [
        -142.0,
        -2520.0,
        797.0
      ],
      [
        -140.0,
        -2520.0,
        797.0
      ],
      [
        -140.0,
        -2520.0,
        797.0
      ],
      [
        -140.0,
        -2518.0,
        797.0
      ],
      [
        -168.0,
        -2518.0,
        797.0
      ],
      [
        -168.0,
        -2520.0,
        797.0
      ],
      [
        -168.0,
        -2518.0,
        797.0
      ],
      [
        -166.0,
        -2518.0,
        797.0
      ],
      [
        -168.0,
        -2520.0,
        797.0
      ],
      [
        -166.0,
        -2520.0,
        797.0
      ],
      [
        -166.0,
        -2520.0,
        797.0
      ],
      [
        -166.0,
        -2518.0,
        797.0
      ],
      [
        -189.5,
        -2498.105224609375,
        795.5
      ],
      [
        -189.5,
        -2497.46142578125,
        795.5
      ],
      [
        -189.5,
        -2498.5,
        795.5
      ],
      [
        -189.5,
        -2498.105224609375,
        795.5
      ],
      [
        -189.5,
        -2497.46142578125,
        795.5
      ],
      [
        -189.5,
        -2486.658203125,
        795.5
      ],
      [
        -226.5,
        -2501.0,
        795.5
      ],
      [
        -227.9053955078125,
        -2499.5947265625,
        795.5
      ],
      [
        -229.0,
        -2498.5,
        795.5
      ],
      [
        -227.9053955078125,
        -2499.5947265625,
        795.5
      ],
      [
        -190.56727600097656,
        -2499.62353515625,
        795.5
      ],
      [
        -191.875,
        -2501.0,
        795.5
      ],
      [
        -189.5,
        -2498.5,
        795.5
      ],
      [
        -190.56727600097656,
        -2499.62353515625,
        795.5
      ],
      [
        -199.0,
        -2508.5,
        789.2177124023438
      ],
      [
        -210.2396697998047,
        -2508.5,
        789.0
      ],
      [
        -191.0762481689453,
        -2500.1591796875,
        794.78466796875
      ],
      [
        -199.0,
        -2508.5,
        789.2177124023438
      ],
      [
        -191.0762481689453,
        -2500.1591796875,
        794.78466796875
      ],
      [
        -190.0582733154297,
        -2499.087646484375,
        795.5
      ],
      [
        -219.26951599121094,
        -2508.23046875,
        789.0
      ],
      [
        -226.4711456298828,
        -2501.029052734375,
        793.5345458984375
      ],
      [
        -229.0,
        -2498.5,
        795.126953125
      ],
      [
        -226.4711456298828,
        -2501.029052734375,
        793.5345458984375
      ],
      [
        -218.74610900878906,
        -2508.24609375,
        789.0
      ],
      [
        -219.26951599121094,
        -2508.23046875,
        789.0
      ],
      [
        -210.2396697998047,
        -2508.5,
        789.0
      ],
      [
        -218.74610900878906,
        -2508.24609375,
        789.0
      ],
      [
        -188.5,
        -2522.5,
        782.5999145507812
      ],
      [
        -188.300048828125,
        -2522.5,
        782.5999145507812
      ],
      [
        -188.5,
        -2522.666748046875,
        782.5
      ],
      [
        -188.5,
        -2522.5,
        782.5999145507812
      ],
      [
        -198.67579650878906,
        -2508.15869140625,
        789.0
      ],
      [
        -199.2437286376953,
        -2508.15869140625,
        789.0
      ],
      [
        -218.65879821777344,
        -2508.15869140625,
        789.0
      ],
      [
        -219.3412322998047,
        -2508.15869140625,
        789.0
      ],
      [
        -199.2437286376953,
        -2508.15869140625,
        789.0
      ],
      [
        -218.65879821777344,
        -2508.15869140625,
        789.0
      ],
      [
        -191.23948669433594,
        -2500.3310546875,
        794.5552368164062
      ],
      [
        -198.67579650878906,
        -2508.15869140625,
        789.0
      ],
      [
        -191.23948669433594,
        -2500.3310546875,
        794.5552368164062
      ],
      [
        -189.97491455078125,
        -2499.0,
        795.5
      ],
      [
        -219.3412322998047,
        -2508.15869140625,
        789.0
      ],
      [
        -219.9058380126953,
        -2507.59423828125,
        789.400634765625
      ],
      [
        -226.5,
        -2501.000244140625,
        793.552734375
      ],
      [
        -226.5,
        -2501.0,
        782.5
      ],
      [
        -197.33753967285156,
        -2506.75,
        789.0
      ],
      [
        -220.7499542236328,
        -2506.75,
        789.0
      ],
      [
        -220.7499542236328,
        -2506.75,
        789.0
      ],
      [
        -220.75009155273438,
        -2506.75,
        789.9322509765625
      ],
      [
        -193.0,
        -2494.0,
        795.5
      ],
      [
        -194.5,
        -2494.0,
        794.5
      ],
      [
        -194.5,
        -2494.0,
        795.5
      ],
      [
        -194.5,
        -2495.5,
        795.5
      ],
      [
        -194.5,
        -2495.5,
        794.5
      ],
      [
        -224.60009765625,
        -2495.5,
        795.4999389648438
      ],
      [
        -224.60009765625,
        -2494.0,
        795.4999389648438
      ],
      [
        -225.00006103515625,
        -2494.0,
        794.5
      ],
      [
        -225.00006103515625,
        -2495.5,
        794.5
      ],
      [
        -225.800048828125,
        -2494.0,
        792.4999389648438
      ],
      [
        -225.800048828125,
        -2495.5,
        792.4999389648438
      ],
      [
        -225.800048828125,
        -2495.5,
        792.4999389648438
      ],
      [
        -225.800048828125,
        -2494.0,
        792.4999389648438
      ],
      [
        -226.5,
        -2494.0,
        792.4999389648438
      ],
      [
        -226.5,
        -2495.5,
        792.4999389648438
      ],
      [
        -194.5,
        -2494.0,
        794.0
      ],
      [
        -194.5,
        -2495.5,
        794.0
      ],
      [
        -193.0,
        -2495.5,
        794.0
      ],
      [
        -193.0,
        -2494.0,
        794.0
      ],
      [
        -194.5,
        -2495.5,
        794.0
      ],
      [
        -194.5,
        -2494.0,
        794.0
      ],
      [
        -226.5,
        -2495.5,
        783.0
      ],
      [
        -226.5,
        -2494.0,
        783.0
      ],
      [
        -225.800048828125,
        -2494.0,
        783.0
      ],
      [
        -225.800048828125,
        -2495.5,
        783.0
      ],
      [
        -225.800048828125,
        -2495.5,
        783.0
      ],
      [
        -225.800048828125,
        -2494.0,
        783.0
      ],
      [
        -225.6000518798828,
        -2494.0,
        782.5
      ],
      [
        -225.6000518798828,
        -2495.5,
        782.5
      ],
      [
        -222.34388732910156,
        -2501.931396484375,
        792.0631103515625
      ],
      [
        -222.34388732910156,
        -2501.931396484375,
        782.5
      ],
      [
        -225.2498321533203,
        -2499.1826171875,
        782.5
      ],
      [
        -225.2498321533203,
        -2499.1826171875,
        792.0631103515625
      ],
      [
        -191.5,
        -2492.481689453125,
        804.0
      ],
      [
        -191.5,
        -2492.481689453125,
        804.0
      ],
      [
        -168.0,
        -2520.0,
        803.4865112304688
      ],
      [
        -166.0,
        -2520.0,
        803.196044921875
      ],
      [
        -142.0,
        -2520.0,
        799.71044921875
      ],
      [
        -140.0,
        -2520.0,
        799.4199829101562
      ],
      [
        -168.0,
        -2518.0,
        803.2757568359375
      ],
      [
        -168.0,
        -2520.0,
        803.4865112304688
      ],
      [
        -168.0,
        -2518.0,
        803.2758178710938
      ],
      [
        -166.0,
        -2518.0,
        802.9852905273438
      ],
      [
        -142.0,
        -2518.0,
        799.4996948242188
      ],
      [
        -140.0,
        -2518.0,
        799.209228515625
      ],
      [
        -166.0,
        -2520.0,
        803.196044921875
      ],
      [
        -166.0,
        -2518.0,
        802.9852905273438
      ],
      [
        -142.0,
        -2518.0,
        799.4996948242188
      ],
      [
        -142.0,
        -2520.0,
        799.71044921875
      ],
      [
        -140.0,
        -2520.0,
        799.4199829101562
      ],
      [
        -140.0,
        -2518.0,
        799.209228515625
      ],
      [
        976.0157470703125,
        -2838.53125,
        670.8987426757812
      ],
      [
        1078.9036865234375,
        -2832.7783203125,
        655.3497314453125
      ],
      [
        976.0157470703125,
        -2838.53125,
        670.8988037109375
      ],
      [
        817.7457275390625,
        -2670.761474609375,
        676.2077026367188
      ],
      [
        1078.9036865234375,
        -2832.7783203125,
        655.3497314453125
      ],
      [
        1285.0223388671875,
        -2819.570556640625,
        624.0225830078125
      ],
      [
        1285.0223388671875,
        -2819.570556640625,
        624.0225830078125
      ],
      [
        1403.9776611328125,
        -2782.974853515625,
        602.8902587890625
      ],
      [
        1598.1002197265625,
        -2709.817626953125,
        566.9887084960938
      ],
      [
        1403.9776611328125,
        -2782.974853515625,
        602.8902587890625
      ],
      [
        1602.5487060546875,
        -2735.09130859375,
        150.0
      ],
      [
        1598.1002197265625,
        -2709.817626953125,
        566.9888305664062
      ],
      [
        1614.3267822265625,
        -2718.2626953125,
        565.52197265625
      ],
      [
        1683.745361328125,
        -2754.39111328125,
        559.2467041015625
      ],
      [
        1735.0538330078125,
        -2799.8408203125,
        214.44290161132812
      ],
      [
        1731.916015625,
        -2801.775146484375,
        150.0
      ],
      [
        1754.750244140625,
        -2788.801513671875,
        552.5599975585938
      ],
      [
        1754.7542724609375,
        -2790.00048828125,
        532.7901000976562
      ],
      [
        1735.0538330078125,
        -2799.8408203125,
        214.44290161132812
      ],
      [
        1683.745361328125,
        -2754.39111328125,
        559.2466430664062
      ],
      [
        1754.7542724609375,
        -2790.00048828125,
        532.7901000976562
      ],
      [
        1754.750244140625,
        -2788.801513671875,
        552.5599975585938
      ],
      [
        1755.0457763671875,
        -2789.4521484375,
        552.5856323242188
      ],
      [
        1754.7841796875,
        -2798.823974609375,
        387.3013610839844
      ],
      [
        1740.3115234375,
        -2804.498291015625,
        179.1099853515625
      ],
      [
        1740.3115234375,
        -2804.498291015625,
        179.1099853515625
      ],
      [
        1738.69189453125,
        -2805.267822265625,
        150.0
      ],
      [
        1754.7841796875,
        -2798.823974609375,
        387.30133056640625
      ],
      [
        1757.4910888671875,
        -2794.8359375,
        552.7977905273438
      ],
      [
        817.7457275390625,
        -2670.761474609375,
        676.2077026367188
      ],
      [
        1754.81591796875,
        -2808.18359375,
        232.9730224609375
      ],
      [
        1760.2698974609375,
        -2800.9541015625,
        553.038818359375
      ],
      [
        1754.81591796875,
        -2808.18359375,
        232.97305297851562
      ],
      [
        1748.9217529296875,
        -2810.384521484375,
        150.0
      ],
      [
        718.9588012695312,
        -4041.57568359375,
        834.9921264648438
      ],
      [
        720.1486206054688,
        -4018.671875,
        832.4060668945312
      ],
      [
        251.97702026367188,
        -3725.8681640625,
        869.5489501953125
      ],
      [
        170.42144775390625,
        -3640.320556640625,
        872.3798828125
      ],
      [
        263.30963134765625,
        -3738.836669921875,
        869.26953125
      ],
      [
        251.97702026367188,
        -3725.8681640625,
        869.5490112304688
      ],
      [
        263.3096008300781,
        -3738.836669921875,
        869.2695922851562
      ],
      [
        264.5401916503906,
        -3739.04638671875,
        869.1129760742188
      ],
      [
        170.42144775390625,
        -3640.320556640625,
        872.3798828125
      ],
      [
        170.725341796875,
        -3639.406005859375,
        872.2393798828125
      ],
      [
        265.7342529296875,
        -3739.249755859375,
        868.9609985351562
      ],
      [
        195.037841796875,
        -3516.980712890625,
        855.8088989257812
      ],
      [
        182.2213592529297,
        -3496.15380859375,
        855.475830078125
      ],
      [
        172.6287078857422,
        -3633.677978515625,
        871.359375
      ],
      [
        225.87149047851562,
        -3522.966064453125,
        150.0
      ],
      [
        343.6313171386719,
        -3734.2119140625,
        536.5526123046875
      ],
      [
        352.535400390625,
        -3724.961181640625,
        150.0
      ],
      [
        341.0475158691406,
        -3745.71630859375,
        794.1105346679688
      ],
      [
        343.6313171386719,
        -3734.2119140625,
        536.5526123046875
      ],
      [
        341.0475158691406,
        -3745.71630859375,
        794.1105346679688
      ],
      [
        340.672607421875,
        -3749.061767578125,
        859.1112060546875
      ],
      [
        284.8941955566406,
        -3742.513916015625,
        866.522216796875
      ],
      [
        284.8941955566406,
        -3742.513916015625,
        866.522216796875
      ],
      [
        275.6490173339844,
        -3740.93896484375,
        867.698974609375
      ],
      [
        175.43414306640625,
        -3625.235107421875,
        870.0623779296875
      ],
      [
        196.05996704101562,
        -3518.6416015625,
        855.83544921875
      ],
      [
        196.05996704101562,
        -3518.6416015625,
        855.83544921875
      ],
      [
        175.43414306640625,
        -3625.235107421875,
        870.0623779296875
      ],
      [
        -257.4031982421875,
        -2993.197509765625,
        866.329833984375
      ],
      [
        -256.20599365234375,
        -2994.445068359375,
        866.2874755859375
      ],
      [
        -257.4032287597656,
        -2993.197509765625,
        866.3298950195312
      ],
      [
        -55.11924743652344,
        -3144.019287109375,
        852.8427734375
      ],
      [
        -233.40467834472656,
        -3018.2060546875,
        865.4794921875
      ],
      [
        -25.087284088134766,
        -3165.262939453125,
        850.719482421875
      ],
      [
        -55.119232177734375,
        -3144.019287109375,
        852.8427734375
      ],
      [
        -233.40467834472656,
        -3018.2060546875,
        865.4794921875
      ],
      [
        720.1486206054688,
        -4018.671875,
        832.4060668945312
      ],
      [
        696.728759765625,
        -3986.5517578125,
        832.423095703125
      ],
      [
        365.09722900390625,
        -3733.654541015625,
        466.1090087890625
      ],
      [
        380.52783203125,
        -3726.552978515625,
        150.0
      ],
      [
        353.29998779296875,
        -3747.2802734375,
        794.8886108398438
      ],
      [
        365.09722900390625,
        -3733.654541015625,
        466.1089782714844
      ],
      [
        353.29998779296875,
        -3747.2802734375,
        794.8886108398438
      ],
      [
        351.340087890625,
        -3750.31396484375,
        857.69384765625
      ],
      [
        588.4303588867188,
        -3803.95458984375,
        150.0
      ],
      [
        590.853271484375,
        -3811.47265625,
        234.0389404296875
      ],
      [
        607.57421875,
        -3863.3564453125,
        814.0244750976562
      ],
      [
        696.728759765625,
        -3986.552001953125,
        832.423095703125
      ],
      [
        605.4859619140625,
        -3862.95751953125,
        832.6519775390625
      ],
      [
        479.6567687988281,
        -3765.376953125,
        840.6450805664062
      ],
      [
        479.6567687988281,
        -3765.376953125,
        840.64501953125
      ],
      [
        524.5755004882812,
        -3799.62890625,
        837.7302856445312
      ],
      [
        590.853515625,
        -3811.47265625,
        234.03753662109375
      ],
      [
        599.5436401367188,
        -3856.79443359375,
        832.8656005859375
      ],
      [
        599.5436401367188,
        -3856.79443359375,
        832.8656005859375
      ],
      [
        603.1636962890625,
        -3859.811767578125,
        832.6577758789062
      ],
      [
        603.1636962890625,
        -3859.811767578125,
        832.6577758789062
      ],
      [
        -24.54266357421875,
        -3165.648193359375,
        850.680908203125
      ],
      [
        161.78378295898438,
        -3462.9423828125,
        854.9447021484375
      ],
      [
        161.78378295898438,
        -3462.9423828125,
        854.9447021484375
      ],
      [
        -24.542665481567383,
        -3165.648193359375,
        850.6809692382812
      ],
      [
        27.792327880859375,
        -3036.71337890625,
        183.7232666015625
      ],
      [
        35.304771423339844,
        -3045.33349609375,
        150.0
      ],
      [
        27.79233169555664,
        -3036.71337890625,
        183.7232666015625
      ],
      [
        28.390148162841797,
        -3035.85009765625,
        150.0
      ],
      [
        84.12651062011719,
        -3112.313232421875,
        150.40260314941406
      ],
      [
        85.03846740722656,
        -3113.5439453125,
        150.0
      ],
      [
        84.12651062011719,
        -3112.313232421875,
        150.40260314941406
      ],
      [
        83.82987213134766,
        -3111.886474609375,
        150.0
      ],
      [
        185.0437469482422,
        -3171.353271484375,
        820.2420654296875
      ],
      [
        186.97056579589844,
        -3173.9990234375,
        814.9385986328125
      ],
      [
        167.1021270751953,
        -3141.785888671875,
        819.0518798828125
      ],
      [
        185.04376220703125,
        -3171.353271484375,
        820.2420654296875
      ],
      [
        167.1020965576172,
        -3141.785888671875,
        819.0518188476562
      ],
      [
        159.78958129882812,
        -3128.198486328125,
        802.8056640625
      ],
      [
        175.84060668945312,
        -3103.24462890625,
        276.59075927734375
      ],
      [
        155.44485473632812,
        -3109.72900390625,
        686.5156860351562
      ],
      [
        153.9232177734375,
        -3117.298095703125,
        789.7723999023438
      ],
      [
        152.61541748046875,
        -3112.431640625,
        761.877685546875
      ],
      [
        153.92320251464844,
        -3117.298095703125,
        789.7723388671875
      ],
      [
        152.939208984375,
        -3110.526123046875,
        736.879638671875
      ],
      [
        152.6153564453125,
        -3112.431640625,
        761.8776245117188
      ],
      [
        175.4763641357422,
        -3090.30517578125,
        150.0
      ],
      [
        176.64120483398438,
        -3097.86279296875,
        207.90785217285156
      ],
      [
        176.64122009277344,
        -3097.86279296875,
        207.90785217285156
      ],
      [
        175.84060668945312,
        -3103.24462890625,
        276.59075927734375
      ],
      [
        155.44485473632812,
        -3109.72900390625,
        686.5156860351562
      ],
      [
        152.96188354492188,
        -3110.392578125,
        735.1290283203125
      ],
      [
        152.96188354492188,
        -3110.392578125,
        735.1290283203125
      ],
      [
        314.77362060546875,
        -3335.406982421875,
        318.67132568359375
      ],
      [
        271.1811218261719,
        -3281.92626953125,
        504.090087890625
      ],
      [
        271.1811218261719,
        -3281.92626953125,
        504.090087890625
      ],
      [
        216.47909545898438,
        -3214.519287109375,
        733.7183227539062
      ],
      [
        216.47909545898438,
        -3214.519287109375,
        733.7183227539062
      ],
      [
        314.77362060546875,
        -3335.406982421875,
        318.67132568359375
      ],
      [
        370.908447265625,
        -3422.326904296875,
        265.0660400390625
      ],
      [
        80.17647552490234,
        -3103.483154296875,
        150.0
      ],
      [
        468.15325927734375,
        -3572.90185546875,
        172.20265197753906
      ],
      [
        475.2839660644531,
        -3582.4423828125,
        149.99998474121094
      ],
      [
        466.6621398925781,
        -3578.49462890625,
        149.99998474121094
      ],
      [
        397.5082702636719,
        -3464.87060546875,
        253.57794189453125
      ],
      [
        370.908447265625,
        -3422.326904296875,
        265.0660095214844
      ],
      [
        464.6321105957031,
        -3568.190673828125,
        183.16636657714844
      ],
      [
        397.5082702636719,
        -3464.87060546875,
        253.57794189453125
      ],
      [
        464.6321105957031,
        -3568.190673828125,
        183.16635131835938
      ],
      [
        749.7349853515625,
        -3646.34765625,
        474.95501708984375
      ],
      [
        748.069580078125,
        -3643.765380859375,
        530.0675048828125
      ],
      [
        563.7830200195312,
        -3542.828125,
        804.9779052734375
      ],
      [
        740.3842163085938,
        -3629.134033203125,
        788.4231567382812
      ],
      [
        748.069580078125,
        -3643.765380859375,
        530.0675048828125
      ],
      [
        594.16162109375,
        -3225.363037109375,
        489.78759765625
      ],
      [
        633.32763671875,
        -3226.150634765625,
        150.0
      ],
      [
        394.0809020996094,
        -3398.00244140625,
        814.3648071289062
      ],
      [
        185.49929809570312,
        -3171.784423828125,
        820.822265625
      ],
      [
        328.1347351074219,
        -3160.864501953125,
        798.9561157226562
      ],
      [
        209.39527893066406,
        -3131.2197265625,
        813.07763671875
      ],
      [
        152.939208984375,
        -3110.526123046875,
        736.879638671875
      ],
      [
        394.0809020996094,
        -3398.00244140625,
        814.36474609375
      ],
      [
        503.2005920410156,
        -3507.91259765625,
        810.09765625
      ],
      [
        209.395263671875,
        -3131.2197265625,
        813.07763671875
      ],
      [
        172.98614501953125,
        -3125.396484375,
        817.7518310546875
      ],
      [
        563.7830200195312,
        -3542.828125,
        804.9779052734375
      ],
      [
        511.6044616699219,
        -3516.24755859375,
        809.7553100585938
      ],
      [
        167.85598754882812,
        -3142.342041015625,
        820.2824096679688
      ],
      [
        172.98617553710938,
        -3125.396484375,
        817.7518920898438
      ],
      [
        167.85601806640625,
        -3142.342041015625,
        820.282470703125
      ],
      [
        185.4993133544922,
        -3171.784423828125,
        820.822265625
      ],
      [
        511.6044616699219,
        -3516.24755859375,
        809.7553100585938
      ],
      [
        503.2005920410156,
        -3507.91259765625,
        810.09765625
      ],
      [
        315.5208740234375,
        -3336.56396484375,
        317.957763671875
      ],
      [
        763.2233276367188,
        -3358.15087890625,
        488.07037353515625
      ],
      [
        771.220947265625,
        -3333.741943359375,
        278.1331787109375
      ],
      [
        581.4734497070312,
        -3278.59033203125,
        774.5669555664062
      ],
      [
        763.2233276367188,
        -3358.15087890625,
        488.07037353515625
      ],
      [
        759.0072631835938,
        -3361.5283203125,
        612.8505859375
      ],
      [
        642.1612548828125,
        -3309.138427734375,
        768.9717407226562
      ],
      [
        581.4734497070312,
        -3278.59033203125,
        774.5669555664062
      ],
      [
        581.761962890625,
        -3230.205810546875,
        769.427001953125
      ],
      [
        588.2852172851562,
        -3228.572265625,
        653.202392578125
      ],
      [
        588.2852172851562,
        -3228.572265625,
        653.202392578125
      ],
      [
        594.16162109375,
        -3225.363037109375,
        489.78759765625
      ],
      [
        754.1663208007812,
        -3363.828857421875,
        758.4673461914062
      ],
      [
        642.1612548828125,
        -3309.138427734375,
        768.9718017578125
      ],
      [
        759.0072631835938,
        -3361.5283203125,
        612.8505859375
      ],
      [
        771.2208862304688,
        -3333.741943359375,
        278.1330871582031
      ],
      [
        776.5504150390625,
        -3309.557861328125,
        150.0
      ],
      [
        326.01080322265625,
        -3352.806884765625,
        307.9405212402344
      ],
      [
        411.2447509765625,
        -3486.014404296875,
        239.16864013671875
      ],
      [
        749.7350463867188,
        -3646.34765625,
        474.95501708984375
      ],
      [
        756.60693359375,
        -3721.607421875,
        151.5281219482422
      ],
      [
        441.84271240234375,
        -3533.1123046875,
        207.0719757080078
      ],
      [
        756.601806640625,
        -3722.73974609375,
        150.0
      ],
      [
        756.6068725585938,
        -3721.607666015625,
        151.527587890625
      ],
      [
        502.7161560058594,
        -3207.968017578125,
        778.5640258789062
      ],
      [
        347.40338134765625,
        -3165.675048828125,
        796.6644897460938
      ],
      [
        347.40338134765625,
        -3165.675048828125,
        796.6644897460938
      ],
      [
        588.1956176757812,
        -3228.089599609375,
        654.798828125
      ],
      [
        594.1504516601562,
        -3225.154052734375,
        489.7355041503906
      ],
      [
        581.7662353515625,
        -3229.494140625,
        769.3513793945312
      ],
      [
        588.1956176757812,
        -3228.089599609375,
        654.798828125
      ],
      [
        594.1504516601562,
        -3225.154052734375,
        489.7355041503906
      ],
      [
        607.8739624023438,
        -3225.638671875,
        370.8250732421875
      ],
      [
        594.1498413085938,
        -3225.142333984375,
        489.7325744628906
      ],
      [
        631.7510986328125,
        -3206.932373046875,
        150.0
      ],
      [
        594.1498413085938,
        -3225.142333984375,
        489.7325744628906
      ],
      [
        594.1429443359375,
        -3225.15771484375,
        489.9440612792969
      ],
      [
        519.4442138671875,
        -3197.96484375,
        775.0805053710938
      ],
      [
        502.7161560058594,
        -3207.968017578125,
        778.56396484375
      ],
      [
        558.1326293945312,
        -3175.111328125,
        767.0536499023438
      ],
      [
        519.4442138671875,
        -3197.96484375,
        775.08056640625
      ],
      [
        622.3021850585938,
        -3091.74951171875,
        150.0
      ],
      [
        580.0615234375,
        -3162.15771484375,
        762.5039672851562
      ],
      [
        581.9744262695312,
        -3194.569091796875,
        765.6412353515625
      ],
      [
        580.0615234375,
        -3162.15771484375,
        762.5040283203125
      ],
      [
        581.9744262695312,
        -3194.569091796875,
        765.6412353515625
      ],
      [
        728.1550903320312,
        -4311.93701171875,
        150.0
      ],
      [
        775.1337890625,
        -4428.5595703125,
        867.6085815429688
      ],
      [
        711.5406494140625,
        -4309.482421875,
        864.2977294921875
      ],
      [
        775.1337890625,
        -4428.5595703125,
        867.6085815429688
      ],
      [
        775.6495971679688,
        -4428.7001953125,
        867.5484619140625
      ],
      [
        706.3965454101562,
        -4299.78662109375,
        864.0232543945312
      ],
      [
        711.5406494140625,
        -4309.482421875,
        864.2977905273438
      ],
      [
        706.3965454101562,
        -4299.78662109375,
        864.0232543945312
      ],
      [
        706.4161987304688,
        -4299.38232421875,
        863.977783203125
      ],
      [
        959.901611328125,
        -4478.89404296875,
        846.0774536132812
      ],
      [
        1031.510009765625,
        -4587.34521484375,
        847.1046142578125
      ],
      [
        987.291748046875,
        -4496.2939453125,
        843.932861328125
      ],
      [
        959.901611328125,
        -4478.89404296875,
        846.0775146484375
      ],
      [
        981.9635620117188,
        -4485.32275390625,
        843.5507202148438
      ],
      [
        1031.510009765625,
        -4587.34521484375,
        847.1046142578125
      ],
      [
        1090.3385009765625,
        -4513.5712890625,
        779.9810180664062
      ],
      [
        1088.598388671875,
        -4513.95361328125,
        831.0805053710938
      ],
      [
        982.8438110351562,
        -4485.5791015625,
        843.4498901367188
      ],
      [
        987.291748046875,
        -4496.2939453125,
        843.932861328125
      ],
      [
        982.8438110351562,
        -4485.5791015625,
        843.4498901367188
      ],
      [
        1090.369384765625,
        -4513.5302734375,
        780.0087280273438
      ],
      [
        1088.681640625,
        -4513.8466796875,
        831.05712890625
      ],
      [
        1865.2816162109375,
        -3032.154052734375,
        562.148193359375
      ],
      [
        1988.0572509765625,
        -3311.627197265625,
        573.763916015625
      ],
      [
        1988.0572509765625,
        -3311.627197265625,
        573.763916015625
      ],
      [
        1765.539306640625,
        -3687.543701171875,
        645.68994140625
      ],
      [
        1765.539306640625,
        -3687.543701171875,
        645.68994140625
      ],
      [
        1727.8050537109375,
        -3753.45166015625,
        658.1146850585938
      ],
      [
        1727.8050537109375,
        -3753.45166015625,
        658.11474609375
      ],
      [
        1727.0693359375,
        -3752.533935546875,
        658.1248779296875
      ],
      [
        1865.2816162109375,
        -3032.154052734375,
        562.148193359375
      ],
      [
        1004.6134033203125,
        -3583.95556640625,
        745.2877197265625
      ],
      [
        1131.030517578125,
        -3538.5615234375,
        722.1446533203125
      ],
      [
        781.055908203125,
        -4260.13427734375,
        849.002197265625
      ],
      [
        807.1443481445312,
        -4330.4716796875,
        852.6244506835938
      ],
      [
        1133.2755126953125,
        -4456.51806640625,
        818.5400390625
      ],
      [
        817.6455078125,
        -4361.908203125,
        854.41162109375
      ],
      [
        807.1443481445312,
        -4330.4716796875,
        852.6244506835938
      ],
      [
        1290.54443359375,
        -3456.015625,
        150.0
      ],
      [
        1261.7950439453125,
        -3490.740966796875,
        679.6151123046875
      ],
      [
        1262.05615234375,
        -3490.94482421875,
        685.9617309570312
      ],
      [
        1263.6844482421875,
        -3447.886474609375,
        150.0
      ],
      [
        1252.320556640625,
        -3488.439208984375,
        699.2479858398438
      ],
      [
        1131.030517578125,
        -3538.5615234375,
        722.1446533203125
      ],
      [
        1253.45361328125,
        -3488.759765625,
        699.1171875
      ],
      [
        1252.320556640625,
        -3488.439208984375,
        699.2479858398438
      ],
      [
        1004.6134033203125,
        -3583.95556640625,
        745.2877197265625
      ],
      [
        968.8547973632812,
        -3541.45068359375,
        746.0025024414062
      ],
      [
        967.4859008789062,
        -3528.393798828125,
        575.4642944335938
      ],
      [
        965.5997314453125,
        -3521.15576171875,
        441.1583557128906
      ],
      [
        967.48583984375,
        -3528.393798828125,
        575.4644775390625
      ],
      [
        965.5997924804688,
        -3521.156005859375,
        441.1583251953125
      ],
      [
        966.2415771484375,
        -3516.525146484375,
        420.44580078125
      ],
      [
        970.4108276367188,
        -3486.441650390625,
        285.88909912109375
      ],
      [
        972.3165893554688,
        -3464.74560546875,
        150.0
      ],
      [
        970.4108276367188,
        -3486.441650390625,
        285.88909912109375
      ],
      [
        1406.1966552734375,
        -3532.895263671875,
        681.5841064453125
      ],
      [
        1566.2442626953125,
        -3621.541015625,
        667.6799926757812
      ],
      [
        1360.010009765625,
        -3518.896728515625,
        686.8169555664062
      ],
      [
        1406.1966552734375,
        -3532.895263671875,
        681.5841064453125
      ],
      [
        1360.010009765625,
        -3518.896728515625,
        686.8169555664062
      ],
      [
        1713.8681640625,
        -3736.06640625,
        658.3070068359375
      ],
      [
        1631.621826171875,
        -3658.343994140625,
        662.0626831054688
      ],
      [
        1586.0001220703125,
        -3632.483154296875,
        665.9636840820312
      ],
      [
        1631.621826171875,
        -3658.343994140625,
        662.0626831054688
      ],
      [
        1586.0001220703125,
        -3632.483154296875,
        665.9636840820312
      ],
      [
        1713.8681640625,
        -3736.06640625,
        658.3070068359375
      ],
      [
        771.623779296875,
        -3371.7392578125,
        737.724365234375
      ],
      [
        758.2100830078125,
        -3361.9072265625,
        636.830322265625
      ],
      [
        855.4188842773438,
        -3413.26904296875,
        748.9713134765625
      ],
      [
        920.180908203125,
        -3483.59375,
        746.9754638671875
      ],
      [
        855.4188842773438,
        -3413.26904296875,
        748.9713134765625
      ],
      [
        774.132568359375,
        -3373.578125,
        756.5947875976562
      ],
      [
        920.180908203125,
        -3483.59375,
        746.9754638671875
      ],
      [
        806.2110595703125,
        -4043.64892578125,
        150.0
      ],
      [
        795.4458618164062,
        -3656.04296875,
        783.2615356445312
      ],
      [
        811.7066650390625,
        -3750.4384765625,
        790.8460083007812
      ],
      [
        852.4025268554688,
        -3986.275390625,
        809.7847900390625
      ],
      [
        811.7066650390625,
        -3750.4384765625,
        790.8460083007812
      ],
      [
        852.4025268554688,
        -3986.275390625,
        809.7847900390625
      ],
      [
        852.3602905273438,
        -3986.43701171875,
        809.8079833984375
      ],
      [
        810.385986328125,
        -4147.142578125,
        832.8369140625
      ],
      [
        780.9491577148438,
        -4259.84619140625,
        848.9873657226562
      ],
      [
        795.4458618164062,
        -3656.04296875,
        783.2615966796875
      ],
      [
        718.9588012695312,
        -4041.57568359375,
        834.9921264648438
      ],
      [
        779.6024169921875,
        -4256.21533203125,
        848.8003540039062
      ],
      [
        810.385986328125,
        -4147.142578125,
        832.8369140625
      ],
      [
        779.6024169921875,
        -4256.21533203125,
        848.8004150390625
      ],
      [
        -542.7430419921875,
        -2638.90576171875,
        475.2274169921875
      ],
      [
        -529.8553466796875,
        -2692.37841796875,
        874.203125
      ],
      [
        -542.2255859375,
        -2659.71337890625,
        872.5579223632812
      ],
      [
        -488.8464050292969,
        -2803.204345703125,
        879.9244384765625
      ],
      [
        -529.8553466796875,
        -2692.37841796875,
        874.203125
      ],
      [
        -765.3082885742188,
        -2323.076416015625,
        639.467529296875
      ],
      [
        -758.2701416015625,
        -2329.916748046875,
        639.4786987304688
      ],
      [
        -724.7533569335938,
        -2362.4892578125,
        639.4855346679688
      ],
      [
        -758.2701416015625,
        -2329.916748046875,
        639.4786987304688
      ],
      [
        -768.812255859375,
        -2320.185302734375,
        648.37158203125
      ],
      [
        -769.9774169921875,
        -2319.287109375,
        652.428466796875
      ],
      [
        -769.9774169921875,
        -2319.287109375,
        652.428466796875
      ],
      [
        -771.8432006835938,
        -2318.6943359375,
        673.583251953125
      ],
      [
        -761.8179321289062,
        -2329.194580078125,
        686.7105102539062
      ],
      [
        -738.4791259765625,
        -2351.890625,
        686.9730224609375
      ],
      [
        -761.8179321289062,
        -2329.194580078125,
        686.7105102539062
      ],
      [
        -763.1956787109375,
        -2327.6796875,
        683.6611938476562
      ],
      [
        -771.84326171875,
        -2318.6943359375,
        673.583251953125
      ],
      [
        -763.1956787109375,
        -2327.6796875,
        683.6611938476562
      ],
      [
        -765.3082885742188,
        -2323.076416015625,
        639.467529296875
      ],
      [
        -768.812255859375,
        -2320.185302734375,
        648.37158203125
      ],
      [
        -735.351318359375,
        -2354.930419921875,
        686.9745483398438
      ],
      [
        -738.4791259765625,
        -2351.890625,
        686.9730224609375
      ],
      [
        -733.5985717773438,
        -2356.4541015625,
        683.8611450195312
      ],
      [
        -722.9044799804688,
        -2366.329345703125,
        674.8947143554688
      ],
      [
        -1020.0485229492188,
        -2047.3824462890625,
        151.93190002441406
      ],
      [
        -487.7550964355469,
        -2803.549072265625,
        879.80224609375
      ],
      [
        -488.8464050292969,
        -2803.204345703125,
        879.9244384765625
      ],
      [
        -484.9613342285156,
        -2802.0263671875,
        698.3142700195312
      ],
      [
        -692.7105102539062,
        -2379.91015625,
        615.4983520507812
      ],
      [
        -681.9195556640625,
        -2397.4638671875,
        720.006591796875
      ],
      [
        -1018.7880249023438,
        -2045.9326171875,
        151.26873779296875
      ],
      [
        -719.7452392578125,
        -2356.772216796875,
        639.4212036132812
      ],
      [
        -756.295654296875,
        -2323.13134765625,
        639.4253540039062
      ],
      [
        -761.552978515625,
        -2318.2919921875,
        639.4187622070312
      ],
      [
        -756.295654296875,
        -2323.13134765625,
        639.4253540039062
      ],
      [
        -761.552978515625,
        -2318.2919921875,
        639.4187622070312
      ],
      [
        -765.3121337890625,
        -2323.0732421875,
        639.477294921875
      ],
      [
        -761.5559692382812,
        -2318.289794921875,
        639.426025390625
      ],
      [
        -758.3292846679688,
        -2324.705810546875,
        686.684326171875
      ],
      [
        -732.9213256835938,
        -2348.111572265625,
        686.9592895507812
      ],
      [
        -766.3021850585938,
        -2314.824462890625,
        651.81005859375
      ],
      [
        -768.4712524414062,
        -2314.45263671875,
        674.0901489257812
      ],
      [
        -730.1785888671875,
        -2350.51318359375,
        685.2745971679688
      ],
      [
        -718.3978271484375,
        -2360.6611328125,
        675.7409057617188
      ],
      [
        -731.1618041992188,
        -2349.731201171875,
        686.9600219726562
      ],
      [
        -732.2608642578125,
        -2348.719482421875,
        686.9595947265625
      ],
      [
        -737.3109741210938,
        -2353.02587890625,
        686.9735717773438
      ],
      [
        -768.4713134765625,
        -2314.45263671875,
        674.0901489257812
      ],
      [
        -759.2192993164062,
        -2323.744140625,
        684.730224609375
      ],
      [
        -758.3292846679688,
        -2324.705810546875,
        686.684326171875
      ],
      [
        -759.2192993164062,
        -2323.744140625,
        684.730224609375
      ],
      [
        -765.4027099609375,
        -2315.434326171875,
        648.81787109375
      ],
      [
        -765.4027099609375,
        -2315.434326171875,
        648.81787109375
      ],
      [
        -766.3021850585938,
        -2314.824462890625,
        651.81005859375
      ],
      [
        -732.9213256835938,
        -2348.111572265625,
        686.9592895507812
      ],
      [
        -685.3416137695312,
        -2384.8916015625,
        590.8056030273438
      ],
      [
        -692.7105102539062,
        -2379.91015625,
        615.4983520507812
      ],
      [
        -685.3506469726562,
        -2384.460693359375,
        585.010498046875
      ],
      [
        -685.3416748046875,
        -2384.8916015625,
        590.8056030273438
      ],
      [
        -530.0181884765625,
        -2654.155029296875,
        316.3236083984375
      ],
      [
        -542.7430419921875,
        -2638.90576171875,
        475.2274169921875
      ],
      [
        -458.3185119628906,
        -2812.849365234375,
        876.5070190429688
      ],
      [
        -456.64459228515625,
        -2812.469482421875,
        807.8794555664062
      ],
      [
        -689.2754516601562,
        -2391.3369140625,
        865.6367797851562
      ],
      [
        -703.9307861328125,
        -2371.319091796875,
        865.6560668945312
      ],
      [
        -713.2709350585938,
        -2363.612060546875,
        866.2005004882812
      ],
      [
        -703.9307861328125,
        -2371.319091796875,
        865.656005859375
      ],
      [
        -714.7833862304688,
        -2350.402099609375,
        639.3530883789062
      ],
      [
        -714.5018920898438,
        -2350.78662109375,
        639.3538208007812
      ],
      [
        -754.6287231445312,
        -2317.40283203125,
        639.3803100585938
      ],
      [
        -758.402099609375,
        -2314.27783203125,
        639.3778686523438
      ],
      [
        -754.6287231445312,
        -2317.40283203125,
        639.3803100585938
      ],
      [
        -758.402099609375,
        -2314.27783203125,
        639.3778686523438
      ],
      [
        -761.5559692382812,
        -2318.289794921875,
        639.426025390625
      ],
      [
        -758.4042358398438,
        -2314.2763671875,
        639.3829345703125
      ],
      [
        -754.6053466796875,
        -2319.914306640625,
        686.6563720703125
      ],
      [
        -763.1381225585938,
        -2310.982421875,
        651.2776489257812
      ],
      [
        -765.279052734375,
        -2310.43701171875,
        674.5700073242188
      ],
      [
        -732.2607421875,
        -2348.7197265625,
        686.9595947265625
      ],
      [
        -765.279052734375,
        -2310.43701171875,
        674.5700073242188
      ],
      [
        -754.98779296875,
        -2319.55615234375,
        685.8677978515625
      ],
      [
        -754.6053466796875,
        -2319.914306640625,
        686.6563720703125
      ],
      [
        -754.98779296875,
        -2319.55615234375,
        685.8677978515625
      ],
      [
        -762.5052490234375,
        -2311.396728515625,
        649.1970825195312
      ],
      [
        -762.5052490234375,
        -2311.396728515625,
        649.1970825195312
      ],
      [
        -763.1381225585938,
        -2310.982421875,
        651.2776489257812
      ],
      [
        -743.8213500976562,
        -2328.3017578125,
        866.9169921875
      ],
      [
        -756.9968872070312,
        -2314.731201171875,
        867.400634765625
      ],
      [
        -713.2709350585938,
        -2363.612060546875,
        866.2005615234375
      ],
      [
        -720.4390869140625,
        -2352.38525390625,
        866.0586547851562
      ],
      [
        -1014.7175903320312,
        -2040.0740966796875,
        150.16165161132812
      ],
      [
        -1014.6470947265625,
        -2040.1346435546875,
        150.0
      ],
      [
        -1014.7175903320312,
        -2040.0740966796875,
        150.16165161132812
      ],
      [
        -1025.1650390625,
        -2031.635986328125,
        189.5177459716797
      ],
      [
        -1025.1650390625,
        -2031.635986328125,
        189.5177459716797
      ],
      [
        -1030.0263671875,
        -2027.8453369140625,
        211.71893310546875
      ],
      [
        -1030.0263671875,
        -2027.8453369140625,
        211.71893310546875
      ],
      [
        -1033.514892578125,
        -2025.6693115234375,
        243.25596618652344
      ],
      [
        -734.5917358398438,
        -2333.9970703125,
        639.3666381835938
      ],
      [
        -753.7207641601562,
        -2314.28271484375,
        639.3557739257812
      ],
      [
        -756.3106689453125,
        -2311.61328125,
        639.3507080078125
      ],
      [
        -753.7208251953125,
        -2314.28271484375,
        639.3557739257812
      ],
      [
        -756.3106689453125,
        -2311.61328125,
        639.3507080078125
      ],
      [
        -758.4042358398438,
        -2314.2763671875,
        639.3829345703125
      ],
      [
        -760.3704223632812,
        -2307.621826171875,
        650.8119506835938
      ],
      [
        -762.0160522460938,
        -2306.33251953125,
        675.0604858398438
      ],
      [
        -762.0160522460938,
        -2306.33251953125,
        675.0604858398438
      ],
      [
        -760.0314331054688,
        -2307.949462890625,
        649.5208740234375
      ],
      [
        -760.0314331054688,
        -2307.949462890625,
        649.5208740234375
      ],
      [
        -760.3704833984375,
        -2307.621826171875,
        650.8119506835938
      ],
      [
        -728.7449951171875,
        -2339.37646484375,
        865.894287109375
      ],
      [
        -743.8213500976562,
        -2328.3017578125,
        866.9169921875
      ],
      [
        -728.7449951171875,
        -2339.37646484375,
        865.894287109375
      ],
      [
        -756.9968872070312,
        -2314.731201171875,
        867.400634765625
      ],
      [
        -760.5123901367188,
        -2303.76025390625,
        866.7552490234375
      ],
      [
        -758.6405639648438,
        -2301.782470703125,
        759.6326904296875
      ],
      [
        -755.9369506835938,
        -2302.220703125,
        650.1961669921875
      ],
      [
        -765.091796875,
        -2295.123779296875,
        742.39501953125
      ],
      [
        -757.0101318359375,
        -2300.060302734375,
        666.3331298828125
      ],
      [
        -755.9306640625,
        -2302.23095703125,
        650.0648803710938
      ],
      [
        -755.9369506835938,
        -2302.220703125,
        650.1961669921875
      ],
      [
        -759.273681640625,
        -2308.695556640625,
        647.44970703125
      ],
      [
        -755.9295654296875,
        -2302.23388671875,
        650.0578002929688
      ],
      [
        -755.9295654296875,
        -2302.23388671875,
        650.0578002929688
      ],
      [
        -755.9306640625,
        -2302.23095703125,
        650.0648803710938
      ],
      [
        -761.9382934570312,
        -2306.4140625,
        675.1514892578125
      ],
      [
        -758.6405639648438,
        -2301.782470703125,
        759.6326904296875
      ],
      [
        -765.091796875,
        -2295.123779296875,
        742.39501953125
      ],
      [
        -753.7212524414062,
        -2308.314453125,
        639.3170776367188
      ],
      [
        -750.8490600585938,
        -2317.2421875,
        639.357421875
      ],
      [
        -752.8091430664062,
        -2311.149658203125,
        639.3311767578125
      ],
      [
        -753.7212524414062,
        -2308.314453125,
        639.3170776367188
      ],
      [
        -752.8091430664062,
        -2311.149658203125,
        639.3311767578125
      ],
      [
        -742.0281372070312,
        -2313.18505859375,
        639.28125
      ],
      [
        -756.3975830078125,
        -2299.9072265625,
        645.4571533203125
      ],
      [
        -756.9557495117188,
        -2300.09326171875,
        665.8225708007812
      ],
      [
        -756.95556640625,
        -2300.09375,
        665.8196411132812
      ],
      [
        -755.6088256835938,
        -2303.116943359375,
        648.4978637695312
      ],
      [
        -756.3975219726562,
        -2299.90771484375,
        645.4580078125
      ],
      [
        -739.8612060546875,
        -2314.904052734375,
        630.2252807617188
      ],
      [
        -705.91748046875,
        -2349.233642578125,
        630.2252807617188
      ],
      [
        -708.697265625,
        -2344.1669921875,
        630.2252807617188
      ],
      [
        -585.7590942382812,
        -2544.758056640625,
        866.76806640625
      ],
      [
        -585.7590942382812,
        -2544.758056640625,
        866.7681274414062
      ],
      [
        -642.4852294921875,
        -2459.847900390625,
        866.0599975585938
      ],
      [
        -678.7152709960938,
        -2405.76123046875,
        865.6229248046875
      ],
      [
        -642.4852294921875,
        -2459.847900390625,
        866.0599975585938
      ],
      [
        -678.7152709960938,
        -2405.76123046875,
        865.6229248046875
      ],
      [
        -580.6322021484375,
        -2523.185546875,
        150.0
      ],
      [
        -704.3489990234375,
        -2348.25,
        630.2252807617188
      ],
      [
        -704.5856323242188,
        -2348.42529296875,
        641.6248779296875
      ],
      [
        -704.3489990234375,
        -2348.25,
        630.2252807617188
      ],
      [
        -708.7366943359375,
        -2344.52734375,
        641.6248779296875
      ],
      [
        -704.5856323242188,
        -2348.42529296875,
        641.6248779296875
      ],
      [
        -993.2120361328125,
        -2038.0494384765625,
        196.9026641845703
      ],
      [
        -1002.9469604492188,
        -2031.875244140625,
        287.4402160644531
      ],
      [
        -757.15625,
        -2299.6904296875,
        668.834228515625
      ],
      [
        -765.2634887695312,
        -2294.6083984375,
        745.6574096679688
      ],
      [
        -983.6271362304688,
        -2045.90087890625,
        150.0
      ],
      [
        -993.2120361328125,
        -2038.0494384765625,
        196.9026641845703
      ],
      [
        -756.52685546875,
        -2299.30322265625,
        644.2453002929688
      ],
      [
        -757.1561889648438,
        -2299.6904296875,
        668.8339233398438
      ],
      [
        -754.57177734375,
        -2301.5498046875,
        643.3837280273438
      ],
      [
        -756.5269165039062,
        -2299.30322265625,
        644.2451782226562
      ],
      [
        -754.3570556640625,
        -2301.445068359375,
        642.3101196289062
      ],
      [
        -765.2634887695312,
        -2294.6083984375,
        745.6574096679688
      ],
      [
        -760.5297241210938,
        -2299.83251953125,
        754.5848999023438
      ],
      [
        -770.2131958007812,
        -2273.45458984375,
        864.970947265625
      ],
      [
        -773.5408935546875,
        -2261.224365234375,
        864.1656494140625
      ],
      [
        -770.2131958007812,
        -2273.45458984375,
        864.970947265625
      ],
      [
        -771.5665283203125,
        -2275.6953125,
        865.4036254882812
      ],
      [
        -937.3193359375,
        -2053.54150390625,
        174.40814208984375
      ],
      [
        -954.8668212890625,
        -2041.6365966796875,
        356.9372863769531
      ],
      [
        -938.1552734375,
        -2052.93896484375,
        183.98452758789062
      ],
      [
        -933.0374755859375,
        -2057.4658203125,
        150.0
      ],
      [
        -937.3193359375,
        -2053.54150390625,
        174.40814208984375
      ],
      [
        -768.5595703125,
        -2279.531982421875,
        865.3711547851562
      ],
      [
        -771.5665283203125,
        -2275.6953125,
        865.4036254882812
      ],
      [
        -759.4663696289062,
        -2300.93017578125,
        757.4260864257812
      ],
      [
        -768.0801391601562,
        -2280.1435546875,
        865.365966796875
      ],
      [
        -768.0801391601562,
        -2280.1435546875,
        865.365966796875
      ],
      [
        -751.1504516601562,
        -2303.486572265625,
        630.2252807617188
      ],
      [
        -752.4912719726562,
        -2299.746337890625,
        630.2252807617188
      ],
      [
        -752.772216796875,
        -2299.947021484375,
        641.6248779296875
      ],
      [
        -751.1085205078125,
        -2304.58740234375,
        641.6248779296875
      ],
      [
        -774.0778198242188,
        -2259.7197265625,
        864.0850830078125
      ],
      [
        -808.562255859375,
        -2222.119384765625,
        865.131591796875
      ],
      [
        -953.4334106445312,
        -2041.9276123046875,
        359.0092468261719
      ],
      [
        -855.3812866210938,
        -2170.46875,
        866.4890747070312
      ],
      [
        -808.562255859375,
        -2222.119384765625,
        865.131591796875
      ],
      [
        -830.53173828125,
        -2076.013671875,
        293.091552734375
      ],
      [
        -842.3095703125,
        -2065.77197265625,
        565.3817749023438
      ],
      [
        -929.723388671875,
        -2055.64697265625,
        171.35107421875
      ],
      [
        -948.3048706054688,
        -2042.9688720703125,
        366.42230224609375
      ],
      [
        -927.1857299804688,
        -2057.93994140625,
        157.1568603515625
      ],
      [
        -929.7234497070312,
        -2055.64697265625,
        171.35108947753906
      ],
      [
        -927.1857299804688,
        -2057.93994140625,
        157.1568603515625
      ],
      [
        -925.8958129882812,
        -2059.108154296875,
        150.0
      ],
      [
        -828.211669921875,
        -2078.48974609375,
        245.9615936279297
      ],
      [
        -830.53173828125,
        -2076.013671875,
        293.0915222167969
      ],
      [
        -828.211669921875,
        -2078.48974609375,
        245.9615936279297
      ],
      [
        -826.5889282226562,
        -2080.65185546875,
        219.0944061279297
      ],
      [
        -822.4157104492188,
        -2086.212158203125,
        150.0
      ],
      [
        -820.8699340820312,
        -2078.9296875,
        281.6034240722656
      ],
      [
        -834.2371215820312,
        -2067.539306640625,
        581.6278076171875
      ],
      [
        -819.4318237304688,
        -2080.4501953125,
        252.7462921142578
      ],
      [
        -813.2948608398438,
        -2088.699951171875,
        150.0
      ],
      [
        -819.4318237304688,
        -2080.4501953125,
        252.7462921142578
      ],
      [
        -820.8699340820312,
        -2078.9296875,
        281.6034240722656
      ],
      [
        -427.0450439453125,
        -2372.223388671875,
        825.5380859375
      ],
      [
        -387.8594665527344,
        -2401.6845703125,
        822.951171875
      ],
      [
        -387.8594665527344,
        -2401.6845703125,
        822.9512329101562
      ],
      [
        -364.3202209472656,
        -2416.802978515625,
        821.12548828125
      ],
      [
        -629.8267211914062,
        -2024.815673828125,
        818.3839721679688
      ],
      [
        -619.1536865234375,
        -2036.7056884765625,
        818.086669921875
      ],
      [
        -499.9651794433594,
        -2015.67578125,
        798.5606079101562
      ],
      [
        -597.2589721679688,
        -2061.09716796875,
        817.476806640625
      ],
      [
        -597.2589721679688,
        -2061.09716796875,
        817.476806640625
      ],
      [
        -577.8394165039062,
        -2180.648681640625,
        639.2813110351562
      ],
      [
        -664.288330078125,
        -2141.87109375,
        723.4588012695312
      ],
      [
        -584.162841796875,
        -2185.198974609375,
        639.2813110351562
      ],
      [
        -652.0059204101562,
        -2148.14013671875,
        723.0960083007812
      ],
      [
        -652.0059204101562,
        -2148.14013671875,
        723.0960083007812
      ],
      [
        -664.288330078125,
        -2141.87109375,
        723.4588012695312
      ],
      [
        -556.5177612304688,
        -2291.06005859375,
        401.86346435546875
      ],
      [
        -594.0824584960938,
        -2199.5419921875,
        630.2252807617188
      ],
      [
        -604.6767578125,
        -2194.20947265625,
        630.2252807617188
      ],
      [
        -602.43359375,
        -2192.60791015625,
        641.6248779296875
      ],
      [
        -599.2575073242188,
        -2193.659912109375,
        641.6248779296875
      ],
      [
        -599.7045288085938,
        -2193.9814453125,
        641.6248779296875
      ],
      [
        -598.7432250976562,
        -2194.46533203125,
        641.6248779296875
      ],
      [
        -364.3202209472656,
        -2416.802978515625,
        821.12548828125
      ],
      [
        -572.667724609375,
        -2250.59716796875,
        630.2252807617188
      ],
      [
        -615.7203369140625,
        -2202.09423828125,
        630.2252807617188
      ],
      [
        -612.2840576171875,
        -2205.430908203125,
        639.2813110351562
      ],
      [
        -575.7613525390625,
        -2246.577392578125,
        639.28125
      ],
      [
        -572.667724609375,
        -2250.59716796875,
        630.2252807617188
      ],
      [
        -572.3814697265625,
        -2250.385009765625,
        639.28125
      ],
      [
        -560.1396484375,
        -2241.306640625,
        639.28125
      ],
      [
        -612.2088012695312,
        -2205.376953125,
        641.6248779296875
      ],
      [
        -612.2840576171875,
        -2205.430908203125,
        639.2813110351562
      ],
      [
        -615.3544921875,
        -2201.833251953125,
        641.6248779296875
      ],
      [
        -612.2088012695312,
        -2205.376953125,
        641.6248779296875
      ],
      [
        -575.6868286132812,
        -2246.522705078125,
        641.6248779296875
      ],
      [
        -572.307373046875,
        -2250.330078125,
        641.6248779296875
      ],
      [
        -572.307373046875,
        -2250.330078125,
        641.6248779296875
      ],
      [
        -577.1485595703125,
        -2253.920166015625,
        630.2252807617188
      ],
      [
        -620.7225341796875,
        -2205.665771484375,
        630.2252807617188
      ],
      [
        -617.2255859375,
        -2208.9716796875,
        639.2813110351562
      ],
      [
        -580.2741088867188,
        -2249.89208984375,
        639.28125
      ],
      [
        -577.1485595703125,
        -2253.920166015625,
        630.2252807617188
      ],
      [
        -576.842041015625,
        -2253.69287109375,
        639.28125
      ],
      [
        -572.3814697265625,
        -2250.385009765625,
        639.28125
      ],
      [
        -580.1944580078125,
        -2249.833740234375,
        641.6248779296875
      ],
      [
        -576.7626953125,
        -2253.634033203125,
        641.6248779296875
      ],
      [
        -620.3309326171875,
        -2205.38623046875,
        641.6248779296875
      ],
      [
        -617.1452026367188,
        -2208.9140625,
        641.6248779296875
      ],
      [
        -617.1452026367188,
        -2208.9140625,
        641.6248779296875
      ],
      [
        -617.2255859375,
        -2208.9716796875,
        639.2813110351562
      ],
      [
        -576.7626953125,
        -2253.634033203125,
        641.6248779296875
      ],
      [
        -650.1624755859375,
        -2228.74755859375,
        191.84388732910156
      ],
      [
        -621.9351806640625,
        -2242.641357421875,
        385.7645568847656
      ],
      [
        -598.365234375,
        -2257.631591796875,
        457.1593017578125
      ],
      [
        -556.5177612304688,
        -2291.06005859375,
        401.86346435546875
      ],
      [
        -596.5943603515625,
        -2232.3857421875,
        630.2252807617188
      ],
      [
        -622.7305297851562,
        -2207.099365234375,
        630.2252807617188
      ],
      [
        -611.5069580078125,
        -2223.46826171875,
        630.2252807617188
      ],
      [
        -619.4703979492188,
        -2210.580078125,
        639.2813110351562
      ],
      [
        -598.1838989257812,
        -2230.05859375,
        639.28125
      ],
      [
        -611.6262817382812,
        -2222.020263671875,
        639.2813110351562
      ],
      [
        -621.9924926757812,
        -2206.572509765625,
        641.6248779296875
      ],
      [
        -619.3190307617188,
        -2210.4716796875,
        641.6248779296875
      ],
      [
        -619.3190307617188,
        -2210.4716796875,
        641.6248779296875
      ],
      [
        -619.4703979492188,
        -2210.580078125,
        639.2813110351562
      ],
      [
        -585.9564208984375,
        -2260.451904296875,
        630.2252807617188
      ],
      [
        -586.351318359375,
        -2260.156005859375,
        630.2252807617188
      ],
      [
        -588.4153442382812,
        -2255.8720703125,
        639.28125
      ],
      [
        -585.9564208984375,
        -2260.451904296875,
        630.2252807617188
      ],
      [
        -585.8740844726562,
        -2260.390869140625,
        633.503662109375
      ],
      [
        -585.5047607421875,
        -2260.116943359375,
        639.28125
      ],
      [
        -576.842041015625,
        -2253.69287109375,
        639.2811889648438
      ],
      [
        -588.2650146484375,
        -2255.76171875,
        641.6248779296875
      ],
      [
        -585.35498046875,
        -2260.005859375,
        641.6248779296875
      ],
      [
        -585.35498046875,
        -2260.005859375,
        641.6248779296875
      ],
      [
        -640.3580932617188,
        -2219.685302734375,
        630.2252807617188
      ],
      [
        -636.1280517578125,
        -2222.515869140625,
        639.2813110351562
      ],
      [
        -590.0313720703125,
        -2257.05908203125,
        639.28125
      ],
      [
        -585.7290649414062,
        -2260.283447265625,
        639.2811889648438
      ],
      [
        -585.5047607421875,
        -2260.116943359375,
        639.2811889648438
      ],
      [
        -589.9722900390625,
        -2257.015869140625,
        641.6248779296875
      ],
      [
        -585.6702270507812,
        -2260.23974609375,
        641.6248779296875
      ],
      [
        -640.0664672851562,
        -2219.47705078125,
        641.6248779296875
      ],
      [
        -636.0682983398438,
        -2222.47314453125,
        641.6248779296875
      ],
      [
        -636.0682983398438,
        -2222.47314453125,
        641.6248779296875
      ],
      [
        -636.1280517578125,
        -2222.515869140625,
        639.2813110351562
      ],
      [
        -585.6702270507812,
        -2260.23974609375,
        641.6248779296875
      ],
      [
        -476.416259765625,
        -2368.53466796875,
        150.0
      ],
      [
        -395.4619445800781,
        -2413.077880859375,
        377.04852294921875
      ],
      [
        -615.7688598632812,
        -2259.3193359375,
        331.1248779296875
      ],
      [
        -609.7339477539062,
        -2260.53369140625,
        385.06915283203125
      ],
      [
        -606.9039916992188,
        -2261.97998046875,
        394.9552307128906
      ],
      [
        -586.0836791992188,
        -2260.54638671875,
        630.2252807617188
      ],
      [
        -585.8740844726562,
        -2260.390869140625,
        633.503662109375
      ],
      [
        -586.0836791992188,
        -2260.54638671875,
        630.2252807617188
      ],
      [
        -586.351318359375,
        -2260.156005859375,
        630.2252807617188
      ],
      [
        -636.64794921875,
        -2254.804443359375,
        150.0
      ],
      [
        -615.7688598632812,
        -2259.3193359375,
        331.1248779296875
      ],
      [
        -588.0315551757812,
        -2261.99072265625,
        630.2252807617188
      ],
      [
        -643.9855346679688,
        -2222.275146484375,
        630.2252807617188
      ],
      [
        -639.5083618164062,
        -2224.93798828125,
        639.2813110351562
      ],
      [
        -592.1062622070312,
        -2258.583251953125,
        639.28125
      ],
      [
        -588.0315551757812,
        -2261.99072265625,
        630.2252807617188
      ],
      [
        -587.6763916015625,
        -2261.7275390625,
        639.28125
      ],
      [
        -585.7290649414062,
        -2260.283447265625,
        639.2811889648438
      ],
      [
        -592.0139770507812,
        -2258.515625,
        641.6248779296875
      ],
      [
        -587.58447265625,
        -2261.659423828125,
        641.6248779296875
      ],
      [
        -643.5300903320312,
        -2221.949951171875,
        641.6248779296875
      ],
      [
        -639.414794921875,
        -2224.87109375,
        641.6248779296875
      ],
      [
        -639.414794921875,
        -2224.87109375,
        641.6248779296875
      ],
      [
        -639.5083618164062,
        -2224.93798828125,
        639.2813110351562
      ],
      [
        -587.58447265625,
        -2261.659423828125,
        641.6248779296875
      ],
      [
        -773.896484375,
        -2259.91748046875,
        864.07958984375
      ],
      [
        -773.896484375,
        -2259.91748046875,
        864.07958984375
      ],
      [
        -634.6590576171875,
        -2257.9169921875,
        150.0
      ],
      [
        -621.508544921875,
        -2258.078125,
        281.33367919921875
      ],
      [
        -596.6500854492188,
        -2269.94384765625,
        382.9001159667969
      ],
      [
        -704.5369873046875,
        -2348.38916015625,
        639.2811889648438
      ],
      [
        -587.6763916015625,
        -2261.7275390625,
        639.2811889648438
      ],
      [
        1805.7742919921875,
        -2832.09912109375,
        1703.96142578125
      ],
      [
        2014.292724609375,
        -3296.4443359375,
        1634.694091796875
      ],
      [
        2014.793212890625,
        -3296.4345703125,
        1653.20458984375
      ],
      [
        2014.762939453125,
        -3296.392822265625,
        1652.7911376953125
      ],
      [
        2013.76904296875,
        -3295.01806640625,
        1639.1903076171875
      ],
      [
        2014.292724609375,
        -3296.4443359375,
        1634.694091796875
      ],
      [
        2013.76904296875,
        -3295.01806640625,
        1639.1903076171875
      ],
      [
        994.7415771484375,
        -2812.97412109375,
        1640.0830078125
      ],
      [
        994.7415161132812,
        -2812.97412109375,
        1640.0830078125
      ],
      [
        994.8046875,
        -2812.84619140625,
        1644.060546875
      ],
      [
        1296.56396484375,
        -2816.019775390625,
        621.9722290039062
      ],
      [
        1286.375244140625,
        -2819.154296875,
        623.7822265625
      ],
      [
        1047.982666015625,
        -2834.50732421875,
        660.022705078125
      ],
      [
        760.3065795898438,
        -2611.7666015625,
        678.3338012695312
      ],
      [
        1600.0574951171875,
        -2654.99267578125,
        1693.07763671875
      ],
      [
        1600.6016845703125,
        -2653.7763671875,
        1720.4039306640625
      ],
      [
        1600.0574951171875,
        -2654.99267578125,
        1693.0775146484375
      ],
      [
        1754.7242431640625,
        -2781.122802734375,
        679.1740112304688
      ],
      [
        1748.0452880859375,
        -2785.55224609375,
        553.19140625
      ],
      [
        1753.1971435546875,
        -2726.42578125,
        1716.2720947265625
      ],
      [
        1758.2896728515625,
        -2756.008056640625,
        1227.1275634765625
      ],
      [
        1685.5030517578125,
        -2691.410400390625,
        1718.481201171875
      ],
      [
        1678.62939453125,
        -2703.35400390625,
        1437.4730224609375
      ],
      [
        1678.62939453125,
        -2703.35400390625,
        1437.47314453125
      ],
      [
        1753.351318359375,
        -2726.735595703125,
        1716.2359619140625
      ],
      [
        1753.397705078125,
        -2727.590576171875,
        1697.0128173828125
      ],
      [
        1764.1435546875,
        -2748.426513671875,
        1713.7091064453125
      ],
      [
        1762.2589111328125,
        -2762.368408203125,
        1266.985595703125
      ],
      [
        1769.0184326171875,
        -2758.224609375,
        1712.567626953125
      ],
      [
        1766.283203125,
        -2768.817138671875,
        1307.3970947265625
      ],
      [
        1769.20166015625,
        -3681.504150390625,
        653.609375
      ],
      [
        1768.987060546875,
        -3681.71923828125,
        644.5755004882812
      ],
      [
        1769.20166015625,
        -3681.504150390625,
        653.6094970703125
      ],
      [
        1786.37353515625,
        -3673.044677734375,
        1197.888916015625
      ],
      [
        1786.37353515625,
        -3673.044677734375,
        1197.888916015625
      ],
      [
        1790.171875,
        -3671.369873046875,
        1314.2698974609375
      ],
      [
        1802.312255859375,
        -3666.802001953125,
        1670.210693359375
      ],
      [
        1801.53173828125,
        -3666.360595703125,
        1662.3399658203125
      ],
      [
        2014.762939453125,
        -3296.392822265625,
        1652.7911376953125
      ],
      [
        1790.0635986328125,
        -3671.2265625,
        1314.85400390625
      ],
      [
        1790.171875,
        -3671.369873046875,
        1314.2698974609375
      ],
      [
        2013.990478515625,
        -3295.62109375,
        1637.2891845703125
      ],
      [
        1800.7913818359375,
        -3665.942138671875,
        1654.8743896484375
      ],
      [
        2014.1802978515625,
        -3295.5869140625,
        1644.8177490234375
      ],
      [
        1959.78662109375,
        -3375.6220703125,
        1584.1126708984375
      ],
      [
        1785.4967041015625,
        -3665.183349609375,
        1339.4947509765625
      ],
      [
        1790.53125,
        -3660.140625,
        1551.4122314453125
      ],
      [
        1959.78662109375,
        -3375.6220703125,
        1584.1126708984375
      ],
      [
        1775.086181640625,
        -3651.407470703125,
        1395.6650390625
      ],
      [
        1775.086181640625,
        -3651.407470703125,
        1395.6650390625
      ],
      [
        1766.907470703125,
        -3685.287353515625,
        648.6484985351562
      ],
      [
        1783.7489013671875,
        -3677.61474609375,
        1198.3900146484375
      ],
      [
        1783.7489013671875,
        -3677.61474609375,
        1198.3900146484375
      ],
      [
        1787.2939453125,
        -3676.184326171875,
        1310.1553955078125
      ],
      [
        1799.25146484375,
        -3672.136962890625,
        1670.4556884765625
      ],
      [
        1798.4693603515625,
        -3671.67431640625,
        1662.478759765625
      ],
      [
        1801.53173828125,
        -3666.360595703125,
        1662.33984375
      ],
      [
        1766.907470703125,
        -3685.287353515625,
        648.6484375
      ],
      [
        1766.830322265625,
        -3685.36279296875,
        645.2726440429688
      ],
      [
        1797.73779296875,
        -3671.241455078125,
        1655.017578125
      ],
      [
        1800.7913818359375,
        -3665.942138671875,
        1654.8741455078125
      ],
      [
        1787.1900634765625,
        -3676.04736328125,
        1310.715087890625
      ],
      [
        1787.2939453125,
        -3676.184326171875,
        1310.1553955078125
      ],
      [
        1790.0635986328125,
        -3671.2265625,
        1314.85400390625
      ],
      [
        1771.999755859375,
        -3656.015869140625,
        1392.5159912109375
      ],
      [
        1771.999755859375,
        -3656.015869140625,
        1392.5159912109375
      ],
      [
        192.068603515625,
        -2496.407958984375,
        816.3604736328125
      ],
      [
        -762.6567993164062,
        -2311.351806640625,
        1060.670166015625
      ],
      [
        -762.2197875976562,
        -2311.787353515625,
        1049.9979248046875
      ],
      [
        -761.0499267578125,
        -2313.075927734375,
        1017.7451171875
      ],
      [
        -762.2197875976562,
        -2311.787353515625,
        1049.9979248046875
      ],
      [
        -770.2198486328125,
        -2273.465576171875,
        864.9730834960938
      ],
      [
        -761.0499267578125,
        -2313.075927734375,
        1017.7451171875
      ],
      [
        -755.8292236328125,
        -2315.933837890625,
        867.3577880859375
      ],
      [
        -760.5597534179688,
        -2313.442138671875,
        1009.4588012695312
      ],
      [
        -772.55126953125,
        -2264.861572265625,
        864.4051513671875
      ],
      [
        -781.7940673828125,
        -2251.306396484375,
        864.3192749023438
      ],
      [
        -775.0046997070312,
        -2297.716796875,
        1402.14111328125
      ],
      [
        -762.6567993164062,
        -2311.351806640625,
        1060.670166015625
      ],
      [
        -752.1456298828125,
        -2319.727783203125,
        867.2225341796875
      ],
      [
        -773.8370971679688,
        -2260.1357421875,
        864.093994140625
      ],
      [
        546.5700073242188,
        -2518.948486328125,
        699.5957641601562
      ],
      [
        533.9306640625,
        -2518.20263671875,
        701.3528442382812
      ],
      [
        -410.68377685546875,
        -2383.697021484375,
        846.5617065429688
      ],
      [
        -410.8484191894531,
        -2384.400634765625,
        824.4688110351562
      ],
      [
        -217.5,
        -2420.548095703125,
        815.0
      ],
      [
        -235.0,
        -2417.304931640625,
        815.0
      ],
      [
        -195.5,
        -2360.5,
        797.5
      ],
      [
        -210.5,
        -2360.5,
        797.5
      ],
      [
        -217.5,
        -2420.548095703125,
        815.0
      ],
      [
        -217.5,
        -2421.03857421875,
        800.2484130859375
      ],
      [
        -209.5,
        -2422.412841796875,
        803.5
      ],
      [
        -213.6124267578125,
        -2421.775146484375,
        799.7614135742188
      ],
      [
        -195.5,
        -2425.20703125,
        797.5
      ],
      [
        -195.55975341796875,
        -2425.196044921875,
        797.5
      ],
      [
        -195.5,
        -2425.20703125,
        797.5
      ],
      [
        -195.5,
        -2425.207275390625,
        797.4924926757812
      ],
      [
        -235.0,
        -2417.304931640625,
        815.0
      ],
      [
        -235.0,
        -2417.722412109375,
        802.4406127929688
      ],
      [
        192.06858825683594,
        -2496.407958984375,
        816.3604736328125
      ],
      [
        182.40977478027344,
        -2497.27294921875,
        757.8363037109375
      ],
      [
        -765.3306274414062,
        -2315.517578125,
        1257.8922119140625
      ],
      [
        -771.4268188476562,
        -2307.923095703125,
        1411.5374755859375
      ],
      [
        -743.9637451171875,
        -2325.078125,
        1118.72021484375
      ],
      [
        -730.3872680664062,
        -2338.170166015625,
        866.0056762695312
      ],
      [
        -765.3306274414062,
        -2315.517578125,
        1257.8922119140625
      ],
      [
        -743.9637451171875,
        -2325.078125,
        1118.72021484375
      ],
      [
        -394.64996337890625,
        -2394.941162109375,
        867.16455078125
      ],
      [
        -394.2513122558594,
        -2396.87890625,
        823.3731079101562
      ],
      [
        182.40977478027344,
        -2497.27294921875,
        757.8362426757812
      ],
      [
        182.11636352539062,
        -2497.438232421875,
        750.2604370117188
      ],
      [
        -235.0,
        -2424.1884765625,
        815.0
      ],
      [
        -230.2054443359375,
        -2425.0,
        815.0
      ],
      [
        -231.81393432617188,
        -2425.0,
        808.6278686523438
      ],
      [
        -233.24667358398438,
        -2425.0,
        802.9528198242188
      ],
      [
        -230.2054443359375,
        -2425.0,
        815.0
      ],
      [
        -231.81393432617188,
        -2425.0,
        808.6278686523438
      ],
      [
        -225.0,
        -2426.308349609375,
        805.0
      ],
      [
        -230.0,
        -2425.4619140625,
        805.0
      ],
      [
        -225.0,
        -2426.4404296875,
        801.9068603515625
      ],
      [
        -225.0,
        -2426.308349609375,
        805.0
      ],
      [
        -230.0,
        -2425.4619140625,
        805.0
      ],
      [
        -230.0,
        -2425.56689453125,
        802.541015625
      ],
      [
        -235.0,
        -2424.1884765625,
        815.0
      ],
      [
        -235.0,
        -2424.69384765625,
        803.1751708984375
      ],
      [
        -665.3473510742188,
        -2437.622802734375,
        1276.7486572265625
      ],
      [
        -650.2114868164062,
        -2448.3134765625,
        865.966796875
      ],
      [
        -698.2745361328125,
        -2408.3671875,
        1479.6412353515625
      ],
      [
        -680.15087890625,
        -2432.476806640625,
        1457.0142822265625
      ],
      [
        -665.3473510742188,
        -2437.622802734375,
        1276.7486572265625
      ],
      [
        -682.7564697265625,
        -2431.766357421875,
        1480.5965576171875
      ],
      [
        -680.15087890625,
        -2432.476806640625,
        1457.0142822265625
      ],
      [
        -732.7147216796875,
        -2333.08203125,
        1138.888427734375
      ],
      [
        -732.7147216796875,
        -2333.08203125,
        1138.888427734375
      ],
      [
        -733.7012939453125,
        -2332.134033203125,
        1156.9888916015625
      ],
      [
        -733.44970703125,
        -2333.139892578125,
        1178.7537841796875
      ],
      [
        -733.7510986328125,
        -2332.292724609375,
        1165.0408935546875
      ],
      [
        -733.7510986328125,
        -2332.292724609375,
        1165.040771484375
      ],
      [
        -733.7012939453125,
        -2332.134033203125,
        1156.9888916015625
      ],
      [
        -733.44970703125,
        -2333.139892578125,
        1178.7537841796875
      ],
      [
        -767.23583984375,
        -2313.14404296875,
        1305.910888671875
      ],
      [
        -261.09228515625,
        -2467.271484375,
        811.450927734375
      ],
      [
        -197.00942993164062,
        -2461.5,
        804.0
      ],
      [
        -195.8740692138672,
        -2461.5,
        801.370849609375
      ],
      [
        -198.5,
        -2461.641357421875,
        804.0
      ],
      [
        -200.0576934814453,
        -2461.870361328125,
        802.0175170898438
      ],
      [
        -198.5,
        -2461.641357421875,
        804.0
      ],
      [
        -197.00942993164062,
        -2461.5,
        804.0
      ],
      [
        -241.98291015625,
        -2471.127197265625,
        862.629638671875
      ],
      [
        -238.65765380859375,
        -2472.60400390625,
        808.7545166015625
      ],
      [
        -241.98291015625,
        -2471.127197265625,
        862.629638671875
      ],
      [
        -251.7679443359375,
        -2471.830078125,
        810.5770263671875
      ],
      [
        -198.5,
        -2474.9541015625,
        804.0
      ],
      [
        -191.5,
        -2475.343994140625,
        804.0
      ],
      [
        -191.5,
        -2475.343994140625,
        804.0
      ],
      [
        -191.5,
        -2475.38720703125,
        802.1988525390625
      ],
      [
        -198.5,
        -2474.9541015625,
        804.0
      ],
      [
        -199.08656311035156,
        -2474.939208984375,
        803.2534790039062
      ],
      [
        -138.0,
        -2478.035400390625,
        816.0
      ],
      [
        -144.0,
        -2477.701416015625,
        816.0
      ],
      [
        -144.0,
        -2477.665283203125,
        817.5
      ],
      [
        -138.0,
        -2477.99951171875,
        817.5
      ],
      [
        -138.0,
        -2477.99951171875,
        817.5
      ],
      [
        -138.0,
        -2478.035400390625,
        816.0
      ],
      [
        -144.0,
        -2477.701416015625,
        816.0
      ],
      [
        -144.0,
        -2477.665283203125,
        817.5
      ],
      [
        547.6314086914062,
        -2519.44775390625,
        699.4942016601562
      ],
      [
        1765.1552734375,
        -3709.990234375,
        1201.9404296875
      ],
      [
        1727.3623046875,
        -3755.18798828125,
        682.8560791015625
      ],
      [
        1678.6641845703125,
        -3877.904296875,
        1660.62744140625
      ],
      [
        1797.7379150390625,
        -3671.24169921875,
        1655.0189208984375
      ],
      [
        1771.896240234375,
        -3701.942626953125,
        1288.141357421875
      ],
      [
        1771.4212646484375,
        -3702.49658203125,
        1288.010498046875
      ],
      [
        1765.1552734375,
        -3709.990234375,
        1201.9404296875
      ],
      [
        1771.896240234375,
        -3701.942626953125,
        1288.141357421875
      ],
      [
        1678.6641845703125,
        -3877.904296875,
        1660.62744140625
      ],
      [
        1675.942626953125,
        -3883.381103515625,
        1680.0
      ],
      [
        1727.3623046875,
        -3755.18798828125,
        682.8561401367188
      ],
      [
        1706.7816162109375,
        -3778.021240234375,
        1207.3966064453125
      ],
      [
        1252.9141845703125,
        -4306.802734375,
        1328.07421875
      ],
      [
        1252.9141845703125,
        -4306.802734375,
        1328.07421875
      ],
      [
        1269.7293701171875,
        -4287.13525390625,
        1358.498291015625
      ],
      [
        1636.295166015625,
        -3859.893310546875,
        1338.7508544921875
      ],
      [
        1654.0455322265625,
        -3839.280517578125,
        1303.609619140625
      ],
      [
        1496.001220703125,
        -4022.9189453125,
        1568.70751953125
      ],
      [
        1383.4669189453125,
        -4154.10400390625,
        1564.2860107421875
      ],
      [
        1664.4010009765625,
        -3827.30908203125,
        1258.5145263671875
      ],
      [
        1708.9287109375,
        -3784.619873046875,
        1249.7352294921875
      ],
      [
        1675.306640625,
        -3814.59033203125,
        1261.520263671875
      ],
      [
        1664.4010009765625,
        -3827.30908203125,
        1258.5145263671875
      ],
      [
        1692.298095703125,
        -3794.8583984375,
        1227.87939453125
      ],
      [
        1701.264892578125,
        -3785.8525390625,
        1218.6199951171875
      ],
      [
        1701.264892578125,
        -3785.8525390625,
        1218.6199951171875
      ],
      [
        1707.4495849609375,
        -3778.875,
        1207.610595703125
      ],
      [
        1496.0010986328125,
        -4022.9189453125,
        1568.70751953125
      ],
      [
        1515.475830078125,
        -4000.1982421875,
        1577.947021484375
      ],
      [
        1636.295166015625,
        -3859.893310546875,
        1338.7509765625
      ],
      [
        1543.9288330078125,
        -3967.00244140625,
        1591.4462890625
      ],
      [
        1543.9288330078125,
        -3967.00244140625,
        1591.4462890625
      ],
      [
        1654.0455322265625,
        -3839.280517578125,
        1303.609619140625
      ],
      [
        1698.7310791015625,
        -3786.952880859375,
        1412.5794677734375
      ],
      [
        1709.8927001953125,
        -3823.70458984375,
        1659.156494140625
      ],
      [
        1704.3438720703125,
        -3780.7255859375,
        1269.523193359375
      ],
      [
        1700.344482421875,
        -3785.498779296875,
        1219.0433349609375
      ],
      [
        1700.344482421875,
        -3785.498779296875,
        1219.04345703125
      ],
      [
        1706.7816162109375,
        -3778.021240234375,
        1207.396728515625
      ],
      [
        1373.6864013671875,
        -4165.50537109375,
        1563.9017333984375
      ],
      [
        1269.7293701171875,
        -4287.13525390625,
        1358.498291015625
      ],
      [
        1373.6865234375,
        -4165.50537109375,
        1563.9017333984375
      ],
      [
        1043.6417236328125,
        -4549.78515625,
        1761.0574951171875
      ],
      [
        1797.6087646484375,
        -3671.165283203125,
        1653.70166015625
      ],
      [
        1771.4212646484375,
        -3702.49658203125,
        1288.010498046875
      ],
      [
        1787.1900634765625,
        -3676.04736328125,
        1310.715087890625
      ],
      [
        1676.256591796875,
        -3739.0,
        1197.62109375
      ],
      [
        1699.3291015625,
        -3725.75537109375,
        743.0841064453125
      ],
      [
        1566.2449951171875,
        -3878.915771484375,
        1269.789306640625
      ],
      [
        1513.16650390625,
        -3942.123291015625,
        1421.9434814453125
      ],
      [
        1249.8150634765625,
        -4288.96484375,
        1269.789306640625
      ],
      [
        1350.5107421875,
        -4152.73876953125,
        1426.417724609375
      ],
      [
        1513.16650390625,
        -3942.123291015625,
        1421.943603515625
      ],
      [
        1403.209716796875,
        -4085.14697265625,
        1407.345458984375
      ],
      [
        1699.3291015625,
        -3725.75537109375,
        743.0841064453125
      ],
      [
        1702.236572265625,
        -3725.074462890625,
        658.838134765625
      ],
      [
        1666.443603515625,
        -3824.93310546875,
        1256.271484375
      ],
      [
        1665.51171875,
        -3826.013671875,
        1258.8206787109375
      ],
      [
        1403.209716796875,
        -4085.14697265625,
        1407.345458984375
      ],
      [
        1350.5107421875,
        -4152.73876953125,
        1426.417724609375
      ],
      [
        1012.7789916992188,
        -4578.0556640625,
        1763.11181640625
      ],
      [
        1694.231201171875,
        -3772.135986328125,
        1313.169677734375
      ],
      [
        1698.7310791015625,
        -3786.952880859375,
        1412.5794677734375
      ],
      [
        1694.231201171875,
        -3772.135986328125,
        1313.169677734375
      ],
      [
        1704.3438720703125,
        -3780.7255859375,
        1269.523193359375
      ],
      [
        1679.88720703125,
        -3777.63720703125,
        1228.45458984375
      ],
      [
        1679.88720703125,
        -3777.63720703125,
        1228.4547119140625
      ],
      [
        1689.1883544921875,
        -3755.53125,
        1201.7625732421875
      ],
      [
        1627.5845947265625,
        -3799.42822265625,
        1269.789306640625
      ],
      [
        1566.2449951171875,
        -3878.915771484375,
        1269.789306640625
      ],
      [
        1627.584716796875,
        -3799.428466796875,
        1269.789306640625
      ],
      [
        1653.150390625,
        -3767.3623046875,
        1240.7547607421875
      ],
      [
        1653.150390625,
        -3767.3623046875,
        1240.7548828125
      ],
      [
        1676.256591796875,
        -3739.0,
        1197.6212158203125
      ],
      [
        217.53436279296875,
        -2503.37060546875,
        745.7415771484375
      ],
      [
        212.83778381347656,
        -2502.583984375,
        746.3408203125
      ],
      [
        547.9561767578125,
        -2519.6005859375,
        699.463134765625
      ],
      [
        -657.9453125,
        -2448.8642578125,
        1283.4403076171875
      ],
      [
        -641.55224609375,
        -2461.506591796875,
        875.2473754882812
      ],
      [
        -641.55224609375,
        -2461.506591796875,
        875.2473754882812
      ],
      [
        -641.1875,
        -2461.79052734375,
        866.076171875
      ],
      [
        -671.77001953125,
        -2443.513427734375,
        1445.6971435546875
      ],
      [
        -657.9453125,
        -2448.8642578125,
        1283.4403076171875
      ],
      [
        -675.7212524414062,
        -2442.319091796875,
        1480.5965576171875
      ],
      [
        -671.77001953125,
        -2443.513427734375,
        1445.6971435546875
      ],
      [
        -140.0,
        -2485.567626953125,
        816.0
      ],
      [
        -140.0,
        -2486.155517578125,
        795.8539428710938
      ],
      [
        -142.0,
        -2485.478759765625,
        816.0
      ],
      [
        -142.0,
        -2486.058349609375,
        796.1341552734375
      ],
      [
        -142.0,
        -2485.0,
        816.0
      ],
      [
        -142.0,
        -2485.478515625,
        816.0
      ],
      [
        -140.0,
        -2485.567626953125,
        816.0
      ],
      [
        -140.0,
        -2485.0,
        816.0
      ],
      [
        -140.0,
        -2485.0,
        817.5
      ],
      [
        -140.0,
        -2485.52392578125,
        817.5
      ],
      [
        -142.0,
        -2485.43505859375,
        817.5
      ],
      [
        -142.0,
        -2485.0,
        817.5
      ],
      [
        -142.0,
        -2477.77685546875,
        817.5
      ],
      [
        -140.0,
        -2477.88818359375,
        817.5
      ],
      [
        -140.0,
        -2477.924072265625,
        816.0
      ],
      [
        -142.0,
        -2477.812744140625,
        816.0
      ],
      [
        -191.5,
        -2483.624755859375,
        804.0
      ],
      [
        -198.1400146484375,
        -2483.3291015625,
        804.0
      ],
      [
        -191.5,
        -2483.624755859375,
        804.0
      ],
      [
        -191.5,
        -2483.652099609375,
        803.0697021484375
      ],
      [
        -164.0,
        -2484.4990234375,
        816.0
      ],
      [
        -170.0,
        -2484.23193359375,
        816.0
      ],
      [
        -144.0,
        -2485.3896484375,
        816.0
      ],
      [
        -170.0,
        -2484.188232421875,
        817.5
      ],
      [
        -164.0,
        -2484.455322265625,
        817.5
      ],
      [
        -144.0,
        -2485.345947265625,
        817.5
      ],
      [
        -144.0,
        -2485.3896484375,
        816.0
      ],
      [
        -144.0,
        -2485.345947265625,
        817.5
      ],
      [
        -164.0,
        -2484.455322265625,
        817.5
      ],
      [
        -164.0,
        -2484.4990234375,
        816.0
      ],
      [
        -170.0,
        -2484.23193359375,
        816.0
      ],
      [
        -170.0,
        -2484.188232421875,
        817.5
      ],
      [
        -138.0,
        -2485.65673828125,
        816.0
      ],
      [
        -138.0,
        -2485.613037109375,
        817.5
      ],
      [
        -138.0,
        -2485.613037109375,
        817.5
      ],
      [
        -138.0,
        -2485.65673828125,
        816.0
      ],
      [
        -485.34185791015625,
        -2976.867431640625,
        1285.45166015625
      ],
      [
        -548.6903686523438,
        -2914.067626953125,
        1346.0098876953125
      ],
      [
        131.10858154296875,
        -3642.2841796875,
        1557.621337890625
      ],
      [
        239.99160766601562,
        -3781.800048828125,
        1741.628173828125
      ],
      [
        115.55072021484375,
        -3635.988037109375,
        1702.0457763671875
      ],
      [
        172.2946319580078,
        -3634.683349609375,
        871.5138549804688
      ],
      [
        -458.80450439453125,
        -2947.761474609375,
        1328.684326171875
      ],
      [
        -532.1365356445312,
        -2869.818359375,
        1405.2808837890625
      ],
      [
        -430.1038818359375,
        -2916.282958984375,
        1375.4412841796875
      ],
      [
        -527.7708129882812,
        -2858.148681640625,
        1420.9122314453125
      ],
      [
        -426.1293640136719,
        -2911.923828125,
        1381.916259765625
      ],
      [
        -526.5921630859375,
        -2854.998046875,
        1425.1324462890625
      ],
      [
        -418.0727844238281,
        -2903.08740234375,
        1395.0413818359375
      ],
      [
        -518.608642578125,
        -2833.657958984375,
        1453.7174072265625
      ],
      [
        -306.4403381347656,
        -2983.164306640625,
        1431.2838134765625
      ],
      [
        -234.29946899414062,
        -3017.273681640625,
        865.5111694335938
      ],
      [
        -417.92596435546875,
        -2902.92626953125,
        1395.280517578125
      ],
      [
        -518.491943359375,
        -2833.345947265625,
        1454.1353759765625
      ],
      [
        -306.5947570800781,
        -2982.995849609375,
        1431.2254638671875
      ],
      [
        -490.27947998046875,
        -2852.865966796875,
        1437.6243896484375
      ],
      [
        -502.12994384765625,
        -2816.757568359375,
        1479.110595703125
      ],
      [
        -502.12994384765625,
        -2816.757568359375,
        1479.110595703125
      ],
      [
        -482.4688415527344,
        -2858.27001953125,
        1433.0533447265625
      ],
      [
        -495.6846008300781,
        -2819.032470703125,
        1478.0430908203125
      ],
      [
        -495.6846008300781,
        -2819.032470703125,
        1478.0430908203125
      ],
      [
        -479.3180236816406,
        -2860.449951171875,
        1431.2093505859375
      ],
      [
        -477.76031494140625,
        -2825.358642578125,
        1475.0743408203125
      ],
      [
        -402.65911865234375,
        -2886.181640625,
        1420.152099609375
      ],
      [
        -477.76031494140625,
        -2825.358642578125,
        1475.0743408203125
      ],
      [
        -467.463623046875,
        -2820.6962890625,
        1405.229248046875
      ],
      [
        -458.1455383300781,
        -2820.93603515625,
        1363.39306640625
      ],
      [
        -467.463623046875,
        -2820.6962890625,
        1405.229248046875
      ],
      [
        -420.0225524902344,
        -2845.73681640625,
        1465.511474609375
      ],
      [
        -391.74853515625,
        -2874.215087890625,
        1437.9267578125
      ],
      [
        -430.2678527832031,
        -2830.660888671875,
        1347.227294921875
      ],
      [
        -424.3450622558594,
        -2839.9580078125,
        1431.2955322265625
      ],
      [
        -420.02252197265625,
        -2845.73681640625,
        1465.511474609375
      ],
      [
        -424.3450622558594,
        -2839.9580078125,
        1431.2955322265625
      ],
      [
        -341.54644775390625,
        -2935.67578125,
        1375.4600830078125
      ],
      [
        -350.9110412597656,
        -2919.97998046875,
        1392.35009765625
      ],
      [
        -351.9558410644531,
        -2913.74560546875,
        1384.2762451171875
      ],
      [
        -355.0424499511719,
        -2911.1865234375,
        1402.115478515625
      ],
      [
        -351.9558410644531,
        -2913.74560546875,
        1384.2762451171875
      ],
      [
        -350.9110412597656,
        -2919.97998046875,
        1392.35009765625
      ],
      [
        -360.3669128417969,
        -2906.77197265625,
        1432.8883056640625
      ],
      [
        -423.2957458496094,
        -2833.093017578125,
        1343.184326171875
      ],
      [
        -418.51580810546875,
        -2842.56201171875,
        1434.8194580078125
      ],
      [
        -352.0572509765625,
        -2913.140380859375,
        1383.4925537109375
      ],
      [
        -415.390380859375,
        -2847.37158203125,
        1464.7442626953125
      ],
      [
        -390.809814453125,
        -2873.185546875,
        1439.4560546875
      ],
      [
        -415.3903503417969,
        -2847.37158203125,
        1464.7442626953125
      ],
      [
        -418.51580810546875,
        -2842.56201171875,
        1434.8194580078125
      ],
      [
        -360.6916809082031,
        -2905.960205078125,
        1433.3387451171875
      ],
      [
        -352.0572509765625,
        -2913.140380859375,
        1383.4925537109375
      ],
      [
        -356.8445739746094,
        -2653.39501953125,
        856.48974609375
      ],
      [
        -352.09356689453125,
        -2658.112548828125,
        844.7754516601562
      ],
      [
        -356.8445739746094,
        -2653.39501953125,
        856.48974609375
      ],
      [
        -359.39111328125,
        -2648.854736328125,
        844.85986328125
      ],
      [
        328.0792236328125,
        -3776.214599609375,
        1518.7890625
      ],
      [
        335.708251953125,
        -3760.00537109375,
        1080.6446533203125
      ],
      [
        330.9205017089844,
        -3796.41357421875,
        1757.6214599609375
      ],
      [
        328.59930419921875,
        -3784.984130859375,
        1640.2244873046875
      ],
      [
        328.0792236328125,
        -3776.214599609375,
        1518.7890625
      ],
      [
        328.59930419921875,
        -3784.984130859375,
        1640.2244873046875
      ],
      [
        335.7083435058594,
        -3760.00537109375,
        1080.64501953125
      ],
      [
        337.63714599609375,
        -3748.705322265625,
        859.5145263671875
      ],
      [
        582.6322631835938,
        -3843.89892578125,
        833.9629516601562
      ],
      [
        578.5888061523438,
        -3848.79638671875,
        923.2786865234375
      ],
      [
        578.5892333984375,
        -3848.796630859375,
        923.27685546875
      ],
      [
        427.02386474609375,
        -3811.61572265625,
        1771.9530029296875
      ],
      [
        372.306640625,
        -3796.810302734375,
        1698.7210693359375
      ],
      [
        426.9809875488281,
        -3811.851806640625,
        1774.517333984375
      ],
      [
        330.1453552246094,
        -3792.596923828125,
        1718.41796875
      ],
      [
        372.306640625,
        -3796.810302734375,
        1698.7210693359375
      ],
      [
        427.02386474609375,
        -3811.61572265625,
        1771.9530029296875
      ],
      [
        717.0300903320312,
        -4014.394775390625,
        832.4083251953125
      ],
      [
        720.0778198242188,
        -4018.57470703125,
        832.4061279296875
      ],
      [
        554.5967407226562,
        -3918.78564453125,
        1817.6278076171875
      ],
      [
        431.4535217285156,
        -3806.322265625,
        1687.0391845703125
      ],
      [
        -277.6770324707031,
        -2673.25390625,
        885.4474487304688
      ],
      [
        -281.7960510253906,
        -2667.673095703125,
        885.4474487304688
      ],
      [
        -270.802978515625,
        -2682.567626953125,
        885.4474487304688
      ],
      [
        -277.6770324707031,
        -2673.25390625,
        885.4474487304688
      ],
      [
        -253.76882934570312,
        -2705.64697265625,
        885.4474487304688
      ],
      [
        -270.802978515625,
        -2682.567626953125,
        885.4474487304688
      ],
      [
        -281.7960510253906,
        -2667.673095703125,
        885.4474487304688
      ],
      [
        -282.3660583496094,
        -2660.30322265625,
        834.8795166015625
      ],
      [
        -248.13571166992188,
        -2710.77294921875,
        866.2379760742188
      ],
      [
        -241.3089599609375,
        -2715.917724609375,
        834.7764892578125
      ],
      [
        -253.76882934570312,
        -2705.64697265625,
        885.4474487304688
      ],
      [
        -248.13571166992188,
        -2710.77294921875,
        866.2379760742188
      ],
      [
        675.9293212890625,
        -3595.44775390625,
        846.2713623046875
      ],
      [
        659.6268920898438,
        -3571.96337890625,
        1021.3223266601562
      ],
      [
        643.696044921875,
        -3313.746337890625,
        888.9113159179688
      ],
      [
        631.365478515625,
        -3328.055419921875,
        1062.68310546875
      ],
      [
        628.440673828125,
        -3333.72119140625,
        1106.8314208984375
      ],
      [
        619.492919921875,
        -3352.686767578125,
        1243.9998779296875
      ],
      [
        468.0013427734375,
        -3286.90576171875,
        1269.789306640625
      ],
      [
        497.7791748046875,
        -3300.689697265625,
        1269.789306640625
      ],
      [
        497.7791748046875,
        -3300.689697265625,
        1269.789306640625
      ],
      [
        618.569580078125,
        -3363.663818359375,
        1269.789306640625
      ],
      [
        626.9627685546875,
        -3445.623046875,
        1269.789306640625
      ],
      [
        630.8406982421875,
        -3483.491455078125,
        1269.789306640625
      ],
      [
        626.9627685546875,
        -3445.623046875,
        1269.789306640625
      ],
      [
        633.9680786132812,
        -3499.441650390625,
        1250.9715576171875
      ],
      [
        640.5079956054688,
        -3530.7392578125,
        1208.9666748046875
      ],
      [
        675.9293212890625,
        -3595.44775390625,
        846.2713623046875
      ],
      [
        680.53076171875,
        -3599.88330078125,
        794.0338745117188
      ],
      [
        643.696044921875,
        -3313.746337890625,
        888.9113159179688
      ],
      [
        653.3914794921875,
        -3314.6220703125,
        767.9185791015625
      ],
      [
        630.8406982421875,
        -3483.491455078125,
        1269.789306640625
      ],
      [
        633.9680786132812,
        -3499.441650390625,
        1250.9715576171875
      ],
      [
        618.569580078125,
        -3363.663818359375,
        1269.789306640625
      ],
      [
        619.492919921875,
        -3352.686767578125,
        1243.9998779296875
      ],
      [
        628.440673828125,
        -3333.72119140625,
        1106.8314208984375
      ],
      [
        631.365478515625,
        -3328.055419921875,
        1062.68310546875
      ],
      [
        597.0,
        -3458.0,
        1269.789306640625
      ],
      [
        599.0,
        -3458.0,
        1269.789306640625
      ],
      [
        623.0,
        -3458.0,
        1269.789306640625
      ],
      [
        625.0,
        -3458.0,
        1269.789306640625
      ],
      [
        623.0,
        -3458.0,
        1269.789306640625
      ],
      [
        623.0,
        -3460.0,
        1269.789306640625
      ],
      [
        623.0,
        -3460.0,
        1269.789306640625
      ],
      [
        625.0,
        -3460.0,
        1269.789306640625
      ],
      [
        625.0,
        -3460.0,
        1269.789306640625
      ],
      [
        625.0,
        -3458.0,
        1269.789306640625
      ],
      [
        597.0,
        -3458.0,
        1269.789306640625
      ],
      [
        597.0,
        -3460.0,
        1269.789306640625
      ],
      [
        597.0,
        -3460.0,
        1269.789306640625
      ],
      [
        599.0,
        -3460.0,
        1269.789306640625
      ],
      [
        599.0,
        -3460.0,
        1269.789306640625
      ],
      [
        599.0,
        -3458.0,
        1269.789306640625
      ],
      [
        623.0,
        -3425.0,
        1269.789306640625
      ],
      [
        623.0,
        -3427.0,
        1269.789306640625
      ],
      [
        623.0,
        -3427.0,
        1269.789306640625
      ],
      [
        625.0,
        -3427.0,
        1269.789306640625
      ],
      [
        623.0,
        -3425.0,
        1269.789306640625
      ],
      [
        624.8737182617188,
        -3425.0,
        1269.5
      ],
      [
        624.8507690429688,
        -3425.0,
        1269.789306640625
      ],
      [
        625.0,
        -3427.0,
        1269.789306640625
      ],
      [
        625.0,
        -3426.457275390625,
        1269.789306640625
      ],
      [
        625.0,
        -3426.23291015625,
        1269.5
      ],
      [
        597.0,
        -3425.0,
        1269.789306640625
      ],
      [
        597.0,
        -3427.0,
        1269.789306640625
      ],
      [
        597.0,
        -3425.0,
        1269.789306640625
      ],
      [
        599.0,
        -3425.0,
        1269.789306640625
      ],
      [
        597.0,
        -3427.0,
        1269.789306640625
      ],
      [
        599.0,
        -3427.0,
        1269.789306640625
      ],
      [
        599.0,
        -3427.0,
        1269.789306640625
      ],
      [
        599.0,
        -3425.0,
        1269.789306640625
      ],
      [
        581.5094604492188,
        -3272.55126953125,
        773.9254150390625
      ],
      [
        602.0,
        -3465.82666015625,
        1290.5
      ],
      [
        594.0,
        -3459.33203125,
        1290.5
      ],
      [
        622.7457275390625,
        -3420.5,
        1290.5
      ],
      [
        628.1732788085938,
        -3473.5,
        1290.5
      ],
      [
        602.0,
        -3466.8583984375,
        1288.0
      ],
      [
        594.0,
        -3460.36376953125,
        1288.0
      ],
      [
        628.3717651367188,
        -3473.5,
        1288.0
      ],
      [
        622.9442138671875,
        -3420.5,
        1288.0
      ],
      [
        628.1732788085938,
        -3473.5,
        1290.5
      ],
      [
        628.3717651367188,
        -3473.5,
        1288.0
      ],
      [
        622.9442138671875,
        -3420.5,
        1288.0
      ],
      [
        622.7457275390625,
        -3420.5,
        1290.5
      ],
      [
        602.0,
        -3466.8583984375,
        1288.0
      ],
      [
        602.0,
        -3465.82666015625,
        1290.5
      ],
      [
        594.0,
        -3459.331787109375,
        1290.5
      ],
      [
        594.0,
        -3460.36376953125,
        1288.0
      ],
      [
        623.405029296875,
        -3425.0,
        1288.0
      ],
      [
        623.6098022460938,
        -3427.0,
        1288.0
      ],
      [
        625.0,
        -3427.0,
        1270.4896240234375
      ],
      [
        625.0,
        -3427.0,
        1270.4896240234375
      ],
      [
        475.2145690917969,
        -3300.977783203125,
        1286.167236328125
      ],
      [
        475.89849853515625,
        -3299.09814453125,
        1286.0291748046875
      ],
      [
        473.3350524902344,
        -3300.29345703125,
        1283.468505859375
      ],
      [
        475.2145690917969,
        -3300.977783203125,
        1286.167236328125
      ],
      [
        475.89849853515625,
        -3299.09814453125,
        1286.0291748046875
      ],
      [
        474.0192565917969,
        -3298.414306640625,
        1283.3314208984375
      ],
      [
        473.3350524902344,
        -3300.29345703125,
        1283.468505859375
      ],
      [
        474.0192565917969,
        -3298.414306640625,
        1283.3314208984375
      ],
      [
        474.0194091796875,
        -3298.414306640625,
        1272.5
      ],
      [
        475.89849853515625,
        -3299.09814453125,
        1272.5
      ],
      [
        475.214599609375,
        -3300.977783203125,
        1272.5
      ],
      [
        473.3350524902344,
        -3300.29345703125,
        1272.5
      ],
      [
        473.54931640625,
        -3298.2431640625,
        1272.5
      ],
      [
        472.8653564453125,
        -3300.12255859375,
        1272.5
      ],
      [
        471.92584228515625,
        -3299.7802734375,
        1270.0
      ],
      [
        472.6097106933594,
        -3297.9013671875,
        1270.0
      ],
      [
        472.8653564453125,
        -3300.12255859375,
        1272.5
      ],
      [
        473.54931640625,
        -3298.2431640625,
        1272.5
      ],
      [
        476.0694580078125,
        -3298.628173828125,
        1272.5
      ],
      [
        476.4112854003906,
        -3297.6884765625,
        1270.0
      ],
      [
        476.0694580078125,
        -3298.628173828125,
        1272.5
      ],
      [
        474.70159912109375,
        -3302.387451171875,
        1270.0
      ],
      [
        475.0435485839844,
        -3301.44775390625,
        1272.5
      ],
      [
        475.0435485839844,
        -3301.44775390625,
        1272.5
      ],
      [
        623.2128295898438,
        -3427.0,
        1293.0
      ],
      [
        623.0,
        -3427.0,
        1295.68115234375
      ],
      [
        599.0,
        -3427.0,
        1293.0
      ],
      [
        597.0,
        -3427.0,
        1293.0
      ],
      [
        597.0,
        -3425.0,
        1293.0
      ],
      [
        599.0,
        -3425.0,
        1293.0
      ],
      [
        597.0,
        -3427.0,
        1324.0
      ],
      [
        599.0,
        -3427.0,
        1324.0
      ],
      [
        599.0,
        -3425.0,
        1324.0
      ],
      [
        597.0,
        -3425.0,
        1324.0
      ],
      [
        596.5,
        -3425.0,
        1293.0
      ],
      [
        596.5,
        -3427.0,
        1293.0
      ],
      [
        595.5,
        -3427.0,
        1290.5
      ],
      [
        595.5,
        -3425.0,
        1290.5
      ],
      [
        596.5,
        -3427.0,
        1293.0
      ],
      [
        596.5,
        -3425.0,
        1293.0
      ],
      [
        595.0,
        -3425.0,
        1324.0
      ],
      [
        595.0,
        -3427.0,
        1324.0
      ],
      [
        595.0,
        -3425.0,
        1325.5
      ],
      [
        595.0,
        -3427.0,
        1325.5
      ],
      [
        595.0,
        -3427.0,
        1324.0
      ],
      [
        595.0,
        -3425.0,
        1324.0
      ],
      [
        599.0,
        -3417.5,
        1324.0
      ],
      [
        599.0,
        -3417.5,
        1324.0
      ],
      [
        599.0,
        -3417.5,
        1325.5
      ],
      [
        599.0,
        -3424.5,
        1293.0
      ],
      [
        599.0,
        -3423.5,
        1290.5
      ],
      [
        599.0,
        -3424.5,
        1293.0
      ],
      [
        601.0,
        -3427.0,
        1324.0
      ],
      [
        601.0,
        -3427.0,
        1325.5
      ],
      [
        601.0,
        -3427.0,
        1324.0
      ],
      [
        600.5,
        -3427.0,
        1290.5
      ],
      [
        599.5,
        -3427.0,
        1293.0
      ],
      [
        599.5,
        -3427.0,
        1293.0
      ],
      [
        623.0529174804688,
        -3423.5,
        1290.5
      ],
      [
        622.9568481445312,
        -3424.5,
        1293.0
      ],
      [
        622.9568481445312,
        -3424.5,
        1293.0
      ],
      [
        623.2128295898438,
        -3427.0,
        1293.0
      ],
      [
        622.5,
        -3427.0,
        1293.0
      ],
      [
        622.5,
        -3427.0,
        1293.0
      ],
      [
        621.5,
        -3427.0,
        1290.5
      ],
      [
        623.0,
        -3425.0,
        1293.1011962890625
      ],
      [
        623.0,
        -3427.0,
        1295.68115234375
      ],
      [
        623.008056640625,
        -3425.0,
        1293.0
      ],
      [
        623.0,
        -3425.0,
        1293.1011962890625
      ],
      [
        624.1311645507812,
        -3460.0,
        1324.0
      ],
      [
        625.0,
        -3460.0,
        1313.05615234375
      ],
      [
        625.0,
        -3458.0,
        1310.4761962890625
      ],
      [
        623.9263305664062,
        -3458.0,
        1324.0
      ],
      [
        625.0,
        -3460.0,
        1313.05615234375
      ],
      [
        625.0,
        -3458.0,
        1310.4761962890625
      ],
      [
        625.0,
        -3460.0,
        1293.0
      ],
      [
        623.0,
        -3460.0,
        1293.0
      ],
      [
        623.0,
        -3458.0,
        1293.0
      ],
      [
        625.0,
        -3458.0,
        1293.0
      ],
      [
        623.0,
        -3458.0,
        1324.0
      ],
      [
        623.0,
        -3460.0,
        1324.0
      ],
      [
        624.1311645507812,
        -3460.0,
        1324.0
      ],
      [
        623.9263305664062,
        -3458.0,
        1324.0
      ],
      [
        626.5,
        -3458.0,
        1290.5
      ],
      [
        626.5,
        -3460.0,
        1290.5
      ],
      [
        625.5,
        -3460.0,
        1293.0
      ],
      [
        625.5,
        -3458.0,
        1293.0
      ],
      [
        625.5,
        -3458.0,
        1293.0
      ],
      [
        625.5,
        -3460.0,
        1293.0
      ],
      [
        623.1583251953125,
        -3450.5,
        1324.0
      ],
      [
        623.0,
        -3450.5,
        1324.0
      ],
      [
        623.0,
        -3450.5,
        1324.0
      ],
      [
        623.1583251953125,
        -3450.5,
        1324.0
      ],
      [
        623.0392456054688,
        -3450.5,
        1325.5
      ],
      [
        623.0,
        -3450.5,
        1325.5
      ],
      [
        623.0,
        -3456.5,
        1290.5
      ],
      [
        626.432373046875,
        -3456.5,
        1290.5
      ],
      [
        626.4251708984375,
        -3456.57470703125,
        1290.68701171875
      ],
      [
        623.0,
        -3457.5,
        1293.0
      ],
      [
        626.5,
        -3457.160400390625,
        1290.5
      ],
      [
        626.4251708984375,
        -3456.57470703125,
        1290.68701171875
      ],
      [
        623.0,
        -3457.5,
        1293.0
      ],
      [
        623.0,
        -3427.5,
        1293.0
      ],
      [
        623.2640380859375,
        -3427.5,
        1293.0
      ],
      [
        623.56494140625,
        -3428.5,
        1290.5
      ],
      [
        623.0,
        -3428.5,
        1290.5
      ],
      [
        623.2640380859375,
        -3427.5,
        1293.0
      ],
      [
        623.0,
        -3427.5,
        1293.0
      ],
      [
        623.0,
        -3427.0,
        1293.0
      ],
      [
        623.0,
        -3467.5,
        1324.0
      ],
      [
        624.8992309570312,
        -3467.5,
        1324.0
      ],
      [
        623.0,
        -3467.5,
        1325.5
      ],
      [
        624.7801513671875,
        -3467.5,
        1325.5
      ],
      [
        624.8992309570312,
        -3467.5,
        1324.0
      ],
      [
        623.0,
        -3467.5,
        1324.0
      ],
      [
        623.0,
        -3460.5,
        1293.0
      ],
      [
        623.0,
        -3461.5,
        1290.5
      ],
      [
        623.0,
        -3460.5,
        1293.0
      ],
      [
        621.0,
        -3467.42578125,
        1324.0
      ],
      [
        621.0914916992188,
        -3467.5,
        1324.0
      ],
      [
        600.1514892578125,
        -3450.5,
        1324.0
      ],
      [
        601.0,
        -3451.188720703125,
        1324.0
      ],
      [
        621.0,
        -3429.424072265625,
        1324.0
      ],
      [
        621.5198364257812,
        -3434.5,
        1324.0
      ],
      [
        621.0,
        -3466.80615234375,
        1325.5
      ],
      [
        621.0,
        -3467.42578125,
        1324.0
      ],
      [
        621.0,
        -3430.5869140625,
        1325.5
      ],
      [
        621.0,
        -3429.424072265625,
        1324.0
      ],
      [
        621.854248046875,
        -3467.5,
        1325.5
      ],
      [
        621.0914916992188,
        -3467.5,
        1324.0
      ],
      [
        621.4006958007812,
        -3434.5,
        1325.5
      ],
      [
        621.5198364257812,
        -3434.5,
        1324.0
      ],
      [
        601.0,
        -3451.188720703125,
        1324.0
      ],
      [
        601.0,
        -3450.569580078125,
        1325.5
      ],
      [
        600.9141845703125,
        -3450.5,
        1325.5
      ],
      [
        600.1514892578125,
        -3450.5,
        1324.0
      ],
      [
        596.7098999023438,
        -3460.5,
        1293.0
      ],
      [
        596.5,
        -3460.32958984375,
        1293.0
      ],
      [
        596.5,
        -3460.32958984375,
        1293.0
      ],
      [
        595.5,
        -3460.54931640625,
        1290.5
      ],
      [
        596.6708984375,
        -3461.5,
        1290.5
      ],
      [
        596.7098999023438,
        -3460.5,
        1293.0
      ],
      [
        599.0,
        -3458.0,
        1303.56298828125
      ],
      [
        597.0,
        -3458.0,
        1299.62890625
      ],
      [
        599.0,
        -3460.0,
        1298.716796875
      ],
      [
        599.0,
        -3458.0,
        1303.56298828125
      ],
      [
        597.0,
        -3458.0,
        1299.62890625
      ],
      [
        597.0,
        -3460.0,
        1294.7825927734375
      ],
      [
        599.0,
        -3460.0,
        1298.716796875
      ],
      [
        597.0,
        -3460.0,
        1294.7825927734375
      ],
      [
        532.4071044921875,
        -3307.10595703125,
        1269.789306640625
      ],
      [
        471.142822265625,
        -3279.474853515625,
        1269.789306640625
      ],
      [
        505.0115966796875,
        -3294.75,
        1269.789306640625
      ],
      [
        505.0115966796875,
        -3294.75,
        1269.789306640625
      ],
      [
        532.4071044921875,
        -3307.10595703125,
        1269.789306640625
      ],
      [
        644.5982666015625,
        -3550.313720703125,
        1182.6954345703125
      ],
      [
        599.0,
        -3458.0,
        1315.776123046875
      ],
      [
        597.0,
        -3458.0,
        1312.5372314453125
      ],
      [
        594.0,
        -3472.634765625,
        1288.0
      ],
      [
        594.718505859375,
        -3473.5,
        1288.0
      ],
      [
        596.2626342773438,
        -3473.5,
        1290.5
      ],
      [
        594.0,
        -3470.775390625,
        1290.5
      ],
      [
        594.0,
        -3470.775390625,
        1290.5
      ],
      [
        594.0,
        -3472.634765625,
        1288.0
      ],
      [
        594.718505859375,
        -3473.5,
        1288.0
      ],
      [
        596.2626342773438,
        -3473.5,
        1290.5
      ],
      [
        599.0,
        -3460.0,
        1313.0867919921875
      ],
      [
        597.0,
        -3460.0,
        1309.84814453125
      ],
      [
        597.0,
        -3458.0,
        1312.5372314453125
      ],
      [
        597.0,
        -3460.0,
        1309.84814453125
      ],
      [
        599.0,
        -3460.0,
        1313.0867919921875
      ],
      [
        599.0,
        -3458.0,
        1315.776123046875
      ],
      [
        597.8502807617188,
        -3450.5,
        1324.0
      ],
      [
        601.0,
        -3454.292724609375,
        1324.0
      ],
      [
        601.0,
        -3454.292724609375,
        1324.0
      ],
      [
        601.0,
        -3453.177001953125,
        1325.5
      ],
      [
        598.776611328125,
        -3450.5,
        1325.5
      ],
      [
        597.8502807617188,
        -3450.5,
        1324.0
      ],
      [
        549.2824096679688,
        -3239.8798828125,
        1071.7427978515625
      ],
      [
        554.9752197265625,
        -3236.477783203125,
        1010.4617309570312
      ],
      [
        552.81494140625,
        -3269.5537109375,
        1079.65576171875
      ],
      [
        581.6201782226562,
        -3253.98388671875,
        771.9529418945312
      ],
      [
        521.4730834960938,
        -3302.174560546875,
        1269.789306640625
      ],
      [
        484.1070251464844,
        -3276.545654296875,
        1284.37939453125
      ],
      [
        484.7911376953125,
        -3274.666259765625,
        1284.2423095703125
      ],
      [
        482.2276916503906,
        -3275.861572265625,
        1281.681396484375
      ],
      [
        484.1070251464844,
        -3276.545654296875,
        1284.37939453125
      ],
      [
        484.7911376953125,
        -3274.666259765625,
        1284.2423095703125
      ],
      [
        482.91168212890625,
        -3273.982177734375,
        1281.5438232421875
      ],
      [
        482.2276916503906,
        -3275.861572265625,
        1281.6815185546875
      ],
      [
        482.91168212890625,
        -3273.982177734375,
        1281.5438232421875
      ],
      [
        506.8655090332031,
        -3205.48681640625,
        777.6998901367188
      ],
      [
        535.5631713867188,
        -3245.86376953125,
        1147.671142578125
      ],
      [
        535.5631713867188,
        -3245.86376953125,
        1147.671142578125
      ],
      [
        541.5631713867188,
        -3241.13134765625,
        1112.6033935546875
      ],
      [
        549.2824096679688,
        -3239.8798828125,
        1071.7427978515625
      ],
      [
        576.892822265625,
        -3229.878662109375,
        856.1787109375
      ],
      [
        554.9752197265625,
        -3236.477783203125,
        1010.4617309570312
      ],
      [
        576.892822265625,
        -3229.878662109375,
        856.1787109375
      ],
      [
        581.7977905273438,
        -3224.194580078125,
        768.7883911132812
      ],
      [
        659.6268310546875,
        -3571.96337890625,
        1021.3223266601562
      ],
      [
        645.9032592773438,
        -3556.55908203125,
        1174.3135986328125
      ],
      [
        645.9032592773438,
        -3556.55908203125,
        1174.3135986328125
      ],
      [
        529.0746459960938,
        -3216.295654296875,
        976.5902099609375
      ],
      [
        576.892822265625,
        -3204.979248046875,
        856.1787109375
      ],
      [
        551.649658203125,
        -3229.893310546875,
        1033.870849609375
      ],
      [
        576.892822265625,
        -3204.979248046875,
        856.1787109375
      ],
      [
        578.0961303710938,
        -3201.6396484375,
        834.740234375
      ],
      [
        581.9627685546875,
        -3196.521240234375,
        765.8486328125
      ],
      [
        508.15106201171875,
        -3204.718017578125,
        777.4321899414062
      ],
      [
        548.7560424804688,
        -3235.458251953125,
        1070.563720703125
      ],
      [
        551.649658203125,
        -3229.893310546875,
        1033.870849609375
      ],
      [
        548.7560424804688,
        -3235.458251953125,
        1070.563720703125
      ],
      [
        529.0746459960938,
        -3216.295654296875,
        976.5902099609375
      ],
      [
        528.6437377929688,
        -3195.122802734375,
        849.4788818359375
      ],
      [
        528.6437377929688,
        -3195.122802734375,
        849.4788818359375
      ],
      [
        542.2993774414062,
        -3184.464111328125,
        770.3386840820312
      ],
      [
        581.52197265625,
        -3192.13134765625,
        773.7025146484375
      ],
      [
        581.52197265625,
        -3192.13134765625,
        773.7025146484375
      ],
      [
        581.7504272460938,
        -3190.77392578125,
        765.2738647460938
      ],
      [
        535.500244140625,
        -3245.832275390625,
        1147.5496826171875
      ],
      [
        529.61572265625,
        -3242.880615234375,
        1136.1912841796875
      ],
      [
        568.4853515625,
        -2525.15283203125,
        819.0501708984375
      ],
      [
        579.1474609375,
        -2534.241455078125,
        696.475830078125
      ],
      [
        642.281005859375,
        -4031.08349609375,
        1832.025390625
      ],
      [
        616.0787963867188,
        -3997.394775390625,
        1827.77685546875
      ],
      [
        580.78759765625,
        -3944.7900390625,
        1756.1932373046875
      ],
      [
        560.656494140625,
        -3914.7822265625,
        1715.3597412109375
      ],
      [
        560.2274169921875,
        -3914.3642578125,
        1714.6058349609375
      ],
      [
        564.9246215820312,
        -3910.67578125,
        1628.662841796875
      ],
      [
        580.78759765625,
        -3944.7900390625,
        1756.1932373046875
      ],
      [
        560.8180541992188,
        -3914.939697265625,
        1715.6435546875
      ],
      [
        560.8180541992188,
        -3914.939697265625,
        1715.6435546875
      ],
      [
        12.945996284484863,
        -2898.948974609375,
        885.4474487304688
      ],
      [
        -68.38288879394531,
        -2902.1630859375,
        829.2857055664062
      ],
      [
        12.945999145507812,
        -2898.948974609375,
        885.4474487304688
      ],
      [
        44.51416778564453,
        -2893.52490234375,
        811.9789428710938
      ],
      [
        -37.866092681884766,
        -2848.014892578125,
        885.4474487304688
      ],
      [
        -35.475276947021484,
        -2851.993896484375,
        885.4474487304688
      ],
      [
        -138.67898559570312,
        -2666.321044921875,
        885.4474487304688
      ],
      [
        -138.67898559570312,
        -2661.678955078125,
        885.4474487304688
      ],
      [
        -143.32101440429688,
        -2661.678955078125,
        885.4474487304688
      ],
      [
        -143.32101440429688,
        -2666.321044921875,
        885.4474487304688
      ],
      [
        -143.32101440429688,
        -2666.321044921875,
        885.4474487304688
      ],
      [
        -138.67898559570312,
        -2666.321044921875,
        885.4474487304688
      ],
      [
        -143.32101440429688,
        -2661.678955078125,
        885.4474487304688
      ],
      [
        -138.67898559570312,
        -2661.678955078125,
        885.4474487304688
      ],
      [
        -35.475276947021484,
        -2851.993896484375,
        885.4474487304688
      ],
      [
        -31.496259689331055,
        -2849.60302734375,
        885.4474487304688
      ],
      [
        -37.866092681884766,
        -2848.014892578125,
        885.4474487304688
      ],
      [
        -33.887123107910156,
        -2845.624267578125,
        885.4474487304688
      ],
      [
        -31.496259689331055,
        -2849.60302734375,
        885.4474487304688
      ],
      [
        -33.887123107910156,
        -2845.624267578125,
        885.4474487304688
      ],
      [
        -60.152442932128906,
        -2861.406005859375,
        885.4474487304688
      ],
      [
        -56.17348098754883,
        -2859.01513671875,
        885.4474487304688
      ],
      [
        -57.76163101196289,
        -2865.385009765625,
        885.4474487304688
      ],
      [
        -53.782596588134766,
        -2862.993896484375,
        885.4474487304688
      ],
      [
        -60.152442932128906,
        -2861.406005859375,
        885.4474487304688
      ],
      [
        -57.76163101196289,
        -2865.385009765625,
        885.4474487304688
      ],
      [
        -53.782596588134766,
        -2862.993896484375,
        885.4474487304688
      ],
      [
        -56.17348098754883,
        -2859.01513671875,
        885.4474487304688
      ],
      [
        -169.32101440429688,
        -2666.321044921875,
        885.4474487304688
      ],
      [
        -164.67898559570312,
        -2666.321044921875,
        885.4474487304688
      ],
      [
        -164.67898559570312,
        -2666.321044921875,
        885.4474487304688
      ],
      [
        -164.67898559570312,
        -2663.856689453125,
        885.4474487304688
      ],
      [
        -164.5,
        -2663.672119140625,
        885.0
      ],
      [
        -169.5,
        -2665.086669921875,
        885.0
      ],
      [
        -169.32101440429688,
        -2665.169921875,
        885.4474487304688
      ],
      [
        -169.32101440429688,
        -2666.321044921875,
        885.4474487304688
      ],
      [
        -6.884873867034912,
        -2809.56689453125,
        810.5975952148438
      ],
      [
        -186.06431579589844,
        -2662.72265625,
        885.4474487304688
      ],
      [
        -211.42047119140625,
        -2656.7822265625,
        824.204833984375
      ],
      [
        -169.32101440429688,
        -2661.678955078125,
        885.4474487304688
      ],
      [
        -164.67898559570312,
        -2661.678955078125,
        885.4474487304688
      ],
      [
        -169.32101440429688,
        -2661.678955078125,
        885.4474487304688
      ],
      [
        -164.67898559570312,
        -2661.678955078125,
        885.4474487304688
      ],
      [
        -197.0970916748047,
        -2711.95166015625,
        901.4474487304688
      ],
      [
        -201.3208770751953,
        -2706.853271484375,
        885.4474487304688
      ],
      [
        -197.0970916748047,
        -2711.95166015625,
        901.4474487304688
      ],
      [
        -168.0,
        -2663.0,
        918.5
      ],
      [
        -168.0,
        -2665.0,
        918.5
      ],
      [
        -166.0,
        -2665.0,
        918.5
      ],
      [
        -166.0,
        -2663.0,
        918.5
      ],
      [
        -166.0,
        -2663.0,
        920.0
      ],
      [
        -166.0,
        -2665.0,
        920.0
      ],
      [
        -168.0,
        -2665.0,
        920.0
      ],
      [
        -168.0,
        -2663.0,
        920.0
      ],
      [
        -166.0,
        -2663.0,
        887.5
      ],
      [
        -166.0,
        -2665.0,
        887.5
      ],
      [
        -168.0,
        -2665.0,
        887.5
      ],
      [
        -168.0,
        -2663.0,
        887.5
      ],
      [
        -166.0,
        -2655.5,
        918.5
      ],
      [
        -168.0,
        -2655.5,
        918.5
      ],
      [
        -168.0,
        -2655.5,
        920.0
      ],
      [
        -166.0,
        -2655.5,
        920.0
      ],
      [
        -166.0,
        -2655.5,
        920.0
      ],
      [
        -168.0,
        -2655.5,
        920.0
      ],
      [
        -168.0,
        -2655.5,
        918.5
      ],
      [
        -166.0,
        -2655.5,
        918.5
      ],
      [
        -166.0,
        -2662.5,
        887.5
      ],
      [
        -168.0,
        -2662.5,
        887.5
      ],
      [
        -168.0,
        -2661.678955078125,
        885.4474487304688
      ],
      [
        -166.0,
        -2661.678955078125,
        885.4474487304688
      ],
      [
        -168.0,
        -2662.5,
        887.5
      ],
      [
        -166.0,
        -2662.5,
        887.5
      ],
      [
        -170.0,
        -2665.0,
        918.5
      ],
      [
        -170.0,
        -2665.0,
        920.0
      ],
      [
        -170.0,
        -2665.0,
        918.5
      ],
      [
        -170.0,
        -2665.0,
        920.0
      ],
      [
        -168.5,
        -2665.0,
        887.5
      ],
      [
        -169.32101440429688,
        -2665.0,
        885.4474487304688
      ],
      [
        -168.5,
        -2665.0,
        887.5
      ],
      [
        -166.0,
        -2672.5,
        918.5
      ],
      [
        -166.0,
        -2672.5,
        920.0
      ],
      [
        -166.0,
        -2672.5,
        918.5
      ],
      [
        -166.0,
        -2672.5,
        920.0
      ],
      [
        -166.0,
        -2665.5,
        887.5
      ],
      [
        -166.0,
        -2666.321044921875,
        885.4474487304688
      ],
      [
        -166.0,
        -2665.5,
        887.5
      ],
      [
        -58.33970260620117,
        -2861.85791015625,
        918.5
      ],
      [
        -57.30973815917969,
        -2863.572265625,
        918.5
      ],
      [
        -55.59528732299805,
        -2862.5419921875,
        918.5
      ],
      [
        -56.62539291381836,
        -2860.827880859375,
        918.5
      ],
      [
        -56.62539291381836,
        -2860.827880859375,
        920.0
      ],
      [
        -55.59528732299805,
        -2862.5419921875,
        920.0
      ],
      [
        -57.30973815917969,
        -2863.572265625,
        920.0
      ],
      [
        -58.33970260620117,
        -2861.85791015625,
        920.0
      ],
      [
        -56.6253547668457,
        -2860.827880859375,
        887.5
      ],
      [
        -55.59532165527344,
        -2862.5419921875,
        887.5
      ],
      [
        -57.30986022949219,
        -2863.572265625,
        887.5
      ],
      [
        -58.339805603027344,
        -2861.857666015625,
        887.5
      ],
      [
        -60.48876190185547,
        -2854.3994140625,
        918.5
      ],
      [
        -62.201942443847656,
        -2855.4287109375,
        918.5
      ],
      [
        -62.201942443847656,
        -2855.4287109375,
        920.0
      ],
      [
        -60.48876190185547,
        -2854.3994140625,
        920.0
      ],
      [
        -60.48876190185547,
        -2854.3994140625,
        920.0
      ],
      [
        -62.201942443847656,
        -2855.4287109375,
        920.0
      ],
      [
        -62.201942443847656,
        -2855.4287109375,
        918.5
      ],
      [
        -60.48876190185547,
        -2854.3994140625,
        918.5
      ],
      [
        -56.88302230834961,
        -2860.399169921875,
        887.5
      ],
      [
        -58.597164154052734,
        -2861.42919921875,
        887.5
      ],
      [
        -59.01997756958008,
        -2860.7255859375,
        885.4474487304688
      ],
      [
        -57.305843353271484,
        -2859.695556640625,
        885.4474487304688
      ],
      [
        -58.597164154052734,
        -2861.42919921875,
        887.5
      ],
      [
        -56.88302230834961,
        -2860.399169921875,
        887.5
      ],
      [
        -59.02387619018555,
        -2864.6025390625,
        918.5
      ],
      [
        -59.02387619018555,
        -2864.6025390625,
        920.0
      ],
      [
        -59.02387619018555,
        -2864.6025390625,
        918.5
      ],
      [
        -59.02387619018555,
        -2864.6025390625,
        920.0
      ],
      [
        -57.73823547363281,
        -2863.82958984375,
        887.5
      ],
      [
        -58.441917419433594,
        -2864.2529296875,
        885.4474487304688
      ],
      [
        -57.73823547363281,
        -2863.82958984375,
        887.5
      ],
      [
        -51.732017517089844,
        -2868.970458984375,
        918.5
      ],
      [
        -51.732017517089844,
        -2868.970458984375,
        920.0
      ],
      [
        -51.732017517089844,
        -2868.970458984375,
        918.5
      ],
      [
        -51.732017517089844,
        -2868.970458984375,
        920.0
      ],
      [
        -55.33778381347656,
        -2862.970703125,
        887.5
      ],
      [
        -54.91481399536133,
        -2863.67431640625,
        885.4474487304688
      ],
      [
        -55.33778381347656,
        -2862.970703125,
        887.5
      ],
      [
        -142.0,
        -2663.0,
        914.8635864257812
      ],
      [
        -142.0,
        -2665.0,
        917.3863525390625
      ],
      [
        -142.0,
        -2665.0,
        917.3863525390625
      ],
      [
        -140.0,
        -2665.0,
        913.1650390625
      ],
      [
        -142.0,
        -2663.0,
        914.863525390625
      ],
      [
        -140.0,
        -2663.0,
        910.6422729492188
      ],
      [
        -140.0,
        -2665.0,
        913.1650390625
      ],
      [
        -140.0,
        -2663.0,
        910.6422729492188
      ],
      [
        -140.0,
        -2665.0,
        887.5
      ],
      [
        -142.0,
        -2665.0,
        887.5
      ],
      [
        -142.0,
        -2663.0,
        887.5
      ],
      [
        -140.0,
        -2663.0,
        887.5
      ],
      [
        -139.5,
        -2665.0,
        887.5
      ],
      [
        -139.5,
        -2663.0,
        887.5
      ],
      [
        -138.67898559570312,
        -2663.0,
        885.4474487304688
      ],
      [
        -138.67898559570312,
        -2665.0,
        885.4474487304688
      ],
      [
        -139.5,
        -2663.0,
        887.5
      ],
      [
        -139.5,
        -2665.0,
        887.5
      ],
      [
        -142.0,
        -2661.678955078125,
        885.4474487304688
      ],
      [
        -142.0,
        -2662.5,
        887.5
      ],
      [
        -142.0,
        -2662.5,
        887.5
      ],
      [
        -36.053436279296875,
        -2848.466796875,
        918.5
      ],
      [
        -35.02348709106445,
        -2850.180908203125,
        918.5
      ],
      [
        -33.30897903442383,
        -2849.15087890625,
        918.5
      ],
      [
        -34.339088439941406,
        -2847.436767578125,
        918.5
      ],
      [
        -35.02347183227539,
        -2850.180908203125,
        920.0
      ],
      [
        -36.05342483520508,
        -2848.466796875,
        920.0
      ],
      [
        -34.33908462524414,
        -2847.436767578125,
        920.0
      ],
      [
        -33.30890655517578,
        -2849.15087890625,
        920.0
      ],
      [
        -33.30891418457031,
        -2849.15087890625,
        887.5
      ],
      [
        -35.023521423339844,
        -2850.18115234375,
        887.5
      ],
      [
        -36.053470611572266,
        -2848.466796875,
        887.5
      ],
      [
        -34.33905029296875,
        -2847.436767578125,
        887.5
      ],
      [
        -32.880523681640625,
        -2848.8935546875,
        887.5
      ],
      [
        -33.91046905517578,
        -2847.17919921875,
        887.5
      ],
      [
        -33.206912994384766,
        -2846.75634765625,
        885.4474487304688
      ],
      [
        -32.17672348022461,
        -2848.470703125,
        885.4474487304688
      ],
      [
        -33.91046905517578,
        -2847.17919921875,
        887.5
      ],
      [
        -32.880523681640625,
        -2848.8935546875,
        887.5
      ],
      [
        -32.69523239135742,
        -2848.7822265625,
        918.5
      ],
      [
        -33.72125244140625,
        -2847.0654296875,
        918.5
      ],
      [
        -34.24418258666992,
        -2847.379638671875,
        920.0
      ],
      [
        -33.218177795410156,
        -2849.096435546875,
        920.0
      ],
      [
        -31.16071319580078,
        -2856.60986328125,
        918.5
      ],
      [
        -28.847665786743164,
        -2855.22021484375,
        918.5
      ],
      [
        -29.37066078186035,
        -2855.534423828125,
        920.0
      ],
      [
        -31.160676956176758,
        -2856.60986328125,
        920.0
      ],
      [
        -28.847665786743164,
        -2855.22021484375,
        918.5
      ],
      [
        -31.16071319580078,
        -2856.60986328125,
        918.5
      ],
      [
        -31.160676956176758,
        -2856.60986328125,
        920.0
      ],
      [
        -29.37066078186035,
        -2855.534423828125,
        920.0
      ],
      [
        -34.76587677001953,
        -2850.60986328125,
        887.5
      ],
      [
        -34.34300231933594,
        -2851.3134765625,
        885.4474487304688
      ],
      [
        -34.76587677001953,
        -2850.60986328125,
        887.5
      ],
      [
        -37.56859588623047,
        -2840.627685546875,
        918.5
      ],
      [
        -39.915985107421875,
        -2842.0380859375,
        918.5
      ],
      [
        -141.78041076660156,
        -2672.5,
        918.5
      ],
      [
        -138.04559326171875,
        -2672.5,
        918.5
      ],
      [
        -142.0,
        -2665.883056640625,
        918.5
      ],
      [
        -142.0,
        -2672.134521484375,
        918.5
      ],
      [
        -39.915992736816406,
        -2842.0380859375,
        920.0
      ],
      [
        -38.091575622558594,
        -2840.94189453125,
        920.0
      ],
      [
        -138.7563934326172,
        -2672.5,
        920.0
      ],
      [
        -141.7803955078125,
        -2672.5,
        920.0
      ],
      [
        -142.0,
        -2672.134521484375,
        920.0
      ],
      [
        -142.0,
        -2667.072509765625,
        920.0
      ],
      [
        -138.04559326171875,
        -2672.5,
        918.5
      ],
      [
        -141.78041076660156,
        -2672.5,
        918.5
      ],
      [
        -141.7803955078125,
        -2672.5,
        920.0
      ],
      [
        -138.7563934326172,
        -2672.5,
        920.0
      ],
      [
        -38.091575622558594,
        -2840.94189453125,
        920.0
      ],
      [
        -39.915992736816406,
        -2842.0380859375,
        920.0
      ],
      [
        -39.915985107421875,
        -2842.0380859375,
        918.5
      ],
      [
        -37.56859588623047,
        -2840.627685546875,
        918.5
      ],
      [
        -142.0,
        -2665.5,
        887.5
      ],
      [
        -142.0,
        -2666.321044921875,
        885.4474487304688
      ],
      [
        -142.0,
        -2665.5,
        887.5
      ],
      [
        -36.73373031616211,
        -2847.33447265625,
        885.4474487304688
      ],
      [
        -36.31084060668945,
        -2848.038330078125,
        887.5
      ],
      [
        -36.31084060668945,
        -2848.038330078125,
        887.5
      ],
      [
        -142.0,
        -2672.5,
        918.5
      ],
      [
        -142.0,
        -2672.5,
        920.0
      ],
      [
        -142.0,
        -2672.5,
        918.5
      ],
      [
        -142.0,
        -2672.5,
        920.0
      ],
      [
        -144.0,
        -2662.53662109375,
        918.5
      ],
      [
        -144.0,
        -2662.53662109375,
        918.5
      ],
      [
        -144.0,
        -2663.725830078125,
        920.0
      ],
      [
        -144.0,
        -2663.725830078125,
        920.0
      ],
      [
        -3.838775634765625,
        -2811.316162109375,
        810.3395385742188
      ],
      [
        -191.5,
        -2492.27783203125,
        804.0
      ],
      [
        -196.81251525878906,
        -2483.38818359375,
        804.0
      ],
      [
        -191.5,
        -2492.27783203125,
        804.0
      ],
      [
        -191.5,
        -2492.259033203125,
        803.9765625
      ],
      [
        560.6563720703125,
        -3914.7822265625,
        1715.3594970703125
      ],
      [
        79.60877227783203,
        -2859.235595703125,
        803.2691650390625
      ],
      [
        482.2278747558594,
        -3275.861328125,
        1323.5
      ],
      [
        484.1072082519531,
        -3276.54541015625,
        1323.5
      ],
      [
        484.7911682128906,
        -3274.666259765625,
        1323.5
      ],
      [
        482.91168212890625,
        -3273.982177734375,
        1323.5
      ],
      [
        484.1072082519531,
        -3276.54541015625,
        1325.0
      ],
      [
        482.2278747558594,
        -3275.861328125,
        1325.0
      ],
      [
        482.91168212890625,
        -3273.982177734375,
        1325.0
      ],
      [
        484.7911682128906,
        -3274.666259765625,
        1325.0
      ],
      [
        491.1546630859375,
        -3279.11083984375,
        1323.5
      ],
      [
        491.83868408203125,
        -3277.231689453125,
        1323.5
      ],
      [
        491.83868408203125,
        -3277.231689453125,
        1325.0
      ],
      [
        491.1546630859375,
        -3279.11083984375,
        1325.0
      ],
      [
        491.83868408203125,
        -3277.231689453125,
        1323.5
      ],
      [
        491.1546630859375,
        -3279.11083984375,
        1323.5
      ],
      [
        491.1546630859375,
        -3279.11083984375,
        1325.0
      ],
      [
        491.83868408203125,
        -3277.231689453125,
        1325.0
      ],
      [
        475.8641662597656,
        -3271.4169921875,
        1323.5
      ],
      [
        475.1802978515625,
        -3273.2958984375,
        1323.5
      ],
      [
        475.1802978515625,
        -3273.2958984375,
        1325.0
      ],
      [
        475.8641662597656,
        -3271.4169921875,
        1325.0
      ],
      [
        475.8641662597656,
        -3271.4169921875,
        1325.0
      ],
      [
        475.1802978515625,
        -3273.2958984375,
        1325.0
      ],
      [
        475.1802978515625,
        -3273.2958984375,
        1323.5
      ],
      [
        475.8641662597656,
        -3271.4169921875,
        1323.5
      ],
      [
        475.2145080566406,
        -3300.977783203125,
        1325.0
      ],
      [
        473.3351745605469,
        -3300.29345703125,
        1325.0
      ],
      [
        474.0193786621094,
        -3298.414306640625,
        1325.0
      ],
      [
        475.8984680175781,
        -3299.09814453125,
        1325.0
      ],
      [
        475.8984680175781,
        -3299.09814453125,
        1323.5
      ],
      [
        474.0193786621094,
        -3298.414306640625,
        1323.5
      ],
      [
        473.3351745605469,
        -3300.29345703125,
        1323.5
      ],
      [
        475.2145080566406,
        -3300.977783203125,
        1323.5
      ],
      [
        482.2619323730469,
        -3303.54345703125,
        1323.5
      ],
      [
        482.9465026855469,
        -3301.66259765625,
        1323.5
      ],
      [
        482.9465026855469,
        -3301.66259765625,
        1325.0
      ],
      [
        482.2619323730469,
        -3303.54345703125,
        1325.0
      ],
      [
        482.9465026855469,
        -3301.66259765625,
        1323.5
      ],
      [
        482.2619323730469,
        -3303.54345703125,
        1323.5
      ],
      [
        482.2619323730469,
        -3303.54345703125,
        1325.0
      ],
      [
        482.9465026855469,
        -3301.66259765625,
        1325.0
      ],
      [
        472.6507873535156,
        -3302.1728515625,
        1323.5
      ],
      [
        472.6507873535156,
        -3302.1728515625,
        1325.0
      ],
      [
        472.6507873535156,
        -3302.1728515625,
        1323.5
      ],
      [
        472.6507873535156,
        -3302.1728515625,
        1325.0
      ],
      [
        466.9713439941406,
        -3295.849609375,
        1323.5
      ],
      [
        466.9713439941406,
        -3295.849609375,
        1325.0
      ],
      [
        466.9713439941406,
        -3295.849609375,
        1325.0
      ],
      [
        466.9713439941406,
        -3295.849609375,
        1323.5
      ],
      [
        731.8804931640625,
        -4360.33203125,
        1128.1400146484375
      ],
      [
        731.8804931640625,
        -4360.33203125,
        1128.1400146484375
      ],
      [
        755.9525146484375,
        -4392.64306640625,
        866.6099243164062
      ],
      [
        981.9635620117188,
        -4485.32275390625,
        843.5507202148438
      ],
      [
        952.0841674804688,
        -4492.5625,
        1553.435791015625
      ],
      [
        765.4669189453125,
        -4443.63818359375,
        1816.467529296875
      ],
      [
        954.2808837890625,
        -4507.3974609375,
        1660.364990234375
      ],
      [
        992.7523193359375,
        -4596.400390625,
        1764.44482421875
      ],
      [
        952.0841674804688,
        -4492.5625,
        1553.4356689453125
      ],
      [
        950.15869140625,
        -4499.61279296875,
        1667.355712890625
      ],
      [
        950.15869140625,
        -4499.61279296875,
        1667.355712890625
      ],
      [
        772.9165649414062,
        -4424.40771484375,
        867.4931640625
      ],
      [
        694.1695556640625,
        -4310.0068359375,
        1543.8734130859375
      ],
      [
        756.906982421875,
        -4440.6171875,
        1817.5745849609375
      ],
      [
        681.7706909179688,
        -4298.9931640625,
        1794.4674072265625
      ],
      [
        694.1695556640625,
        -4310.0068359375,
        1543.8734130859375
      ],
      [
        679.9492797851562,
        -4296.572265625,
        1814.7427978515625
      ],
      [
        681.7706909179688,
        -4298.9931640625,
        1794.4674072265625
      ],
      [
        757.1337280273438,
        -4440.697265625,
        1817.5452880859375
      ],
      [
        681.6741943359375,
        -4297.5009765625,
        1793.12841796875
      ],
      [
        679.71435546875,
        -4294.8466796875,
        1814.8580322265625
      ],
      [
        681.6741943359375,
        -4297.5009765625,
        1793.12841796875
      ],
      [
        810.7130737304688,
        -4168.02490234375,
        1197.0963134765625
      ],
      [
        780.855712890625,
        -4251.77490234375,
        848.1504516601562
      ],
      [
        812.9754028320312,
        -4138.9873046875,
        848.35400390625
      ],
      [
        872.90966796875,
        -4301.4326171875,
        1256.812744140625
      ],
      [
        859.7396240234375,
        -4274.20458984375,
        1254.7398681640625
      ],
      [
        835.8154296875,
        -4224.4111328125,
        1247.5322265625
      ],
      [
        810.7130737304688,
        -4168.02490234375,
        1197.09619140625
      ],
      [
        859.7396240234375,
        -4274.20458984375,
        1254.7398681640625
      ],
      [
        835.8153686523438,
        -4224.4111328125,
        1247.5322265625
      ],
      [
        812.9754028320312,
        -4138.9873046875,
        848.35400390625
      ],
      [
        812.9542846679688,
        -4137.3095703125,
        831.4278564453125
      ],
      [
        994.1641845703125,
        -4595.10693359375,
        1764.350830078125
      ],
      [
        821.5584106445312,
        -4129.29150390625,
        1186.4161376953125
      ],
      [
        822.922607421875,
        -4107.6591796875,
        907.962646484375
      ],
      [
        853.9423217773438,
        -4213.328125,
        1257.294677734375
      ],
      [
        821.5584106445312,
        -4129.29150390625,
        1186.416015625
      ],
      [
        881.4633178710938,
        -4280.025390625,
        1264.756103515625
      ],
      [
        853.9423217773438,
        -4213.328125,
        1257.294677734375
      ],
      [
        885.4208984375,
        -4289.5556640625,
        1265.1514892578125
      ],
      [
        881.4633178710938,
        -4280.025390625,
        1264.756103515625
      ],
      [
        822.922607421875,
        -4107.6591796875,
        907.962646484375
      ],
      [
        822.7315673828125,
        -4099.87548828125,
        826.0635986328125
      ],
      [
        803.0803833007812,
        -3677.029052734375,
        909.9917602539062
      ],
      [
        801.6185913085938,
        -3676.619384765625,
        866.916015625
      ],
      [
        899.16796875,
        -4173.95458984375,
        1269.789306640625
      ],
      [
        900.4749755859375,
        -4181.64453125,
        1269.789306640625
      ],
      [
        892.8248901367188,
        -3648.751953125,
        1269.789306640625
      ],
      [
        940.3001098632812,
        -3629.3427734375,
        1269.789306640625
      ],
      [
        912.9552612304688,
        -4255.0732421875,
        1269.789306640625
      ],
      [
        900.4749755859375,
        -4181.64453125,
        1269.789306640625
      ],
      [
        863.269775390625,
        -3660.834716796875,
        1269.789306640625
      ],
      [
        892.8248901367188,
        -3648.751953125,
        1269.789306640625
      ],
      [
        917.3206787109375,
        -4280.7578125,
        1269.789306640625
      ],
      [
        912.955322265625,
        -4255.0732421875,
        1269.789306640625
      ],
      [
        803.0803833007812,
        -3677.029052734375,
        909.9917602539062
      ],
      [
        804.4501953125,
        -3677.375,
        948.734619140625
      ],
      [
        819.3653564453125,
        -3716.474609375,
        1171.0030517578125
      ],
      [
        804.4501953125,
        -3677.375,
        948.734619140625
      ],
      [
        805.130615234375,
        -3677.4853515625,
        965.3541259765625
      ],
      [
        833.7940673828125,
        -3719.427490234375,
        1216.1597900390625
      ],
      [
        826.3023071289062,
        -3718.88525390625,
        1197.1392822265625
      ],
      [
        858.0565185546875,
        -3710.09228515625,
        1228.2294921875
      ],
      [
        930.0554809570312,
        -3821.15087890625,
        1257.2091064453125
      ],
      [
        942.7125854492188,
        -3895.83203125,
        1259.5858154296875
      ],
      [
        833.7940673828125,
        -3719.427490234375,
        1216.1597900390625
      ],
      [
        942.712646484375,
        -3895.83203125,
        1259.5858154296875
      ],
      [
        998.5626831054688,
        -4037.717529296875,
        1265.828857421875
      ],
      [
        1608.2640380859375,
        -3750.112548828125,
        1261.404541015625
      ],
      [
        801.6185913085938,
        -3676.619384765625,
        866.916015625
      ],
      [
        798.8544921875,
        -3675.83056640625,
        784.8514404296875
      ],
      [
        995.0,
        -3647.5,
        1252.136962890625
      ],
      [
        997.1614379882812,
        -3647.5,
        1256.926025390625
      ],
      [
        1020.0,
        -3647.5,
        1258.16650390625
      ],
      [
        995.0,
        -3625.187744140625,
        1152.5
      ],
      [
        995.0,
        -3647.5,
        1252.136962890625
      ],
      [
        1020.0,
        -3647.5,
        1258.16650390625
      ],
      [
        1020.0,
        -3641.208251953125,
        1258.0242919921875
      ],
      [
        1020.0,
        -3634.58935546875,
        1249.8753662109375
      ],
      [
        1020.0,
        -3622.5,
        1195.8892822265625
      ],
      [
        1000.4169311523438,
        -3622.5,
        1152.5
      ],
      [
        1020.0,
        -3622.5,
        1195.88916015625
      ],
      [
        892.5,
        -3982.5,
        1223.00439453125
      ],
      [
        989.4918212890625,
        -3982.5,
        1264.087158203125
      ],
      [
        976.8275756835938,
        -3982.5,
        1263.3992919921875
      ],
      [
        895.8646850585938,
        -3982.5,
        1231.6805419921875
      ],
      [
        892.5,
        -4000.0,
        1213.3897705078125
      ],
      [
        892.5,
        -3982.5,
        1223.0045166015625
      ],
      [
        892.5,
        -3982.5,
        1130.0
      ],
      [
        867.5,
        -3982.5,
        1130.0
      ],
      [
        867.5,
        -3982.5,
        1158.5390625
      ],
      [
        867.5,
        -4000.0,
        1148.92431640625
      ],
      [
        892.5,
        -3975.0,
        1227.1251220703125
      ],
      [
        867.5,
        -3975.0,
        1162.65966796875
      ],
      [
        892.5,
        -3975.0,
        1227.1251220703125
      ],
      [
        867.5,
        -3975.0,
        1162.65966796875
      ],
      [
        855.0,
        -3742.5,
        1225.170166015625
      ],
      [
        855.0,
        -3717.5,
        1226.4019775390625
      ],
      [
        826.3023071289062,
        -3718.88525390625,
        1197.1392822265625
      ],
      [
        823.9547119140625,
        -3713.948486328125,
        1169.8922119140625
      ],
      [
        830.0,
        -3717.5,
        1199.1463623046875
      ],
      [
        855.0,
        -3717.5,
        1226.4019775390625
      ],
      [
        838.8035278320312,
        -3717.5,
        1218.65185546875
      ],
      [
        830.0,
        -3742.5,
        1193.7001953125
      ],
      [
        839.2887573242188,
        -3742.5,
        1217.6522216796875
      ],
      [
        855.0,
        -3742.5,
        1225.170166015625
      ],
      [
        830.0,
        -3717.5,
        1199.1468505859375
      ],
      [
        830.0,
        -3719.15283203125,
        1206.52734375
      ],
      [
        830.0,
        -3742.5,
        1193.7001953125
      ],
      [
        823.9547119140625,
        -3713.948486328125,
        1169.8922119140625
      ],
      [
        821.7115478515625,
        -3715.138916015625,
        1170.238525390625
      ],
      [
        823.5496826171875,
        -3741.89453125,
        1177.39990234375
      ],
      [
        819.3652954101562,
        -3716.474365234375,
        1171.0029296875
      ],
      [
        821.7115478515625,
        -3715.138916015625,
        1170.238525390625
      ],
      [
        892.5,
        -3725.0,
        1190.0
      ],
      [
        892.5,
        -3725.0,
        1243.976318359375
      ],
      [
        855.0,
        -3725.0,
        1226.032470703125
      ],
      [
        855.0,
        -3735.0,
        1225.5396728515625
      ],
      [
        892.5,
        -3735.0,
        1243.483642578125
      ],
      [
        892.5,
        -3735.0,
        1190.0
      ],
      [
        872.5,
        -3781.5,
        1231.6224365234375
      ],
      [
        872.5,
        -3784.5,
        1231.4744873046875
      ],
      [
        872.5,
        -3831.5,
        1229.15869140625
      ],
      [
        872.5,
        -3834.5,
        1229.0108642578125
      ],
      [
        872.5,
        -3854.5,
        1228.025390625
      ],
      [
        872.5,
        -3857.5,
        1227.8775634765625
      ],
      [
        872.5,
        -3805.5,
        1230.4398193359375
      ],
      [
        872.5,
        -3808.5,
        1230.2918701171875
      ],
      [
        872.5,
        -3781.5,
        1231.6224365234375
      ],
      [
        869.5,
        -3781.5,
        1230.186767578125
      ],
      [
        869.5,
        -3784.5,
        1230.0389404296875
      ],
      [
        872.5,
        -3784.5,
        1231.4744873046875
      ],
      [
        869.5,
        -3781.5,
        1230.186767578125
      ],
      [
        869.5,
        -3784.5,
        1230.0389404296875
      ],
      [
        872.5,
        -3805.5,
        1230.4398193359375
      ],
      [
        869.5,
        -3805.5,
        1229.0042724609375
      ],
      [
        869.5,
        -3808.5,
        1228.8564453125
      ],
      [
        872.5,
        -3808.5,
        1230.2918701171875
      ],
      [
        869.5,
        -3805.5,
        1229.0042724609375
      ],
      [
        869.5,
        -3808.5,
        1228.8564453125
      ],
      [
        872.5,
        -3831.5,
        1229.15869140625
      ],
      [
        869.5,
        -3831.5,
        1227.72314453125
      ],
      [
        869.5,
        -3834.5,
        1227.5753173828125
      ],
      [
        872.5,
        -3834.5,
        1229.0108642578125
      ],
      [
        869.5,
        -3831.5,
        1227.72314453125
      ],
      [
        869.5,
        -3834.5,
        1227.5753173828125
      ],
      [
        872.5,
        -3854.5,
        1228.025390625
      ],
      [
        869.5,
        -3854.5,
        1226.5899658203125
      ],
      [
        869.5,
        -3854.5,
        1226.5899658203125
      ],
      [
        869.5,
        -3857.5,
        1226.4420166015625
      ],
      [
        869.5,
        -3857.5,
        1226.4420166015625
      ],
      [
        872.5,
        -3857.5,
        1227.8775634765625
      ],
      [
        1596.605224609375,
        -3752.958984375,
        1269.789306640625
      ],
      [
        1608.263916015625,
        -3750.112548828125,
        1261.404541015625
      ],
      [
        917.5,
        -3781.5,
        1253.155029296875
      ],
      [
        917.5,
        -3784.5,
        1253.0072021484375
      ],
      [
        917.5,
        -3831.5,
        1250.69140625
      ],
      [
        917.5,
        -3834.5,
        1250.5435791015625
      ],
      [
        917.5,
        -3805.5,
        1251.972412109375
      ],
      [
        917.5,
        -3808.5,
        1251.8245849609375
      ],
      [
        917.5,
        -3854.5,
        1249.55810546875
      ],
      [
        917.5,
        -3857.5,
        1249.4102783203125
      ],
      [
        917.5,
        -3781.5,
        1253.155029296875
      ],
      [
        914.5,
        -3781.5,
        1251.719482421875
      ],
      [
        914.5,
        -3784.5,
        1251.57177734375
      ],
      [
        917.5,
        -3784.5,
        1253.0072021484375
      ],
      [
        914.5,
        -3781.5,
        1251.719482421875
      ],
      [
        914.5,
        -3784.5,
        1251.57177734375
      ],
      [
        917.5,
        -3805.5,
        1251.972412109375
      ],
      [
        914.5,
        -3805.5,
        1250.536865234375
      ],
      [
        914.5,
        -3808.5,
        1250.38916015625
      ],
      [
        917.5,
        -3808.5,
        1251.8245849609375
      ],
      [
        914.5,
        -3805.5,
        1250.536865234375
      ],
      [
        914.5,
        -3808.5,
        1250.38916015625
      ],
      [
        917.5,
        -3831.5,
        1250.69140625
      ],
      [
        914.5,
        -3831.5,
        1249.2559814453125
      ],
      [
        914.5,
        -3834.5,
        1249.108154296875
      ],
      [
        917.5,
        -3834.5,
        1250.5435791015625
      ],
      [
        914.5,
        -3831.5,
        1249.2559814453125
      ],
      [
        914.5,
        -3834.5,
        1249.108154296875
      ],
      [
        917.5,
        -3854.5,
        1249.55810546875
      ],
      [
        914.5,
        -3854.5,
        1248.12255859375
      ],
      [
        914.5,
        -3857.5,
        1247.9747314453125
      ],
      [
        917.5,
        -3857.5,
        1249.4102783203125
      ],
      [
        914.5,
        -3854.5,
        1248.12255859375
      ],
      [
        914.5,
        -3857.5,
        1247.9747314453125
      ],
      [
        900.0,
        -3725.0,
        1247.5650634765625
      ],
      [
        900.0,
        -3735.0,
        1247.0723876953125
      ],
      [
        989.5,
        -3845.0,
        1260.977294921875
      ],
      [
        989.5,
        -3791.5,
        1259.7672119140625
      ],
      [
        924.0,
        -3782.5,
        1256.0059814453125
      ],
      [
        924.0,
        -3785.421630859375,
        1256.072021484375
      ],
      [
        924.0,
        -3807.5,
        1254.9842529296875
      ],
      [
        924.0,
        -3807.5,
        1254.9842529296875
      ],
      [
        924.0,
        -3852.5,
        1252.766845703125
      ],
      [
        967.5,
        -3770.5,
        1258.09716796875
      ],
      [
        934.0,
        -3770.5,
        1256.2777099609375
      ],
      [
        934.0,
        -3864.5,
        1256.960693359375
      ],
      [
        937.4022216796875,
        -3864.5,
        1258.5887451171875
      ],
      [
        967.5,
        -3864.5,
        1260.2235107421875
      ],
      [
        967.5,
        -3864.5,
        1260.2235107421875
      ],
      [
        978.5,
        -3852.5,
        1260.549560546875
      ],
      [
        978.5,
        -3782.5,
        1258.9661865234375
      ],
      [
        967.5,
        -3770.5,
        1258.09716796875
      ],
      [
        934.0,
        -3770.5,
        1256.2777099609375
      ],
      [
        924.0,
        -3782.5,
        1256.0059814453125
      ],
      [
        978.5,
        -3852.5,
        1260.549560546875
      ],
      [
        978.5,
        -3845.0,
        1260.3798828125
      ],
      [
        978.5,
        -3791.5,
        1259.1697998046875
      ],
      [
        978.5,
        -3782.5,
        1258.9661865234375
      ],
      [
        924.0,
        -3852.5,
        1252.766845703125
      ],
      [
        934.0,
        -3864.5,
        1256.960693359375
      ],
      [
        985.3749389648438,
        -3845.0,
        1238.0
      ],
      [
        978.5,
        -3845.0,
        1260.3798828125
      ],
      [
        985.3749389648438,
        -3845.0,
        1260.7532958984375
      ],
      [
        986.7500610351562,
        -3791.5,
        1259.617919921875
      ],
      [
        978.5,
        -3791.5,
        1259.1697998046875
      ],
      [
        986.7500610351562,
        -3791.5,
        1238.0
      ],
      [
        989.5,
        -3791.5,
        1259.7672119140625
      ],
      [
        989.5,
        -3845.0,
        1260.977294921875
      ],
      [
        1012.5,
        -3647.5,
        1257.75927734375
      ],
      [
        1012.5,
        -3649.51123046875,
        1257.8046875
      ],
      [
        998.5626831054688,
        -4037.717529296875,
        1265.828857421875
      ],
      [
        971.2003784179688,
        -4063.91845703125,
        1264.935302734375
      ],
      [
        905.3214111328125,
        -3982.5,
        1237.423583984375
      ],
      [
        896.4446411132812,
        -3982.5,
        1233.176025390625
      ],
      [
        915.989013671875,
        -3982.5,
        1239.564697265625
      ],
      [
        957.4013671875,
        -3982.5,
        1262.3441162109375
      ],
      [
        933.3511962890625,
        -4100.1611328125,
        1263.6993408203125
      ],
      [
        897.4816284179688,
        -3982.5,
        1235.85009765625
      ],
      [
        905.3214111328125,
        -3982.5,
        1237.423583984375
      ],
      [
        930.0554809570312,
        -3821.15087890625,
        1257.2091064453125
      ],
      [
        858.0565185546875,
        -3710.09228515625,
        1228.2294921875
      ],
      [
        872.9542236328125,
        -3707.922119140625,
        1251.5465087890625
      ],
      [
        900.0,
        -3725.0,
        1253.4017333984375
      ],
      [
        881.566650390625,
        -3725.0,
        1252.4005126953125
      ],
      [
        867.72119140625,
        -3725.0,
        1232.11962890625
      ],
      [
        886.6094360351562,
        -3735.0,
        1252.900634765625
      ],
      [
        900.0,
        -3735.0,
        1253.6279296875
      ],
      [
        874.2041625976562,
        -3735.0,
        1234.72900390625
      ],
      [
        924.0,
        -3807.5,
        1256.5714111328125
      ],
      [
        924.0,
        -3807.5,
        1256.5714111328125
      ],
      [
        924.0,
        -3809.143310546875,
        1256.608642578125
      ],
      [
        924.0,
        -3811.810302734375,
        1254.7718505859375
      ],
      [
        914.5,
        -3781.5,
        1255.46728515625
      ],
      [
        914.5,
        -3784.5,
        1255.53515625
      ],
      [
        914.5,
        -3784.5,
        1255.53515625
      ],
      [
        917.5,
        -3784.5,
        1255.6982421875
      ],
      [
        917.5,
        -3781.5,
        1255.63037109375
      ],
      [
        914.5,
        -3781.5,
        1255.46728515625
      ],
      [
        917.5,
        -3781.5,
        1255.63037109375
      ],
      [
        917.5,
        -3784.5,
        1255.6982421875
      ],
      [
        906.6879272460938,
        -3982.5,
        1259.589599609375
      ],
      [
        924.0,
        -3852.5,
        1257.58935546875
      ],
      [
        924.0,
        -3852.5,
        1257.58935546875
      ],
      [
        934.0,
        -3864.5,
        1258.4039306640625
      ],
      [
        934.0,
        -3864.5,
        1258.4039306640625
      ],
      [
        855.0,
        -3742.5,
        1251.3533935546875
      ],
      [
        855.0,
        -3717.5,
        1250.787841796875
      ],
      [
        852.3013916015625,
        -3742.5,
        1251.206787109375
      ],
      [
        855.0,
        -3742.5,
        1251.3533935546875
      ],
      [
        855.0,
        -3717.5,
        1250.787841796875
      ],
      [
        853.26513671875,
        -3717.5,
        1250.693603515625
      ],
      [
        855.0,
        -3735.0,
        1251.1837158203125
      ],
      [
        855.0,
        -3725.0,
        1250.95751953125
      ],
      [
        872.5,
        -3831.5,
        1254.3170166015625
      ],
      [
        872.5,
        -3834.5,
        1252.745361328125
      ],
      [
        872.5,
        -3831.633544921875,
        1254.320068359375
      ],
      [
        872.5,
        -3781.5,
        1253.18603515625
      ],
      [
        872.5,
        -3784.5,
        1253.25390625
      ],
      [
        872.5,
        -3854.5,
        1241.7569580078125
      ],
      [
        872.5,
        -3857.5,
        1240.1087646484375
      ],
      [
        872.5,
        -3805.5,
        1253.72900390625
      ],
      [
        872.5,
        -3808.5,
        1253.796875
      ],
      [
        869.5,
        -3805.5,
        1253.5660400390625
      ],
      [
        869.5,
        -3808.5,
        1253.6337890625
      ],
      [
        869.5,
        -3831.5,
        1246.65771484375
      ],
      [
        869.5,
        -3834.5,
        1245.0093994140625
      ],
      [
        869.5,
        -3781.5,
        1253.023193359375
      ],
      [
        869.5,
        -3784.5,
        1253.091064453125
      ],
      [
        869.5,
        -3854.5,
        1234.021240234375
      ],
      [
        869.5,
        -3857.5,
        1232.373046875
      ],
      [
        869.5,
        -3808.5,
        1253.6337890625
      ],
      [
        872.5,
        -3808.5,
        1253.796875
      ],
      [
        872.5,
        -3805.5,
        1253.72900390625
      ],
      [
        869.5,
        -3805.5,
        1253.5660400390625
      ],
      [
        869.5,
        -3784.5,
        1253.091064453125
      ],
      [
        872.5,
        -3784.5,
        1253.25390625
      ],
      [
        872.5,
        -3781.5,
        1253.18603515625
      ],
      [
        869.5,
        -3781.5,
        1253.023193359375
      ],
      [
        872.5,
        -3831.5,
        1254.3170166015625
      ],
      [
        872.4697265625,
        -3831.5,
        1254.3154296875
      ],
      [
        869.5,
        -3831.5,
        1246.6575927734375
      ],
      [
        869.5,
        -3834.5,
        1245.0093994140625
      ],
      [
        872.5,
        -3834.5,
        1252.7452392578125
      ],
      [
        872.5,
        -3854.5,
        1241.7569580078125
      ],
      [
        869.5,
        -3854.5,
        1234.021240234375
      ],
      [
        869.5,
        -3857.5,
        1232.373046875
      ],
      [
        872.5,
        -3857.5,
        1240.1087646484375
      ],
      [
        914.5,
        -3854.5,
        1257.11865234375
      ],
      [
        914.5,
        -3857.5,
        1257.1865234375
      ],
      [
        914.5,
        -3831.5,
        1256.5982666015625
      ],
      [
        914.5,
        -3834.5,
        1256.6661376953125
      ],
      [
        914.5,
        -3805.5,
        1256.01025390625
      ],
      [
        914.5,
        -3808.5,
        1256.078125
      ],
      [
        914.5,
        -3857.5,
        1257.1865234375
      ],
      [
        917.5,
        -3857.5,
        1257.349365234375
      ],
      [
        917.5,
        -3854.5,
        1257.281494140625
      ],
      [
        914.5,
        -3854.5,
        1257.11865234375
      ],
      [
        917.5,
        -3854.5,
        1257.281494140625
      ],
      [
        917.5,
        -3857.5,
        1257.349365234375
      ],
      [
        914.5,
        -3834.5,
        1256.6661376953125
      ],
      [
        917.5,
        -3834.5,
        1256.8292236328125
      ],
      [
        917.5,
        -3831.5,
        1256.7613525390625
      ],
      [
        914.5,
        -3831.5,
        1256.5982666015625
      ],
      [
        917.5,
        -3831.5,
        1256.7613525390625
      ],
      [
        917.5,
        -3834.5,
        1256.8292236328125
      ],
      [
        914.5,
        -3808.5,
        1256.078125
      ],
      [
        917.5,
        -3808.5,
        1256.240966796875
      ],
      [
        917.5,
        -3805.5,
        1256.173095703125
      ],
      [
        914.5,
        -3805.5,
        1256.01025390625
      ],
      [
        917.5,
        -3805.5,
        1256.173095703125
      ],
      [
        917.5,
        -3808.5,
        1256.240966796875
      ],
      [
        891.760009765625,
        -3981.575927734375,
        1234.53955078125
      ],
      [
        929.3295288085938,
        -4104.01220703125,
        1263.5679931640625
      ],
      [
        891.760009765625,
        -3981.575927734375,
        1234.53955078125
      ],
      [
        877.2393798828125,
        -3975.0,
        1187.773681640625
      ],
      [
        892.5,
        -3975.0,
        1233.533935546875
      ],
      [
        892.201904296875,
        -3975.0,
        1233.47412109375
      ],
      [
        892.5,
        -4000.0,
        1224.0787353515625
      ],
      [
        892.5,
        -3983.9873046875,
        1235.111328125
      ],
      [
        892.5,
        -3975.0,
        1233.533935546875
      ],
      [
        867.5,
        -3982.40966796875,
        1160.747802734375
      ],
      [
        867.5,
        -3997.879638671875,
        1150.0892333984375
      ],
      [
        867.5,
        -3980.05419921875,
        1159.8828125
      ],
      [
        892.5,
        -3982.5,
        1234.8502197265625
      ],
      [
        897.4816284179688,
        -3982.5,
        1235.85009765625
      ],
      [
        884.6712036132812,
        -3958.473876953125,
        1229.062255859375
      ],
      [
        867.5,
        -3975.0,
        1165.85302734375
      ],
      [
        869.5642700195312,
        -3975.0,
        1172.0831298828125
      ],
      [
        867.5,
        -3975.0,
        1165.85302734375
      ],
      [
        867.5,
        -3977.258544921875,
        1164.296875
      ],
      [
        889.7421875,
        -3975.0,
        1232.9803466796875
      ],
      [
        892.5,
        -3981.591064453125,
        1236.76220703125
      ],
      [
        892.5,
        -3975.0,
        1234.7171630859375
      ],
      [
        892.5,
        -3975.0,
        1234.7171630859375
      ],
      [
        890.458251953125,
        -3975.0,
        1235.1414794921875
      ],
      [
        892.5,
        -3982.5,
        1236.13623046875
      ],
      [
        897.5386962890625,
        -3982.5,
        1235.9971923828125
      ],
      [
        892.7815551757812,
        -3982.5,
        1236.98583984375
      ],
      [
        828.1298828125,
        -3769.71923828125,
        1184.40185546875
      ],
      [
        830.0,
        -3742.5,
        1212.8668212890625
      ],
      [
        842.52783203125,
        -3742.5,
        1250.6759033203125
      ],
      [
        830.0,
        -3723.50341796875,
        1225.9552001953125
      ],
      [
        830.0,
        -3742.5,
        1212.8668212890625
      ],
      [
        823.6493530273438,
        -3742.5,
        1177.55224609375
      ],
      [
        823.732421875,
        -3742.5,
        1177.5384521484375
      ],
      [
        900.153564453125,
        -3982.5,
        1259.234619140625
      ],
      [
        869.5,
        -3854.5,
        1254.6744384765625
      ],
      [
        869.5,
        -3854.833740234375,
        1254.6820068359375
      ],
      [
        869.5,
        -3857.5,
        1252.8448486328125
      ],
      [
        869.5,
        -3831.5,
        1254.1541748046875
      ],
      [
        869.5,
        -3834.5,
        1254.2220458984375
      ],
      [
        869.5,
        -3857.5,
        1252.844970703125
      ],
      [
        870.14013671875,
        -3857.5,
        1254.7769775390625
      ],
      [
        872.5,
        -3857.5,
        1254.9051513671875
      ],
      [
        872.5,
        -3854.5,
        1254.83740234375
      ],
      [
        869.5,
        -3854.5,
        1254.67431640625
      ],
      [
        872.5,
        -3854.5,
        1254.83740234375
      ],
      [
        872.5,
        -3857.5,
        1254.9051513671875
      ],
      [
        869.5,
        -3834.5,
        1254.2220458984375
      ],
      [
        872.5,
        -3834.5,
        1254.3848876953125
      ],
      [
        869.5,
        -3831.5,
        1254.1541748046875
      ],
      [
        872.5,
        -3834.5,
        1254.3848876953125
      ],
      [
        892.5,
        -3975.0,
        1241.303466796875
      ],
      [
        892.5,
        -3975.0,
        1241.303466796875
      ],
      [
        884.4439086914062,
        -4090.4658203125,
        1252.1815185546875
      ],
      [
        892.9599609375,
        -4138.837890625,
        1262.3802490234375
      ],
      [
        891.614990234375,
        -4131.22998046875,
        1260.7750244140625
      ],
      [
        884.4439086914062,
        -4090.4658203125,
        1252.1815185546875
      ],
      [
        867.5,
        -4000.0,
        1167.20751953125
      ],
      [
        867.5,
        -3982.40966796875,
        1160.747802734375
      ],
      [
        892.5,
        -4000.0,
        1237.921630859375
      ],
      [
        892.5,
        -3983.987548828125,
        1235.1112060546875
      ],
      [
        892.5,
        -3982.5,
        1237.1387939453125
      ],
      [
        899.7266845703125,
        -3982.5,
        1259.21142578125
      ],
      [
        892.5,
        -4000.0,
        1243.5650634765625
      ],
      [
        892.5,
        -3982.5,
        1237.138671875
      ],
      [
        892.5,
        -3982.5,
        1236.1361083984375
      ],
      [
        892.5,
        -3981.55078125,
        1236.7901611328125
      ],
      [
        867.5,
        -3975.0,
        1257.2913818359375
      ],
      [
        892.5,
        -3975.0,
        1258.6492919921875
      ],
      [
        867.5,
        -3975.0,
        1257.2913818359375
      ],
      [
        867.5,
        -3988.988037109375,
        1257.60791015625
      ],
      [
        867.5,
        -4000.0,
        1202.7003173828125
      ],
      [
        892.5,
        -4000.0,
        1259.21484375
      ],
      [
        892.5,
        -3975.0,
        1258.6494140625
      ],
      [
        892.5,
        -3982.5,
        1258.8189697265625
      ],
      [
        830.0,
        -3742.5,
        1249.9954833984375
      ],
      [
        830.0,
        -3728.8173828125,
        1249.6859130859375
      ],
      [
        830.0,
        -3742.5,
        1249.9954833984375
      ],
      [
        869.5,
        -3857.5,
        1254.7421875
      ],
      [
        869.5,
        -3857.5,
        1254.7421875
      ],
      [
        874.18115234375,
        -3707.743408203125,
        1253.466796875
      ],
      [
        1012.5,
        -3652.37158203125,
        1258.238037109375
      ],
      [
        1012.5,
        -3728.609375,
        1269.789306640625
      ],
      [
        1012.5,
        -3710.17626953125,
        1269.789306640625
      ],
      [
        1002.5,
        -3723.693603515625,
        1269.789306640625
      ],
      [
        1002.5,
        -3649.144287109375,
        1257.7652587890625
      ],
      [
        1002.5,
        -3709.315185546875,
        1269.789306640625
      ],
      [
        1002.5,
        -3647.5,
        1257.4366455078125
      ],
      [
        1005.585205078125,
        -3647.5,
        1257.383544921875
      ],
      [
        1002.5,
        -3647.5,
        1257.2159423828125
      ],
      [
        989.5,
        -3845.0,
        1269.789306640625
      ],
      [
        989.5,
        -3791.5,
        1269.789306640625
      ],
      [
        967.5,
        -3770.5,
        1269.789306640625
      ],
      [
        934.0,
        -3770.5,
        1269.789306640625
      ],
      [
        924.0,
        -3782.5,
        1264.7454833984375
      ],
      [
        924.0,
        -3800.1533203125,
        1262.7998046875
      ],
      [
        924.0,
        -3807.5,
        1257.7403564453125
      ],
      [
        924.0,
        -3807.5,
        1257.7403564453125
      ],
      [
        924.0,
        -3809.143310546875,
        1256.608642578125
      ],
      [
        934.0,
        -3770.5,
        1269.789306640625
      ],
      [
        933.625244140625,
        -3770.94970703125,
        1269.789306640625
      ],
      [
        924.0,
        -3782.5,
        1264.7454833984375
      ],
      [
        978.5,
        -3782.5,
        1269.789306640625
      ],
      [
        967.5,
        -3770.5,
        1269.789306640625
      ],
      [
        967.5,
        -3864.5,
        1269.789306640625
      ],
      [
        978.5,
        -3852.5,
        1269.789306640625
      ],
      [
        958.6893920898438,
        -3864.5,
        1269.2984619140625
      ],
      [
        959.9423828125,
        -3864.5,
        1269.789306640625
      ],
      [
        967.5,
        -3864.5,
        1269.789306640625
      ],
      [
        951.9163818359375,
        -3864.5,
        1259.3770751953125
      ],
      [
        978.5,
        -3852.5,
        1269.789306640625
      ],
      [
        978.5,
        -3845.0,
        1269.789306640625
      ],
      [
        978.5,
        -3791.5,
        1269.789306640625
      ],
      [
        978.5,
        -3782.5,
        1269.789306640625
      ],
      [
        986.7500610351562,
        -3791.5,
        1269.789306640625
      ],
      [
        978.5,
        -3791.5,
        1269.789306640625
      ],
      [
        986.7500610351562,
        -3791.5,
        1259.617919921875
      ],
      [
        978.5,
        -3845.0,
        1269.789306640625
      ],
      [
        985.3749389648438,
        -3845.0,
        1269.789306640625
      ],
      [
        985.3749389648438,
        -3845.0,
        1260.7532958984375
      ],
      [
        989.5,
        -3845.0,
        1269.789306640625
      ],
      [
        989.5,
        -3791.5,
        1269.789306640625
      ],
      [
        917.5,
        -3781.5,
        1262.30908203125
      ],
      [
        917.5,
        -3784.5,
        1261.9783935546875
      ],
      [
        917.5,
        -3781.5,
        1262.30908203125
      ],
      [
        914.5,
        -3781.5,
        1261.1337890625
      ],
      [
        914.5,
        -3784.5,
        1259.6644287109375
      ],
      [
        915.5610961914062,
        -3784.5,
        1261.2188720703125
      ],
      [
        917.5,
        -3784.5,
        1261.9783935546875
      ],
      [
        914.5,
        -3781.5,
        1261.1337890625
      ],
      [
        914.5,
        -3782.53173828125,
        1261.0201416015625
      ],
      [
        914.5,
        -3784.5,
        1259.6644287109375
      ],
      [
        900.0,
        -3725.0,
        1261.6800537109375
      ],
      [
        883.4843139648438,
        -3725.0,
        1255.209716796875
      ],
      [
        881.566650390625,
        -3725.0,
        1252.4005126953125
      ],
      [
        900.0,
        -3735.0,
        1260.577880859375
      ],
      [
        886.6094360351562,
        -3735.0,
        1252.900634765625
      ],
      [
        888.875244140625,
        -3735.0,
        1256.219482421875
      ],
      [
        997.4312744140625,
        -3647.5,
        1257.52392578125
      ],
      [
        958.1583862304688,
        -3864.5,
        1268.5206298828125
      ],
      [
        937.4022216796875,
        -3864.5,
        1258.5887451171875
      ],
      [
        976.8275146484375,
        -3982.5,
        1263.3992919921875
      ],
      [
        1002.0364990234375,
        -3982.5,
        1269.789306640625
      ],
      [
        993.137939453125,
        -3982.5,
        1269.789306640625
      ],
      [
        924.0,
        -3807.5,
        1261.9901123046875
      ],
      [
        924.0,
        -3807.5,
        1261.9901123046875
      ],
      [
        924.0,
        -3848.293212890625,
        1257.494140625
      ],
      [
        934.0,
        -3864.5,
        1259.625732421875
      ],
      [
        934.0,
        -3864.5,
        1259.625732421875
      ],
      [
        927.13818359375,
        -3856.265869140625,
        1257.844970703125
      ],
      [
        879.4047241210938,
        -3735.0,
        1252.50927734375
      ],
      [
        875.4683837890625,
        -3725.0,
        1252.0693359375
      ],
      [
        917.5,
        -3805.5,
        1259.6640625
      ],
      [
        917.5,
        -3808.5,
        1259.3333740234375
      ],
      [
        917.5,
        -3831.5,
        1256.7984619140625
      ],
      [
        917.5,
        -3831.77978515625,
        1256.7677001953125
      ],
      [
        917.5,
        -3805.5,
        1259.6640625
      ],
      [
        914.5,
        -3805.5,
        1258.48876953125
      ],
      [
        914.5,
        -3808.5,
        1258.1580810546875
      ],
      [
        917.5,
        -3808.5,
        1259.3333740234375
      ],
      [
        914.5,
        -3805.5,
        1258.48876953125
      ],
      [
        914.5,
        -3808.5,
        1258.1580810546875
      ],
      [
        917.5,
        -3831.5,
        1256.7984619140625
      ],
      [
        917.3898315429688,
        -3831.5,
        1256.75537109375
      ],
      [
        914.5,
        -3784.5,
        1260.80322265625
      ],
      [
        914.5,
        -3784.5,
        1260.80322265625
      ],
      [
        884.6099853515625,
        -3706.22412109375,
        1269.789306640625
      ],
      [
        900.0,
        -3725.0,
        1269.789306640625
      ],
      [
        893.4375610351562,
        -3725.0,
        1269.789306640625
      ],
      [
        883.4843139648438,
        -3725.0,
        1255.209716796875
      ],
      [
        924.0,
        -3782.5,
        1269.789306640625
      ],
      [
        924.0,
        -3790.004638671875,
        1269.789306640625
      ],
      [
        924.0,
        -3800.1533203125,
        1262.7998046875
      ],
      [
        924.0,
        -3782.5,
        1269.789306640625
      ],
      [
        959.0245361328125,
        -3864.5,
        1269.789306640625
      ],
      [
        958.6893920898438,
        -3864.5,
        1269.2984619140625
      ],
      [
        898.1390380859375,
        -3735.0,
        1269.789306640625
      ],
      [
        900.0,
        -3735.0,
        1269.789306640625
      ],
      [
        888.875244140625,
        -3735.0,
        1256.219482421875
      ],
      [
        917.5,
        -3781.5,
        1266.1251220703125
      ],
      [
        914.5,
        -3781.5,
        1261.730712890625
      ],
      [
        917.5,
        -3781.5,
        1266.1251220703125
      ],
      [
        917.5,
        -3784.5,
        1264.05908203125
      ],
      [
        917.5,
        -3784.5,
        1264.05908203125
      ],
      [
        915.5610961914062,
        -3784.5,
        1261.2188720703125
      ],
      [
        914.5,
        -3781.5,
        1261.730712890625
      ],
      [
        914.5,
        -3782.53173828125,
        1261.0201416015625
      ],
      [
        899.1680297851562,
        -4173.95458984375,
        1269.789306640625
      ],
      [
        892.5,
        -3982.5,
        1269.789306640625
      ],
      [
        892.5,
        -4000.0,
        1269.789306640625
      ],
      [
        892.5,
        -3982.5,
        1269.789306640625
      ],
      [
        892.5,
        -3982.5,
        1258.819091796875
      ],
      [
        867.5,
        -3982.5,
        1269.789306640625
      ],
      [
        867.5,
        -3986.544921875,
        1269.789306640625
      ],
      [
        867.5,
        -3982.5,
        1257.4610595703125
      ],
      [
        924.0,
        -3807.5,
        1269.789306640625
      ],
      [
        924.0,
        -3807.5,
        1269.789306640625
      ],
      [
        924.0,
        -3852.5,
        1269.789306640625
      ],
      [
        934.0,
        -3864.5,
        1269.789306640625
      ],
      [
        924.0,
        -3852.5,
        1269.789306640625
      ],
      [
        934.0,
        -3864.5,
        1269.789306640625
      ],
      [
        855.0,
        -3735.0,
        1269.789306640625
      ],
      [
        855.0,
        -3725.0,
        1269.789306640625
      ],
      [
        855.0,
        -3735.0,
        1269.789306640625
      ],
      [
        855.0,
        -3725.0,
        1269.789306640625
      ],
      [
        855.0,
        -3725.0,
        1250.95751953125
      ],
      [
        855.0,
        -3735.0,
        1251.1837158203125
      ],
      [
        830.0,
        -3733.3193359375,
        1269.789306640625
      ],
      [
        830.0,
        -3735.0,
        1269.789306640625
      ],
      [
        830.0,
        -3735.0,
        1249.8258056640625
      ],
      [
        855.0,
        -3720.91552734375,
        1269.789306640625
      ],
      [
        855.0,
        -3717.5,
        1254.5374755859375
      ],
      [
        855.0,
        -3717.5,
        1254.5374755859375
      ],
      [
        830.0,
        -3742.5,
        1269.789306640625
      ],
      [
        855.0,
        -3742.5,
        1269.789306640625
      ],
      [
        830.0,
        -3742.5,
        1269.789306640625
      ],
      [
        855.0,
        -3742.5,
        1269.789306640625
      ],
      [
        867.5,
        -3975.0,
        1269.789306640625
      ],
      [
        892.5,
        -3975.0,
        1269.789306640625
      ],
      [
        867.5,
        -3975.0,
        1269.789306640625
      ],
      [
        892.5,
        -3975.0,
        1269.789306640625
      ],
      [
        872.5,
        -3781.5,
        1269.789306640625
      ],
      [
        872.5,
        -3784.5,
        1269.789306640625
      ],
      [
        872.5,
        -3831.5,
        1269.789306640625
      ],
      [
        872.5,
        -3834.5,
        1269.789306640625
      ],
      [
        872.5,
        -3854.5,
        1269.789306640625
      ],
      [
        872.5,
        -3857.5,
        1269.789306640625
      ],
      [
        872.5,
        -3805.5,
        1269.789306640625
      ],
      [
        872.5,
        -3808.5,
        1269.789306640625
      ],
      [
        869.5,
        -3781.5,
        1269.789306640625
      ],
      [
        869.5,
        -3784.5,
        1269.789306640625
      ],
      [
        869.5,
        -3831.5,
        1269.789306640625
      ],
      [
        869.5,
        -3834.5,
        1269.789306640625
      ],
      [
        869.5,
        -3854.5,
        1269.789306640625
      ],
      [
        869.5,
        -3857.5,
        1269.789306640625
      ],
      [
        869.5,
        -3805.5,
        1269.789306640625
      ],
      [
        869.5,
        -3808.5,
        1269.789306640625
      ],
      [
        872.5,
        -3781.5,
        1269.789306640625
      ],
      [
        869.5,
        -3781.5,
        1269.789306640625
      ],
      [
        869.5,
        -3784.5,
        1269.789306640625
      ],
      [
        872.5,
        -3784.5,
        1269.789306640625
      ],
      [
        872.5,
        -3805.5,
        1269.789306640625
      ],
      [
        869.5,
        -3805.5,
        1269.789306640625
      ],
      [
        869.5,
        -3808.5,
        1269.789306640625
      ],
      [
        872.5,
        -3808.5,
        1269.789306640625
      ],
      [
        872.5,
        -3831.5,
        1269.789306640625
      ],
      [
        869.5,
        -3831.5,
        1269.789306640625
      ],
      [
        869.5,
        -3834.5,
        1269.789306640625
      ],
      [
        872.5,
        -3834.5,
        1269.789306640625
      ],
      [
        872.5,
        -3854.5,
        1269.789306640625
      ],
      [
        869.5,
        -3854.5,
        1269.789306640625
      ],
      [
        869.5,
        -3857.5,
        1269.789306640625
      ],
      [
        872.5,
        -3857.5,
        1269.789306640625
      ],
      [
        917.5,
        -3831.5,
        1269.789306640625
      ],
      [
        914.5,
        -3831.5,
        1269.789306640625
      ],
      [
        914.5,
        -3831.5,
        1269.789306640625
      ],
      [
        914.5,
        -3834.5,
        1269.789306640625
      ],
      [
        914.5,
        -3854.5,
        1269.789306640625
      ],
      [
        914.5,
        -3857.5,
        1269.789306640625
      ],
      [
        914.5,
        -3834.5,
        1269.789306640625
      ],
      [
        917.5,
        -3834.5,
        1269.789306640625
      ],
      [
        917.5,
        -3831.5,
        1269.789306640625
      ],
      [
        917.5,
        -3834.5,
        1269.789306640625
      ],
      [
        917.5,
        -3854.5,
        1269.789306640625
      ],
      [
        914.5,
        -3854.5,
        1269.789306640625
      ],
      [
        914.5,
        -3857.5,
        1269.789306640625
      ],
      [
        917.5,
        -3857.5,
        1269.789306640625
      ],
      [
        917.5,
        -3854.5,
        1269.789306640625
      ],
      [
        917.5,
        -3857.5,
        1269.789306640625
      ],
      [
        914.5,
        -3805.5,
        1269.789306640625
      ],
      [
        914.5,
        -3808.5,
        1269.789306640625
      ],
      [
        914.5,
        -3781.5,
        1269.789306640625
      ],
      [
        914.5,
        -3784.5,
        1269.789306640625
      ],
      [
        914.5,
        -3808.5,
        1269.789306640625
      ],
      [
        917.5,
        -3808.5,
        1269.789306640625
      ],
      [
        917.5,
        -3805.5,
        1269.789306640625
      ],
      [
        914.5,
        -3805.5,
        1269.789306640625
      ],
      [
        917.5,
        -3805.5,
        1269.789306640625
      ],
      [
        917.5,
        -3808.5,
        1269.789306640625
      ],
      [
        914.5,
        -3784.5,
        1269.789306640625
      ],
      [
        917.5,
        -3784.5,
        1269.789306640625
      ],
      [
        917.5,
        -3781.5,
        1269.789306640625
      ],
      [
        914.5,
        -3781.5,
        1269.789306640625
      ],
      [
        917.5,
        -3781.5,
        1269.789306640625
      ],
      [
        917.5,
        -3784.5,
        1269.789306640625
      ],
      [
        965.5023803710938,
        -3666.088623046875,
        1269.789306640625
      ],
      [
        997.7568969726562,
        -3647.5,
        1258.2454833984375
      ],
      [
        1000.7955932617188,
        -3647.5,
        1257.466064453125
      ],
      [
        1012.5,
        -3647.5,
        1263.250244140625
      ],
      [
        1012.5,
        -3652.811279296875,
        1269.789306640625
      ],
      [
        1002.5,
        -3647.5,
        1259.89013671875
      ],
      [
        1002.5,
        -3655.540771484375,
        1269.789306640625
      ],
      [
        1002.5,
        -3647.5,
        1259.89013671875
      ],
      [
        1012.5,
        -3647.5,
        1263.2503662109375
      ],
      [
        1012.5,
        -3647.5,
        1257.7591552734375
      ],
      [
        1002.5,
        -3647.5,
        1257.4366455078125
      ],
      [
        997.7839965820312,
        -3647.5,
        1258.305419921875
      ],
      [
        1020.0,
        -3647.5,
        1265.7705078125
      ],
      [
        1020.0,
        -3647.5,
        1265.7705078125
      ],
      [
        1002.9671020507812,
        -3647.5,
        1269.789306640625
      ],
      [
        1020.0,
        -3647.5,
        1269.789306640625
      ],
      [
        1020.0,
        -3647.5,
        1269.789306640625
      ],
      [
        1020.0,
        -3639.048828125,
        1269.789306640625
      ],
      [
        1002.5,
        -3647.5,
        1268.754150390625
      ],
      [
        1002.5,
        -3647.73193359375,
        1269.789306640625
      ],
      [
        1012.5,
        -3647.5,
        1269.789306640625
      ],
      [
        813.1619262695312,
        -3678.788818359375,
        1161.51953125
      ],
      [
        976.9523315429688,
        -3613.7265625,
        1242.7796630859375
      ],
      [
        995.0,
        -3622.5,
        1184.5966796875
      ],
      [
        995.0,
        -3641.282470703125,
        1269.789306640625
      ],
      [
        995.0,
        -3647.5,
        1269.789306640625
      ],
      [
        995.0,
        -3622.5,
        1184.5965576171875
      ],
      [
        1000.7686767578125,
        -3622.5,
        1153.279296875
      ],
      [
        995.0,
        -3647.5,
        1269.789306640625
      ],
      [
        1000.1948852539062,
        -3647.5,
        1269.789306640625
      ],
      [
        1000.9984130859375,
        -3647.5,
        1265.4273681640625
      ],
      [
        995.0,
        -3637.697509765625,
        1253.5289306640625
      ],
      [
        995.0,
        -3639.660400390625,
        1257.5733642578125
      ],
      [
        997.7565307617188,
        -3647.5,
        1258.2454833984375
      ],
      [
        995.0,
        -3647.5,
        1258.9525146484375
      ],
      [
        995.0,
        -3639.660400390625,
        1257.5733642578125
      ],
      [
        995.0,
        -3649.088623046875,
        1259.2320556640625
      ],
      [
        863.269775390625,
        -3660.834716796875,
        1269.789306640625
      ],
      [
        833.2885131835938,
        -3671.887451171875,
        1218.2603759765625
      ],
      [
        940.3001098632812,
        -3629.3427734375,
        1269.789306640625
      ],
      [
        971.6315307617188,
        -3616.2919921875,
        1259.4564208984375
      ],
      [
        824.448974609375,
        -3714.98779296875,
        1175.62890625
      ],
      [
        817.8761596679688,
        -3676.84375,
        1160.7587890625
      ],
      [
        819.9124755859375,
        -3676.818115234375,
        1195.2711181640625
      ],
      [
        976.9523315429688,
        -3613.7265625,
        1242.7796630859375
      ],
      [
        971.6315307617188,
        -3616.2919921875,
        1259.4564208984375
      ],
      [
        817.8761596679688,
        -3676.84375,
        1160.7587890625
      ],
      [
        814.2550659179688,
        -3678.334716796875,
        1161.210205078125
      ],
      [
        818.4602661132812,
        -3710.97607421875,
        1169.6192626953125
      ],
      [
        813.1619262695312,
        -3678.788818359375,
        1161.51953125
      ],
      [
        814.2550659179688,
        -3678.334716796875,
        1161.210205078125
      ],
      [
        821.126708984375,
        -3715.4716796875,
        1170.4290771484375
      ],
      [
        830.0,
        -3717.5,
        1269.789306640625
      ],
      [
        830.0,
        -3717.5,
        1269.789306640625
      ],
      [
        855.0,
        -3717.5,
        1269.789306640625
      ],
      [
        855.0,
        -3717.5,
        1269.789306640625
      ],
      [
        833.3350219726562,
        -3717.5,
        1216.03515625
      ],
      [
        830.0,
        -3719.15283203125,
        1206.5272216796875
      ],
      [
        830.0,
        -3717.5,
        1207.435302734375
      ],
      [
        838.8036499023438,
        -3717.5,
        1218.65185546875
      ],
      [
        833.3350219726562,
        -3717.5,
        1216.03515625
      ],
      [
        833.2885131835938,
        -3671.887451171875,
        1218.2603759765625
      ],
      [
        830.0,
        -3703.49609375,
        1215.1292724609375
      ],
      [
        830.0,
        -3673.193603515625,
        1216.6224365234375
      ],
      [
        830.0,
        -3703.49609375,
        1215.1292724609375
      ],
      [
        820.5045166015625,
        -3676.810791015625,
        1205.30517578125
      ],
      [
        823.4071044921875,
        -3675.81201171875,
        1213.338623046875
      ],
      [
        820.5045166015625,
        -3676.810791015625,
        1205.30517578125
      ],
      [
        823.4071044921875,
        -3675.81201171875,
        1213.338623046875
      ],
      [
        995.0,
        -3622.5,
        1269.789306640625
      ],
      [
        1020.0,
        -3622.5,
        1269.789306640625
      ],
      [
        995.0,
        -3622.5,
        1269.789306640625
      ],
      [
        1020.0,
        -3622.5,
        1269.789306640625
      ],
      [
        1002.5,
        -3647.5,
        1269.789306640625
      ],
      [
        884.4342041015625,
        -4090.610595703125,
        1252.2049560546875
      ],
      [
        884.4342041015625,
        -4090.610595703125,
        1252.2049560546875
      ],
      [
        867.5,
        -3987.632568359375,
        1269.789306640625
      ],
      [
        867.5,
        -4000.0,
        1204.74951171875
      ],
      [
        1332.18701171875,
        -4177.52783203125,
        1397.915771484375
      ],
      [
        1012.5,
        -4578.31103515625,
        1763.13037109375
      ],
      [
        1002.5,
        -4587.47119140625,
        1763.7960205078125
      ],
      [
        1002.5,
        -4598.06396484375,
        1580.5767822265625
      ],
      [
        1012.5,
        -4578.5986328125,
        1758.157470703125
      ],
      [
        1012.5,
        -3622.5,
        1362.5
      ],
      [
        1002.5,
        -3622.5,
        1362.5
      ],
      [
        1002.5,
        -3622.5,
        1269.789306640625
      ],
      [
        1012.5,
        -3622.5,
        1269.789306640625
      ],
      [
        1002.5,
        -3647.5,
        1362.5
      ],
      [
        1012.5,
        -3647.5,
        1362.5
      ],
      [
        1012.5,
        -3647.5,
        1269.789306640625
      ],
      [
        1002.5,
        -3647.5,
        1269.789306640625
      ],
      [
        892.5,
        -3982.5,
        1362.5
      ],
      [
        892.5,
        -3982.5,
        1269.789306640625
      ],
      [
        867.5,
        -3982.5,
        1296.781494140625
      ],
      [
        867.5,
        -3982.5,
        1269.789306640625
      ],
      [
        855.0,
        -3735.0,
        1362.5
      ],
      [
        855.0,
        -3725.0,
        1362.5
      ],
      [
        855.0,
        -3725.0,
        1269.789306640625
      ],
      [
        855.0,
        -3735.0,
        1269.789306640625
      ],
      [
        830.0,
        -3725.0,
        1362.5
      ],
      [
        830.0,
        -3735.0,
        1362.5
      ],
      [
        830.0,
        -3735.0,
        1269.789306640625
      ],
      [
        830.0,
        -3725.0,
        1269.789306640625
      ],
      [
        867.5,
        -3975.0,
        1295.0
      ],
      [
        867.5,
        -3975.0,
        1298.0
      ],
      [
        867.5,
        -3982.268310546875,
        1298.0
      ],
      [
        867.5,
        -3982.5,
        1295.0
      ],
      [
        867.5,
        -3975.0,
        1298.0
      ],
      [
        867.5,
        -3975.0,
        1295.0
      ],
      [
        892.5,
        -3975.0,
        1295.0
      ],
      [
        892.5,
        -3975.0,
        1298.0
      ],
      [
        892.5,
        -3975.0,
        1298.0
      ],
      [
        892.5,
        -3975.0,
        1295.0
      ],
      [
        892.5,
        -3982.5,
        1295.0
      ],
      [
        892.5,
        -3982.5,
        1298.0
      ],
      [
        949.5,
        -3817.5,
        1298.0
      ],
      [
        949.5,
        -3813.78271484375,
        1298.0
      ],
      [
        949.5,
        -3806.21728515625,
        1298.0
      ],
      [
        949.5,
        -3787.5,
        1298.0
      ],
      [
        949.5,
        -3863.0,
        1298.0
      ],
      [
        949.5,
        -3817.5,
        1298.0
      ],
      [
        967.5,
        -3787.5,
        1298.0
      ],
      [
        967.5,
        -3817.5,
        1298.0
      ],
      [
        978.5,
        -3846.125,
        1298.0
      ],
      [
        978.5,
        -3852.5,
        1298.0
      ],
      [
        978.5,
        -3790.14990234375,
        1298.0
      ],
      [
        978.5,
        -3782.5,
        1298.0
      ],
      [
        978.5,
        -3836.0,
        1298.0
      ],
      [
        978.5,
        -3846.125,
        1298.0
      ],
      [
        978.5,
        -3790.14990234375,
        1298.0
      ],
      [
        978.5,
        -3818.85009765625,
        1298.0
      ],
      [
        967.5,
        -3770.5,
        1298.0
      ],
      [
        978.5,
        -3782.5,
        1298.0
      ],
      [
        978.5,
        -3852.5,
        1298.0
      ],
      [
        967.5,
        -3864.5,
        1298.0
      ],
      [
        974.0,
        -3822.5,
        1298.0
      ],
      [
        974.0,
        -3818.85009765625,
        1298.0
      ],
      [
        974.0,
        -3832.0,
        1298.0
      ],
      [
        974.0,
        -3836.0,
        1298.0
      ],
      [
        971.0,
        -3835.0,
        1298.0
      ],
      [
        971.0,
        -3832.0,
        1298.0
      ],
      [
        971.0,
        -3819.0,
        1298.0
      ],
      [
        971.0,
        -3822.5,
        1298.0
      ],
      [
        974.0,
        -3832.0,
        1298.0
      ],
      [
        971.0,
        -3832.0,
        1298.0
      ],
      [
        971.0,
        -3822.5,
        1298.0
      ],
      [
        974.0,
        -3822.5,
        1298.0
      ],
      [
        971.0,
        -3835.0,
        1298.0
      ],
      [
        967.5,
        -3835.0,
        1298.0
      ],
      [
        967.5,
        -3835.0,
        1295.0
      ],
      [
        967.5,
        -3819.0,
        1298.0
      ],
      [
        971.0,
        -3819.0,
        1298.0
      ],
      [
        967.5,
        -3819.0,
        1295.4200439453125
      ],
      [
        967.5,
        -3819.0,
        1295.4200439453125
      ],
      [
        967.5,
        -3819.0,
        1295.0
      ],
      [
        978.5,
        -3836.0,
        1298.0
      ],
      [
        974.0,
        -3836.0,
        1298.0
      ],
      [
        974.0,
        -3818.85009765625,
        1298.0
      ],
      [
        978.5,
        -3818.85009765625,
        1298.0
      ],
      [
        983.5,
        -3802.5,
        1298.0
      ],
      [
        983.5,
        -3797.0,
        1298.0
      ],
      [
        983.5,
        -3797.0,
        1298.0
      ],
      [
        983.5,
        -3791.5,
        1298.0
      ],
      [
        978.5,
        -3797.0,
        1298.0
      ],
      [
        983.5,
        -3797.0,
        1298.0
      ],
      [
        978.5,
        -3791.5,
        1298.0
      ],
      [
        983.5,
        -3791.5,
        1298.0
      ],
      [
        978.5,
        -3802.5,
        1298.0
      ],
      [
        983.5,
        -3802.5,
        1298.0
      ],
      [
        949.5,
        -3770.5,
        1295.0
      ],
      [
        967.5,
        -3770.5,
        1296.5
      ],
      [
        949.5,
        -3770.5,
        1296.5
      ],
      [
        967.5,
        -3864.5,
        1296.5
      ],
      [
        949.5,
        -3864.5,
        1295.0
      ],
      [
        949.5,
        -3864.5,
        1296.5
      ],
      [
        951.5,
        -3835.0,
        1296.5
      ],
      [
        967.5,
        -3835.0,
        1296.5
      ],
      [
        951.5,
        -3819.0,
        1296.5
      ],
      [
        951.5,
        -3835.0,
        1296.5
      ],
      [
        967.5,
        -3819.0,
        1296.5
      ],
      [
        953.0,
        -3819.71240234375,
        1296.5
      ],
      [
        951.5,
        -3819.71240234375,
        1296.5
      ],
      [
        960.0,
        -3819.71240234375,
        1296.5
      ],
      [
        958.5,
        -3819.71240234375,
        1296.5
      ],
      [
        958.5,
        -3819.71240234375,
        1296.5
      ],
      [
        958.5,
        -3819.0,
        1296.5
      ],
      [
        960.0,
        -3819.0,
        1296.5
      ],
      [
        960.0,
        -3819.71240234375,
        1296.5
      ],
      [
        953.0,
        -3819.0,
        1296.5
      ],
      [
        953.0,
        -3819.71240234375,
        1296.5
      ],
      [
        949.5,
        -3787.5,
        1298.0
      ],
      [
        967.5,
        -3787.5,
        1298.0
      ],
      [
        967.5,
        -3770.5,
        1298.0
      ],
      [
        949.5,
        -3770.5,
        1298.0
      ],
      [
        967.5,
        -3864.5,
        1298.0
      ],
      [
        949.5,
        -3864.5,
        1298.0
      ],
      [
        950.5,
        -3813.78271484375,
        1298.0
      ],
      [
        950.5,
        -3817.5,
        1298.0
      ],
      [
        950.5,
        -3787.5,
        1298.0
      ],
      [
        950.5,
        -3806.21728515625,
        1298.0
      ],
      [
        949.5,
        -3813.78271484375,
        1298.0
      ],
      [
        950.5,
        -3813.78271484375,
        1298.0
      ],
      [
        949.5,
        -3817.5,
        1298.0
      ],
      [
        950.5,
        -3817.5,
        1296.5
      ],
      [
        950.5,
        -3817.5,
        1298.0
      ],
      [
        950.5,
        -3806.21728515625,
        1298.0
      ],
      [
        949.5,
        -3806.21728515625,
        1298.0
      ],
      [
        951.5,
        -3835.0,
        1298.0
      ],
      [
        951.5,
        -3819.0,
        1298.0
      ],
      [
        951.5,
        -3835.0,
        1298.0
      ],
      [
        951.5,
        -3817.5,
        1296.5
      ],
      [
        951.5,
        -3817.5,
        1298.0
      ],
      [
        958.5,
        -3819.0,
        1298.0
      ],
      [
        953.0,
        -3817.5,
        1298.0
      ],
      [
        958.5,
        -3817.5,
        1298.0
      ],
      [
        967.5,
        -3817.5,
        1298.0
      ],
      [
        958.5,
        -3817.5,
        1298.0
      ],
      [
        958.5,
        -3819.0,
        1298.0
      ],
      [
        953.0,
        -3817.5,
        1298.0
      ],
      [
        953.0,
        -3819.0,
        1298.0
      ],
      [
        953.0,
        -3820.4248046875,
        1298.0
      ],
      [
        951.5,
        -3820.4248046875,
        1298.0
      ],
      [
        960.0,
        -3820.4248046875,
        1298.0
      ],
      [
        958.5,
        -3820.4248046875,
        1298.0
      ],
      [
        958.5,
        -3820.4248046875,
        1298.0
      ],
      [
        958.5,
        -3819.0,
        1298.0
      ],
      [
        960.0,
        -3819.0,
        1298.0
      ],
      [
        960.0,
        -3820.4248046875,
        1298.0
      ],
      [
        953.0,
        -3819.0,
        1298.0
      ],
      [
        953.0,
        -3820.4248046875,
        1298.0
      ],
      [
        924.0,
        -3805.0,
        1296.5
      ],
      [
        924.0,
        -3808.6787109375,
        1296.5
      ],
      [
        924.0,
        -3850.470703125,
        1296.5
      ],
      [
        924.0,
        -3849.607177734375,
        1296.5
      ],
      [
        924.0,
        -3787.5,
        1296.5
      ],
      [
        924.0,
        -3782.5,
        1296.5
      ],
      [
        924.0,
        -3852.5,
        1296.5
      ],
      [
        924.0,
        -3850.470703125,
        1296.5
      ],
      [
        924.0,
        -3787.5,
        1296.5
      ],
      [
        924.0,
        -3805.0,
        1296.5
      ],
      [
        924.0,
        -3808.6787109375,
        1296.5
      ],
      [
        924.0,
        -3849.607177734375,
        1296.5
      ],
      [
        934.0,
        -3864.5,
        1296.5
      ],
      [
        924.0,
        -3852.5,
        1296.5
      ],
      [
        924.0,
        -3782.5,
        1296.5
      ],
      [
        934.0,
        -3770.5,
        1296.5
      ],
      [
        934.0,
        -3770.5,
        1296.5
      ],
      [
        949.5,
        -3770.5,
        1296.5
      ],
      [
        934.0,
        -3864.5,
        1296.5
      ],
      [
        949.5,
        -3864.5,
        1296.5
      ],
      [
        925.5,
        -3809.0,
        1298.0
      ],
      [
        925.5,
        -3808.25,
        1298.0
      ],
      [
        925.5,
        -3808.25,
        1298.0
      ],
      [
        925.5,
        -3807.5,
        1298.0
      ],
      [
        925.5,
        -3804.0,
        1298.0
      ],
      [
        925.5,
        -3807.5,
        1298.0
      ],
      [
        925.5,
        -3804.0,
        1298.0
      ],
      [
        925.5,
        -3787.5,
        1298.0
      ],
      [
        925.5,
        -3850.03564453125,
        1298.0
      ],
      [
        925.5,
        -3848.818115234375,
        1298.0
      ],
      [
        925.5,
        -3852.5,
        1298.0
      ],
      [
        925.5,
        -3850.03564453125,
        1298.0
      ],
      [
        925.5,
        -3848.818115234375,
        1298.0
      ],
      [
        925.5,
        -3809.0,
        1298.0
      ],
      [
        924.0,
        -3809.857177734375,
        1298.0
      ],
      [
        924.0,
        -3848.441162109375,
        1298.0
      ],
      [
        924.0,
        -3846.71435546875,
        1298.0
      ],
      [
        924.0,
        -3782.5,
        1298.0
      ],
      [
        924.0,
        -3852.5,
        1298.0
      ],
      [
        924.0,
        -3848.441162109375,
        1298.0
      ],
      [
        924.0,
        -3809.857177734375,
        1298.0
      ],
      [
        924.0,
        -3846.71435546875,
        1298.0
      ],
      [
        924.0,
        -3782.5,
        1298.0
      ],
      [
        925.5,
        -3780.699951171875,
        1296.5
      ],
      [
        925.5,
        -3780.699951171875,
        1298.0
      ],
      [
        925.5,
        -3854.300048828125,
        1296.5
      ],
      [
        924.0,
        -3852.5,
        1298.0
      ],
      [
        925.5,
        -3854.300048828125,
        1298.0
      ],
      [
        932.5,
        -3862.699951171875,
        1296.5
      ],
      [
        925.5,
        -3854.300048828125,
        1297.5
      ],
      [
        932.5,
        -3862.699951171875,
        1297.5
      ],
      [
        932.5,
        -3772.300048828125,
        1296.5
      ],
      [
        932.5,
        -3772.300048828125,
        1297.5
      ],
      [
        925.5,
        -3780.699951171875,
        1297.5
      ],
      [
        925.5,
        -3852.5,
        1297.5
      ],
      [
        932.5,
        -3860.666748046875,
        1296.5
      ],
      [
        932.5,
        -3860.666748046875,
        1297.5
      ],
      [
        925.5,
        -3843.0,
        1297.5
      ],
      [
        932.5,
        -3843.0,
        1296.5
      ],
      [
        932.5,
        -3843.0,
        1297.5
      ],
      [
        925.5,
        -3850.0,
        1297.5
      ],
      [
        932.5,
        -3850.0,
        1296.5
      ],
      [
        932.5,
        -3850.0,
        1297.5
      ],
      [
        932.5,
        -3852.5,
        1296.5
      ],
      [
        925.5,
        -3852.5,
        1297.5
      ],
      [
        932.5,
        -3852.5,
        1297.5
      ],
      [
        932.5,
        -3845.5,
        1296.5
      ],
      [
        925.5,
        -3845.5,
        1297.5
      ],
      [
        932.5,
        -3845.5,
        1297.5
      ],
      [
        932.5,
        -3787.5,
        1296.5
      ],
      [
        925.5,
        -3787.5,
        1297.5
      ],
      [
        932.5,
        -3787.5,
        1297.5
      ],
      [
        926.8333129882812,
        -3802.5,
        1297.5
      ],
      [
        926.8333129882812,
        -3792.5,
        1297.5
      ],
      [
        925.5,
        -3802.5,
        1297.5
      ],
      [
        926.8333129882812,
        -3802.5,
        1297.5
      ],
      [
        926.8333129882812,
        -3792.5,
        1297.5
      ],
      [
        925.5,
        -3792.5,
        1297.5
      ],
      [
        926.8336181640625,
        -3809.0,
        1297.5
      ],
      [
        929.5001220703125,
        -3809.0,
        1296.5
      ],
      [
        926.5,
        -3839.0,
        1298.0
      ],
      [
        926.5,
        -3813.0,
        1298.0
      ],
      [
        925.5,
        -3839.0,
        1298.0
      ],
      [
        926.5,
        -3839.0,
        1298.0
      ],
      [
        926.5,
        -3792.5,
        1297.625
      ],
      [
        926.5,
        -3792.5,
        1297.5
      ],
      [
        926.5,
        -3802.5,
        1297.625
      ],
      [
        926.5,
        -3792.5,
        1297.625
      ],
      [
        926.5,
        -3813.0,
        1297.625
      ],
      [
        925.5,
        -3813.0,
        1298.0
      ],
      [
        926.5,
        -3802.5,
        1297.625
      ],
      [
        926.5,
        -3802.5,
        1297.5
      ],
      [
        926.5,
        -3813.0,
        1298.0
      ],
      [
        926.5,
        -3779.5,
        1298.0
      ],
      [
        926.5,
        -3779.5,
        1297.5
      ],
      [
        925.5,
        -3787.5,
        1298.0
      ],
      [
        926.5,
        -3787.5,
        1298.0
      ],
      [
        926.5,
        -3787.5,
        1297.5
      ],
      [
        926.5,
        -3853.666748046875,
        1298.0
      ],
      [
        925.5,
        -3852.5,
        1298.0
      ],
      [
        926.5,
        -3853.666748046875,
        1297.5
      ],
      [
        926.5,
        -3855.5,
        1298.0
      ],
      [
        926.5,
        -3855.5,
        1297.5
      ],
      [
        925.5,
        -3845.5,
        1298.0
      ],
      [
        926.5,
        -3845.5,
        1298.0
      ],
      [
        926.5,
        -3845.5,
        1297.5
      ],
      [
        926.5,
        -3843.0,
        1298.0
      ],
      [
        925.5,
        -3843.0,
        1298.0
      ],
      [
        926.5,
        -3843.0,
        1297.5
      ],
      [
        925.5,
        -3852.5,
        1298.0
      ],
      [
        926.5,
        -3852.5,
        1298.0
      ],
      [
        926.5,
        -3852.5,
        1297.5
      ],
      [
        926.5,
        -3850.0,
        1298.0
      ],
      [
        925.5,
        -3850.0,
        1298.0
      ],
      [
        926.5,
        -3850.0,
        1297.5
      ],
      [
        932.5,
        -3862.699951171875,
        1298.0
      ],
      [
        932.5,
        -3772.300048828125,
        1298.0
      ],
      [
        932.5,
        -3860.666748046875,
        1298.0
      ],
      [
        932.5,
        -3843.0,
        1298.0
      ],
      [
        932.5,
        -3850.0,
        1298.0
      ],
      [
        932.5,
        -3852.5,
        1298.0
      ],
      [
        932.5,
        -3845.5,
        1298.0
      ],
      [
        926.8334350585938,
        -3787.5,
        1297.5
      ],
      [
        926.5,
        -3787.5,
        1297.625
      ],
      [
        932.5,
        -3787.5,
        1298.0
      ],
      [
        934.0,
        -3770.5,
        1298.0
      ],
      [
        934.0,
        -3864.5,
        1298.0
      ],
      [
        934.5,
        -3787.5,
        1298.0
      ],
      [
        934.5,
        -3787.5,
        1298.0
      ],
      [
        949.5,
        -3787.5,
        1298.0
      ],
      [
        934.0,
        -3770.5,
        1298.0
      ],
      [
        949.5,
        -3863.0,
        1298.0
      ],
      [
        934.5,
        -3863.0,
        1298.0
      ],
      [
        934.0,
        -3864.5,
        1298.0
      ],
      [
        932.7500610351562,
        -3863.0,
        1296.5
      ],
      [
        932.7500610351562,
        -3863.0,
        1298.0
      ],
      [
        934.5,
        -3863.0,
        1298.0
      ],
      [
        933.0,
        -3845.5,
        1298.0
      ],
      [
        934.0,
        -3845.0,
        1298.0
      ],
      [
        934.0,
        -3845.0,
        1298.0
      ],
      [
        934.0,
        -3843.5,
        1298.0
      ],
      [
        933.0,
        -3843.0,
        1298.0
      ],
      [
        934.0,
        -3843.5,
        1298.0
      ],
      [
        933.0,
        -3843.0,
        1298.0
      ],
      [
        933.0,
        -3845.5,
        1298.0
      ],
      [
        934.0,
        -3852.0,
        1298.0
      ],
      [
        934.0,
        -3850.5,
        1298.0
      ],
      [
        933.0,
        -3850.0,
        1298.0
      ],
      [
        934.0,
        -3850.5,
        1298.0
      ],
      [
        933.0,
        -3852.5,
        1298.0
      ],
      [
        934.0,
        -3852.0,
        1298.0
      ],
      [
        933.0,
        -3852.5,
        1298.0
      ],
      [
        933.0,
        -3850.0,
        1298.0
      ],
      [
        986.7500610351562,
        -3791.5,
        1295.0
      ],
      [
        986.7500610351562,
        -3791.5,
        1269.789306640625
      ],
      [
        985.3749389648438,
        -3845.0,
        1295.0
      ],
      [
        985.3749389648438,
        -3845.0,
        1269.789306640625
      ],
      [
        914.5,
        -3858.0,
        1295.0
      ],
      [
        917.5,
        -3858.0,
        1295.0
      ],
      [
        917.5,
        -3858.0,
        1292.0
      ],
      [
        914.5,
        -3858.0,
        1292.0
      ],
      [
        914.5,
        -3858.0,
        1292.0
      ],
      [
        917.5,
        -3858.0,
        1292.0
      ],
      [
        918.0,
        -3854.5,
        1295.0
      ],
      [
        918.0,
        -3854.5,
        1292.0
      ],
      [
        918.0,
        -3854.5,
        1292.0
      ],
      [
        918.0,
        -3834.5,
        1295.0
      ],
      [
        918.0,
        -3831.5,
        1295.0
      ],
      [
        918.0,
        -3831.5,
        1292.0
      ],
      [
        918.0,
        -3834.5,
        1292.0
      ],
      [
        918.0,
        -3834.5,
        1292.0
      ],
      [
        918.0,
        -3831.5,
        1292.0
      ],
      [
        914.5,
        -3854.0,
        1292.0
      ],
      [
        914.5,
        -3854.0,
        1295.0
      ],
      [
        914.5,
        -3854.0,
        1292.0
      ],
      [
        914.5,
        -3835.0,
        1295.0
      ],
      [
        914.5,
        -3835.0,
        1292.0
      ],
      [
        914.5,
        -3835.0,
        1292.0
      ],
      [
        869.5,
        -3858.0,
        1295.0
      ],
      [
        872.5,
        -3858.0,
        1295.0
      ],
      [
        872.5,
        -3858.0,
        1292.0
      ],
      [
        869.5,
        -3858.0,
        1292.0
      ],
      [
        869.5,
        -3858.0,
        1292.0
      ],
      [
        872.5,
        -3858.0,
        1292.0
      ],
      [
        869.0,
        -3854.5,
        1292.0
      ],
      [
        869.0,
        -3854.5,
        1295.0
      ],
      [
        869.0,
        -3854.5,
        1292.0
      ],
      [
        869.0,
        -3834.5,
        1292.0
      ],
      [
        869.0,
        -3831.5,
        1292.0
      ],
      [
        869.0,
        -3831.5,
        1295.0
      ],
      [
        869.0,
        -3834.5,
        1295.0
      ],
      [
        869.0,
        -3831.5,
        1292.0
      ],
      [
        869.0,
        -3834.5,
        1292.0
      ],
      [
        872.5,
        -3854.0,
        1292.0
      ],
      [
        872.5,
        -3854.0,
        1295.0
      ],
      [
        872.5,
        -3854.0,
        1292.0
      ],
      [
        872.5,
        -3835.0,
        1295.0
      ],
      [
        872.5,
        -3835.0,
        1292.0
      ],
      [
        872.5,
        -3835.0,
        1292.0
      ],
      [
        914.0,
        -3831.5,
        1292.0
      ],
      [
        914.0,
        -3831.5,
        1295.0
      ],
      [
        914.0,
        -3831.5,
        1292.0
      ],
      [
        873.0,
        -3831.5,
        1295.0
      ],
      [
        873.0,
        -3831.5,
        1292.0
      ],
      [
        873.0,
        -3831.5,
        1292.0
      ],
      [
        918.0,
        -3808.5,
        1295.0
      ],
      [
        918.0,
        -3805.5,
        1295.0
      ],
      [
        918.0,
        -3805.5,
        1292.0
      ],
      [
        918.0,
        -3808.5,
        1292.0
      ],
      [
        918.0,
        -3808.5,
        1292.0
      ],
      [
        918.0,
        -3805.5,
        1292.0
      ],
      [
        914.5,
        -3831.0,
        1292.0
      ],
      [
        914.5,
        -3831.0,
        1295.0
      ],
      [
        914.5,
        -3831.0,
        1292.0
      ],
      [
        914.5,
        -3809.0,
        1295.0
      ],
      [
        914.5,
        -3809.0,
        1292.0
      ],
      [
        914.5,
        -3809.0,
        1292.0
      ],
      [
        869.0,
        -3808.5,
        1292.0
      ],
      [
        869.0,
        -3805.5,
        1292.0
      ],
      [
        869.0,
        -3805.5,
        1295.0
      ],
      [
        869.0,
        -3808.5,
        1295.0
      ],
      [
        869.0,
        -3805.5,
        1292.0
      ],
      [
        869.0,
        -3808.5,
        1292.0
      ],
      [
        872.5,
        -3831.0,
        1292.0
      ],
      [
        872.5,
        -3831.0,
        1295.0
      ],
      [
        872.5,
        -3831.0,
        1292.0
      ],
      [
        872.5,
        -3809.0,
        1295.0
      ],
      [
        872.5,
        -3809.0,
        1292.0
      ],
      [
        872.5,
        -3809.0,
        1292.0
      ],
      [
        914.0,
        -3805.5,
        1292.0
      ],
      [
        914.0,
        -3805.5,
        1295.0
      ],
      [
        914.0,
        -3805.5,
        1292.0
      ],
      [
        873.0,
        -3805.5,
        1295.0
      ],
      [
        873.0,
        -3805.5,
        1292.0
      ],
      [
        873.0,
        -3805.5,
        1292.0
      ],
      [
        869.0,
        -3784.5,
        1292.0
      ],
      [
        869.0,
        -3781.5,
        1292.0
      ],
      [
        869.0,
        -3781.5,
        1295.0
      ],
      [
        869.0,
        -3784.5,
        1295.0
      ],
      [
        869.0,
        -3781.5,
        1292.0
      ],
      [
        869.0,
        -3784.5,
        1292.0
      ],
      [
        872.5,
        -3781.0,
        1292.0
      ],
      [
        872.5,
        -3781.0,
        1295.0
      ],
      [
        872.5,
        -3781.0,
        1292.0
      ],
      [
        872.5,
        -3805.0,
        1292.0
      ],
      [
        872.5,
        -3805.0,
        1295.0
      ],
      [
        872.5,
        -3805.0,
        1292.0
      ],
      [
        872.5,
        -3785.0,
        1295.0
      ],
      [
        872.5,
        -3785.0,
        1292.0
      ],
      [
        872.5,
        -3785.0,
        1292.0
      ],
      [
        918.0,
        -3784.5,
        1295.0
      ],
      [
        918.0,
        -3781.5,
        1295.0
      ],
      [
        918.0,
        -3781.5,
        1292.0
      ],
      [
        918.0,
        -3784.5,
        1292.0
      ],
      [
        918.0,
        -3784.5,
        1292.0
      ],
      [
        918.0,
        -3781.5,
        1292.0
      ],
      [
        914.5,
        -3781.0,
        1292.0
      ],
      [
        914.5,
        -3781.0,
        1295.0
      ],
      [
        914.5,
        -3781.0,
        1292.0
      ],
      [
        914.5,
        -3805.0,
        1292.0
      ],
      [
        914.5,
        -3805.0,
        1295.0
      ],
      [
        914.5,
        -3805.0,
        1292.0
      ],
      [
        914.5,
        -3785.0,
        1295.0
      ],
      [
        914.5,
        -3785.0,
        1292.0
      ],
      [
        914.5,
        -3785.0,
        1292.0
      ],
      [
        870.5,
        -3857.5,
        1303.5
      ],
      [
        870.5,
        -3858.0,
        1298.0
      ],
      [
        870.5,
        -3781.5,
        1298.0
      ],
      [
        870.5,
        -3782.0,
        1303.5
      ],
      [
        869.5,
        -3975.0,
        1303.5
      ],
      [
        869.0,
        -3975.0,
        1298.0
      ],
      [
        870.5,
        -3975.0,
        1298.0
      ],
      [
        870.5,
        -3975.0,
        1303.5
      ],
      [
        916.5,
        -3857.5,
        1303.5
      ],
      [
        916.5,
        -3858.0,
        1298.0
      ],
      [
        916.5,
        -3781.5,
        1298.0
      ],
      [
        916.5,
        -3782.0,
        1303.5
      ],
      [
        892.5,
        -3975.0,
        1303.5
      ],
      [
        892.5,
        -3975.0,
        1303.5
      ],
      [
        892.5,
        -3982.5,
        1303.5
      ],
      [
        891.0,
        -3827.984619140625,
        1303.5
      ],
      [
        897.60009765625,
        -3827.984619140625,
        1303.5
      ],
      [
        897.60009765625,
        -3852.61572265625,
        1303.5
      ],
      [
        891.0,
        -3852.61572265625,
        1303.5
      ],
      [
        881.984375,
        -3837.000244140625,
        1303.5
      ],
      [
        885.284423828125,
        -3831.284423828125,
        1303.5
      ],
      [
        906.61572265625,
        -3843.60009765625,
        1303.5
      ],
      [
        903.3154296875,
        -3849.315673828125,
        1303.5
      ],
      [
        903.315673828125,
        -3831.284423828125,
        1303.5
      ],
      [
        906.615478515625,
        -3837.000244140625,
        1303.5
      ],
      [
        885.284423828125,
        -3849.315673828125,
        1303.5
      ],
      [
        881.984375,
        -3843.60009765625,
        1303.5
      ],
      [
        891.0,
        -3852.61572265625,
        1303.5
      ],
      [
        885.284423828125,
        -3849.315673828125,
        1303.5
      ],
      [
        881.984375,
        -3843.60009765625,
        1303.5
      ],
      [
        881.984375,
        -3837.000244140625,
        1303.5
      ],
      [
        906.615478515625,
        -3837.000244140625,
        1303.5
      ],
      [
        906.61572265625,
        -3843.60009765625,
        1303.5
      ],
      [
        897.60009765625,
        -3827.984619140625,
        1303.5
      ],
      [
        903.315673828125,
        -3831.284423828125,
        1303.5
      ],
      [
        885.284423828125,
        -3831.284423828125,
        1303.5
      ],
      [
        891.0,
        -3827.984619140625,
        1303.5
      ],
      [
        903.3154296875,
        -3849.315673828125,
        1303.5
      ],
      [
        897.60009765625,
        -3852.61572265625,
        1303.5
      ],
      [
        874.4179077148438,
        -3787.41796875,
        1303.5
      ],
      [
        874.4179077148438,
        -3784.58203125,
        1303.5
      ],
      [
        871.5820922851562,
        -3787.41796875,
        1303.5
      ],
      [
        871.5820922851562,
        -3784.58203125,
        1303.5
      ],
      [
        874.4179077148438,
        -3784.58203125,
        1303.5
      ],
      [
        871.5820922851562,
        -3784.58203125,
        1303.5
      ],
      [
        871.5820922851562,
        -3787.41796875,
        1303.5
      ],
      [
        874.4179077148438,
        -3787.41796875,
        1303.5
      ],
      [
        914.9179077148438,
        -3787.41796875,
        1303.5
      ],
      [
        914.9179077148438,
        -3784.58203125,
        1303.5
      ],
      [
        912.0820922851562,
        -3787.41796875,
        1303.5
      ],
      [
        912.0820922851562,
        -3784.58203125,
        1303.5
      ],
      [
        914.9179077148438,
        -3784.58203125,
        1303.5
      ],
      [
        912.0820922851562,
        -3784.58203125,
        1303.5
      ],
      [
        912.0820922851562,
        -3787.41796875,
        1303.5
      ],
      [
        914.9179077148438,
        -3787.41796875,
        1303.5
      ],
      [
        949.5,
        -3817.5,
        1303.5
      ],
      [
        949.5,
        -3814.5,
        1303.5
      ],
      [
        949.5,
        -3805.5,
        1303.5
      ],
      [
        949.5,
        -3787.5,
        1303.5
      ],
      [
        949.5,
        -3863.0,
        1303.5
      ],
      [
        949.5,
        -3817.5,
        1303.5
      ],
      [
        978.5,
        -3848.1875,
        1303.5
      ],
      [
        978.5,
        -3852.5,
        1303.5
      ],
      [
        978.5,
        -3787.675048828125,
        1303.5
      ],
      [
        978.5,
        -3782.5,
        1303.5
      ],
      [
        978.5,
        -3833.25,
        1303.5
      ],
      [
        978.5,
        -3848.1875,
        1303.5
      ],
      [
        978.5,
        -3787.675048828125,
        1303.5
      ],
      [
        978.5,
        -3821.324951171875,
        1303.5
      ],
      [
        967.5,
        -3787.5,
        1303.5
      ],
      [
        967.5,
        -3817.5,
        1303.5
      ],
      [
        967.5,
        -3770.5,
        1303.5
      ],
      [
        978.5,
        -3782.5,
        1303.5
      ],
      [
        978.5,
        -3852.5,
        1303.5
      ],
      [
        967.5,
        -3864.5,
        1303.5
      ],
      [
        974.0,
        -3821.324951171875,
        1303.5
      ],
      [
        974.0,
        -3833.25,
        1303.5
      ],
      [
        971.0,
        -3835.0,
        1303.5
      ],
      [
        971.0,
        -3819.0,
        1303.5
      ],
      [
        967.5,
        -3819.0,
        1303.5
      ],
      [
        971.0,
        -3819.0,
        1303.5
      ],
      [
        967.5,
        -3819.0,
        1298.0
      ],
      [
        971.0,
        -3835.0,
        1303.5
      ],
      [
        967.5,
        -3835.0,
        1303.5
      ],
      [
        967.5,
        -3835.0,
        1298.0
      ],
      [
        978.5,
        -3833.25,
        1303.5
      ],
      [
        974.0,
        -3833.25,
        1303.5
      ],
      [
        974.0,
        -3821.324951171875,
        1303.5
      ],
      [
        978.5,
        -3821.324951171875,
        1303.5
      ],
      [
        949.5,
        -3787.5,
        1303.5
      ],
      [
        967.5,
        -3787.5,
        1303.5
      ],
      [
        949.5,
        -3770.5,
        1298.0
      ],
      [
        967.5,
        -3770.5,
        1303.5
      ],
      [
        949.5,
        -3770.5,
        1303.5
      ],
      [
        967.5,
        -3864.5,
        1303.5
      ],
      [
        949.5,
        -3864.5,
        1298.0
      ],
      [
        949.5,
        -3864.5,
        1303.5
      ],
      [
        950.5,
        -3814.5,
        1303.5
      ],
      [
        950.5,
        -3817.5,
        1303.5
      ],
      [
        950.5,
        -3787.5,
        1303.5
      ],
      [
        950.5,
        -3805.5,
        1303.5
      ],
      [
        949.5,
        -3817.5,
        1303.5
      ],
      [
        950.5,
        -3817.5,
        1298.0
      ],
      [
        950.5,
        -3817.5,
        1303.5
      ],
      [
        949.5,
        -3814.5,
        1303.5
      ],
      [
        950.5,
        -3814.5,
        1303.5
      ],
      [
        950.5,
        -3805.5,
        1303.5
      ],
      [
        949.5,
        -3805.5,
        1303.5
      ],
      [
        951.5,
        -3835.0,
        1303.5
      ],
      [
        951.5,
        -3819.0,
        1303.5
      ],
      [
        951.5,
        -3835.0,
        1303.5
      ],
      [
        951.5,
        -3817.5,
        1298.0
      ],
      [
        951.5,
        -3817.5,
        1303.5
      ],
      [
        958.5,
        -3819.0,
        1303.5
      ],
      [
        953.0,
        -3817.5,
        1303.5
      ],
      [
        958.5,
        -3817.5,
        1303.5
      ],
      [
        967.5,
        -3817.5,
        1303.5
      ],
      [
        958.5,
        -3817.5,
        1303.5
      ],
      [
        958.5,
        -3819.0,
        1303.5
      ],
      [
        953.0,
        -3817.5,
        1303.5
      ],
      [
        953.0,
        -3819.0,
        1303.5
      ],
      [
        958.5,
        -3819.0,
        1303.5
      ],
      [
        958.5,
        -3820.662353515625,
        1303.5
      ],
      [
        960.0,
        -3820.662353515625,
        1303.5
      ],
      [
        960.0,
        -3819.0,
        1303.5
      ],
      [
        960.0,
        -3820.662353515625,
        1303.5
      ],
      [
        958.5,
        -3820.662353515625,
        1303.5
      ],
      [
        953.0,
        -3820.662353515625,
        1303.5
      ],
      [
        953.0,
        -3819.0,
        1303.5
      ],
      [
        953.0,
        -3820.662353515625,
        1303.5
      ],
      [
        951.5,
        -3820.662353515625,
        1303.5
      ],
      [
        983.5,
        -3797.0,
        1303.5
      ],
      [
        983.5,
        -3791.5,
        1303.5
      ],
      [
        978.5,
        -3797.0,
        1303.5
      ],
      [
        983.5,
        -3797.0,
        1303.5
      ],
      [
        978.5,
        -3791.5,
        1303.5
      ],
      [
        983.5,
        -3791.5,
        1303.5
      ],
      [
        925.5,
        -3807.5,
        1303.5
      ],
      [
        925.5,
        -3801.75,
        1303.5
      ],
      [
        925.5,
        -3804.0,
        1303.5
      ],
      [
        925.5,
        -3807.5,
        1303.5
      ],
      [
        925.5,
        -3804.0,
        1303.5
      ],
      [
        925.5,
        -3787.5,
        1303.5
      ],
      [
        925.5,
        -3793.25,
        1303.5
      ],
      [
        925.5,
        -3852.5,
        1303.5
      ],
      [
        924.0,
        -3801.75,
        1303.5
      ],
      [
        924.0,
        -3793.25,
        1303.5
      ],
      [
        924.0,
        -3782.5,
        1303.5
      ],
      [
        924.0,
        -3852.5,
        1303.5
      ],
      [
        924.5,
        -3810.0,
        1303.5
      ],
      [
        924.5,
        -3842.0,
        1303.5
      ],
      [
        924.5,
        -3842.0,
        1303.5
      ],
      [
        924.5,
        -3810.0,
        1303.5
      ],
      [
        924.5,
        -3813.0,
        1302.0
      ],
      [
        924.5,
        -3839.0,
        1302.0
      ],
      [
        925.5,
        -3854.300048828125,
        1298.0
      ],
      [
        924.5,
        -3853.10009765625,
        1298.0
      ],
      [
        924.5,
        -3853.10009765625,
        1302.0
      ],
      [
        925.5,
        -3854.300048828125,
        1302.0
      ],
      [
        924.5,
        -3781.89990234375,
        1298.0
      ],
      [
        925.5,
        -3780.699951171875,
        1298.0
      ],
      [
        925.5,
        -3780.699951171875,
        1302.0
      ],
      [
        924.5,
        -3781.89990234375,
        1302.0
      ],
      [
        925.5,
        -3801.95458984375,
        1302.0
      ],
      [
        924.5,
        -3801.95458984375,
        1302.0
      ],
      [
        924.5,
        -3802.5,
        1298.0
      ],
      [
        924.5,
        -3792.5,
        1298.0
      ],
      [
        924.5,
        -3793.04541015625,
        1302.0
      ],
      [
        925.5,
        -3793.04541015625,
        1302.0
      ],
      [
        924.5,
        -3811.0,
        1303.5
      ],
      [
        924.5,
        -3813.0,
        1302.0
      ],
      [
        925.5,
        -3780.699951171875,
        1303.5
      ],
      [
        924.5,
        -3781.89990234375,
        1303.5
      ],
      [
        925.5,
        -3801.75,
        1303.5
      ],
      [
        924.5,
        -3801.75,
        1303.5
      ],
      [
        924.5,
        -3793.25,
        1303.5
      ],
      [
        925.5,
        -3793.25,
        1303.5
      ],
      [
        924.5,
        -3841.0,
        1303.5
      ],
      [
        924.5,
        -3839.0,
        1302.0
      ],
      [
        924.5,
        -3853.10009765625,
        1303.5
      ],
      [
        925.5,
        -3854.300048828125,
        1303.5
      ],
      [
        924.0,
        -3801.95458984375,
        1302.0
      ],
      [
        924.5,
        -3801.95458984375,
        1302.0
      ],
      [
        924.0,
        -3852.5,
        1302.0
      ],
      [
        924.5,
        -3853.10009765625,
        1302.0
      ],
      [
        924.0,
        -3782.5,
        1302.0
      ],
      [
        924.5,
        -3781.89990234375,
        1302.0
      ],
      [
        924.0,
        -3793.04541015625,
        1302.0
      ],
      [
        924.5,
        -3793.04541015625,
        1302.0
      ],
      [
        924.0,
        -3793.25,
        1303.5
      ],
      [
        924.0,
        -3782.5,
        1303.5
      ],
      [
        924.0,
        -3801.75,
        1303.5
      ],
      [
        924.0,
        -3852.5,
        1303.5
      ],
      [
        925.5,
        -3843.0,
        1301.5
      ],
      [
        926.5,
        -3843.0,
        1298.0
      ],
      [
        926.5,
        -3843.0,
        1301.5
      ],
      [
        925.5,
        -3852.5,
        1301.5
      ],
      [
        926.5,
        -3853.666748046875,
        1298.0
      ],
      [
        926.5,
        -3853.666748046875,
        1301.5
      ],
      [
        926.5,
        -3855.5,
        1298.0
      ],
      [
        925.5,
        -3854.300048828125,
        1301.5
      ],
      [
        926.5,
        -3855.5,
        1301.5
      ],
      [
        925.5,
        -3850.0,
        1301.5
      ],
      [
        926.5,
        -3850.0,
        1298.0
      ],
      [
        926.5,
        -3850.0,
        1301.5
      ],
      [
        925.5,
        -3852.5,
        1301.5
      ],
      [
        926.5,
        -3852.5,
        1301.5
      ],
      [
        926.5,
        -3852.5,
        1298.0
      ],
      [
        925.5,
        -3845.5,
        1301.5
      ],
      [
        926.5,
        -3845.5,
        1301.5
      ],
      [
        926.5,
        -3845.5,
        1298.0
      ],
      [
        926.5,
        -3779.5,
        1298.0
      ],
      [
        926.5,
        -3779.5,
        1301.5
      ],
      [
        925.5,
        -3780.699951171875,
        1301.5
      ],
      [
        926.5,
        -3787.5,
        1298.0
      ],
      [
        925.5,
        -3787.5,
        1301.5
      ],
      [
        926.5,
        -3787.5,
        1301.5
      ],
      [
        925.5,
        -3845.5,
        1303.5
      ],
      [
        926.5,
        -3845.5,
        1303.5
      ],
      [
        926.5,
        -3779.5,
        1303.5
      ],
      [
        925.5,
        -3787.5,
        1303.5
      ],
      [
        926.5,
        -3787.5,
        1303.5
      ],
      [
        926.5,
        -3843.0,
        1303.5
      ],
      [
        925.5,
        -3843.0,
        1303.5
      ],
      [
        926.5,
        -3853.666748046875,
        1303.5
      ],
      [
        925.5,
        -3852.5,
        1303.5
      ],
      [
        926.5,
        -3855.5,
        1303.5
      ],
      [
        925.5,
        -3852.5,
        1303.5
      ],
      [
        926.5,
        -3852.5,
        1303.5
      ],
      [
        926.5,
        -3850.0,
        1303.5
      ],
      [
        925.5,
        -3850.0,
        1303.5
      ],
      [
        926.5,
        -3853.666748046875,
        1301.5
      ],
      [
        926.5,
        -3853.666748046875,
        1300.5
      ],
      [
        928.0,
        -3855.416748046875,
        1300.5
      ],
      [
        928.0,
        -3855.416748046875,
        1301.0
      ],
      [
        926.5,
        -3855.5,
        1300.5
      ],
      [
        926.5,
        -3855.5,
        1301.5
      ],
      [
        928.0,
        -3857.300048828125,
        1301.0
      ],
      [
        928.0,
        -3857.300048828125,
        1300.5
      ],
      [
        928.0,
        -3777.699951171875,
        1300.5
      ],
      [
        928.0,
        -3777.699951171875,
        1301.0
      ],
      [
        926.5,
        -3779.5,
        1301.5
      ],
      [
        926.5,
        -3779.5,
        1300.5
      ],
      [
        926.5,
        -3843.0,
        1301.5
      ],
      [
        926.5,
        -3843.0,
        1300.5
      ],
      [
        928.0,
        -3843.0,
        1300.5
      ],
      [
        928.0,
        -3843.0,
        1301.0
      ],
      [
        926.5,
        -3850.0,
        1301.5
      ],
      [
        926.5,
        -3850.0,
        1300.5
      ],
      [
        928.0,
        -3850.0,
        1300.5
      ],
      [
        928.0,
        -3850.0,
        1301.0
      ],
      [
        928.0,
        -3852.5,
        1301.0
      ],
      [
        928.0,
        -3852.5,
        1300.5
      ],
      [
        926.5,
        -3852.5,
        1300.5
      ],
      [
        926.5,
        -3852.5,
        1301.5
      ],
      [
        928.0,
        -3845.5,
        1301.0
      ],
      [
        928.0,
        -3845.5,
        1300.5
      ],
      [
        926.5,
        -3845.5,
        1300.5
      ],
      [
        926.5,
        -3845.5,
        1301.5
      ],
      [
        926.5,
        -3787.5,
        1300.5
      ],
      [
        926.5,
        -3787.5,
        1301.5
      ],
      [
        928.0,
        -3787.5,
        1301.0
      ],
      [
        928.0,
        -3787.5,
        1300.5
      ],
      [
        928.0,
        -3855.416748046875,
        1298.0
      ],
      [
        928.0,
        -3857.300048828125,
        1298.0
      ],
      [
        928.0,
        -3777.699951171875,
        1298.0
      ],
      [
        928.0,
        -3845.5,
        1298.0
      ],
      [
        928.0,
        -3787.5,
        1298.0
      ],
      [
        928.0,
        -3843.0,
        1298.0
      ],
      [
        928.0,
        -3852.5,
        1298.0
      ],
      [
        928.0,
        -3850.0,
        1298.0
      ],
      [
        928.0,
        -3855.416748046875,
        1303.5
      ],
      [
        928.0,
        -3857.300048828125,
        1303.5
      ],
      [
        928.0,
        -3777.699951171875,
        1303.5
      ],
      [
        928.0,
        -3845.5,
        1303.5
      ],
      [
        928.0,
        -3787.5,
        1303.5
      ],
      [
        928.0,
        -3843.0,
        1303.5
      ],
      [
        928.0,
        -3852.5,
        1303.5
      ],
      [
        928.0,
        -3850.0,
        1303.5
      ],
      [
        934.0,
        -3770.5,
        1303.5
      ],
      [
        934.0,
        -3864.5,
        1303.5
      ],
      [
        934.5,
        -3787.5,
        1303.5
      ],
      [
        934.5,
        -3787.5,
        1303.5
      ],
      [
        949.5,
        -3787.5,
        1303.5
      ],
      [
        934.0,
        -3770.5,
        1303.5
      ],
      [
        949.5,
        -3863.0,
        1303.5
      ],
      [
        934.5,
        -3863.0,
        1303.5
      ],
      [
        934.0,
        -3864.5,
        1303.5
      ],
      [
        932.75,
        -3863.0,
        1298.0
      ],
      [
        932.75,
        -3863.0,
        1303.5
      ],
      [
        934.5,
        -3863.0,
        1303.5
      ],
      [
        933.0,
        -3845.5,
        1303.5
      ],
      [
        933.0,
        -3843.0,
        1303.5
      ],
      [
        934.0,
        -3845.0,
        1303.5
      ],
      [
        934.0,
        -3843.5,
        1303.5
      ],
      [
        933.0,
        -3843.0,
        1303.5
      ],
      [
        934.0,
        -3843.5,
        1303.5
      ],
      [
        933.0,
        -3845.5,
        1303.5
      ],
      [
        934.0,
        -3845.0,
        1303.5
      ],
      [
        933.0,
        -3852.5,
        1303.5
      ],
      [
        933.0,
        -3850.0,
        1303.5
      ],
      [
        934.0,
        -3852.0,
        1303.5
      ],
      [
        934.0,
        -3850.5,
        1303.5
      ],
      [
        933.0,
        -3850.0,
        1303.5
      ],
      [
        934.0,
        -3850.5,
        1303.5
      ],
      [
        933.0,
        -3852.5,
        1303.5
      ],
      [
        934.0,
        -3852.0,
        1303.5
      ],
      [
        926.0624389648438,
        -3854.974853515625,
        1315.0
      ],
      [
        934.0,
        -3854.340087890625,
        1323.4666748046875
      ],
      [
        925.0000610351562,
        -3832.5,
        1316.0
      ],
      [
        925.0000610351562,
        -3847.5,
        1316.0
      ],
      [
        925.0000610351562,
        -3788.0,
        1316.0
      ],
      [
        925.0000610351562,
        -3803.0,
        1316.0
      ],
      [
        926.9999389648438,
        -3780.10009765625,
        1316.0
      ],
      [
        934.0,
        -3780.659912109375,
        1323.4666748046875
      ],
      [
        925.0,
        -3782.5,
        1316.0
      ],
      [
        932.5000610351562,
        -3847.5,
        1323.5
      ],
      [
        932.5000610351562,
        -3832.5,
        1323.5
      ],
      [
        932.5000610351562,
        -3803.0,
        1323.5
      ],
      [
        932.5000610351562,
        -3788.0,
        1323.5
      ],
      [
        925.5,
        -3832.5,
        1316.5
      ],
      [
        925.0000610351562,
        -3832.5,
        1316.0
      ],
      [
        932.5000610351562,
        -3832.5,
        1323.5
      ],
      [
        925.5,
        -3832.5,
        1316.5
      ],
      [
        925.5,
        -3847.5,
        1316.5
      ],
      [
        925.0000610351562,
        -3847.5,
        1316.0
      ],
      [
        925.5,
        -3847.5,
        1316.5
      ],
      [
        932.5000610351562,
        -3847.5,
        1323.5
      ],
      [
        934.0,
        -3854.340087890625,
        1323.4666748046875
      ],
      [
        934.0,
        -3854.300048828125,
        1323.5
      ],
      [
        934.03125,
        -3854.300048828125,
        1323.5
      ],
      [
        925.5,
        -3788.0,
        1316.5
      ],
      [
        925.0000610351562,
        -3788.0,
        1316.0
      ],
      [
        932.5000610351562,
        -3788.0,
        1323.5
      ],
      [
        925.5,
        -3788.0,
        1316.5
      ],
      [
        925.5,
        -3803.0,
        1316.5
      ],
      [
        925.0000610351562,
        -3803.0,
        1316.0
      ],
      [
        925.5,
        -3803.0,
        1316.5
      ],
      [
        932.5000610351562,
        -3803.0,
        1323.5
      ],
      [
        934.0,
        -3780.699951171875,
        1323.5
      ],
      [
        934.0,
        -3780.659912109375,
        1323.4666748046875
      ],
      [
        934.03125,
        -3780.699951171875,
        1323.5
      ],
      [
        935.4375,
        -3852.5,
        1325.0
      ],
      [
        935.4375,
        -3782.5,
        1325.0
      ],
      [
        924.0,
        -3852.5,
        1312.800048828125
      ],
      [
        926.0624389648438,
        -3854.974853515625,
        1315.0
      ],
      [
        924.0,
        -3782.5,
        1312.800048828125
      ],
      [
        926.0624389648438,
        -3780.025146484375,
        1315.0
      ],
      [
        926.0624389648438,
        -3780.025146484375,
        1315.0
      ],
      [
        967.5,
        -3781.300048828125,
        1324.0
      ],
      [
        934.5,
        -3781.300048828125,
        1324.0
      ],
      [
        934.5,
        -3853.699951171875,
        1324.0
      ],
      [
        967.5,
        -3853.699951171875,
        1324.0
      ],
      [
        963.0,
        -3822.0,
        1324.0
      ],
      [
        963.0,
        -3832.0,
        1324.0
      ],
      [
        968.5999755859375,
        -3782.5,
        1324.0
      ],
      [
        967.5,
        -3781.300048828125,
        1324.0
      ],
      [
        967.5,
        -3853.699951171875,
        1324.0
      ],
      [
        968.5999755859375,
        -3852.5,
        1324.0
      ],
      [
        954.5,
        -3822.0,
        1324.0
      ],
      [
        954.5,
        -3832.0,
        1324.0
      ],
      [
        963.0,
        -3832.0,
        1324.0
      ],
      [
        954.5,
        -3832.0,
        1324.0
      ],
      [
        954.5,
        -3822.0,
        1324.0
      ],
      [
        963.0,
        -3822.0,
        1324.0
      ],
      [
        967.5,
        -3833.6875,
        1307.0
      ],
      [
        967.5,
        -3820.3125,
        1307.0
      ],
      [
        967.5,
        -3835.0,
        1307.0
      ],
      [
        967.5,
        -3833.6875,
        1307.0
      ],
      [
        967.5,
        -3819.0,
        1307.0
      ],
      [
        967.5,
        -3820.3125,
        1307.0
      ],
      [
        967.5,
        -3835.0,
        1307.0
      ],
      [
        967.5,
        -3835.0,
        1303.5
      ],
      [
        967.5,
        -3819.0,
        1306.43994140625
      ],
      [
        967.5,
        -3819.0,
        1303.5
      ],
      [
        967.5,
        -3819.0,
        1307.0
      ],
      [
        967.5,
        -3819.0,
        1306.43994140625
      ],
      [
        949.5,
        -3770.5,
        1315.0
      ],
      [
        949.5,
        -3781.300048828125,
        1324.0
      ],
      [
        949.5,
        -3864.5,
        1315.0
      ],
      [
        949.5,
        -3853.699951171875,
        1324.0
      ],
      [
        950.5,
        -3793.9287109375,
        1303.5
      ],
      [
        950.5,
        -3801.071533203125,
        1303.5
      ],
      [
        950.5,
        -3801.107177734375,
        1303.75
      ],
      [
        950.5,
        -3793.892822265625,
        1303.75
      ],
      [
        950.5,
        -3793.892822265625,
        1303.75
      ],
      [
        950.5,
        -3801.107177734375,
        1303.75
      ],
      [
        950.5,
        -3804.0,
        1324.0
      ],
      [
        950.5,
        -3791.0,
        1324.0
      ],
      [
        949.5,
        -3770.5,
        1303.5
      ],
      [
        949.5,
        -3770.5,
        1315.0
      ],
      [
        949.5,
        -3864.5,
        1315.0
      ],
      [
        949.5,
        -3864.5,
        1303.5
      ],
      [
        953.0,
        -3819.0,
        1307.0
      ],
      [
        953.0,
        -3820.5,
        1307.0
      ],
      [
        951.5,
        -3822.0,
        1307.0
      ],
      [
        953.0,
        -3822.0,
        1307.0
      ],
      [
        953.0,
        -3819.0,
        1307.0
      ],
      [
        953.0,
        -3820.5,
        1307.0
      ],
      [
        960.0,
        -3819.0,
        1305.239990234375
      ],
      [
        960.0,
        -3819.0,
        1303.5
      ],
      [
        958.5,
        -3819.0,
        1307.0
      ],
      [
        960.0,
        -3819.0,
        1307.0
      ],
      [
        960.0,
        -3819.0,
        1305.239990234375
      ],
      [
        960.0,
        -3819.0,
        1307.0
      ],
      [
        958.5,
        -3819.0,
        1307.0
      ],
      [
        958.5,
        -3822.0,
        1307.0
      ],
      [
        960.0,
        -3822.0,
        1307.0
      ],
      [
        967.5,
        -3822.0,
        1307.0
      ],
      [
        924.5,
        -3794.0,
        1309.0
      ],
      [
        924.5,
        -3801.0,
        1309.0
      ],
      [
        924.5,
        -3813.0,
        1309.0
      ],
      [
        924.5,
        -3839.0,
        1309.0
      ],
      [
        924.5,
        -3853.10009765625,
        1309.0
      ],
      [
        924.5,
        -3853.10009765625,
        1313.3333740234375
      ],
      [
        925.5,
        -3854.300048828125,
        1314.4000244140625
      ],
      [
        925.5,
        -3854.300048828125,
        1309.0
      ],
      [
        925.5,
        -3780.699951171875,
        1309.0
      ],
      [
        925.5,
        -3780.699951171875,
        1314.4000244140625
      ],
      [
        924.5,
        -3781.89990234375,
        1313.3333740234375
      ],
      [
        924.5,
        -3781.89990234375,
        1309.0
      ],
      [
        924.5,
        -3801.0,
        1309.0
      ],
      [
        924.5,
        -3801.75,
        1303.5
      ],
      [
        925.5,
        -3854.300048828125,
        1303.5
      ],
      [
        924.5,
        -3853.10009765625,
        1303.5
      ],
      [
        924.5,
        -3841.0,
        1307.5
      ],
      [
        924.5,
        -3841.0,
        1303.5
      ],
      [
        924.5,
        -3811.0,
        1303.5
      ],
      [
        924.5,
        -3811.0,
        1307.5
      ],
      [
        924.5,
        -3841.0,
        1307.5
      ],
      [
        924.5,
        -3839.0,
        1309.0
      ],
      [
        924.5,
        -3811.0,
        1307.5
      ],
      [
        924.5,
        -3813.0,
        1309.0
      ],
      [
        924.5,
        -3781.89990234375,
        1303.5
      ],
      [
        925.5,
        -3780.699951171875,
        1303.5
      ],
      [
        924.5,
        -3794.0,
        1309.0
      ],
      [
        924.5,
        -3793.25,
        1303.5
      ],
      [
        924.0,
        -3852.5,
        1309.0
      ],
      [
        924.5,
        -3853.10009765625,
        1309.0
      ],
      [
        924.0,
        -3782.5,
        1309.0
      ],
      [
        924.5,
        -3781.89990234375,
        1309.0
      ],
      [
        949.5,
        -3778.300048828125,
        1321.5
      ],
      [
        946.0,
        -3781.300048828125,
        1324.0
      ],
      [
        946.0,
        -3778.300048828125,
        1321.5
      ],
      [
        946.0,
        -3853.699951171875,
        1324.0
      ],
      [
        949.5,
        -3856.699951171875,
        1321.5
      ],
      [
        946.0,
        -3856.699951171875,
        1321.5
      ],
      [
        949.5,
        -3855.234375,
        1321.5
      ],
      [
        946.0,
        -3852.5,
        1324.0
      ],
      [
        946.0,
        -3855.234375,
        1321.5
      ],
      [
        947.6428833007812,
        -3803.642822265625,
        1321.5
      ],
      [
        947.6428833007812,
        -3791.357177734375,
        1321.5
      ],
      [
        947.6428833007812,
        -3803.642822265625,
        1321.5
      ],
      [
        949.5,
        -3803.642822265625,
        1321.5
      ],
      [
        947.5,
        -3787.5,
        1324.0
      ],
      [
        949.5,
        -3787.5,
        1321.5
      ],
      [
        947.6428833007812,
        -3787.5,
        1321.5
      ],
      [
        949.5,
        -3791.357177734375,
        1321.5
      ],
      [
        947.6428833007812,
        -3791.357177734375,
        1321.5
      ],
      [
        947.6143188476562,
        -3818.5,
        1322.0
      ],
      [
        947.642822265625,
        -3818.5,
        1321.5
      ],
      [
        946.0,
        -3787.5,
        1324.0
      ],
      [
        946.0,
        -3787.5,
        1321.5
      ],
      [
        938.0,
        -3781.300048828125,
        1324.0
      ],
      [
        935.5,
        -3781.300048828125,
        1324.0
      ],
      [
        935.5,
        -3778.300048828125,
        1321.5
      ],
      [
        938.0,
        -3778.300048828125,
        1321.5
      ],
      [
        935.5,
        -3856.699951171875,
        1321.5
      ],
      [
        935.5,
        -3853.699951171875,
        1324.0
      ],
      [
        938.0,
        -3853.699951171875,
        1324.0
      ],
      [
        938.0,
        -3856.699951171875,
        1321.5
      ],
      [
        938.0,
        -3852.5,
        1324.0
      ],
      [
        935.5,
        -3852.5,
        1324.0
      ],
      [
        935.5,
        -3855.234375,
        1321.5
      ],
      [
        938.0,
        -3855.234375,
        1321.5
      ],
      [
        935.5,
        -3787.5,
        1324.0
      ],
      [
        938.0,
        -3787.5,
        1324.0
      ],
      [
        938.0,
        -3787.5,
        1321.5
      ],
      [
        935.5,
        -3787.5,
        1321.5
      ],
      [
        935.5,
        -3770.5,
        1303.5
      ],
      [
        935.5,
        -3770.5,
        1315.0
      ],
      [
        935.5,
        -3864.5,
        1315.0
      ],
      [
        935.5,
        -3864.5,
        1303.5
      ],
      [
        935.5,
        -3863.0,
        1314.4000244140625
      ],
      [
        935.5,
        -3864.5,
        1315.0
      ],
      [
        935.5,
        -3770.5,
        1315.0
      ],
      [
        935.5,
        -3787.5,
        1314.4000244140625
      ],
      [
        935.5,
        -3787.5,
        1309.0
      ],
      [
        935.5,
        -3787.5,
        1314.4000244140625
      ],
      [
        935.5,
        -3787.5,
        1309.0
      ],
      [
        935.5,
        -3787.5,
        1303.5
      ],
      [
        948.048583984375,
        -3863.0,
        1314.4000244140625
      ],
      [
        948.3571166992188,
        -3863.0,
        1309.0
      ],
      [
        948.3571166992188,
        -3863.0,
        1309.0
      ],
      [
        948.6714477539062,
        -3863.0,
        1303.5
      ],
      [
        935.5,
        -3863.0,
        1314.4000244140625
      ],
      [
        935.5,
        -3863.0,
        1309.0
      ],
      [
        935.5,
        -3863.0,
        1309.0
      ],
      [
        935.5,
        -3863.0,
        1303.5
      ],
      [
        935.5,
        -3864.5,
        1314.095703125
      ],
      [
        934.0,
        -3864.5,
        1312.495849609375
      ],
      [
        934.5,
        -3863.0,
        1310.5999755859375
      ],
      [
        935.5,
        -3863.0,
        1310.5999755859375
      ],
      [
        930.9279174804688,
        -3838.0,
        1310.5999755859375
      ],
      [
        931.61865234375,
        -3835.099853515625,
        1311.4530029296875
      ],
      [
        930.9279174804688,
        -3835.099853515625,
        1310.5999755859375
      ],
      [
        926.427734375,
        -3835.099853515625,
        1311.796142578125
      ],
      [
        927.5946044921875,
        -3838.0,
        1310.5999755859375
      ],
      [
        927.5946044921875,
        -3835.099853515625,
        1310.5999755859375
      ],
      [
        931.2518310546875,
        -3843.5,
        1311.0
      ],
      [
        927.2042846679688,
        -3843.5,
        1311.0
      ],
      [
        927.5945434570312,
        -3843.300048828125,
        1310.5999755859375
      ],
      [
        930.927978515625,
        -3843.300048828125,
        1310.5999755859375
      ],
      [
        927.2042846679688,
        -3845.0,
        1311.0
      ],
      [
        931.2518310546875,
        -3845.0,
        1311.0
      ],
      [
        930.927978515625,
        -3845.199951171875,
        1310.5999755859375
      ],
      [
        927.5945434570312,
        -3845.199951171875,
        1310.5999755859375
      ],
      [
        927.2042846679688,
        -3843.5,
        1311.0
      ],
      [
        931.2518310546875,
        -3843.5,
        1311.0
      ],
      [
        931.2518310546875,
        -3845.0,
        1311.0
      ],
      [
        927.2042846679688,
        -3845.0,
        1311.0
      ],
      [
        927.2042846679688,
        -3852.0,
        1311.0
      ],
      [
        931.2518310546875,
        -3852.0,
        1311.0
      ],
      [
        930.927978515625,
        -3852.199951171875,
        1310.5999755859375
      ],
      [
        927.5945434570312,
        -3852.199951171875,
        1310.5999755859375
      ],
      [
        931.2518310546875,
        -3850.5,
        1311.0
      ],
      [
        927.2042846679688,
        -3850.5,
        1311.0
      ],
      [
        927.5945434570312,
        -3850.300048828125,
        1310.5999755859375
      ],
      [
        930.927978515625,
        -3850.300048828125,
        1310.5999755859375
      ],
      [
        927.2042846679688,
        -3850.5,
        1311.0
      ],
      [
        931.2518310546875,
        -3850.5,
        1311.0
      ],
      [
        931.2518310546875,
        -3852.0,
        1311.0
      ],
      [
        927.2042846679688,
        -3852.0,
        1311.0
      ],
      [
        927.594482421875,
        -3835.89990234375,
        1310.5999755859375
      ],
      [
        926.8140258789062,
        -3835.89990234375,
        1311.4000244140625
      ],
      [
        926.8140258789062,
        -3835.89990234375,
        1311.4000244140625
      ],
      [
        926.8140258789062,
        -3835.099853515625,
        1311.4000244140625
      ],
      [
        931.61865234375,
        -3835.099853515625,
        1311.4530029296875
      ],
      [
        931.61865234375,
        -3835.89990234375,
        1311.4530029296875
      ],
      [
        927.6865234375,
        -3835.89990234375,
        1313.3504638671875
      ],
      [
        927.6865234375,
        -3835.099853515625,
        1313.3504638671875
      ],
      [
        927.6865234375,
        -3835.099853515625,
        1313.3504638671875
      ],
      [
        927.6865234375,
        -3835.89990234375,
        1313.3504638671875
      ],
      [
        926.427734375,
        -3835.89990234375,
        1311.796142578125
      ],
      [
        926.427734375,
        -3835.099853515625,
        1311.796142578125
      ],
      [
        927.5946044921875,
        -3838.0,
        1310.5999755859375
      ],
      [
        930.9279174804688,
        -3838.0,
        1310.5999755859375
      ],
      [
        925.7999877929688,
        -3843.300048828125,
        1310.5999755859375
      ],
      [
        925.7999877929688,
        -3845.199951171875,
        1310.5999755859375
      ],
      [
        925.7999877929688,
        -3843.300048828125,
        1310.5999755859375
      ],
      [
        925.7999877929688,
        -3845.199951171875,
        1310.5999755859375
      ],
      [
        925.7999877929688,
        -3852.199951171875,
        1310.5999755859375
      ],
      [
        925.7999877929688,
        -3850.300048828125,
        1310.5999755859375
      ],
      [
        925.7999877929688,
        -3852.199951171875,
        1310.5999755859375
      ],
      [
        925.7999877929688,
        -3850.300048828125,
        1310.5999755859375
      ],
      [
        932.9290771484375,
        -3843.300048828125,
        1310.5999755859375
      ],
      [
        933.7000122070312,
        -3843.685302734375,
        1310.5999755859375
      ],
      [
        932.9290771484375,
        -3843.300048828125,
        1310.5999755859375
      ],
      [
        932.9290771484375,
        -3845.199951171875,
        1310.5999755859375
      ],
      [
        933.7000122070312,
        -3844.814453125,
        1310.5999755859375
      ],
      [
        933.7000122070312,
        -3843.685302734375,
        1310.5999755859375
      ],
      [
        932.9290771484375,
        -3845.199951171875,
        1310.5999755859375
      ],
      [
        933.7000122070312,
        -3844.814453125,
        1310.5999755859375
      ],
      [
        932.9290771484375,
        -3852.199951171875,
        1310.5999755859375
      ],
      [
        932.9290771484375,
        -3850.300048828125,
        1310.5999755859375
      ],
      [
        933.7000122070312,
        -3850.685302734375,
        1310.5999755859375
      ],
      [
        932.9290771484375,
        -3850.300048828125,
        1310.5999755859375
      ],
      [
        933.7000122070312,
        -3851.814453125,
        1310.5999755859375
      ],
      [
        933.7000122070312,
        -3850.685302734375,
        1310.5999755859375
      ],
      [
        932.9290771484375,
        -3852.199951171875,
        1310.5999755859375
      ],
      [
        933.7000122070312,
        -3851.814453125,
        1310.5999755859375
      ],
      [
        930.9279174804688,
        -3828.0,
        1310.5999755859375
      ],
      [
        931.61865234375,
        -3825.099853515625,
        1311.4530029296875
      ],
      [
        930.9279174804688,
        -3825.099853515625,
        1310.5999755859375
      ],
      [
        930.9279174804688,
        -3833.5,
        1310.5999755859375
      ],
      [
        926.427734375,
        -3825.099853515625,
        1311.796142578125
      ],
      [
        927.5946044921875,
        -3828.0,
        1310.5999755859375
      ],
      [
        927.5946044921875,
        -3825.099853515625,
        1310.5999755859375
      ],
      [
        927.5946044921875,
        -3833.5,
        1310.5999755859375
      ],
      [
        930.9279174804688,
        -3833.5,
        1310.5999755859375
      ],
      [
        927.5946044921875,
        -3833.5,
        1310.5999755859375
      ],
      [
        927.594482421875,
        -3825.89990234375,
        1310.5999755859375
      ],
      [
        926.8140258789062,
        -3825.89990234375,
        1311.4000244140625
      ],
      [
        926.8140258789062,
        -3825.89990234375,
        1311.4000244140625
      ],
      [
        926.8140258789062,
        -3825.099853515625,
        1311.4000244140625
      ],
      [
        931.61865234375,
        -3825.099853515625,
        1311.4530029296875
      ],
      [
        931.61865234375,
        -3825.89990234375,
        1311.4530029296875
      ],
      [
        927.6865234375,
        -3825.89990234375,
        1313.3504638671875
      ],
      [
        927.6865234375,
        -3825.099853515625,
        1313.3504638671875
      ],
      [
        927.6865234375,
        -3825.099853515625,
        1313.3504638671875
      ],
      [
        927.6865234375,
        -3825.89990234375,
        1313.3504638671875
      ],
      [
        926.427734375,
        -3825.89990234375,
        1311.796142578125
      ],
      [
        926.427734375,
        -3825.099853515625,
        1311.796142578125
      ],
      [
        927.5946044921875,
        -3828.0,
        1310.5999755859375
      ],
      [
        930.9279174804688,
        -3828.0,
        1310.5999755859375
      ],
      [
        930.9279174804688,
        -3823.5,
        1310.5999755859375
      ],
      [
        930.9279174804688,
        -3817.5,
        1310.5999755859375
      ],
      [
        931.61865234375,
        -3814.5,
        1311.4530029296875
      ],
      [
        930.9279174804688,
        -3814.5,
        1310.5999755859375
      ],
      [
        927.5946044921875,
        -3823.5,
        1310.5999755859375
      ],
      [
        926.427734375,
        -3814.5,
        1311.796142578125
      ],
      [
        927.5946044921875,
        -3817.5,
        1310.5999755859375
      ],
      [
        927.5946044921875,
        -3814.5,
        1310.5999755859375
      ],
      [
        930.9279174804688,
        -3823.5,
        1310.5999755859375
      ],
      [
        927.5946044921875,
        -3823.5,
        1310.5999755859375
      ],
      [
        927.594482421875,
        -3815.300048828125,
        1310.5999755859375
      ],
      [
        926.8140258789062,
        -3815.300048828125,
        1311.4000244140625
      ],
      [
        926.8140258789062,
        -3815.300048828125,
        1311.4000244140625
      ],
      [
        926.8140258789062,
        -3814.5,
        1311.4000244140625
      ],
      [
        931.61865234375,
        -3814.5,
        1311.4530029296875
      ],
      [
        931.61865234375,
        -3815.300048828125,
        1311.4530029296875
      ],
      [
        927.6865234375,
        -3815.300048828125,
        1313.3504638671875
      ],
      [
        927.6865234375,
        -3814.5,
        1313.3504638671875
      ],
      [
        927.6865234375,
        -3814.5,
        1313.3504638671875
      ],
      [
        927.6865234375,
        -3815.300048828125,
        1313.3504638671875
      ],
      [
        926.427734375,
        -3815.300048828125,
        1311.796142578125
      ],
      [
        926.427734375,
        -3814.5,
        1311.796142578125
      ],
      [
        927.5946044921875,
        -3817.5,
        1310.5999755859375
      ],
      [
        930.9279174804688,
        -3817.5,
        1310.5999755859375
      ],
      [
        934.5,
        -3787.5,
        1310.5999755859375
      ],
      [
        925.5,
        -3787.5,
        1310.5999755859375
      ],
      [
        935.5,
        -3787.5,
        1310.5999755859375
      ],
      [
        934.5,
        -3787.5,
        1310.5999755859375
      ],
      [
        930.9279174804688,
        -3813.0,
        1310.5999755859375
      ],
      [
        927.5946044921875,
        -3813.0,
        1310.5999755859375
      ],
      [
        930.9279174804688,
        -3813.0,
        1310.5999755859375
      ],
      [
        927.5946044921875,
        -3813.0,
        1310.5999755859375
      ],
      [
        928.1797485351562,
        -3843.0,
        1310.0
      ],
      [
        930.4420166015625,
        -3843.0,
        1310.0
      ],
      [
        930.927978515625,
        -3843.300048828125,
        1310.5999755859375
      ],
      [
        927.5945434570312,
        -3843.300048828125,
        1310.5999755859375
      ],
      [
        930.4420166015625,
        -3843.0,
        1310.0
      ],
      [
        928.1797485351562,
        -3843.0,
        1310.0
      ],
      [
        929.4158935546875,
        -3843.0,
        1308.7327880859375
      ],
      [
        930.4420166015625,
        -3845.5,
        1310.0
      ],
      [
        928.1797485351562,
        -3845.5,
        1310.0
      ],
      [
        927.5945434570312,
        -3845.199951171875,
        1310.5999755859375
      ],
      [
        930.927978515625,
        -3845.199951171875,
        1310.5999755859375
      ],
      [
        928.1797485351562,
        -3845.5,
        1310.0
      ],
      [
        930.4420166015625,
        -3845.5,
        1310.0
      ],
      [
        929.4158935546875,
        -3845.5,
        1308.7327880859375
      ],
      [
        930.4420166015625,
        -3852.5,
        1310.0
      ],
      [
        928.1797485351562,
        -3852.5,
        1310.0
      ],
      [
        927.5945434570312,
        -3852.199951171875,
        1310.5999755859375
      ],
      [
        930.927978515625,
        -3852.199951171875,
        1310.5999755859375
      ],
      [
        928.1797485351562,
        -3850.0,
        1310.0
      ],
      [
        930.4420166015625,
        -3850.0,
        1310.0
      ],
      [
        930.927978515625,
        -3850.300048828125,
        1310.5999755859375
      ],
      [
        927.5945434570312,
        -3850.300048828125,
        1310.5999755859375
      ],
      [
        928.1797485351562,
        -3852.5,
        1310.0
      ],
      [
        930.4420166015625,
        -3852.5,
        1310.0
      ],
      [
        929.4158935546875,
        -3852.5,
        1308.7327880859375
      ],
      [
        930.4420166015625,
        -3850.0,
        1310.0
      ],
      [
        928.1797485351562,
        -3850.0,
        1310.0
      ],
      [
        929.4158935546875,
        -3850.0,
        1308.7327880859375
      ],
      [
        925.5,
        -3843.0,
        1303.89697265625
      ],
      [
        925.5,
        -3845.5,
        1303.89697265625
      ],
      [
        925.5,
        -3852.5,
        1303.89697265625
      ],
      [
        925.5,
        -3850.0,
        1303.89697265625
      ],
      [
        914.88232421875,
        -3787.38232421875,
        1305.88232421875
      ],
      [
        914.88232421875,
        -3784.61767578125,
        1305.88232421875
      ],
      [
        914.88232421875,
        -3784.61767578125,
        1305.88232421875
      ],
      [
        912.5000610351562,
        -3784.58203125,
        1303.5
      ],
      [
        914.88232421875,
        -3787.38232421875,
        1305.88232421875
      ],
      [
        912.5000610351562,
        -3787.41796875,
        1303.5
      ],
      [
        874.8635864257812,
        -3975.0,
        1362.5
      ],
      [
        873.1237182617188,
        -3839.733154296875,
        1343.3607177734375
      ],
      [
        873.2337036132812,
        -3840.5,
        1344.5704345703125
      ],
      [
        896.455810546875,
        -3844.27490234375,
        1316.7618408203125
      ],
      [
        887.3914794921875,
        -3833.699951171875,
        1311.3154296875
      ],
      [
        873.2337036132812,
        -3840.5,
        1344.5704345703125
      ],
      [
        873.1237182617188,
        -3841.266845703125,
        1343.3607177734375
      ],
      [
        872.9974365234375,
        -3840.5,
        1341.9716796875
      ],
      [
        873.1237182617188,
        -3839.733154296875,
        1343.3607177734375
      ],
      [
        873.1237182617188,
        -3841.266845703125,
        1343.3607177734375
      ],
      [
        872.9974365234375,
        -3840.5,
        1341.9716796875
      ],
      [
        890.964599609375,
        -3838.763427734375,
        1315.0653076171875
      ],
      [
        890.2894897460938,
        -3838.0498046875,
        1314.7919921875
      ],
      [
        892.3897705078125,
        -3840.5,
        1316.053955078125
      ],
      [
        891.8365478515625,
        -3839.78076171875,
        1315.5892333984375
      ],
      [
        890.28955078125,
        -3842.9501953125,
        1314.7919921875
      ],
      [
        890.9645385742188,
        -3842.236572265625,
        1315.065185546875
      ],
      [
        889.7314453125,
        -3842.236572265625,
        1314.3243408203125
      ],
      [
        890.28955078125,
        -3842.9501953125,
        1314.7919921875
      ],
      [
        890.2894897460938,
        -3838.0498046875,
        1314.7919921875
      ],
      [
        889.7314453125,
        -3838.763427734375,
        1314.3243408203125
      ],
      [
        891.83642578125,
        -3841.21923828125,
        1315.589111328125
      ],
      [
        892.3897705078125,
        -3840.5,
        1316.053955078125
      ],
      [
        889.7314453125,
        -3838.763427734375,
        1314.3243408203125
      ],
      [
        889.3093872070312,
        -3839.271240234375,
        1314.0377197265625
      ],
      [
        889.3093872070312,
        -3839.271240234375,
        1314.0377197265625
      ],
      [
        888.8594970703125,
        -3839.78076171875,
        1313.8004150390625
      ],
      [
        888.8594970703125,
        -3839.78076171875,
        1313.8004150390625
      ],
      [
        888.1893310546875,
        -3840.5,
        1313.5301513671875
      ],
      [
        890.702880859375,
        -3842.21875,
        1315.48681640625
      ],
      [
        890.0347290039062,
        -3842.92529296875,
        1315.21630859375
      ],
      [
        891.8365478515625,
        -3839.78076171875,
        1315.5892333984375
      ],
      [
        891.6030883789062,
        -3839.498046875,
        1315.4306640625
      ],
      [
        891.3486328125,
        -3839.365478515625,
        1315.232177734375
      ],
      [
        891.3486328125,
        -3839.365478515625,
        1315.232177734375
      ],
      [
        890.8473510742188,
        -3839.243408203125,
        1314.874267578125
      ],
      [
        888.5291748046875,
        -3840.5,
        1313.652099609375
      ],
      [
        888.3880004882812,
        -3840.713134765625,
        1313.6102294921875
      ],
      [
        888.8594360351562,
        -3841.21923828125,
        1313.80029296875
      ],
      [
        888.8594360351562,
        -3841.21923828125,
        1313.80029296875
      ],
      [
        889.3093872070312,
        -3841.728759765625,
        1314.0377197265625
      ],
      [
        890.9645385742188,
        -3842.236572265625,
        1315.065185546875
      ],
      [
        891.4156494140625,
        -3841.728515625,
        1315.3033447265625
      ],
      [
        891.4156494140625,
        -3841.728515625,
        1315.3033447265625
      ],
      [
        891.83642578125,
        -3841.21923828125,
        1315.589111328125
      ],
      [
        889.3093872070312,
        -3841.728759765625,
        1314.0377197265625
      ],
      [
        889.7314453125,
        -3842.236572265625,
        1314.3243408203125
      ],
      [
        891.1494140625,
        -3841.716064453125,
        1315.722412109375
      ],
      [
        890.702880859375,
        -3842.21875,
        1315.48681640625
      ],
      [
        891.4157104492188,
        -3839.271240234375,
        1315.3033447265625
      ],
      [
        891.4157104492188,
        -3839.271240234375,
        1315.3033447265625
      ],
      [
        891.1907958984375,
        -3839.01806640625,
        1315.1846923828125
      ],
      [
        890.90234375,
        -3839.018310546875,
        1314.9638671875
      ],
      [
        891.56591796875,
        -3841.2119140625,
        1316.00537109375
      ],
      [
        891.1494140625,
        -3841.716064453125,
        1315.722412109375
      ],
      [
        890.964599609375,
        -3838.763427734375,
        1315.0653076171875
      ],
      [
        892.1132202148438,
        -3840.5,
        1316.465087890625
      ],
      [
        891.56591796875,
        -3841.2119140625,
        1316.00537109375
      ],
      [
        891.5657348632812,
        -3839.7880859375,
        1316.005126953125
      ],
      [
        892.1132202148438,
        -3840.5,
        1316.465087890625
      ],
      [
        891.1492919921875,
        -3839.283935546875,
        1315.7222900390625
      ],
      [
        891.5657348632812,
        -3839.7880859375,
        1316.005126953125
      ],
      [
        890.7028198242188,
        -3838.78125,
        1315.4866943359375
      ],
      [
        891.1492919921875,
        -3839.283935546875,
        1315.7222900390625
      ],
      [
        889.0643310546875,
        -3841.71630859375,
        1314.4697265625
      ],
      [
        888.6189575195312,
        -3841.212158203125,
        1314.2347412109375
      ],
      [
        888.1893310546875,
        -3840.5,
        1313.5301513671875
      ],
      [
        889.482177734375,
        -3842.21923828125,
        1314.75341796875
      ],
      [
        889.0643310546875,
        -3841.71630859375,
        1314.4697265625
      ],
      [
        890.0347290039062,
        -3842.92529296875,
        1315.21630859375
      ],
      [
        889.482177734375,
        -3842.21923828125,
        1314.75341796875
      ],
      [
        890.0347290039062,
        -3838.0751953125,
        1315.21630859375
      ],
      [
        890.7028198242188,
        -3838.78125,
        1315.4866943359375
      ],
      [
        889.4821166992188,
        -3838.78076171875,
        1314.75341796875
      ],
      [
        890.0347290039062,
        -3838.0751953125,
        1315.21630859375
      ],
      [
        889.0642700195312,
        -3839.283447265625,
        1314.4696044921875
      ],
      [
        889.4821166992188,
        -3838.78076171875,
        1314.75341796875
      ],
      [
        888.6188354492188,
        -3839.787841796875,
        1314.234619140625
      ],
      [
        889.0642700195312,
        -3839.283447265625,
        1314.4696044921875
      ],
      [
        887.9554443359375,
        -3840.5,
        1313.967041015625
      ],
      [
        888.6188354492188,
        -3839.787841796875,
        1314.234619140625
      ],
      [
        888.6189575195312,
        -3841.212158203125,
        1314.2347412109375
      ],
      [
        887.9554443359375,
        -3840.5,
        1313.967041015625
      ],
      [
        878.1557006835938,
        -3854.9443359375,
        1311.3729248046875
      ],
      [
        888.6078491210938,
        -3844.64794921875,
        1314.2548828125
      ],
      [
        886.5255126953125,
        -3842.218017578125,
        1313.0035400390625
      ],
      [
        876.1993408203125,
        -3852.661865234375,
        1310.1973876953125
      ],
      [
        888.3701782226562,
        -3844.605712890625,
        1314.6846923828125
      ],
      [
        878.0218505859375,
        -3854.7998046875,
        1311.83154296875
      ],
      [
        888.6078491210938,
        -3844.64794921875,
        1314.2548828125
      ],
      [
        886.5255126953125,
        -3842.218017578125,
        1313.0035400390625
      ],
      [
        875.9702758789062,
        -3854.78369140625,
        1310.8905029296875
      ],
      [
        877.1245727539062,
        -3855.68359375,
        1311.5841064453125
      ],
      [
        878.1557006835938,
        -3854.9443359375,
        1311.3729248046875
      ],
      [
        875.9702758789062,
        -3854.78369140625,
        1310.8905029296875
      ],
      [
        876.1993408203125,
        -3852.661865234375,
        1310.1973876953125
      ],
      [
        875.451416015625,
        -3853.241455078125,
        1310.369140625
      ],
      [
        876.085205078125,
        -3852.54052734375,
        1310.6678466796875
      ],
      [
        886.3081665039062,
        -3842.200927734375,
        1313.44580078125
      ],
      [
        875.1987915039062,
        -3853.437255859375,
        1310.4271240234375
      ],
      [
        878.0218505859375,
        -3854.7998046875,
        1311.83154296875
      ],
      [
        870.399658203125,
        -3860.26123046875,
        1313.396484375
      ],
      [
        870.32470703125,
        -3858.756591796875,
        1312.5721435546875
      ],
      [
        870.2852783203125,
        -3859.013916015625,
        1312.13818359375
      ],
      [
        870.36083984375,
        -3860.531982421875,
        1312.96923828125
      ],
      [
        870.2333984375,
        -3857.284912109375,
        1311.5672607421875
      ],
      [
        870.2852783203125,
        -3859.013916015625,
        1312.13818359375
      ],
      [
        876.085205078125,
        -3852.54052734375,
        1310.6678466796875
      ],
      [
        870.32470703125,
        -3858.756591796875,
        1312.5721435546875
      ],
      [
        870.2732543945312,
        -3857.042724609375,
        1312.0057373046875
      ],
      [
        888.3701782226562,
        -3844.605712890625,
        1314.6846923828125
      ],
      [
        886.3081665039062,
        -3842.200927734375,
        1313.44580078125
      ],
      [
        884.76806640625,
        -3843.9951171875,
        1312.52587890625
      ],
      [
        884.8380126953125,
        -3843.98828125,
        1312.4095458984375
      ],
      [
        885.1448364257812,
        -3843.95849609375,
        1311.8988037109375
      ],
      [
        885.144775390625,
        -3843.958251953125,
        1311.8988037109375
      ],
      [
        885.4970703125,
        -3843.923583984375,
        1311.3126220703125
      ],
      [
        885.4970703125,
        -3843.923583984375,
        1311.3126220703125
      ],
      [
        885.998291015625,
        -3843.87451171875,
        1310.478271484375
      ],
      [
        886.52490234375,
        -3846.699951171875,
        1313.6805419921875
      ],
      [
        887.0650024414062,
        -3846.699951171875,
        1312.87646484375
      ],
      [
        887.0650024414062,
        -3846.699951171875,
        1312.87646484375
      ],
      [
        887.4444580078125,
        -3846.699951171875,
        1312.3116455078125
      ],
      [
        887.906005859375,
        -3846.699951171875,
        1311.62451171875
      ],
      [
        887.4444580078125,
        -3846.699951171875,
        1312.3116455078125
      ],
      [
        870.2852783203125,
        -3821.986328125,
        1312.13818359375
      ],
      [
        869.9841918945312,
        -3832.017822265625,
        1308.82568359375
      ],
      [
        888.6077270507812,
        -3836.351806640625,
        1314.2548828125
      ],
      [
        878.1559448242188,
        -3826.055908203125,
        1311.373046875
      ],
      [
        875.97021484375,
        -3826.216552734375,
        1310.8905029296875
      ],
      [
        878.1559448242188,
        -3826.055908203125,
        1311.373046875
      ],
      [
        877.3851928710938,
        -3825.50341796875,
        1311.5308837890625
      ],
      [
        872.217041015625,
        -3832.77001953125,
        1308.63525390625
      ],
      [
        872.3504028320312,
        -3839.49609375,
        1307.884765625
      ],
      [
        888.6077270507812,
        -3836.351806640625,
        1314.2548828125
      ],
      [
        870.36083984375,
        -3820.4677734375,
        1312.969482421875
      ],
      [
        870.2852783203125,
        -3821.986328125,
        1312.13818359375
      ],
      [
        869.9841918945312,
        -3832.017822265625,
        1308.82568359375
      ],
      [
        869.8992309570312,
        -3840.5,
        1307.891357421875
      ],
      [
        869.8992309570312,
        -3840.5,
        1307.891357421875
      ],
      [
        869.9841918945312,
        -3848.982421875,
        1308.82568359375
      ],
      [
        869.9841918945312,
        -3848.982421875,
        1308.82568359375
      ],
      [
        870.027587890625,
        -3848.864990234375,
        1309.30322265625
      ],
      [
        869.9437255859375,
        -3840.5,
        1308.381103515625
      ],
      [
        870.027587890625,
        -3848.864990234375,
        1309.30322265625
      ],
      [
        878.0219116210938,
        -3826.2001953125,
        1311.83154296875
      ],
      [
        870.32470703125,
        -3822.243408203125,
        1312.5721435546875
      ],
      [
        870.399658203125,
        -3820.738525390625,
        1313.3966064453125
      ],
      [
        870.027587890625,
        -3832.135009765625,
        1309.30322265625
      ],
      [
        870.32470703125,
        -3822.243408203125,
        1312.5721435546875
      ],
      [
        869.9437255859375,
        -3840.5,
        1308.381103515625
      ],
      [
        870.027587890625,
        -3832.135009765625,
        1309.30322265625
      ],
      [
        888.370361328125,
        -3836.394775390625,
        1314.6846923828125
      ],
      [
        878.0218505859375,
        -3826.2001953125,
        1311.83154296875
      ],
      [
        888.3704223632812,
        -3836.39501953125,
        1314.6846923828125
      ],
      [
        884.8077392578125,
        -3843.9912109375,
        1312.4598388671875
      ],
      [
        884.9496459960938,
        -3843.9775390625,
        1312.2236328125
      ],
      [
        884.9356079101562,
        -3843.286376953125,
        1312.2470703125
      ],
      [
        884.9356079101562,
        -3843.286376953125,
        1312.2470703125
      ],
      [
        885.1713256835938,
        -3843.95556640625,
        1311.8546142578125
      ],
      [
        885.0144653320312,
        -3841.250732421875,
        1312.1158447265625
      ],
      [
        884.9468994140625,
        -3840.0869140625,
        1312.228271484375
      ],
      [
        884.9468994140625,
        -3840.0869140625,
        1312.228271484375
      ],
      [
        885.0144653320312,
        -3841.250732421875,
        1312.1158447265625
      ],
      [
        885.915771484375,
        -3833.699951171875,
        1313.5125732421875
      ],
      [
        884.5762329101562,
        -3833.699951171875,
        1312.8450927734375
      ],
      [
        885.9910888671875,
        -3833.699951171875,
        1313.400390625
      ],
      [
        884.5762329101562,
        -3833.699951171875,
        1312.8450927734375
      ],
      [
        886.6943969726562,
        -3833.699951171875,
        1312.3531494140625
      ],
      [
        886.6943969726562,
        -3833.699951171875,
        1312.3531494140625
      ],
      [
        887.0367431640625,
        -3833.699951171875,
        1311.8433837890625
      ],
      [
        887.0367431640625,
        -3833.699951171875,
        1311.8433837890625
      ],
      [
        887.3914794921875,
        -3833.699951171875,
        1311.3154296875
      ],
      [
        905.0226440429688,
        -3864.46044921875,
        1340.160888671875
      ],
      [
        900.9612426757812,
        -3852.662109375,
        1325.075927734375
      ],
      [
        870.972900390625,
        -3872.83056640625,
        1319.7017822265625
      ],
      [
        894.57373046875,
        -3857.01806640625,
        1320.946533203125
      ],
      [
        899.545654296875,
        -3853.142578125,
        1323.93408203125
      ],
      [
        892.95703125,
        -3858.61865234375,
        1320.266357421875
      ],
      [
        894.5737915039062,
        -3857.018310546875,
        1320.9466552734375
      ],
      [
        892.6578979492188,
        -3873.61376953125,
        1332.7313232421875
      ],
      [
        899.545654296875,
        -3853.142578125,
        1323.93408203125
      ],
      [
        900.9612426757812,
        -3852.662109375,
        1325.075927734375
      ],
      [
        900.7913208007812,
        -3852.419921875,
        1324.89501953125
      ],
      [
        904.843017578125,
        -3864.375732421875,
        1340.2764892578125
      ],
      [
        905.0226440429688,
        -3864.46044921875,
        1340.160888671875
      ],
      [
        888.7088623046875,
        -3858.37939453125,
        1317.422607421875
      ],
      [
        886.6810302734375,
        -3859.193603515625,
        1316.495361328125
      ],
      [
        888.7088623046875,
        -3858.379638671875,
        1317.4227294921875
      ],
      [
        881.0609130859375,
        -3875.406005859375,
        1325.76318359375
      ],
      [
        882.843994140625,
        -3857.018310546875,
        1313.898681640625
      ],
      [
        880.6929321289062,
        -3856.922119140625,
        1312.8974609375
      ],
      [
        882.843994140625,
        -3857.018310546875,
        1313.898681640625
      ],
      [
        870.972900390625,
        -3872.83056640625,
        1319.7017822265625
      ],
      [
        871.0113525390625,
        -3872.72802734375,
        1320.1248779296875
      ],
      [
        900.5994873046875,
        -3852.540771484375,
        1325.3974609375
      ],
      [
        904.6328735351562,
        -3864.27685546875,
        1340.4117431640625
      ],
      [
        900.3335571289062,
        -3851.767333984375,
        1324.4075927734375
      ],
      [
        904.6328735351562,
        -3864.27685546875,
        1340.4117431640625
      ],
      [
        871.01953125,
        -3872.706298828125,
        1320.21484375
      ],
      [
        879.0513916015625,
        -3854.06201171875,
        1311.619873046875
      ],
      [
        871.01953125,
        -3872.706298828125,
        1320.21484375
      ],
      [
        895.1671752929688,
        -3844.401611328125,
        1318.9063720703125
      ],
      [
        895.6624755859375,
        -3844.35302734375,
        1318.0821533203125
      ],
      [
        895.6624755859375,
        -3844.35302734375,
        1318.0821533203125
      ],
      [
        896.0101318359375,
        -3844.318603515625,
        1317.5035400390625
      ],
      [
        896.455810546875,
        -3844.27490234375,
        1316.7618408203125
      ],
      [
        896.0101318359375,
        -3844.318603515625,
        1317.5035400390625
      ],
      [
        889.9053955078125,
        -3846.699951171875,
        1315.4312744140625
      ],
      [
        892.0543823242188,
        -3846.699951171875,
        1316.841064453125
      ],
      [
        892.0543823242188,
        -3846.699951171875,
        1316.841064453125
      ],
      [
        894.9566650390625,
        -3846.699951171875,
        1319.0625
      ],
      [
        894.9567260742188,
        -3846.699951171875,
        1319.0625
      ],
      [
        895.0338134765625,
        -3846.699951171875,
        1319.1285400390625
      ],
      [
        895.1671752929688,
        -3844.4013671875,
        1318.906494140625
      ],
      [
        893.6358642578125,
        -3842.218017578125,
        1317.2760009765625
      ],
      [
        893.6358642578125,
        -3842.218017578125,
        1317.2760009765625
      ],
      [
        887.6517333984375,
        -3846.699951171875,
        1314.19580078125
      ],
      [
        886.5247802734375,
        -3846.699951171875,
        1313.6805419921875
      ],
      [
        887.6517333984375,
        -3846.699951171875,
        1314.19580078125
      ],
      [
        889.9053955078125,
        -3846.699951171875,
        1315.4312744140625
      ],
      [
        894.109130859375,
        -3857.126220703125,
        1320.66748046875
      ],
      [
        894.2542114257812,
        -3855.70947265625,
        1320.4259033203125
      ],
      [
        894.2542724609375,
        -3855.709716796875,
        1320.4259033203125
      ],
      [
        895.0279541015625,
        -3846.800048828125,
        1319.13818359375
      ],
      [
        895.0280151367188,
        -3846.800048828125,
        1319.13818359375
      ],
      [
        883.4320678710938,
        -3855.756103515625,
        1313.93505859375
      ],
      [
        885.630859375,
        -3847.58056640625,
        1313.43408203125
      ],
      [
        883.4320678710938,
        -3855.756103515625,
        1313.93505859375
      ],
      [
        883.2919311523438,
        -3857.122314453125,
        1314.1678466796875
      ],
      [
        899.1651611328125,
        -3853.439208984375,
        1323.7054443359375
      ],
      [
        898.856201171875,
        -3852.174560546875,
        1323.2021484375
      ],
      [
        898.855712890625,
        -3852.174072265625,
        1323.20166015625
      ],
      [
        895.5643920898438,
        -3844.9677734375,
        1319.3294677734375
      ],
      [
        893.3464965820312,
        -3842.2001953125,
        1317.674560546875
      ],
      [
        900.5994873046875,
        -3852.540771484375,
        1325.3974609375
      ],
      [
        893.3464965820312,
        -3842.2001953125,
        1317.674560546875
      ],
      [
        886.9197998046875,
        -3830.34033203125,
        1306.0
      ],
      [
        888.5595092773438,
        -3831.703125,
        1306.0
      ],
      [
        895.138427734375,
        -3837.171142578125,
        1306.0
      ],
      [
        892.9813232421875,
        -3835.37841796875,
        1306.0
      ],
      [
        888.5595092773438,
        -3831.703125,
        1306.0
      ],
      [
        892.9813232421875,
        -3835.37841796875,
        1306.0
      ],
      [
        896.3892211914062,
        -3838.2109375,
        1306.0
      ],
      [
        895.138427734375,
        -3837.171142578125,
        1306.0
      ],
      [
        901.0927124023438,
        -3842.1201171875,
        1306.0
      ],
      [
        903.841552734375,
        -3844.405029296875,
        1306.0
      ],
      [
        897.780517578125,
        -3839.367431640625,
        1306.0
      ],
      [
        896.38916015625,
        -3838.2109375,
        1306.0
      ],
      [
        901.0925903320312,
        -3842.1201171875,
        1306.0
      ],
      [
        897.780517578125,
        -3839.367431640625,
        1306.0
      ],
      [
        905.4019775390625,
        -3845.7021484375,
        1306.0
      ],
      [
        905.9466552734375,
        -3844.7587890625,
        1303.5
      ],
      [
        886.9197998046875,
        -3830.34033203125,
        1306.0
      ],
      [
        887.910888671875,
        -3829.76806640625,
        1303.5
      ],
      [
        893.626953125,
        -3840.974853515625,
        1315.0621337890625
      ],
      [
        896.2021484375,
        -3840.72216796875,
        1310.7763671875
      ],
      [
        893.8037109375,
        -3836.62109375,
        1307.0018310546875
      ],
      [
        892.7756958007812,
        -3836.0,
        1307.419921875
      ],
      [
        895.94677734375,
        -3839.121337890625,
        1308.2894287109375
      ],
      [
        893.8037109375,
        -3836.62109375,
        1307.0018310546875
      ],
      [
        896.2021484375,
        -3840.72216796875,
        1310.7763671875
      ],
      [
        895.94677734375,
        -3839.121337890625,
        1308.2894287109375
      ],
      [
        892.1546630859375,
        -3836.0,
        1308.3443603515625
      ],
      [
        892.7755737304688,
        -3836.0,
        1307.419921875
      ],
      [
        892.1546630859375,
        -3836.0,
        1308.3443603515625
      ],
      [
        889.3628540039062,
        -3836.0,
        1312.5
      ],
      [
        891.0,
        -3833.7314453125,
        1306.0
      ],
      [
        891.331298828125,
        -3834.5,
        1306.883544921875
      ],
      [
        891.331298828125,
        -3834.5,
        1306.883544921875
      ],
      [
        891.9248046875,
        -3834.5,
        1306.0
      ],
      [
        905.4019775390625,
        -3845.7021484375,
        1306.0
      ],
      [
        904.5762939453125,
        -3846.13232421875,
        1308.0
      ],
      [
        903.841552734375,
        -3844.405029296875,
        1306.0
      ],
      [
        903.7960205078125,
        -3845.48388671875,
        1308.0
      ],
      [
        904.5762939453125,
        -3846.13232421875,
        1308.0
      ],
      [
        903.7960205078125,
        -3845.48388671875,
        1308.0
      ],
      [
        872.0454711914062,
        -3785.0,
        1331.5
      ],
      [
        871.9910888671875,
        -3784.990966796875,
        1330.9014892578125
      ],
      [
        871.9910888671875,
        -3787.009033203125,
        1330.9014892578125
      ],
      [
        871.9910888671875,
        -3784.990966796875,
        1330.9014892578125
      ],
      [
        871.9910888671875,
        -3787.009033203125,
        1330.9014892578125
      ],
      [
        872.0454711914062,
        -3787.0,
        1331.5
      ],
      [
        872.0454711914062,
        -3785.0,
        1331.5
      ],
      [
        873.9761352539062,
        -3786.599853515625,
        1333.10009765625
      ],
      [
        872.1909790039062,
        -3786.599853515625,
        1333.10009765625
      ],
      [
        872.1909790039062,
        -3786.599853515625,
        1333.10009765625
      ],
      [
        873.9761352539062,
        -3786.599853515625,
        1333.10009765625
      ],
      [
        873.97265625,
        -3786.972900390625,
        1333.333251953125
      ],
      [
        872.212158203125,
        -3786.972900390625,
        1333.333251953125
      ],
      [
        914.4761352539062,
        -3786.599853515625,
        1333.10009765625
      ],
      [
        912.5238647460938,
        -3786.599853515625,
        1333.10009765625
      ],
      [
        912.5238647460938,
        -3786.599853515625,
        1333.10009765625
      ],
      [
        914.4761352539062,
        -3786.599853515625,
        1333.10009765625
      ],
      [
        914.47265625,
        -3786.972900390625,
        1333.333251953125
      ],
      [
        912.52734375,
        -3786.972900390625,
        1333.333251953125
      ],
      [
        874.0,
        -3786.985595703125,
        1332.483154296875
      ],
      [
        883.9921875,
        -3786.973876953125,
        1333.255859375
      ],
      [
        873.982421875,
        -3786.972900390625,
        1333.333251953125
      ],
      [
        873.982421875,
        -3786.972900390625,
        1333.333251953125
      ],
      [
        883.9906005859375,
        -3786.972900390625,
        1333.3330078125
      ],
      [
        883.9921875,
        -3786.973876953125,
        1333.255859375
      ],
      [
        883.9906005859375,
        -3786.972900390625,
        1333.3330078125
      ],
      [
        912.5,
        -3786.985595703125,
        1332.483154296875
      ],
      [
        902.5078125,
        -3786.973876953125,
        1333.255859375
      ],
      [
        912.517578125,
        -3786.972900390625,
        1333.333251953125
      ],
      [
        912.517578125,
        -3786.972900390625,
        1333.333251953125
      ],
      [
        902.5093994140625,
        -3786.972900390625,
        1333.3330078125
      ],
      [
        902.5078125,
        -3786.973876953125,
        1333.255859375
      ],
      [
        902.5093994140625,
        -3786.972900390625,
        1333.3330078125
      ],
      [
        874.0,
        -3786.985595703125,
        1332.483154296875
      ],
      [
        912.5,
        -3786.985595703125,
        1332.483154296875
      ],
      [
        902.8680419921875,
        -3847.342529296875,
        1325.9305419921875
      ],
      [
        900.33349609375,
        -3851.76708984375,
        1324.407470703125
      ],
      [
        902.8680419921875,
        -3847.342529296875,
        1325.9305419921875
      ],
      [
        904.1106567382812,
        -3845.60693359375,
        1326.96826171875
      ],
      [
        911.382080078125,
        -3851.76904296875,
        1343.98193359375
      ],
      [
        904.0343017578125,
        -3840.5,
        1326.631103515625
      ],
      [
        904.0343017578125,
        -3840.5,
        1326.631103515625
      ],
      [
        904.6035766601562,
        -3838.28369140625,
        1327.264404296875
      ],
      [
        912.9179077148438,
        -3838.238525390625,
        1344.90478515625
      ],
      [
        909.89892578125,
        -3825.0537109375,
        1343.0908203125
      ],
      [
        902.8677978515625,
        -3833.657958984375,
        1325.9302978515625
      ],
      [
        902.8677978515625,
        -3833.657958984375,
        1325.9302978515625
      ],
      [
        902.6567993164062,
        -3831.298828125,
        1326.0947265625
      ],
      [
        889.8438720703125,
        -3833.699951171875,
        1315.53369140625
      ],
      [
        887.3720703125,
        -3833.699951171875,
        1314.1785888671875
      ],
      [
        887.3720703125,
        -3833.699951171875,
        1314.1785888671875
      ],
      [
        885.9157104492188,
        -3833.699951171875,
        1313.5125732421875
      ],
      [
        895.6555786132812,
        -3836.462890625,
        1318.0936279296875
      ],
      [
        895.2988891601562,
        -3837.694580078125,
        1318.687255859375
      ],
      [
        895.4735107421875,
        -3834.685546875,
        1318.3966064453125
      ],
      [
        895.7789306640625,
        -3837.66650390625,
        1317.888427734375
      ],
      [
        895.2539672851562,
        -3838.46826171875,
        1318.761962890625
      ],
      [
        895.2988891601562,
        -3837.694580078125,
        1318.687255859375
      ],
      [
        895.6555786132812,
        -3836.462890625,
        1318.0936279296875
      ],
      [
        895.7789306640625,
        -3837.66650390625,
        1317.888427734375
      ],
      [
        895.2953491210938,
        -3840.5,
        1318.6932373046875
      ],
      [
        895.2539672851562,
        -3838.46923828125,
        1318.76220703125
      ],
      [
        894.53759765625,
        -3838.281494140625,
        1318.121337890625
      ],
      [
        894.53759765625,
        -3838.281494140625,
        1318.121337890625
      ],
      [
        892.12060546875,
        -3838.28173828125,
        1316.0516357421875
      ],
      [
        892.12060546875,
        -3838.28173828125,
        1316.0516357421875
      ],
      [
        891.0134887695312,
        -3838.563232421875,
        1315.14501953125
      ],
      [
        891.0134887695312,
        -3838.563232421875,
        1315.14501953125
      ],
      [
        890.8538818359375,
        -3838.646484375,
        1315.0205078125
      ],
      [
        895.2421264648438,
        -3843.109619140625,
        1318.78173828125
      ],
      [
        895.1671752929688,
        -3844.4013671875,
        1318.906494140625
      ],
      [
        895.2421264648438,
        -3843.109619140625,
        1318.78173828125
      ],
      [
        895.2953491210938,
        -3840.5,
        1318.693115234375
      ],
      [
        903.0006713867188,
        -3840.5,
        1325.6922607421875
      ],
      [
        903.945068359375,
        -3841.0234375,
        1326.5775146484375
      ],
      [
        903.0020751953125,
        -3840.5,
        1325.6934814453125
      ],
      [
        895.4100952148438,
        -3834.066162109375,
        1318.502197265625
      ],
      [
        895.1672973632812,
        -3834.151123046875,
        1318.90625
      ],
      [
        895.176513671875,
        -3833.699951171875,
        1318.89111328125
      ],
      [
        895.3726196289062,
        -3833.699951171875,
        1318.564697265625
      ],
      [
        895.13037109375,
        -3835.962890625,
        1318.9677734375
      ],
      [
        895.1672973632812,
        -3834.151123046875,
        1318.9063720703125
      ],
      [
        895.4100952148438,
        -3834.066162109375,
        1318.502197265625
      ],
      [
        895.2420654296875,
        -3837.890625,
        1318.78173828125
      ],
      [
        895.2538452148438,
        -3838.46923828125,
        1318.7620849609375
      ],
      [
        895.2420654296875,
        -3837.890625,
        1318.78173828125
      ],
      [
        895.1302490234375,
        -3835.963623046875,
        1318.9677734375
      ],
      [
        893.4598999023438,
        -3836.4013671875,
        1317.4735107421875
      ],
      [
        893.4598999023438,
        -3836.4013671875,
        1317.4735107421875
      ],
      [
        891.2481079101562,
        -3837.602294921875,
        1315.52734375
      ],
      [
        891.2481079101562,
        -3837.602294921875,
        1315.52734375
      ],
      [
        890.48974609375,
        -3838.261474609375,
        1314.873046875
      ],
      [
        902.9573364257812,
        -3834.18310546875,
        1325.9840087890625
      ],
      [
        901.9199829101562,
        -3834.18408203125,
        1325.0418701171875
      ],
      [
        901.9199829101562,
        -3834.18408203125,
        1325.0418701171875
      ],
      [
        902.534423828125,
        -3833.699951171875,
        1326.2877197265625
      ],
      [
        903.4203491210938,
        -3833.699951171875,
        1327.0924072265625
      ],
      [
        895.0280151367188,
        -3834.199951171875,
        1319.13818359375
      ],
      [
        895.1303100585938,
        -3835.963623046875,
        1318.9678955078125
      ],
      [
        895.0280151367188,
        -3834.199951171875,
        1319.13818359375
      ],
      [
        894.984619140625,
        -3833.699951171875,
        1319.21044921875
      ],
      [
        893.4501342773438,
        -3833.699951171875,
        1318.0360107421875
      ],
      [
        891.84814453125,
        -3835.144775390625,
        1316.5050048828125
      ],
      [
        891.8482666015625,
        -3835.14453125,
        1316.5052490234375
      ],
      [
        890.2191162109375,
        -3837.36279296875,
        1314.9091796875
      ],
      [
        902.8749389648438,
        -3833.699951171875,
        1325.9345703125
      ],
      [
        902.7921142578125,
        -3833.699951171875,
        1325.859375
      ],
      [
        902.7921142578125,
        -3833.699951171875,
        1325.859375
      ],
      [
        895.3841552734375,
        -3833.699951171875,
        1319.5162353515625
      ],
      [
        895.3841552734375,
        -3833.699951171875,
        1319.5162353515625
      ],
      [
        895.1266479492188,
        -3833.699951171875,
        1319.9447021484375
      ],
      [
        902.534423828125,
        -3833.699951171875,
        1326.2877197265625
      ],
      [
        892.2009887695312,
        -3833.699951171875,
        1317.0799560546875
      ],
      [
        892.2009887695312,
        -3833.699951171875,
        1317.0799560546875
      ],
      [
        890.4043579101562,
        -3833.699951171875,
        1315.9013671875
      ],
      [
        889.9465942382812,
        -3834.70263671875,
        1315.3626708984375
      ],
      [
        891.9434814453125,
        -3833.699951171875,
        1317.508544921875
      ],
      [
        895.1266479492188,
        -3833.699951171875,
        1319.9447021484375
      ],
      [
        889.8438720703125,
        -3833.699951171875,
        1315.53369140625
      ],
      [
        889.58642578125,
        -3833.699951171875,
        1315.9622802734375
      ],
      [
        891.9434814453125,
        -3833.699951171875,
        1317.508544921875
      ],
      [
        887.1146850585938,
        -3833.699951171875,
        1314.607177734375
      ],
      [
        889.58642578125,
        -3833.699951171875,
        1315.9622802734375
      ],
      [
        887.1146240234375,
        -3833.699951171875,
        1314.6070556640625
      ],
      [
        885.6347045898438,
        -3833.699951171875,
        1313.930419921875
      ],
      [
        872.6726684570312,
        -3795.079833984375,
        1338.400146484375
      ],
      [
        880.0740966796875,
        -3786.972900390625,
        1333.3331298828125
      ],
      [
        883.8385009765625,
        -3790.1962890625,
        1335.3477783203125
      ],
      [
        879.5651245117188,
        -3787.288818359375,
        1332.4178466796875
      ],
      [
        879.7588500976562,
        -3786.978759765625,
        1332.928466796875
      ],
      [
        871.8388671875,
        -3807.96240234375,
        1320.7071533203125
      ],
      [
        871.8316040039062,
        -3807.73583984375,
        1320.2176513671875
      ],
      [
        871.8316040039062,
        -3807.73583984375,
        1320.2176513671875
      ],
      [
        871.82421875,
        -3808.418212890625,
        1319.7220458984375
      ],
      [
        871.82421875,
        -3808.418212890625,
        1319.7220458984375
      ],
      [
        871.71923828125,
        -3821.441650390625,
        1312.6912841796875
      ],
      [
        899.545654296875,
        -3827.857666015625,
        1323.93408203125
      ],
      [
        899.545654296875,
        -3827.857666015625,
        1323.93408203125
      ],
      [
        898.56689453125,
        -3825.714599609375,
        1323.63720703125
      ],
      [
        894.5738525390625,
        -3823.98193359375,
        1320.9466552734375
      ],
      [
        894.5738525390625,
        -3823.98193359375,
        1320.9466552734375
      ],
      [
        892.9568481445312,
        -3822.381591796875,
        1320.2662353515625
      ],
      [
        888.7089233398438,
        -3822.62109375,
        1317.422607421875
      ],
      [
        899.7994384765625,
        -3828.30078125,
        1324.0865478515625
      ],
      [
        898.8576049804688,
        -3828.82373046875,
        1323.20361328125
      ],
      [
        898.8567504882812,
        -3828.824951171875,
        1323.2027587890625
      ],
      [
        893.4497680664062,
        -3833.699951171875,
        1318.0357666015625
      ],
      [
        894.9541625976562,
        -3824.2783203125,
        1321.1751708984375
      ],
      [
        894.2653198242188,
        -3825.24560546875,
        1320.44384765625
      ],
      [
        894.2656860351562,
        -3825.243896484375,
        1320.4444580078125
      ],
      [
        890.4046630859375,
        -3833.699951171875,
        1315.901611328125
      ],
      [
        889.155517578125,
        -3822.724609375,
        1317.69091796875
      ],
      [
        888.8484497070312,
        -3823.9833984375,
        1317.1903076171875
      ],
      [
        871.8292846679688,
        -3808.850341796875,
        1320.061279296875
      ],
      [
        871.8388671875,
        -3807.96240234375,
        1320.7071533203125
      ],
      [
        871.7257690429688,
        -3821.688720703125,
        1313.124267578125
      ],
      [
        871.8292846679688,
        -3808.850341796875,
        1320.061279296875
      ],
      [
        872.1182250976562,
        -3787.10009765625,
        1332.2999267578125
      ],
      [
        872.5999755859375,
        -3795.579833984375,
        1337.5999755859375
      ],
      [
        880.6998291015625,
        -3795.82080078125,
        1337.75048828125
      ],
      [
        881.8134155273438,
        -3789.2138671875,
        1333.62109375
      ],
      [
        879.5651245117188,
        -3787.288818359375,
        1332.4178466796875
      ],
      [
        877.8637084960938,
        -3795.224365234375,
        1338.490478515625
      ],
      [
        880.6998291015625,
        -3795.82080078125,
        1337.75048828125
      ],
      [
        872.5999755859375,
        -3795.579833984375,
        1337.5999755859375
      ],
      [
        872.6726684570312,
        -3795.079833984375,
        1338.400146484375
      ],
      [
        872.107421875,
        -3787.085205078125,
        1332.1810302734375
      ],
      [
        872.1182250976562,
        -3787.10009765625,
        1332.2999267578125
      ],
      [
        883.8270874023438,
        -3790.938232421875,
        1334.69873046875
      ],
      [
        883.8270874023438,
        -3790.938232421875,
        1334.69873046875
      ],
      [
        883.8385009765625,
        -3790.1962890625,
        1335.3477783203125
      ],
      [
        872.0454711914062,
        -3787.0,
        1331.5
      ],
      [
        914.4702758789062,
        -3787.230712890625,
        1333.494384765625
      ],
      [
        914.4702758789062,
        -3787.230712890625,
        1333.494384765625
      ],
      [
        914.39697265625,
        -3795.08984375,
        1338.406494140625
      ],
      [
        914.488037109375,
        -3787.10009765625,
        1332.2999267578125
      ],
      [
        914.485107421875,
        -3787.416259765625,
        1332.49755859375
      ],
      [
        914.485107421875,
        -3787.416259765625,
        1332.49755859375
      ],
      [
        914.4088745117188,
        -3795.59033203125,
        1337.6065673828125
      ],
      [
        912.5,
        -3786.9892578125,
        1332.23046875
      ],
      [
        914.39697265625,
        -3795.08984375,
        1338.406494140625
      ],
      [
        914.4088745117188,
        -3795.59033203125,
        1337.6065673828125
      ],
      [
        914.488037109375,
        -3787.10009765625,
        1332.2999267578125
      ],
      [
        914.5,
        -3785.820556640625,
        1331.5
      ],
      [
        870.972900390625,
        -3808.16943359375,
        1319.7017822265625
      ],
      [
        871.01953125,
        -3808.293701171875,
        1320.21484375
      ],
      [
        871.8369140625,
        -3807.90087890625,
        1320.5743408203125
      ],
      [
        871.01953125,
        -3808.293701171875,
        1320.21484375
      ],
      [
        870.972900390625,
        -3808.16943359375,
        1319.7017822265625
      ],
      [
        868.3491821289062,
        -3975.0,
        1362.5
      ],
      [
        867.5,
        -3975.0,
        1336.2239990234375
      ],
      [
        867.5,
        -3975.0,
        1336.2239990234375
      ],
      [
        853.0780639648438,
        -3838.239501953125,
        1308.9493408203125
      ],
      [
        856.0970458984375,
        -3855.9462890625,
        1310.7633056640625
      ],
      [
        856.0971069335938,
        -3825.0537109375,
        1310.763427734375
      ],
      [
        863.212158203125,
        -3866.781005859375,
        1315.03857421875
      ],
      [
        863.2117919921875,
        -3814.21923828125,
        1315.038330078125
      ],
      [
        870.404296875,
        -3819.594970703125,
        1313.447265625
      ],
      [
        863.2117919921875,
        -3814.21923828125,
        1315.038330078125
      ],
      [
        872.1904907226562,
        -3786.594482421875,
        1333.0946044921875
      ],
      [
        872.0,
        -3787.007568359375,
        1330.99951171875
      ],
      [
        823.5826416015625,
        -4134.54443359375,
        1190.846435546875
      ],
      [
        896.9005126953125,
        -4161.1279296875,
        1267.0830078125
      ],
      [
        867.5,
        -3986.72607421875,
        1362.5
      ],
      [
        867.5,
        -3980.81982421875,
        1305.617919921875
      ],
      [
        867.5,
        -3978.600341796875,
        1362.5
      ],
      [
        867.5,
        -3976.525634765625,
        1328.2003173828125
      ],
      [
        811.8483276367188,
        -3670.808837890625,
        1159.5113525390625
      ],
      [
        800.9530639648438,
        -3663.281494140625,
        915.6940307617188
      ],
      [
        799.6431274414062,
        -3662.1640625,
        881.8123168945312
      ],
      [
        795.9359130859375,
        -3658.8876953125,
        783.4901123046875
      ],
      [
        862.091064453125,
        -3658.32763671875,
        1269.789306640625
      ],
      [
        830.1616821289062,
        -3667.064208984375,
        1217.0018310546875
      ],
      [
        800.2938232421875,
        -3662.7333984375,
        898.9514770507812
      ],
      [
        800.9530639648438,
        -3663.281494140625,
        915.6940307617188
      ],
      [
        800.2938232421875,
        -3662.7333984375,
        898.9514770507812
      ],
      [
        799.6431274414062,
        -3662.1640625,
        881.8123168945312
      ],
      [
        819.9124755859375,
        -3676.818115234375,
        1195.2711181640625
      ],
      [
        816.6090698242188,
        -3669.109375,
        1158.8548583984375
      ],
      [
        819.1124877929688,
        -3670.087646484375,
        1198.734619140625
      ],
      [
        891.5476684570312,
        -3648.0009765625,
        1269.789306640625
      ],
      [
        913.3961791992188,
        -3640.341796875,
        1269.789306640625
      ],
      [
        862.091064453125,
        -3658.32763671875,
        1269.789306640625
      ],
      [
        891.5476684570312,
        -3648.0009765625,
        1269.789306640625
      ],
      [
        816.6090698242188,
        -3669.109375,
        1158.8548583984375
      ],
      [
        812.6698608398438,
        -3670.51025390625,
        1159.2908935546875
      ],
      [
        811.8483276367188,
        -3670.808837890625,
        1159.5113525390625
      ],
      [
        812.6698608398438,
        -3670.51025390625,
        1159.2908935546875
      ],
      [
        830.1616821289062,
        -3667.064208984375,
        1217.0018310546875
      ],
      [
        821.9633178710938,
        -3669.749267578125,
        1212.946533203125
      ],
      [
        819.6045532226562,
        -3670.27978515625,
        1206.57275390625
      ],
      [
        821.9633178710938,
        -3669.749267578125,
        1212.946533203125
      ],
      [
        819.6045532226562,
        -3670.27978515625,
        1206.57275390625
      ],
      [
        667.2552490234375,
        -3325.69189453125,
        900.4549560546875
      ],
      [
        674.9246826171875,
        -3325.136474609375,
        765.8990478515625
      ],
      [
        667.2552490234375,
        -3325.69189453125,
        900.4549560546875
      ],
      [
        639.3869018554688,
        -3318.746826171875,
        949.6392211914062
      ],
      [
        775.4918823242188,
        -3646.291259765625,
        785.132080078125
      ],
      [
        686.0,
        -3446.5,
        1269.789306640625
      ],
      [
        686.0,
        -3493.0,
        1269.789306640625
      ],
      [
        646.5,
        -3446.5,
        1269.789306640625
      ],
      [
        646.5,
        -3493.0,
        1269.789306640625
      ],
      [
        646.5,
        -3493.0,
        1269.789306640625
      ],
      [
        646.6446533203125,
        -3493.0,
        1269.789306640625
      ],
      [
        646.6446533203125,
        -3493.0,
        1269.789306640625
      ],
      [
        686.0,
        -3493.0,
        1269.789306640625
      ],
      [
        676.0,
        -3436.5,
        1269.789306640625
      ],
      [
        656.0,
        -3436.5,
        1269.789306640625
      ],
      [
        685.9195556640625,
        -3446.419677734375,
        1269.789306640625
      ],
      [
        676.0,
        -3436.5,
        1269.789306640625
      ],
      [
        686.0,
        -3446.5,
        1269.789306640625
      ],
      [
        685.9195556640625,
        -3446.419677734375,
        1269.789306640625
      ],
      [
        656.0,
        -3436.5,
        1269.789306640625
      ],
      [
        646.5784301757812,
        -3446.41748046875,
        1269.789306640625
      ],
      [
        646.5784301757812,
        -3446.41748046875,
        1269.789306640625
      ],
      [
        646.5,
        -3446.5,
        1269.789306640625
      ],
      [
        625.0,
        -3425.0,
        1269.789306640625
      ],
      [
        625.0,
        -3426.457275390625,
        1269.789306640625
      ],
      [
        624.8507690429688,
        -3425.0,
        1269.789306640625
      ],
      [
        625.0,
        -3425.0,
        1269.789306640625
      ],
      [
        686.0,
        -3449.97705078125,
        1269.789306640625
      ],
      [
        693.0,
        -3449.97705078125,
        1269.789306640625
      ],
      [
        693.0,
        -3452.4765625,
        1269.789306640625
      ],
      [
        686.0,
        -3452.4765625,
        1269.789306640625
      ],
      [
        693.0,
        -3449.97705078125,
        1269.789306640625
      ],
      [
        693.0,
        -3452.4765625,
        1269.789306640625
      ],
      [
        795.6347045898438,
        -3657.13916015625,
        783.349609375
      ],
      [
        850.137451171875,
        -3661.598388671875,
        1250.02685546875
      ],
      [
        625.0,
        -3427.0,
        1297.2666015625
      ],
      [
        625.0,
        -3425.0,
        1297.2666015625
      ],
      [
        625.0,
        -3425.0,
        1297.2666015625
      ],
      [
        623.0,
        -3425.0,
        1296.7332763671875
      ],
      [
        625.0,
        -3427.0,
        1297.2666015625
      ],
      [
        623.0,
        -3427.0,
        1296.7332763671875
      ],
      [
        623.0,
        -3425.0,
        1296.7332763671875
      ],
      [
        623.0,
        -3427.0,
        1296.7332763671875
      ],
      [
        623.0,
        -3425.0,
        1305.0
      ],
      [
        623.0,
        -3427.0,
        1305.0
      ],
      [
        625.0,
        -3425.0,
        1305.0
      ],
      [
        623.0,
        -3425.0,
        1305.0
      ],
      [
        625.0,
        -3427.0,
        1305.0
      ],
      [
        623.0,
        -3427.0,
        1305.0
      ],
      [
        625.0,
        -3427.0,
        1305.0
      ],
      [
        625.0,
        -3425.0,
        1305.0
      ],
      [
        686.0,
        -3446.5,
        1303.5
      ],
      [
        686.0,
        -3493.0,
        1303.5
      ],
      [
        648.875,
        -3444.0,
        1303.5
      ],
      [
        683.5,
        -3444.0,
        1303.5
      ],
      [
        648.4285278320312,
        -3493.0,
        1303.5
      ],
      [
        650.4000244140625,
        -3493.0,
        1303.5
      ],
      [
        646.5,
        -3493.0,
        1303.5
      ],
      [
        648.4285278320312,
        -3493.0,
        1303.5
      ],
      [
        679.25,
        -3493.0,
        1303.5
      ],
      [
        682.3265380859375,
        -3493.0,
        1303.5
      ],
      [
        682.3265380859375,
        -3493.0,
        1303.5
      ],
      [
        686.0,
        -3493.0,
        1303.5
      ],
      [
        650.4000244140625,
        -3493.0,
        1303.5
      ],
      [
        679.25,
        -3493.0,
        1303.5
      ],
      [
        683.5,
        -3444.0,
        1303.5
      ],
      [
        684.9053955078125,
        -3445.4052734375,
        1303.5
      ],
      [
        686.0,
        -3446.5,
        1303.5
      ],
      [
        684.9053955078125,
        -3445.4052734375,
        1303.5
      ],
      [
        647.5672607421875,
        -3445.37646484375,
        1303.5
      ],
      [
        648.875,
        -3444.0,
        1303.5
      ],
      [
        647.5672607421875,
        -3445.37646484375,
        1303.5
      ],
      [
        646.5,
        -3446.5,
        1303.5
      ],
      [
        686.0,
        -3446.5,
        1288.0
      ],
      [
        686.0,
        -3493.0,
        1288.0
      ],
      [
        683.5,
        -3493.0,
        1288.0
      ],
      [
        683.5,
        -3493.0,
        1303.5
      ],
      [
        683.5,
        -3444.0,
        1301.5740966796875
      ],
      [
        686.0,
        -3446.5,
        1288.0
      ],
      [
        683.5,
        -3444.0,
        1301.5740966796875
      ],
      [
        683.5,
        -3444.0,
        1288.0
      ],
      [
        650.0,
        -3493.0,
        1302.2777099609375
      ],
      [
        650.0,
        -3493.0,
        1303.5
      ],
      [
        650.0,
        -3493.0,
        1288.0
      ],
      [
        650.0,
        -3493.0,
        1302.2777099609375
      ],
      [
        650.0,
        -3442.815673828125,
        1300.0809326171875
      ],
      [
        650.0,
        -3442.815673828125,
        1302.7894287109375
      ],
      [
        650.0,
        -3442.815673828125,
        1300.0809326171875
      ],
      [
        646.5,
        -3446.5,
        1288.0
      ],
      [
        650.0,
        -3442.81591796875,
        1288.0
      ],
      [
        650.0,
        -3442.815673828125,
        1302.7894287109375
      ],
      [
        650.0,
        -3444.0,
        1303.5
      ],
      [
        656.0,
        -3436.5,
        1297.2177734375
      ],
      [
        667.2396850585938,
        -3436.5,
        1297.0
      ],
      [
        676.26953125,
        -3436.76953125,
        1297.0
      ],
      [
        683.4711303710938,
        -3443.97119140625,
        1301.5345458984375
      ],
      [
        683.4711303710938,
        -3443.97119140625,
        1301.5345458984375
      ],
      [
        683.5,
        -3444.0,
        1301.552734375
      ],
      [
        656.0,
        -3436.5,
        1297.2177734375
      ],
      [
        650.0,
        -3442.815673828125,
        1301.4332275390625
      ],
      [
        675.74609375,
        -3436.75390625,
        1297.0
      ],
      [
        676.26953125,
        -3436.76953125,
        1297.0
      ],
      [
        667.2396850585938,
        -3436.5,
        1297.0
      ],
      [
        675.74609375,
        -3436.75390625,
        1297.0
      ],
      [
        651.5,
        -3444.396728515625,
        1302.362060546875
      ],
      [
        651.5,
        -3444.396728515625,
        1302.0
      ],
      [
        650.8478393554688,
        -3445.09375,
        1302.0
      ],
      [
        650.0,
        -3446.0,
        1302.0
      ],
      [
        650.8478393554688,
        -3445.09375,
        1302.0
      ],
      [
        651.5,
        -3444.396728515625,
        1302.362060546875
      ],
      [
        651.5,
        -3445.520751953125,
        1303.1597900390625
      ],
      [
        651.5,
        -3446.5,
        1303.5
      ],
      [
        650.0,
        -3446.5,
        1302.0
      ],
      [
        651.5,
        -3446.5,
        1302.0
      ],
      [
        681.60009765625,
        -3481.5,
        1303.5
      ],
      [
        681.60009765625,
        -3483.0,
        1303.5
      ],
      [
        682.0000610351562,
        -3483.0,
        1302.5
      ],
      [
        682.0000610351562,
        -3481.5,
        1302.5
      ],
      [
        682.2000732421875,
        -3483.0,
        1302.0
      ],
      [
        682.2000732421875,
        -3481.5,
        1302.0
      ],
      [
        651.89990234375,
        -3491.5,
        1302.0
      ],
      [
        651.89990234375,
        -3489.5,
        1302.0
      ],
      [
        651.89990234375,
        -3489.5,
        1302.0
      ],
      [
        682.2000732421875,
        -3483.89990234375,
        1302.0
      ],
      [
        683.5,
        -3483.89990234375,
        1302.0
      ],
      [
        682.2000732421875,
        -3483.89990234375,
        1302.0
      ],
      [
        681.60009765625,
        -3465.5,
        1303.5
      ],
      [
        681.60009765625,
        -3467.0,
        1303.5
      ],
      [
        682.0000610351562,
        -3467.0,
        1302.5
      ],
      [
        682.0000610351562,
        -3465.5,
        1302.5
      ],
      [
        682.2000732421875,
        -3467.0,
        1302.0
      ],
      [
        682.2000732421875,
        -3465.5,
        1302.0
      ],
      [
        682.2000732421875,
        -3480.5,
        1302.0
      ],
      [
        683.5,
        -3480.5,
        1302.0
      ],
      [
        682.2000732421875,
        -3480.5,
        1302.0
      ],
      [
        682.2000732421875,
        -3467.89990234375,
        1302.0
      ],
      [
        683.5,
        -3467.89990234375,
        1302.0
      ],
      [
        682.2000732421875,
        -3467.89990234375,
        1302.0
      ],
      [
        681.60009765625,
        -3449.5,
        1303.5
      ],
      [
        681.60009765625,
        -3451.0,
        1303.5
      ],
      [
        682.0000610351562,
        -3451.0,
        1302.5
      ],
      [
        682.0000610351562,
        -3449.5,
        1302.5
      ],
      [
        682.2000732421875,
        -3451.0,
        1302.0
      ],
      [
        682.2000732421875,
        -3449.5,
        1302.0
      ],
      [
        682.2000732421875,
        -3464.5,
        1302.0
      ],
      [
        683.5,
        -3464.5,
        1302.0
      ],
      [
        682.2000732421875,
        -3464.5,
        1302.0
      ],
      [
        682.2000732421875,
        -3451.89990234375,
        1302.0
      ],
      [
        683.5,
        -3451.89990234375,
        1302.0
      ],
      [
        682.2000732421875,
        -3451.89990234375,
        1302.0
      ],
      [
        651.977294921875,
        -3443.886474609375,
        1302.0
      ],
      [
        656.6136474609375,
        -3443.886474609375,
        1302.0
      ],
      [
        682.363037109375,
        -3445.924560546875,
        1302.0
      ],
      [
        680.977294921875,
        -3444.613525390625,
        1302.0
      ],
      [
        683.5,
        -3447.0,
        1302.0
      ],
      [
        682.363037109375,
        -3445.924560546875,
        1302.0
      ],
      [
        651.89990234375,
        -3448.5,
        1302.0
      ],
      [
        682.2000732421875,
        -3448.5,
        1302.0
      ],
      [
        683.5,
        -3448.5,
        1302.0
      ],
      [
        682.2000732421875,
        -3448.5,
        1302.0
      ],
      [
        651.89990234375,
        -3446.5,
        1302.0
      ],
      [
        651.89990234375,
        -3448.5,
        1302.0
      ],
      [
        651.89990234375,
        -3446.5,
        1302.0
      ],
      [
        651.977294921875,
        -3443.886474609375,
        1302.0
      ],
      [
        676.0,
        -3436.5,
        1288.0
      ],
      [
        656.0,
        -3436.5,
        1288.0
      ],
      [
        680.8571166992188,
        -3441.357177734375,
        1288.0
      ],
      [
        676.0,
        -3436.5,
        1288.0
      ],
      [
        680.8571166992188,
        -3441.357177734375,
        1288.0
      ],
      [
        655.6759643554688,
        -3436.841064453125,
        1297.0
      ],
      [
        656.2435913085938,
        -3436.841064453125,
        1297.0
      ],
      [
        675.6588134765625,
        -3436.84130859375,
        1297.0
      ],
      [
        676.341064453125,
        -3436.841064453125,
        1297.0
      ],
      [
        656.2435913085938,
        -3436.841064453125,
        1297.0
      ],
      [
        675.6587524414062,
        -3436.84130859375,
        1297.0
      ],
      [
        655.6759643554688,
        -3436.841064453125,
        1297.0
      ],
      [
        650.0,
        -3442.815673828125,
        1301.2401123046875
      ],
      [
        656.0,
        -3436.5,
        1288.0
      ],
      [
        651.5145263671875,
        -3441.2216796875,
        1288.0
      ],
      [
        651.5145263671875,
        -3441.2216796875,
        1288.0
      ],
      [
        654.3375244140625,
        -3438.25,
        1290.5
      ],
      [
        677.75,
        -3438.25,
        1290.5
      ],
      [
        654.3375244140625,
        -3438.25,
        1297.0
      ],
      [
        677.75,
        -3438.25,
        1297.0
      ],
      [
        682.4714965820312,
        -3446.027099609375,
        1288.0
      ],
      [
        679.3438720703125,
        -3443.068603515625,
        1288.0
      ],
      [
        679.3438720703125,
        -3443.068603515625,
        1290.1090087890625
      ],
      [
        682.471435546875,
        -3446.027099609375,
        1288.52197265625
      ],
      [
        679.3438720703125,
        -3443.068603515625,
        1298.0167236328125
      ],
      [
        679.3439331054688,
        -3443.068603515625,
        1301.02880859375
      ],
      [
        682.471435546875,
        -3446.027099609375,
        1288.52197265625
      ],
      [
        679.3438720703125,
        -3443.068603515625,
        1290.1090087890625
      ],
      [
        679.3438720703125,
        -3443.068603515625,
        1298.0167236328125
      ],
      [
        682.471435546875,
        -3446.027099609375,
        1302.0
      ],
      [
        682.249755859375,
        -3445.8173828125,
        1288.0
      ],
      [
        682.249755859375,
        -3445.8173828125,
        1300.0631103515625
      ],
      [
        682.249755859375,
        -3445.8173828125,
        1300.0631103515625
      ],
      [
        679.3438720703125,
        -3443.068603515625,
        1300.0631103515625
      ],
      [
        677.0226440429688,
        -3440.872802734375,
        1299.6485595703125
      ],
      [
        679.3438720703125,
        -3443.068603515625,
        1298.510009765625
      ],
      [
        678.9837646484375,
        -3441.90625,
        1290.5
      ],
      [
        677.4077758789062,
        -3441.237060546875,
        1290.5
      ],
      [
        674.25,
        -3438.25,
        1288.33544921875
      ],
      [
        677.4078979492188,
        -3441.2373046875,
        1290.5
      ],
      [
        678.5732421875,
        -3442.339599609375,
        1291.2987060546875
      ],
      [
        679.3438720703125,
        -3443.068603515625,
        1291.8272705078125
      ],
      [
        678.5732421875,
        -3442.339599609375,
        1291.2987060546875
      ],
      [
        678.9837036132812,
        -3441.90625,
        1290.5
      ],
      [
        679.3438720703125,
        -3443.068603515625,
        1290.5
      ],
      [
        686.0,
        -3500.0,
        1286.5
      ],
      [
        686.0,
        -3500.0,
        1286.5
      ],
      [
        686.0,
        -3500.0,
        1288.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.34175899624824524,
        0.1286817193031311,
        0.9309360384941101
      ],
      "plane_d": 470.632568359375,
      "bbox_min": [
        -6971.595703125,
        -4840.0,
        -300.0
      ],
      "bbox_max": [
        2500.0,
        6957.4052734375,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.2137451171875,
      "bbox_min": [
        -6971.595703125,
        -3101.035888671875,
        -300.0
      ],
      "bbox_max": [
        -3347.652587890625,
        4741.14404296875,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6821.484375,
        -3101.035888671875,
        -300.0
      ],
      "bbox_max": [
        -3347.652587890625,
        4729.087890625,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -3642.102783203125,
        -3101.035888671875,
        -300.0
      ],
      "bbox_max": [
        -3347.652587890625,
        -2017.578125,
        -300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6158.31884765625,
        3750.8916015625,
        347.8716735839844
      ],
      "bbox_max": [
        -5532.32763671875,
        4687.75390625,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7714905142784119,
        0.08541621267795563,
        0.6304812431335449
      ],
      "plane_d": 2975.195556640625,
      "bbox_min": [
        -5573.5615234375,
        -3910.0,
        -300.0
      ],
      "bbox_max": [
        -25.0457763671875,
        6233.96142578125,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -5573.5615234375,
        -3148.702880859375,
        -300.0
      ],
      "bbox_max": [
        -3262.646728515625,
        5695.4521484375,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.2137451171875,
      "bbox_min": [
        -5573.5615234375,
        -2698.510498046875,
        -300.0
      ],
      "bbox_max": [
        -3457.04638671875,
        5688.64697265625,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -5532.32763671875,
        -2698.510498046875,
        -300.0
      ],
      "bbox_max": [
        -3457.04638671875,
        5234.39599609375,
        347.87164306640625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5532.32763671875,
        4687.75390625,
        -22.699951171875
      ],
      "bbox_max": [
        -5158.470703125,
        5234.39599609375,
        347.87164306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5174.01171875,
        5224.01171875,
        -22.699951171875
      ],
      "bbox_max": [
        -5158.470703125,
        5234.39599609375,
        -11.83929443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -5573.5615234375,
        4475.62646484375,
        -22.699951171875
      ],
      "bbox_max": [
        -4474.53173828125,
        5688.64697265625,
        901.1307983398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5335.22314453125,
        4982.7412109375,
        -22.699951171875
      ],
      "bbox_max": [
        -4478.6357421875,
        5688.64697265625,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5335.22314453125,
        4982.7412109375,
        -11.839269638061523
      ],
      "bbox_max": [
        -5174.01171875,
        5224.01171875,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5573.5615234375,
        4626.04296875,
        150.0
      ],
      "bbox_max": [
        -4599.86376953125,
        5607.64453125,
        901.1307983398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5174.01171875,
        5224.01171875,
        150.0
      ],
      "bbox_max": [
        -4599.86376953125,
        5607.64453125,
        671.7944946289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5895068049430847,
        -0.7432911992073059,
        0.31622785329818726
      ],
      "plane_d": 4052.21826171875,
      "bbox_min": [
        -4485.7236328125,
        2156.023681640625,
        -300.0
      ],
      "bbox_max": [
        -3861.632568359375,
        5695.4521484375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -4485.7236328125,
        5683.91064453125,
        -22.699951171875
      ],
      "bbox_max": [
        -4468.451171875,
        5695.4521484375,
        -0.000560760498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -4912.15185546875,
        -3910.0,
        -300.0
      ],
      "bbox_max": [
        -25.0457763671875,
        6233.96142578125,
        1000.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -4912.15185546875,
        -3472.765869140625,
        -300.0
      ],
      "bbox_max": [
        -69.49658203125,
        6233.96142578125,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5895068049430847,
        -0.7432911992073059,
        0.31622785329818726
      ],
      "plane_d": 4052.21826171875,
      "bbox_min": [
        -4599.8642578125,
        2200.0,
        -300.0
      ],
      "bbox_max": [
        -2610.551025390625,
        6233.96142578125,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -4599.8642578125,
        5607.64453125,
        -22.699951171875
      ],
      "bbox_max": [
        -3662.5146484375,
        6233.96142578125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -4901.7099609375,
        5405.95751953125,
        150.0
      ],
      "bbox_max": [
        -4038.378662109375,
        5982.8173828125,
        546.6788940429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -2906.989501953125,
        -3472.765869140625,
        -300.0
      ],
      "bbox_max": [
        -69.49658203125,
        1330.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4976885914802551,
        -0.8076545596122742,
        0.31622782349586487
      ],
      "plane_d": 447.54583740234375,
      "bbox_min": [
        -2827.890380859375,
        -1095.0159912109375,
        -300.0
      ],
      "bbox_max": [
        -1822.041748046875,
        -612.2042846679688,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10974399000406265,
        -0.9423142671585083,
        0.3162277042865753
      ],
      "plane_d": -1209.764404296875,
      "bbox_min": [
        -2827.890380859375,
        -1095.0159912109375,
        -300.0
      ],
      "bbox_max": [
        -2485.635009765625,
        -963.6311645507812,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        -2906.989501953125,
        -2942.424560546875,
        0.0
      ],
      "bbox_max": [
        -269.1846923828125,
        1330.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1330.0,
      "bbox_min": [
        -2749.31689453125,
        -2942.424560546875,
        0.0
      ],
      "bbox_max": [
        -269.1846923828125,
        1330.0,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1034676656126976,
        -0.8884226083755493,
        0.44721338152885437
      ],
      "plane_d": -1140.5770263671875,
      "bbox_min": [
        -2749.31689453125,
        -991.6719970703125,
        0.0
      ],
      "bbox_max": [
        -2508.544921875,
        -917.86865234375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9115313291549683,
        -0.38201379776000977,
        0.1522369533777237
      ],
      "plane_d": -1389.03466796875,
      "bbox_min": [
        -998.4295654296875,
        -2942.424560546875,
        0.0
      ],
      "bbox_max": [
        -269.1846923828125,
        -2052.855712890625,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8872413635253906,
        0.4606812298297882,
        0.023994388058781624
      ],
      "plane_d": 1603.4219970703125,
      "bbox_min": [
        -542.46337890625,
        -2942.424560546875,
        0.0
      ],
      "bbox_max": [
        -269.1846923828125,
        -2340.52392578125,
        16.305919647216797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2967163920402527,
        0.9547621607780457,
        0.01971287839114666
      ],
      "plane_d": 2806.599853515625,
      "bbox_min": [
        -335.6207275390625,
        -2835.53662109375,
        0.0
      ],
      "bbox_max": [
        -334.930419921875,
        -2835.25341796875,
        3.064878463745117
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32657477259635925,
        0.944736123085022,
        0.02867927961051464
      ],
      "plane_d": 2788.171630859375,
      "bbox_min": [
        -335.6207275390625,
        -2835.491943359375,
        0.0
      ],
      "bbox_max": [
        -334.930419921875,
        -2835.25341796875,
        1.413412094116211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7295700907707214,
        0.6833271980285645,
        0.02813161164522171
      ],
      "plane_d": 2207.02783203125,
      "bbox_min": [
        -292.2781066894531,
        -2918.07177734375,
        0.0
      ],
      "bbox_max": [
        -292.12548828125,
        -2917.931396484375,
        5.098724842071533
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5485955476760864,
        0.7409572601318359,
        0.3873308598995209
      ],
      "plane_d": 2070.496826171875,
      "bbox_min": [
        -542.46337890625,
        -2942.424560546875,
        0.0
      ],
      "bbox_max": [
        -269.1846923828125,
        -2340.52392578125,
        16.305919647216797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46342891454696655,
        -0.8689261674880981,
        0.1737847626209259
      ],
      "plane_d": -2528.490478515625,
      "bbox_min": [
        -391.940673828125,
        -2942.424560546875,
        0.0
      ],
      "bbox_max": [
        -269.1846923828125,
        -2699.2919921875,
        11.023941040039062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7295700907707214,
        0.6833271980285645,
        0.02813161164522171
      ],
      "plane_d": 2207.02783203125,
      "bbox_min": [
        -292.18988037109375,
        -2942.424560546875,
        0.0
      ],
      "bbox_max": [
        -269.1846923828125,
        -2917.931396484375,
        5.079243183135986
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4636538028717041,
        -0.7131181955337524,
        0.5258208513259888
      ],
      "plane_d": -1921.4649658203125,
      "bbox_min": [
        -542.46337890625,
        -2440.3291015625,
        0.0
      ],
      "bbox_max": [
        -480.08074951171875,
        -2340.52392578125,
        16.305919647216797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4998539388179779,
        -0.8565889596939087,
        0.1280682235956192
      ],
      "plane_d": -2276.9931640625,
      "bbox_min": [
        -542.46337890625,
        -2440.3291015625,
        0.0
      ],
      "bbox_max": [
        -485.1326599121094,
        -2340.52392578125,
        16.305919647216797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5381221771240234,
        0.8373711705207825,
        0.0960942804813385
      ],
      "plane_d": 2298.044677734375,
      "bbox_min": [
        -511.46240234375,
        -2420.4609375,
        0.0
      ],
      "bbox_max": [
        -506.69952392578125,
        -2415.673583984375,
        15.131795883178711
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9296503663063049,
        0.3666344881057739,
        0.03646130487322807
      ],
      "plane_d": 1454.0635986328125,
      "bbox_min": [
        -998.4295654296875,
        -2846.7548828125,
        0.0
      ],
      "bbox_max": [
        -329.32183837890625,
        -2052.855712890625,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8202191591262817,
        0.571056604385376,
        0.033687908202409744
      ],
      "plane_d": 1912.07421875,
      "bbox_min": [
        -998.4295654296875,
        -2792.09521484375,
        0.0
      ],
      "bbox_max": [
        -463.345703125,
        -2052.855712890625,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7558661103248596,
        -0.43222060799598694,
        0.4917842447757721
      ],
      "plane_d": -188.6185302734375,
      "bbox_min": [
        -998.4295654296875,
        -2792.09521484375,
        0.0
      ],
      "bbox_max": [
        -463.345703125,
        -2052.855712890625,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.703201413154602,
        0.7104752063751221,
        0.027071993798017502
      ],
      "plane_d": 2169.124267578125,
      "bbox_min": [
        -998.4295654296875,
        -2792.09521484375,
        0.0
      ],
      "bbox_max": [
        -463.345703125,
        -2052.855712890625,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9315862059593201,
        0.3613213896751404,
        0.03992580994963646
      ],
      "plane_d": 1440.1312255859375,
      "bbox_min": [
        -476.63665771484375,
        -2792.09521484375,
        0.0
      ],
      "bbox_max": [
        -463.345703125,
        -2762.5009765625,
        51.287872314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32657477259635925,
        0.944736123085022,
        0.02867927961051464
      ],
      "plane_d": 2788.171630859375,
      "bbox_min": [
        -465.1822814941406,
        -2792.09521484375,
        0.0
      ],
      "bbox_max": [
        -463.345703125,
        -2791.1015625,
        51.16314697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.755939245223999,
        0.6539766788482666,
        0.02950362116098404
      ],
      "plane_d": 2042.1041259765625,
      "bbox_min": [
        -989.39013671875,
        -2298.567626953125,
        0.0
      ],
      "bbox_max": [
        -730.8558959960938,
        -2052.855712890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16410836577415466,
        -0.9725522994995117,
        0.16495561599731445
      ],
      "plane_d": -2175.37255859375,
      "bbox_min": [
        -989.39013671875,
        -2298.567626953125,
        0.0
      ],
      "bbox_max": [
        -730.8558959960938,
        -2052.855712890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7153007388114929,
        0.6982023119926453,
        0.029299555346369743
      ],
      "plane_d": 2127.64697265625,
      "bbox_min": [
        -952.0017700195312,
        -2298.567626953125,
        0.0
      ],
      "bbox_max": [
        -730.8558959960938,
        -2059.164794921875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9409332871437073,
        0.3373379111289978,
        0.0291153434664011
      ],
      "plane_d": 1465.486572265625,
      "bbox_min": [
        -952.0017700195312,
        -2295.762939453125,
        0.0
      ],
      "bbox_max": [
        -734.897216796875,
        -2059.164794921875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22133076190948486,
        -0.9681739807128906,
        0.11684101819992065
      ],
      "plane_d": -2216.021240234375,
      "bbox_min": [
        -952.0017700195312,
        -2074.339599609375,
        60.354286193847656
      ],
      "bbox_max": [
        -909.219970703125,
        -2059.164794921875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2265453338623047,
        -0.9669476747512817,
        0.11700189113616943
      ],
      "plane_d": -2218.357666015625,
      "bbox_min": [
        -931.78857421875,
        -2074.339599609375,
        60.354286193847656
      ],
      "bbox_max": [
        -909.219970703125,
        -2064.103271484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2292175441980362,
        -0.9629797339439392,
        0.14187826216220856
      ],
      "plane_d": -2214.51904296875,
      "bbox_min": [
        -931.78857421875,
        -2074.339599609375,
        60.354286193847656
      ],
      "bbox_max": [
        -909.219970703125,
        -2066.770263671875,
        77.9502944946289
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21190191805362701,
        -0.9627490639686584,
        0.16796369850635529
      ],
      "plane_d": -2199.871337890625,
      "bbox_min": [
        -916.883544921875,
        -2092.55859375,
        0.0
      ],
      "bbox_max": [
        -874.2844848632812,
        -2067.269775390625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2292175441980362,
        -0.9629797339439392,
        0.14187826216220856
      ],
      "plane_d": -2214.51904296875,
      "bbox_min": [
        -916.883544921875,
        -2083.308837890625,
        42.68165969848633
      ],
      "bbox_max": [
        -882.4772338867188,
        -2067.269775390625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2265453338623047,
        -0.9669476747512817,
        0.11700189113616943
      ],
      "plane_d": -2218.357666015625,
      "bbox_min": [
        -916.883544921875,
        -2076.03125,
        77.9502944946289
      ],
      "bbox_max": [
        -889.1314086914062,
        -2067.269775390625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47615304589271545,
        -0.8670215010643005,
        0.14680615067481995
      ],
      "plane_d": -2214.495849609375,
      "bbox_min": [
        -891.9275512695312,
        -2424.538818359375,
        0.0
      ],
      "bbox_max": [
        -645.8916015625,
        -2073.11669921875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40625426173210144,
        -0.880420982837677,
        0.2445736974477768
      ],
      "plane_d": -2194.858154296875,
      "bbox_min": [
        -791.312744140625,
        -2160.820068359375,
        12.314563751220703
      ],
      "bbox_max": [
        -712.3984375,
        -2106.671875,
        76.15544128417969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8710070252418518,
        0.4906066656112671,
        0.025533335283398628
      ],
      "plane_d": 1752.1368408203125,
      "bbox_min": [
        -752.3124389648438,
        -2424.538818359375,
        0.0
      ],
      "bbox_max": [
        -645.8916015625,
        -2254.792724609375,
        82.57786560058594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7153007388114929,
        0.6982023119926453,
        0.029299555346369743
      ],
      "plane_d": 2127.64697265625,
      "bbox_min": [
        -752.3124389648438,
        -2333.46923828125,
        0.0
      ],
      "bbox_max": [
        -697.9111328125,
        -2254.792724609375,
        82.57786560058594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9409332871437073,
        0.3373379111289978,
        0.0291153434664011
      ],
      "plane_d": 1465.486572265625,
      "bbox_min": [
        -739.3873901367188,
        -2293.465576171875,
        35.78874588012695
      ],
      "bbox_max": [
        -736.849853515625,
        -2289.005859375,
        82.32648468017578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -704.1259765625,
        -2333.46923828125,
        0.0
      ],
      "bbox_max": [
        -697.9111328125,
        -2329.094970703125,
        74.89317321777344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8764687180519104,
        0.48085829615592957,
        0.024040397256612778
      ],
      "plane_d": 1733.2122802734375,
      "bbox_min": [
        -699.4259033203125,
        -2424.538818359375,
        0.0
      ],
      "bbox_max": [
        -645.8916015625,
        -2332.319091796875,
        73.77235412597656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -699.4259033203125,
        -2333.704833984375,
        0.0
      ],
      "bbox_max": [
        -697.9111328125,
        -2332.319091796875,
        73.77235412597656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.834480881690979,
        0.550487756729126,
        0.024593127891421318
      ],
      "plane_d": 1872.022705078125,
      "bbox_min": [
        -659.8509521484375,
        -2424.538818359375,
        0.0
      ],
      "bbox_max": [
        -645.8916015625,
        -2403.364990234375,
        68.92090606689453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2292175441980362,
        -0.9629797339439392,
        0.14187826216220856
      ],
      "plane_d": -2214.51904296875,
      "bbox_min": [
        -891.9275512695312,
        -2256.71337890625,
        0.0
      ],
      "bbox_max": [
        -750.751220703125,
        -2073.11669921875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429206371307373,
        0.6689925789833069,
        0.022761045023798943
      ],
      "plane_d": 2066.188232421875,
      "bbox_min": [
        -891.9275512695312,
        -2256.71337890625,
        0.0
      ],
      "bbox_max": [
        -750.751220703125,
        -2073.11669921875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9281567931175232,
        0.37126728892326355,
        0.02618309296667576
      ],
      "plane_d": 1533.945556640625,
      "bbox_min": [
        -752.9208374023438,
        -2256.71337890625,
        0.0
      ],
      "bbox_max": [
        -750.751220703125,
        -2254.792724609375,
        82.59110260009766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21190191805362701,
        -0.9627490639686584,
        0.16796369850635529
      ],
      "plane_d": -2199.871337890625,
      "bbox_min": [
        -891.9275512695312,
        -2104.970947265625,
        0.0
      ],
      "bbox_max": [
        -817.89013671875,
        -2073.11669921875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2265453338623047,
        -0.9669476747512817,
        0.11700189113616943
      ],
      "plane_d": -2218.357666015625,
      "bbox_min": [
        -891.9275512695312,
        -2088.039306640625,
        81.32788848876953
      ],
      "bbox_max": [
        -833.81982421875,
        -2073.11669921875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32657477259635925,
        0.944736123085022,
        0.02867927961051464
      ],
      "plane_d": 2788.171630859375,
      "bbox_min": [
        -720.233154296875,
        -2846.7548828125,
        0.0
      ],
      "bbox_max": [
        -329.32183837890625,
        -2145.23828125,
        55.392127990722656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8872413635253906,
        0.4606812298297882,
        0.023994388058781624
      ],
      "plane_d": 1603.4219970703125,
      "bbox_min": [
        -335.0601501464844,
        -2846.7548828125,
        3.0822858810424805
      ],
      "bbox_max": [
        -329.32183837890625,
        -2835.57080078125,
        9.436009407043457
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8397244811058044,
        -0.5365661978721619,
        0.08342374861240387
      ],
      "plane_d": -1756.9742431640625,
      "bbox_min": [
        -661.85498046875,
        -2341.778076171875,
        0.0
      ],
      "bbox_max": [
        -540.2335815429688,
        -2238.677001953125,
        23.676090240478516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4998539388179779,
        -0.8565889596939087,
        0.1280682235956192
      ],
      "plane_d": -2276.9931640625,
      "bbox_min": [
        -543.9111328125,
        -2341.778076171875,
        0.0
      ],
      "bbox_max": [
        -540.2335815429688,
        -2338.3798828125,
        17.267974853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4636538028717041,
        -0.7131181955337524,
        0.5258208513259888
      ],
      "plane_d": -1921.4649658203125,
      "bbox_min": [
        -543.9111328125,
        -2341.778076171875,
        0.0
      ],
      "bbox_max": [
        -542.4313354492188,
        -2340.81591796875,
        0.16411590576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40625426173210144,
        -0.880420982837677,
        0.2445736974477768
      ],
      "plane_d": -2194.858154296875,
      "bbox_min": [
        -720.233154296875,
        -2275.20458984375,
        0.0
      ],
      "bbox_max": [
        -636.0657348632812,
        -2145.23828125,
        55.392127990722656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47615304589271545,
        -0.8670215010643005,
        0.14680615067481995
      ],
      "plane_d": -2214.495849609375,
      "bbox_min": [
        -712.3984375,
        -2171.264892578125,
        0.0
      ],
      "bbox_max": [
        -697.17626953125,
        -2160.820068359375,
        12.31456184387207
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8397244811058044,
        -0.5365661978721619,
        0.08342374861240387
      ],
      "plane_d": -1756.9742431640625,
      "bbox_min": [
        -661.85498046875,
        -2275.20458984375,
        0.0
      ],
      "bbox_max": [
        -636.0657348632812,
        -2236.3203125,
        45.532135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8221501111984253,
        -0.5637224912643433,
        0.07928481698036194
      ],
      "plane_d": -1806.1368408203125,
      "bbox_min": [
        -661.85498046875,
        -2241.480224609375,
        0.0
      ],
      "bbox_max": [
        -655.5964965820312,
        -2236.3203125,
        45.532135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5192293524742126,
        -0.8514940738677979,
        0.07320254296064377
      ],
      "plane_d": -2270.671142578125,
      "bbox_min": [
        -636.28662109375,
        -2835.733642578125,
        0.0
      ],
      "bbox_max": [
        -334.97283935546875,
        -2272.493896484375,
        42.083526611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8397244811058044,
        -0.5365661978721619,
        0.08342374861240387
      ],
      "plane_d": -1756.9742431640625,
      "bbox_min": [
        -636.28662109375,
        -2278.69140625,
        0.0
      ],
      "bbox_max": [
        -633.2545166015625,
        -2272.493896484375,
        42.083526611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8953548073768616,
        -0.444709450006485,
        0.023941759020090103
      ],
      "plane_d": -1532.2132568359375,
      "bbox_min": [
        -511.46240234375,
        -2835.733642578125,
        0.0
      ],
      "bbox_max": [
        -334.97283935546875,
        -2415.673583984375,
        15.71405029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9434628486633301,
        -0.32140111923217773,
        0.08111273497343063
      ],
      "plane_d": -1258.9459228515625,
      "bbox_min": [
        -511.46240234375,
        -2421.639404296875,
        0.0
      ],
      "bbox_max": [
        -507.00762939453125,
        -2415.673583984375,
        15.714020729064941
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5381221771240234,
        0.8373711705207825,
        0.0960942804813385
      ],
      "plane_d": 2298.044677734375,
      "bbox_min": [
        -511.46240234375,
        -2420.27294921875,
        0.0
      ],
      "bbox_max": [
        -507.00762939453125,
        -2415.673583984375,
        15.691069602966309
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8689243793487549,
        0.41837501525878906,
        0.2644478976726532
      ],
      "plane_d": 566.2352905273438,
      "bbox_min": [
        -511.46240234375,
        -2419.84130859375,
        0.0
      ],
      "bbox_max": [
        -508.50347900390625,
        -2415.673583984375,
        15.691069602966309
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2967163920402527,
        0.9547621607780457,
        0.01971287839114666
      ],
      "plane_d": 2806.599853515625,
      "bbox_min": [
        -337.7999267578125,
        -2835.733642578125,
        1.4134142398834229
      ],
      "bbox_max": [
        -334.97283935546875,
        -2834.813232421875,
        10.314589500427246
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8872413635253906,
        0.4606812298297882,
        0.023994388058781624
      ],
      "plane_d": 1603.4219970703125,
      "bbox_min": [
        -335.11419677734375,
        -2835.733642578125,
        3.064664363861084
      ],
      "bbox_max": [
        -334.97283935546875,
        -2835.53662109375,
        9.44150161743164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1330.0,
      "bbox_min": [
        -2720.0,
        -2160.974609375,
        100.0
      ],
      "bbox_max": [
        -835.8177490234375,
        1330.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2265453338623047,
        -0.9669476747512817,
        0.11700189113616943
      ],
      "plane_d": -2218.357666015625,
      "bbox_min": [
        -1020.9271850585938,
        -2160.974609375,
        100.0
      ],
      "bbox_max": [
        -835.8177490234375,
        -2040.4329833984375,
        152.3941650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7558661103248596,
        -0.43222060799598694,
        0.4917842447757721
      ],
      "plane_d": -188.6185302734375,
      "bbox_min": [
        -1020.9271850585938,
        -2160.974609375,
        100.0
      ],
      "bbox_max": [
        -835.8177490234375,
        -2040.4329833984375,
        152.3941650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22133076190948486,
        -0.9681739807128906,
        0.11684101819992065
      ],
      "plane_d": -2216.021240234375,
      "bbox_min": [
        -983.4622802734375,
        -2160.974609375,
        100.0
      ],
      "bbox_max": [
        -835.8177490234375,
        -2047.3272705078125,
        138.49298095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14295123517513275,
        0.10370974987745285,
        0.984281063079834
      ],
      "plane_d": -505.4921875,
      "bbox_min": [
        -5704.521484375,
        -4840.0,
        -300.0
      ],
      "bbox_max": [
        2500.0,
        6957.4052734375,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600968956947327,
        0.260924369096756,
        0.10065929591655731
      ],
      "plane_d": 4053.40478515625,
      "bbox_min": [
        -5331.83740234375,
        -4840.0,
        -300.0
      ],
      "bbox_max": [
        2500.0,
        6957.4052734375,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -5331.83740234375,
        -4840.0,
        -300.0
      ],
      "bbox_max": [
        2500.0,
        6957.4052734375,
        1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -3711.9189453125,
        -653.9140625,
        -300.0
      ],
      "bbox_max": [
        -291.9101257324219,
        6871.484375,
        0.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -3711.9189453125,
        6200.95068359375,
        -22.699951171875
      ],
      "bbox_max": [
        -2708.39404296875,
        6871.484375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -4038.37890625,
        -4432.0419921875,
        0.0
      ],
      "bbox_max": [
        1978.01318359375,
        6871.484375,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        -2975.73193359375,
        -4432.0419921875,
        0.0
      ],
      "bbox_max": [
        1978.01318359375,
        3398.1728515625,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9155784845352173,
        -0.4009268283843994,
        0.03120390512049198
      ],
      "plane_d": 474.5985412597656,
      "bbox_min": [
        -2863.203369140625,
        -4427.73583984375,
        0.0
      ],
      "bbox_max": [
        1976.828125,
        3382.115234375,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7444267272949219,
        -0.3871832489967346,
        0.5439833998680115
      ],
      "plane_d": 171.2200927734375,
      "bbox_min": [
        -2863.203369140625,
        -4427.73583984375,
        0.0
      ],
      "bbox_max": [
        1976.828125,
        3382.115234375,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48862767219543457,
        -0.23000489175319672,
        0.8416298031806946
      ],
      "plane_d": 182.18280029296875,
      "bbox_min": [
        -2863.203369140625,
        -4427.73583984375,
        0.0
      ],
      "bbox_max": [
        1976.828125,
        3382.115234375,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8252175450325012,
        0.5623308420181274,
        0.052915215492248535
      ],
      "plane_d": 1773.6002197265625,
      "bbox_min": [
        -2863.203369140625,
        -4427.73583984375,
        0.0
      ],
      "bbox_max": [
        1976.828125,
        3382.115234375,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.58088219165802,
        0.8135150671005249,
        0.027732910588383675
      ],
      "plane_d": 2567.5458984375,
      "bbox_min": [
        -866.6705932617188,
        -4427.73583984375,
        0.0
      ],
      "bbox_max": [
        815.3750610351562,
        -2079.0341796875,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.878898024559021,
        0.47661417722702026,
        0.019420865923166275
      ],
      "plane_d": 1412.29296875,
      "bbox_min": [
        204.65553283691406,
        -4427.73583984375,
        0.0
      ],
      "bbox_max": [
        815.3750610351562,
        -3502.35498046875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9755158424377441,
        -0.21523292362689972,
        0.0452059768140316
      ],
      "plane_d": -985.38037109375,
      "bbox_min": [
        204.65553283691406,
        -3725.4296875,
        0.0
      ],
      "bbox_max": [
        387.8497619628906,
        -3502.35498046875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7465224862098694,
        0.6641824245452881,
        0.039570894092321396
      ],
      "plane_d": 2255.672607421875,
      "bbox_min": [
        204.65553283691406,
        -3725.4296875,
        0.0
      ],
      "bbox_max": [
        387.8497619628906,
        -3615.822509765625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0567576140165329,
        0.9980700612068176,
        0.025192802771925926
      ],
      "plane_d": 3693.984130859375,
      "bbox_min": [
        204.65553283691406,
        -3725.4296875,
        0.0
      ],
      "bbox_max": [
        387.8497619628906,
        -3615.822509765625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9822387099266052,
        -0.18323063850402832,
        0.04041934385895729
      ],
      "plane_d": -870.5835571289062,
      "bbox_min": [
        204.65553283691406,
        -3632.149169921875,
        0.0
      ],
      "bbox_max": [
        208.97607421875,
        -3615.822509765625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9959223866462708,
        -0.08835939317941666,
        0.0181999821215868
      ],
      "plane_d": -1099.0582275390625,
      "bbox_min": [
        720.5958862304688,
        -4427.73583984375,
        0.0
      ],
      "bbox_max": [
        815.3750610351562,
        -4223.58056640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8812400102615356,
        0.4723060727119446,
        0.018526695668697357
      ],
      "plane_d": 1392.0955810546875,
      "bbox_min": [
        720.5958862304688,
        -4312.38916015625,
        0.0
      ],
      "bbox_max": [
        756.310302734375,
        -4262.43359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661832451820374,
        0.25639787316322327,
        0.027386151254177094
      ],
      "plane_d": 1823.6815185546875,
      "bbox_min": [
        752.90673828125,
        -4275.525390625,
        0.0
      ],
      "bbox_max": [
        756.310302734375,
        -4262.43359375,
        94.172119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9811185002326965,
        0.1803492158651352,
        0.06986100971698761
      ],
      "plane_d": 1509.7783203125,
      "bbox_min": [
        752.90673828125,
        -4275.525390625,
        0.0
      ],
      "bbox_max": [
        756.1282958984375,
        -4262.43359375,
        19.196945190429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9115313291549683,
        -0.38201379776000977,
        0.1522369533777237
      ],
      "plane_d": -1389.03466796875,
      "bbox_min": [
        -866.6705932617188,
        -3158.10205078125,
        0.0
      ],
      "bbox_max": [
        2.78466796875,
        -2079.0341796875,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46342888474464417,
        -0.8689260482788086,
        0.1737847924232483
      ],
      "plane_d": -2528.490478515625,
      "bbox_min": [
        -507.0077819824219,
        -3158.10205078125,
        0.0
      ],
      "bbox_max": [
        2.78466796875,
        -2420.27294921875,
        100.00000762939453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6797831654548645,
        0.7331897616386414,
        0.018096309155225754
      ],
      "plane_d": 2118.83056640625,
      "bbox_min": [
        -507.0077819824219,
        -2435.604248046875,
        11.103279113769531
      ],
      "bbox_max": [
        -490.261474609375,
        -2420.27294921875,
        55.0307502746582
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5381221771240234,
        0.8373711705207825,
        0.0960942804813385
      ],
      "plane_d": 2298.044677734375,
      "bbox_min": [
        -507.0077819824219,
        -2432.39990234375,
        15.044677734375
      ],
      "bbox_max": [
        -495.2618713378906,
        -2420.27294921875,
        55.0307502746582
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7295700907707214,
        0.6833271980285645,
        0.02813161164522171
      ],
      "plane_d": 2207.02783203125,
      "bbox_min": [
        -329.3223571777344,
        -3158.10205078125,
        0.0
      ],
      "bbox_max": [
        2.78466796875,
        -2846.75390625,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388664484024048,
        0.6731492280960083,
        0.03076668083667755
      ],
      "plane_d": 2178.357666015625,
      "bbox_min": [
        -223.589599609375,
        -3008.524169921875,
        0.0
      ],
      "bbox_max": [
        -208.442626953125,
        -2995.22216796875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5771116018295288,
        0.8162537217140198,
        0.02592291869223118
      ],
      "plane_d": 2576.205322265625,
      "bbox_min": [
        -329.3223571777344,
        -3158.10205078125,
        0.0
      ],
      "bbox_max": [
        2.78466796875,
        -2846.75390625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8872413635253906,
        0.4606812298297882,
        0.023994388058781624
      ],
      "plane_d": 1603.4219970703125,
      "bbox_min": [
        -329.3223571777344,
        -2918.3369140625,
        5.0987548828125
      ],
      "bbox_max": [
        -292.2781066894531,
        -2846.75390625,
        44.05067443847656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9094638824462891,
        0.4146226942539215,
        0.031041515991091728
      ],
      "plane_d": 1475.5181884765625,
      "bbox_min": [
        -295.7951354980469,
        -2918.3369140625,
        5.0987548828125
      ],
      "bbox_max": [
        -292.2781066894531,
        -2913.1083984375,
        44.05067443847656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9296503663063049,
        0.3666344881057739,
        0.03646130487322807
      ],
      "plane_d": 1454.0635986328125,
      "bbox_min": [
        -866.6705932617188,
        -2940.561279296875,
        8.852900505065918
      ],
      "bbox_max": [
        -274.785888671875,
        -2079.0341796875,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8202191591262817,
        0.571056604385376,
        0.033687908202409744
      ],
      "plane_d": 1912.07421875,
      "bbox_min": [
        -866.6705932617188,
        -2793.04638671875,
        51.09109115600586
      ],
      "bbox_max": [
        -464.95758056640625,
        -2079.0341796875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9315862059593201,
        0.3613213896751404,
        0.03992580994963646
      ],
      "plane_d": 1440.1312255859375,
      "bbox_min": [
        -835.8177490234375,
        -2793.04638671875,
        51.09109115600586
      ],
      "bbox_max": [
        -464.95758056640625,
        -2160.974609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.755939245223999,
        0.6539766788482666,
        0.02950362116098404
      ],
      "plane_d": 2042.1041259765625,
      "bbox_min": [
        -835.8177490234375,
        -2298.534912109375,
        81.7224349975586
      ],
      "bbox_max": [
        -734.2352905273438,
        -2160.974609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9409332871437073,
        0.3373379111289978,
        0.0291153434664011
      ],
      "plane_d": 1465.486572265625,
      "bbox_min": [
        -738.1463012695312,
        -2296.04931640625,
        82.32648468017578
      ],
      "bbox_max": [
        -736.9662475585938,
        -2293.465576171875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32657477259635925,
        0.944736123085022,
        0.02867927961051464
      ],
      "plane_d": 2788.171630859375,
      "bbox_min": [
        -466.93536376953125,
        -2793.04638671875,
        51.09109115600586
      ],
      "bbox_max": [
        -464.95758056640625,
        -2792.019775390625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4426290988922119,
        -0.8944221138954163,
        0.06394129991531372
      ],
      "plane_d": -2236.98828125,
      "bbox_min": [
        -866.6705932617188,
        -2435.106201171875,
        55.392127990722656
      ],
      "bbox_max": [
        -639.9016723632812,
        -2079.0341796875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2292175441980362,
        -0.9629797339439392,
        0.14187826216220856
      ],
      "plane_d": -2214.51904296875,
      "bbox_min": [
        -816.5322875976562,
        -2094.26025390625,
        82.06751251220703
      ],
      "bbox_max": [
        -811.36181640625,
        -2092.9150390625,
        92.37496948242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8710070252418518,
        0.4906066656112671,
        0.025533335283398628
      ],
      "plane_d": 1752.1368408203125,
      "bbox_min": [
        -866.6705932617188,
        -2435.106201171875,
        66.70761108398438
      ],
      "bbox_max": [
        -639.9016723632812,
        -2079.0341796875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.755939245223999,
        0.6539766788482666,
        0.02950362116098404
      ],
      "plane_d": 2042.1041259765625,
      "bbox_min": [
        -866.6705932617188,
        -2333.877685546875,
        73.77235412597656
      ],
      "bbox_max": [
        -699.4259033203125,
        -2079.0341796875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7153007388114929,
        0.6982023119926453,
        0.029299555346369743
      ],
      "plane_d": 2127.64697265625,
      "bbox_min": [
        -752.6417236328125,
        -2333.877685546875,
        73.77235412597656
      ],
      "bbox_max": [
        -699.4259033203125,
        -2256.71337890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9281567931175232,
        0.37126728892326355,
        0.02618309296667576
      ],
      "plane_d": 1533.945556640625,
      "bbox_min": [
        -752.6417236328125,
        -2333.877685546875,
        73.77235412597656
      ],
      "bbox_max": [
        -699.4259033203125,
        -2256.71337890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9409332871437073,
        0.3373379111289978,
        0.0291153434664011
      ],
      "plane_d": 1465.486572265625,
      "bbox_min": [
        -740.3533325195312,
        -2293.99560546875,
        82.29664611816406
      ],
      "bbox_max": [
        -737.7894287109375,
        -2287.839599609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -706.2094116210938,
        -2333.877685546875,
        73.77235412597656
      ],
      "bbox_max": [
        -699.4259033203125,
        -2328.01416015625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429206371307373,
        0.6689925789833069,
        0.022761045023798943
      ],
      "plane_d": 2066.188232421875,
      "bbox_min": [
        -866.6705932617188,
        -2257.118896484375,
        82.57786560058594
      ],
      "bbox_max": [
        -752.3124389648438,
        -2079.0341796875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9281567931175232,
        0.37126728892326355,
        0.02618309296667576
      ],
      "plane_d": 1533.945556640625,
      "bbox_min": [
        -753.378173828125,
        -2257.118896484375,
        82.57786560058594
      ],
      "bbox_max": [
        -752.3124389648438,
        -2255.193359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2265453338623047,
        -0.9669476747512817,
        0.11700189113616943
      ],
      "plane_d": -2218.357666015625,
      "bbox_min": [
        -866.6705932617188,
        -2086.62939453125,
        90.87821197509766
      ],
      "bbox_max": [
        -838.9634399414062,
        -2079.0341796875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -839.9876708984375,
        -2334.198974609375,
        73.71197509765625
      ],
      "bbox_max": [
        -699.1726684570312,
        -2085.28564453125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2265453338623047,
        -0.9669476747512817,
        0.11700189113616943
      ],
      "plane_d": -2218.357666015625,
      "bbox_min": [
        -839.9876708984375,
        -2087.857666015625,
        89.40303039550781
      ],
      "bbox_max": [
        -834.4826049804688,
        -2085.28564453125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2265453338623047,
        -0.9669476747512817,
        0.11700189113616943
      ],
      "plane_d": -2218.357666015625,
      "bbox_min": [
        -835.6233520507812,
        -2092.988525390625,
        83.52244567871094
      ],
      "bbox_max": [
        -811.104736328125,
        -2086.30810546875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2292175441980362,
        -0.9629797339439392,
        0.14187826216220856
      ],
      "plane_d": -2214.51904296875,
      "bbox_min": [
        -833.8198852539062,
        -2092.988525390625,
        83.52244567871094
      ],
      "bbox_max": [
        -811.104736328125,
        -2088.039306640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26263877749443054,
        -0.9629242420196533,
        0.061626359820365906
      ],
      "plane_d": -2234.106201171875,
      "bbox_min": [
        -822.662353515625,
        -2092.9150390625,
        92.37496948242188
      ],
      "bbox_max": [
        -811.104736328125,
        -2089.3447265625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8953548073768616,
        -0.444709450006485,
        0.023941759020090103
      ],
      "plane_d": -1532.2132568359375,
      "bbox_min": [
        -726.2146606445312,
        -2940.561279296875,
        8.852900505065918
      ],
      "bbox_max": [
        -274.785888671875,
        -2134.50732421875,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9434628486633301,
        -0.32140111923217773,
        0.08111273497343063
      ],
      "plane_d": -1258.9459228515625,
      "bbox_min": [
        -508.69366455078125,
        -2453.637939453125,
        15.1318359375
      ],
      "bbox_max": [
        -489.9320983886719,
        -2419.360107421875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8689243793487549,
        0.41837501525878906,
        0.2644478976726532
      ],
      "plane_d": 566.2352905273438,
      "bbox_min": [
        -508.6936340332031,
        -2442.234130859375,
        15.1318359375
      ],
      "bbox_max": [
        -492.83447265625,
        -2419.360107421875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5381221771240234,
        0.8373711705207825,
        0.0960942804813385
      ],
      "plane_d": 2298.044677734375,
      "bbox_min": [
        -508.50347900390625,
        -2436.940673828125,
        15.1318359375
      ],
      "bbox_max": [
        -494.3927917480469,
        -2419.360107421875,
        89.73331451416016
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32657477259635925,
        0.944736123085022,
        0.02867927961051464
      ],
      "plane_d": 2788.171630859375,
      "bbox_min": [
        -726.2146606445312,
        -2940.561279296875,
        8.852900505065918
      ],
      "bbox_max": [
        -274.785888671875,
        -2134.50732421875,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8872413635253906,
        0.4606812298297882,
        0.023994388058781624
      ],
      "plane_d": 1603.4219970703125,
      "bbox_min": [
        -336.30511474609375,
        -2940.561279296875,
        8.852900505065918
      ],
      "bbox_max": [
        -274.785888671875,
        -2835.733642578125,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7295700907707214,
        0.6833271980285645,
        0.02813161164522171
      ],
      "plane_d": 2207.02783203125,
      "bbox_min": [
        -295.1187744140625,
        -2920.6904296875,
        44.0506591796875
      ],
      "bbox_max": [
        -292.7136535644531,
        -2918.3369140625,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7295700907707214,
        0.6833271980285645,
        0.02813161164522171
      ],
      "plane_d": 2207.02783203125,
      "bbox_min": [
        -293.3972473144531,
        -2940.561279296875,
        46.240901947021484
      ],
      "bbox_max": [
        -274.785888671875,
        -2919.20703125,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8872413635253906,
        0.4606812298297882,
        0.023994388058781624
      ],
      "plane_d": 1603.4219970703125,
      "bbox_min": [
        -336.8768310546875,
        -2838.052734375,
        9.436009407043457
      ],
      "bbox_max": [
        -335.0601501464844,
        -2835.6298828125,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5192293524742126,
        -0.8514940738677979,
        0.07320254296064377
      ],
      "plane_d": -2270.671142578125,
      "bbox_min": [
        -726.2146606445312,
        -2319.371337890625,
        24.427444458007812
      ],
      "bbox_max": [
        -570.3208618164062,
        -2134.50732421875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40625426173210144,
        -0.880420982837677,
        0.2445736974477768
      ],
      "plane_d": -2194.858154296875,
      "bbox_min": [
        -716.7096557617188,
        -2187.470947265625,
        45.06836700439453
      ],
      "bbox_max": [
        -676.2098388671875,
        -2140.103515625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4714754819869995,
        -0.8809452652931213,
        0.040574923157691956
      ],
      "plane_d": -2225.99169921875,
      "bbox_min": [
        -702.4977416992188,
        -2157.045166015625,
        71.84719848632812
      ],
      "bbox_max": [
        -684.5930786132812,
        -2146.244384765625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4426290988922119,
        -0.8944221138954163,
        0.06394129991531372
      ],
      "plane_d": -2236.98828125,
      "bbox_min": [
        -723.8789672851562,
        -2148.558837890625,
        53.60438537597656
      ],
      "bbox_max": [
        -714.1131591796875,
        -2136.437744140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40625426173210144,
        -0.880420982837677,
        0.2445736974477768
      ],
      "plane_d": -2194.858154296875,
      "bbox_min": [
        -723.8789672851562,
        -2148.558837890625,
        53.60438537597656
      ],
      "bbox_max": [
        -714.1131591796875,
        -2137.222412109375,
        78.19243621826172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40625426173210144,
        -0.880420982837677,
        0.2445736974477768
      ],
      "plane_d": -2194.858154296875,
      "bbox_min": [
        -724.39501953125,
        -2141.080078125,
        66.8880386352539
      ],
      "bbox_max": [
        -722.3239135742188,
        -2136.9609375,
        78.2761001586914
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7376764416694641,
        -0.6278554797172546,
        0.24825602769851685
      ],
      "plane_d": -1929.36328125,
      "bbox_min": [
        -2863.203369140625,
        -4272.7587890625,
        0.0
      ],
      "bbox_max": [
        1976.828125,
        3382.115234375,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8139365315437317,
        0.49027109146118164,
        0.3116752505302429
      ],
      "plane_d": 3230.79345703125,
      "bbox_min": [
        -2863.203369140625,
        -4014.0205078125,
        0.0
      ],
      "bbox_max": [
        1976.828125,
        3382.115234375,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03556028753519058,
        -0.9742233157157898,
        0.2227654755115509
      ],
      "plane_d": -2832.166748046875,
      "bbox_min": [
        -2863.203369140625,
        -4014.0205078125,
        0.0
      ],
      "bbox_max": [
        1976.828125,
        3382.115234375,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.044299058616161346,
        -0.9751470685005188,
        0.21708440780639648
      ],
      "plane_d": -2462.152099609375,
      "bbox_min": [
        -2863.203369140625,
        -2911.70751953125,
        0.0
      ],
      "bbox_max": [
        1757.2171630859375,
        3382.115234375,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04024601727724075,
        -0.9707819819450378,
        0.23656384646892548
      ],
      "plane_d": -2453.2021484375,
      "bbox_min": [
        -2863.203369140625,
        -2549.316162109375,
        0.0
      ],
      "bbox_max": [
        545.7724609375,
        3382.115234375,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15576203167438507,
        -0.9588549137115479,
        0.23735080659389496
      ],
      "plane_d": -2399.908447265625,
      "bbox_min": [
        -687.770263671875,
        -2533.448974609375,
        0.0
      ],
      "bbox_max": [
        201.5947265625,
        -2154.12646484375,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5395222306251526,
        -0.8415294885635376,
        0.027272434905171394
      ],
      "plane_d": -2254.31982421875,
      "bbox_min": [
        -687.770263671875,
        -2439.067138671875,
        0.0
      ],
      "bbox_max": [
        -377.20721435546875,
        -2154.12646484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5812810063362122,
        -0.8116893172264099,
        0.057208240032196045
      ],
      "plane_d": -2210.2236328125,
      "bbox_min": [
        -544.6834106445312,
        -2330.7607421875,
        90.66432189941406
      ],
      "bbox_max": [
        -537.8623046875,
        -2325.952880859375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.56119704246521,
        -0.8256406784057617,
        0.058097995817661285
      ],
      "plane_d": -2231.885986328125,
      "bbox_min": [
        -544.6834106445312,
        -2328.025634765625,
        90.66432189941406
      ],
      "bbox_max": [
        -542.5712890625,
        -2325.952880859375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4998539388179779,
        -0.8565889596939087,
        0.1280682235956192
      ],
      "plane_d": -2276.9931640625,
      "bbox_min": [
        -589.16552734375,
        -2439.067138671875,
        0.0
      ],
      "bbox_max": [
        -377.20721435546875,
        -2298.828125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5537408590316772,
        -0.8233800530433655,
        0.12416242808103561
      ],
      "plane_d": -2228.56689453125,
      "bbox_min": [
        -589.16552734375,
        -2338.3798828125,
        17.26797866821289
      ],
      "bbox_max": [
        -542.600341796875,
        -2298.828125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5577746033668518,
        -0.8295528292655945,
        0.027008702978491783
      ],
      "plane_d": -2232.429443359375,
      "bbox_min": [
        -565.2019653320312,
        -2439.067138671875,
        0.0
      ],
      "bbox_max": [
        -377.20721435546875,
        -2313.44091796875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5192293524742126,
        -0.8514940738677979,
        0.07320254296064377
      ],
      "plane_d": -2270.671142578125,
      "bbox_min": [
        -565.2019653320312,
        -2439.067138671875,
        0.0
      ],
      "bbox_max": [
        -377.20721435546875,
        -2313.44091796875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.475697785615921,
        -0.7068511247634888,
        0.5235198140144348
      ],
      "plane_d": -1910.9530029296875,
      "bbox_min": [
        -395.46923828125,
        -2439.067138671875,
        0.0
      ],
      "bbox_max": [
        -377.20721435546875,
        -2426.31689453125,
        19.15047264099121
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5573205947875977,
        -0.7778975367546082,
        0.2902913987636566
      ],
      "plane_d": -2111.422607421875,
      "bbox_min": [
        -393.007080078125,
        -2437.6767578125,
        15.339889526367188
      ],
      "bbox_max": [
        -377.20721435546875,
        -2426.31689453125,
        19.15047264099121
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12844467163085938,
        -0.9180779457092285,
        0.3750130534172058
      ],
      "plane_d": -2301.740966796875,
      "bbox_min": [
        -495.3668212890625,
        -2533.448974609375,
        0.0
      ],
      "bbox_max": [
        201.5947265625,
        -2411.125732421875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5577746033668518,
        -0.8295528292655945,
        0.027008702978491783
      ],
      "plane_d": -2232.429443359375,
      "bbox_min": [
        -404.895263671875,
        -2455.599853515625,
        0.0
      ],
      "bbox_max": [
        -360.08795166015625,
        -2416.557861328125,
        83.05286407470703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.475697785615921,
        -0.7068511247634888,
        0.5235198140144348
      ],
      "plane_d": -1910.9530029296875,
      "bbox_min": [
        -404.895263671875,
        -2455.599853515625,
        0.0
      ],
      "bbox_max": [
        -360.08795166015625,
        -2416.557861328125,
        83.05286407470703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5395222306251526,
        -0.8415294885635376,
        0.027272434905171394
      ],
      "plane_d": -2254.31982421875,
      "bbox_min": [
        -404.895263671875,
        -2451.3544921875,
        13.21284294128418
      ],
      "bbox_max": [
        -360.08795166015625,
        -2416.557861328125,
        83.05286407470703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5573205947875977,
        -0.7778975367546082,
        0.2902913987636566
      ],
      "plane_d": -2111.422607421875,
      "bbox_min": [
        -378.0712890625,
        -2451.3544921875,
        13.21284294128418
      ],
      "bbox_max": [
        -360.08795166015625,
        -2436.873779296875,
        21.301130294799805
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1437128782272339,
        -0.9889427423477173,
        0.036590516567230225
      ],
      "plane_d": -2465.451416015625,
      "bbox_min": [
        -495.3668212890625,
        -2519.970947265625,
        0.0
      ],
      "bbox_max": [
        201.5947265625,
        -2411.125732421875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5577746033668518,
        -0.8295528292655945,
        0.027008702978491783
      ],
      "plane_d": -2232.429443359375,
      "bbox_min": [
        -412.5116882324219,
        -2436.734130859375,
        43.47489547729492
      ],
      "bbox_max": [
        -376.2373046875,
        -2411.125732421875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5395222306251526,
        -0.8415294885635376,
        0.027272434905171394
      ],
      "plane_d": -2254.31982421875,
      "bbox_min": [
        -412.5116882324219,
        -2424.856689453125,
        66.89019775390625
      ],
      "bbox_max": [
        -392.609375,
        -2411.125732421875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5577746033668518,
        -0.8295528292655945,
        0.027008702978491783
      ],
      "plane_d": -2232.429443359375,
      "bbox_min": [
        -495.3668212890625,
        -2516.718505859375,
        0.0
      ],
      "bbox_max": [
        -91.83806610107422,
        -2431.851806640625,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26177865266799927,
        -0.9109151363372803,
        0.31891322135925293
      ],
      "plane_d": -2245.35107421875,
      "bbox_min": [
        -188.47286987304688,
        -2516.718505859375,
        0.0
      ],
      "bbox_max": [
        -91.83806610107422,
        -2475.97119140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24863126873970032,
        -0.9681477546691895,
        0.029538404196500778
      ],
      "plane_d": -2377.22607421875,
      "bbox_min": [
        -111.46427917480469,
        -2481.011474609375,
        39.34489440917969
      ],
      "bbox_max": [
        -91.83806610107422,
        -2475.97119140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5573205947875977,
        -0.7778975367546082,
        0.2902913987636566
      ],
      "plane_d": -2111.422607421875,
      "bbox_min": [
        -495.3668212890625,
        -2511.976806640625,
        0.0
      ],
      "bbox_max": [
        -274.94073486328125,
        -2431.851806640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.475697785615921,
        -0.7068511247634888,
        0.5235198140144348
      ],
      "plane_d": -1910.9530029296875,
      "bbox_min": [
        -495.3668212890625,
        -2511.976806640625,
        0.0
      ],
      "bbox_max": [
        -281.3318176269531,
        -2431.851806640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6797831654548645,
        0.7331897616386414,
        0.018096309155225754
      ],
      "plane_d": 2118.83056640625,
      "bbox_min": [
        -495.3668212890625,
        -2507.2900390625,
        0.0
      ],
      "bbox_max": [
        -387.7213134765625,
        -2431.851806640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5381221771240234,
        0.8373711705207825,
        0.0960942804813385
      ],
      "plane_d": 2298.044677734375,
      "bbox_min": [
        -495.3667907714844,
        -2447.493896484375,
        50.84194564819336
      ],
      "bbox_max": [
        -479.80426025390625,
        -2431.851806640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8689243793487549,
        0.41837501525878906,
        0.2644478976726532
      ],
      "plane_d": 566.2352905273438,
      "bbox_min": [
        -494.392822265625,
        -2440.193603515625,
        89.73331451416016
      ],
      "bbox_max": [
        -492.4398193359375,
        -2436.940673828125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5485955476760864,
        0.7409572601318359,
        0.3873308598995209
      ],
      "plane_d": 2070.496826171875,
      "bbox_min": [
        -485.1326599121094,
        -2507.2900390625,
        0.0
      ],
      "bbox_max": [
        -387.7213134765625,
        -2440.3291015625,
        33.09272766113281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.038124386221170425,
        -0.9989581108093262,
        0.02508561499416828
      ],
      "plane_d": -2511.24755859375,
      "bbox_min": [
        128.55201721191406,
        -2549.316162109375,
        0.0
      ],
      "bbox_max": [
        545.7724609375,
        -2507.998046875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1437128782272339,
        -0.9889427423477173,
        0.036590516567230225
      ],
      "plane_d": -2465.451416015625,
      "bbox_min": [
        128.55201721191406,
        -2519.970947265625,
        63.29396057128906
      ],
      "bbox_max": [
        201.5947265625,
        -2507.998046875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41336196660995483,
        -0.8782291412353516,
        0.24051113426685333
      ],
      "plane_d": -2016.743896484375,
      "bbox_min": [
        537.39794921875,
        -2549.316162109375,
        0.0
      ],
      "bbox_max": [
        545.7724609375,
        -2532.531005859375,
        75.72715759277344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4237554669380188,
        -0.9054881930351257,
        0.022859251126646996
      ],
      "plane_d": -2065.258056640625,
      "bbox_min": [
        542.20849609375,
        -2534.514892578125,
        68.196044921875
      ],
      "bbox_max": [
        545.7724609375,
        -2532.84130859375,
        68.46411895751953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4237554669380188,
        -0.9054881930351257,
        0.022859251126646996
      ],
      "plane_d": -2065.258056640625,
      "bbox_min": [
        538.8607788085938,
        -2534.449462890625,
        68.4259033203125
      ],
      "bbox_max": [
        545.647216796875,
        -2532.531005859375,
        75.72715759277344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.043660908937454224,
        -0.9987923502922058,
        0.02252989076077938
      ],
      "plane_d": -2507.651123046875,
      "bbox_min": [
        538.8607788085938,
        -2532.84130859375,
        68.4259033203125
      ],
      "bbox_max": [
        542.2547607421875,
        -2532.531005859375,
        75.72715759277344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.038124386221170425,
        -0.9989581108093262,
        0.02508561499416828
      ],
      "plane_d": -2511.24755859375,
      "bbox_min": [
        -441.97967529296875,
        -2911.70751953125,
        0.0
      ],
      "bbox_max": [
        1757.2171630859375,
        -2482.563232421875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5577746033668518,
        -0.8295528292655945,
        0.027008702978491783
      ],
      "plane_d": -2232.429443359375,
      "bbox_min": [
        -295.439697265625,
        -2502.074951171875,
        45.62123107910156
      ],
      "bbox_max": [
        -278.3159484863281,
        -2489.22021484375,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.697449803352356,
        -0.6287873983383179,
        0.3437880277633667
      ],
      "plane_d": -1147.93994140625,
      "bbox_min": [
        737.22607421875,
        -2859.089111328125,
        0.0
      ],
      "bbox_max": [
        1757.2171630859375,
        -2624.998291015625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08990637212991714,
        -0.6167760491371155,
        0.7819873094558716
      ],
      "plane_d": -1881.6788330078125,
      "bbox_min": [
        1302.58544921875,
        -2859.089111328125,
        0.0
      ],
      "bbox_max": [
        1757.2171630859375,
        -2736.48974609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3314240276813507,
        -0.910738468170166,
        0.24640101194381714
      ],
      "plane_d": -3039.8310546875,
      "bbox_min": [
        1302.58544921875,
        -2859.089111328125,
        0.0
      ],
      "bbox_max": [
        1757.2171630859375,
        -2736.48974609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3762500584125519,
        -0.5601121783256531,
        0.738044798374176
      ],
      "plane_d": -977.8809204101562,
      "bbox_min": [
        1422.0576171875,
        -2846.877685546875,
        0.0
      ],
      "bbox_max": [
        1757.2171630859375,
        -2736.48974609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34605666995048523,
        -0.6463470458984375,
        0.6800589561462402
      ],
      "plane_d": -1269.10009765625,
      "bbox_min": [
        1596.2685546875,
        -2846.877685546875,
        0.0
      ],
      "bbox_max": [
        1754.84716796875,
        -2817.374267578125,
        81.42682647705078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29879969358444214,
        -0.9538390636444092,
        0.030162015929818153
      ],
      "plane_d": -3092.20263671875,
      "bbox_min": [
        1422.0576171875,
        -2821.983642578125,
        62.26757049560547
      ],
      "bbox_max": [
        1757.2171630859375,
        -2736.48974609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3609467148780823,
        -0.930988073348999,
        0.054576583206653595
      ],
      "plane_d": -3130.5810546875,
      "bbox_min": [
        1586.376953125,
        -2741.73876953125,
        62.26757049560547
      ],
      "bbox_max": [
        1601.1317138671875,
        -2736.48974609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4576248228549957,
        -0.8877981305122375,
        0.04892735183238983
      ],
      "plane_d": -1702.181884765625,
      "bbox_min": [
        1599.915771484375,
        -2738.644775390625,
        62.26757049560547
      ],
      "bbox_max": [
        1601.1317138671875,
        -2736.48974609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4576248228549957,
        -0.8877981305122375,
        0.04892735183238983
      ],
      "plane_d": -1702.181884765625,
      "bbox_min": [
        1600.0625,
        -2821.983642578125,
        62.26757049560547
      ],
      "bbox_max": [
        1757.2171630859375,
        -2737.116455078125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4312950074672699,
        -0.9005617499351501,
        0.054527778178453445
      ],
      "plane_d": -1784.802734375,
      "bbox_min": [
        1752.0833740234375,
        -2817.374267578125,
        81.42682647705078
      ],
      "bbox_max": [
        1754.9029541015625,
        -2814.926025390625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9105714559555054,
        -0.4126048982143402,
        0.024836042895913124
      ],
      "plane_d": 433.4289855957031,
      "bbox_min": [
        1754.8433837890625,
        -2817.374267578125,
        81.42682647705078
      ],
      "bbox_max": [
        1754.9029541015625,
        -2816.247802734375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7206773161888123,
        -0.6925857067108154,
        0.03080742061138153
      ],
      "plane_d": -1281.2325439453125,
      "bbox_min": [
        737.22607421875,
        -2852.63134765625,
        0.0
      ],
      "bbox_max": [
        967.203125,
        -2624.998291015625,
        85.39134979248047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4237554669380188,
        -0.9054881930351257,
        0.022859251126646996
      ],
      "plane_d": -2065.258056640625,
      "bbox_min": [
        738.4486083984375,
        -2632.488525390625,
        54.74072265625
      ],
      "bbox_max": [
        754.398193359375,
        -2624.998291015625,
        74.25576782226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7206773161888123,
        -0.6925857067108154,
        0.03080742061138153
      ],
      "plane_d": -1281.2325439453125,
      "bbox_min": [
        -428.56591796875,
        -2911.70751953125,
        0.0
      ],
      "bbox_max": [
        967.203125,
        -2495.0,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41336196660995483,
        -0.8782291412353516,
        0.24051113426685333
      ],
      "plane_d": -2016.743896484375,
      "bbox_min": [
        -428.56591796875,
        -2911.70751953125,
        0.0
      ],
      "bbox_max": [
        967.203125,
        -2495.0,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39036044478416443,
        -0.871857762336731,
        0.29577508568763733
      ],
      "plane_d": -2016.8592529296875,
      "bbox_min": [
        545.50390625,
        -2643.37060546875,
        0.0
      ],
      "bbox_max": [
        746.97509765625,
        -2534.449462890625,
        70.64186096191406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4237554669380188,
        -0.9054881930351257,
        0.022859251126646996
      ],
      "plane_d": -2065.258056640625,
      "bbox_min": [
        545.647216796875,
        -2628.61328125,
        55.76939392089844
      ],
      "bbox_max": [
        746.97509765625,
        -2534.449462890625,
        70.64186096191406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8044940829277039,
        0.5709185004234314,
        0.1638335883617401
      ],
      "plane_d": 1555.55419921875,
      "bbox_min": [
        -428.56591796875,
        -2911.70751953125,
        0.0
      ],
      "bbox_max": [
        967.203125,
        -2495.0,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6797831654548645,
        0.7331897616386414,
        0.018096309155225754
      ],
      "plane_d": 2118.83056640625,
      "bbox_min": [
        -428.56591796875,
        -2911.70751953125,
        0.0
      ],
      "bbox_max": [
        21.83740234375,
        -2495.0,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8953304290771484,
        -0.40696901082992554,
        0.1809958815574646
      ],
      "plane_d": -1297.9310302734375,
      "bbox_min": [
        -268.0494079589844,
        -2911.70751953125,
        0.0
      ],
      "bbox_max": [
        -116.50020599365234,
        -2742.678466796875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.021644897758960724,
        -0.9809890389442444,
        0.1928522288799286
      ],
      "plane_d": -2715.1787109375,
      "bbox_min": [
        -268.0494079589844,
        -2763.52734375,
        0.0
      ],
      "bbox_max": [
        -183.79403686523438,
        -2742.678466796875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07290501147508621,
        -0.9842317700386047,
        0.16116014122962952
      ],
      "plane_d": -2734.059814453125,
      "bbox_min": [
        -268.0494079589844,
        -2763.52734375,
        0.0
      ],
      "bbox_max": [
        -193.516357421875,
        -2744.892333984375,
        88.51737976074219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5485955476760864,
        0.7409572601318359,
        0.3873308598995209
      ],
      "plane_d": 2070.496826171875,
      "bbox_min": [
        -423.2140808105469,
        -2771.8046875,
        0.0
      ],
      "bbox_max": [
        21.83740234375,
        -2498.310546875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2770751714706421,
        0.8977282643318176,
        0.34251025319099426
      ],
      "plane_d": 2265.678955078125,
      "bbox_min": [
        -284.549072265625,
        -2771.8046875,
        0.0
      ],
      "bbox_max": [
        21.83740234375,
        -2500.73388671875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8048807978630066,
        0.5699580907821655,
        0.16527128219604492
      ],
      "plane_d": 1552.8994140625,
      "bbox_min": [
        -76.62801361083984,
        -2771.8046875,
        0.0
      ],
      "bbox_max": [
        21.83740234375,
        -2645.3701171875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5469550490379333,
        0.8172126412391663,
        0.18166914582252502
      ],
      "plane_d": 2239.822998046875,
      "bbox_min": [
        12.728614807128906,
        -2771.8046875,
        0.0
      ],
      "bbox_max": [
        21.83740234375,
        -2755.423583984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3544447720050812,
        0.9085077047348022,
        0.22132006287574768
      ],
      "plane_d": 2284.22607421875,
      "bbox_min": [
        -284.549072265625,
        -2641.868896484375,
        0.0
      ],
      "bbox_max": [
        -116.931396484375,
        -2500.73388671875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2806796431541443,
        -0.9589745998382568,
        0.03983548656105995
      ],
      "plane_d": -2351.9248046875,
      "bbox_min": [
        -284.549072265625,
        -2641.868896484375,
        0.0
      ],
      "bbox_max": [
        -180.17478942871094,
        -2500.73388671875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5424458384513855,
        -0.8393089771270752,
        0.03623468056321144
      ],
      "plane_d": -2253.585693359375,
      "bbox_min": [
        -284.549072265625,
        -2528.596923828125,
        0.0
      ],
      "bbox_max": [
        -247.44158935546875,
        -2500.73388671875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5577746033668518,
        -0.8295528292655945,
        0.027008702978491783
      ],
      "plane_d": -2232.429443359375,
      "bbox_min": [
        -278.9546813964844,
        -2523.504638671875,
        29.988645553588867
      ],
      "bbox_max": [
        -247.552978515625,
        -2500.73388671875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5573205947875977,
        -0.7778975367546082,
        0.2902913987636566
      ],
      "plane_d": -2111.422607421875,
      "bbox_min": [
        -275.4774169921875,
        -2523.504638671875,
        29.988645553588867
      ],
      "bbox_max": [
        -247.552978515625,
        -2505.205078125,
        35.92359924316406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5573205947875977,
        -0.7778975367546082,
        0.2902913987636566
      ],
      "plane_d": -2111.422607421875,
      "bbox_min": [
        -284.549072265625,
        -2528.596923828125,
        0.0
      ],
      "bbox_max": [
        -247.552978515625,
        -2505.713134765625,
        35.92359924316406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.475697785615921,
        -0.7068511247634888,
        0.5235198140144348
      ],
      "plane_d": -1910.9530029296875,
      "bbox_min": [
        -284.549072265625,
        -2528.596923828125,
        0.0
      ],
      "bbox_max": [
        -258.9478759765625,
        -2511.255126953125,
        3.897660732269287
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26177865266799927,
        -0.9109151363372803,
        0.31891322135925293
      ],
      "plane_d": -2245.35107421875,
      "bbox_min": [
        -270.15826416015625,
        -2641.868896484375,
        0.0
      ],
      "bbox_max": [
        -180.17478942871094,
        -2507.82373046875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5573205947875977,
        -0.7778975367546082,
        0.2902913987636566
      ],
      "plane_d": -2111.422607421875,
      "bbox_min": [
        -259.85284423828125,
        -2536.31884765625,
        0.0
      ],
      "bbox_max": [
        -247.552978515625,
        -2523.504638671875,
        35.92359924316406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.475697785615921,
        -0.7068511247634888,
        0.5235198140144348
      ],
      "plane_d": -1910.9530029296875,
      "bbox_min": [
        -259.85284423828125,
        -2536.31884765625,
        0.0
      ],
      "bbox_max": [
        -248.378662109375,
        -2528.280029296875,
        1.2501134872436523
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26103347539901733,
        -0.9127302169799805,
        0.31430086493492126
      ],
      "plane_d": -2249.9501953125,
      "bbox_min": [
        -270.15826416015625,
        -2641.868896484375,
        21.661537170410156
      ],
      "bbox_max": [
        -188.47286987304688,
        -2507.82373046875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29478561878204346,
        0.9554215669631958,
        0.016467038542032242
      ],
      "plane_d": 2442.81298828125,
      "bbox_min": [
        -270.15826416015625,
        -2641.868896484375,
        90.5094223022461
      ],
      "bbox_max": [
        -243.77239990234375,
        -2633.727783203125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4237554669380188,
        -0.9054881930351257,
        0.022859251126646996
      ],
      "plane_d": -2065.258056640625,
      "bbox_min": [
        13.097672462463379,
        -2898.67626953125,
        0.0
      ],
      "bbox_max": [
        967.203125,
        -2531.49365234375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39029523730278015,
        -0.9200517535209656,
        0.034270964562892914
      ],
      "plane_d": -2129.463623046875,
      "bbox_min": [
        741.9876098632812,
        -2631.499267578125,
        74.25576782226562
      ],
      "bbox_max": [
        754.9293212890625,
        -2625.5380859375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5622952580451965,
        0.8052801489830017,
        0.18801021575927734
      ],
      "plane_d": 2204.44580078125,
      "bbox_min": [
        13.097672462463379,
        -2898.67626953125,
        0.0
      ],
      "bbox_max": [
        967.203125,
        -2531.49365234375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5546605587005615,
        0.8106602430343628,
        0.1875675618648529
      ],
      "plane_d": 2220.478759765625,
      "bbox_min": [
        53.73303985595703,
        -2830.41943359375,
        0.0
      ],
      "bbox_max": [
        114.56396484375,
        -2799.00146484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.043660908937454224,
        -0.9987923502922058,
        0.02252989076077938
      ],
      "plane_d": -2507.651123046875,
      "bbox_min": [
        527.6738891601562,
        -2852.63134765625,
        75.69832611083984
      ],
      "bbox_max": [
        967.203125,
        -2531.49365234375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7266949415206909,
        -0.6864138841629028,
        0.02739434503018856
      ],
      "plane_d": -1257.5203857421875,
      "bbox_min": [
        963.1213989257812,
        -2852.63134765625,
        83.82173156738281
      ],
      "bbox_max": [
        967.203125,
        -2847.664306640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2657254636287689,
        0.956613302230835,
        0.11950235813856125
      ],
      "plane_d": 2891.673095703125,
      "bbox_min": [
        -126.16167449951172,
        -4014.0205078125,
        0.0
      ],
      "bbox_max": [
        1976.828125,
        -2820.1181640625,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4031985104084015,
        -0.8806112408638,
        0.24890731275081635
      ],
      "plane_d": -3000.44140625,
      "bbox_min": [
        4.2593994140625,
        -4014.0205078125,
        0.0
      ],
      "bbox_max": [
        1765.005859375,
        -3024.006591796875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.820148766040802,
        0.5630922913551331,
        0.10140593349933624
      ],
      "plane_d": 1138.31640625,
      "bbox_min": [
        4.2593994140625,
        -3675.006591796875,
        0.0
      ],
      "bbox_max": [
        1765.005859375,
        -3024.006591796875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8890878558158875,
        -0.38653871417045593,
        0.24517454206943512
      ],
      "plane_d": -1165.108642578125,
      "bbox_min": [
        4.2593994140625,
        -3378.362548828125,
        0.0
      ],
      "bbox_max": [
        919.1904907226562,
        -3024.006591796875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7488449215888977,
        0.6414593458175659,
        0.16661718487739563
      ],
      "plane_d": 1462.0894775390625,
      "bbox_min": [
        884.703125,
        -3378.362548828125,
        0.0
      ],
      "bbox_max": [
        919.1904907226562,
        -3320.220703125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7055326700210571,
        -0.7082751393318176,
        0.023873645812273026
      ],
      "plane_d": -2135.6064453125,
      "bbox_min": [
        19.614755630493164,
        -3058.502197265625,
        40.90336608886719
      ],
      "bbox_max": [
        46.83256149291992,
        -3033.381591796875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38686707615852356,
        0.9116483330726624,
        0.1386769711971283
      ],
      "plane_d": 3600.500244140625,
      "bbox_min": [
        1021.2090454101562,
        -3675.006591796875,
        0.0
      ],
      "bbox_max": [
        1765.005859375,
        -3435.015380859375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6071054935455322,
        0.7819521427154541,
        0.14132829010486603
      ],
      "plane_d": 1790.0787353515625,
      "bbox_min": [
        1701.3076171875,
        -3675.006591796875,
        0.0
      ],
      "bbox_max": [
        1765.005859375,
        -3610.1337890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6603245735168457,
        0.7348749041557312,
        0.15469467639923096
      ],
      "plane_d": 1523.8634033203125,
      "bbox_min": [
        1740.637939453125,
        -3675.006591796875,
        0.0
      ],
      "bbox_max": [
        1765.005859375,
        -3658.743408203125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3277740478515625,
        0.9389278292655945,
        0.10477888584136963
      ],
      "plane_d": 3635.802490234375,
      "bbox_min": [
        1021.2090454101562,
        -3526.953369140625,
        0.0
      ],
      "bbox_max": [
        1078.841552734375,
        -3506.834228515625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2870385944843292,
        0.9484124183654785,
        0.13461995124816895
      ],
      "plane_d": 2887.098876953125,
      "bbox_min": [
        638.0684814453125,
        -3632.45703125,
        0.0
      ],
      "bbox_max": [
        1706.7811279296875,
        -3203.320068359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4219103455543518,
        0.8972445130348206,
        0.13016921281814575
      ],
      "plane_d": 2511.218994140625,
      "bbox_min": [
        686.9929809570312,
        -3632.45703125,
        0.0
      ],
      "bbox_max": [
        1706.7811279296875,
        -3263.8212890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6071054935455322,
        0.7819521427154541,
        0.14132829010486603
      ],
      "plane_d": 1790.0787353515625,
      "bbox_min": [
        686.9929809570312,
        -3632.45703125,
        0.0
      ],
      "bbox_max": [
        1706.7811279296875,
        -3263.8212890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45461931824684143,
        0.8825740814208984,
        0.11993440240621567
      ],
      "plane_d": 2558.304443359375,
      "bbox_min": [
        686.9929809570312,
        -3269.954345703125,
        82.87269592285156
      ],
      "bbox_max": [
        694.3810424804688,
        -3263.8212890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25093328952789307,
        0.9610074758529663,
        0.1161772757768631
      ],
      "plane_d": 2983.87744140625,
      "bbox_min": [
        638.0684814453125,
        -3500.836669921875,
        0.0
      ],
      "bbox_max": [
        1463.9609375,
        -3203.320068359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4219103455543518,
        0.8972445130348206,
        0.13016921281814575
      ],
      "plane_d": 2511.218994140625,
      "bbox_min": [
        1452.395263671875,
        -3500.836669921875,
        0.0
      ],
      "bbox_max": [
        1463.9609375,
        -3487.208984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45461931824684143,
        0.8825740814208984,
        0.11993440240621567
      ],
      "plane_d": 2558.304443359375,
      "bbox_min": [
        638.0684814453125,
        -3266.39990234375,
        0.0
      ],
      "bbox_max": [
        687.480712890625,
        -3203.320068359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9916024804115295,
        0.04682568460702896,
        0.12054863572120667
      ],
      "plane_d": -494.3349304199219,
      "bbox_min": [
        638.0684814453125,
        -3242.14501953125,
        0.0
      ],
      "bbox_max": [
        651.244873046875,
        -3203.320068359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.990161120891571,
        0.08122681081295013,
        0.11394374072551727
      ],
      "plane_d": -382.1380310058594,
      "bbox_min": [
        638.2070922851562,
        -3242.14501953125,
        0.0
      ],
      "bbox_max": [
        651.244873046875,
        -3215.491943359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9722859859466553,
        -0.2179602086544037,
        0.08457721769809723
      ],
      "plane_d": -94.62902069091797,
      "bbox_min": [
        682.0857543945312,
        -4014.0205078125,
        0.0
      ],
      "bbox_max": [
        803.0175170898438,
        -3691.26171875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4797043204307556,
        -0.8567934036254883,
        0.1891794204711914
      ],
      "plane_d": -2854.3671875,
      "bbox_min": [
        742.7138671875,
        -3747.286376953125,
        0.0
      ],
      "bbox_max": [
        751.8825073242188,
        -3727.60693359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4797043204307556,
        -0.8567934036254883,
        0.1891794204711914
      ],
      "plane_d": -2854.3671875,
      "bbox_min": [
        682.0857543945312,
        -4014.0205078125,
        0.0
      ],
      "bbox_max": [
        803.0175170898438,
        -3691.26171875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9811185002326965,
        0.1803492158651352,
        0.06986100971698761
      ],
      "plane_d": 1509.7783203125,
      "bbox_min": [
        800.9765625,
        -4014.0205078125,
        0.0
      ],
      "bbox_max": [
        803.0175170898438,
        -4009.5986328125,
        17.247535705566406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.033044300973415375,
        -0.9766026735305786,
        0.21249790489673615
      ],
      "plane_d": -2835.659912109375,
      "bbox_min": [
        -126.16167449951172,
        -3385.396484375,
        0.0
      ],
      "bbox_max": [
        1976.828125,
        -2820.1181640625,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34605666995048523,
        -0.6463470458984375,
        0.6800589561462402
      ],
      "plane_d": -1269.10009765625,
      "bbox_min": [
        964.4151000976562,
        -2859.089111328125,
        0.0
      ],
      "bbox_max": [
        1757.966796875,
        -2820.1181640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3314240276813507,
        -0.910738468170166,
        0.24640101194381714
      ],
      "plane_d": -3039.8310546875,
      "bbox_min": [
        964.4151000976562,
        -2859.089111328125,
        0.0
      ],
      "bbox_max": [
        1757.966796875,
        -2820.1181640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7266949415206909,
        -0.6864138841629028,
        0.02739434503018856
      ],
      "plane_d": -1257.5203857421875,
      "bbox_min": [
        964.4151000976562,
        -2852.63134765625,
        83.82173156738281
      ],
      "bbox_max": [
        967.203125,
        -2849.033935546875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9105714559555054,
        -0.4126048982143402,
        0.024836042895913124
      ],
      "plane_d": 433.4289855957031,
      "bbox_min": [
        1756.59716796875,
        -2823.44140625,
        91.74354553222656
      ],
      "bbox_max": [
        1757.966796875,
        -2820.1181640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13878872990608215,
        -0.9766721129417419,
        0.16385747492313385
      ],
      "plane_d": -2890.414794921875,
      "bbox_min": [
        -126.16167449951172,
        -3385.396484375,
        0.0
      ],
      "bbox_max": [
        1976.828125,
        -2822.366943359375,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5622952580451965,
        0.8052801489830017,
        0.18801021575927734
      ],
      "plane_d": 2204.44580078125,
      "bbox_min": [
        -126.16167449951172,
        -2965.43310546875,
        0.0
      ],
      "bbox_max": [
        264.127197265625,
        -2878.10595703125,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8953304290771484,
        -0.40696901082992554,
        0.1809958815574646
      ],
      "plane_d": -1297.9310302734375,
      "bbox_min": [
        -126.16167449951172,
        -2916.697265625,
        0.0
      ],
      "bbox_max": [
        -110.41657257080078,
        -2888.488525390625,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5659378170967102,
        -0.8116989731788635,
        0.14442728459835052
      ],
      "plane_d": -2430.857666015625,
      "bbox_min": [
        -91.95228576660156,
        -2965.43310546875,
        0.0
      ],
      "bbox_max": [
        -40.876319885253906,
        -2912.87255859375,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.42698726058006287,
        0.9038631319999695,
        0.02670924738049507
      ],
      "plane_d": 2528.235595703125,
      "bbox_min": [
        173.83953857421875,
        -2921.9189453125,
        0.0
      ],
      "bbox_max": [
        264.127197265625,
        -2882.221923828125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07275157421827316,
        -0.9971229434013367,
        0.02128235250711441
      ],
      "plane_d": -2932.72802734375,
      "bbox_min": [
        0.776123046875,
        -3385.396484375,
        0.0
      ],
      "bbox_max": [
        1976.828125,
        -2822.366943359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05928827077150345,
        -0.9979740977287292,
        0.02307876944541931
      ],
      "plane_d": -2906.13037109375,
      "bbox_min": [
        227.6385040283203,
        -2922.44677734375,
        0.0
      ],
      "bbox_max": [
        1090.228271484375,
        -2844.948486328125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7266949415206909,
        -0.6864138841629028,
        0.02739434503018856
      ],
      "plane_d": -1257.5203857421875,
      "bbox_min": [
        964.5720825195312,
        -2852.63134765625,
        83.82173156738281
      ],
      "bbox_max": [
        967.4459838867188,
        -2849.2001953125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164135575294495,
        -0.9401665925979614,
        0.1123996302485466
      ],
      "plane_d": -2832.044921875,
      "bbox_min": [
        227.6385040283203,
        -2922.44677734375,
        0.0
      ],
      "bbox_max": [
        264.127197265625,
        -2909.704833984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.42698726058006287,
        0.9038631319999695,
        0.02670924738049507
      ],
      "plane_d": 2528.235595703125,
      "bbox_min": [
        232.01698303222656,
        -2921.9189453125,
        0.0
      ],
      "bbox_max": [
        264.127197265625,
        -2909.704833984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5551269054412842,
        -0.8123753666877747,
        0.17855116724967957
      ],
      "plane_d": -2520.319091796875,
      "bbox_min": [
        234.75198364257812,
        -2921.9189453125,
        0.0
      ],
      "bbox_max": [
        264.127197265625,
        -2914.023681640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9736523628234863,
        -0.03027019277215004,
        0.22601918876171112
      ],
      "plane_d": -345.6151123046875,
      "bbox_min": [
        241.10792541503906,
        -2921.9189453125,
        0.0
      ],
      "bbox_max": [
        264.127197265625,
        -2914.023681640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24178145825862885,
        0.9671421051025391,
        0.07860032469034195
      ],
      "plane_d": 2937.0234375,
      "bbox_min": [
        0.776123046875,
        -3385.396484375,
        0.0
      ],
      "bbox_max": [
        1976.828125,
        -2822.366943359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9916024804115295,
        0.04682568460702896,
        0.12054863572120667
      ],
      "plane_d": -494.3349304199219,
      "bbox_min": [
        637.6810302734375,
        -3212.556396484375,
        0.0
      ],
      "bbox_max": [
        649.7892456054688,
        -3199.202392578125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5805860161781311,
        0.8118429183959961,
        0.0618952140212059
      ],
      "plane_d": 2859.779541015625,
      "bbox_min": [
        0.776123046875,
        -3385.396484375,
        0.0
      ],
      "bbox_max": [
        1976.828125,
        -2822.366943359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9916024804115295,
        0.04682568460702896,
        0.12054863572120667
      ],
      "plane_d": -494.3349304199219,
      "bbox_min": [
        611.2384033203125,
        -3385.396484375,
        0.0
      ],
      "bbox_max": [
        1976.828125,
        -2822.366943359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.520085871219635,
        0.8490864038467407,
        0.0925370380282402
      ],
      "plane_d": 2934.9326171875,
      "bbox_min": [
        611.2384033203125,
        -3093.0771484375,
        0.0
      ],
      "bbox_max": [
        643.145751953125,
        -3062.634765625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34605666995048523,
        -0.6463470458984375,
        0.6800589561462402
      ],
      "plane_d": -1269.10009765625,
      "bbox_min": [
        1651.5008544921875,
        -3385.396484375,
        0.0
      ],
      "bbox_max": [
        1976.828125,
        -2822.366943359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8598151206970215,
        0.5105383396148682,
        0.008278584107756615
      ],
      "plane_d": 3395.324462890625,
      "bbox_min": [
        1757.6160888671875,
        -3385.396484375,
        21.55415916442871
      ],
      "bbox_max": [
        1976.828125,
        -2822.366943359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9105714559555054,
        -0.4126048982143402,
        0.024836042895913124
      ],
      "plane_d": 433.4289855957031,
      "bbox_min": [
        1757.6160888671875,
        -2825.67236328125,
        95.00662994384766
      ],
      "bbox_max": [
        1759.1138916015625,
        -2822.366943359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7055326700210571,
        -0.7082751393318176,
        0.023873645812273026
      ],
      "plane_d": -2135.6064453125,
      "bbox_min": [
        0.776123046875,
        -3044.38916015625,
        0.0
      ],
      "bbox_max": [
        32.66470718383789,
        -3015.99462890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8890878558158875,
        -0.38653871417045593,
        0.24517454206943512
      ],
      "plane_d": -1165.108642578125,
      "bbox_min": [
        0.776123046875,
        -3033.381591796875,
        0.0
      ],
      "bbox_max": [
        19.614755630493164,
        -3015.99462890625,
        40.90336608886719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4673880636692047,
        0.8835117816925049,
        0.030906956642866135
      ],
      "plane_d": 2664.30419921875,
      "bbox_min": [
        0.776123046875,
        -3044.462158203125,
        0.0
      ],
      "bbox_max": [
        47.97587203979492,
        -3015.99462890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7055326700210571,
        -0.7082751393318176,
        0.023873645812273026
      ],
      "plane_d": -2135.6064453125,
      "bbox_min": [
        0.776123046875,
        -3037.047119140625,
        0.0
      ],
      "bbox_max": [
        25.294330596923828,
        -3015.99462890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9811185002326965,
        0.1803492158651352,
        0.06986100971698761
      ],
      "plane_d": 1509.7783203125,
      "bbox_min": [
        -292.8008728027344,
        -4272.7587890625,
        0.0
      ],
      "bbox_max": [
        809.4983520507812,
        -2733.74169921875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7589617371559143,
        -0.6175175309181213,
        0.20651651918888092
      ],
      "plane_d": -1886.5819091796875,
      "bbox_min": [
        -292.8008728027344,
        -4272.7587890625,
        0.0
      ],
      "bbox_max": [
        809.4983520507812,
        -2733.74169921875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4031985104084015,
        -0.8806112408638,
        0.24890731275081635
      ],
      "plane_d": -3000.44140625,
      "bbox_min": [
        456.5915222167969,
        -4009.5986328125,
        0.0
      ],
      "bbox_max": [
        809.4983520507812,
        -3591.09033203125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9722859859466553,
        -0.2179602086544037,
        0.08457721769809723
      ],
      "plane_d": -94.62902069091797,
      "bbox_min": [
        623.7564086914062,
        -4009.5986328125,
        0.0
      ],
      "bbox_max": [
        809.4983520507812,
        -3821.736572265625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6175416707992554,
        0.7847907543182373,
        0.05240177363157272
      ],
      "plane_d": 2614.06787109375,
      "bbox_min": [
        623.7564086914062,
        -3831.5546875,
        0.0
      ],
      "bbox_max": [
        635.6904296875,
        -3821.736572265625,
        12.68804931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6095806360244751,
        0.7911239266395569,
        0.05034474655985832
      ],
      "plane_d": 2643.391845703125,
      "bbox_min": [
        633.6099243164062,
        -3831.5546875,
        0.0
      ],
      "bbox_max": [
        635.6904296875,
        -3830.215087890625,
        12.68804931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9959223866462708,
        -0.08835939317941666,
        0.0181999821215868
      ],
      "plane_d": -1099.0582275390625,
      "bbox_min": [
        -292.8008728027344,
        -4272.7587890625,
        0.0
      ],
      "bbox_max": [
        769.688232421875,
        -2733.74169921875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8040251731872559,
        -0.5580930113792419,
        0.2051236778497696
      ],
      "plane_d": -1666.128173828125,
      "bbox_min": [
        -292.8008728027344,
        -4049.611083984375,
        0.0
      ],
      "bbox_max": [
        747.388671875,
        -2733.74169921875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7167351245880127,
        -0.6454834342002869,
        0.2638974189758301
      ],
      "plane_d": -2018.5269775390625,
      "bbox_min": [
        416.7092590332031,
        -3834.495849609375,
        0.0
      ],
      "bbox_max": [
        635.197265625,
        -3548.9794921875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4031985104084015,
        -0.8806112408638,
        0.24890731275081635
      ],
      "plane_d": -3000.44140625,
      "bbox_min": [
        429.211669921875,
        -3616.28173828125,
        0.0
      ],
      "bbox_max": [
        463.3052673339844,
        -3584.334228515625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6175416707992554,
        0.7847907543182373,
        0.05240177363157272
      ],
      "plane_d": 2614.06787109375,
      "bbox_min": [
        476.6596374511719,
        -4049.611083984375,
        0.0
      ],
      "bbox_max": [
        744.4066772460938,
        -3729.96630859375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9983112215995789,
        -0.04819893091917038,
        0.03242654725909233
      ],
      "plane_d": -939.6201171875,
      "bbox_min": [
        742.4443969726562,
        -4049.611083984375,
        60.31206130981445
      ],
      "bbox_max": [
        744.4066772460938,
        -4020.2939453125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07290501147508621,
        -0.9842317700386047,
        0.16116014122962952
      ],
      "plane_d": -2734.059814453125,
      "bbox_min": [
        -292.8008728027344,
        -2758.006591796875,
        0.0
      ],
      "bbox_max": [
        -255.75247192382812,
        -2733.74169921875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07290501147508621,
        -0.9842317700386047,
        0.16116014122962952
      ],
      "plane_d": -2734.059814453125,
      "bbox_min": [
        -261.8863220214844,
        -2749.34912109375,
        58.4351692199707
      ],
      "bbox_max": [
        -247.44180297851562,
        -2742.0888671875,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.021644897758960724,
        -0.9809890389442444,
        0.1928522288799286
      ],
      "plane_d": -2715.1787109375,
      "bbox_min": [
        -256.6742248535156,
        -2744.892333984375,
        88.51737213134766
      ],
      "bbox_max": [
        -247.44180297851562,
        -2742.474853515625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8076764345169067,
        0.5888927578926086,
        0.029395628720521927
      ],
      "plane_d": 1760.45068359375,
      "bbox_min": [
        729.767822265625,
        -4018.573974609375,
        0.0
      ],
      "bbox_max": [
        747.388671875,
        -3995.305419921875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9983112215995789,
        -0.04819893091917038,
        0.03242654725909233
      ],
      "plane_d": -939.6201171875,
      "bbox_min": [
        743.94287109375,
        -4018.573974609375,
        0.0
      ],
      "bbox_max": [
        747.388671875,
        -4014.48095703125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661832451820374,
        0.25639787316322327,
        0.027386151254177094
      ],
      "plane_d": 1823.6815185546875,
      "bbox_min": [
        756.1282958984375,
        -4272.7587890625,
        19.196945190429688
      ],
      "bbox_max": [
        769.688232421875,
        -4222.96875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9155784845352173,
        -0.4009268283843994,
        0.03120390512049198
      ],
      "plane_d": 474.5985412597656,
      "bbox_min": [
        -2975.73193359375,
        -4432.0419921875,
        100.0
      ],
      "bbox_max": [
        1978.01318359375,
        3398.1728515625,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1330.0,
      "bbox_min": [
        -2975.73193359375,
        -4432.0419921875,
        100.0
      ],
      "bbox_max": [
        1978.01318359375,
        3398.1728515625,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -2975.73193359375,
        3160.589599609375,
        100.0
      ],
      "bbox_max": [
        -2663.149658203125,
        3398.1728515625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5895066857337952,
        -0.7432910799980164,
        0.3162282407283783
      ],
      "plane_d": 4052.218017578125,
      "bbox_min": [
        -2916.7197265625,
        3191.259765625,
        100.0
      ],
      "bbox_max": [
        -2663.149658203125,
        3398.1728515625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.58088219165802,
        0.8135150671005249,
        0.027732910588383675
      ],
      "plane_d": 2567.5458984375,
      "bbox_min": [
        -1016.3764038085938,
        -4432.0419921875,
        100.0
      ],
      "bbox_max": [
        828.2930908203125,
        -2040.115234375,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.878898024559021,
        0.47661417722702026,
        0.019420865923166275
      ],
      "plane_d": 1412.29296875,
      "bbox_min": [
        202.49526977539062,
        -4432.0419921875,
        100.0
      ],
      "bbox_max": [
        828.2930908203125,
        -3504.326171875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9755158424377441,
        -0.21523292362689972,
        0.0452059768140316
      ],
      "plane_d": -985.38037109375,
      "bbox_min": [
        202.49526977539062,
        -3726.552978515625,
        100.0
      ],
      "bbox_max": [
        382.968505859375,
        -3504.326171875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0567576140165329,
        0.9980700612068176,
        0.025192802771925926
      ],
      "plane_d": 3693.984130859375,
      "bbox_min": [
        202.49526977539062,
        -3726.552978515625,
        100.0
      ],
      "bbox_max": [
        382.968505859375,
        -3608.2099609375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7465224862098694,
        0.6641824245452881,
        0.039570894092321396
      ],
      "plane_d": 2255.672607421875,
      "bbox_min": [
        202.49526977539062,
        -3720.957763671875,
        100.0
      ],
      "bbox_max": [
        283.3534240722656,
        -3608.2099609375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7245655059814453,
        0.6883644461631775,
        0.0340445451438427
      ],
      "plane_d": 2351.841064453125,
      "bbox_min": [
        202.49526977539062,
        -3720.957763671875,
        100.0
      ],
      "bbox_max": [
        283.3534240722656,
        -3608.2099609375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9822387099266052,
        -0.18323063850402832,
        0.04041934385895729
      ],
      "plane_d": -870.5835571289062,
      "bbox_min": [
        202.49526977539062,
        -3632.699951171875,
        100.0
      ],
      "bbox_max": [
        207.70118713378906,
        -3608.2099609375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9959223866462708,
        -0.08835939317941666,
        0.0181999821215868
      ],
      "plane_d": -1099.0582275390625,
      "bbox_min": [
        719.6626586914062,
        -4432.0419921875,
        100.0
      ],
      "bbox_max": [
        828.2930908203125,
        -4229.533203125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2644350826740265,
        0.9642910957336426,
        0.01472469512373209
      ],
      "plane_d": 4052.539794921875,
      "bbox_min": [
        719.6626586914062,
        -4432.0419921875,
        100.0
      ],
      "bbox_max": [
        828.2930908203125,
        -4295.87158203125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8812400102615356,
        0.4723060727119446,
        0.018526695668697357
      ],
      "plane_d": 1392.0955810546875,
      "bbox_min": [
        719.6626586914062,
        -4320.8681640625,
        100.0
      ],
      "bbox_max": [
        732.9417114257812,
        -4295.87158203125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8953548073768616,
        -0.444709450006485,
        0.023941759020090103
      ],
      "plane_d": -1532.2132568359375,
      "bbox_min": [
        -1016.3764038085938,
        -3155.48193359375,
        100.0
      ],
      "bbox_max": [
        -5.41292667388916,
        -2040.115234375,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9434628486633301,
        -0.32140111923217773,
        0.08111273497343063
      ],
      "plane_d": -1258.9459228515625,
      "bbox_min": [
        -493.81695556640625,
        -2472.6201171875,
        100.0
      ],
      "bbox_max": [
        -479.16693115234375,
        -2440.193603515625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388664484024048,
        0.6731492280960083,
        0.03076668083667755
      ],
      "plane_d": 2178.357666015625,
      "bbox_min": [
        -217.75363159179688,
        -3009.087890625,
        100.0
      ],
      "bbox_max": [
        -211.47071838378906,
        -3001.6279296875,
        145.20553588867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8202191591262817,
        0.571056604385376,
        0.033687908202409744
      ],
      "plane_d": 1912.07421875,
      "bbox_min": [
        -1016.3764038085938,
        -2794.01904296875,
        100.0
      ],
      "bbox_max": [
        -466.5007019042969,
        -2040.115234375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9315862059593201,
        0.3613213896751404,
        0.03992580994963646
      ],
      "plane_d": 1440.1312255859375,
      "bbox_min": [
        -1016.3764038085938,
        -2794.01904296875,
        100.0
      ],
      "bbox_max": [
        -466.5007019042969,
        -2040.115234375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.703201413154602,
        0.7104752063751221,
        0.027071993798017502
      ],
      "plane_d": 2169.124267578125,
      "bbox_min": [
        -1016.3764038085938,
        -2298.52734375,
        100.0
      ],
      "bbox_max": [
        -734.9911499023438,
        -2040.115234375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.755939245223999,
        0.6539766788482666,
        0.02950362116098404
      ],
      "plane_d": 2042.1041259765625,
      "bbox_min": [
        -1016.3764038085938,
        -2298.52734375,
        100.0
      ],
      "bbox_max": [
        -734.9911499023438,
        -2040.115234375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16410836577415466,
        -0.9725522994995117,
        0.16495561599731445
      ],
      "plane_d": -2175.37255859375,
      "bbox_min": [
        -1016.3764038085938,
        -2047.3272705078125,
        138.49298095703125
      ],
      "bbox_max": [
        -983.4622802734375,
        -2040.115234375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7558661103248596,
        -0.43222060799598694,
        0.4917842447757721
      ],
      "plane_d": -188.6185302734375,
      "bbox_min": [
        -1016.3764038085938,
        -2043.1588134765625,
        148.753173828125
      ],
      "bbox_max": [
        -1014.0064697265625,
        -2040.115234375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2265453338623047,
        -0.9669476747512817,
        0.11700189113616943
      ],
      "plane_d": -2218.357666015625,
      "bbox_min": [
        -929.2406005859375,
        -2064.401123046875,
        117.573974609375
      ],
      "bbox_max": [
        -920.051025390625,
        -2058.711669921875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2265453338623047,
        -0.9669476747512817,
        0.11700189113616943
      ],
      "plane_d": -2218.357666015625,
      "bbox_min": [
        -925.8958129882812,
        -2071.75146484375,
        108.74629211425781
      ],
      "bbox_max": [
        -893.2371826171875,
        -2059.108154296875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32657477259635925,
        0.944736123085022,
        0.02867927961051464
      ],
      "plane_d": 2788.171630859375,
      "bbox_min": [
        -468.7301940917969,
        -2794.01904296875,
        100.0
      ],
      "bbox_max": [
        -466.5007019042969,
        -2792.896240234375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4426290988922119,
        -0.8944221138954163,
        0.06394129991531372
      ],
      "plane_d": -2236.98828125,
      "bbox_min": [
        -899.41455078125,
        -2450.97705078125,
        100.0
      ],
      "bbox_max": [
        -630.9057006835938,
        -2065.3125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2265453338623047,
        -0.9669476747512817,
        0.11700189113616943
      ],
      "plane_d": -2218.357666015625,
      "bbox_min": [
        -899.41455078125,
        -2450.97705078125,
        100.0
      ],
      "bbox_max": [
        -630.9057006835938,
        -2065.3125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.755939245223999,
        0.6539766788482666,
        0.02950362116098404
      ],
      "plane_d": 2042.1041259765625,
      "bbox_min": [
        -812.3786010742188,
        -2334.6572265625,
        100.0
      ],
      "bbox_max": [
        -699.9646606445312,
        -2190.323974609375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7153007388114929,
        0.6982023119926453,
        0.029299555346369743
      ],
      "plane_d": 2127.64697265625,
      "bbox_min": [
        -753.5869140625,
        -2334.6572265625,
        100.0
      ],
      "bbox_max": [
        -699.9646606445312,
        -2257.11865234375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9281567931175232,
        0.37126728892326355,
        0.02618309296667576
      ],
      "plane_d": 1533.945556640625,
      "bbox_min": [
        -753.5869140625,
        -2334.6572265625,
        100.0
      ],
      "bbox_max": [
        -699.9646606445312,
        -2257.11865234375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9409332871437073,
        0.3373379111289978,
        0.0291153434664011
      ],
      "plane_d": 1465.486572265625,
      "bbox_min": [
        -743.0813598632812,
        -2295.4951171875,
        100.0
      ],
      "bbox_max": [
        -738.1463012695312,
        -2284.5458984375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -710.3585815429688,
        -2334.6572265625,
        100.0
      ],
      "bbox_max": [
        -699.9646606445312,
        -2325.861572265625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429206371307373,
        0.6689925789833069,
        0.022761045023798943
      ],
      "plane_d": 2066.188232421875,
      "bbox_min": [
        -787.3925170898438,
        -2258.281982421875,
        100.0
      ],
      "bbox_max": [
        -752.641845703125,
        -2219.205810546875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9281567931175232,
        0.37126728892326355,
        0.02618309296667576
      ],
      "plane_d": 1533.945556640625,
      "bbox_min": [
        -754.691650390625,
        -2258.281982421875,
        100.0
      ],
      "bbox_max": [
        -752.641845703125,
        -2255.27783203125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.834480881690979,
        0.550487756729126,
        0.024593127891421318
      ],
      "plane_d": 1872.022705078125,
      "bbox_min": [
        -734.0372314453125,
        -2450.97705078125,
        100.0
      ],
      "bbox_max": [
        -630.9057006835938,
        -2127.061767578125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8764687180519104,
        0.48085829615592957,
        0.024040397256612778
      ],
      "plane_d": 1733.2122802734375,
      "bbox_min": [
        -734.0372314453125,
        -2351.653564453125,
        100.0
      ],
      "bbox_max": [
        -691.41796875,
        -2127.061767578125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -700.9912109375,
        -2335.138916015625,
        100.0
      ],
      "bbox_max": [
        -699.62255859375,
        -2333.877685546875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4714754819869995,
        -0.8809452652931213,
        0.040574923157691956
      ],
      "plane_d": -2225.99169921875,
      "bbox_min": [
        -734.0372314453125,
        -2129.61083984375,
        143.35594177246094
      ],
      "bbox_max": [
        -729.8462524414062,
        -2127.061767578125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7295700907707214,
        0.6833271980285645,
        0.02813161164522171
      ],
      "plane_d": 2207.02783203125,
      "bbox_min": [
        -336.9926452636719,
        -3009.147705078125,
        100.0
      ],
      "bbox_max": [
        -212.83958435058594,
        -2838.052734375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388664484024048,
        0.6731492280960083,
        0.03076668083667755
      ],
      "plane_d": 2178.357666015625,
      "bbox_min": [
        -231.1630859375,
        -3009.147705078125,
        100.0
      ],
      "bbox_max": [
        -212.83958435058594,
        -2989.194580078125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8872413635253906,
        0.4606812298297882,
        0.023994388058781624
      ],
      "plane_d": 1603.4219970703125,
      "bbox_min": [
        -336.9926452636719,
        -2919.312744140625,
        100.0
      ],
      "bbox_max": [
        -295.1187744140625,
        -2838.052734375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9094638824462891,
        0.4146226942539215,
        0.031041515991091728
      ],
      "plane_d": 1475.5181884765625,
      "bbox_min": [
        -304.8987121582031,
        -2919.312744140625,
        100.0
      ],
      "bbox_max": [
        -295.1187744140625,
        -2901.1435546875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9115313291549683,
        -0.38201379776000977,
        0.1522369533777237
      ],
      "plane_d": -1389.03466796875,
      "bbox_min": [
        -730.3295288085938,
        -2839.3330078125,
        100.0
      ],
      "bbox_max": [
        -336.30511474609375,
        -2129.046142578125,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46342888474464417,
        -0.8689260482788086,
        0.1737847924232483
      ],
      "plane_d": -2528.490478515625,
      "bbox_min": [
        -381.2264404296875,
        -2691.655517578125,
        100.0
      ],
      "bbox_max": [
        -371.7124938964844,
        -2679.980224609375,
        146.20753479003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5192293524742126,
        -0.8514940738677979,
        0.07320254296064377
      ],
      "plane_d": -2270.671142578125,
      "bbox_min": [
        -730.3295288085938,
        -2839.3330078125,
        100.0
      ],
      "bbox_max": [
        -336.30511474609375,
        -2129.046142578125,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4714754819869995,
        -0.8809452652931213,
        0.040574923157691956
      ],
      "plane_d": -2225.99169921875,
      "bbox_min": [
        -730.3295288085938,
        -2274.531494140625,
        100.0
      ],
      "bbox_max": [
        -625.37158203125,
        -2129.046142578125,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4426290988922119,
        -0.8944221138954163,
        0.06394129991531372
      ],
      "plane_d": -2236.98828125,
      "bbox_min": [
        -714.90673828125,
        -2146.244384765625,
        100.0
      ],
      "bbox_max": [
        -702.4977416992188,
        -2139.5322265625,
        117.49517822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8221501111984253,
        -0.5637224912643433,
        0.07928481698036194
      ],
      "plane_d": -1806.1368408203125,
      "bbox_min": [
        -729.8462524414062,
        -2248.028076171875,
        100.0
      ],
      "bbox_max": [
        -640.9779052734375,
        -2129.61083984375,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4426290988922119,
        -0.8944221138954163,
        0.06394129991531372
      ],
      "plane_d": -2236.98828125,
      "bbox_min": [
        -722.3139038085938,
        -2140.103515625,
        100.0
      ],
      "bbox_max": [
        -713.5335083007812,
        -2135.42333984375,
        128.20516967773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4426290988922119,
        -0.8944221138954163,
        0.06394129991531372
      ],
      "plane_d": -2236.98828125,
      "bbox_min": [
        -729.8462524414062,
        -2136.437744140625,
        100.0
      ],
      "bbox_max": [
        -720.2892456054688,
        -2129.61083984375,
        143.35594177246094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2967163920402527,
        0.9547621607780457,
        0.01971287839114666
      ],
      "plane_d": 2806.599853515625,
      "bbox_min": [
        -376.6602783203125,
        -2839.3330078125,
        100.0
      ],
      "bbox_max": [
        -336.30511474609375,
        -2825.620361328125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8872413635253906,
        0.4606812298297882,
        0.023994388058781624
      ],
      "plane_d": 1603.4219970703125,
      "bbox_min": [
        -337.85003662109375,
        -2839.3330078125,
        100.00001525878906
      ],
      "bbox_max": [
        -336.30511474609375,
        -2836.95166015625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8477191925048828,
        0.52967768907547,
        0.02852289006114006
      ],
      "plane_d": 3434.6318359375,
      "bbox_min": [
        -695.2870483398438,
        -4272.58740234375,
        100.0
      ],
      "bbox_max": [
        1978.01318359375,
        -2147.800537109375,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.038124386221170425,
        -0.9989581108093262,
        0.02508561499416828
      ],
      "plane_d": -2511.24755859375,
      "bbox_min": [
        -695.2870483398438,
        -4272.58740234375,
        100.0
      ],
      "bbox_max": [
        1978.01318359375,
        -2147.800537109375,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1437128782272339,
        -0.9889427423477173,
        0.036590516567230225
      ],
      "plane_d": -2465.451416015625,
      "bbox_min": [
        -695.2870483398438,
        -2519.083251953125,
        100.0
      ],
      "bbox_max": [
        203.69203186035156,
        -2147.800537109375,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5395222306251526,
        -0.8415294885635376,
        0.027272434905171394
      ],
      "plane_d": -2254.31982421875,
      "bbox_min": [
        -695.2870483398438,
        -2434.573486328125,
        100.0
      ],
      "bbox_max": [
        -376.7134704589844,
        -2147.800537109375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5192293524742126,
        -0.8514940738677979,
        0.07320254296064377
      ],
      "plane_d": -2270.671142578125,
      "bbox_min": [
        -695.2870483398438,
        -2345.409423828125,
        100.0
      ],
      "bbox_max": [
        -512.486328125,
        -2147.800537109375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4714754819869995,
        -0.8809452652931213,
        0.040574923157691956
      ],
      "plane_d": -2225.99169921875,
      "bbox_min": [
        -695.2870483398438,
        -2156.062255859375,
        100.0
      ],
      "bbox_max": [
        -683.1119995117188,
        -2147.800537109375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5812810063362122,
        -0.8116893172264099,
        0.057208240032196045
      ],
      "plane_d": -2210.2236328125,
      "bbox_min": [
        -555.8399658203125,
        -2345.409423828125,
        100.0
      ],
      "bbox_max": [
        -512.486328125,
        -2314.851318359375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.56119704246521,
        -0.8256406784057617,
        0.058097995817661285
      ],
      "plane_d": -2231.885986328125,
      "bbox_min": [
        -555.8399658203125,
        -2327.388427734375,
        100.0
      ],
      "bbox_max": [
        -542.415771484375,
        -2314.851318359375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5577746033668518,
        -0.8295528292655945,
        0.027008702978491783
      ],
      "plane_d": -2232.429443359375,
      "bbox_min": [
        -593.4502563476562,
        -2434.573486328125,
        100.0
      ],
      "bbox_max": [
        -376.7134704589844,
        -2294.4609375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5192293524742126,
        -0.8514940738677979,
        0.07320254296064377
      ],
      "plane_d": -2270.671142578125,
      "bbox_min": [
        -593.4502563476562,
        -2317.492919921875,
        100.0
      ],
      "bbox_max": [
        -558.556884765625,
        -2294.4609375,
        120.40879821777344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2806796431541443,
        -0.9589745998382568,
        0.03983548656105995
      ],
      "plane_d": -2351.9248046875,
      "bbox_min": [
        -293.9805908203125,
        -2519.083251953125,
        100.0
      ],
      "bbox_max": [
        203.69203186035156,
        -2474.238525390625,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5424458384513855,
        -0.8393089771270752,
        0.03623468056321144
      ],
      "plane_d": -2253.585693359375,
      "bbox_min": [
        -293.9805908203125,
        -2500.4580078125,
        111.1881103515625
      ],
      "bbox_max": [
        -277.0323181152344,
        -2488.573486328125,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1616773158311844,
        -0.9864528775215149,
        0.027771705761551857
      ],
      "plane_d": -2454.997314453125,
      "bbox_min": [
        -126.83592987060547,
        -2519.083251953125,
        100.0
      ],
      "bbox_max": [
        203.69203186035156,
        -2474.238525390625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24863126873970032,
        -0.9681477546691895,
        0.029538404196500778
      ],
      "plane_d": -2377.22607421875,
      "bbox_min": [
        -126.83592987060547,
        -2483.43359375,
        100.0
      ],
      "bbox_max": [
        -91.03118896484375,
        -2474.238525390625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6797831654548645,
        0.7331897616386414,
        0.018096309155225754
      ],
      "plane_d": 2118.83056640625,
      "bbox_min": [
        -492.83447265625,
        -2494.999755859375,
        100.0
      ],
      "bbox_max": [
        -428.566162109375,
        -2439.373779296875,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5381221771240234,
        0.8373711705207825,
        0.0960942804813385
      ],
      "plane_d": 2298.044677734375,
      "bbox_min": [
        -492.83447265625,
        -2463.404052734375,
        100.0
      ],
      "bbox_max": [
        -463.9752197265625,
        -2439.373779296875,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8689243793487549,
        0.41837501525878906,
        0.2644478976726532
      ],
      "plane_d": 566.2352905273438,
      "bbox_min": [
        -492.83447265625,
        -2457.293212890625,
        100.0
      ],
      "bbox_max": [
        -482.92852783203125,
        -2439.373779296875,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05928827077150345,
        -0.9979740977287292,
        0.02307876944541931
      ],
      "plane_d": -2906.13037109375,
      "bbox_min": [
        967.517578125,
        -3675.324462890625,
        100.0
      ],
      "bbox_max": [
        1978.01318359375,
        -2733.634033203125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29879969358444214,
        -0.9538390636444092,
        0.030162015929818153
      ],
      "plane_d": -3092.20263671875,
      "bbox_min": [
        1285.57861328125,
        -2832.186767578125,
        100.0
      ],
      "bbox_max": [
        1738.69189453125,
        -2733.634033203125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3609467148780823,
        -0.930988073348999,
        0.054576583206653595
      ],
      "plane_d": -3130.5810546875,
      "bbox_min": [
        1285.57861328125,
        -2832.186767578125,
        100.0
      ],
      "bbox_max": [
        1602.5487060546875,
        -2733.634033203125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06795407831668854,
        -0.9973331689834595,
        0.026623612269759178
      ],
      "plane_d": -2915.987548828125,
      "bbox_min": [
        1285.57861328125,
        -2832.186767578125,
        126.93004608154297
      ],
      "bbox_max": [
        1295.013671875,
        -2831.575439453125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4576248228549957,
        -0.8877981305122375,
        0.04892735183238983
      ],
      "plane_d": -1702.181884765625,
      "bbox_min": [
        1599.721435546875,
        -2737.116455078125,
        100.0
      ],
      "bbox_max": [
        1602.5487060546875,
        -2733.634033203125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4576248228549957,
        -0.8877981305122375,
        0.04892735183238983
      ],
      "plane_d": -1702.181884765625,
      "bbox_min": [
        1295.013671875,
        -2832.15966796875,
        100.0
      ],
      "bbox_max": [
        1738.69189453125,
        -2735.09130859375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3314240276813507,
        -0.910738468170166,
        0.24640101194381714
      ],
      "plane_d": -3039.8310546875,
      "bbox_min": [
        1295.013671875,
        -2832.15966796875,
        100.0
      ],
      "bbox_max": [
        1422.0576171875,
        -2793.21337890625,
        126.93004608154297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.033044300973415375,
        -0.9766026735305786,
        0.21249790489673615
      ],
      "plane_d": -2835.659912109375,
      "bbox_min": [
        1090.228271484375,
        -3675.324462890625,
        100.0
      ],
      "bbox_max": [
        1978.01318359375,
        -2805.267822265625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4576248228549957,
        -0.8877981305122375,
        0.04892735183238983
      ],
      "plane_d": -1702.181884765625,
      "bbox_min": [
        1295.013671875,
        -2837.873046875,
        100.0
      ],
      "bbox_max": [
        1757.6160888671875,
        -2805.267822265625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4312950074672699,
        -0.9005617499351501,
        0.054527778178453445
      ],
      "plane_d": -1784.802734375,
      "bbox_min": [
        1744.6431884765625,
        -2816.37939453125,
        100.0
      ],
      "bbox_max": [
        1755.01416015625,
        -2808.33544921875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9105714559555054,
        -0.4126048982143402,
        0.024836042895913124
      ],
      "plane_d": 433.4289855957031,
      "bbox_min": [
        1754.835205078125,
        -2816.37939453125,
        100.0
      ],
      "bbox_max": [
        1755.01416015625,
        -2813.84716796875,
        139.5871124267578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9105714559555054,
        -0.4126048982143402,
        0.024836042895913124
      ],
      "plane_d": 433.4289855957031,
      "bbox_min": [
        1295.013671875,
        -2837.873046875,
        100.0
      ],
      "bbox_max": [
        1757.6160888671875,
        -2814.3955078125,
        137.03912353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3314240276813507,
        -0.910738468170166,
        0.24640101194381714
      ],
      "plane_d": -3039.8310546875,
      "bbox_min": [
        1295.013671875,
        -2837.873046875,
        100.0
      ],
      "bbox_max": [
        1316.8963623046875,
        -2831.482177734375,
        126.93004608154297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8598151206970215,
        0.5105383396148682,
        0.008278584107756615
      ],
      "plane_d": 3395.324462890625,
      "bbox_min": [
        1751.6458740234375,
        -3675.324462890625,
        100.0
      ],
      "bbox_max": [
        1978.01318359375,
        -2811.689208984375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4312950074672699,
        -0.9005617499351501,
        0.054527778178453445
      ],
      "plane_d": -1784.802734375,
      "bbox_min": [
        1751.6458740234375,
        -3675.324462890625,
        100.0
      ],
      "bbox_max": [
        1758.7371826171875,
        -2811.689208984375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07275157421827316,
        -0.9971229434013367,
        0.02128235250711441
      ],
      "plane_d": -2932.72802734375,
      "bbox_min": [
        -428.3454895019531,
        -4014.703369140625,
        100.0
      ],
      "bbox_max": [
        1758.60791015625,
        -2495.204345703125,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4237554669380188,
        -0.9054881930351257,
        0.022859251126646996
      ],
      "plane_d": -2065.258056640625,
      "bbox_min": [
        -428.3454895019531,
        -2942.648681640625,
        100.0
      ],
      "bbox_max": [
        968.48828125,
        -2495.204345703125,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39029523730278015,
        -0.9200517535209656,
        0.034270964562892914
      ],
      "plane_d": -2129.463623046875,
      "bbox_min": [
        728.277099609375,
        -2631.02783203125,
        100.0
      ],
      "bbox_max": [
        755.5160522460938,
        -2617.859375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6797831654548645,
        0.7331897616386414,
        0.018096309155225754
      ],
      "plane_d": 2118.83056640625,
      "bbox_min": [
        -428.3454895019531,
        -2942.648681640625,
        100.0
      ],
      "bbox_max": [
        968.48828125,
        -2495.204345703125,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8928471803665161,
        -0.4178312420845032,
        0.16805040836334229
      ],
      "plane_d": -1327.4686279296875,
      "bbox_min": [
        -226.6180877685547,
        -2942.648681640625,
        100.0
      ],
      "bbox_max": [
        -40.316280364990234,
        -2737.420654296875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5659378170967102,
        -0.8116989731788635,
        0.14442728459835052
      ],
      "plane_d": -2430.857666015625,
      "bbox_min": [
        -84.01172637939453,
        -2942.648681640625,
        100.0
      ],
      "bbox_max": [
        -40.316280364990234,
        -2918.408935546875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9041878581047058,
        -0.4269438683986664,
        0.012780503369867802
      ],
      "plane_d": -1335.0274658203125,
      "bbox_min": [
        -226.6180877685547,
        -2858.90234375,
        100.0
      ],
      "bbox_max": [
        -124.75054931640625,
        -2737.420654296875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.021644897758960724,
        -0.9809890389442444,
        0.1928522288799286
      ],
      "plane_d": -2715.1787109375,
      "bbox_min": [
        -226.6180877685547,
        -2744.0830078125,
        100.0
      ],
      "bbox_max": [
        -181.17271423339844,
        -2737.420654296875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03495609387755394,
        -0.999209463596344,
        0.01893291436135769
      ],
      "plane_d": -2745.70556640625,
      "bbox_min": [
        -223.37704467773438,
        -2739.159423828125,
        125.32073974609375
      ],
      "bbox_max": [
        -181.17271423339844,
        -2737.420654296875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05073527246713638,
        -0.9985750317573547,
        0.016546614468097687
      ],
      "plane_d": -2746.530029296875,
      "bbox_min": [
        -185.04052734375,
        -2739.159423828125,
        125.32073974609375
      ],
      "bbox_max": [
        -181.17271423339844,
        -2738.56201171875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8048807978630066,
        0.5699580907821655,
        0.16527128219604492
      ],
      "plane_d": 1552.8994140625,
      "bbox_min": [
        -278.31597900390625,
        -2922.710693359375,
        100.0
      ],
      "bbox_max": [
        968.48828125,
        -2499.527099609375,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29478561878204346,
        0.9554215669631958,
        0.016467038542032242
      ],
      "plane_d": 2442.81298828125,
      "bbox_min": [
        -278.31597900390625,
        -2645.3701171875,
        100.0
      ],
      "bbox_max": [
        -76.62802124023438,
        -2499.527099609375,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8044940829277039,
        0.5709185004234314,
        0.1638335883617401
      ],
      "plane_d": 1555.55419921875,
      "bbox_min": [
        -121.81702423095703,
        -2645.3701171875,
        100.0
      ],
      "bbox_max": [
        -76.62802124023438,
        -2593.511962890625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.256084680557251,
        0.9662680625915527,
        0.027326710522174835
      ],
      "plane_d": 2474.06640625,
      "bbox_min": [
        -121.81702423095703,
        -2596.96142578125,
        144.4669647216797
      ],
      "bbox_max": [
        -120.41259765625,
        -2596.432861328125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3544447720050812,
        0.9085077047348022,
        0.22132006287574768
      ],
      "plane_d": 2284.22607421875,
      "bbox_min": [
        -278.31597900390625,
        -2633.727783203125,
        100.0
      ],
      "bbox_max": [
        -113.429931640625,
        -2499.527099609375,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8044940829277039,
        0.5709185004234314,
        0.1638335883617401
      ],
      "plane_d": 1555.55419921875,
      "bbox_min": [
        -120.41259765625,
        -2596.432861328125,
        100.0
      ],
      "bbox_max": [
        -113.429931640625,
        -2585.182373046875,
        144.4669647216797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2806796431541443,
        -0.9589745998382568,
        0.03983548656105995
      ],
      "plane_d": -2351.9248046875,
      "bbox_min": [
        -278.31597900390625,
        -2520.810302734375,
        100.0
      ],
      "bbox_max": [
        -190.32196044921875,
        -2499.527099609375,
        150.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5577746033668518,
        -0.8295528292655945,
        0.027008702978491783
      ],
      "plane_d": -2232.429443359375,
      "bbox_min": [
        -278.31597900390625,
        -2503.8837890625,
        100.00000762939453
      ],
      "bbox_max": [
        -273.6312561035156,
        -2500.4580078125,
        111.18811798095703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5551269054412842,
        -0.8123753666877747,
        0.17855116724967957
      ],
      "plane_d": -2520.319091796875,
      "bbox_min": [
        220.0643768310547,
        -2920.01318359375,
        100.0
      ],
      "bbox_max": [
        241.15911865234375,
        -2910.076171875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9736523628234863,
        -0.03027019277215004,
        0.22601918876171112
      ],
      "plane_d": -345.6151123046875,
      "bbox_min": [
        229.59829711914062,
        -2915.669921875,
        100.0
      ],
      "bbox_max": [
        241.15911865234375,
        -2910.076171875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5622952580451965,
        0.8052801489830017,
        0.18801021575927734
      ],
      "plane_d": 2204.44580078125,
      "bbox_min": [
        -121.27578735351562,
        -2882.221923828125,
        100.0
      ],
      "bbox_max": [
        968.48828125,
        -2529.359619140625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5546605587005615,
        0.8106602430343628,
        0.1875675618648529
      ],
      "plane_d": 2220.478759765625,
      "bbox_min": [
        8.17422103881836,
        -2836.88671875,
        100.0
      ],
      "bbox_max": [
        99.65169525146484,
        -2771.5576171875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5469550490379333,
        0.8172126412391663,
        0.18166914582252502
      ],
      "plane_d": 2239.822998046875,
      "bbox_min": [
        8.17422103881836,
        -2799.00146484375,
        100.0
      ],
      "bbox_max": [
        53.733036041259766,
        -2771.5576171875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.043660908937454224,
        -0.9987923502922058,
        0.02252989076077938
      ],
      "plane_d": -2507.651123046875,
      "bbox_min": [
        -121.27578735351562,
        -2852.242919921875,
        100.0
      ],
      "bbox_max": [
        968.48828125,
        -2529.359619140625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7266949415206909,
        -0.6864138841629028,
        0.02739434503018856
      ],
      "plane_d": -1257.5203857421875,
      "bbox_min": [
        -121.27578735351562,
        -2852.242919921875,
        100.0
      ],
      "bbox_max": [
        968.48828125,
        -2596.432861328125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05928827077150345,
        -0.9979740977287292,
        0.02307876944541931
      ],
      "plane_d": -2906.13037109375,
      "bbox_min": [
        967.4459838867188,
        -2852.242919921875,
        100.0
      ],
      "bbox_max": [
        968.48828125,
        -2851.024658203125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8282895088195801,
        0.5597261190414429,
        0.02536366507411003
      ],
      "plane_d": 1549.3636474609375,
      "bbox_min": [
        -121.27578735351562,
        -2626.30078125,
        144.4669647216797
      ],
      "bbox_max": [
        -100.3984375,
        -2596.432861328125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.256084680557251,
        0.9662680625915527,
        0.027326710522174835
      ],
      "plane_d": 2474.06640625,
      "bbox_min": [
        -121.27578735351562,
        -2596.818115234375,
        144.4669647216797
      ],
      "bbox_max": [
        -120.41259765625,
        -2596.432861328125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4031985104084015,
        -0.8806112408638,
        0.24890731275081635
      ],
      "plane_d": -3000.44140625,
      "bbox_min": [
        -49.245452880859375,
        -4014.703369140625,
        100.0
      ],
      "bbox_max": [
        1758.60791015625,
        -2935.236083984375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24178145825862885,
        0.9671421051025391,
        0.07860032469034195
      ],
      "plane_d": 2937.0234375,
      "bbox_min": [
        -49.245452880859375,
        -3682.71533203125,
        100.0
      ],
      "bbox_max": [
        1758.60791015625,
        -2935.236083984375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3310750424861908,
        0.924628496170044,
        0.1882859170436859
      ],
      "plane_d": 2774.772216796875,
      "bbox_min": [
        44.33879089355469,
        -3682.71533203125,
        100.0
      ],
      "bbox_max": [
        1758.60791015625,
        -3056.01806640625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.820148766040802,
        0.5630922913551331,
        0.10140593349933624
      ],
      "plane_d": 1138.31640625,
      "bbox_min": [
        44.33879089355469,
        -3682.71533203125,
        100.0
      ],
      "bbox_max": [
        1758.60791015625,
        -3056.01806640625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7488449215888977,
        0.6414593458175659,
        0.16661718487739563
      ],
      "plane_d": 1462.0894775390625,
      "bbox_min": [
        44.33879089355469,
        -3407.433349609375,
        100.0
      ],
      "bbox_max": [
        932.9675903320312,
        -3056.01806640625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8890878558158875,
        -0.38653871417045593,
        0.24517454206943512
      ],
      "plane_d": -1165.108642578125,
      "bbox_min": [
        44.33879089355469,
        -3103.483154296875,
        100.0
      ],
      "bbox_max": [
        80.17649841308594,
        -3056.01806640625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7055326700210571,
        -0.7082751393318176,
        0.023873645812273026
      ],
      "plane_d": -2135.6064453125,
      "bbox_min": [
        44.33879089355469,
        -3079.755859375,
        100.0
      ],
      "bbox_max": [
        69.86077880859375,
        -3056.01806640625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38686707615852356,
        0.9116483330726624,
        0.1386769711971283
      ],
      "plane_d": 3600.500244140625,
      "bbox_min": [
        1019.3123779296875,
        -3682.71533203125,
        100.0
      ],
      "bbox_max": [
        1758.60791015625,
        -3453.021240234375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6071054935455322,
        0.7819521427154541,
        0.14132829010486603
      ],
      "plane_d": 1790.0787353515625,
      "bbox_min": [
        1706.7811279296875,
        -3682.71533203125,
        100.0
      ],
      "bbox_max": [
        1758.60791015625,
        -3632.45703125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6603245735168457,
        0.7348749041557312,
        0.15469467639923096
      ],
      "plane_d": 1523.8634033203125,
      "bbox_min": [
        1728.4539794921875,
        -3682.71533203125,
        100.0
      ],
      "bbox_max": [
        1758.60791015625,
        -3658.32080078125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3277740478515625,
        0.9389278292655945,
        0.10477888584136963
      ],
      "plane_d": 3635.802490234375,
      "bbox_min": [
        1019.3123779296875,
        -3533.1953125,
        100.0
      ],
      "bbox_max": [
        1105.7611083984375,
        -3503.0166015625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4219103455543518,
        0.8972445130348206,
        0.13016921281814575
      ],
      "plane_d": 2511.218994140625,
      "bbox_min": [
        631.7510986328125,
        -3643.619140625,
        100.0
      ],
      "bbox_max": [
        1709.51806640625,
        -3204.351318359375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2870385944843292,
        0.9484124183654785,
        0.13461995124816895
      ],
      "plane_d": 2887.098876953125,
      "bbox_min": [
        631.7510986328125,
        -3643.619140625,
        100.0
      ],
      "bbox_max": [
        1709.51806640625,
        -3204.351318359375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44719284772872925,
        0.8824665546417236,
        0.14584721624851227
      ],
      "plane_d": 2416.2138671875,
      "bbox_min": [
        687.480712890625,
        -3643.619140625,
        100.0
      ],
      "bbox_max": [
        1709.51806640625,
        -3266.39990234375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6071054935455322,
        0.7819521427154541,
        0.14132829010486603
      ],
      "plane_d": 1790.0787353515625,
      "bbox_min": [
        687.480712890625,
        -3643.619140625,
        100.0
      ],
      "bbox_max": [
        1709.51806640625,
        -3266.39990234375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38686707615852356,
        0.9116483330726624,
        0.1386769711971283
      ],
      "plane_d": 3600.500244140625,
      "bbox_min": [
        687.480712890625,
        -3462.024169921875,
        100.0
      ],
      "bbox_max": [
        1247.3350830078125,
        -3266.39990234375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45461931824684143,
        0.8825740814208984,
        0.11993440240621567
      ],
      "plane_d": 2558.304443359375,
      "bbox_min": [
        687.480712890625,
        -3287.85888671875,
        100.0
      ],
      "bbox_max": [
        715.9491577148438,
        -3266.39990234375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45461931824684143,
        0.8825740814208984,
        0.11993440240621567
      ],
      "plane_d": 2558.304443359375,
      "bbox_min": [
        631.7510986328125,
        -3500.812744140625,
        100.0
      ],
      "bbox_max": [
        1452.395263671875,
        -3204.351318359375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25093328952789307,
        0.9610074758529663,
        0.1161772757768631
      ],
      "plane_d": 2983.87744140625,
      "bbox_min": [
        631.7510986328125,
        -3500.812744140625,
        100.0
      ],
      "bbox_max": [
        1452.395263671875,
        -3204.351318359375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9916024804115295,
        0.04682568460702896,
        0.12054863572120667
      ],
      "plane_d": -494.3349304199219,
      "bbox_min": [
        632.1046142578125,
        -3215.491943359375,
        100.0
      ],
      "bbox_max": [
        638.2070922851562,
        -3204.351318359375,
        146.80604553222656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2657254636287689,
        0.956613302230835,
        0.11950235813856125
      ],
      "plane_d": 2891.673095703125,
      "bbox_min": [
        -49.245452880859375,
        -3206.932373046875,
        100.0
      ],
      "bbox_max": [
        637.6810302734375,
        -2935.236083984375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7055326700210571,
        -0.7082751393318176,
        0.023873645812273026
      ],
      "plane_d": -2135.6064453125,
      "bbox_min": [
        32.66484832763672,
        -3062.008056640625,
        100.0
      ],
      "bbox_max": [
        52.043949127197266,
        -3044.38916015625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5805860161781311,
        0.8118429183959961,
        0.0618952140212059
      ],
      "plane_d": 2859.779541015625,
      "bbox_min": [
        -49.245452880859375,
        -3206.932373046875,
        100.0
      ],
      "bbox_max": [
        637.6810302734375,
        -2935.236083984375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9916024804115295,
        0.04682568460702896,
        0.12054863572120667
      ],
      "plane_d": -494.3349304199219,
      "bbox_min": [
        595.2847290039062,
        -3206.932373046875,
        100.0
      ],
      "bbox_max": [
        637.6810302734375,
        -3080.4638671875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.520085871219635,
        0.8490864038467407,
        0.0925370380282402
      ],
      "plane_d": 2934.9326171875,
      "bbox_min": [
        595.2847290039062,
        -3108.29833984375,
        100.0
      ],
      "bbox_max": [
        631.8307495117188,
        -3080.4638671875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.990161120891571,
        0.08122681081295013,
        0.11394374072551727
      ],
      "plane_d": -382.1380310058594,
      "bbox_min": [
        631.6881713867188,
        -3206.932373046875,
        146.80604553222656
      ],
      "bbox_max": [
        632.1046142578125,
        -3206.165283203125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5659378170967102,
        -0.8116989731788635,
        0.14442728459835052
      ],
      "plane_d": -2430.857666015625,
      "bbox_min": [
        -49.245452880859375,
        -2948.48388671875,
        100.00000762939453
      ],
      "bbox_max": [
        -40.346435546875,
        -2941.065185546875,
        143.77073669433594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30837056040763855,
        0.9432834982872009,
        0.12297829240560532
      ],
      "plane_d": 2844.69873046875,
      "bbox_min": [
        15.48095703125,
        -3076.980712890625,
        100.0
      ],
      "bbox_max": [
        133.05445861816406,
        -3027.271728515625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7055326700210571,
        -0.7082751393318176,
        0.023873645812273026
      ],
      "plane_d": -2135.6064453125,
      "bbox_min": [
        25.294631958007812,
        -3053.701904296875,
        100.0
      ],
      "bbox_max": [
        43.705684661865234,
        -3037.04736328125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4673880636692047,
        0.8835117816925049,
        0.030906956642866135
      ],
      "plane_d": 2664.30419921875,
      "bbox_min": [
        15.48095703125,
        -3058.69580078125,
        100.0
      ],
      "bbox_max": [
        71.57574462890625,
        -3027.271728515625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7055326700210571,
        -0.7082751393318176,
        0.023873645812273026
      ],
      "plane_d": -2135.6064453125,
      "bbox_min": [
        15.48095703125,
        -3047.57373046875,
        100.0
      ],
      "bbox_max": [
        37.5537109375,
        -3027.271728515625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9722859859466553,
        -0.2179602086544037,
        0.08457721769809723
      ],
      "plane_d": -94.62902069091797,
      "bbox_min": [
        651.7716674804688,
        -4014.703369140625,
        100.0
      ],
      "bbox_max": [
        813.4141845703125,
        -3663.24951171875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9816219806671143,
        -0.15174885094165802,
        0.1157173216342926
      ],
      "plane_d": 160.41783142089844,
      "bbox_min": [
        747.0010986328125,
        -3813.888427734375,
        100.0
      ],
      "bbox_max": [
        770.6924438476562,
        -3717.766845703125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4797043204307556,
        -0.8567934036254883,
        0.1891794204711914
      ],
      "plane_d": -2854.3671875,
      "bbox_min": [
        747.0010986328125,
        -3730.33984375,
        100.0
      ],
      "bbox_max": [
        756.466796875,
        -3717.766845703125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4797043204307556,
        -0.8567934036254883,
        0.1891794204711914
      ],
      "plane_d": -2854.3671875,
      "bbox_min": [
        651.7716674804688,
        -4014.703369140625,
        100.0
      ],
      "bbox_max": [
        813.4141845703125,
        -3663.24951171875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9811185002326965,
        0.1803492158651352,
        0.06986100971698761
      ],
      "plane_d": 1509.7783203125,
      "bbox_min": [
        807.9715576171875,
        -4014.703369140625,
        100.0
      ],
      "bbox_max": [
        813.4141845703125,
        -4004.46337890625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9811185002326965,
        0.1803492158651352,
        0.06986100971698761
      ],
      "plane_d": 1509.7783203125,
      "bbox_min": [
        -431.3668518066406,
        -4272.58740234375,
        100.0
      ],
      "bbox_max": [
        813.383056640625,
        -2493.63720703125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7376764416694641,
        -0.6278554797172546,
        0.24825602769851685
      ],
      "plane_d": -1929.36328125,
      "bbox_min": [
        -431.3668518066406,
        -4272.58740234375,
        100.0
      ],
      "bbox_max": [
        778.0789794921875,
        -2493.63720703125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6797831654548645,
        0.7331897616386414,
        0.018096309155225754
      ],
      "plane_d": 2118.83056640625,
      "bbox_min": [
        -431.3668518066406,
        -3119.670654296875,
        100.0
      ],
      "bbox_max": [
        84.0410385131836,
        -2493.63720703125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8890878558158875,
        -0.38653871417045593,
        0.24517454206943512
      ],
      "plane_d": -1165.108642578125,
      "bbox_min": [
        -247.44180297851562,
        -3119.670654296875,
        100.0
      ],
      "bbox_max": [
        84.0410385131836,
        -2736.792236328125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9041878581047058,
        -0.4269438683986664,
        0.012780503369867802
      ],
      "plane_d": -1335.0274658203125,
      "bbox_min": [
        -247.44180297851562,
        -2923.960693359375,
        100.0
      ],
      "bbox_max": [
        -65.88924407958984,
        -2736.792236328125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5659378170967102,
        -0.8116989731788635,
        0.14442728459835052
      ],
      "plane_d": -2430.857666015625,
      "bbox_min": [
        -106.06298065185547,
        -2923.960693359375,
        100.0
      ],
      "bbox_max": [
        -65.88924407958984,
        -2898.462158203125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5022168159484863,
        -0.8430072069168091,
        0.19265787303447723
      ],
      "plane_d": -2521.018310546875,
      "bbox_min": [
        -106.06298065185547,
        -2912.87255859375,
        100.0
      ],
      "bbox_max": [
        -91.95228576660156,
        -2898.462158203125,
        127.41638946533203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8928471803665161,
        -0.4178312420845032,
        0.16805040836334229
      ],
      "plane_d": -1327.4686279296875,
      "bbox_min": [
        -247.44180297851562,
        -2906.478759765625,
        100.0
      ],
      "bbox_max": [
        -102.68457794189453,
        -2736.792236328125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5022168159484863,
        -0.8430072069168091,
        0.19265787303447723
      ],
      "plane_d": -2521.018310546875,
      "bbox_min": [
        -109.77278900146484,
        -2906.478759765625,
        100.0
      ],
      "bbox_max": [
        -102.68457794189453,
        -2898.548828125,
        125.89128112792969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8953304290771484,
        -0.40696901082992554,
        0.1809958815574646
      ],
      "plane_d": -1297.9310302734375,
      "bbox_min": [
        -247.44180297851562,
        -2902.256103515625,
        100.0
      ],
      "bbox_max": [
        -107.31792449951172,
        -2736.792236328125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5022168159484863,
        -0.8430072069168091,
        0.19265787303447723
      ],
      "plane_d": -2521.018310546875,
      "bbox_min": [
        -110.41657257080078,
        -2902.256103515625,
        100.0
      ],
      "bbox_max": [
        -107.36421203613281,
        -2898.805908203125,
        121.37503814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.021644897758960724,
        -0.9809890389442444,
        0.1928522288799286
      ],
      "plane_d": -2715.1787109375,
      "bbox_min": [
        -247.44180297851562,
        -2743.13818359375,
        100.0
      ],
      "bbox_max": [
        -217.66452026367188,
        -2736.792236328125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03495609387755394,
        -0.999209463596344,
        0.01893291436135769
      ],
      "plane_d": -2745.70556640625,
      "bbox_min": [
        -242.3101806640625,
        -2737.630615234375,
        128.3785400390625
      ],
      "bbox_max": [
        -217.66452026367188,
        -2736.792236328125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8529126644134521,
        0.5195903182029724,
        0.05065583065152168
      ],
      "plane_d": 1448.42822265625,
      "bbox_min": [
        -306.0428161621094,
        -4272.58740234375,
        100.0
      ],
      "bbox_max": [
        778.0789794921875,
        -2719.01416015625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9959223866462708,
        -0.08835939317941666,
        0.0181999821215868
      ],
      "plane_d": -1099.0582275390625,
      "bbox_min": [
        -306.0428161621094,
        -4272.58740234375,
        100.0
      ],
      "bbox_max": [
        778.0789794921875,
        -2719.01416015625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6175416707992554,
        0.7847907543182373,
        0.05240177363157272
      ],
      "plane_d": 2614.06787109375,
      "bbox_min": [
        -306.0428161621094,
        -4067.17626953125,
        100.0
      ],
      "bbox_max": [
        743.94287109375,
        -2719.01416015625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0567576140165329,
        0.9980700612068176,
        0.025192802771925926
      ],
      "plane_d": 3693.984130859375,
      "bbox_min": [
        380.52789306640625,
        -4067.17626953125,
        100.0
      ],
      "bbox_max": [
        743.94287109375,
        -3725.4296875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9983112215995789,
        -0.04819893091917038,
        0.03242654725909233
      ],
      "plane_d": -939.6201171875,
      "bbox_min": [
        461.42340087890625,
        -4067.17626953125,
        100.0
      ],
      "bbox_max": [
        743.94287109375,
        -3730.757568359375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.123633973300457,
        0.9912832975387573,
        0.04551797732710838
      ],
      "plane_d": 3634.754638671875,
      "bbox_min": [
        461.42340087890625,
        -3736.264892578125,
        100.0
      ],
      "bbox_max": [
        503.9828186035156,
        -3730.757568359375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8040251731872559,
        -0.5580930113792419,
        0.2051236778497696
      ],
      "plane_d": -1666.128173828125,
      "bbox_min": [
        -306.0428161621094,
        -3836.18017578125,
        100.0
      ],
      "bbox_max": [
        631.803466796875,
        -2719.01416015625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7167351245880127,
        -0.6454834342002869,
        0.2638974189758301
      ],
      "plane_d": -2018.5269775390625,
      "bbox_min": [
        410.4580383300781,
        -3836.18017578125,
        100.0
      ],
      "bbox_max": [
        631.803466796875,
        -3521.596435546875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4031985104084015,
        -0.8806112408638,
        0.24890731275081635
      ],
      "plane_d": -3000.44140625,
      "bbox_min": [
        448.5495300292969,
        -3591.09033203125,
        100.0
      ],
      "bbox_max": [
        466.6619873046875,
        -3574.628662109375,
        149.99998474121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6095806360244751,
        0.7911239266395569,
        0.05034474655985832
      ],
      "plane_d": 2643.391845703125,
      "bbox_min": [
        611.6952514648438,
        -3836.18017578125,
        100.0
      ],
      "bbox_max": [
        631.803466796875,
        -3820.60888671875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5771116018295288,
        0.8162537217140198,
        0.02592291869223118
      ],
      "plane_d": 2576.205322265625,
      "bbox_min": [
        -306.0428161621094,
        -3159.412353515625,
        100.0
      ],
      "bbox_max": [
        -0.47167086601257324,
        -2719.01416015625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46342888474464417,
        -0.8689260482788086,
        0.1737847924232483
      ],
      "plane_d": -2528.490478515625,
      "bbox_min": [
        -306.0428161621094,
        -2742.0888671875,
        100.0
      ],
      "bbox_max": [
        -261.8863220214844,
        -2719.01416015625,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.03495609387755394,
        -0.999209463596344,
        0.01893291436135769
      ],
      "plane_d": -2745.70556640625,
      "bbox_min": [
        -277.0634765625,
        -2736.049072265625,
        131.54193115234375
      ],
      "bbox_max": [
        -266.8736572265625,
        -2735.678466796875,
        134.9861297607422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03495609387755394,
        -0.999209463596344,
        0.01893291436135769
      ],
      "plane_d": -2745.70556640625,
      "bbox_min": [
        -277.0634765625,
        -2735.9775390625,
        132.2830047607422
      ],
      "bbox_max": [
        -267.0494689941406,
        -2735.56787109375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48667991161346436,
        -0.873214602470398,
        0.025275880470871925
      ],
      "plane_d": -2527.019287109375,
      "bbox_min": [
        -306.0428161621094,
        -2735.678466796875,
        132.2830047607422
      ],
      "bbox_max": [
        -270.6280212402344,
        -2719.01416015625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03495609387755394,
        -0.999209463596344,
        0.01893291436135769
      ],
      "plane_d": -2745.70556640625,
      "bbox_min": [
        -277.0634765625,
        -2735.678466796875,
        132.2830047607422
      ],
      "bbox_max": [
        -270.6280212402344,
        -2735.3544921875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5146318078041077,
        -0.8572092652320862,
        0.018616268411278725
      ],
      "plane_d": -2490.09716796875,
      "bbox_min": [
        -280.040771484375,
        -2735.678466796875,
        132.2830047607422
      ],
      "bbox_max": [
        -276.7245788574219,
        -2733.50634765625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03495609387755394,
        -0.999209463596344,
        0.01893291436135769
      ],
      "plane_d": -2745.70556640625,
      "bbox_min": [
        -277.0634765625,
        -2735.678466796875,
        132.2830047607422
      ],
      "bbox_max": [
        -276.7245788574219,
        -2735.345703125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03495609387755394,
        -0.999209463596344,
        0.01893291436135769
      ],
      "plane_d": -2745.70556640625,
      "bbox_min": [
        -267.81591796875,
        -3834.45458984375,
        100.0
      ],
      "bbox_max": [
        627.6203002929688,
        -2735.666259765625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6095806360244751,
        0.7911239266395569,
        0.05034474655985832
      ],
      "plane_d": 2643.391845703125,
      "bbox_min": [
        -266.8736572265625,
        -3834.45458984375,
        100.0
      ],
      "bbox_max": [
        627.6203002929688,
        -2736.049072265625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9041878581047058,
        -0.4269438683986664,
        0.012780503369867802
      ],
      "plane_d": -1335.0274658203125,
      "bbox_min": [
        -115.40731048583984,
        -2897.551025390625,
        125.72265625
      ],
      "bbox_max": [
        -106.15278625488281,
        -2878.03759765625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8907564282417297,
        -0.4539978802204132,
        0.02095247246325016
      ],
      "plane_d": -1413.04296875,
      "bbox_min": [
        -108.65835571289062,
        -2897.551025390625,
        129.14999389648438
      ],
      "bbox_max": [
        -106.15278625488281,
        -2892.33056640625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8953304290771484,
        -0.40696901082992554,
        0.1809958815574646
      ],
      "plane_d": -1297.9310302734375,
      "bbox_min": [
        -107.4236068725586,
        -2897.551025390625,
        125.72265625
      ],
      "bbox_max": [
        -106.488037109375,
        -2895.8125,
        129.14999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8928471803665161,
        -0.4178312420845032,
        0.16805040836334229
      ],
      "plane_d": -1327.4686279296875,
      "bbox_min": [
        -107.31792449951172,
        -2897.551025390625,
        127.91844177246094
      ],
      "bbox_max": [
        -106.488037109375,
        -2895.8125,
        129.14999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5022168159484863,
        -0.8430072069168091,
        0.19265787303447723
      ],
      "plane_d": -2521.018310546875,
      "bbox_min": [
        -107.68672180175781,
        -2898.86962890625,
        120.25569915771484
      ],
      "bbox_max": [
        -104.64932250976562,
        -2897.01708984375,
        129.5564422607422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8953304290771484,
        -0.40696901082992554,
        0.1809958815574646
      ],
      "plane_d": -1297.9310302734375,
      "bbox_min": [
        -107.68672180175781,
        -2898.86962890625,
        120.25569915771484
      ],
      "bbox_max": [
        -106.488037109375,
        -2897.01708984375,
        129.14999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5659378170967102,
        -0.8116989731788635,
        0.14442728459835052
      ],
      "plane_d": -2430.857666015625,
      "bbox_min": [
        -106.488037109375,
        -2898.7607421875,
        127.41638946533203
      ],
      "bbox_max": [
        -104.64932250976562,
        -2897.551025390625,
        129.5564422607422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661832451820374,
        0.25639787316322327,
        0.027386151254177094
      ],
      "plane_d": 1823.6815185546875,
      "bbox_min": [
        756.5209350585938,
        -4272.58740234375,
        100.0
      ],
      "bbox_max": [
        778.0789794921875,
        -4196.6904296875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8076764345169067,
        0.5888927578926086,
        0.029395628720521927
      ],
      "plane_d": 1760.45068359375,
      "bbox_min": [
        720.9573974609375,
        -4020.620361328125,
        100.0
      ],
      "bbox_max": [
        744.1162109375,
        -3985.717529296875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9983112215995789,
        -0.04819893091917038,
        0.03242654725909233
      ],
      "plane_d": -939.6201171875,
      "bbox_min": [
        742.2200317382812,
        -4020.620361328125,
        100.0
      ],
      "bbox_max": [
        744.1162109375,
        -4014.984375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -5331.83740234375,
        -4587.34521484375,
        149.99996948242188
      ],
      "bbox_max": [
        1988.0572509765625,
        5224.01171875,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164135575294495,
        -0.9401665925979614,
        0.1123996302485466
      ],
      "plane_d": -2832.044921875,
      "bbox_min": [
        -549.0830078125,
        -2957.051025390625,
        149.99996948242188
      ],
      "bbox_max": [
        1760.2698974609375,
        -2360.5,
        874.3952026367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5381221771240234,
        0.8373711705207825,
        0.0960942804813385
      ],
      "plane_d": 2298.044677734375,
      "bbox_min": [
        -549.0830078125,
        -2957.051025390625,
        149.99996948242188
      ],
      "bbox_max": [
        832.5137329101562,
        -2360.5,
        874.3952026367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8907564282417297,
        -0.4539978802204132,
        0.02095247246325016
      ],
      "plane_d": -1413.04296875,
      "bbox_min": [
        -549.0830078125,
        -2957.051025390625,
        149.99996948242188
      ],
      "bbox_max": [
        229.67507934570312,
        -2455.514404296875,
        874.3952026367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9041878581047058,
        -0.4269438683986664,
        0.012780503369867802
      ],
      "plane_d": -1335.0274658203125,
      "bbox_min": [
        -240.532470703125,
        -2940.929931640625,
        150.0
      ],
      "bbox_max": [
        229.67507934570312,
        -2624.96337890625,
        830.8804321289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5551808476448059,
        -0.8314713835716248,
        0.020727891474962234
      ],
      "plane_d": -2470.791259765625,
      "bbox_min": [
        -232.06524658203125,
        -2940.929931640625,
        150.0
      ],
      "bbox_max": [
        229.67507934570312,
        -2624.96337890625,
        830.8804321289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5551269054412842,
        -0.8123753666877747,
        0.17855116724967957
      ],
      "plane_d": -2520.319091796875,
      "bbox_min": [
        -232.06524658203125,
        -2926.276123046875,
        150.0
      ],
      "bbox_max": [
        229.67507934570312,
        -2624.96337890625,
        830.8804321289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8067750930786133,
        -0.3633389174938202,
        0.46593865752220154
      ],
      "plane_d": -1509.4693603515625,
      "bbox_min": [
        -170.6421356201172,
        -2926.276123046875,
        150.0
      ],
      "bbox_max": [
        229.67507934570312,
        -2740.3857421875,
        830.8804321289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9736523628234863,
        -0.03027019277215004,
        0.22601918876171112
      ],
      "plane_d": -345.6151123046875,
      "bbox_min": [
        -95.332275390625,
        -2926.276123046875,
        150.0
      ],
      "bbox_max": [
        229.67507934570312,
        -2884.895751953125,
        830.8804321289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.507418692111969,
        -0.7326852679252625,
        0.45353996753692627
      ],
      "plane_d": -2537.18505859375,
      "bbox_min": [
        -95.332275390625,
        -2926.276123046875,
        822.9534301757812
      ],
      "bbox_max": [
        -35.91261672973633,
        -2884.895751953125,
        830.8804321289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39022088050842285,
        -0.7511724829673767,
        0.5324167609214783
      ],
      "plane_d": -2652.04638671875,
      "bbox_min": [
        -37.998291015625,
        -2926.276123046875,
        825.3902587890625
      ],
      "bbox_max": [
        -35.91261672973633,
        -2924.48193359375,
        827.2244262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8277426958084106,
        -0.4763690233230591,
        0.29650387167930603
      ],
      "plane_d": -1684.990478515625,
      "bbox_min": [
        -165.17123413085938,
        -2764.08740234375,
        814.5003051757812
      ],
      "bbox_max": [
        -148.8699951171875,
        -2743.185546875,
        826.4266967773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29478561878204346,
        0.9554215669631958,
        0.016467038542032242
      ],
      "plane_d": 2442.81298828125,
      "bbox_min": [
        -232.06524658203125,
        -2746.3408203125,
        150.0
      ],
      "bbox_max": [
        -159.21490478515625,
        -2624.96337890625,
        826.0592041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8067750930786133,
        -0.3633389174938202,
        0.46593865752220154
      ],
      "plane_d": -1509.4693603515625,
      "bbox_min": [
        -178.71194458007812,
        -2743.185546875,
        805.8959350585938
      ],
      "bbox_max": [
        -165.17123413085938,
        -2723.851318359375,
        822.09619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022255789488554,
        -0.9675591588020325,
        0.25166231393814087
      ],
      "plane_d": -2846.35498046875,
      "bbox_min": [
        -178.71194458007812,
        -2728.105712890625,
        805.8959350585938
      ],
      "bbox_max": [
        -174.85557556152344,
        -2723.851318359375,
        822.09619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499540239572525,
        0.8658553957939148,
        0.02745842933654785
      ],
      "plane_d": 2413.8603515625,
      "bbox_min": [
        -13.905780792236328,
        -2862.373291015625,
        150.0
      ],
      "bbox_max": [
        128.6957244873047,
        -2755.377197265625,
        492.12506103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8505732417106628,
        0.5242752432823181,
        0.040749020874500275
      ],
      "plane_d": 1447.7750244140625,
      "bbox_min": [
        -13.905780792236328,
        -2862.373291015625,
        150.0
      ],
      "bbox_max": [
        128.6957244873047,
        -2755.377197265625,
        434.9576416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8282895088195801,
        0.5597261190414429,
        0.02536366507411003
      ],
      "plane_d": 1549.3636474609375,
      "bbox_min": [
        -13.905780792236328,
        -2784.34814453125,
        162.60202026367188
      ],
      "bbox_max": [
        5.50732421875,
        -2755.377197265625,
        240.40985107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8048807978630066,
        0.5699580907821655,
        0.16527128219604492
      ],
      "plane_d": 1552.8994140625,
      "bbox_min": [
        -13.905776977539062,
        -2784.34814453125,
        162.60202026367188
      ],
      "bbox_max": [
        5.50732421875,
        -2755.377197265625,
        179.27828979492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5546605587005615,
        0.8106602430343628,
        0.1875675618648529
      ],
      "plane_d": 2220.478759765625,
      "bbox_min": [
        -11.330795288085938,
        -2862.373291015625,
        150.0
      ],
      "bbox_max": [
        128.6957244873047,
        -2755.734130859375,
        198.4245147705078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5622952580451965,
        0.8052801489830017,
        0.18801021575927734
      ],
      "plane_d": 2204.44580078125,
      "bbox_min": [
        5.50732421875,
        -2862.373291015625,
        150.0
      ],
      "bbox_max": [
        128.6957244873047,
        -2779.186279296875,
        198.4245147705078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5469550490379333,
        0.8172126412391663,
        0.18166914582252502
      ],
      "plane_d": 2239.822998046875,
      "bbox_min": [
        5.50732421875,
        -2789.759765625,
        150.0
      ],
      "bbox_max": [
        23.317577362060547,
        -2779.186279296875,
        179.27828979492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8048807978630066,
        0.5699580907821655,
        0.16527128219604492
      ],
      "plane_d": 1552.8994140625,
      "bbox_min": [
        5.50732421875,
        -2784.34814453125,
        150.0
      ],
      "bbox_max": [
        8.17422103881836,
        -2779.186279296875,
        179.27828979492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5527381300926208,
        -0.8330889940261841,
        0.02105342224240303
      ],
      "plane_d": -2475.496826171875,
      "bbox_min": [
        -106.15278625488281,
        -2940.5732421875,
        150.0
      ],
      "bbox_max": [
        -40.85074996948242,
        -2887.419189453125,
        822.9534301757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05073527246713638,
        -0.9985750317573547,
        0.016546614468097687
      ],
      "plane_d": -2746.530029296875,
      "bbox_min": [
        -240.532470703125,
        -2738.758544921875,
        150.0
      ],
      "bbox_max": [
        -176.931884765625,
        -2630.9775390625,
        822.111083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022255789488554,
        -0.9675591588020325,
        0.25166231393814087
      ],
      "plane_d": -2846.35498046875,
      "bbox_min": [
        -178.720947265625,
        -2728.105712890625,
        805.8959350585938
      ],
      "bbox_max": [
        -176.931884765625,
        -2723.84716796875,
        822.111083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03495609387755394,
        -0.999209463596344,
        0.01893291436135769
      ],
      "plane_d": -2745.70556640625,
      "bbox_min": [
        -187.0667724609375,
        -2738.56201171875,
        150.0
      ],
      "bbox_max": [
        -185.04052734375,
        -2738.263671875,
        162.32699584960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03495609387755394,
        -0.999209463596344,
        0.01893291436135769
      ],
      "plane_d": -2745.70556640625,
      "bbox_min": [
        -479.16693115234375,
        -2957.051025390625,
        149.99996948242188
      ],
      "bbox_max": [
        -181.90737915039062,
        -2472.6201171875,
        845.1654052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8953548073768616,
        -0.444709450006485,
        0.023941759020090103
      ],
      "plane_d": -1532.2132568359375,
      "bbox_min": [
        -479.16693115234375,
        -2725.718017578125,
        150.0
      ],
      "bbox_max": [
        -198.43910217285156,
        -2472.6201171875,
        845.1654052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5604902505874634,
        -0.8216592073440552,
        0.10357100516557693
      ],
      "plane_d": -2468.90185546875,
      "bbox_min": [
        -367.330810546875,
        -2725.718017578125,
        669.435546875
      ],
      "bbox_max": [
        -198.43910217285156,
        -2635.6806640625,
        845.1654052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5375874042510986,
        -0.8341876268386841,
        0.12300780415534973
      ],
      "plane_d": -2511.1875,
      "bbox_min": [
        -331.27056884765625,
        -2725.718017578125,
        742.539306640625
      ],
      "bbox_max": [
        -198.43910217285156,
        -2635.6806640625,
        843.2679443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1262851357460022,
        -0.9829915761947632,
        0.13334013521671295
      ],
      "plane_d": -2811.5068359375,
      "bbox_min": [
        -318.67523193359375,
        -2725.718017578125,
        742.539306640625
      ],
      "bbox_max": [
        -198.43910217285156,
        -2635.6806640625,
        838.744873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5633555054664612,
        0.8184596300125122,
        0.11293553560972214
      ],
      "plane_d": 2242.135498046875,
      "bbox_min": [
        -318.67523193359375,
        -2721.63427734375,
        749.8496704101562
      ],
      "bbox_max": [
        -203.51712036132812,
        -2635.6806640625,
        837.5585327148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022255789488554,
        -0.9675591588020325,
        0.25166231393814087
      ],
      "plane_d": -2846.35498046875,
      "bbox_min": [
        -205.52914428710938,
        -2721.63427734375,
        828.4257202148438
      ],
      "bbox_max": [
        -203.51712036132812,
        -2721.14453125,
        830.1307983398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8953548073768616,
        -0.444709450006485,
        0.023941759020090103
      ],
      "plane_d": -1532.2132568359375,
      "bbox_min": [
        -379.1385498046875,
        -2679.906494140625,
        150.0
      ],
      "bbox_max": [
        -367.330810546875,
        -2669.8203125,
        669.435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05073527246713638,
        -0.9985750317573547,
        0.016546614468097687
      ],
      "plane_d": -2746.530029296875,
      "bbox_min": [
        -356.8122253417969,
        -2957.051025390625,
        149.99996948242188
      ],
      "bbox_max": [
        -181.90737915039062,
        -2724.219970703125,
        803.1287841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1262851357460022,
        -0.9829915761947632,
        0.13334013521671295
      ],
      "plane_d": -2811.5068359375,
      "bbox_min": [
        -274.07421875,
        -2727.325439453125,
        742.539306640625
      ],
      "bbox_max": [
        -196.44049072265625,
        -2724.219970703125,
        803.1287841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7295700907707214,
        0.6833271980285645,
        0.02813161164522171
      ],
      "plane_d": 2207.02783203125,
      "bbox_min": [
        -356.8122253417969,
        -2957.051025390625,
        149.99996948242188
      ],
      "bbox_max": [
        -261.2692565917969,
        -2831.78857421875,
        540.5281982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2967163920402527,
        0.9547621607780457,
        0.01971287839114666
      ],
      "plane_d": 2806.599853515625,
      "bbox_min": [
        -356.8122253417969,
        -2839.92333984375,
        150.0
      ],
      "bbox_max": [
        -337.85003662109375,
        -2831.78857421875,
        303.5602111816406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1262851357460022,
        -0.9829915761947632,
        0.13334013521671295
      ],
      "plane_d": -2811.5068359375,
      "bbox_min": [
        -203.9866485595703,
        -2728.105712890625,
        793.17236328125
      ],
      "bbox_max": [
        -176.931884765625,
        -2721.23583984375,
        829.9163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022255789488554,
        -0.9675591588020325,
        0.25166231393814087
      ],
      "plane_d": -2846.35498046875,
      "bbox_min": [
        -203.9866485595703,
        -2728.105712890625,
        805.8959350585938
      ],
      "bbox_max": [
        -176.931884765625,
        -2721.23583984375,
        829.9163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2967163920402527,
        0.9547621607780457,
        0.01971287839114666
      ],
      "plane_d": 2806.599853515625,
      "bbox_min": [
        -549.0830078125,
        -2950.291259765625,
        150.0
      ],
      "bbox_max": [
        -282.8677978515625,
        -2588.620361328125,
        874.3952026367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9094638824462891,
        0.4146226942539215,
        0.031041515991091728
      ],
      "plane_d": 1475.5181884765625,
      "bbox_min": [
        -354.8207092285156,
        -2944.58154296875,
        362.6800537109375
      ],
      "bbox_max": [
        -297.8014831542969,
        -2845.004150390625,
        868.137451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3401496112346649,
        0.9401360750198364,
        0.02103203907608986
      ],
      "plane_d": 2779.226806640625,
      "bbox_min": [
        -354.8207092285156,
        -2927.37158203125,
        651.6136474609375
      ],
      "bbox_max": [
        -312.7353515625,
        -2845.004150390625,
        868.137451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388457655906677,
        0.6731600761413574,
        0.031021639704704285
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -320.4237365722656,
        -2927.37158203125,
        688.5384521484375
      ],
      "bbox_max": [
        -312.7353515625,
        -2920.833740234375,
        868.137451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -320.4237365722656,
        -2926.55029296875,
        688.5384521484375
      ],
      "bbox_max": [
        -312.7353515625,
        -2920.833740234375,
        868.137451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7295700907707214,
        0.6833271980285645,
        0.02813161164522171
      ],
      "plane_d": 2207.02783203125,
      "bbox_min": [
        -353.7283935546875,
        -2944.58154296875,
        405.2056884765625
      ],
      "bbox_max": [
        -297.8014831542969,
        -2845.004150390625,
        868.1151733398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388457655906677,
        0.6731600761413574,
        0.031021639704704285
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -317.4518737792969,
        -2944.58154296875,
        603.116943359375
      ],
      "bbox_max": [
        -299.7966003417969,
        -2924.27294921875,
        868.1151733398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388664484024048,
        0.6731492280960083,
        0.03076668083667755
      ],
      "plane_d": 2178.357666015625,
      "bbox_min": [
        -312.7353515625,
        -2937.811279296875,
        603.116943359375
      ],
      "bbox_max": [
        -299.7966003417969,
        -2924.27294921875,
        690.1046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3401496112346649,
        0.9401360750198364,
        0.02103203907608986
      ],
      "plane_d": 2779.226806640625,
      "bbox_min": [
        -353.7283935546875,
        -2924.27294921875,
        651.6136474609375
      ],
      "bbox_max": [
        -312.7353515625,
        -2845.004150390625,
        867.85791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910527229309082,
        0.41264408826828003,
        0.025789525359869003
      ],
      "plane_d": 1473.680908203125,
      "bbox_min": [
        -352.2510681152344,
        -2924.27294921875,
        651.6136474609375
      ],
      "bbox_max": [
        -312.7353515625,
        -2845.004150390625,
        867.85791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -326.9071960449219,
        -2924.27294921875,
        688.5384521484375
      ],
      "bbox_max": [
        -312.7353515625,
        -2904.157958984375,
        867.85791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388457655906677,
        0.6731600761413574,
        0.031021639704704285
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -301.7523193359375,
        -2950.291259765625,
        446.265380859375
      ],
      "bbox_max": [
        -282.8677978515625,
        -2930.243408203125,
        867.6483764648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388664484024048,
        0.6731492280960083,
        0.03076668083667755
      ],
      "plane_d": 2178.357666015625,
      "bbox_min": [
        -300.4662780761719,
        -2950.291259765625,
        446.265380859375
      ],
      "bbox_max": [
        -282.8677978515625,
        -2930.243408203125,
        691.2490844726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9315862059593201,
        0.3613213896751404,
        0.03992580994963646
      ],
      "plane_d": 1440.1312255859375,
      "bbox_min": [
        -549.0830078125,
        -2847.17236328125,
        150.0
      ],
      "bbox_max": [
        -347.613525390625,
        -2588.620361328125,
        874.3952026367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9296503663063049,
        0.3666344881057739,
        0.03646130487322807
      ],
      "plane_d": 1454.0635986328125,
      "bbox_min": [
        -549.0830078125,
        -2707.45458984375,
        150.0
      ],
      "bbox_max": [
        -502.21734619140625,
        -2588.620361328125,
        275.1019287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3401496112346649,
        0.9401360750198364,
        0.02103203907608986
      ],
      "plane_d": 2779.226806640625,
      "bbox_min": [
        -392.178466796875,
        -2847.17236328125,
        651.6136474609375
      ],
      "bbox_max": [
        -347.613525390625,
        -2833.74560546875,
        869.1029663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9373313784599304,
        0.34786927700042725,
        0.019921978935599327
      ],
      "plane_d": 1415.8299560546875,
      "bbox_min": [
        -508.76104736328125,
        -2801.845947265625,
        506.04541015625
      ],
      "bbox_max": [
        -482.3701171875,
        -2729.926025390625,
        696.421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -508.76104736328125,
        -2800.61376953125,
        506.04541015625
      ],
      "bbox_max": [
        -482.3701171875,
        -2729.926025390625,
        619.49169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.038124386221170425,
        -0.9989581108093262,
        0.02508561499416828
      ],
      "plane_d": -2511.24755859375,
      "bbox_min": [
        -450.96990966796875,
        -2908.51806640625,
        150.0
      ],
      "bbox_max": [
        832.5137329101562,
        -2360.5,
        833.6973266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1616773158311844,
        -0.9864528775215149,
        0.027771705761551857
      ],
      "plane_d": -2454.997314453125,
      "bbox_min": [
        -450.96990966796875,
        -2517.873779296875,
        150.0
      ],
      "bbox_max": [
        218.1004638671875,
        -2360.5,
        813.5462036132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16672015190124512,
        -0.9851060509681702,
        0.0420771948993206
      ],
      "plane_d": -2461.554931640625,
      "bbox_min": [
        -450.96990966796875,
        -2494.908935546875,
        150.0
      ],
      "bbox_max": [
        167.01559448242188,
        -2360.5,
        803.2074584960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5395222306251526,
        -0.8415294885635376,
        0.027272434905171394
      ],
      "plane_d": -2254.31982421875,
      "bbox_min": [
        -450.96990966796875,
        -2432.368408203125,
        150.0
      ],
      "bbox_max": [
        -191.0,
        -2360.5,
        803.1751708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -800.0,
      "bbox_min": [
        -235.0,
        -2432.368408203125,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2360.5,
        803.1751708984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2402.0,
      "bbox_min": [
        -215.0,
        -2432.368408203125,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2360.5,
        799.9635620117188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2385.0,
      "bbox_min": [
        -215.0,
        -2402.0,
        779.0
      ],
      "bbox_max": [
        -191.0,
        -2360.5,
        797.2257690429688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -210.5,
        -2385.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        795.4345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -210.5,
        -2385.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        795.4345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2385.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2371.5,
        795.4345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2385.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2371.5,
        794.9603881835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2373.0,
      "bbox_min": [
        -210.5,
        -2382.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2371.5,
        794.9603881835938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 207.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        784.0
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        793.661865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -199.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        784.0
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -784.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        784.0
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.40613850951194763,
        0.9138116240501404
      ],
      "plane_d": -1680.195068359375,
      "bbox_min": [
        -210.5,
        -2382.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2373.0,
        794.9603881835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.857492983341217,
        0.0,
        -0.5144957900047302
      ],
      "plane_d": 586.9539794921875,
      "bbox_min": [
        -210.5,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2377.0,
        794.9603881835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -210.5,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -207.76231384277344,
        -2377.0,
        794.9603881835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2380.5,
      "bbox_min": [
        -210.5,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -207.76231384277344,
        -2380.5,
        794.9603881835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857492983341217,
        -0.0,
        -0.5144957900047302
      ],
      "plane_d": 238.81179809570312,
      "bbox_min": [
        -197.32847595214844,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2377.0,
        793.0474853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -197.32847595214844,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2377.0,
        793.0474853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2380.5,
      "bbox_min": [
        -197.32847595214844,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2380.5,
        793.0474853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2402.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2385.0,
        797.2257690429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -210.5,
        -2402.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2385.0,
        796.7515869140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2402.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2390.0,
        796.7515869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.857492983341217,
        0.0,
        -0.5144957900047302
      ],
      "plane_d": 586.9539794921875,
      "bbox_min": [
        -210.5,
        -2397.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2394.0,
        796.7515869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2397.5,
      "bbox_min": [
        -210.5,
        -2397.5,
        792.5
      ],
      "bbox_max": [
        -206.77374267578125,
        -2394.0,
        796.7515869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -210.5,
        -2397.5,
        792.5
      ],
      "bbox_max": [
        -209.0,
        -2394.0,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857492983341217,
        -0.0,
        -0.5144957900047302
      ],
      "plane_d": 238.81179809570312,
      "bbox_min": [
        -198.50579833984375,
        -2397.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2394.0,
        795.0096435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -198.50579833984375,
        -2397.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2394.0,
        795.0096435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2397.5,
      "bbox_min": [
        -198.50579833984375,
        -2397.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2397.5,
        795.0096435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2419.0,
      "bbox_min": [
        -215.0,
        -2432.368408203125,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2402.0,
        799.9635620117188
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2419.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2402.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2419.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2402.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -210.5,
        -2419.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2402.0,
        797.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -210.5,
        -2419.0,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2407.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.857492983341217,
        0.0,
        -0.5144957900047302
      ],
      "plane_d": 586.9539794921875,
      "bbox_min": [
        -210.5,
        -2414.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2411.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2414.5,
      "bbox_min": [
        -210.5,
        -2414.5,
        792.5
      ],
      "bbox_max": [
        -206.0,
        -2411.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -210.5,
        -2414.5,
        792.5
      ],
      "bbox_max": [
        -209.0,
        -2411.0,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857492983341217,
        -0.0,
        -0.5144957900047302
      ],
      "plane_d": 238.81179809570312,
      "bbox_min": [
        -199.68312072753906,
        -2414.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2411.0,
        796.9718627929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2414.5,
      "bbox_min": [
        -199.68312072753906,
        -2414.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2411.0,
        796.9718627929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -197.0,
        -2414.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2411.0,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -215.0,
        -2432.368408203125,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2419.0,
        799.9635620117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -215.0,
        -2432.368408203125,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2419.0,
        799.9635620117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6726728081703186,
        0.0,
        -0.7399401068687439
      ],
      "plane_d": 735.466796875,
      "bbox_min": [
        -215.0,
        -2424.0,
        798.5
      ],
      "bbox_max": [
        -213.3900604248047,
        -2419.0,
        799.9635620117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -210.5,
        -2432.368408203125,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2419.0,
        797.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -210.5,
        -2431.62109375,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2424.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857492983341217,
        -0.0,
        -0.5144957900047302
      ],
      "plane_d": 238.81179809570312,
      "bbox_min": [
        -210.5,
        -2431.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2428.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2428.0,
      "bbox_min": [
        -200.0,
        -2431.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2428.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2431.5,
      "bbox_min": [
        -197.33596801757812,
        -2431.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2428.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -197.0,
        -2431.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2428.0,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2428.0,
      "bbox_min": [
        -210.5,
        -2429.843994140625,
        792.5
      ],
      "bbox_max": [
        -206.0,
        -2428.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.857492983341217,
        0.0,
        -0.5144957900047302
      ],
      "plane_d": 586.9539794921875,
      "bbox_min": [
        -210.5,
        -2429.843994140625,
        792.5
      ],
      "bbox_max": [
        -206.0,
        -2428.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -210.5,
        -2429.5498046875,
        792.5
      ],
      "bbox_max": [
        -209.0,
        -2428.0,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 235.0,
      "bbox_min": [
        -235.0,
        -2426.521728515625,
        800.0
      ],
      "bbox_max": [
        -217.5,
        -2407.25,
        803.1751708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2425.0,
      "bbox_min": [
        -233.9909210205078,
        -2426.521728515625,
        800.0
      ],
      "bbox_max": [
        -217.5,
        -2418.680908203125,
        802.9528198242188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 230.0,
      "bbox_min": [
        -230.0,
        -2426.521728515625,
        800.0
      ],
      "bbox_max": [
        -225.0,
        -2425.0,
        802.541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -225.0,
      "bbox_min": [
        -225.0,
        -2426.521728515625,
        800.0
      ],
      "bbox_max": [
        -225.0,
        -2425.0,
        801.9068603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -217.5,
      "bbox_min": [
        -217.5,
        -2425.0,
        800.0
      ],
      "bbox_max": [
        -217.5,
        -2418.680908203125,
        800.6658325195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0943203866481781,
        -0.9947079420089722,
        0.04074132815003395
      ],
      "plane_d": -2462.647705078125,
      "bbox_min": [
        -235.0,
        -2456.546875,
        660.5152587890625
      ],
      "bbox_max": [
        -81.97344207763672,
        -2424.69384765625,
        803.2074584960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -235.0,
        -2434.710693359375,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2424.69384765625,
        803.2074584960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -800.0,
      "bbox_min": [
        -235.0,
        -2429.312744140625,
        800.0
      ],
      "bbox_max": [
        -225.0,
        -2424.69384765625,
        803.2074584960938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 230.0,
      "bbox_min": [
        -235.0,
        -2429.312744140625,
        800.0
      ],
      "bbox_max": [
        -225.0,
        -2424.69384765625,
        803.2074584960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2424.999755859375,
      "bbox_min": [
        -235.0,
        -2425.0,
        800.0
      ],
      "bbox_max": [
        -233.24667358398438,
        -2424.69384765625,
        803.2074584960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 235.0,
      "bbox_min": [
        -235.0,
        -2425.0,
        800.0
      ],
      "bbox_max": [
        -235.0,
        -2424.69384765625,
        803.2074584960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -225.0,
      "bbox_min": [
        -225.0,
        -2429.312744140625,
        800.0
      ],
      "bbox_max": [
        -225.0,
        -2426.4404296875,
        802.2029418945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2434.710693359375,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2429.08251953125,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -210.5,
        -2434.710693359375,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2429.08251953125,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -210.5,
        -2434.710693359375,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2429.296142578125,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2431.5,
      "bbox_min": [
        -210.5,
        -2431.5,
        792.5
      ],
      "bbox_max": [
        -196.21461486816406,
        -2429.296142578125,
        797.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.857492983341217,
        0.0,
        -0.5144957900047302
      ],
      "plane_d": 586.9539794921875,
      "bbox_min": [
        -210.5,
        -2431.5,
        792.5
      ],
      "bbox_max": [
        -197.33596801757812,
        -2429.296142578125,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -210.5,
        -2431.5,
        792.5
      ],
      "bbox_max": [
        -209.0,
        -2429.296142578125,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857492983341217,
        -0.0,
        -0.5144957900047302
      ],
      "plane_d": 238.81179809570312,
      "bbox_min": [
        -200.0,
        -2431.5,
        793.0599365234375
      ],
      "bbox_max": [
        -197.33596801757812,
        -2430.859375,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1437128782272339,
        -0.9889427423477173,
        0.036590516567230225
      ],
      "plane_d": -2465.451416015625,
      "bbox_min": [
        -397.05926513671875,
        -2510.762939453125,
        150.0
      ],
      "bbox_max": [
        160.30667114257812,
        -2413.303466796875,
        813.5462036132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5395222306251526,
        -0.8415294885635376,
        0.027272434905171394
      ],
      "plane_d": -2254.31982421875,
      "bbox_min": [
        -397.05926513671875,
        -2435.74755859375,
        150.0
      ],
      "bbox_max": [
        -195.5,
        -2413.303466796875,
        802.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5384513735771179,
        -0.8420933485031128,
        0.03080403432250023
      ],
      "plane_d": -2256.63623046875,
      "bbox_min": [
        -393.7957458496094,
        -2435.74755859375,
        383.8638610839844
      ],
      "bbox_max": [
        -195.5,
        -2413.92529296875,
        802.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5812810063362122,
        -0.8116893172264099,
        0.057208240032196045
      ],
      "plane_d": -2210.2236328125,
      "bbox_min": [
        -393.7957458496094,
        -2430.734130859375,
        383.8638610839844
      ],
      "bbox_max": [
        -225.0,
        -2413.92529296875,
        802.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 230.0,
      "bbox_min": [
        -230.0,
        -2430.734130859375,
        799.6328735351562
      ],
      "bbox_max": [
        -225.0,
        -2428.4130859375,
        802.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -225.0,
      "bbox_min": [
        -230.0,
        -2430.734130859375,
        799.6328735351562
      ],
      "bbox_max": [
        -225.0,
        -2428.493408203125,
        802.3486938476562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -800.0,
      "bbox_min": [
        -230.0,
        -2430.734130859375,
        799.6328735351562
      ],
      "bbox_max": [
        -225.0,
        -2428.493408203125,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721364974975586,
        0.8944272994995117
      ],
      "plane_d": -1802.27099609375,
      "bbox_min": [
        -229.959228515625,
        -2430.734130859375,
        799.6328735351562
      ],
      "bbox_max": [
        -225.0,
        -2430.0,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5994062423706055,
        -0.7998847365379333,
        0.029941599816083908
      ],
      "plane_d": -2178.19677734375,
      "bbox_min": [
        -392.69354248046875,
        -2415.410400390625,
        388.2456970214844
      ],
      "bbox_max": [
        -391.1797790527344,
        -2414.40576171875,
        394.5291748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5781846046447754,
        -0.8145887851715088,
        0.0463433638215065
      ],
      "plane_d": -2211.789794921875,
      "bbox_min": [
        -392.69354248046875,
        -2415.410400390625,
        388.2456970214844
      ],
      "bbox_max": [
        -391.22314453125,
        -2414.40576171875,
        390.6929016113281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2435.74755859375,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2431.759765625,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -210.5,
        -2435.74755859375,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2431.759765625,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -210.5,
        -2435.10009765625,
        797.5
      ],
      "bbox_max": [
        -195.5,
        -2431.759765625,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5424458384513855,
        -0.8393089771270752,
        0.03623468056321144
      ],
      "plane_d": -2253.585693359375,
      "bbox_min": [
        -391.22314453125,
        -2423.404296875,
        388.9328308105469
      ],
      "bbox_max": [
        -378.3543701171875,
        -2415.410400390625,
        402.36541748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5577746033668518,
        -0.8295528292655945,
        0.027008702978491783
      ],
      "plane_d": -2232.429443359375,
      "bbox_min": [
        -392.3694763183594,
        -2432.66259765625,
        150.0
      ],
      "bbox_max": [
        -377.13458251953125,
        -2415.410400390625,
        395.07733154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5424458384513855,
        -0.8393089771270752,
        0.03623468056321144
      ],
      "plane_d": -2253.585693359375,
      "bbox_min": [
        -391.22314453125,
        -2424.687255859375,
        358.6369934082031
      ],
      "bbox_max": [
        -378.44415283203125,
        -2415.410400390625,
        395.07733154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24863126873970032,
        -0.9681477546691895,
        0.029538404196500778
      ],
      "plane_d": -2377.22607421875,
      "bbox_min": [
        -378.89312744140625,
        -2502.74169921875,
        150.0
      ],
      "bbox_max": [
        -82.792724609375,
        -2421.510009765625,
        813.5462036132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5424458384513855,
        -0.8393089771270752,
        0.03623468056321144
      ],
      "plane_d": -2253.585693359375,
      "bbox_min": [
        -378.89312744140625,
        -2499.527099609375,
        150.0
      ],
      "bbox_max": [
        -82.792724609375,
        -2421.510009765625,
        813.5462036132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.430268257856369,
        -0.8978968262672424,
        0.09300856292247772
      ],
      "plane_d": -2403.1669921875,
      "bbox_min": [
        -311.013427734375,
        -2489.7099609375,
        587.814208984375
      ],
      "bbox_max": [
        -137.0,
        -2429.88330078125,
        813.5462036132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8360707759857178,
        -0.5481618642807007,
        0.022454261779785156
      ],
      "plane_d": -1177.5562744140625,
      "bbox_min": [
        -240.31146240234375,
        -2488.98486328125,
        626.2130737304688
      ],
      "bbox_max": [
        -195.5,
        -2429.88330078125,
        804.588623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -230.0,
        -2465.578125,
        778.5
      ],
      "bbox_max": [
        -208.26608276367188,
        -2429.88330078125,
        804.588623046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -229.0,
      "bbox_min": [
        -229.0,
        -2465.578125,
        778.5
      ],
      "bbox_max": [
        -229.0,
        -2461.5,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2453.5,
      "bbox_min": [
        -230.0,
        -2465.5166015625,
        780.0
      ],
      "bbox_max": [
        -210.5,
        -2429.88330078125,
        804.588623046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 222.5,
      "bbox_min": [
        -230.0,
        -2452.0,
        780.0
      ],
      "bbox_max": [
        -210.5,
        -2429.88330078125,
        804.588623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 230.0,
      "bbox_min": [
        -230.0,
        -2445.0,
        796.25
      ],
      "bbox_max": [
        -222.5,
        -2429.88330078125,
        804.588623046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2445.0,
      "bbox_min": [
        -230.0,
        -2445.0,
        796.25
      ],
      "bbox_max": [
        -222.5,
        -2429.994140625,
        804.588623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721364974975586,
        0.8944272994995117
      ],
      "plane_d": -1802.27099609375,
      "bbox_min": [
        -230.0,
        -2445.0,
        796.25
      ],
      "bbox_max": [
        -222.5,
        -2429.994140625,
        803.3355712890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -796.25,
      "bbox_min": [
        -230.0,
        -2445.0,
        796.25
      ],
      "bbox_max": [
        -222.5,
        -2430.6337890625,
        803.3355712890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -225.0,
      "bbox_min": [
        -225.0,
        -2440.0,
        796.25
      ],
      "bbox_max": [
        -222.5,
        -2430.6337890625,
        803.3355712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2451.999755859375,
      "bbox_min": [
        -222.5,
        -2452.0,
        780.0
      ],
      "bbox_max": [
        -210.71971130371094,
        -2437.0,
        803.4993286132812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -222.5,
        -2452.0,
        780.0
      ],
      "bbox_max": [
        -210.71971130371094,
        -2437.0,
        803.4993286132812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2440.0,
      "bbox_min": [
        -222.5,
        -2445.0,
        795.5
      ],
      "bbox_max": [
        -215.0,
        -2440.0,
        803.4993286132812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2445.0,
      "bbox_min": [
        -222.5,
        -2445.0,
        795.5
      ],
      "bbox_max": [
        -215.0,
        -2440.0,
        803.4993286132812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -215.0,
      "bbox_min": [
        -222.5,
        -2445.0,
        795.5
      ],
      "bbox_max": [
        -215.0,
        -2440.0,
        802.2260131835938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        -220.0,
        -2445.0,
        795.5
      ],
      "bbox_max": [
        -220.0,
        -2440.0,
        796.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2438.0,
      "bbox_min": [
        -221.5,
        -2447.0,
        780.0
      ],
      "bbox_max": [
        -213.0,
        -2438.0,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -788.5,
      "bbox_min": [
        -221.5,
        -2447.0,
        780.0
      ],
      "bbox_max": [
        -213.0,
        -2438.0,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2447.0,
      "bbox_min": [
        -221.5,
        -2447.0,
        780.0
      ],
      "bbox_max": [
        -213.0,
        -2438.0,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 213.0,
      "bbox_min": [
        -213.0,
        -2441.113037109375,
        780.0
      ],
      "bbox_max": [
        -213.0,
        -2438.0,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 226.5,
      "bbox_min": [
        -229.0,
        -2465.5166015625,
        780.0
      ],
      "bbox_max": [
        -221.5377197265625,
        -2453.5,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -229.0,
      "bbox_min": [
        -229.0,
        -2465.5166015625,
        780.0
      ],
      "bbox_max": [
        -226.82305908203125,
        -2461.5,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -797.0,
      "bbox_min": [
        -229.0,
        -2464.8203125,
        797.0
      ],
      "bbox_max": [
        -226.82305908203125,
        -2461.5,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -226.5,
        -2461.58056640625,
        780.0
      ],
      "bbox_max": [
        -221.5377197265625,
        -2453.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2461.10009765625,
      "bbox_min": [
        -226.5,
        -2461.58056640625,
        780.0
      ],
      "bbox_max": [
        -226.10430908203125,
        -2461.10009765625,
        794.7322387695312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -783.0,
      "bbox_min": [
        -226.5,
        -2461.58056640625,
        783.0
      ],
      "bbox_max": [
        -226.18492126464844,
        -2461.10009765625,
        792.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 792.4999389648438,
      "bbox_min": [
        -226.5,
        -2461.19140625,
        792.4999389648438
      ],
      "bbox_max": [
        -226.4401397705078,
        -2461.10009765625,
        792.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2436.0,
      "bbox_min": [
        -210.5,
        -2437.0,
        780.0
      ],
      "bbox_max": [
        -208.3075408935547,
        -2432.920654296875,
        797.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2437.0,
      "bbox_min": [
        -210.5,
        -2437.0,
        780.0
      ],
      "bbox_max": [
        -210.30335998535156,
        -2437.0,
        787.320556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -210.5,
        -2436.0,
        797.5
      ],
      "bbox_max": [
        -208.3075408935547,
        -2432.920654296875,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09340238571166992,
        -0.9850569367408752,
        0.14470228552818298
      ],
      "plane_d": -2519.996337890625,
      "bbox_min": [
        -240.25204467773438,
        -2488.98486328125,
        626.2130737304688
      ],
      "bbox_max": [
        -195.5,
        -2433.2392578125,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -229.0,
        -2465.578125,
        772.0
      ],
      "bbox_max": [
        -195.5,
        -2433.2392578125,
        804.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9845619797706604,
        -0.17503629624843597,
        0.0
      ],
      "plane_d": -651.885986328125,
      "bbox_min": [
        -224.5,
        -2462.62548828125,
        772.0
      ],
      "bbox_max": [
        -223.04331970214844,
        -2461.5,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.15676754713058472,
        -0.9876355528831482
      ],
      "plane_d": 376.5713195800781,
      "bbox_min": [
        -224.5,
        -2462.62548828125,
        772.0
      ],
      "bbox_max": [
        -223.04331970214844,
        -2461.5,
        772.1786499023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2451.999755859375,
      "bbox_min": [
        -227.62997436523438,
        -2463.9697265625,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2433.2392578125,
        804.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2453.5,
      "bbox_min": [
        -227.62997436523438,
        -2463.9697265625,
        780.0
      ],
      "bbox_max": [
        -214.9629669189453,
        -2453.5,
        804.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 226.5,
      "bbox_min": [
        -227.62997436523438,
        -2463.9697265625,
        780.0
      ],
      "bbox_max": [
        -216.38796997070312,
        -2453.5,
        804.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -797.0,
      "bbox_min": [
        -227.62997436523438,
        -2462.730712890625,
        797.0
      ],
      "bbox_max": [
        -226.5,
        -2461.5,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -226.5,
        -2463.719482421875,
        780.0
      ],
      "bbox_max": [
        -216.38796997070312,
        -2453.5,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 797.0,
      "bbox_min": [
        -226.5,
        -2462.551513671875,
        797.0
      ],
      "bbox_max": [
        -225.34124755859375,
        -2461.5,
        804.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2461.10009765625,
      "bbox_min": [
        -226.5,
        -2463.719482421875,
        780.0
      ],
      "bbox_max": [
        -224.60009765625,
        -2461.10009765625,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -783.0,
      "bbox_min": [
        -226.5,
        -2463.719482421875,
        783.0
      ],
      "bbox_max": [
        -225.800048828125,
        -2461.10009765625,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 503.968017578125,
      "bbox_min": [
        -226.5,
        -2462.927001953125,
        792.4999389648438
      ],
      "bbox_max": [
        -224.73223876953125,
        -2461.10009765625,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2461.10009765625,
      "bbox_min": [
        -226.5,
        -2462.927001953125,
        792.4999389648438
      ],
      "bbox_max": [
        -224.73223876953125,
        -2461.10009765625,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 792.4999389648438,
      "bbox_min": [
        -226.5,
        -2462.927001953125,
        792.4999389648438
      ],
      "bbox_max": [
        -225.800048828125,
        -2461.10009765625,
        792.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2436.0,
      "bbox_min": [
        -220.55421447753906,
        -2452.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2433.2392578125,
        802.5778198242188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -220.55421447753906,
        -2452.0,
        780.0
      ],
      "bbox_max": [
        -196.78082275390625,
        -2436.0,
        802.5778198242188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2445.0,
      "bbox_min": [
        -216.15487670898438,
        -2445.0,
        795.5
      ],
      "bbox_max": [
        -215.0,
        -2443.2529296875,
        802.5778198242188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -215.0,
      "bbox_min": [
        -215.0,
        -2445.0,
        795.5
      ],
      "bbox_max": [
        -215.0,
        -2443.2529296875,
        802.4100952148438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2437.0,
      "bbox_min": [
        -217.0880889892578,
        -2447.0,
        780.0
      ],
      "bbox_max": [
        -196.78082275390625,
        -2436.0,
        795.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -199.0,
      "bbox_min": [
        -207.0,
        -2437.0,
        780.0
      ],
      "bbox_max": [
        -199.0,
        -2436.0,
        791.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 207.0,
      "bbox_min": [
        -207.0,
        -2437.0,
        780.0
      ],
      "bbox_max": [
        -199.0,
        -2436.0,
        791.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 791.0,
      "bbox_min": [
        -207.0,
        -2437.0,
        791.0
      ],
      "bbox_max": [
        -199.0,
        -2436.0,
        791.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 213.0,
      "bbox_min": [
        -217.0880889892578,
        -2447.0,
        780.0
      ],
      "bbox_max": [
        -213.0,
        -2440.764892578125,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2447.0,
      "bbox_min": [
        -217.0880889892578,
        -2447.0,
        780.0
      ],
      "bbox_max": [
        -213.0,
        -2440.764892578125,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -788.5,
      "bbox_min": [
        -217.0880889892578,
        -2447.0,
        788.5
      ],
      "bbox_max": [
        -213.0,
        -2440.764892578125,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -210.11761474609375,
        -2436.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2433.2392578125,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -195.5,
        -2435.837646484375,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2435.67578125,
        781.9389038085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -226.5,
      "bbox_min": [
        -229.0,
        -2466.363525390625,
        778.5
      ],
      "bbox_max": [
        -226.04180908203125,
        -2461.5517578125,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09340238571166992,
        -0.9850569367408752,
        0.14470228552818298
      ],
      "plane_d": -2519.996337890625,
      "bbox_min": [
        -239.92828369140625,
        -2489.7099609375,
        614.1401977539062
      ],
      "bbox_max": [
        -137.0,
        -2435.00048828125,
        806.5680541992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.5,
      "bbox_min": [
        -228.03358459472656,
        -2468.9677734375,
        748.5889282226562
      ],
      "bbox_max": [
        -137.0,
        -2435.00048828125,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -226.5885772705078,
        -2465.120849609375,
        778.5
      ],
      "bbox_max": [
        -137.0,
        -2435.00048828125,
        804.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 189.5,
      "bbox_min": [
        -189.5,
        -2461.832763671875,
        778.5
      ],
      "bbox_max": [
        -189.5,
        -2461.5,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -226.5885772705078,
        -2465.120849609375,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2435.00048828125,
        804.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2436.0,
      "bbox_min": [
        -226.5885772705078,
        -2462.6318359375,
        795.5
      ],
      "bbox_max": [
        -195.5,
        -2435.00048828125,
        804.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -797.0,
      "bbox_min": [
        -226.5885772705078,
        -2462.6318359375,
        797.0
      ],
      "bbox_max": [
        -214.6508331298828,
        -2461.5,
        804.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -197.28770446777344,
        -2436.0,
        797.5
      ],
      "bbox_max": [
        -195.5,
        -2435.00048828125,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -193.0,
      "bbox_min": [
        -226.5,
        -2465.120849609375,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2435.174072265625,
        795.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -782.5,
      "bbox_min": [
        -189.5,
        -2461.6123046875,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2450.0,
        782.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -189.5,
      "bbox_min": [
        -189.5,
        -2461.6123046875,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2450.0,
        782.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -145.0,
      "bbox_min": [
        -145.0,
        -2453.30517578125,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2450.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 137.0,
      "bbox_min": [
        -137.0,
        -2451.8056640625,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2450.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2453.5,
      "bbox_min": [
        -226.5,
        -2465.120849609375,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2435.174072265625,
        795.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2452.0,
      "bbox_min": [
        -214.7349395751953,
        -2453.5,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2435.174072265625,
        795.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        -209.0,
        -2453.5,
        780.0
      ],
      "bbox_max": [
        -200.0,
        -2452.0,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 209.0,
      "bbox_min": [
        -209.0,
        -2453.5,
        780.0
      ],
      "bbox_max": [
        -200.0,
        -2452.0,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7848846912384033,
        0.0,
        -0.6196418404579163
      ],
      "plane_d": 331.81719970703125,
      "bbox_min": [
        -209.0,
        -2453.5,
        788.8333129882812
      ],
      "bbox_max": [
        -200.0,
        -2452.0,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7848846912384033,
        0.0,
        -0.6196418404579163
      ],
      "plane_d": 652.8350219726562,
      "bbox_min": [
        -209.0,
        -2453.5,
        788.8333129882812
      ],
      "bbox_max": [
        -202.5,
        -2452.0,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.0,
      "bbox_min": [
        -206.5,
        -2453.5,
        792.0
      ],
      "bbox_max": [
        -202.5,
        -2452.0,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2436.0,
      "bbox_min": [
        -198.2058868408203,
        -2437.0,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2435.174072265625,
        795.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2437.0,
      "bbox_min": [
        -198.2058868408203,
        -2437.0,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2437.0,
        795.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -195.5,
        -2436.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2435.174072265625,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 226.5,
      "bbox_min": [
        -226.5,
        -2465.120849609375,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2453.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        -0.0,
        0.3713776469230652
      ],
      "plane_d": -81.13743591308594,
      "bbox_min": [
        -226.5,
        -2464.5,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2453.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2464.5,
      "bbox_min": [
        -226.5,
        -2464.5,
        780.0
      ],
      "bbox_max": [
        -224.60009765625,
        -2463.084228515625,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -783.0,
      "bbox_min": [
        -226.5,
        -2464.5,
        783.0
      ],
      "bbox_max": [
        -225.800048828125,
        -2463.084228515625,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 503.968017578125,
      "bbox_min": [
        -226.5,
        -2463.284423828125,
        792.4999389648438
      ],
      "bbox_max": [
        -193.0,
        -2453.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 792.4999389648438,
      "bbox_min": [
        -226.5,
        -2463.284423828125,
        792.4999389648438
      ],
      "bbox_max": [
        -224.60009765625,
        -2461.10009765625,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2461.10009765625,
      "bbox_min": [
        -224.7626190185547,
        -2461.10009765625,
        795.1695556640625
      ],
      "bbox_max": [
        -224.60009765625,
        -2461.10009765625,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2461.999755859375,
      "bbox_min": [
        -221.5,
        -2462.421630859375,
        793.5999755859375
      ],
      "bbox_max": [
        -193.0,
        -2453.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.5,
      "bbox_min": [
        -221.5,
        -2462.421630859375,
        794.5
      ],
      "bbox_max": [
        -216.05406188964844,
        -2462.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": 405.87933349609375,
      "bbox_min": [
        -221.5,
        -2462.421630859375,
        794.5
      ],
      "bbox_max": [
        -220.5,
        -2462.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -194.89990234375,
      "bbox_min": [
        -194.89990234375,
        -2460.030029296875,
        793.5999755859375
      ],
      "bbox_max": [
        -193.0,
        -2453.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 793.5999755859375,
      "bbox_min": [
        -194.89990234375,
        -2460.030029296875,
        793.5999755859375
      ],
      "bbox_max": [
        -193.0,
        -2453.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2455.5,
      "bbox_min": [
        -194.89990234375,
        -2460.030029296875,
        793.5999755859375
      ],
      "bbox_max": [
        -193.0,
        -2455.5,
        795.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.0,
      "bbox_min": [
        -194.5,
        -2460.030029296875,
        794.0
      ],
      "bbox_max": [
        -193.0,
        -2455.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -194.5,
      "bbox_min": [
        -194.5,
        -2460.030029296875,
        794.0
      ],
      "bbox_max": [
        -194.5,
        -2455.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.15676754713058472,
        -0.9876355528831482
      ],
      "plane_d": 376.5713195800781,
      "bbox_min": [
        -224.38064575195312,
        -2468.9677734375,
        748.5889282226562
      ],
      "bbox_max": [
        -193.5,
        -2461.5,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845619797706604,
        -0.17503629624843597,
        0.0
      ],
      "plane_d": -651.885986328125,
      "bbox_min": [
        -224.38064575195312,
        -2465.92822265625,
        772.0
      ],
      "bbox_max": [
        -193.5,
        -2461.5,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.981175422668457,
        -0.19311872124671936,
        0.0
      ],
      "plane_d": -285.5042724609375,
      "bbox_min": [
        -193.82656860351562,
        -2463.1591796875,
        772.0
      ],
      "bbox_max": [
        -193.5,
        -2461.5,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5639985799789429,
        0.8257757425308228
      ],
      "plane_d": 769.4562377929688,
      "bbox_min": [
        -220.5,
        -2468.9677734375,
        748.5889282226562
      ],
      "bbox_max": [
        -197.5,
        -2463.99072265625,
        754.0732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -220.49998474121094,
      "bbox_min": [
        -220.5,
        -2468.9677734375,
        748.5889282226562
      ],
      "bbox_max": [
        -197.5,
        -2463.99072265625,
        754.0732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 217.49998474121094,
      "bbox_min": [
        -220.5,
        -2468.9677734375,
        748.5889282226562
      ],
      "bbox_max": [
        -197.5,
        -2463.99072265625,
        753.896728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5639985799789429,
        -0.8257757425308228
      ],
      "plane_d": -773.2127075195312,
      "bbox_min": [
        -220.5,
        -2468.9677734375,
        748.5889282226562
      ],
      "bbox_max": [
        -217.5,
        -2466.99072265625,
        749.939208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -200.49998474121094,
      "bbox_min": [
        -200.5,
        -2467.244140625,
        748.5889282226562
      ],
      "bbox_max": [
        -197.5,
        -2463.99072265625,
        752.8963012695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 197.49998474121094,
      "bbox_min": [
        -200.5,
        -2467.244140625,
        748.5889282226562
      ],
      "bbox_max": [
        -197.5,
        -2463.99072265625,
        752.7197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5639985799789429,
        -0.8257757425308228
      ],
      "plane_d": -773.2127075195312,
      "bbox_min": [
        -200.5,
        -2467.244140625,
        748.5889282226562
      ],
      "bbox_max": [
        -197.5574951171875,
        -2466.99072265625,
        748.7620239257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.5,
      "bbox_min": [
        -229.4999542236328,
        -2471.029296875,
        748.5889282226562
      ],
      "bbox_max": [
        -188.5418243408203,
        -2459.667236328125,
        806.5680541992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -229.4999542236328,
        -2469.236328125,
        778.5
      ],
      "bbox_max": [
        -188.5418243408203,
        -2459.667236328125,
        806.5680541992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -797.0,
      "bbox_min": [
        -229.4999542236328,
        -2467.115966796875,
        795.5
      ],
      "bbox_max": [
        -200.0345001220703,
        -2461.5,
        806.5680541992188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -229.0,
      "bbox_min": [
        -229.0,
        -2467.115966796875,
        795.5
      ],
      "bbox_max": [
        -229.0,
        -2464.8203125,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09431735426187515,
        -0.9947081804275513,
        0.040740691125392914
      ],
      "plane_d": -2462.6484375,
      "bbox_min": [
        -229.4999542236328,
        -2466.46044921875,
        797.0
      ],
      "bbox_max": [
        -200.0345001220703,
        -2461.5,
        806.5680541992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -804.0,
      "bbox_min": [
        -226.5,
        -2464.5830078125,
        797.0
      ],
      "bbox_max": [
        -219.5,
        -2461.5,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7863183617591858,
        0.0,
        0.6178215742111206
      ],
      "plane_d": -652.812744140625,
      "bbox_min": [
        -204.0,
        -2462.2431640625,
        797.0
      ],
      "bbox_max": [
        -201.8528289794922,
        -2461.5,
        799.7327880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7863183617591858,
        -0.0,
        0.6178215742111206
      ],
      "plane_d": -324.1316833496094,
      "bbox_min": [
        -226.5,
        -2466.46044921875,
        797.0
      ],
      "bbox_max": [
        -214.0,
        -2463.39794921875,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -226.5,
      "bbox_min": [
        -226.5,
        -2466.46044921875,
        797.0
      ],
      "bbox_max": [
        -219.5,
        -2463.632568359375,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -804.0,
      "bbox_min": [
        -226.5,
        -2465.587646484375,
        804.0
      ],
      "bbox_max": [
        -219.5,
        -2463.632568359375,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -229.0,
        -2469.236328125,
        778.5
      ],
      "bbox_max": [
        -188.5418243408203,
        -2459.667236328125,
        795.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 189.5,
      "bbox_min": [
        -189.5,
        -2461.832763671875,
        778.5
      ],
      "bbox_max": [
        -189.5,
        -2461.6123046875,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -229.0,
      "bbox_min": [
        -229.0,
        -2469.04931640625,
        780.0
      ],
      "bbox_max": [
        -229.0,
        -2464.945556640625,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -193.0,
      "bbox_min": [
        -226.5,
        -2464.5,
        780.0
      ],
      "bbox_max": [
        -188.5418243408203,
        -2459.667236328125,
        795.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -189.5,
      "bbox_min": [
        -189.5,
        -2461.645751953125,
        780.0
      ],
      "bbox_max": [
        -188.5418243408203,
        -2461.154052734375,
        782.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -782.5,
      "bbox_min": [
        -189.5,
        -2461.333740234375,
        782.5
      ],
      "bbox_max": [
        -188.5418243408203,
        -2461.154052734375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.5,
      "bbox_min": [
        -226.5,
        -2464.5,
        792.4999389648438
      ],
      "bbox_max": [
        -201.0382080078125,
        -2462.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -2463.499755859375,
      "bbox_min": [
        -226.5,
        -2464.5,
        794.5
      ],
      "bbox_max": [
        -209.04136657714844,
        -2462.369873046875,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": 405.87933349609375,
      "bbox_min": [
        -225.00006103515625,
        -2463.5,
        794.5
      ],
      "bbox_max": [
        -220.5,
        -2462.369873046875,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 503.968017578125,
      "bbox_min": [
        -225.00006103515625,
        -2463.5,
        794.5
      ],
      "bbox_max": [
        -224.60009765625,
        -2462.663818359375,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2464.5,
      "bbox_min": [
        -226.5,
        -2464.5,
        794.5
      ],
      "bbox_max": [
        -224.60009765625,
        -2463.5,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 503.968017578125,
      "bbox_min": [
        -225.00006103515625,
        -2464.5,
        794.5
      ],
      "bbox_max": [
        -224.60009765625,
        -2463.5,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2464.5,
      "bbox_min": [
        -226.5,
        -2464.5,
        792.4999389648438
      ],
      "bbox_max": [
        -225.00006103515625,
        -2463.21826171875,
        794.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 792.4999389648438,
      "bbox_min": [
        -226.5,
        -2464.5,
        792.4999389648438
      ],
      "bbox_max": [
        -225.800048828125,
        -2463.21826171875,
        792.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -194.5,
      "bbox_min": [
        -194.5,
        -2460.8369140625,
        794.0
      ],
      "bbox_max": [
        -193.0,
        -2459.8095703125,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.0,
      "bbox_min": [
        -194.5,
        -2460.8369140625,
        794.0
      ],
      "bbox_max": [
        -193.0,
        -2459.8876953125,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.15676754713058472,
        -0.9876355528831482
      ],
      "plane_d": 376.5713195800781,
      "bbox_min": [
        -223.861572265625,
        -2471.029296875,
        748.5889282226562
      ],
      "bbox_max": [
        -193.64280700683594,
        -2462.2255859375,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845619797706604,
        -0.17503629624843597,
        0.0
      ],
      "plane_d": -651.885986328125,
      "bbox_min": [
        -223.861572265625,
        -2468.81494140625,
        772.2633666992188
      ],
      "bbox_max": [
        -193.64280700683594,
        -2462.2255859375,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.981175422668457,
        -0.19311872124671936,
        0.0
      ],
      "plane_d": -285.5042724609375,
      "bbox_min": [
        -193.8791046142578,
        -2463.426025390625,
        772.2633666992188
      ],
      "bbox_max": [
        -193.64280700683594,
        -2462.2255859375,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 217.49998474121094,
      "bbox_min": [
        -220.5,
        -2471.029296875,
        748.5889282226562
      ],
      "bbox_max": [
        -197.5,
        -2466.37841796875,
        755.5391845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -220.49998474121094,
      "bbox_min": [
        -220.5,
        -2471.029296875,
        749.7625732421875
      ],
      "bbox_max": [
        -217.5,
        -2468.1015625,
        755.5391845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5639985799789429,
        0.8257757425308228
      ],
      "plane_d": 769.4562377929688,
      "bbox_min": [
        -220.5,
        -2471.029296875,
        749.7625732421875
      ],
      "bbox_max": [
        -217.5,
        -2468.1015625,
        755.5391845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5639985799789429,
        -0.8257757425308228
      ],
      "plane_d": -773.2127075195312,
      "bbox_min": [
        -220.5,
        -2471.029296875,
        749.7625732421875
      ],
      "bbox_max": [
        -217.5,
        -2468.708984375,
        751.3472900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -200.49998474121094,
      "bbox_min": [
        -200.5,
        -2467.5751953125,
        748.5889282226562
      ],
      "bbox_max": [
        -197.5,
        -2466.37841796875,
        753.1799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 197.49998474121094,
      "bbox_min": [
        -200.5,
        -2467.5751953125,
        748.5889282226562
      ],
      "bbox_max": [
        -197.5,
        -2466.37841796875,
        753.1799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5639985799789429,
        0.8257757425308228
      ],
      "plane_d": 769.4562377929688,
      "bbox_min": [
        -200.5,
        -2467.5751953125,
        748.5889282226562
      ],
      "bbox_max": [
        -197.5,
        -2466.37841796875,
        753.1799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5639985799789429,
        -0.8257757425308228
      ],
      "plane_d": -773.2127075195312,
      "bbox_min": [
        -200.5,
        -2467.5751953125,
        748.5889282226562
      ],
      "bbox_max": [
        -197.5,
        -2466.99072265625,
        748.988037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0943203866481781,
        -0.9947079420089722,
        0.04074132815003395
      ],
      "plane_d": -2462.647705078125,
      "bbox_min": [
        -255.26904296875,
        -2488.57080078125,
        641.2897338867188
      ],
      "bbox_max": [
        -82.792724609375,
        -2451.49365234375,
        810.9051513671875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        -206.2283935546875,
        -2462.660888671875,
        778.5
      ],
      "bbox_max": [
        -137.0,
        -2451.49365234375,
        802.0175170898438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -782.5,
      "bbox_min": [
        -206.2283935546875,
        -2462.660888671875,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2451.49365234375,
        802.0175170898438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 137.0,
      "bbox_min": [
        -193.0,
        -2462.005859375,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2451.49365234375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -145.0,
      "bbox_min": [
        -193.0,
        -2462.005859375,
        780.0
      ],
      "bbox_max": [
        -145.0,
        -2452.9931640625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -189.5,
      "bbox_min": [
        -193.0,
        -2462.005859375,
        780.0
      ],
      "bbox_max": [
        -162.0,
        -2458.0,
        782.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 162.0,
      "bbox_min": [
        -162.0,
        -2459.1630859375,
        780.0
      ],
      "bbox_max": [
        -162.0,
        -2458.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -193.0,
      "bbox_min": [
        -193.0,
        -2462.005859375,
        782.3699951171875
      ],
      "bbox_max": [
        -193.0,
        -2461.98974609375,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -206.2283935546875,
        -2462.660888671875,
        782.5
      ],
      "bbox_max": [
        -189.5,
        -2460.36865234375,
        802.0175170898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2461.5,
      "bbox_min": [
        -204.0,
        -2462.449462890625,
        797.0
      ],
      "bbox_max": [
        -193.9868621826172,
        -2461.5,
        802.0175170898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7863183617591858,
        0.0,
        0.6178215742111206
      ],
      "plane_d": -652.812744140625,
      "bbox_min": [
        -204.0,
        -2462.449462890625,
        797.0
      ],
      "bbox_max": [
        -200.0576934814453,
        -2461.5,
        802.0175170898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -193.0,
      "bbox_min": [
        -203.96652221679688,
        -2462.548828125,
        782.5
      ],
      "bbox_max": [
        -189.5,
        -2460.36865234375,
        795.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 189.49998474121094,
      "bbox_min": [
        -189.5,
        -2461.66845703125,
        782.5
      ],
      "bbox_max": [
        -189.5,
        -2461.5,
        786.614990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2461.999755859375,
      "bbox_min": [
        -203.96652221679688,
        -2462.548828125,
        794.0
      ],
      "bbox_max": [
        -193.0,
        -2460.5556640625,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.5,
      "bbox_min": [
        -203.96652221679688,
        -2462.548828125,
        794.5
      ],
      "bbox_max": [
        -198.2743682861328,
        -2462.0,
        794.7256469726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 702.1571044921875,
      "bbox_min": [
        -198.5,
        -2462.03076171875,
        794.5
      ],
      "bbox_max": [
        -198.2743682861328,
        -2462.0,
        794.7256469726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.0,
      "bbox_min": [
        -194.5,
        -2461.671630859375,
        794.0
      ],
      "bbox_max": [
        -193.0,
        -2460.5556640625,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -194.5,
      "bbox_min": [
        -194.5,
        -2461.671630859375,
        794.0
      ],
      "bbox_max": [
        -194.5,
        -2460.64990234375,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 189.5,
      "bbox_min": [
        -189.5,
        -2461.832763671875,
        778.5
      ],
      "bbox_max": [
        -189.5,
        -2461.645751953125,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.430268257856369,
        -0.8978968262672424,
        0.09300856292247772
      ],
      "plane_d": -2403.1669921875,
      "bbox_min": [
        -255.26904296875,
        -2487.6455078125,
        663.3368530273438
      ],
      "bbox_max": [
        -242.75209045410156,
        -2470.118408203125,
        810.9051513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.5,
      "bbox_min": [
        -229.0,
        -2486.43408203125,
        748.6341552734375
      ],
      "bbox_max": [
        -137.0,
        -2456.6904296875,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -229.0,
        -2486.1748046875,
        778.5
      ],
      "bbox_max": [
        -137.0,
        -2456.6904296875,
        804.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -229.0,
      "bbox_min": [
        -229.0,
        -2485.577880859375,
        778.5
      ],
      "bbox_max": [
        -229.0,
        -2469.04931640625,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -797.0,
      "bbox_min": [
        -229.0,
        -2485.775146484375,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2456.6904296875,
        804.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -229.0,
        -2485.775146484375,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2456.6904296875,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -229.0,
      "bbox_min": [
        -229.0,
        -2485.15087890625,
        795.5
      ],
      "bbox_max": [
        -189.5,
        -2461.5,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 189.5,
      "bbox_min": [
        -189.5,
        -2479.832275390625,
        795.5
      ],
      "bbox_max": [
        -189.5,
        -2461.5,
        797.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -782.5,
      "bbox_min": [
        -229.0,
        -2485.635009765625,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2456.6904296875,
        795.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -189.5,
      "bbox_min": [
        -229.0,
        -2485.635009765625,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2456.6904296875,
        782.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 137.0,
      "bbox_min": [
        -137.0,
        -2466.822509765625,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2456.6904296875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -192.99998474121094,
      "bbox_min": [
        -229.0,
        -2485.635009765625,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2462.00048828125,
        782.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -229.0,
      "bbox_min": [
        -229.0,
        -2485.540283203125,
        780.0
      ],
      "bbox_max": [
        -229.0,
        -2468.737548828125,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        -0.0,
        0.3713776469230652
      ],
      "plane_d": -81.13743591308594,
      "bbox_min": [
        -226.5,
        -2482.231201171875,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2477.10009765625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2477.10009765625,
      "bbox_min": [
        -226.5,
        -2480.5,
        780.0
      ],
      "bbox_max": [
        -224.60009765625,
        -2477.10009765625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2480.5,
      "bbox_min": [
        -226.5,
        -2480.5,
        780.0
      ],
      "bbox_max": [
        -224.60009765625,
        -2480.5,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.5,
      "bbox_min": [
        -197.0,
        -2482.231201171875,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2479.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -197.0,
      "bbox_min": [
        -197.0,
        -2482.231201171875,
        780.0
      ],
      "bbox_max": [
        -195.0,
        -2479.0,
        780.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        -197.0,
        -2481.717529296875,
        780.0
      ],
      "bbox_max": [
        -195.0,
        -2479.0,
        780.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2479.0,
      "bbox_min": [
        -197.0,
        -2479.0,
        780.0
      ],
      "bbox_max": [
        -195.0,
        -2479.0,
        780.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -781.5,
      "bbox_min": [
        -196.0,
        -2481.943603515625,
        781.0
      ],
      "bbox_max": [
        -193.0,
        -2479.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 781.0,
      "bbox_min": [
        -196.0,
        -2481.943603515625,
        781.0
      ],
      "bbox_max": [
        -194.0,
        -2479.0,
        781.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -196.0,
      "bbox_min": [
        -196.0,
        -2481.943603515625,
        781.0
      ],
      "bbox_max": [
        -194.0,
        -2479.0,
        781.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 194.0,
      "bbox_min": [
        -196.0,
        -2481.429931640625,
        781.0
      ],
      "bbox_max": [
        -194.0,
        -2479.0,
        781.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2479.0,
      "bbox_min": [
        -196.0,
        -2479.0,
        781.0
      ],
      "bbox_max": [
        -194.0,
        -2479.0,
        781.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.0,
      "bbox_min": [
        -195.0,
        -2481.656494140625,
        782.0
      ],
      "bbox_max": [
        -193.0,
        -2479.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -2481.656494140625,
        782.0
      ],
      "bbox_max": [
        -193.0,
        -2479.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2479.0,
      "bbox_min": [
        -195.0,
        -2479.0,
        782.0
      ],
      "bbox_max": [
        -193.0,
        -2479.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 226.5,
      "bbox_min": [
        -229.0,
        -2485.572265625,
        782.5
      ],
      "bbox_max": [
        -183.22999572753906,
        -2461.46826171875,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -229.0,
      "bbox_min": [
        -229.0,
        -2485.4775390625,
        782.5
      ],
      "bbox_max": [
        -229.0,
        -2467.115966796875,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -194.5,
      "bbox_min": [
        -226.5,
        -2481.161865234375,
        782.5
      ],
      "bbox_max": [
        -183.22999572753906,
        -2461.46826171875,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -192.99998474121094,
      "bbox_min": [
        -194.5,
        -2481.161865234375,
        782.5
      ],
      "bbox_max": [
        -183.22999572753906,
        -2461.46826171875,
        795.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": -2496.705810546875,
      "bbox_min": [
        -193.0,
        -2480.883544921875,
        782.5
      ],
      "bbox_max": [
        -189.5,
        -2477.0,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2477.0,
      "bbox_min": [
        -193.0,
        -2480.883544921875,
        785.5
      ],
      "bbox_max": [
        -189.5,
        -2477.0,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 790.5,
      "bbox_min": [
        -193.0,
        -2480.883544921875,
        790.5
      ],
      "bbox_max": [
        -189.5,
        -2479.0,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25766265392303467,
        -0.0,
        0.9662349224090576
      ],
      "plane_d": -719.3297119140625,
      "bbox_min": [
        -189.5,
        -2479.9541015625,
        791.5
      ],
      "bbox_max": [
        -183.22999572753906,
        -2475.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4705882668495178,
        0.8823530077934265,
        0.0
      ],
      "plane_d": 2273.0,
      "bbox_min": [
        -189.5,
        -2479.9541015625,
        791.5
      ],
      "bbox_max": [
        -183.22999572753906,
        -2475.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 791.5,
      "bbox_min": [
        -189.5,
        -2479.9541015625,
        791.5
      ],
      "bbox_max": [
        -183.22999572753906,
        -2475.0,
        791.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.0,
      "bbox_min": [
        -194.5,
        -2481.161865234375,
        794.0
      ],
      "bbox_max": [
        -193.0,
        -2461.529541015625,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.5,
      "bbox_min": [
        -226.5,
        -2480.5,
        782.5
      ],
      "bbox_max": [
        -197.5,
        -2462.0,
        795.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -2479.499755859375,
      "bbox_min": [
        -226.5,
        -2480.5,
        794.5
      ],
      "bbox_max": [
        -197.5,
        -2478.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": 405.87933349609375,
      "bbox_min": [
        -225.00006103515625,
        -2479.5,
        794.5
      ],
      "bbox_max": [
        -197.5,
        -2478.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 702.1571044921875,
      "bbox_min": [
        -198.5,
        -2479.5,
        794.5
      ],
      "bbox_max": [
        -197.5,
        -2478.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 503.968017578125,
      "bbox_min": [
        -225.00006103515625,
        -2479.5,
        794.5
      ],
      "bbox_max": [
        -224.60009765625,
        -2478.0,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2480.5,
      "bbox_min": [
        -226.5,
        -2480.5,
        794.5
      ],
      "bbox_max": [
        -224.60009765625,
        -2479.5,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 503.968017578125,
      "bbox_min": [
        -225.00006103515625,
        -2480.5,
        794.5
      ],
      "bbox_max": [
        -224.60009765625,
        -2479.5,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2461.999755859375,
      "bbox_min": [
        -198.61032104492188,
        -2462.0,
        794.7256469726562
      ],
      "bbox_max": [
        -197.5,
        -2462.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2477.10009765625,
      "bbox_min": [
        -226.5,
        -2478.0,
        794.5
      ],
      "bbox_max": [
        -224.60009765625,
        -2477.10009765625,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 503.968017578125,
      "bbox_min": [
        -225.00006103515625,
        -2478.0,
        794.5
      ],
      "bbox_max": [
        -224.60009765625,
        -2477.10009765625,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 792.4999389648438,
      "bbox_min": [
        -226.5,
        -2480.5,
        792.4999389648438
      ],
      "bbox_max": [
        -225.00006103515625,
        -2477.10009765625,
        794.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2480.5,
      "bbox_min": [
        -226.5,
        -2480.5,
        792.4999389648438
      ],
      "bbox_max": [
        -225.00006103515625,
        -2477.10009765625,
        794.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2477.10009765625,
      "bbox_min": [
        -226.5,
        -2477.10009765625,
        792.4999389648438
      ],
      "bbox_max": [
        -225.00006103515625,
        -2477.10009765625,
        794.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -783.0,
      "bbox_min": [
        -226.5,
        -2480.5,
        782.5
      ],
      "bbox_max": [
        -225.6000518798828,
        -2477.10009765625,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        -0.0,
        0.3713776469230652
      ],
      "plane_d": -81.13743591308594,
      "bbox_min": [
        -226.5,
        -2480.5,
        782.5
      ],
      "bbox_max": [
        -225.6000518798828,
        -2477.10009765625,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2480.5,
      "bbox_min": [
        -226.5,
        -2480.5,
        782.5
      ],
      "bbox_max": [
        -225.6000518798828,
        -2477.10009765625,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2477.10009765625,
      "bbox_min": [
        -226.5,
        -2477.10009765625,
        782.5
      ],
      "bbox_max": [
        -225.6000518798828,
        -2477.10009765625,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7863183617591858,
        -0.0,
        0.6178215742111206
      ],
      "plane_d": -324.1316833496094,
      "bbox_min": [
        -226.5,
        -2485.685546875,
        797.0
      ],
      "bbox_max": [
        -190.0,
        -2461.5,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -804.0,
      "bbox_min": [
        -226.5,
        -2485.2998046875,
        797.0
      ],
      "bbox_max": [
        -219.5,
        -2464.275634765625,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -226.5,
      "bbox_min": [
        -226.5,
        -2485.20849609375,
        797.0
      ],
      "bbox_max": [
        -226.5,
        -2465.587646484375,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7863183617591858,
        0.0,
        0.6178215742111206
      ],
      "plane_d": -652.812744140625,
      "bbox_min": [
        -204.0,
        -2483.510009765625,
        797.0
      ],
      "bbox_max": [
        -190.0,
        -2461.5,
        803.9121704101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 191.5,
      "bbox_min": [
        -195.8740692138672,
        -2480.2998046875,
        797.0
      ],
      "bbox_max": [
        -190.0,
        -2461.5,
        802.6981201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2477.5,
      "bbox_min": [
        -191.5,
        -2480.16259765625,
        797.0
      ],
      "bbox_max": [
        -190.0,
        -2474.5,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2474.5,
      "bbox_min": [
        -191.5,
        -2477.5,
        797.0
      ],
      "bbox_max": [
        -190.0,
        -2474.5,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -801.5,
      "bbox_min": [
        -191.5,
        -2477.5,
        801.5
      ],
      "bbox_max": [
        -190.5,
        -2474.5,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2479.5,
      "bbox_min": [
        -191.5,
        -2480.16259765625,
        797.0
      ],
      "bbox_max": [
        -190.0,
        -2479.5,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -801.5,
      "bbox_min": [
        -191.5,
        -2480.16259765625,
        801.5
      ],
      "bbox_max": [
        -190.5,
        -2479.5,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.15676754713058472,
        -0.9876355528831482
      ],
      "plane_d": 376.5713195800781,
      "bbox_min": [
        -223.3140869140625,
        -2486.43408203125,
        748.6341552734375
      ],
      "bbox_max": [
        -193.7212371826172,
        -2462.6240234375,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845619797706604,
        -0.17503629624843597,
        0.0
      ],
      "plane_d": -651.885986328125,
      "bbox_min": [
        -223.3140869140625,
        -2485.981201171875,
        773.1610717773438
      ],
      "bbox_max": [
        -220.14772033691406,
        -2468.170654296875,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -200.49998474121094,
      "bbox_min": [
        -220.5,
        -2486.43408203125,
        748.6341552734375
      ],
      "bbox_max": [
        -197.5,
        -2466.5341796875,
        766.3409423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5639985799789429,
        0.8257757425308228
      ],
      "plane_d": 769.4562377929688,
      "bbox_min": [
        -200.5,
        -2483.7392578125,
        748.6341552734375
      ],
      "bbox_max": [
        -197.5,
        -2466.5341796875,
        764.4843139648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 197.49998474121094,
      "bbox_min": [
        -200.5,
        -2483.7392578125,
        748.6341552734375
      ],
      "bbox_max": [
        -197.5,
        -2466.5341796875,
        763.96875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5639985799789429,
        -0.8257757425308228
      ],
      "plane_d": -773.2127075195312,
      "bbox_min": [
        -200.5,
        -2483.7392578125,
        748.6341552734375
      ],
      "bbox_max": [
        -197.5,
        -2467.056884765625,
        760.0280151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 217.49998474121094,
      "bbox_min": [
        -220.5,
        -2486.43408203125,
        750.993408203125
      ],
      "bbox_max": [
        -217.5,
        -2469.98828125,
        766.3409423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5639985799789429,
        0.8257757425308228
      ],
      "plane_d": 769.4562377929688,
      "bbox_min": [
        -220.5,
        -2486.43408203125,
        750.993408203125
      ],
      "bbox_max": [
        -217.5,
        -2469.98828125,
        766.3409423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -220.49998474121094,
      "bbox_min": [
        -220.5,
        -2486.43408203125,
        750.993408203125
      ],
      "bbox_max": [
        -217.5,
        -2470.506591796875,
        766.2639770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5639985799789429,
        -0.8257757425308228
      ],
      "plane_d": -773.2127075195312,
      "bbox_min": [
        -220.5,
        -2486.43408203125,
        750.993408203125
      ],
      "bbox_max": [
        -217.5,
        -2470.51123046875,
        761.86865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5384513735771179,
        -0.8420933485031128,
        0.03080403432250023
      ],
      "plane_d": -2256.63623046875,
      "bbox_min": [
        -378.3916931152344,
        -2490.66552734375,
        402.36541748046875
      ],
      "bbox_max": [
        -264.0294494628906,
        -2421.510009765625,
        717.7734985351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.430268257856369,
        -0.8978968262672424,
        0.09300856292247772
      ],
      "plane_d": -2403.1669921875,
      "bbox_min": [
        -315.125,
        -2489.113037109375,
        583.2484130859375
      ],
      "bbox_max": [
        -264.0294494628906,
        -2452.5625,
        717.7734985351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2806796431541443,
        -0.9589745998382568,
        0.03983548656105995
      ],
      "plane_d": -2351.9248046875,
      "bbox_min": [
        -212.66876220703125,
        -2502.74169921875,
        150.0
      ],
      "bbox_max": [
        -126.83592987060547,
        -2466.746337890625,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -782.5,
      "bbox_min": [
        -212.66876220703125,
        -2489.051025390625,
        759.5125732421875
      ],
      "bbox_max": [
        -137.0,
        -2466.746337890625,
        804.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        -212.35694885253906,
        -2489.051025390625,
        759.5125732421875
      ],
      "bbox_max": [
        -137.0,
        -2466.746337890625,
        782.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -145.0,
      "bbox_min": [
        -197.0,
        -2488.74560546875,
        780.0
      ],
      "bbox_max": [
        -145.0,
        -2468.80078125,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 162.0,
      "bbox_min": [
        -197.0,
        -2488.096923828125,
        780.0
      ],
      "bbox_max": [
        -162.0,
        -2473.16650390625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -189.5,
      "bbox_min": [
        -197.0,
        -2487.04736328125,
        780.0
      ],
      "bbox_max": [
        -189.5,
        -2480.228759765625,
        782.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -192.99998474121094,
      "bbox_min": [
        -197.0,
        -2486.913818359375,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2481.12744140625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.0,
      "bbox_min": [
        -197.0,
        -2486.86376953125,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2481.142822265625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -2486.787109375,
        782.0
      ],
      "bbox_max": [
        -195.0,
        -2481.641357421875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 781.0,
      "bbox_min": [
        -197.0,
        -2486.850341796875,
        780.0
      ],
      "bbox_max": [
        -194.0,
        -2481.414794921875,
        781.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -781.5,
      "bbox_min": [
        -196.0,
        -2486.850341796875,
        781.0
      ],
      "bbox_max": [
        -194.0,
        -2481.414794921875,
        781.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 194.0,
      "bbox_min": [
        -196.0,
        -2486.850341796875,
        781.0
      ],
      "bbox_max": [
        -194.0,
        -2481.414794921875,
        781.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -196.0,
      "bbox_min": [
        -196.0,
        -2486.774169921875,
        781.0
      ],
      "bbox_max": [
        -196.0,
        -2481.928466796875,
        781.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.5,
      "bbox_min": [
        -197.0,
        -2486.837158203125,
        780.0
      ],
      "bbox_max": [
        -195.0,
        -2481.702392578125,
        780.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        -197.0,
        -2486.837158203125,
        780.0
      ],
      "bbox_max": [
        -195.0,
        -2481.702392578125,
        780.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -197.0,
      "bbox_min": [
        -197.0,
        -2486.760986328125,
        780.0
      ],
      "bbox_max": [
        -197.0,
        -2482.216064453125,
        780.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.5,
      "bbox_min": [
        -212.33071899414062,
        -2487.1845703125,
        759.5125732421875
      ],
      "bbox_max": [
        -189.5,
        -2480.304931640625,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 189.5,
      "bbox_min": [
        -189.5,
        -2487.085205078125,
        778.5
      ],
      "bbox_max": [
        -189.5,
        -2480.304931640625,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.15676754713058472,
        -0.9876355528831482
      ],
      "plane_d": 376.5713195800781,
      "bbox_min": [
        -212.28367614746094,
        -2487.1845703125,
        759.5125732421875
      ],
      "bbox_max": [
        -197.5,
        -2482.436279296875,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.981175422668457,
        -0.19311872124671936,
        0.0
      ],
      "plane_d": -285.5042724609375,
      "bbox_min": [
        -198.48057556152344,
        -2486.8046875,
        775.3392944335938
      ],
      "bbox_max": [
        -197.62074279785156,
        -2482.436279296875,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 197.49998474121094,
      "bbox_min": [
        -200.5,
        -2487.1845703125,
        759.5125732421875
      ],
      "bbox_max": [
        -197.5,
        -2482.8486328125,
        766.8534545898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -200.49998474121094,
      "bbox_min": [
        -200.5,
        -2487.1845703125,
        759.5125732421875
      ],
      "bbox_max": [
        -197.5,
        -2482.8486328125,
        766.8534545898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5639985799789429,
        0.8257757425308228
      ],
      "plane_d": 769.4562377929688,
      "bbox_min": [
        -200.5,
        -2487.1845703125,
        759.5125732421875
      ],
      "bbox_max": [
        -197.5,
        -2482.8486328125,
        766.8534545898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5639985799789429,
        -0.8257757425308228
      ],
      "plane_d": -773.2127075195312,
      "bbox_min": [
        -200.5,
        -2487.1845703125,
        759.5125732421875
      ],
      "bbox_max": [
        -197.5,
        -2482.984619140625,
        762.381103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -797.0,
      "bbox_min": [
        -212.66876220703125,
        -2488.5,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2478.305908203125,
        804.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -212.64161682128906,
        -2486.78369140625,
        790.5
      ],
      "bbox_max": [
        -189.5,
        -2479.98486328125,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 790.5,
      "bbox_min": [
        -193.0,
        -2486.78369140625,
        790.5
      ],
      "bbox_max": [
        -189.5,
        -2479.98486328125,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.0,
      "bbox_min": [
        -194.5,
        -2486.5625,
        794.0
      ],
      "bbox_max": [
        -193.0,
        -2480.776611328125,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -194.5,
      "bbox_min": [
        -194.5,
        -2486.5048828125,
        794.0
      ],
      "bbox_max": [
        -194.5,
        -2481.1162109375,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -164.0,
      "bbox_min": [
        -189.5,
        -2488.5,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2478.305908203125,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 163.10009765625,
      "bbox_min": [
        -164.0,
        -2488.5,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2478.5,
        796.2333374023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2483.0,
      "bbox_min": [
        -164.0,
        -2487.974853515625,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2478.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2478.5,
      "bbox_min": [
        -164.0,
        -2483.0,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2478.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -789.2999877929688,
      "bbox_min": [
        -164.0,
        -2483.0,
        789.2999877929688
      ],
      "bbox_max": [
        -163.10009765625,
        -2478.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 786.5,
      "bbox_min": [
        -163.800048828125,
        -2487.974853515625,
        782.5
      ],
      "bbox_max": [
        -163.300048828125,
        -2483.0,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 163.300048828125,
      "bbox_min": [
        -163.800048828125,
        -2487.884033203125,
        786.5
      ],
      "bbox_max": [
        -163.300048828125,
        -2483.0,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -787.0,
      "bbox_min": [
        -163.800048828125,
        -2487.871337890625,
        786.5
      ],
      "bbox_max": [
        -163.300048828125,
        -2483.0,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -163.800048828125,
      "bbox_min": [
        -163.800048828125,
        -2487.864990234375,
        786.5
      ],
      "bbox_max": [
        -163.800048828125,
        -2483.0,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -163.552490234375,
      "bbox_min": [
        -163.552490234375,
        -2487.974853515625,
        782.5
      ],
      "bbox_max": [
        -163.552490234375,
        -2483.0,
        786.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -785.0,
      "bbox_min": [
        -143.5,
        -2488.5,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2483.5,
        796.2333374023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -2601.12744140625,
      "bbox_min": [
        -143.5,
        -2488.5,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2483.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.0,
        0.3713906705379486
      ],
      "plane_d": -162.0191650390625,
      "bbox_min": [
        -143.5,
        -2488.5,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2483.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2015.258544921875,
      "bbox_min": [
        -143.5,
        -2488.5,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2483.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": -423.849609375,
      "bbox_min": [
        -143.5,
        -2488.5,
        782.5
      ],
      "bbox_max": [
        -142.5,
        -2483.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -142.0,
      "bbox_min": [
        -142.0,
        -2487.0,
        785.0
      ],
      "bbox_max": [
        -140.0,
        -2485.0,
        796.2333374023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2487.0,
      "bbox_min": [
        -142.0,
        -2487.0,
        785.0
      ],
      "bbox_max": [
        -140.0,
        -2485.0,
        796.2333374023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2485.0,
      "bbox_min": [
        -142.0,
        -2487.0,
        785.0
      ],
      "bbox_max": [
        -140.0,
        -2485.0,
        796.0226440429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        -140.0,
        -2487.0,
        785.0
      ],
      "bbox_max": [
        -140.0,
        -2485.0,
        795.94287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 182.0,
      "bbox_min": [
        -189.5,
        -2487.93896484375,
        782.5
      ],
      "bbox_max": [
        -164.5,
        -2478.305908203125,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25766265392303467,
        -0.0,
        0.9662349224090576
      ],
      "plane_d": -719.3297119140625,
      "bbox_min": [
        -189.5,
        -2487.044677734375,
        791.5
      ],
      "bbox_max": [
        -182.0,
        -2478.305908203125,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 791.5,
      "bbox_min": [
        -189.5,
        -2487.044677734375,
        791.5
      ],
      "bbox_max": [
        -182.0,
        -2478.305908203125,
        793.3470458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4705882668495178,
        0.8823530077934265,
        0.0
      ],
      "plane_d": 2273.0,
      "bbox_min": [
        -183.30148315429688,
        -2479.0,
        791.5
      ],
      "bbox_max": [
        -182.0,
        -2478.305908203125,
        793.3470458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -785.0,
      "bbox_min": [
        -169.5,
        -2487.93896484375,
        782.5
      ],
      "bbox_max": [
        -164.5,
        -2483.5,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2015.258544921875,
      "bbox_min": [
        -169.5,
        -2487.93896484375,
        782.5
      ],
      "bbox_max": [
        -164.5,
        -2483.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.0,
        0.3713906705379486
      ],
      "plane_d": -137.87876892089844,
      "bbox_min": [
        -169.5,
        -2487.93896484375,
        782.5
      ],
      "bbox_max": [
        -164.5,
        -2483.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": -447.989990234375,
      "bbox_min": [
        -169.5,
        -2487.8759765625,
        782.5
      ],
      "bbox_max": [
        -165.12408447265625,
        -2483.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -2601.12744140625,
      "bbox_min": [
        -168.72901916503906,
        -2487.8759765625,
        784.0601806640625
      ],
      "bbox_max": [
        -165.12408447265625,
        -2487.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -168.0,
      "bbox_min": [
        -168.0,
        -2487.0,
        785.0
      ],
      "bbox_max": [
        -166.0,
        -2485.0,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2485.0,
      "bbox_min": [
        -168.0,
        -2487.0,
        785.0
      ],
      "bbox_max": [
        -166.0,
        -2485.0,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2487.0,
      "bbox_min": [
        -168.0,
        -2487.0,
        785.0
      ],
      "bbox_max": [
        -166.0,
        -2485.0,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 166.0,
      "bbox_min": [
        -166.0,
        -2487.0,
        785.0
      ],
      "bbox_max": [
        -166.0,
        -2485.0,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7863183617591858,
        0.0,
        0.6178215742111206
      ],
      "plane_d": -652.812744140625,
      "bbox_min": [
        -204.0,
        -2487.0,
        797.0
      ],
      "bbox_max": [
        -166.0,
        -2479.90576171875,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -804.0,
      "bbox_min": [
        -198.5,
        -2486.1943359375,
        804.0
      ],
      "bbox_max": [
        -196.06138610839844,
        -2482.8330078125,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2482.5,
      "bbox_min": [
        -191.5,
        -2486.469482421875,
        797.0
      ],
      "bbox_max": [
        -190.0,
        -2479.90576171875,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -801.5,
      "bbox_min": [
        -191.5,
        -2482.5,
        801.5
      ],
      "bbox_max": [
        -190.5,
        -2479.90576171875,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2484.5,
      "bbox_min": [
        -191.5,
        -2486.469482421875,
        797.0
      ],
      "bbox_max": [
        -190.0,
        -2484.5,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -801.5,
      "bbox_min": [
        -191.5,
        -2486.469482421875,
        801.5
      ],
      "bbox_max": [
        -190.5,
        -2484.5,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -168.0,
      "bbox_min": [
        -168.0,
        -2487.0,
        797.0
      ],
      "bbox_max": [
        -166.0,
        -2485.0,
        800.0094604492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2487.0,
      "bbox_min": [
        -168.0,
        -2487.0,
        797.0
      ],
      "bbox_max": [
        -166.0,
        -2485.0,
        800.0094604492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2485.0,
      "bbox_min": [
        -168.0,
        -2487.0,
        797.0
      ],
      "bbox_max": [
        -166.0,
        -2485.0,
        799.7987060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 166.0,
      "bbox_min": [
        -166.0,
        -2487.0,
        797.0
      ],
      "bbox_max": [
        -166.0,
        -2485.0,
        799.718994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.043660908937454224,
        -0.9987923502922058,
        0.02252989076077938
      ],
      "plane_d": -2507.651123046875,
      "bbox_min": [
        -277.0323181152344,
        -2908.51806640625,
        150.0
      ],
      "bbox_max": [
        832.5137329101562,
        -2485.032470703125,
        833.6973266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.256084680557251,
        0.9662680625915527,
        0.027326710522174835
      ],
      "plane_d": 2474.06640625,
      "bbox_min": [
        -277.0323181152344,
        -2908.51806640625,
        150.0
      ],
      "bbox_max": [
        832.5137329101562,
        -2485.032470703125,
        833.6973266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29478561878204346,
        0.9554215669631958,
        0.016467038542032242
      ],
      "plane_d": 2442.81298828125,
      "bbox_min": [
        -274.07421875,
        -2908.51806640625,
        150.0
      ],
      "bbox_max": [
        832.5137329101562,
        -2518.778076171875,
        833.6973266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9736523628234863,
        -0.03027019277215004,
        0.22601918876171112
      ],
      "plane_d": -345.6151123046875,
      "bbox_min": [
        -274.07421875,
        -2908.51806640625,
        150.0
      ],
      "bbox_max": [
        832.5137329101562,
        -2518.778076171875,
        833.6973266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8282895088195801,
        0.5597261190414429,
        0.02536366507411003
      ],
      "plane_d": 1549.3636474609375,
      "bbox_min": [
        -274.07421875,
        -2908.51806640625,
        150.0
      ],
      "bbox_max": [
        225.14236450195312,
        -2596.603759765625,
        833.6973266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8505732417106628,
        0.5242752432823181,
        0.040749020874500275
      ],
      "plane_d": 1447.7750244140625,
      "bbox_min": [
        -274.07421875,
        -2819.087158203125,
        240.40988159179688
      ],
      "bbox_max": [
        11.735824584960938,
        -2615.420654296875,
        833.6973266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8054807782173157,
        0.5523382425308228,
        0.21476304531097412
      ],
      "plane_d": 1383.29052734375,
      "bbox_min": [
        -274.07421875,
        -2775.635009765625,
        749.8496704101562
      ],
      "bbox_max": [
        -30.098535537719727,
        -2615.420654296875,
        833.6973266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26160192489624023,
        0.9247593879699707,
        0.27637779712677
      ],
      "plane_d": 2175.628173828125,
      "bbox_min": [
        -274.07421875,
        -2731.083740234375,
        749.8496704101562
      ],
      "bbox_max": [
        -126.417724609375,
        -2615.420654296875,
        833.6973266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8277426958084106,
        -0.4763690233230591,
        0.29650387167930603
      ],
      "plane_d": -1684.990478515625,
      "bbox_min": [
        -181.55667114257812,
        -2731.083740234375,
        815.7214965820312
      ],
      "bbox_max": [
        -168.10862731933594,
        -2722.562744140625,
        826.798583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022255789488554,
        -0.9675591588020325,
        0.25166231393814087
      ],
      "plane_d": -2846.35498046875,
      "bbox_min": [
        -181.55667114257812,
        -2725.597900390625,
        815.7214965820312
      ],
      "bbox_max": [
        -172.77281188964844,
        -2722.562744140625,
        826.798583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14437326788902283,
        0.977375328540802,
        0.1545761078596115
      ],
      "plane_d": 2438.747314453125,
      "bbox_min": [
        -274.07421875,
        -2666.8583984375,
        749.8496704101562
      ],
      "bbox_max": [
        -198.81744384765625,
        -2654.277587890625,
        833.6973266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499540239572525,
        0.8658553957939148,
        0.02745842933654785
      ],
      "plane_d": 2413.8603515625,
      "bbox_min": [
        -9.408012390136719,
        -2819.087158203125,
        673.62255859375
      ],
      "bbox_max": [
        11.735822677612305,
        -2808.1181640625,
        810.8114013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5873186588287354,
        0.808143138885498,
        0.04428848996758461
      ],
      "plane_d": 2238.9775390625,
      "bbox_min": [
        -100.3984375,
        -2826.348876953125,
        150.0
      ],
      "bbox_max": [
        39.70861053466797,
        -2626.30078125,
        673.62255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7206773161888123,
        -0.6925857067108154,
        0.03080742061138153
      ],
      "plane_d": -1281.2325439453125,
      "bbox_min": [
        755.5160522460938,
        -2631.5810546875,
        150.0
      ],
      "bbox_max": [
        775.3273315429688,
        -2612.369140625,
        678.1928100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7206773161888123,
        -0.6925857067108154,
        0.03080742061138153
      ],
      "plane_d": -1281.2325439453125,
      "bbox_min": [
        757.5983276367188,
        -2709.53515625,
        150.0
      ],
      "bbox_max": [
        832.5137329101562,
        -2626.5556640625,
        677.7105102539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5424458384513855,
        -0.8393089771270752,
        0.03623468056321144
      ],
      "plane_d": -2253.585693359375,
      "bbox_min": [
        -277.0323181152344,
        -2524.5,
        150.0
      ],
      "bbox_max": [
        -137.0,
        -2485.032470703125,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6707437038421631,
        -0.7391219139099121,
        0.06165841594338417
      ],
      "plane_d": -1717.3441162109375,
      "bbox_min": [
        -246.677001953125,
        -2502.31689453125,
        539.8119506835938
      ],
      "bbox_max": [
        -214.20103454589844,
        -2485.068115234375,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8360707759857178,
        -0.5481618642807007,
        0.022454261779785156
      ],
      "plane_d": -1177.5562744140625,
      "bbox_min": [
        -246.677001953125,
        -2502.31689453125,
        539.8119506835938
      ],
      "bbox_max": [
        -239.92828369140625,
        -2488.814208984375,
        632.4262084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09340238571166992,
        -0.9850569367408752,
        0.14470228552818298
      ],
      "plane_d": -2519.996337890625,
      "bbox_min": [
        -246.677001953125,
        -2502.31689453125,
        539.8119506835938
      ],
      "bbox_max": [
        -239.92828369140625,
        -2488.963623046875,
        626.5665893554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09340238571166992,
        -0.9850569367408752,
        0.14470228552818298
      ],
      "plane_d": -2519.996337890625,
      "bbox_min": [
        -246.677001953125,
        -2502.31689453125,
        539.8119506835938
      ],
      "bbox_max": [
        -214.20103454589844,
        -2485.068115234375,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1828530877828598,
        -0.9755827784538269,
        0.12166771292686462
      ],
      "plane_d": -2461.789306640625,
      "bbox_min": [
        -246.677001953125,
        -2502.31689453125,
        539.8119506835938
      ],
      "bbox_max": [
        -214.20103454589844,
        -2489.7099609375,
        614.1401977539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -229.0,
      "bbox_min": [
        -229.0,
        -2486.786376953125,
        778.5
      ],
      "bbox_max": [
        -226.5,
        -2485.19677734375,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.5,
      "bbox_min": [
        -226.5,
        -2486.496337890625,
        778.5
      ],
      "bbox_max": [
        -224.01219177246094,
        -2485.67333984375,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -226.5,
        -2485.68017578125,
        795.5
      ],
      "bbox_max": [
        -224.8556671142578,
        -2485.24609375,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -229.0,
      "bbox_min": [
        -229.0,
        -2487.22802734375,
        778.5
      ],
      "bbox_max": [
        -225.44155883789062,
        -2485.032470703125,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 226.5,
      "bbox_min": [
        -229.0,
        -2487.22802734375,
        778.5
      ],
      "bbox_max": [
        -226.12477111816406,
        -2485.50048828125,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.5,
      "bbox_min": [
        -229.0,
        -2487.22802734375,
        778.5
      ],
      "bbox_max": [
        -227.49098205566406,
        -2486.063232421875,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -226.5,
        -2485.7900390625,
        795.5
      ],
      "bbox_max": [
        -226.12477111816406,
        -2485.50048828125,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -226.5,
      "bbox_min": [
        -226.5,
        -2485.72802734375,
        797.0
      ],
      "bbox_max": [
        -225.44155883789062,
        -2485.032470703125,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -804.0,
      "bbox_min": [
        -226.5,
        -2485.43701171875,
        804.0
      ],
      "bbox_max": [
        -225.44155883789062,
        -2485.032470703125,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24863126873970032,
        -0.9681477546691895,
        0.029538404196500778
      ],
      "plane_d": -2377.22607421875,
      "bbox_min": [
        -246.677001953125,
        -2524.5,
        405.9115295410156
      ],
      "bbox_max": [
        -137.0,
        -2485.0791015625,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1828530877828598,
        -0.9755827784538269,
        0.12166771292686462
      ],
      "plane_d": -2461.789306640625,
      "bbox_min": [
        -246.677001953125,
        -2502.31689453125,
        539.8119506835938
      ],
      "bbox_max": [
        -208.477294921875,
        -2485.0791015625,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -229.0,
      "bbox_min": [
        -229.0,
        -2490.494873046875,
        761.7916870117188
      ],
      "bbox_max": [
        -212.28367614746094,
        -2485.0791015625,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.5,
      "bbox_min": [
        -229.0,
        -2490.494873046875,
        761.7916870117188
      ],
      "bbox_max": [
        -212.28367614746094,
        -2485.0791015625,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -797.0,
      "bbox_min": [
        -229.0,
        -2489.930419921875,
        780.0
      ],
      "bbox_max": [
        -212.3572235107422,
        -2485.0791015625,
        804.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -226.5,
        -2489.806884765625,
        780.0
      ],
      "bbox_max": [
        -212.3572235107422,
        -2485.308837890625,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -226.5,
        -2489.806884765625,
        780.0
      ],
      "bbox_max": [
        -212.3572235107422,
        -2485.727294921875,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7863183617591858,
        -0.0,
        0.6178215742111206
      ],
      "plane_d": -324.1316833496094,
      "bbox_min": [
        -226.5,
        -2489.288330078125,
        797.0
      ],
      "bbox_max": [
        -214.0,
        -2485.0791015625,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -226.5,
      "bbox_min": [
        -226.5,
        -2489.288330078125,
        797.0
      ],
      "bbox_max": [
        -219.5,
        -2485.0791015625,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -804.0,
      "bbox_min": [
        -226.5,
        -2489.074951171875,
        804.0
      ],
      "bbox_max": [
        -219.5,
        -2485.0791015625,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.15676754713058472,
        -0.9876355528831482
      ],
      "plane_d": 376.5713195800781,
      "bbox_min": [
        -220.5,
        -2488.7705078125,
        761.7916870117188
      ],
      "bbox_max": [
        -212.28367614746094,
        -2485.9150390625,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845619797706604,
        -0.17503629624843597,
        0.0
      ],
      "plane_d": -651.885986328125,
      "bbox_min": [
        -220.15945434570312,
        -2488.189697265625,
        775.8858642578125
      ],
      "bbox_max": [
        -219.75509643554688,
        -2485.9150390625,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -220.49998474121094,
      "bbox_min": [
        -220.5,
        -2488.7705078125,
        761.7916870117188
      ],
      "bbox_max": [
        -217.5,
        -2486.209228515625,
        767.9205932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 217.49998474121094,
      "bbox_min": [
        -220.5,
        -2488.7705078125,
        761.7916870117188
      ],
      "bbox_max": [
        -217.5,
        -2486.209228515625,
        767.9205932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5639985799789429,
        -0.8257757425308228
      ],
      "plane_d": -773.2127075195312,
      "bbox_min": [
        -220.5,
        -2488.7705078125,
        761.7916870117188
      ],
      "bbox_max": [
        -217.5,
        -2486.209228515625,
        767.9205932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5639985799789429,
        0.8257757425308228
      ],
      "plane_d": 769.4562377929688,
      "bbox_min": [
        -220.5,
        -2488.634765625,
        766.2639770507812
      ],
      "bbox_max": [
        -217.5,
        -2486.209228515625,
        767.9205932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -782.5,
      "bbox_min": [
        -229.0,
        -2524.5,
        762.3041381835938
      ],
      "bbox_max": [
        -137.0,
        -2485.736572265625,
        804.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        -229.0,
        -2524.5,
        762.3041381835938
      ],
      "bbox_max": [
        -137.0,
        -2486.175048828125,
        782.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -189.5,
      "bbox_min": [
        -229.0,
        -2524.5,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2486.74853515625,
        782.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2524.5,
      "bbox_min": [
        -189.5,
        -2524.5,
        780.0
      ],
      "bbox_max": [
        -162.0,
        -2524.5,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -145.0,
      "bbox_min": [
        -145.0,
        -2524.5,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2488.68310546875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 137.0,
      "bbox_min": [
        -145.0,
        -2524.5,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2488.98828125,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2524.5,
      "bbox_min": [
        -145.0,
        -2524.5,
        780.0
      ],
      "bbox_max": [
        -137.0,
        -2524.5,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2508.5,
      "bbox_min": [
        -229.0,
        -2508.5,
        780.0
      ],
      "bbox_max": [
        -189.5,
        -2486.74853515625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2506.75,
      "bbox_min": [
        -229.0,
        -2508.5,
        780.0
      ],
      "bbox_max": [
        -189.5,
        -2486.74853515625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1928.6339111328125,
      "bbox_min": [
        -220.75,
        -2508.5,
        780.0
      ],
      "bbox_max": [
        -197.33750915527344,
        -2506.75,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7249994277954102,
        -0.6887494921684265,
        0.0
      ],
      "plane_d": -1583.453125,
      "bbox_min": [
        -199.0,
        -2508.5,
        780.0
      ],
      "bbox_max": [
        -197.33750915527344,
        -2506.75,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7302684187889099,
        0.6831603646278381,
        1.873556357168127e-05
      ],
      "plane_d": 1566.2613525390625,
      "bbox_min": [
        -229.0,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -189.5,
        -2486.74853515625,
        782.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7249994277954102,
        -0.6887494921684265,
        0.0
      ],
      "plane_d": -1583.453125,
      "bbox_min": [
        -197.33750915527344,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -189.5,
        -2498.5,
        782.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -192.99998474121094,
      "bbox_min": [
        -229.0,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2486.74853515625,
        782.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -197.0,
      "bbox_min": [
        -229.0,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2486.74853515625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -781.5,
      "bbox_min": [
        -197.0,
        -2494.0,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2486.74853515625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 781.0,
      "bbox_min": [
        -197.0,
        -2494.0,
        780.0
      ],
      "bbox_max": [
        -194.0,
        -2486.74853515625,
        781.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -196.0,
      "bbox_min": [
        -196.0,
        -2494.0,
        781.0
      ],
      "bbox_max": [
        -194.0,
        -2486.761474609375,
        781.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 194.0,
      "bbox_min": [
        -196.0,
        -2494.0,
        781.0
      ],
      "bbox_max": [
        -194.0,
        -2486.837646484375,
        781.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2494.0,
      "bbox_min": [
        -196.0,
        -2494.0,
        781.0
      ],
      "bbox_max": [
        -194.0,
        -2494.0,
        781.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.5,
      "bbox_min": [
        -197.0,
        -2494.0,
        780.0
      ],
      "bbox_max": [
        -195.0,
        -2486.74853515625,
        780.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        -197.0,
        -2494.0,
        780.0
      ],
      "bbox_max": [
        -195.0,
        -2486.82470703125,
        780.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2494.0,
      "bbox_min": [
        -197.0,
        -2494.0,
        780.0
      ],
      "bbox_max": [
        -195.0,
        -2494.0,
        780.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 782.0,
      "bbox_min": [
        -195.0,
        -2494.0,
        782.0
      ],
      "bbox_max": [
        -193.0,
        -2486.774658203125,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -2494.0,
        782.0
      ],
      "bbox_max": [
        -193.0,
        -2486.774658203125,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2494.0,
      "bbox_min": [
        -195.0,
        -2494.0,
        782.0
      ],
      "bbox_max": [
        -193.0,
        -2494.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1928.6339111328125,
      "bbox_min": [
        -229.0,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -202.800048828125,
        -2489.730712890625,
        782.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 226.5,
      "bbox_min": [
        -226.5,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -202.800048828125,
        -2489.730712890625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.18855784833431244,
        0.9820621609687805
      ],
      "plane_d": -295.1087951660156,
      "bbox_min": [
        -215.199951171875,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -202.800048828125,
        -2500.5,
        781.7999877929688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2500.5,
      "bbox_min": [
        -213.0,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -202.800048828125,
        -2500.5,
        781.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9432709813117981,
        0.3320240080356598,
        0.0
      ],
      "plane_d": 1023.5966186523438,
      "bbox_min": [
        -205.0,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -202.800048828125,
        -2500.5,
        781.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7313312292098999,
        0.6820225119590759,
        0.0
      ],
      "plane_d": 1539.7666015625,
      "bbox_min": [
        -225.618408203125,
        -2502.305908203125,
        780.0
      ],
      "bbox_max": [
        -222.34385681152344,
        -2499.1826171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6820065379142761,
        0.7313461899757385,
        0.0
      ],
      "plane_d": 1979.729736328125,
      "bbox_min": [
        -225.24974060058594,
        -2501.931396484375,
        780.0
      ],
      "bbox_max": [
        -221.777587890625,
        -2498.514404296875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.986820638179779,
        -0.161818265914917,
        0.0
      ],
      "plane_d": -185.71542358398438,
      "bbox_min": [
        -225.24974060058594,
        -2501.931396484375,
        780.0
      ],
      "bbox_max": [
        -221.777587890625,
        -2498.846435546875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7313312292098999,
        -0.6820225119590759,
        0.0
      ],
      "plane_d": -1543.7664794921875,
      "bbox_min": [
        -225.24974060058594,
        -2501.931396484375,
        780.0
      ],
      "bbox_max": [
        -222.010986328125,
        -2498.846435546875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2493.10009765625,
      "bbox_min": [
        -226.5,
        -2496.5,
        780.0
      ],
      "bbox_max": [
        -224.60009765625,
        -2493.10009765625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2496.5,
      "bbox_min": [
        -226.5,
        -2496.5,
        780.0
      ],
      "bbox_max": [
        -224.60009765625,
        -2496.5,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.5,
      "bbox_min": [
        -229.0,
        -2508.5,
        762.3041381835938
      ],
      "bbox_max": [
        -189.5,
        -2486.214111328125,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1928.6339111328125,
      "bbox_min": [
        -229.0,
        -2508.5,
        778.5
      ],
      "bbox_max": [
        -189.5,
        -2487.04736328125,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7249994277954102,
        -0.6887494921684265,
        0.0
      ],
      "plane_d": -1583.453125,
      "bbox_min": [
        -229.0,
        -2508.5,
        778.5
      ],
      "bbox_max": [
        -189.5,
        -2487.04736328125,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 189.5,
      "bbox_min": [
        -229.0,
        -2498.5,
        778.5
      ],
      "bbox_max": [
        -189.5,
        -2487.04736328125,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -229.0,
      "bbox_min": [
        -229.0,
        -2498.5,
        778.5
      ],
      "bbox_max": [
        -229.0,
        -2490.44921875,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 197.49998474121094,
      "bbox_min": [
        -221.0,
        -2502.5,
        762.3041381835938
      ],
      "bbox_max": [
        -197.0,
        -2486.280029296875,
        778.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2493.0,
      "bbox_min": [
        -221.0,
        -2502.5,
        762.3041381835938
      ],
      "bbox_max": [
        -197.5,
        -2486.280029296875,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.15676754713058472,
        -0.9876355528831482
      ],
      "plane_d": 376.5713195800781,
      "bbox_min": [
        -220.5,
        -2493.0,
        762.3041381835938
      ],
      "bbox_max": [
        -197.5,
        -2486.280029296875,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845619797706604,
        -0.17503629624843597,
        0.0
      ],
      "plane_d": -651.885986328125,
      "bbox_min": [
        -219.76681518554688,
        -2493.0,
        776.2364501953125
      ],
      "bbox_max": [
        -218.89990234375,
        -2488.12353515625,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -200.49998474121094,
      "bbox_min": [
        -220.5,
        -2493.0,
        762.3041381835938
      ],
      "bbox_max": [
        -197.5,
        -2486.95947265625,
        770.902099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5639985799789429,
        0.8257757425308228
      ],
      "plane_d": 769.4562377929688,
      "bbox_min": [
        -200.5,
        -2493.0,
        766.7764892578125
      ],
      "bbox_max": [
        -197.5,
        -2486.95947265625,
        770.902099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 217.49998474121094,
      "bbox_min": [
        -220.5,
        -2493.0,
        762.9490966796875
      ],
      "bbox_max": [
        -217.5,
        -2487.880126953125,
        770.9020385742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -220.49998474121094,
      "bbox_min": [
        -220.5,
        -2493.0,
        763.46435546875
      ],
      "bbox_max": [
        -217.5,
        -2487.880126953125,
        770.9020385742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5639985799789429,
        0.8257757425308228
      ],
      "plane_d": 769.4562377929688,
      "bbox_min": [
        -220.5,
        -2493.0,
        767.4052124023438
      ],
      "bbox_max": [
        -217.5,
        -2487.880126953125,
        770.9020385742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 217.0,
      "bbox_min": [
        -221.0,
        -2502.5,
        766.3530883789062
      ],
      "bbox_max": [
        -197.5,
        -2493.0,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -221.0,
      "bbox_min": [
        -221.0,
        -2502.5,
        766.3530883789062
      ],
      "bbox_max": [
        -217.0,
        -2493.0,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2502.5,
      "bbox_min": [
        -221.0,
        -2502.5,
        766.3530883789062
      ],
      "bbox_max": [
        -217.0,
        -2493.0,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 775.9999389648438,
      "bbox_min": [
        -221.0,
        -2502.5,
        766.3530883789062
      ],
      "bbox_max": [
        -217.0,
        -2493.0,
        778.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2498.5,
      "bbox_min": [
        -221.0,
        -2498.5,
        776.0
      ],
      "bbox_max": [
        -217.0,
        -2498.5,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 217.49998474121094,
      "bbox_min": [
        -220.5,
        -2502.0,
        766.3530883789062
      ],
      "bbox_max": [
        -217.5,
        -2493.0,
        776.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -220.49998474121094,
      "bbox_min": [
        -220.5,
        -2502.0,
        766.3530883789062
      ],
      "bbox_max": [
        -217.5,
        -2493.0,
        776.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5639985799789429,
        0.8257757425308228
      ],
      "plane_d": 769.4562377929688,
      "bbox_min": [
        -220.5,
        -2502.0,
        770.9020385742188
      ],
      "bbox_max": [
        -217.5,
        -2493.0,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2502.0,
      "bbox_min": [
        -220.5,
        -2502.0,
        772.5
      ],
      "bbox_max": [
        -217.5,
        -2502.0,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2499.0,
      "bbox_min": [
        -220.5,
        -2499.0,
        775.0
      ],
      "bbox_max": [
        -217.5,
        -2499.0,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -201.0,
      "bbox_min": [
        -201.0,
        -2502.5,
        766.3530883789062
      ],
      "bbox_max": [
        -197.5,
        -2493.0,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2502.5,
      "bbox_min": [
        -201.0,
        -2502.5,
        766.3530883789062
      ],
      "bbox_max": [
        -197.5,
        -2493.0,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 775.9999389648438,
      "bbox_min": [
        -201.0,
        -2502.5,
        766.3530883789062
      ],
      "bbox_max": [
        -197.5,
        -2493.0,
        778.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.5639985799789429,
        0.8257757425308228
      ],
      "plane_d": 769.4562377929688,
      "bbox_min": [
        -200.5,
        -2502.0,
        770.9020385742188
      ],
      "bbox_max": [
        -197.5,
        -2493.0,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2502.0,
      "bbox_min": [
        -200.5,
        -2502.0,
        772.5
      ],
      "bbox_max": [
        -197.5,
        -2502.0,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2499.0,
      "bbox_min": [
        -200.5,
        -2499.0,
        775.0
      ],
      "bbox_max": [
        -197.5,
        -2499.0,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 197.0,
      "bbox_min": [
        -197.5,
        -2502.5,
        776.0
      ],
      "bbox_max": [
        -197.0,
        -2498.5,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 775.9999389648438,
      "bbox_min": [
        -197.5,
        -2502.5,
        776.0
      ],
      "bbox_max": [
        -197.0,
        -2498.5,
        778.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2502.5,
      "bbox_min": [
        -197.5,
        -2502.5,
        776.0
      ],
      "bbox_max": [
        -197.0,
        -2498.5,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2498.5,
      "bbox_min": [
        -197.5,
        -2498.5,
        776.0
      ],
      "bbox_max": [
        -197.0,
        -2498.5,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -797.0,
      "bbox_min": [
        -229.0,
        -2523.5,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2485.736572265625,
        804.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -787.0,
      "bbox_min": [
        -188.5,
        -2523.5,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.76025390625,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2523.26025390625,
      "bbox_min": [
        -188.5,
        -2523.5,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.76025390625,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 786.5,
      "bbox_min": [
        -188.5,
        -2523.26025390625,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.76025390625,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -164.0,
      "bbox_min": [
        -188.5,
        -2523.26025390625,
        786.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.76025390625,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 163.10009765625,
      "bbox_min": [
        -163.10009765625,
        -2523.26025390625,
        786.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.76025390625,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -188.5,
      "bbox_min": [
        -188.5,
        -2523.26025390625,
        786.5
      ],
      "bbox_max": [
        -187.60009765625,
        -2522.76025390625,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.60009765625,
      "bbox_min": [
        -187.60009765625,
        -2523.26025390625,
        786.5
      ],
      "bbox_max": [
        -187.60009765625,
        -2522.76025390625,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.00045516141108237207,
        1.0,
        0.0
      ],
      "plane_d": 2522.91455078125,
      "bbox_min": [
        -188.5,
        -2523.26025390625,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.76025390625,
        786.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -164.0,
      "bbox_min": [
        -188.5,
        -2523.26025390625,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.98876953125,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 163.10009765625,
      "bbox_min": [
        -163.10009765625,
        -2523.26025390625,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.98876953125,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.60009765625,
      "bbox_min": [
        -188.5,
        -2523.26025390625,
        782.5
      ],
      "bbox_max": [
        -187.60009765625,
        -2523.0,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -188.5,
      "bbox_min": [
        -188.5,
        -2523.26025390625,
        782.5
      ],
      "bbox_max": [
        -188.5,
        -2523.000244140625,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.60009765625,
      "bbox_min": [
        -188.5,
        -2523.000244140625,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.76025390625,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -188.5,
      "bbox_min": [
        -188.5,
        -2523.000244140625,
        782.5
      ],
      "bbox_max": [
        -188.5,
        -2522.76025390625,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -164.0,
      "bbox_min": [
        -164.0,
        -2522.9892578125,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.76025390625,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 163.10009765625,
      "bbox_min": [
        -163.10009765625,
        -2522.98876953125,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.76025390625,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -164.0,
      "bbox_min": [
        -188.5,
        -2523.5,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2523.26025390625,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 163.10009765625,
      "bbox_min": [
        -163.10009765625,
        -2523.5,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2523.26025390625,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -188.5,
      "bbox_min": [
        -188.5,
        -2523.5,
        782.5
      ],
      "bbox_max": [
        -187.60009765625,
        -2523.26025390625,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2523.5,
      "bbox_min": [
        -164.0,
        -2523.5,
        787.0
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.76025390625,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 163.10009765625,
      "bbox_min": [
        -164.0,
        -2523.5,
        787.0
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.76025390625,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -789.2999877929688,
      "bbox_min": [
        -164.0,
        -2523.5,
        789.2999877929688
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.76025390625,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2523.5,
      "bbox_min": [
        -188.5,
        -2523.5,
        787.0
      ],
      "bbox_max": [
        -187.60009765625,
        -2522.76025390625,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -188.5,
      "bbox_min": [
        -188.5,
        -2523.5,
        787.0
      ],
      "bbox_max": [
        -187.60009765625,
        -2522.76025390625,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.60009765625,
      "bbox_min": [
        -188.5,
        -2523.5,
        787.0
      ],
      "bbox_max": [
        -187.60009765625,
        -2522.76025390625,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -789.2999877929688,
      "bbox_min": [
        -188.5,
        -2523.5,
        789.2999877929688
      ],
      "bbox_max": [
        -187.60009765625,
        -2522.76025390625,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -188.300048828125,
      "bbox_min": [
        -229.0,
        -2522.76025390625,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2485.775146484375,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.800048828125,
      "bbox_min": [
        -188.300048828125,
        -2522.76025390625,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2486.724365234375,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -787.0,
      "bbox_min": [
        -188.300048828125,
        -2522.76025390625,
        782.5
      ],
      "bbox_max": [
        -187.800048828125,
        -2486.724365234375,
        794.6799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 786.5,
      "bbox_min": [
        -188.300048828125,
        -2522.5,
        782.5
      ],
      "bbox_max": [
        -187.800048828125,
        -2497.5,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2498.5,
      "bbox_min": [
        -188.300048828125,
        -2522.5,
        786.5
      ],
      "bbox_max": [
        -187.800048828125,
        -2497.5,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2497.5,
      "bbox_min": [
        -188.300048828125,
        -2497.5,
        786.5
      ],
      "bbox_max": [
        -187.800048828125,
        -2497.5,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2522.5,
      "bbox_min": [
        -188.300048828125,
        -2522.5,
        786.5
      ],
      "bbox_max": [
        -187.800048828125,
        -2522.5,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -188.042724609375,
      "bbox_min": [
        -188.300048828125,
        -2522.5,
        782.5
      ],
      "bbox_max": [
        -187.800048828125,
        -2497.5,
        786.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2498.5,
      "bbox_min": [
        -188.042724609375,
        -2522.5,
        782.5
      ],
      "bbox_max": [
        -187.800048828125,
        -2497.5,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2497.5,
      "bbox_min": [
        -188.042724609375,
        -2497.5,
        782.5
      ],
      "bbox_max": [
        -187.800048828125,
        -2497.5,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2522.5,
      "bbox_min": [
        -188.042724609375,
        -2522.5,
        782.5
      ],
      "bbox_max": [
        -187.800048828125,
        -2522.5,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2498.5,
      "bbox_min": [
        -188.300048828125,
        -2522.5,
        782.5
      ],
      "bbox_max": [
        -188.042724609375,
        -2497.5,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2497.5,
      "bbox_min": [
        -188.300048828125,
        -2497.5,
        782.5
      ],
      "bbox_max": [
        -188.042724609375,
        -2497.5,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2522.5,
      "bbox_min": [
        -188.300048828125,
        -2522.5,
        782.5
      ],
      "bbox_max": [
        -188.042724609375,
        -2522.5,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 791.5,
      "bbox_min": [
        -188.300048828125,
        -2522.76025390625,
        787.0
      ],
      "bbox_max": [
        -187.800048828125,
        -2486.724365234375,
        794.6799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25766265392303467,
        -0.0,
        0.9662349224090576
      ],
      "plane_d": -719.3297119140625,
      "bbox_min": [
        -188.300048828125,
        -2497.280029296875,
        791.5
      ],
      "bbox_max": [
        -187.800048828125,
        -2486.724365234375,
        794.6799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": -2044.5205078125,
      "bbox_min": [
        -188.300048828125,
        -2497.280029296875,
        791.5
      ],
      "bbox_max": [
        -187.800048828125,
        -2496.97998046875,
        794.6799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2498.5,
      "bbox_min": [
        -188.300048828125,
        -2522.76025390625,
        787.0
      ],
      "bbox_max": [
        -187.800048828125,
        -2497.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2497.5,
      "bbox_min": [
        -188.300048828125,
        -2498.5,
        787.0
      ],
      "bbox_max": [
        -187.800048828125,
        -2497.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -789.2999877929688,
      "bbox_min": [
        -188.300048828125,
        -2498.5,
        789.2999877929688
      ],
      "bbox_max": [
        -187.800048828125,
        -2497.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2522.5,
      "bbox_min": [
        -188.300048828125,
        -2522.76025390625,
        787.0
      ],
      "bbox_max": [
        -187.800048828125,
        -2522.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -789.2999877929688,
      "bbox_min": [
        -188.300048828125,
        -2522.76025390625,
        789.2999877929688
      ],
      "bbox_max": [
        -187.800048828125,
        -2522.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2511.5,
      "bbox_min": [
        -187.800048828125,
        -2522.76025390625,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2486.746826171875,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 791.5,
      "bbox_min": [
        -187.800048828125,
        -2511.5,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2486.746826171875,
        794.546630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 182.0,
      "bbox_min": [
        -182.0,
        -2493.5,
        791.5
      ],
      "bbox_max": [
        -182.0,
        -2487.007080078125,
        793.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2493.5,
      "bbox_min": [
        -187.800048828125,
        -2511.5,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2487.72900390625,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -164.0,
      "bbox_min": [
        -187.800048828125,
        -2511.5,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2493.5,
        789.2999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2510.5,
      "bbox_min": [
        -164.0,
        -2511.5,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2493.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 163.10009765625,
      "bbox_min": [
        -164.0,
        -2511.5,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2510.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -789.2999877929688,
      "bbox_min": [
        -164.0,
        -2511.5,
        789.2999877929688
      ],
      "bbox_max": [
        -163.10009765625,
        -2510.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 163.10009765625,
      "bbox_min": [
        -164.0,
        -2494.5,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2493.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2494.5,
      "bbox_min": [
        -164.0,
        -2494.5,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2493.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -789.2999877929688,
      "bbox_min": [
        -164.0,
        -2494.5,
        789.2999877929688
      ],
      "bbox_max": [
        -163.10009765625,
        -2493.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.60009765625,
      "bbox_min": [
        -187.800048828125,
        -2498.5,
        782.5
      ],
      "bbox_max": [
        -187.60009765625,
        -2497.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2497.5,
      "bbox_min": [
        -187.800048828125,
        -2498.5,
        782.5
      ],
      "bbox_max": [
        -187.60009765625,
        -2497.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2498.5,
      "bbox_min": [
        -187.800048828125,
        -2498.5,
        782.5
      ],
      "bbox_max": [
        -187.60009765625,
        -2497.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -789.2999877929688,
      "bbox_min": [
        -187.800048828125,
        -2498.5,
        789.2999877929688
      ],
      "bbox_max": [
        -187.60009765625,
        -2497.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -163.800048828125,
      "bbox_min": [
        -169.5,
        -2493.5,
        782.5
      ],
      "bbox_max": [
        -163.300048828125,
        -2487.72900390625,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 786.5,
      "bbox_min": [
        -163.800048828125,
        -2493.5,
        782.5
      ],
      "bbox_max": [
        -163.300048828125,
        -2487.852294921875,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -787.0,
      "bbox_min": [
        -163.800048828125,
        -2493.5,
        786.5
      ],
      "bbox_max": [
        -163.300048828125,
        -2487.852294921875,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 163.300048828125,
      "bbox_min": [
        -163.300048828125,
        -2493.5,
        786.5
      ],
      "bbox_max": [
        -163.300048828125,
        -2487.871337890625,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -163.552490234375,
      "bbox_min": [
        -163.552490234375,
        -2493.5,
        782.5
      ],
      "bbox_max": [
        -163.552490234375,
        -2487.87451171875,
        786.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -2601.12744140625,
      "bbox_min": [
        -169.5,
        -2488.5,
        782.5
      ],
      "bbox_max": [
        -164.5,
        -2487.72900390625,
        784.427490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": -447.989990234375,
      "bbox_min": [
        -169.5,
        -2488.5,
        782.5
      ],
      "bbox_max": [
        -164.5,
        -2487.72900390625,
        784.427490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.0,
        0.3713906705379486
      ],
      "plane_d": -137.87876892089844,
      "bbox_min": [
        -165.12408447265625,
        -2488.5,
        782.5
      ],
      "bbox_max": [
        -164.5,
        -2487.8759765625,
        784.0601806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -164.0,
      "bbox_min": [
        -187.800048828125,
        -2522.76025390625,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2511.5,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 163.10009765625,
      "bbox_min": [
        -164.0,
        -2522.76025390625,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2511.5,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 786.5,
      "bbox_min": [
        -164.0,
        -2522.76025390625,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2511.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -787.0,
      "bbox_min": [
        -164.0,
        -2522.76025390625,
        786.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2511.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -163.800048828125,
      "bbox_min": [
        -164.0,
        -2522.5,
        786.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2511.5,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 163.300048828125,
      "bbox_min": [
        -163.800048828125,
        -2522.5,
        786.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2511.5,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2522.5,
      "bbox_min": [
        -163.800048828125,
        -2522.5,
        786.5
      ],
      "bbox_max": [
        -163.300048828125,
        -2522.5,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2522.5,
      "bbox_min": [
        -163.300048828125,
        -2522.5,
        786.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.5,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2522.5,
      "bbox_min": [
        -164.0,
        -2522.5,
        786.5
      ],
      "bbox_max": [
        -163.800048828125,
        -2522.5,
        787.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2522.5,
      "bbox_min": [
        -164.0,
        -2522.76025390625,
        787.0
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -789.2999877929688,
      "bbox_min": [
        -164.0,
        -2522.76025390625,
        789.2999877929688
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -163.552490234375,
      "bbox_min": [
        -164.0,
        -2522.5,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2511.5,
        786.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2522.5,
      "bbox_min": [
        -163.552490234375,
        -2522.5,
        782.5
      ],
      "bbox_max": [
        -163.10009765625,
        -2522.5,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2522.5,
      "bbox_min": [
        -164.0,
        -2522.5,
        782.5
      ],
      "bbox_max": [
        -163.552490234375,
        -2522.5,
        786.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": -423.849609375,
      "bbox_min": [
        -143.5,
        -2521.5,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2516.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.0,
        0.3713906705379486
      ],
      "plane_d": -162.0191650390625,
      "bbox_min": [
        -143.5,
        -2521.5,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2516.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -2631.767333984375,
      "bbox_min": [
        -143.5,
        -2521.5,
        782.5
      ],
      "bbox_max": [
        -138.5,
        -2520.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -142.0,
      "bbox_min": [
        -142.0,
        -2520.0,
        785.0
      ],
      "bbox_max": [
        -140.0,
        -2518.0,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2518.0,
      "bbox_min": [
        -142.0,
        -2520.0,
        785.0
      ],
      "bbox_max": [
        -140.0,
        -2518.0,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2520.0,
      "bbox_min": [
        -142.0,
        -2520.0,
        785.0
      ],
      "bbox_max": [
        -140.0,
        -2518.0,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        -140.0,
        -2520.0,
        785.0
      ],
      "bbox_max": [
        -140.0,
        -2518.0,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.60009765625,
      "bbox_min": [
        -187.800048828125,
        -2522.76025390625,
        782.5
      ],
      "bbox_max": [
        -164.5,
        -2516.5,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2522.5,
      "bbox_min": [
        -187.800048828125,
        -2522.76025390625,
        782.5
      ],
      "bbox_max": [
        -187.60009765625,
        -2522.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -789.2999877929688,
      "bbox_min": [
        -187.800048828125,
        -2522.76025390625,
        789.2999877929688
      ],
      "bbox_max": [
        -187.60009765625,
        -2522.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": -447.989990234375,
      "bbox_min": [
        -169.5,
        -2521.5,
        782.5
      ],
      "bbox_max": [
        -164.5,
        -2516.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2045.8984375,
      "bbox_min": [
        -169.5,
        -2521.5,
        782.5
      ],
      "bbox_max": [
        -164.5,
        -2516.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -2631.767333984375,
      "bbox_min": [
        -169.5,
        -2521.5,
        782.5
      ],
      "bbox_max": [
        -164.5,
        -2516.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.0,
        0.3713906705379486
      ],
      "plane_d": -137.87876892089844,
      "bbox_min": [
        -165.5,
        -2521.5,
        782.5
      ],
      "bbox_max": [
        -164.5,
        -2516.5,
        785.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -168.0,
      "bbox_min": [
        -168.0,
        -2520.0,
        785.0
      ],
      "bbox_max": [
        -166.0,
        -2518.0,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2518.0,
      "bbox_min": [
        -168.0,
        -2520.0,
        785.0
      ],
      "bbox_max": [
        -166.0,
        -2518.0,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2520.0,
      "bbox_min": [
        -168.0,
        -2520.0,
        785.0
      ],
      "bbox_max": [
        -166.0,
        -2518.0,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 166.0,
      "bbox_min": [
        -166.0,
        -2520.0,
        785.0
      ],
      "bbox_max": [
        -166.0,
        -2518.0,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5144957900047302,
        0.8574929237365723
      ],
      "plane_d": -1968.8896484375,
      "bbox_min": [
        -229.0,
        -2522.76025390625,
        782.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2485.775146484375,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -229.0,
        -2522.666748046875,
        782.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2485.775146484375,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 189.5,
      "bbox_min": [
        -229.0,
        -2501.0,
        795.5
      ],
      "bbox_max": [
        -189.5,
        -2486.62060546875,
        797.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1928.6337890625,
      "bbox_min": [
        -229.0,
        -2501.0,
        795.5
      ],
      "bbox_max": [
        -189.5,
        -2498.5,
        797.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7250016331672668,
        -0.6887471675872803,
        -5.527531811821973e-06
      ],
      "plane_d": -1583.442626953125,
      "bbox_min": [
        -191.875,
        -2501.0,
        795.5
      ],
      "bbox_max": [
        -189.5,
        -2498.5,
        797.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.01624949462711811,
        0.5443580746650696,
        -0.8386954665184021
      ],
      "plane_d": 2030.669189453125,
      "bbox_min": [
        -229.0,
        -2522.666748046875,
        782.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2486.46728515625,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2508.5,
      "bbox_min": [
        -229.0,
        -2522.666748046875,
        782.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2498.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7250016331672668,
        -0.6887471675872803,
        -5.527531811821973e-06
      ],
      "plane_d": -1583.442626953125,
      "bbox_min": [
        -229.0,
        -2508.5,
        789.0
      ],
      "bbox_max": [
        -190.0582733154297,
        -2498.5,
        795.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1928.6337890625,
      "bbox_min": [
        -229.0,
        -2508.5,
        789.0
      ],
      "bbox_max": [
        -210.2396697998047,
        -2498.5,
        795.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 789.0,
      "bbox_min": [
        -219.26951599121094,
        -2508.5,
        789.0
      ],
      "bbox_max": [
        -210.2396697998047,
        -2508.23046875,
        789.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2522.5,
      "bbox_min": [
        -188.5,
        -2522.666748046875,
        782.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2522.5,
        782.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -188.5,
      "bbox_min": [
        -188.5,
        -2522.666748046875,
        782.5
      ],
      "bbox_max": [
        -188.5,
        -2522.5,
        782.5999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5787469744682312,
        -0.8155071139335632
      ],
      "plane_d": 2095.0244140625,
      "bbox_min": [
        -229.0,
        -2508.5,
        782.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2486.46728515625,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 789.0,
      "bbox_min": [
        -219.9058380126953,
        -2508.5,
        789.0
      ],
      "bbox_max": [
        -189.97491455078125,
        -2499.0,
        795.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7250016331672668,
        -0.6887471675872803,
        -5.527531811821973e-06
      ],
      "plane_d": -1583.442626953125,
      "bbox_min": [
        -219.9058380126953,
        -2508.5,
        789.0
      ],
      "bbox_max": [
        -189.97491455078125,
        -2499.0,
        795.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2508.5,
      "bbox_min": [
        -219.9058380126953,
        -2508.5,
        789.0
      ],
      "bbox_max": [
        -199.0,
        -2507.59423828125,
        789.400634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1928.6337890625,
      "bbox_min": [
        -219.9058380126953,
        -2508.23046875,
        789.0
      ],
      "bbox_max": [
        -219.26951599121094,
        -2507.59423828125,
        789.400634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 226.5,
      "bbox_min": [
        -229.0,
        -2508.15869140625,
        782.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2486.46728515625,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1928.6339111328125,
      "bbox_min": [
        -229.0,
        -2501.000244140625,
        782.5
      ],
      "bbox_max": [
        -226.5,
        -2498.5,
        795.126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 189.5,
      "bbox_min": [
        -226.5,
        -2508.15869140625,
        782.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2486.46728515625,
        795.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2493.999755859375,
      "bbox_min": [
        -226.5,
        -2508.15869140625,
        782.5
      ],
      "bbox_max": [
        -189.5,
        -2486.46728515625,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7249979972839355,
        -0.6887510418891907,
        0.0
      ],
      "plane_d": -1583.4573974609375,
      "bbox_min": [
        -226.5,
        -2508.15869140625,
        782.5
      ],
      "bbox_max": [
        -189.5,
        -2494.0,
        795.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2506.75,
      "bbox_min": [
        -226.5,
        -2508.15869140625,
        782.5
      ],
      "bbox_max": [
        -189.5,
        -2494.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 789.0,
      "bbox_min": [
        -220.75009155273438,
        -2508.15869140625,
        789.0
      ],
      "bbox_max": [
        -197.33753967285156,
        -2506.75,
        789.9322509765625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1928.6337890625,
      "bbox_min": [
        -220.75009155273438,
        -2508.15869140625,
        789.0
      ],
      "bbox_max": [
        -219.3412322998047,
        -2506.75,
        789.9322509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -192.99998474121094,
      "bbox_min": [
        -226.5,
        -2506.75,
        782.5
      ],
      "bbox_max": [
        -189.5,
        -2494.0,
        795.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2496.0,
      "bbox_min": [
        -193.0,
        -2496.0,
        785.5
      ],
      "bbox_max": [
        -189.5,
        -2496.0,
        787.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -2495.499755859375,
      "bbox_min": [
        -226.5,
        -2506.75,
        782.5
      ],
      "bbox_max": [
        -193.0,
        -2494.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.5,
      "bbox_min": [
        -226.5,
        -2495.5,
        782.5
      ],
      "bbox_max": [
        -193.0,
        -2494.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": 405.87933349609375,
      "bbox_min": [
        -225.00006103515625,
        -2495.5,
        794.5
      ],
      "bbox_max": [
        -194.5,
        -2494.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 702.1571044921875,
      "bbox_min": [
        -198.5,
        -2495.5,
        794.5
      ],
      "bbox_max": [
        -194.5,
        -2494.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -194.5,
      "bbox_min": [
        -194.5,
        -2495.5,
        794.5
      ],
      "bbox_max": [
        -194.5,
        -2494.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 503.968017578125,
      "bbox_min": [
        -225.00006103515625,
        -2495.5,
        794.5
      ],
      "bbox_max": [
        -224.60009765625,
        -2494.0,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 503.968017578125,
      "bbox_min": [
        -226.5,
        -2495.5,
        782.5
      ],
      "bbox_max": [
        -193.0,
        -2494.0,
        794.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 792.4999389648438,
      "bbox_min": [
        -226.5,
        -2495.5,
        792.4999389648438
      ],
      "bbox_max": [
        -225.800048828125,
        -2494.0,
        792.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.0,
      "bbox_min": [
        -226.5,
        -2495.5,
        782.5
      ],
      "bbox_max": [
        -193.0,
        -2494.0,
        794.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -194.5,
      "bbox_min": [
        -194.5,
        -2495.5,
        794.0
      ],
      "bbox_max": [
        -194.5,
        -2494.0,
        794.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -783.0,
      "bbox_min": [
        -226.5,
        -2495.5,
        782.5
      ],
      "bbox_max": [
        -225.6000518798828,
        -2494.0,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        -0.0,
        0.3713776469230652
      ],
      "plane_d": -81.13743591308594,
      "bbox_min": [
        -225.800048828125,
        -2495.5,
        782.5
      ],
      "bbox_max": [
        -225.6000518798828,
        -2494.0,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7302743196487427,
        0.6831540465354919,
        0.0
      ],
      "plane_d": 1566.2589111328125,
      "bbox_min": [
        -226.5,
        -2506.75,
        782.5
      ],
      "bbox_max": [
        -193.0,
        -2495.5,
        795.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 789.0,
      "bbox_min": [
        -200.25,
        -2506.75,
        789.0
      ],
      "bbox_max": [
        -195.192138671875,
        -2502.927490234375,
        789.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.726024866104126,
        -0.6876684427261353,
        0.0
      ],
      "plane_d": -1560.1329345703125,
      "bbox_min": [
        -223.162109375,
        -2506.75,
        782.5
      ],
      "bbox_max": [
        -217.25,
        -2502.660400390625,
        789.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 789.0,
      "bbox_min": [
        -223.162109375,
        -2506.75,
        789.0
      ],
      "bbox_max": [
        -217.25,
        -2502.660400390625,
        789.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6820065379142761,
        0.7313461899757385,
        0.0
      ],
      "plane_d": 1979.729736328125,
      "bbox_min": [
        -225.2498321533203,
        -2501.931396484375,
        782.5
      ],
      "bbox_max": [
        -221.777587890625,
        -2498.514404296875,
        792.0631103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7313312292098999,
        0.6820225119590759,
        0.0
      ],
      "plane_d": 1539.7666015625,
      "bbox_min": [
        -225.2498321533203,
        -2499.1826171875,
        782.5
      ],
      "bbox_max": [
        -224.936279296875,
        -2498.846435546875,
        792.0631103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 792.4999389648438,
      "bbox_min": [
        -226.5,
        -2496.5,
        792.4999389648438
      ],
      "bbox_max": [
        -225.800048828125,
        -2495.5,
        792.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -783.0,
      "bbox_min": [
        -226.5,
        -2496.5,
        782.5
      ],
      "bbox_max": [
        -225.6000518798828,
        -2495.5,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        -0.0,
        0.3713776469230652
      ],
      "plane_d": -81.13743591308594,
      "bbox_min": [
        -226.5,
        -2496.5,
        782.5
      ],
      "bbox_max": [
        -225.6000518798828,
        -2495.5,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2496.5,
      "bbox_min": [
        -226.5,
        -2496.5,
        782.5
      ],
      "bbox_max": [
        -225.6000518798828,
        -2496.5,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32006049156188965,
        0.7540068626403809,
        -0.5736156702041626
      ],
      "plane_d": 2273.6181640625,
      "bbox_min": [
        -218.885986328125,
        -2504.67236328125,
        787.7225952148438
      ],
      "bbox_max": [
        -193.0,
        -2495.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13979671895503998,
        0.3293367922306061,
        0.9338063597679138
      ],
      "plane_d": 56.2548828125,
      "bbox_min": [
        -204.582275390625,
        -2504.67236328125,
        787.7225952148438
      ],
      "bbox_max": [
        -193.0,
        -2495.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2792888283729553,
        -0.6579123139381409,
        -0.6993920207023621
      ],
      "plane_d": -1038.661865234375,
      "bbox_min": [
        -204.582275390625,
        -2504.67236328125,
        787.7225952148438
      ],
      "bbox_max": [
        -199.114013671875,
        -2498.9013671875,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32004275918006897,
        -0.7540329098701477,
        0.5735914707183838
      ],
      "plane_d": -2276.86767578125,
      "bbox_min": [
        -204.582275390625,
        -2504.67236328125,
        787.7225952148438
      ],
      "bbox_max": [
        -199.114013671875,
        -2498.9013671875,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9205074906349182,
        0.39072492718696594,
        -0.00012679665815085173
      ],
      "plane_d": 1161.4134521484375,
      "bbox_min": [
        -204.582275390625,
        -2504.67236328125,
        787.7225952148438
      ],
      "bbox_max": [
        -199.114013671875,
        -2498.9013671875,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9204936623573303,
        -0.39075762033462524,
        -3.9387759898090735e-05
      ],
      "plane_d": -1165.3609619140625,
      "bbox_min": [
        -204.582275390625,
        -2504.67236328125,
        787.7225952148438
      ],
      "bbox_max": [
        -202.7958984375,
        -2500.46435546875,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -194.89990234375,
      "bbox_min": [
        -194.89990234375,
        -2498.5,
        793.5999755859375
      ],
      "bbox_max": [
        -193.0,
        -2495.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 793.5999755859375,
      "bbox_min": [
        -194.89990234375,
        -2498.5,
        793.5999755859375
      ],
      "bbox_max": [
        -193.0,
        -2495.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2498.5,
      "bbox_min": [
        -194.89990234375,
        -2498.5,
        793.5999755859375
      ],
      "bbox_max": [
        -193.0,
        -2495.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2496.5,
      "bbox_min": [
        -194.89990234375,
        -2496.5,
        793.5999755859375
      ],
      "bbox_max": [
        -193.0,
        -2495.5,
        795.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -194.5,
      "bbox_min": [
        -194.5,
        -2496.5,
        794.0
      ],
      "bbox_max": [
        -193.0,
        -2495.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.0,
      "bbox_min": [
        -194.5,
        -2496.5,
        794.0
      ],
      "bbox_max": [
        -193.0,
        -2495.5,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3200828433036804,
        0.7540095448493958,
        -0.573599636554718
      ],
      "plane_d": 2407.25146484375,
      "bbox_min": [
        -218.885986328125,
        -2504.472412109375,
        787.7225952148438
      ],
      "bbox_max": [
        -213.417724609375,
        -2498.701416015625,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13979671895503998,
        0.3293367922306061,
        0.9338063597679138
      ],
      "plane_d": 114.62408447265625,
      "bbox_min": [
        -218.885986328125,
        -2504.472412109375,
        787.7225952148438
      ],
      "bbox_max": [
        -213.417724609375,
        -2498.701416015625,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27923837304115295,
        -0.6578962206840515,
        -0.6994273662567139
      ],
      "plane_d": -1155.1939697265625,
      "bbox_min": [
        -218.885986328125,
        -2504.472412109375,
        787.7225952148438
      ],
      "bbox_max": [
        -213.417724609375,
        -2498.701416015625,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3200579881668091,
        -0.7540009617805481,
        0.573624849319458
      ],
      "plane_d": -2410.4443359375,
      "bbox_min": [
        -218.885986328125,
        -2504.472412109375,
        787.7225952148438
      ],
      "bbox_max": [
        -213.417724609375,
        -2498.701416015625,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9205191135406494,
        0.39069756865501404,
        1.6525180399185047e-05
      ],
      "plane_d": 776.37890625,
      "bbox_min": [
        -218.885986328125,
        -2504.472412109375,
        787.7225952148438
      ],
      "bbox_max": [
        -213.417724609375,
        -2498.701416015625,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9204896688461304,
        -0.3907667100429535,
        8.278946552309208e-06
      ],
      "plane_d": -780.5778198242188,
      "bbox_min": [
        -215.2041015625,
        -2504.472412109375,
        787.7225952148438
      ],
      "bbox_max": [
        -213.417724609375,
        -2500.264404296875,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -192.99998474121094,
      "bbox_min": [
        -226.5,
        -2494.0,
        782.5
      ],
      "bbox_max": [
        -189.5,
        -2486.46728515625,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 790.5,
      "bbox_min": [
        -193.0,
        -2494.0,
        790.5
      ],
      "bbox_max": [
        -189.5,
        -2486.650390625,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -194.5,
      "bbox_min": [
        -226.5,
        -2494.0,
        782.5
      ],
      "bbox_max": [
        -193.0,
        -2486.46728515625,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.0,
      "bbox_min": [
        -194.5,
        -2494.0,
        794.0
      ],
      "bbox_max": [
        -193.0,
        -2486.5048828125,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 503.968017578125,
      "bbox_min": [
        -226.5,
        -2494.0,
        782.5
      ],
      "bbox_max": [
        -224.60009765625,
        -2493.10009765625,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2493.10009765625,
      "bbox_min": [
        -226.5,
        -2494.0,
        792.4999389648438
      ],
      "bbox_max": [
        -224.60009765625,
        -2493.10009765625,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 792.4999389648438,
      "bbox_min": [
        -226.5,
        -2494.0,
        792.4999389648438
      ],
      "bbox_max": [
        -225.800048828125,
        -2493.10009765625,
        792.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -783.0,
      "bbox_min": [
        -226.5,
        -2494.0,
        782.5
      ],
      "bbox_max": [
        -225.6000518798828,
        -2493.10009765625,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        -0.0,
        0.3713776469230652
      ],
      "plane_d": -81.13743591308594,
      "bbox_min": [
        -226.5,
        -2494.0,
        782.5
      ],
      "bbox_max": [
        -225.6000518798828,
        -2493.10009765625,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2493.10009765625,
      "bbox_min": [
        -226.5,
        -2493.10009765625,
        782.5
      ],
      "bbox_max": [
        -225.6000518798828,
        -2493.10009765625,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 791.5,
      "bbox_min": [
        -189.5,
        -2498.5,
        782.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2486.670654296875,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25766265392303467,
        -0.0,
        0.9662349224090576
      ],
      "plane_d": -719.3297119140625,
      "bbox_min": [
        -189.5,
        -2498.0,
        791.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2486.670654296875,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": -2044.5205078125,
      "bbox_min": [
        -189.5,
        -2498.0,
        791.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2497.280029296875,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -188.5,
      "bbox_min": [
        -188.5,
        -2498.5,
        782.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2497.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2497.5,
      "bbox_min": [
        -188.5,
        -2498.5,
        782.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2497.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2498.5,
      "bbox_min": [
        -188.5,
        -2498.5,
        782.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2497.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -789.2999877929688,
      "bbox_min": [
        -188.5,
        -2498.5,
        789.2999877929688
      ],
      "bbox_max": [
        -188.300048828125,
        -2497.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -188.5,
      "bbox_min": [
        -188.5,
        -2522.76025390625,
        782.5
      ],
      "bbox_max": [
        -188.300048828125,
        -2522.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -789.2999877929688,
      "bbox_min": [
        -188.5,
        -2522.76025390625,
        789.2999877929688
      ],
      "bbox_max": [
        -188.300048828125,
        -2522.5,
        789.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 191.5,
      "bbox_min": [
        -198.5,
        -2498.5,
        797.0
      ],
      "bbox_max": [
        -190.0,
        -2486.101318359375,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -804.0,
      "bbox_min": [
        -198.5,
        -2498.5,
        804.0
      ],
      "bbox_max": [
        -191.5,
        -2486.101318359375,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9938837289810181,
        -0.0,
        0.11043152213096619
      ],
      "plane_d": 100.82398223876953,
      "bbox_min": [
        -191.5,
        -2497.5,
        797.0
      ],
      "bbox_max": [
        -190.0,
        -2486.43115234375,
        801.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2492.5,
      "bbox_min": [
        -191.5,
        -2497.5,
        797.0
      ],
      "bbox_max": [
        -190.0,
        -2486.43115234375,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2487.5,
      "bbox_min": [
        -191.5,
        -2492.5,
        797.0
      ],
      "bbox_max": [
        -190.0,
        -2486.43115234375,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -801.5,
      "bbox_min": [
        -191.5,
        -2487.5,
        801.5
      ],
      "bbox_max": [
        -190.5,
        -2486.43115234375,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2489.5,
      "bbox_min": [
        -191.5,
        -2492.5,
        797.0
      ],
      "bbox_max": [
        -190.0,
        -2489.5,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -801.5,
      "bbox_min": [
        -191.5,
        -2492.5,
        801.5
      ],
      "bbox_max": [
        -190.5,
        -2489.5,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2497.5,
      "bbox_min": [
        -191.5,
        -2497.5,
        797.0
      ],
      "bbox_max": [
        -190.0,
        -2494.5,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2494.5,
      "bbox_min": [
        -191.5,
        -2497.5,
        797.0
      ],
      "bbox_max": [
        -190.0,
        -2494.5,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -801.5,
      "bbox_min": [
        -191.5,
        -2497.5,
        801.5
      ],
      "bbox_max": [
        -190.5,
        -2494.5,
        801.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2520.0,
      "bbox_min": [
        -168.0,
        -2520.0,
        797.0
      ],
      "bbox_max": [
        -140.0,
        -2518.0,
        803.4865112304688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -168.0,
      "bbox_min": [
        -168.0,
        -2520.0,
        797.0
      ],
      "bbox_max": [
        -140.0,
        -2518.0,
        803.4865112304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2518.0,
      "bbox_min": [
        -168.0,
        -2520.0,
        797.0
      ],
      "bbox_max": [
        -140.0,
        -2518.0,
        803.2758178710938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 166.0,
      "bbox_min": [
        -166.0,
        -2520.0,
        797.0
      ],
      "bbox_max": [
        -140.0,
        -2518.0,
        803.196044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -142.0,
      "bbox_min": [
        -142.0,
        -2520.0,
        797.0
      ],
      "bbox_max": [
        -140.0,
        -2518.0,
        799.71044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        -140.0,
        -2520.0,
        797.0
      ],
      "bbox_max": [
        -140.0,
        -2518.0,
        799.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7863183617591858,
        -0.0,
        0.6178215742111206
      ],
      "plane_d": -324.1316833496094,
      "bbox_min": [
        -226.5,
        -2498.5,
        797.0
      ],
      "bbox_max": [
        -214.0,
        -2486.078125,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2498.5,
      "bbox_min": [
        -226.5,
        -2498.5,
        797.0
      ],
      "bbox_max": [
        -214.0,
        -2487.277099609375,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -804.0,
      "bbox_min": [
        -226.5,
        -2498.5,
        797.0
      ],
      "bbox_max": [
        -219.5,
        -2487.277099609375,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -226.5,
      "bbox_min": [
        -226.5,
        -2498.5,
        797.0
      ],
      "bbox_max": [
        -226.5,
        -2489.074951171875,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5384513735771179,
        -0.8420933485031128,
        0.03080403432250023
      ],
      "plane_d": -2256.63623046875,
      "bbox_min": [
        -266.0561828613281,
        -2502.31689453125,
        519.583740234375
      ],
      "bbox_max": [
        -246.677001953125,
        -2489.029296875,
        587.814208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.430268257856369,
        -0.8978968262672424,
        0.09300856292247772
      ],
      "plane_d": -2403.1669921875,
      "bbox_min": [
        -264.8418273925781,
        -2502.31689453125,
        539.8119506835938
      ],
      "bbox_max": [
        -246.677001953125,
        -2489.029296875,
        587.814208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05928827077150345,
        -0.9979740977287292,
        0.02307876944541931
      ],
      "plane_d": -2906.13037109375,
      "bbox_min": [
        803.9168701171875,
        -2851.0419921875,
        150.0
      ],
      "bbox_max": [
        1760.2698974609375,
        -2656.349853515625,
        676.6976318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7266949415206909,
        -0.6864138841629028,
        0.02739434503018856
      ],
      "plane_d": -1257.5203857421875,
      "bbox_min": [
        803.9168701171875,
        -2851.0419921875,
        150.0
      ],
      "bbox_max": [
        1757.4910888671875,
        -2656.349853515625,
        676.6976318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06795407831668854,
        -0.9973331689834595,
        0.026623612269759178
      ],
      "plane_d": -2915.987548828125,
      "bbox_min": [
        1078.9036865234375,
        -2832.7783203125,
        150.0
      ],
      "bbox_max": [
        1757.4910888671875,
        -2709.817626953125,
        655.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29879969358444214,
        -0.9538390636444092,
        0.030162015929818153
      ],
      "plane_d": -3092.20263671875,
      "bbox_min": [
        1285.0223388671875,
        -2831.575439453125,
        150.0
      ],
      "bbox_max": [
        1755.0457763671875,
        -2709.817626953125,
        624.0225830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3609467148780823,
        -0.930988073348999,
        0.054576583206653595
      ],
      "plane_d": -3130.5810546875,
      "bbox_min": [
        1403.9776611328125,
        -2782.974853515625,
        150.0
      ],
      "bbox_max": [
        1614.3267822265625,
        -2709.817626953125,
        602.8902587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4576248228549957,
        -0.8877981305122375,
        0.04892735183238983
      ],
      "plane_d": -1702.181884765625,
      "bbox_min": [
        1598.1002197265625,
        -2735.09130859375,
        150.0
      ],
      "bbox_max": [
        1614.3267822265625,
        -2709.817626953125,
        566.9888305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4576248228549957,
        -0.8877981305122375,
        0.04892735183238983
      ],
      "plane_d": -1702.181884765625,
      "bbox_min": [
        1602.5487060546875,
        -2801.775146484375,
        150.0
      ],
      "bbox_max": [
        1755.0457763671875,
        -2718.2626953125,
        565.52197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9105714559555054,
        -0.4126048982143402,
        0.024836042895913124
      ],
      "plane_d": 433.4289855957031,
      "bbox_min": [
        1754.750244140625,
        -2790.00048828125,
        532.7901000976562
      ],
      "bbox_max": [
        1755.0457763671875,
        -2788.801513671875,
        552.5856323242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4576248228549957,
        -0.8877981305122375,
        0.04892735183238983
      ],
      "plane_d": -1702.181884765625,
      "bbox_min": [
        1731.916015625,
        -2805.267822265625,
        150.0
      ],
      "bbox_max": [
        1740.3115234375,
        -2799.8408203125,
        214.44290161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9105714559555054,
        -0.4126048982143402,
        0.024836042895913124
      ],
      "plane_d": 433.4289855957031,
      "bbox_min": [
        1754.7542724609375,
        -2798.823974609375,
        387.30133056640625
      ],
      "bbox_max": [
        1757.4910888671875,
        -2789.4521484375,
        552.7977905273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7206773161888123,
        -0.6925857067108154,
        0.03080742061138153
      ],
      "plane_d": -1281.2325439453125,
      "bbox_min": [
        803.9168701171875,
        -2832.313720703125,
        150.0
      ],
      "bbox_max": [
        950.5065307617188,
        -2656.349853515625,
        676.6976318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9105714559555054,
        -0.4126048982143402,
        0.024836042895913124
      ],
      "plane_d": 433.4289855957031,
      "bbox_min": [
        1738.69189453125,
        -2810.384521484375,
        150.0
      ],
      "bbox_max": [
        1760.2698974609375,
        -2794.8359375,
        553.038818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4576248228549957,
        -0.8877981305122375,
        0.04892735183238983
      ],
      "plane_d": -1702.181884765625,
      "bbox_min": [
        1738.69189453125,
        -2808.33544921875,
        150.0
      ],
      "bbox_max": [
        1744.6431884765625,
        -2804.498291015625,
        179.1099853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7245655059814453,
        0.6883644461631775,
        0.0340445451438427
      ],
      "plane_d": 2351.841064453125,
      "bbox_min": [
        -301.6617736816406,
        -3749.061767578125,
        150.0
      ],
      "bbox_max": [
        352.535400390625,
        -2944.680908203125,
        872.3798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7238329648971558,
        0.6886298656463623,
        0.043066371232271194
      ],
      "plane_d": 2345.906494140625,
      "bbox_min": [
        170.42144775390625,
        -3739.249755859375,
        779.1305541992188
      ],
      "bbox_max": [
        266.587890625,
        -3639.406005859375,
        872.3798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7525275945663452,
        0.6564691066741943,
        0.05244596675038338
      ],
      "plane_d": 2210.693359375,
      "bbox_min": [
        251.97702026367188,
        -3739.04638671875,
        789.3822631835938
      ],
      "bbox_max": [
        266.587890625,
        -3725.8681640625,
        869.5490112304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17268598079681396,
        0.9841879606246948,
        0.03941702842712402
      ],
      "plane_d": 3599.984130859375,
      "bbox_min": [
        263.3096008300781,
        -3739.04638671875,
        789.3822631835938
      ],
      "bbox_max": [
        266.587890625,
        -3736.21240234375,
        869.2695922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9500696659088135,
        -0.30839189887046814,
        0.04756174609065056
      ],
      "plane_d": -1326.0494384765625,
      "bbox_min": [
        170.42144775390625,
        -3739.249755859375,
        779.1305541992188
      ],
      "bbox_max": [
        266.587890625,
        -3639.406005859375,
        872.3798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17268598079681396,
        0.9841879606246948,
        0.03941702842712402
      ],
      "plane_d": 3599.984130859375,
      "bbox_min": [
        264.5401916503906,
        -3739.249755859375,
        789.3822631835938
      ],
      "bbox_max": [
        266.587890625,
        -3736.21240234375,
        869.1129760742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7465224862098694,
        0.6641824245452881,
        0.039570894092321396
      ],
      "plane_d": 2255.672607421875,
      "bbox_min": [
        -301.6617736816406,
        -3749.061767578125,
        150.0
      ],
      "bbox_max": [
        352.535400390625,
        -2944.680908203125,
        872.2393798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5771116018295288,
        0.8162537217140198,
        0.02592291869223118
      ],
      "plane_d": 2576.205322265625,
      "bbox_min": [
        -301.6617736816406,
        -3749.061767578125,
        150.0
      ],
      "bbox_max": [
        352.535400390625,
        -2944.680908203125,
        872.2393798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9822387099266052,
        -0.18323063850402832,
        0.04041934385895729
      ],
      "plane_d": -870.5835571289062,
      "bbox_min": [
        170.725341796875,
        -3749.061767578125,
        150.0
      ],
      "bbox_max": [
        352.535400390625,
        -3496.15380859375,
        872.2393798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8509166240692139,
        0.5241855978965759,
        0.03420881927013397
      ],
      "plane_d": 1648.3133544921875,
      "bbox_min": [
        170.725341796875,
        -3639.630859375,
        748.3753662109375
      ],
      "bbox_max": [
        199.43505859375,
        -3496.15380859375,
        872.2393798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9500696659088135,
        -0.30839189887046814,
        0.04756174609065056
      ],
      "plane_d": -1326.0494384765625,
      "bbox_min": [
        170.725341796875,
        -3639.630859375,
        779.1305541992188
      ],
      "bbox_max": [
        175.3134765625,
        -3633.677978515625,
        872.2393798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9755158424377441,
        -0.21523292362689972,
        0.0452059768140316
      ],
      "plane_d": -985.38037109375,
      "bbox_min": [
        172.6287078857422,
        -3749.061767578125,
        150.0
      ],
      "bbox_max": [
        352.535400390625,
        -3516.980712890625,
        871.359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0567576140165329,
        0.9980700612068176,
        0.025192802771925926
      ],
      "plane_d": 3693.984130859375,
      "bbox_min": [
        172.6287078857422,
        -3749.061767578125,
        150.0
      ],
      "bbox_max": [
        352.535400390625,
        -3516.980712890625,
        871.359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12320823967456818,
        0.9910323619842529,
        0.0517178438603878
      ],
      "plane_d": 3629.03662109375,
      "bbox_min": [
        266.587890625,
        -3749.061767578125,
        789.3822631835938
      ],
      "bbox_max": [
        341.0475158691406,
        -3736.21240234375,
        867.698974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17268598079681396,
        0.9841879606246948,
        0.03941702842712402
      ],
      "plane_d": 3599.984130859375,
      "bbox_min": [
        266.587890625,
        -3742.513916015625,
        789.3822631835938
      ],
      "bbox_max": [
        284.8941955566406,
        -3736.21240234375,
        867.698974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17268598079681396,
        0.9841879606246948,
        0.03941702842712402
      ],
      "plane_d": 3599.984130859375,
      "bbox_min": [
        265.7342529296875,
        -3740.93896484375,
        789.3822631835938
      ],
      "bbox_max": [
        275.6490173339844,
        -3736.21240234375,
        868.9609985351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9820936322212219,
        -0.1862727701663971,
        0.028186162933707237
      ],
      "plane_d": -872.0990600585938,
      "bbox_min": [
        172.6287078857422,
        -3639.630859375,
        748.3753662109375
      ],
      "bbox_max": [
        199.43505859375,
        -3516.980712890625,
        871.359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8509166240692139,
        0.5241855978965759,
        0.03420881927013397
      ],
      "plane_d": 1648.3133544921875,
      "bbox_min": [
        172.6287078857422,
        -3639.630859375,
        748.3753662109375
      ],
      "bbox_max": [
        199.43505859375,
        -3516.980712890625,
        871.359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9500696659088135,
        -0.30839189887046814,
        0.04756174609065056
      ],
      "plane_d": -1326.0494384765625,
      "bbox_min": [
        172.6287078857422,
        -3639.630859375,
        779.1305541992188
      ],
      "bbox_max": [
        175.43414306640625,
        -3625.235107421875,
        871.359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.58088219165802,
        0.8135150671005249,
        0.027732910588383675
      ],
      "plane_d": 2567.5458984375,
      "bbox_min": [
        -301.6617736816406,
        -3165.262939453125,
        150.0
      ],
      "bbox_max": [
        -22.141357421875,
        -2944.680908203125,
        867.6456909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388664484024048,
        0.6731492280960083,
        0.03076668083667755
      ],
      "plane_d": 2178.357666015625,
      "bbox_min": [
        -301.6617736816406,
        -3165.262939453125,
        150.0
      ],
      "bbox_max": [
        -22.141357421875,
        -2944.680908203125,
        867.6456909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7295700907707214,
        0.6833271980285645,
        0.02813161164522171
      ],
      "plane_d": 2207.02783203125,
      "bbox_min": [
        -301.6617736816406,
        -3015.99462890625,
        150.0
      ],
      "bbox_max": [
        -229.613525390625,
        -2944.680908203125,
        867.6456909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388457655906677,
        0.6731600761413574,
        0.031021639704704285
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -301.6617736816406,
        -3015.99462890625,
        691.2490844726562
      ],
      "bbox_max": [
        -229.613525390625,
        -2944.680908203125,
        867.6456909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -257.4032287597656,
        -3015.99462890625,
        699.149169921875
      ],
      "bbox_max": [
        -229.613525390625,
        -2993.197509765625,
        866.3298950195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5775443911552429,
        0.8160061836242676,
        0.024013595655560493
      ],
      "plane_d": 2576.89306640625,
      "bbox_min": [
        -256.20599365234375,
        -3165.262939453125,
        699.149169921875
      ],
      "bbox_max": [
        -22.141357421875,
        -2994.445068359375,
        866.2874755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5784722566604614,
        0.815333366394043,
        0.024523701518774033
      ],
      "plane_d": 2574.393798828125,
      "bbox_min": [
        -55.119232177734375,
        -3165.262939453125,
        765.4616088867188
      ],
      "bbox_max": [
        -22.141357421875,
        -3144.019287109375,
        852.8427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -256.20599365234375,
        -3018.2060546875,
        699.149169921875
      ],
      "bbox_max": [
        -229.613525390625,
        -2994.445068359375,
        866.2874755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9959223866462708,
        -0.08835939317941666,
        0.0181999821215868
      ],
      "plane_d": -1099.0582275390625,
      "bbox_min": [
        -25.087284088134766,
        -4311.93701171875,
        149.99998474121094
      ],
      "bbox_max": [
        776.5504150390625,
        -3032.910400390625,
        859.1112060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8076764345169067,
        0.5888927578926086,
        0.029395628720521927
      ],
      "plane_d": 1760.45068359375,
      "bbox_min": [
        -25.087284088134766,
        -4018.671875,
        149.99998474121094
      ],
      "bbox_max": [
        776.5504150390625,
        -3032.910400390625,
        859.1112060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8252175450325012,
        0.5623308420181274,
        0.052915215492248535
      ],
      "plane_d": 1773.6002197265625,
      "bbox_min": [
        -25.087284088134766,
        -3986.552001953125,
        150.0
      ],
      "bbox_max": [
        696.728759765625,
        -3032.910400390625,
        859.1112060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9755158424377441,
        -0.21523292362689972,
        0.0452059768140316
      ],
      "plane_d": -985.38037109375,
      "bbox_min": [
        199.43505859375,
        -3750.31396484375,
        150.0
      ],
      "bbox_max": [
        380.52783203125,
        -3505.311767578125,
        859.1112060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0567576140165329,
        0.9980700612068176,
        0.025192802771925926
      ],
      "plane_d": 3693.984130859375,
      "bbox_min": [
        340.672607421875,
        -3750.31396484375,
        150.0
      ],
      "bbox_max": [
        380.52783203125,
        -3724.961181640625,
        859.1112060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.123633973300457,
        0.9912832975387573,
        0.04551797732710838
      ],
      "plane_d": 3634.754638671875,
      "bbox_min": [
        340.672607421875,
        -3750.31396484375,
        466.1089782714844
      ],
      "bbox_max": [
        365.09722900390625,
        -3733.654541015625,
        859.1112060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12320823967456818,
        0.9910323619842529,
        0.0517178438603878
      ],
      "plane_d": 3629.03662109375,
      "bbox_min": [
        340.672607421875,
        -3750.31396484375,
        794.1105346679688
      ],
      "bbox_max": [
        353.29998779296875,
        -3745.71630859375,
        859.1112060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6175416707992554,
        0.7847907543182373,
        0.05240177363157272
      ],
      "plane_d": 2614.06787109375,
      "bbox_min": [
        -25.087284088134766,
        -3986.552001953125,
        150.0
      ],
      "bbox_max": [
        696.728759765625,
        -3032.910400390625,
        857.69384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0567576140165329,
        0.9980700612068176,
        0.025192802771925926
      ],
      "plane_d": 3693.984130859375,
      "bbox_min": [
        351.340087890625,
        -3986.552001953125,
        150.0
      ],
      "bbox_max": [
        696.728759765625,
        -3726.552978515625,
        857.69384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8021814823150635,
        0.5920624732971191,
        0.07724660634994507
      ],
      "plane_d": 1737.0828857421875,
      "bbox_min": [
        351.340087890625,
        -3986.552001953125,
        794.8886108398438
      ],
      "bbox_max": [
        696.728759765625,
        -3747.2802734375,
        857.69384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12320823967456818,
        0.9910323619842529,
        0.0517178438603878
      ],
      "plane_d": 3629.03662109375,
      "bbox_min": [
        351.340087890625,
        -3799.62890625,
        794.8886108398438
      ],
      "bbox_max": [
        524.5755004882812,
        -3747.2802734375,
        857.69384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6077371835708618,
        0.7909682989120483,
        0.07088473439216614
      ],
      "plane_d": 2627.199462890625,
      "bbox_min": [
        479.6567687988281,
        -3799.62890625,
        803.0512084960938
      ],
      "bbox_max": [
        524.5755004882812,
        -3763.686767578125,
        840.64501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6095806360244751,
        0.7911239266395569,
        0.05034474655985832
      ],
      "plane_d": 2643.391845703125,
      "bbox_min": [
        -25.087284088134766,
        -3863.3564453125,
        150.0
      ],
      "bbox_max": [
        607.57421875,
        -3032.910400390625,
        855.475830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6409114003181458,
        0.7633273005485535,
        0.08101856708526611
      ],
      "plane_d": 2492.2646484375,
      "bbox_min": [
        599.5436401367188,
        -3863.3564453125,
        813.3029174804688
      ],
      "bbox_max": [
        607.57421875,
        -3856.79443359375,
        832.8656005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8021814823150635,
        0.5920624732971191,
        0.07724660634994507
      ],
      "plane_d": 1737.0828857421875,
      "bbox_min": [
        603.1636962890625,
        -3863.3564453125,
        813.3029174804688
      ],
      "bbox_max": [
        607.57421875,
        -3858.52490234375,
        832.6577758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5784722566604614,
        0.815333366394043,
        0.024523701518774033
      ],
      "plane_d": 2574.393798828125,
      "bbox_min": [
        -25.087284088134766,
        -3165.648193359375,
        765.4616088867188
      ],
      "bbox_max": [
        -22.141357421875,
        -3164.78857421875,
        850.719482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7055326700210571,
        -0.7082751393318176,
        0.023873645812273026
      ],
      "plane_d": -2135.6064453125,
      "bbox_min": [
        22.8333740234375,
        -3113.5439453125,
        150.0
      ],
      "bbox_max": [
        85.03846740722656,
        -3032.910400390625,
        183.7232666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8529126644134521,
        0.5195903182029724,
        0.05065583065152168
      ],
      "plane_d": 1448.42822265625,
      "bbox_min": [
        27.792327880859375,
        -3985.717529296875,
        149.99998474121094
      ],
      "bbox_max": [
        776.5504150390625,
        -3035.85009765625,
        820.822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7055326700210571,
        -0.7082751393318176,
        0.023873645812273026
      ],
      "plane_d": -2135.6064453125,
      "bbox_min": [
        27.792327880859375,
        -3818.5302734375,
        149.99998474121094
      ],
      "bbox_max": [
        606.9534301757812,
        -3035.85009765625,
        820.2420654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8246843814849854,
        -0.4889775812625885,
        0.28424733877182007
      ],
      "plane_d": -1631.2696533203125,
      "bbox_min": [
        106.723876953125,
        -3171.353271484375,
        720.4959716796875
      ],
      "bbox_max": [
        185.04376220703125,
        -3097.24658203125,
        820.2420654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7403071522712708,
        0.3129737675189972,
        0.5949727892875671
      ],
      "plane_d": 619.6898193359375,
      "bbox_min": [
        106.723876953125,
        -3141.785888671875,
        720.4959716796875
      ],
      "bbox_max": [
        167.1020965576172,
        -3097.24658203125,
        819.0518188476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2666991353034973,
        0.9633581638336182,
        0.028508827090263367
      ],
      "plane_d": 2934.754150390625,
      "bbox_min": [
        71.57574462890625,
        -3128.198486328125,
        150.0
      ],
      "bbox_max": [
        176.64122009277344,
        -3058.69580078125,
        802.8056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7403071522712708,
        0.3129737675189972,
        0.5949727892875671
      ],
      "plane_d": 619.6898193359375,
      "bbox_min": [
        106.723876953125,
        -3128.198486328125,
        720.4959716796875
      ],
      "bbox_max": [
        159.78958129882812,
        -3097.24658203125,
        802.8056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17600783705711365,
        0.971106767654419,
        0.1611611247062683
      ],
      "plane_d": 2872.85693359375,
      "bbox_min": [
        106.723876953125,
        -3117.298095703125,
        720.4959716796875
      ],
      "bbox_max": [
        153.92320251464844,
        -3097.24658203125,
        789.7723388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2501010000705719,
        0.9651679396629333,
        0.07681389153003693
      ],
      "plane_d": 2907.327392578125,
      "bbox_min": [
        106.723876953125,
        -3112.431640625,
        720.4959716796875
      ],
      "bbox_max": [
        152.939208984375,
        -3097.24658203125,
        761.8776245117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30837056040763855,
        0.9432834982872009,
        0.12297829240560532
      ],
      "plane_d": 2844.69873046875,
      "bbox_min": [
        71.57574462890625,
        -3110.526123046875,
        150.0
      ],
      "bbox_max": [
        176.64122009277344,
        -3058.69580078125,
        736.879638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2657254636287689,
        0.956613302230835,
        0.11950235813856125
      ],
      "plane_d": 2891.673095703125,
      "bbox_min": [
        106.723876953125,
        -3110.526123046875,
        150.0
      ],
      "bbox_max": [
        176.64122009277344,
        -3076.980712890625,
        736.879638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2655453681945801,
        0.9637280106544495,
        0.02671867609024048
      ],
      "plane_d": 2937.3125,
      "bbox_min": [
        106.723876953125,
        -3110.526123046875,
        686.5156860351562
      ],
      "bbox_max": [
        155.44485473632812,
        -3097.24658203125,
        736.879638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2501010000705719,
        0.9651679396629333,
        0.07681389153003693
      ],
      "plane_d": 2907.327392578125,
      "bbox_min": [
        106.723876953125,
        -3110.526123046875,
        720.4959716796875
      ],
      "bbox_max": [
        152.96188354492188,
        -3097.24658203125,
        736.879638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7324283123016357,
        -0.680418848991394,
        0.024058401584625244
      ],
      "plane_d": -2046.59130859375,
      "bbox_min": [
        69.86077880859375,
        -3818.5302734375,
        149.99998474121094
      ],
      "bbox_max": [
        606.9534301757812,
        -3079.755859375,
        814.9385986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7313293218612671,
        -0.6815345883369446,
        0.025845669209957123
      ],
      "plane_d": -2051.4521484375,
      "bbox_min": [
        106.723876953125,
        -3281.92626953125,
        504.090087890625
      ],
      "bbox_max": [
        271.1811218261719,
        -3097.24658203125,
        814.9385986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7322627902030945,
        -0.6772246956825256,
        0.07181940227746964
      ],
      "plane_d": -2071.12744140625,
      "bbox_min": [
        106.723876953125,
        -3214.519287109375,
        720.4959716796875
      ],
      "bbox_max": [
        216.47909545898438,
        -3097.24658203125,
        814.9385986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7589617371559143,
        -0.6175175309181213,
        0.20651651918888092
      ],
      "plane_d": -1886.5819091796875,
      "bbox_min": [
        69.86077880859375,
        -3818.5302734375,
        149.99998474121094
      ],
      "bbox_max": [
        606.9534301757812,
        -3079.755859375,
        318.67132568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8890878558158875,
        -0.38653871417045593,
        0.24517454206943512
      ],
      "plane_d": -1165.108642578125,
      "bbox_min": [
        69.86077880859375,
        -3582.4423828125,
        149.99998474121094
      ],
      "bbox_max": [
        475.2839660644531,
        -3079.755859375,
        207.1168212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4031985104084015,
        -0.8806112408638,
        0.24890731275081635
      ],
      "plane_d": -3000.44140625,
      "bbox_min": [
        466.6621398925781,
        -3582.4423828125,
        149.99998474121094
      ],
      "bbox_max": [
        475.2839660644531,
        -3572.90185546875,
        172.20265197753906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7167351245880127,
        -0.6454834342002869,
        0.2638974189758301
      ],
      "plane_d": -2018.5269775390625,
      "bbox_min": [
        397.5082702636719,
        -3578.49462890625,
        149.99998474121094
      ],
      "bbox_max": [
        468.15325927734375,
        -3464.87060546875,
        253.57794189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4031985104084015,
        -0.8806112408638,
        0.24890731275081635
      ],
      "plane_d": -3000.44140625,
      "bbox_min": [
        458.21844482421875,
        -3578.49462890625,
        149.99998474121094
      ],
      "bbox_max": [
        468.15325927734375,
        -3568.190673828125,
        183.16635131835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7376764416694641,
        -0.6278554797172546,
        0.24825602769851685
      ],
      "plane_d": -1929.36328125,
      "bbox_min": [
        80.17647552490234,
        -3818.5302734375,
        150.0
      ],
      "bbox_max": [
        606.9534301757812,
        -3103.483154296875,
        234.0389404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8890878558158875,
        -0.38653871417045593,
        0.24517454206943512
      ],
      "plane_d": -1165.108642578125,
      "bbox_min": [
        80.17647552490234,
        -3112.313232421875,
        150.0
      ],
      "bbox_max": [
        96.166748046875,
        -3103.483154296875,
        207.1168212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6175416707992554,
        0.7847907543182373,
        0.05240177363157272
      ],
      "plane_d": 2614.06787109375,
      "bbox_min": [
        588.4303588867188,
        -3818.5302734375,
        150.0
      ],
      "bbox_max": [
        606.9534301757812,
        -3803.95458984375,
        234.0389404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7047291398048401,
        -0.7089955806732178,
        0.026118943467736244
      ],
      "plane_d": -2155.4189453125,
      "bbox_min": [
        152.6153564453125,
        -3643.765380859375,
        150.0
      ],
      "bbox_max": [
        776.5504150390625,
        -3110.526123046875,
        820.822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7023268342018127,
        -0.7113156914710999,
        0.02769298106431961
      ],
      "plane_d": -2165.433837890625,
      "bbox_min": [
        152.6153564453125,
        -3643.765380859375,
        150.0
      ],
      "bbox_max": [
        776.5504150390625,
        -3110.526123046875,
        820.822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7313293218612671,
        -0.6815345883369446,
        0.025845669209957123
      ],
      "plane_d": -2051.4521484375,
      "bbox_min": [
        152.6153564453125,
        -3643.765380859375,
        150.0
      ],
      "bbox_max": [
        776.5504150390625,
        -3110.526123046875,
        820.822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4358859956264496,
        -0.8992010354995728,
        0.03795750439167023
      ],
      "plane_d": -2970.5244140625,
      "bbox_min": [
        152.6153564453125,
        -3643.765380859375,
        150.0
      ],
      "bbox_max": [
        776.5504150390625,
        -3110.526123046875,
        820.822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7324283123016357,
        -0.680418848991394,
        0.024058401584625244
      ],
      "plane_d": -2046.59130859375,
      "bbox_min": [
        152.6153564453125,
        -3542.828125,
        317.957763671875
      ],
      "bbox_max": [
        563.7830200195312,
        -3110.526123046875,
        820.822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2501010000705719,
        0.9651679396629333,
        0.07681389153003693
      ],
      "plane_d": 2907.327392578125,
      "bbox_min": [
        152.6153564453125,
        -3542.828125,
        736.879638671875
      ],
      "bbox_max": [
        563.7830200195312,
        -3110.526123046875,
        820.822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7064646482467651,
        -0.7041506767272949,
        0.07127003371715546
      ],
      "plane_d": -2172.34130859375,
      "bbox_min": [
        152.61541748046875,
        -3542.828125,
        754.6683349609375
      ],
      "bbox_max": [
        563.7830200195312,
        -3112.431640625,
        820.822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17600783705711365,
        0.971106767654419,
        0.1611611247062683
      ],
      "plane_d": 2872.85693359375,
      "bbox_min": [
        152.61541748046875,
        -3542.828125,
        761.877685546875
      ],
      "bbox_max": [
        563.7830200195312,
        -3112.431640625,
        820.822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4468574523925781,
        -0.891202986240387,
        0.07794603705406189
      ],
      "plane_d": -2968.193115234375,
      "bbox_min": [
        153.9232177734375,
        -3542.828125,
        785.4234619140625
      ],
      "bbox_max": [
        563.7830200195312,
        -3117.298095703125,
        820.822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7403071522712708,
        0.3129737675189972,
        0.5949727892875671
      ],
      "plane_d": 619.6898193359375,
      "bbox_min": [
        153.9232177734375,
        -3517.91015625,
        785.4234619140625
      ],
      "bbox_max": [
        511.6044616699219,
        -3117.298095703125,
        820.822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8246843814849854,
        -0.4889775812625885,
        0.28424733877182007
      ],
      "plane_d": -1631.2696533203125,
      "bbox_min": [
        167.1021270751953,
        -3517.91015625,
        785.4234619140625
      ],
      "bbox_max": [
        511.6044616699219,
        -3141.785888671875,
        820.822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.700647234916687,
        -0.7095323801040649,
        0.07521316409111023
      ],
      "plane_d": -2197.34130859375,
      "bbox_min": [
        503.2005920410156,
        -3517.91015625,
        785.4234619140625
      ],
      "bbox_max": [
        511.6044616699219,
        -3507.91259765625,
        810.09765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7589617371559143,
        -0.6175175309181213,
        0.20651651918888092
      ],
      "plane_d": -1886.5819091796875,
      "bbox_min": [
        314.77362060546875,
        -3409.624267578125,
        317.957763671875
      ],
      "bbox_max": [
        384.896240234375,
        -3335.406982421875,
        354.4547119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45461931824684143,
        0.8825740814208984,
        0.11993440240621567
      ],
      "plane_d": 2558.304443359375,
      "bbox_min": [
        581.4734497070312,
        -3363.828857421875,
        150.0
      ],
      "bbox_max": [
        776.5504150390625,
        -3225.363037109375,
        774.5669555664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4521629512310028,
        0.8910648822784424,
        0.039396364241838455
      ],
      "plane_d": 2628.0009765625,
      "bbox_min": [
        581.4734497070312,
        -3363.828857421875,
        150.0
      ],
      "bbox_max": [
        776.5504150390625,
        -3225.363037109375,
        774.5669555664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9984285831451416,
        -0.0,
        0.056038569658994675
      ],
      "plane_d": -623.9652709960938,
      "bbox_min": [
        581.4734497070312,
        -3363.828857421875,
        150.0
      ],
      "bbox_max": [
        776.5504150390625,
        -3225.363037109375,
        774.5669555664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9973583221435547,
        0.06245340034365654,
        0.03709162771701813
      ],
      "plane_d": -409.3241882324219,
      "bbox_min": [
        588.2852172851562,
        -3274.30224609375,
        489.78759765625
      ],
      "bbox_max": [
        596.7724609375,
        -3225.363037109375,
        653.202392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7589617371559143,
        -0.6175175309181213,
        0.20651651918888092
      ],
      "plane_d": -1886.5819091796875,
      "bbox_min": [
        315.5208740234375,
        -3409.624267578125,
        307.9405212402344
      ],
      "bbox_max": [
        384.896240234375,
        -3336.56396484375,
        354.4547119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7167351245880127,
        -0.6454834342002869,
        0.2638974189758301
      ],
      "plane_d": -2018.5269775390625,
      "bbox_min": [
        326.01080322265625,
        -3527.64501953125,
        239.16864013671875
      ],
      "bbox_max": [
        505.024658203125,
        -3352.806884765625,
        392.04437255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7589617371559143,
        -0.6175175309181213,
        0.20651651918888092
      ],
      "plane_d": -1886.5819091796875,
      "bbox_min": [
        326.01080322265625,
        -3464.87060546875,
        253.57794189453125
      ],
      "bbox_max": [
        397.5082702636719,
        -3352.806884765625,
        354.4547119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8040251731872559,
        -0.5580930113792419,
        0.2051236778497696
      ],
      "plane_d": -1666.128173828125,
      "bbox_min": [
        370.908447265625,
        -3464.87060546875,
        253.57794189453125
      ],
      "bbox_max": [
        397.5082702636719,
        -3409.624267578125,
        354.4547119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4797043204307556,
        -0.8567934036254883,
        0.1891794204711914
      ],
      "plane_d": -2854.3671875,
      "bbox_min": [
        411.2447509765625,
        -3722.73974609375,
        149.99998474121094
      ],
      "bbox_max": [
        756.60693359375,
        -3486.014404296875,
        474.95501708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7167351245880127,
        -0.6454834342002869,
        0.2638974189758301
      ],
      "plane_d": -2018.5269775390625,
      "bbox_min": [
        411.2447509765625,
        -3533.1123046875,
        207.0719757080078
      ],
      "bbox_max": [
        505.024658203125,
        -3486.014404296875,
        392.04437255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4031985104084015,
        -0.8806112408638,
        0.24890731275081635
      ],
      "plane_d": -3000.44140625,
      "bbox_min": [
        441.84271240234375,
        -3722.73974609375,
        149.99998474121094
      ],
      "bbox_max": [
        756.6068725585938,
        -3527.64501953125,
        392.04437255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7167351245880127,
        -0.6454834342002869,
        0.2638974189758301
      ],
      "plane_d": -2018.5269775390625,
      "bbox_min": [
        441.84271240234375,
        -3568.190673828125,
        183.16636657714844
      ],
      "bbox_max": [
        505.024658203125,
        -3527.64501953125,
        392.04437255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9816219806671143,
        -0.15174885094165802,
        0.1157173216342926
      ],
      "plane_d": 160.41783142089844,
      "bbox_min": [
        756.466796875,
        -3722.73974609375,
        150.0
      ],
      "bbox_max": [
        756.6068725585938,
        -3721.607666015625,
        151.527587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2501010000705719,
        0.9651679396629333,
        0.07681389153003693
      ],
      "plane_d": 2907.327392578125,
      "bbox_min": [
        152.939208984375,
        -3230.205810546875,
        370.8250732421875
      ],
      "bbox_max": [
        607.8739624023438,
        -3110.392578125,
        798.9561157226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9973583221435547,
        0.06245340034365654,
        0.03709162771701813
      ],
      "plane_d": -409.3241882324219,
      "bbox_min": [
        581.761962890625,
        -3230.205810546875,
        370.8250732421875
      ],
      "bbox_max": [
        607.8739624023438,
        -3225.154052734375,
        769.427001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9984285831451416,
        -0.0,
        0.056038569658994675
      ],
      "plane_d": -623.9652709960938,
      "bbox_min": [
        581.761962890625,
        -3230.205810546875,
        653.202392578125
      ],
      "bbox_max": [
        588.2852172851562,
        -3228.089599609375,
        769.427001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24178145825862885,
        0.9671421051025391,
        0.07860032469034195
      ],
      "plane_d": 2937.0234375,
      "bbox_min": [
        175.4763641357422,
        -3229.494140625,
        150.0
      ],
      "bbox_max": [
        633.32763671875,
        -3089.37841796875,
        778.56396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9973583221435547,
        0.06245340034365654,
        0.03709162771701813
      ],
      "plane_d": -409.3241882324219,
      "bbox_min": [
        594.1429443359375,
        -3225.15771484375,
        489.7325744628906
      ],
      "bbox_max": [
        594.1504516601562,
        -3225.142333984375,
        489.9440612792969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038648247718811,
        0.8632845282554626,
        0.029325762763619423
      ],
      "plane_d": 2999.75341796875,
      "bbox_min": [
        519.4442138671875,
        -3197.96484375,
        470.11712646484375
      ],
      "bbox_max": [
        589.951904296875,
        -3146.45263671875,
        775.08056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.520085871219635,
        0.8490864038467407,
        0.0925370380282402
      ],
      "plane_d": 2934.9326171875,
      "bbox_min": [
        175.4763641357422,
        -3198.260009765625,
        150.0
      ],
      "bbox_max": [
        622.3021850585938,
        -3090.30517578125,
        470.11712646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5805860161781311,
        0.8118429183959961,
        0.0618952140212059
      ],
      "plane_d": 2859.779541015625,
      "bbox_min": [
        500.994140625,
        -3198.260009765625,
        150.0
      ],
      "bbox_max": [
        595.2847290039062,
        -3108.29833984375,
        445.51361083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2657254636287689,
        0.956613302230835,
        0.11950235813856125
      ],
      "plane_d": 2891.673095703125,
      "bbox_min": [
        175.4763641357422,
        -3115.903076171875,
        150.0
      ],
      "bbox_max": [
        267.62884521484375,
        -3090.30517578125,
        207.90785217285156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9916024804115295,
        0.04682568460702896,
        0.12054863572120667
      ],
      "plane_d": -494.3349304199219,
      "bbox_min": [
        558.1326293945312,
        -3229.494140625,
        150.0
      ],
      "bbox_max": [
        631.6881713867188,
        -3089.37841796875,
        769.3513793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.520085871219635,
        0.8490864038467407,
        0.0925370380282402
      ],
      "plane_d": 2934.9326171875,
      "bbox_min": [
        589.951904296875,
        -3146.45263671875,
        150.0
      ],
      "bbox_max": [
        626.1732177734375,
        -3089.37841796875,
        470.11712646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038648247718811,
        0.8632845282554626,
        0.029325762763619423
      ],
      "plane_d": 2999.75341796875,
      "bbox_min": [
        558.1326293945312,
        -3229.494140625,
        470.11712646484375
      ],
      "bbox_max": [
        594.1498413085938,
        -3146.45263671875,
        769.3513793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9973583221435547,
        0.06245340034365654,
        0.03709162771701813
      ],
      "plane_d": -409.3241882324219,
      "bbox_min": [
        580.0615234375,
        -3229.494140625,
        470.11712646484375
      ],
      "bbox_max": [
        594.1498413085938,
        -3146.45263671875,
        769.3513793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9984285831451416,
        -0.0,
        0.056038569658994675
      ],
      "plane_d": -623.9652709960938,
      "bbox_min": [
        581.7662353515625,
        -3229.494140625,
        654.798828125
      ],
      "bbox_max": [
        588.1956176757812,
        -3194.569091796875,
        769.3513793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8812400102615356,
        0.4723060727119446,
        0.018526695668697357
      ],
      "plane_d": 1392.0955810546875,
      "bbox_min": [
        707.345947265625,
        -4311.93701171875,
        150.0
      ],
      "bbox_max": [
        728.1550903320312,
        -4296.091796875,
        809.8856811523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8812400102615356,
        0.4723060727119446,
        0.018526695668697357
      ],
      "plane_d": 1392.0955810546875,
      "bbox_min": [
        706.3965454101562,
        -4587.34521484375,
        150.0
      ],
      "bbox_max": [
        1988.0572509765625,
        -2800.9541015625,
        867.6085815429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8815944790840149,
        0.47145190834999084,
        0.022898972034454346
      ],
      "plane_d": 1384.6318359375,
      "bbox_min": [
        706.3965454101562,
        -4428.7001953125,
        779.1305541992188
      ],
      "bbox_max": [
        776.89404296875,
        -4298.99560546875,
        867.6085815429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2645661234855652,
        0.9642309546470642,
        0.016225352883338928
      ],
      "plane_d": 4051.0029296875,
      "bbox_min": [
        706.3965454101562,
        -4428.7001953125,
        779.1305541992188
      ],
      "bbox_max": [
        776.89404296875,
        -4298.99560546875,
        867.6085815429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.88288414478302,
        0.4690592586994171,
        0.02233842946588993
      ],
      "plane_d": 1373.8875732421875,
      "bbox_min": [
        706.3965454101562,
        -4309.482421875,
        809.8856811523438
      ],
      "bbox_max": [
        711.5406494140625,
        -4298.99560546875,
        864.2977905273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9987671971321106,
        -0.046698663383722305,
        0.01683316007256508
      ],
      "plane_d": -920.8641967773438,
      "bbox_min": [
        706.3965454101562,
        -4299.78662109375,
        809.8856811523438
      ],
      "bbox_max": [
        707.345947265625,
        -4298.99560546875,
        864.0232543945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2644350826740265,
        0.9642910957336426,
        0.01472469512373209
      ],
      "plane_d": 4052.539794921875,
      "bbox_min": [
        706.4161987304688,
        -4587.34521484375,
        150.0
      ],
      "bbox_max": [
        1988.0572509765625,
        -2800.9541015625,
        867.5484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2645661234855652,
        0.9642309546470642,
        0.016225352883338928
      ],
      "plane_d": 4051.0029296875,
      "bbox_min": [
        775.6495971679688,
        -4587.34521484375,
        731.2891845703125
      ],
      "bbox_max": [
        1090.369384765625,
        -4427.5537109375,
        867.5484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8981509208679199,
        0.43765097856521606,
        0.042266909033060074
      ],
      "plane_d": 1045.4000244140625,
      "bbox_min": [
        959.901611328125,
        -4587.34521484375,
        731.2891845703125
      ],
      "bbox_max": [
        1090.3385009765625,
        -4478.89404296875,
        847.1046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2819767892360687,
        0.9591768980026245,
        0.02165084145963192
      ],
      "plane_d": 4007.063232421875,
      "bbox_min": [
        959.901611328125,
        -4485.32275390625,
        758.6271362304688
      ],
      "bbox_max": [
        985.5380859375,
        -4478.89404296875,
        846.0775146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7914848923683167,
        0.6107789874076843,
        -0.022378742694854736
      ],
      "plane_d": 3637.23583984375,
      "bbox_min": [
        981.9635620117188,
        -4587.34521484375,
        731.2891845703125
      ],
      "bbox_max": [
        1090.3385009765625,
        -4484.45654296875,
        847.1046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2819767892360687,
        0.9591768980026245,
        0.02165084145963192
      ],
      "plane_d": 4007.063232421875,
      "bbox_min": [
        981.9635620117188,
        -4485.5791015625,
        758.6271362304688
      ],
      "bbox_max": [
        985.5380859375,
        -4484.45654296875,
        843.5507202148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7914848923683167,
        0.6107789874076843,
        -0.022378742694854736
      ],
      "plane_d": 3637.23583984375,
      "bbox_min": [
        1088.598388671875,
        -4513.95361328125,
        779.9810180664062
      ],
      "bbox_max": [
        1090.369384765625,
        -4513.5302734375,
        831.0805053710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.878898024559021,
        0.47661417722702026,
        0.019420865923166275
      ],
      "plane_d": 1412.29296875,
      "bbox_min": [
        706.4161987304688,
        -4513.8466796875,
        150.0
      ],
      "bbox_max": [
        1988.0572509765625,
        -2800.9541015625,
        863.977783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9155784845352173,
        -0.4009268283843994,
        0.03120390512049198
      ],
      "plane_d": 474.5985412597656,
      "bbox_min": [
        706.4161987304688,
        -4513.8466796875,
        150.0
      ],
      "bbox_max": [
        1988.0572509765625,
        -2800.9541015625,
        863.977783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8598151206970215,
        0.5105383396148682,
        0.008278584107756615
      ],
      "plane_d": 3395.324462890625,
      "bbox_min": [
        706.4161987304688,
        -4513.8466796875,
        150.0
      ],
      "bbox_max": [
        1988.0572509765625,
        -2800.9541015625,
        863.977783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660708069801331,
        0.49953848123550415,
        0.019560152664780617
      ],
      "plane_d": 3358.522216796875,
      "bbox_min": [
        1727.0693359375,
        -3753.45166015625,
        567.5963134765625
      ],
      "bbox_max": [
        1765.539306640625,
        -3687.543701171875,
        658.1248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.779249370098114,
        0.6240484714508057,
        0.05773917958140373
      ],
      "plane_d": 957.9458618164062,
      "bbox_min": [
        1727.0693359375,
        -3753.45166015625,
        567.5963134765625
      ],
      "bbox_max": [
        1729.4248046875,
        -3747.09912109375,
        658.1248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8477191925048828,
        0.52967768907547,
        0.02852289006114006
      ],
      "plane_d": 3434.6318359375,
      "bbox_min": [
        706.4161987304688,
        -4513.8466796875,
        150.0
      ],
      "bbox_max": [
        1917.209228515625,
        -2800.9541015625,
        863.977783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661832451820374,
        0.25639787316322327,
        0.027386151254177094
      ],
      "plane_d": 1823.6815185546875,
      "bbox_min": [
        706.4161987304688,
        -4513.8466796875,
        150.0
      ],
      "bbox_max": [
        1865.2816162109375,
        -2800.9541015625,
        863.977783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9105714559555054,
        -0.4126048982143402,
        0.024836042895913124
      ],
      "plane_d": 433.4289855957031,
      "bbox_min": [
        775.437744140625,
        -4513.8466796875,
        150.0
      ],
      "bbox_max": [
        1865.2816162109375,
        -2800.9541015625,
        854.41162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44719284772872925,
        0.8824665546417236,
        0.14584721624851227
      ],
      "plane_d": 2416.2138671875,
      "bbox_min": [
        775.437744140625,
        -4513.8466796875,
        150.0
      ],
      "bbox_max": [
        1728.4539794921875,
        -3442.938232421875,
        854.41162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6071054935455322,
        0.7819521427154541,
        0.14132829010486603
      ],
      "plane_d": 1790.0787353515625,
      "bbox_min": [
        775.437744140625,
        -4513.8466796875,
        150.0
      ],
      "bbox_max": [
        1728.4539794921875,
        -3442.938232421875,
        854.41162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33050450682640076,
        0.9427840113639832,
        0.04387516900897026
      ],
      "plane_d": 3678.2255859375,
      "bbox_min": [
        775.437744140625,
        -4513.8466796875,
        150.0
      ],
      "bbox_max": [
        1581.4024658203125,
        -3442.938232421875,
        854.41162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4219103455543518,
        0.8972445130348206,
        0.13016921281814575
      ],
      "plane_d": 2511.218994140625,
      "bbox_min": [
        775.437744140625,
        -4513.8466796875,
        150.0
      ],
      "bbox_max": [
        1581.4024658203125,
        -3456.015625,
        854.41162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25093328952789307,
        0.9610074758529663,
        0.1161772757768631
      ],
      "plane_d": 2983.87744140625,
      "bbox_min": [
        775.437744140625,
        -4513.8466796875,
        150.0
      ],
      "bbox_max": [
        1446.6124267578125,
        -3456.015625,
        854.41162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9377353191375732,
        -0.34683850407600403,
        0.01885574497282505
      ],
      "plane_d": -761.1635131835938,
      "bbox_min": [
        775.437744140625,
        -4513.8466796875,
        623.4097290039062
      ],
      "bbox_max": [
        1133.2755126953125,
        -4257.208984375,
        854.41162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7914848923683167,
        0.6107789874076843,
        -0.022378742694854736
      ],
      "plane_d": 3637.23583984375,
      "bbox_min": [
        1088.681640625,
        -4513.8466796875,
        780.0087280273438
      ],
      "bbox_max": [
        1133.2755126953125,
        -4456.51806640625,
        831.05712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27419278025627136,
        0.9614750742912292,
        0.01959756575524807
      ],
      "plane_d": 2996.966552734375,
      "bbox_min": [
        1251.11328125,
        -3528.76806640625,
        419.9752197265625
      ],
      "bbox_max": [
        1410.96142578125,
        -3482.402587890625,
        679.6151123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2870385944843292,
        0.9484124183654785,
        0.13461995124816895
      ],
      "plane_d": 2887.098876953125,
      "bbox_min": [
        1251.11328125,
        -3482.402587890625,
        150.0
      ],
      "bbox_max": [
        1290.54443359375,
        -3447.886474609375,
        419.9752197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3783358633518219,
        0.9254153370857239,
        0.02163885533809662
      ],
      "plane_d": 3686.921875,
      "bbox_min": [
        965.5997314453125,
        -3583.95556640625,
        150.0
      ],
      "bbox_max": [
        1263.6844482421875,
        -3442.938232421875,
        746.0025024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27419278025627136,
        0.9614750742912292,
        0.01959756575524807
      ],
      "plane_d": 2996.966552734375,
      "bbox_min": [
        1251.11328125,
        -3490.94482421875,
        419.9752197265625
      ],
      "bbox_max": [
        1262.05615234375,
        -3482.402587890625,
        699.2479858398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38686707615852356,
        0.9116483330726624,
        0.1386769711971283
      ],
      "plane_d": 3600.500244140625,
      "bbox_min": [
        965.5997314453125,
        -3583.95556640625,
        150.0
      ],
      "bbox_max": [
        1263.6844482421875,
        -3442.938232421875,
        746.0025024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2870385944843292,
        0.9484124183654785,
        0.13461995124816895
      ],
      "plane_d": 2887.098876953125,
      "bbox_min": [
        1247.3350830078125,
        -3482.402587890625,
        150.0
      ],
      "bbox_max": [
        1263.6844482421875,
        -3442.938232421875,
        419.9752197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7648679614067078,
        0.6427456736564636,
        0.04307040572166443
      ],
      "plane_d": 1503.0753173828125,
      "bbox_min": [
        965.5997314453125,
        -3583.95556640625,
        150.0
      ],
      "bbox_max": [
        1019.3123779296875,
        -3464.74560546875,
        746.0025024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7488449215888977,
        0.6414593458175659,
        0.16661718487739563
      ],
      "plane_d": 1462.0894775390625,
      "bbox_min": [
        965.5997924804688,
        -3567.58056640625,
        420.44580078125
      ],
      "bbox_max": [
        1008.86376953125,
        -3516.525146484375,
        441.1583251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.820148766040802,
        0.5630922913551331,
        0.10140593349933624
      ],
      "plane_d": 1138.31640625,
      "bbox_min": [
        966.2415771484375,
        -3567.58056640625,
        150.0
      ],
      "bbox_max": [
        1019.3123779296875,
        -3464.74560546875,
        425.44268798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7488449215888977,
        0.6414593458175659,
        0.16661718487739563
      ],
      "plane_d": 1462.0894775390625,
      "bbox_min": [
        966.2415771484375,
        -3567.58056640625,
        285.88909912109375
      ],
      "bbox_max": [
        1008.86376953125,
        -3486.441650390625,
        425.44268798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48610720038414,
        0.8734968304634094,
        0.026513127610087395
      ],
      "plane_d": 2384.339599609375,
      "bbox_min": [
        1253.45361328125,
        -3655.021484375,
        458.24737548828125
      ],
      "bbox_max": [
        1633.35595703125,
        -3488.759765625,
        699.1171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27419278025627136,
        0.9614750742912292,
        0.01959756575524807
      ],
      "plane_d": 2996.966552734375,
      "bbox_min": [
        1253.45361328125,
        -3532.895263671875,
        458.24737548828125
      ],
      "bbox_max": [
        1410.96142578125,
        -3488.759765625,
        699.1171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2924555540084839,
        0.9559801816940308,
        0.023905904963612556
      ],
      "plane_d": 2949.833984375,
      "bbox_min": [
        1360.010009765625,
        -3532.895263671875,
        458.24737548828125
      ],
      "bbox_max": [
        1410.96142578125,
        -3518.896728515625,
        686.8169555664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6872478723526001,
        0.7258203625679016,
        0.029583144932985306
      ],
      "plane_d": 1514.38623046875,
      "bbox_min": [
        1566.2442626953125,
        -3752.533935546875,
        150.0
      ],
      "bbox_max": [
        1754.8330078125,
        -2808.18359375,
        667.6799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48610720038414,
        0.8734968304634094,
        0.026513127610087395
      ],
      "plane_d": 2384.339599609375,
      "bbox_min": [
        1566.2442626953125,
        -3752.533935546875,
        540.2590942382812
      ],
      "bbox_max": [
        1729.4248046875,
        -3621.541015625,
        667.6799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49489134550094604,
        0.8684111833572388,
        0.03073418140411377
      ],
      "plane_d": 2349.123291015625,
      "bbox_min": [
        1586.0001220703125,
        -3752.533935546875,
        540.2590942382812
      ],
      "bbox_max": [
        1729.4248046875,
        -3632.483154296875,
        665.9636840820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.779249370098114,
        0.6240484714508057,
        0.05773917958140373
      ],
      "plane_d": 957.9458618164062,
      "bbox_min": [
        1713.8681640625,
        -3752.533935546875,
        567.5963134765625
      ],
      "bbox_max": [
        1729.4248046875,
        -3736.06640625,
        658.3070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4312950074672699,
        -0.9005617499351501,
        0.054527778178453445
      ],
      "plane_d": -1784.802734375,
      "bbox_min": [
        1748.9217529296875,
        -2813.215576171875,
        150.0
      ],
      "bbox_max": [
        1754.8330078125,
        -2808.18359375,
        232.97305297851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7488449215888977,
        0.6414593458175659,
        0.16661718487739563
      ],
      "plane_d": 1462.0894775390625,
      "bbox_min": [
        758.2100830078125,
        -3541.45068359375,
        150.0
      ],
      "bbox_max": [
        972.3165893554688,
        -3309.557861328125,
        756.5947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3310750424861908,
        0.924628496170044,
        0.1882859170436859
      ],
      "plane_d": 2774.772216796875,
      "bbox_min": [
        758.2100830078125,
        -3486.441650390625,
        150.0
      ],
      "bbox_max": [
        972.3165893554688,
        -3309.557861328125,
        737.724365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45461931824684143,
        0.8825740814208984,
        0.11993440240621567
      ],
      "plane_d": 2558.304443359375,
      "bbox_min": [
        759.0072631835938,
        -3406.070068359375,
        278.1331787109375
      ],
      "bbox_max": [
        858.34912109375,
        -3333.741943359375,
        612.8505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4521629512310028,
        0.8910648822784424,
        0.039396364241838455
      ],
      "plane_d": 2628.0009765625,
      "bbox_min": [
        759.0072631835938,
        -3406.070068359375,
        480.11712646484375
      ],
      "bbox_max": [
        858.34912109375,
        -3358.15087890625,
        612.8505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7357195019721985,
        0.6767817139625549,
        0.026140425354242325
      ],
      "plane_d": 1661.111328125,
      "bbox_min": [
        771.623779296875,
        -3541.45068359375,
        441.1583557128906
      ],
      "bbox_max": [
        968.8547973632812,
        -3371.7392578125,
        756.5947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4407716691493988,
        0.8971563577651978,
        0.028826633468270302
      ],
      "plane_d": 2663.601318359375,
      "bbox_min": [
        771.623779296875,
        -3541.45068359375,
        480.11712646484375
      ],
      "bbox_max": [
        968.8547973632812,
        -3371.7392578125,
        756.5947875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7648679614067078,
        0.6427456736564636,
        0.04307040572166443
      ],
      "plane_d": 1503.0753173828125,
      "bbox_min": [
        920.180908203125,
        -3541.45068359375,
        575.4642944335938
      ],
      "bbox_max": [
        968.8547973632812,
        -3483.59375,
        746.9754638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9811185002326965,
        0.1803492158651352,
        0.06986100971698761
      ],
      "plane_d": 1509.7783203125,
      "bbox_min": [
        806.2110595703125,
        -4043.64892578125,
        150.0
      ],
      "bbox_max": [
        844.33447265625,
        -3989.190673828125,
        544.813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9811185002326965,
        0.1803492158651352,
        0.06986100971698761
      ],
      "plane_d": 1509.7783203125,
      "bbox_min": [
        706.4161987304688,
        -4299.38232421875,
        150.0
      ],
      "bbox_max": [
        852.4025268554688,
        -3361.9072265625,
        863.977783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.985414981842041,
        -0.16721226274967194,
        0.03158261999487877
      ],
      "plane_d": 147.77157592773438,
      "bbox_min": [
        706.4161987304688,
        -4299.38232421875,
        151.5281219482422
      ],
      "bbox_max": [
        852.4025268554688,
        -3361.9072265625,
        863.977783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853616952896118,
        -0.16747599840164185,
        0.03184564411640167
      ],
      "plane_d": 146.53125,
      "bbox_min": [
        754.1663208007812,
        -3989.190673828125,
        544.813232421875
      ],
      "bbox_max": [
        852.4025268554688,
        -3361.9072265625,
        809.8079833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4407716691493988,
        0.8971563577651978,
        0.028826633468270302
      ],
      "plane_d": 2663.601318359375,
      "bbox_min": [
        754.1663208007812,
        -3373.578125,
        636.830322265625
      ],
      "bbox_max": [
        774.132568359375,
        -3361.9072265625,
        758.4673461914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9377353191375732,
        -0.34683850407600403,
        0.01885574497282505
      ],
      "plane_d": -761.1635131835938,
      "bbox_min": [
        775.437744140625,
        -4260.13427734375,
        623.4097290039062
      ],
      "bbox_max": [
        781.055908203125,
        -4257.208984375,
        849.002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4797043204307556,
        -0.8567934036254883,
        0.1891794204711914
      ],
      "plane_d": -2854.3671875,
      "bbox_min": [
        706.4161987304688,
        -4299.38232421875,
        151.5281219482422
      ],
      "bbox_max": [
        810.385986328125,
        -3629.134033203125,
        863.977783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4358859956264496,
        -0.8992010354995728,
        0.03795750439167023
      ],
      "plane_d": -2970.5244140625,
      "bbox_min": [
        706.4161987304688,
        -4299.38232421875,
        474.95501708984375
      ],
      "bbox_max": [
        810.385986328125,
        -3629.134033203125,
        863.977783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4440716505050659,
        -0.8955365419387817,
        0.02854154445230961
      ],
      "plane_d": -2946.057373046875,
      "bbox_min": [
        748.069580078125,
        -3664.63330078125,
        474.95501708984375
      ],
      "bbox_max": [
        787.431640625,
        -3643.765380859375,
        530.0675048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9987671971321106,
        -0.046698663383722305,
        0.01683316007256508
      ],
      "plane_d": -920.8641967773438,
      "bbox_min": [
        706.4161987304688,
        -4299.38232421875,
        623.4097290039062
      ],
      "bbox_max": [
        810.385986328125,
        -4041.57568359375,
        863.977783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9616368412971497,
        0.2738252878189087,
        0.01656172424554825
      ],
      "plane_d": 1901.0960693359375,
      "bbox_min": [
        775.437744140625,
        -4259.84619140625,
        623.4097290039062
      ],
      "bbox_max": [
        810.385986328125,
        -4147.142578125,
        848.9873657226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9377353191375732,
        -0.34683850407600403,
        0.01885574497282505
      ],
      "plane_d": -761.1635131835938,
      "bbox_min": [
        775.437744140625,
        -4259.84619140625,
        623.4097290039062
      ],
      "bbox_max": [
        780.9491577148438,
        -4256.21533203125,
        848.9873657226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1330.0,
      "bbox_min": [
        -2422.66162109375,
        -2818.809326171875,
        150.0
      ],
      "bbox_max": [
        -283.4491271972656,
        1330.0,
        879.9244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8764687180519104,
        0.48085829615592957,
        0.024040397256612778
      ],
      "plane_d": 1733.2122802734375,
      "bbox_min": [
        -1049.821533203125,
        -2818.809326171875,
        150.0
      ],
      "bbox_max": [
        -439.453857421875,
        -2022.358642578125,
        879.9244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6762436032295227,
        0.7347268462181091,
        0.053582221269607544
      ],
      "plane_d": 2184.045166015625,
      "bbox_min": [
        -1049.821533203125,
        -2812.849365234375,
        150.0
      ],
      "bbox_max": [
        -456.64459228515625,
        -2022.358642578125,
        879.9244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -1049.821533203125,
        -2812.849365234375,
        150.0
      ],
      "bbox_max": [
        -456.64459228515625,
        -2022.358642578125,
        879.9244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9373313784599304,
        0.34786927700042725,
        0.019921978935599327
      ],
      "plane_d": 1415.8299560546875,
      "bbox_min": [
        -1049.821533203125,
        -2803.549072265625,
        150.0
      ],
      "bbox_max": [
        -484.9613342285156,
        -2022.358642578125,
        879.9244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.703201413154602,
        0.7104752063751221,
        0.027071993798017502
      ],
      "plane_d": 2169.124267578125,
      "bbox_min": [
        -1049.821533203125,
        -2440.9833984375,
        150.0
      ],
      "bbox_max": [
        -722.9044799804688,
        -2022.358642578125,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -789.134033203125,
        -2435.9833984375,
        639.4786987304688
      ],
      "bbox_max": [
        -724.7533569335938,
        -2329.916748046875,
        640.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -837.259033203125,
        -2440.9833984375,
        639.467529296875
      ],
      "bbox_max": [
        -722.9044799804688,
        -2318.6943359375,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262522339820862,
        0.08588957786560059
      ],
      "plane_d": -911.859375,
      "bbox_min": [
        -837.259033203125,
        -2440.9833984375,
        639.467529296875
      ],
      "bbox_max": [
        -722.9044799804688,
        -2318.6943359375,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003175857476890087,
        -0.008300124667584896,
        -0.9999604821205139
      ],
      "plane_d": 669.7701416015625,
      "bbox_min": [
        -837.259033203125,
        -2440.9833984375,
        639.467529296875
      ],
      "bbox_max": [
        -722.9044799804688,
        -2318.6943359375,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -837.259033203125,
        -2440.9833984375,
        639.467529296875
      ],
      "bbox_max": [
        -722.9044799804688,
        -2318.6943359375,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426010489463806,
        -0.3395310640335083,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -837.259033203125,
        -2400.9833984375,
        663.75
      ],
      "bbox_max": [
        -763.1956787109375,
        -2318.6943359375,
        683.6611938476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -830.384033203125,
        -2440.9833984375,
        639.467529296875
      ],
      "bbox_max": [
        -722.9044799804688,
        -2320.185302734375,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0012480999575927854,
        -0.0017941436963155866,
        -0.9999975562095642
      ],
      "plane_d": 681.8299560546875,
      "bbox_min": [
        -825.384033203125,
        -2440.9833984375,
        663.75
      ],
      "bbox_max": [
        -722.9044799804688,
        -2351.890625,
        687.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34332793951034546,
        0.3998381495475769,
        -0.8498560190200806
      ],
      "plane_d": 1271.518798828125,
      "bbox_min": [
        -782.259033203125,
        -2440.9833984375,
        663.75
      ],
      "bbox_max": [
        -722.9044799804688,
        -2356.4541015625,
        683.8611450195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7558661103248596,
        -0.43222060799598694,
        0.4917842447757721
      ],
      "plane_d": -188.6185302734375,
      "bbox_min": [
        -1049.821533203125,
        -2048.39306640625,
        151.93190002441406
      ],
      "bbox_max": [
        -1020.0485229492188,
        -2022.358642578125,
        219.68569946289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -488.8464050292969,
        -2803.549072265625,
        696.421875
      ],
      "bbox_max": [
        -484.9613342285156,
        -2801.845947265625,
        879.9244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -1049.821533203125,
        -2404.270751953125,
        151.26873779296875
      ],
      "bbox_max": [
        -673.747314453125,
        -2022.358642578125,
        720.006591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7558661103248596,
        -0.43222060799598694,
        0.4917842447757721
      ],
      "plane_d": -188.6185302734375,
      "bbox_min": [
        -1049.821533203125,
        -2366.329345703125,
        151.26873779296875
      ],
      "bbox_max": [
        -718.3978271484375,
        -2022.358642578125,
        686.9745483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -771.84326171875,
        -2366.329345703125,
        639.4187622070312
      ],
      "bbox_max": [
        -718.3978271484375,
        -2314.45263671875,
        686.9745483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004718358162790537,
        0.006487742997705936,
        0.9999678134918213
      ],
      "plane_d": -620.764404296875,
      "bbox_min": [
        -765.3121337890625,
        -2329.916748046875,
        639.4187622070312
      ],
      "bbox_max": [
        -756.295654296875,
        -2318.289794921875,
        639.4786987304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -765.3121337890625,
        -2323.076416015625,
        639.4187622070312
      ],
      "bbox_max": [
        -761.552978515625,
        -2318.289794921875,
        639.477294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003175857476890087,
        -0.008300124667584896,
        -0.9999604821205139
      ],
      "plane_d": 669.7701416015625,
      "bbox_min": [
        -771.84326171875,
        -2366.329345703125,
        639.426025390625
      ],
      "bbox_max": [
        -718.3978271484375,
        -2314.45263671875,
        686.9745483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262522339820862,
        0.08588957786560059
      ],
      "plane_d": -911.859375,
      "bbox_min": [
        -771.84326171875,
        -2366.329345703125,
        639.426025390625
      ],
      "bbox_max": [
        -718.3978271484375,
        -2314.45263671875,
        686.9745483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34332793951034546,
        0.3998381495475769,
        -0.8498560190200806
      ],
      "plane_d": 1271.518798828125,
      "bbox_min": [
        -771.84326171875,
        -2366.329345703125,
        639.426025390625
      ],
      "bbox_max": [
        -718.3978271484375,
        -2314.45263671875,
        686.9745483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0012480999575927854,
        -0.0017941436963155866,
        -0.9999975562095642
      ],
      "plane_d": 681.8299560546875,
      "bbox_min": [
        -737.3109741210938,
        -2354.930419921875,
        686.9595947265625
      ],
      "bbox_max": [
        -731.1618041992188,
        -2348.719482421875,
        686.9745483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426010489463806,
        -0.3395310640335083,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -771.84326171875,
        -2353.02587890625,
        639.426025390625
      ],
      "bbox_max": [
        -732.2608642578125,
        -2314.45263671875,
        686.9735717773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -763.1956787109375,
        -2329.194580078125,
        683.6611938476562
      ],
      "bbox_max": [
        -758.3292846679688,
        -2323.744140625,
        686.7105102539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -769.9774169921875,
        -2353.02587890625,
        639.426025390625
      ],
      "bbox_max": [
        -732.2608642578125,
        -2314.824462890625,
        686.9735717773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -769.9774169921875,
        -2353.02587890625,
        648.37158203125
      ],
      "bbox_max": [
        -732.2608642578125,
        -2314.824462890625,
        686.9735717773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0012480999575927854,
        -0.0017941436963155866,
        -0.9999975562095642
      ],
      "plane_d": 681.8299560546875,
      "bbox_min": [
        -738.4791259765625,
        -2353.02587890625,
        686.9592895507812
      ],
      "bbox_max": [
        -732.2608642578125,
        -2348.111572265625,
        686.9735717773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9562263488769531,
        0.13955684006214142,
        0.2572059631347656
      ],
      "plane_d": 836.2109375,
      "bbox_min": [
        -692.7105102539062,
        -2404.270751953125,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2379.91015625,
        615.4983520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8815664649009705,
        0.4708597660064697,
        0.03364013135433197
      ],
      "plane_d": 1707.2489013671875,
      "bbox_min": [
        -685.3506469726562,
        -2404.270751953125,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2384.460693359375,
        590.8056030273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9315862059593201,
        0.3613213896751404,
        0.03992580994963646
      ],
      "plane_d": 1440.1312255859375,
      "bbox_min": [
        -542.7430419921875,
        -2812.849365234375,
        316.3236083984375
      ],
      "bbox_max": [
        -456.64459228515625,
        -2638.90576171875,
        879.80224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -487.7550964355469,
        -2812.849365234375,
        698.3142700195312
      ],
      "bbox_max": [
        -456.64459228515625,
        -2802.0263671875,
        879.80224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -1049.821533203125,
        -2397.4638671875,
        150.0
      ],
      "bbox_max": [
        -681.9195556640625,
        -2022.358642578125,
        867.400634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.637331485748291,
        0.7695214152336121,
        0.04056220501661301
      ],
      "plane_d": 2238.30517578125,
      "bbox_min": [
        -1049.821533203125,
        -2371.319091796875,
        150.0
      ],
      "bbox_max": [
        -703.9307861328125,
        -2022.358642578125,
        867.400634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -768.4713134765625,
        -2360.6611328125,
        639.3530883789062
      ],
      "bbox_max": [
        -712.98974609375,
        -2310.43701171875,
        686.9600219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -761.5559692382812,
        -2318.2919921875,
        639.3778686523438
      ],
      "bbox_max": [
        -758.402099609375,
        -2314.2763671875,
        639.426025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003175857476890087,
        -0.008300124667584896,
        -0.9999604821205139
      ],
      "plane_d": 669.7701416015625,
      "bbox_min": [
        -768.4713134765625,
        -2360.6611328125,
        639.3829345703125
      ],
      "bbox_max": [
        -712.98974609375,
        -2310.43701171875,
        686.9600219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34332793951034546,
        0.3998381495475769,
        -0.8498560190200806
      ],
      "plane_d": 1271.518798828125,
      "bbox_min": [
        -768.4713134765625,
        -2360.6611328125,
        639.3829345703125
      ],
      "bbox_max": [
        -712.98974609375,
        -2310.43701171875,
        686.9600219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0012480999575927854,
        -0.0017941436963155866,
        -0.9999975562095642
      ],
      "plane_d": 681.8299560546875,
      "bbox_min": [
        -732.2607421875,
        -2349.731201171875,
        686.9425659179688
      ],
      "bbox_max": [
        -726.142822265625,
        -2343.50244140625,
        686.9600219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426010489463806,
        -0.3395310640335083,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -768.4713134765625,
        -2348.7197265625,
        639.3829345703125
      ],
      "bbox_max": [
        -726.142822265625,
        -2310.43701171875,
        686.9595947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -759.2192993164062,
        -2324.705810546875,
        684.730224609375
      ],
      "bbox_max": [
        -754.6053466796875,
        -2319.55615234375,
        686.684326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -766.3021850585938,
        -2348.7197265625,
        639.3829345703125
      ],
      "bbox_max": [
        -726.142822265625,
        -2310.982421875,
        686.9595947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0012480999575927854,
        -0.0017941436963155866,
        -0.9999975562095642
      ],
      "plane_d": 681.8299560546875,
      "bbox_min": [
        -766.3021850585938,
        -2348.7197265625,
        648.81787109375
      ],
      "bbox_max": [
        -726.142822265625,
        -2310.982421875,
        686.9595947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -766.3021850585938,
        -2315.434326171875,
        648.81787109375
      ],
      "bbox_max": [
        -762.5052490234375,
        -2310.982421875,
        651.81005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7176309823989868,
        0.6963256597518921,
        0.011679554358124733
      ],
      "plane_d": 2144.92041015625,
      "bbox_min": [
        -1049.821533203125,
        -2363.612060546875,
        150.0
      ],
      "bbox_max": [
        -713.2709350585938,
        -2022.358642578125,
        867.400634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -1049.821533203125,
        -2363.612060546875,
        150.0
      ],
      "bbox_max": [
        -713.2709350585938,
        -2022.358642578125,
        866.2005615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7558661103248596,
        -0.43222060799598694,
        0.4917842447757721
      ],
      "plane_d": -188.6185302734375,
      "bbox_min": [
        -1049.821533203125,
        -2343.50244140625,
        150.0
      ],
      "bbox_max": [
        -726.142822265625,
        -2022.358642578125,
        686.9425659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16410836577415466,
        -0.9725522994995117,
        0.16495561599731445
      ],
      "plane_d": -2175.37255859375,
      "bbox_min": [
        -1049.821533203125,
        -2343.50244140625,
        150.16165161132812
      ],
      "bbox_max": [
        -726.142822265625,
        -2022.358642578125,
        686.9425659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003175857476890087,
        -0.008300124667584896,
        -0.9999604821205139
      ],
      "plane_d": 669.7701416015625,
      "bbox_min": [
        -1049.821533203125,
        -2343.50244140625,
        189.5177459716797
      ],
      "bbox_max": [
        -726.142822265625,
        -2022.358642578125,
        686.9425659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25237345695495605,
        -0.9668518304824829,
        0.03879788890480995
      ],
      "plane_d": -2228.79150390625,
      "bbox_min": [
        -1049.821533203125,
        -2333.9970703125,
        211.71893310546875
      ],
      "bbox_max": [
        -734.5917358398438,
        -2022.358642578125,
        686.6563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -765.279052734375,
        -2333.9970703125,
        639.3507080078125
      ],
      "bbox_max": [
        -734.5917358398438,
        -2306.33251953125,
        686.6563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -758.4042358398438,
        -2314.27783203125,
        639.3507080078125
      ],
      "bbox_max": [
        -756.3106689453125,
        -2311.61328125,
        639.3829345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426010489463806,
        -0.3395310640335083,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -765.279052734375,
        -2319.914306640625,
        639.3507080078125
      ],
      "bbox_max": [
        -752.123779296875,
        -2306.33251953125,
        686.6563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -754.98779296875,
        -2319.914306640625,
        685.8677978515625
      ],
      "bbox_max": [
        -752.123779296875,
        -2316.721435546875,
        686.6563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -763.1381225585938,
        -2314.2763671875,
        639.3507080078125
      ],
      "bbox_max": [
        -756.3106689453125,
        -2307.621826171875,
        651.2776489257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -763.1381225585938,
        -2311.396728515625,
        649.1970825195312
      ],
      "bbox_max": [
        -760.0314331054688,
        -2307.621826171875,
        651.2776489257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -765.091796875,
        -2352.38525390625,
        639.28125
      ],
      "bbox_max": [
        -714.7833862304688,
        -2295.123779296875,
        867.400634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -728.7449951171875,
        -2352.38525390625,
        686.9425659179688
      ],
      "bbox_max": [
        -720.4390869140625,
        -2339.37646484375,
        866.0586547851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -765.091796875,
        -2350.402099609375,
        639.28125
      ],
      "bbox_max": [
        -714.7833862304688,
        -2295.123779296875,
        867.400634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -762.0160522460938,
        -2308.695556640625,
        647.44970703125
      ],
      "bbox_max": [
        -755.9295654296875,
        -2302.23095703125,
        675.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426010489463806,
        -0.3395310640335083,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -762.0160522460938,
        -2306.4140625,
        675.0604858398438
      ],
      "bbox_max": [
        -761.55126953125,
        -2305.747802734375,
        675.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.785592257976532,
        0.6162072420120239,
        -0.05597551912069321
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -765.091796875,
        -2317.2421875,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2295.123779296875,
        759.6326904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426010489463806,
        -0.3395310640335083,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -761.9382934570312,
        -2316.721435546875,
        675.13037109375
      ],
      "bbox_max": [
        -752.123779296875,
        -2305.747802734375,
        686.6377563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -759.273681640625,
        -2317.2421875,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2302.23388671875,
        650.0578002929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -756.3106689453125,
        -2317.2421875,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2308.314453125,
        639.357421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9640350937843323,
        0.26420632004737854,
        0.028835229575634003
      ],
      "plane_d": 1318.23193359375,
      "bbox_min": [
        -757.0101318359375,
        -2308.314453125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2299.9072265625,
        666.3331298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -757.0101318359375,
        -2303.116943359375,
        648.4978637695312
      ],
      "bbox_max": [
        -755.6088256835938,
        -2300.060302734375,
        666.3331298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262522339820862,
        0.08588957786560059
      ],
      "plane_d": -911.859375,
      "bbox_min": [
        -755.9369506835938,
        -2302.23388671875,
        650.0578002929688
      ],
      "bbox_max": [
        -755.906494140625,
        -2302.20166015625,
        650.1961669921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -755.9295654296875,
        -2303.116943359375,
        648.4978637695312
      ],
      "bbox_max": [
        -755.6088256835938,
        -2302.20166015625,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -756.3975219726562,
        -2308.314453125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2299.90771484375,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936564803123474,
        0.21308477222919464
      ],
      "plane_d": 1814.77783203125,
      "bbox_min": [
        -756.3975219726562,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2299.90771484375,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8815664649009705,
        0.4708597660064697,
        0.03364013135433197
      ],
      "plane_d": 1707.2489013671875,
      "bbox_min": [
        -742.0281372070312,
        -2384.8916015625,
        585.010498046875
      ],
      "bbox_max": [
        -685.3416748046875,
        -2313.18505859375,
        649.505126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -742.0281372070312,
        -2350.78662109375,
        630.2252807617188
      ],
      "bbox_max": [
        -705.91748046875,
        -2313.18505859375,
        639.3538208007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -739.8612060546875,
        -2349.233642578125,
        630.2252807617188
      ],
      "bbox_max": [
        -705.91748046875,
        -2314.904052734375,
        630.2252807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8313450217247009,
        0.5555300712585449,
        0.01586890034377575
      ],
      "plane_d": 1886.90283203125,
      "bbox_min": [
        -708.7366943359375,
        -2544.758056640625,
        150.0
      ],
      "bbox_max": [
        -578.171875,
        -2344.1669921875,
        866.7681274414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8306585550308228,
        0.5565486550331116,
        0.01612250879406929
      ],
      "plane_d": 1888.747802734375,
      "bbox_min": [
        -689.2754516601562,
        -2459.847900390625,
        558.2156982421875
      ],
      "bbox_max": [
        -642.4852294921875,
        -2391.3369140625,
        866.0599975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -689.2754516601562,
        -2405.76123046875,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2391.3369140625,
        865.6367797851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.834480881690979,
        0.550487756729126,
        0.024593127891421318
      ],
      "plane_d": 1872.022705078125,
      "bbox_min": [
        -708.7366943359375,
        -2544.010009765625,
        150.0
      ],
      "bbox_max": [
        -578.171875,
        -2344.1669921875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8202191591262817,
        0.571056604385376,
        0.033687908202409744
      ],
      "plane_d": 1912.07421875,
      "bbox_min": [
        -708.7366943359375,
        -2544.010009765625,
        150.0
      ],
      "bbox_max": [
        -578.171875,
        -2344.1669921875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -708.7366943359375,
        -2349.337158203125,
        630.2252807617188
      ],
      "bbox_max": [
        -704.3489990234375,
        -2344.1669921875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -708.7366943359375,
        -2349.337158203125,
        630.2252807617188
      ],
      "bbox_max": [
        -704.3489990234375,
        -2344.1669921875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -708.7366943359375,
        -2349.337158203125,
        641.6248779296875
      ],
      "bbox_max": [
        -704.5856323242188,
        -2344.52734375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8202191591262817,
        0.571056604385376,
        0.033687908202409744
      ],
      "plane_d": 1912.07421875,
      "bbox_min": [
        -580.6322021484375,
        -2818.809326171875,
        150.0
      ],
      "bbox_max": [
        -439.453857421875,
        -2523.185546875,
        876.5070190429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9296503663063049,
        0.3666344881057739,
        0.03646130487322807
      ],
      "plane_d": 1454.0635986328125,
      "bbox_min": [
        -578.171875,
        -2818.809326171875,
        150.0
      ],
      "bbox_max": [
        -439.453857421875,
        -2542.212158203125,
        876.5070190429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9315862059593201,
        0.3613213896751404,
        0.03992580994963646
      ],
      "plane_d": 1440.1312255859375,
      "bbox_min": [
        -578.171875,
        -2654.155029296875,
        275.1019592285156
      ],
      "bbox_max": [
        -530.0181884765625,
        -2544.010009765625,
        475.2274169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -458.3185119628906,
        -2818.809326171875,
        807.8794555664062
      ],
      "bbox_max": [
        -439.453857421875,
        -2812.469482421875,
        876.5070190429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -1030.0263671875,
        -2304.79736328125,
        150.0
      ],
      "bbox_max": [
        -750.960693359375,
        -2027.8453369140625,
        754.5848999023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22133076190948486,
        -0.9681739807128906,
        0.11684101819992065
      ],
      "plane_d": -2216.021240234375,
      "bbox_min": [
        -1030.0263671875,
        -2301.5498046875,
        150.0
      ],
      "bbox_max": [
        -754.3570556640625,
        -2027.8453369140625,
        668.8339233398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350937843323,
        0.26420632004737854,
        0.028835229575634003
      ],
      "plane_d": 1318.23193359375,
      "bbox_min": [
        -1014.7175903320312,
        -2301.5498046875,
        150.0
      ],
      "bbox_max": [
        -754.3570556640625,
        -2040.0740966796875,
        668.8339233398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7558661103248596,
        -0.43222060799598694,
        0.4917842447757721
      ],
      "plane_d": -188.6185302734375,
      "bbox_min": [
        -1014.7175903320312,
        -2040.1346435546875,
        150.0
      ],
      "bbox_max": [
        -1014.635986328125,
        -2040.0740966796875,
        150.16165161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936564803123474,
        0.21308477222919464
      ],
      "plane_d": 1814.77783203125,
      "bbox_min": [
        -756.5269165039062,
        -2301.5498046875,
        642.3101196289062
      ],
      "bbox_max": [
        -754.3570556640625,
        -2299.30322265625,
        645.4580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.785592257976532,
        0.6162072420120239,
        -0.05597551912069321
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -765.2634887695312,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2294.6083984375,
        754.5848999023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936564803123474,
        0.21308477222919464
      ],
      "plane_d": 1814.77783203125,
      "bbox_min": [
        -754.57177734375,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2301.445068359375,
        643.3837280273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9409332871437073,
        0.3373379111289978,
        0.0291153434664011
      ],
      "plane_d": 1465.486572265625,
      "bbox_min": [
        -1002.9469604492188,
        -2456.341064453125,
        150.0
      ],
      "bbox_max": [
        -283.4491271972656,
        -2015.67578125,
        866.7552490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9281567931175232,
        0.37126728892326355,
        0.02618309296667576
      ],
      "plane_d": 1533.945556640625,
      "bbox_min": [
        -1002.9469604492188,
        -2304.79736328125,
        150.0
      ],
      "bbox_max": [
        -743.0813598632812,
        -2031.875244140625,
        866.7552490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429206371307373,
        0.6689925789833069,
        0.022761045023798943
      ],
      "plane_d": 2066.188232421875,
      "bbox_min": [
        -1002.9469604492188,
        -2304.79736328125,
        150.0
      ],
      "bbox_max": [
        -750.960693359375,
        -2031.875244140625,
        866.7552490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7385133504867554,
        0.6736845970153809,
        0.027333253994584084
      ],
      "plane_d": 2070.8447265625,
      "bbox_min": [
        -1002.9469604492188,
        -2304.79736328125,
        150.0
      ],
      "bbox_max": [
        -750.960693359375,
        -2031.875244140625,
        866.7552490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350937843323,
        0.26420632004737854,
        0.028835229575634003
      ],
      "plane_d": 1318.23193359375,
      "bbox_min": [
        -1002.9469604492188,
        -2304.79736328125,
        150.0
      ],
      "bbox_max": [
        -750.960693359375,
        -2031.875244140625,
        866.7552490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -1002.9469604492188,
        -2300.93017578125,
        150.0
      ],
      "bbox_max": [
        -757.15625,
        -2031.875244140625,
        865.4036254882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25237345695495605,
        -0.9668518304824829,
        0.03879788890480995
      ],
      "plane_d": -2228.79150390625,
      "bbox_min": [
        -1002.9469604492188,
        -2057.4658203125,
        150.0
      ],
      "bbox_max": [
        -933.0374755859375,
        -2031.875244140625,
        356.9372863769531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22133076190948486,
        -0.9681739807128906,
        0.11684101819992065
      ],
      "plane_d": -2216.021240234375,
      "bbox_min": [
        -993.2120361328125,
        -2057.4658203125,
        150.0
      ],
      "bbox_max": [
        -933.0374755859375,
        -2038.0494384765625,
        196.9026641845703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.785592257976532,
        0.6162072420120239,
        -0.05597551912069321
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -771.5665283203125,
        -2300.93017578125,
        745.6574096679688
      ],
      "bbox_max": [
        -759.4663696289062,
        -2275.6953125,
        865.4036254882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -768.0801391601562,
        -2303.76025390625,
        759.6326904296875
      ],
      "bbox_max": [
        -758.6405639648438,
        -2280.1435546875,
        866.7552490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -753.873046875,
        -2303.486572265625,
        630.2252807617188
      ],
      "bbox_max": [
        -751.1504516601562,
        -2299.746337890625,
        630.2252807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -753.871337890625,
        -2304.58740234375,
        641.6248779296875
      ],
      "bbox_max": [
        -751.1085205078125,
        -2299.947021484375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7370969653129578,
        0.6752943992614746,
        0.02579813450574875
      ],
      "plane_d": 2074.2548828125,
      "bbox_min": [
        -954.8668212890625,
        -2259.7197265625,
        183.98452758789062
      ],
      "bbox_max": [
        -765.472412109375,
        -2041.6365966796875,
        866.4890747070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25237345695495605,
        -0.9668518304824829,
        0.03879788890480995
      ],
      "plane_d": -2228.79150390625,
      "bbox_min": [
        -954.8668212890625,
        -2222.119384765625,
        183.98452758789062
      ],
      "bbox_max": [
        -808.562255859375,
        -2041.6365966796875,
        866.4890747070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -855.3812866210938,
        -2222.119384765625,
        733.704833984375
      ],
      "bbox_max": [
        -808.562255859375,
        -2168.956298828125,
        866.4890747070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2615157663822174,
        -0.9648758172988892,
        0.024980084970593452
      ],
      "plane_d": -2227.614013671875,
      "bbox_min": [
        -953.4334106445312,
        -2219.205810546875,
        150.0
      ],
      "bbox_max": [
        -787.3925170898438,
        -2041.9276123046875,
        565.3817749023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.755939245223999,
        0.6539766788482666,
        0.02950362116098404
      ],
      "plane_d": 2042.1041259765625,
      "bbox_min": [
        -953.4334106445312,
        -2219.205810546875,
        150.0
      ],
      "bbox_max": [
        -787.3925170898438,
        -2041.9276123046875,
        403.0205383300781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25237345695495605,
        -0.9668518304824829,
        0.03879788890480995
      ],
      "plane_d": -2228.79150390625,
      "bbox_min": [
        -953.4334106445312,
        -2059.108154296875,
        150.0
      ],
      "bbox_max": [
        -925.8958129882812,
        -2041.9276123046875,
        366.42230224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2265453338623047,
        -0.9669476747512817,
        0.11700189113616943
      ],
      "plane_d": -2218.357666015625,
      "bbox_min": [
        -927.5880126953125,
        -2059.108154296875,
        150.0
      ],
      "bbox_max": [
        -925.8958129882812,
        -2057.93994140625,
        157.1568603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26263877749443054,
        -0.9629242420196533,
        0.061626359820365906
      ],
      "plane_d": -2234.106201171875,
      "bbox_min": [
        -926.461669921875,
        -2080.65185546875,
        170.03836059570312
      ],
      "bbox_max": [
        -826.5889282226562,
        -2056.551025390625,
        245.9615936279297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26263877749443054,
        -0.9629242420196533,
        0.061626359820365906
      ],
      "plane_d": -2234.106201171875,
      "bbox_min": [
        -929.7234497070312,
        -2086.212158203125,
        150.0
      ],
      "bbox_max": [
        -822.4157104492188,
        -2055.64697265625,
        219.0944061279297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2265453338623047,
        -0.9669476747512817,
        0.11700189113616943
      ],
      "plane_d": -2218.357666015625,
      "bbox_min": [
        -929.7234497070312,
        -2065.93359375,
        150.0
      ],
      "bbox_max": [
        -896.7640991210938,
        -2055.64697265625,
        171.35108947753906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22133076190948486,
        -0.9681739807128906,
        0.11684101819992065
      ],
      "plane_d": -2216.021240234375,
      "bbox_min": [
        -929.7234497070312,
        -2057.93994140625,
        157.1568603515625
      ],
      "bbox_max": [
        -926.461669921875,
        -2055.64697265625,
        171.35108947753906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2615157663822174,
        -0.9648758172988892,
        0.024980084970593452
      ],
      "plane_d": -2227.614013671875,
      "bbox_min": [
        -842.3095703125,
        -2088.699951171875,
        150.0
      ],
      "bbox_max": [
        -813.2948608398438,
        -2065.77197265625,
        581.6278076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26263877749443054,
        -0.9629242420196533,
        0.061626359820365906
      ],
      "plane_d": -2234.106201171875,
      "bbox_min": [
        -830.53173828125,
        -2088.699951171875,
        150.0
      ],
      "bbox_max": [
        -813.2948608398438,
        -2076.013671875,
        293.0915222167969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24620355665683746,
        -0.9684427380561829,
        0.038763467222452164
      ],
      "plane_d": -2226.34130859375,
      "bbox_min": [
        -830.53173828125,
        -2080.4501953125,
        245.9615936279297
      ],
      "bbox_max": [
        -819.4318237304688,
        -2076.013671875,
        293.0915222167969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5994062423706055,
        -0.7998847365379333,
        0.029941599816083908
      ],
      "plane_d": -2178.19677734375,
      "bbox_min": [
        -834.2371215820312,
        -2456.341064453125,
        150.0
      ],
      "bbox_max": [
        -283.4491271972656,
        -2015.67578125,
        864.1656494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5384513735771179,
        -0.8420933485031128,
        0.03080403432250023
      ],
      "plane_d": -2256.63623046875,
      "bbox_min": [
        -834.2371215820312,
        -2456.341064453125,
        150.0
      ],
      "bbox_max": [
        -283.4491271972656,
        -2015.67578125,
        822.9512329101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45383763313293457,
        -0.8906913995742798,
        0.026465822011232376
      ],
      "plane_d": -2228.372314453125,
      "bbox_min": [
        -834.2371215820312,
        -2456.341064453125,
        150.0
      ],
      "bbox_max": [
        -283.4491271972656,
        -2015.67578125,
        821.12548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4271385669708252,
        -0.9028797149658203,
        0.04858982190489769
      ],
      "plane_d": -2246.743408203125,
      "bbox_min": [
        -799.3662109375,
        -2185.198974609375,
        466.048828125
      ],
      "bbox_max": [
        -468.130615234375,
        -2015.67578125,
        818.3839721679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -674.18994140625,
        -2180.648681640625,
        639.28125
      ],
      "bbox_max": [
        -468.130615234375,
        -2015.67578125,
        818.3839721679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36469170451164246,
        -0.3489462733268738,
        0.8632707595825195
      ],
      "plane_d": -1642.7313232421875,
      "bbox_min": [
        -674.18994140625,
        -2128.6962890625,
        757.6525268554688
      ],
      "bbox_max": [
        -619.1536865234375,
        -2024.815673828125,
        818.3839721679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -674.18994140625,
        -2180.648681640625,
        639.28125
      ],
      "bbox_max": [
        -468.130615234375,
        -2015.67578125,
        818.086669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36469170451164246,
        -0.3489462733268738,
        0.8632707595825195
      ],
      "plane_d": -1642.7313232421875,
      "bbox_min": [
        -674.18994140625,
        -2128.6962890625,
        757.6525268554688
      ],
      "bbox_max": [
        -597.2589721679688,
        -2036.7056884765625,
        818.086669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -674.18994140625,
        -2180.648681640625,
        639.28125
      ],
      "bbox_max": [
        -511.7373046875,
        -2128.6962890625,
        757.6525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -674.18994140625,
        -2185.198974609375,
        639.2813110351562
      ],
      "bbox_max": [
        -577.8394165039062,
        -2128.6962890625,
        757.6525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4396458864212036,
        -0.8734606504440308,
        0.20923222601413727
      ],
      "plane_d": -2314.2626953125,
      "bbox_min": [
        -674.18994140625,
        -2148.14013671875,
        723.0960083007812
      ],
      "bbox_max": [
        -652.0059204101562,
        -2128.6962890625,
        757.6525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2615157663822174,
        -0.9648758172988892,
        0.024980084970593452
      ],
      "plane_d": -2227.614013671875,
      "bbox_min": [
        -834.2371215820312,
        -2456.341064453125,
        150.0
      ],
      "bbox_max": [
        -283.4491271972656,
        -2067.539306640625,
        821.12548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4714754819869995,
        -0.8809452652931213,
        0.040574923157691956
      ],
      "plane_d": -2225.99169921875,
      "bbox_min": [
        -820.8699340820312,
        -2456.341064453125,
        150.0
      ],
      "bbox_max": [
        -283.4491271972656,
        -2078.9296875,
        821.12548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7415313124656677,
        -0.6696079969406128,
        0.04191046580672264
      ],
      "plane_d": -1963.6297607421875,
      "bbox_min": [
        -820.8699340820312,
        -2456.341064453125,
        150.0
      ],
      "bbox_max": [
        -283.4491271972656,
        -2078.9296875,
        821.12548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -652.0059204101562,
        -2199.5419921875,
        630.2252807617188
      ],
      "bbox_max": [
        -584.162841796875,
        -2148.14013671875,
        723.0960083007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -604.6767578125,
        -2199.5419921875,
        630.2252807617188
      ],
      "bbox_max": [
        -594.0824584960938,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -599.7045288085938,
        -2194.46533203125,
        641.6248779296875
      ],
      "bbox_max": [
        -598.7432250976562,
        -2193.659912109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -615.3544921875,
        -2250.59716796875,
        630.2252807617188
      ],
      "bbox_max": [
        -560.1396484375,
        -2192.60791015625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -572.667724609375,
        -2250.59716796875,
        630.2252807617188
      ],
      "bbox_max": [
        -560.1396484375,
        -2241.306640625,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -615.3544921875,
        -2250.385009765625,
        639.28125
      ],
      "bbox_max": [
        -560.1396484375,
        -2192.60791015625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -615.3544921875,
        -2205.376953125,
        641.6248779296875
      ],
      "bbox_max": [
        -598.18994140625,
        -2192.60791015625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -575.6868286132812,
        -2250.385009765625,
        639.28125
      ],
      "bbox_max": [
        -560.1396484375,
        -2237.27685546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -572.3814697265625,
        -2250.385009765625,
        639.28125
      ],
      "bbox_max": [
        -560.1396484375,
        -2241.306640625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -577.1485595703125,
        -2253.920166015625,
        630.2252807617188
      ],
      "bbox_max": [
        -572.3814697265625,
        -2250.385009765625,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -620.3309326171875,
        -2253.69287109375,
        639.28125
      ],
      "bbox_max": [
        -572.307373046875,
        -2201.833251953125,
        641.6248779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -617.2255859375,
        -2253.69287109375,
        639.28125
      ],
      "bbox_max": [
        -572.307373046875,
        -2205.376953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -576.842041015625,
        -2253.69287109375,
        639.28125
      ],
      "bbox_max": [
        -572.307373046875,
        -2250.330078125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8221501111984253,
        -0.5637224912643433,
        0.07928481698036194
      ],
      "plane_d": -1806.1368408203125,
      "bbox_min": [
        -820.8699340820312,
        -2291.06005859375,
        150.0
      ],
      "bbox_max": [
        -556.5177612304688,
        -2078.9296875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5089108347892761,
        -0.8510450124740601,
        0.1293531060218811
      ],
      "plane_d": -2284.99560546875,
      "bbox_min": [
        -622.7305297851562,
        -2291.06005859375,
        401.86346435546875
      ],
      "bbox_max": [
        -556.5177612304688,
        -2205.38623046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -622.7305297851562,
        -2232.3857421875,
        630.2252807617188
      ],
      "bbox_max": [
        -596.5943603515625,
        -2205.38623046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -621.9924926757812,
        -2230.05859375,
        639.28125
      ],
      "bbox_max": [
        -598.1838989257812,
        -2205.38623046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -621.9924926757812,
        -2210.580078125,
        639.2813110351562
      ],
      "bbox_max": [
        -617.1452026367188,
        -2205.38623046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -619.4703979492188,
        -2210.580078125,
        639.2813110351562
      ],
      "bbox_max": [
        -617.1452026367188,
        -2208.9140625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -611.6262817382812,
        -2260.451904296875,
        630.2252807617188
      ],
      "bbox_max": [
        -576.7626953125,
        -2222.020263671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -585.9564208984375,
        -2260.451904296875,
        630.2252807617188
      ],
      "bbox_max": [
        -576.842041015625,
        -2253.69287109375,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -588.2650146484375,
        -2260.116943359375,
        639.2811889648438
      ],
      "bbox_max": [
        -576.7626953125,
        -2249.833740234375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -585.5047607421875,
        -2260.116943359375,
        639.2811889648438
      ],
      "bbox_max": [
        -576.7626953125,
        -2253.634033203125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4426290988922119,
        -0.8944221138954163,
        0.06394129991531372
      ],
      "plane_d": -2236.98828125,
      "bbox_min": [
        -820.8699340820312,
        -2260.390869140625,
        150.0
      ],
      "bbox_max": [
        -585.35498046875,
        -2078.9296875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26263877749443054,
        -0.9629242420196533,
        0.061626359820365906
      ],
      "plane_d": -2234.106201171875,
      "bbox_min": [
        -820.8699340820312,
        -2260.390869140625,
        150.0
      ],
      "bbox_max": [
        -585.35498046875,
        -2078.9296875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -585.8740844726562,
        -2260.390869140625,
        633.503662109375
      ],
      "bbox_max": [
        -585.5047607421875,
        -2260.116943359375,
        639.2811889648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -636.1280517578125,
        -2260.283447265625,
        639.2811889648438
      ],
      "bbox_max": [
        -585.35498046875,
        -2210.4716796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -585.7290649414062,
        -2260.283447265625,
        639.2811889648438
      ],
      "bbox_max": [
        -585.35498046875,
        -2260.005859375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24620355665683746,
        -0.9684427380561829,
        0.038763467222452164
      ],
      "plane_d": -2226.34130859375,
      "bbox_min": [
        -820.8699340820312,
        -2083.540283203125,
        252.7462921142578
      ],
      "bbox_max": [
        -805.59375,
        -2078.9296875,
        281.6034240722656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5781846046447754,
        -0.8145887851715088,
        0.0463433638215065
      ],
      "plane_d": -2211.789794921875,
      "bbox_min": [
        -774.0778198242188,
        -2414.696044921875,
        150.0
      ],
      "bbox_max": [
        -392.0885009765625,
        -2219.47705078125,
        864.1656494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8221501111984253,
        -0.5637224912643433,
        0.07928481698036194
      ],
      "plane_d": -1806.1368408203125,
      "bbox_min": [
        -652.7127685546875,
        -2312.4736328125,
        150.0
      ],
      "bbox_max": [
        -541.8916015625,
        -2219.47705078125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5089108347892761,
        -0.8510450124740601,
        0.1293531060218811
      ],
      "plane_d": -2284.99560546875,
      "bbox_min": [
        -606.9039916992188,
        -2312.4736328125,
        318.5225830078125
      ],
      "bbox_max": [
        -541.8916015625,
        -2257.631591796875,
        633.503662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 630.2252807617188,
      "bbox_min": [
        -643.9855346679688,
        -2261.99072265625,
        630.2252807617188
      ],
      "bbox_max": [
        -585.6702270507812,
        -2219.47705078125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -588.0315551757812,
        -2261.99072265625,
        630.2252807617188
      ],
      "bbox_max": [
        -585.7290649414062,
        -2260.283447265625,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -639.5083618164062,
        -2261.7275390625,
        639.2811889648438
      ],
      "bbox_max": [
        -585.6702270507812,
        -2222.47314453125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -587.6763916015625,
        -2261.7275390625,
        639.2811889648438
      ],
      "bbox_max": [
        -585.6702270507812,
        -2260.23974609375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350937843323,
        0.26420632004737854,
        0.028835229575634003
      ],
      "plane_d": 1318.23193359375,
      "bbox_min": [
        -774.0778198242188,
        -2414.40576171875,
        150.0
      ],
      "bbox_max": [
        -392.69354248046875,
        -2221.949951171875,
        864.1656494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7370969653129578,
        0.6752943992614746,
        0.02579813450574875
      ],
      "plane_d": 2074.2548828125,
      "bbox_min": [
        -774.0778198242188,
        -2259.91748046875,
        560.3877563476562
      ],
      "bbox_max": [
        -765.472412109375,
        -2257.5107421875,
        864.0850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5812810063362122,
        -0.8116893172264099,
        0.057208240032196045
      ],
      "plane_d": -2210.2236328125,
      "bbox_min": [
        -752.772216796875,
        -2414.40576171875,
        150.0
      ],
      "bbox_max": [
        -392.69354248046875,
        -2221.949951171875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5395222306251526,
        -0.8415294885635376,
        0.027272434905171394
      ],
      "plane_d": -2254.31982421875,
      "bbox_min": [
        -636.64794921875,
        -2413.92529296875,
        150.0
      ],
      "bbox_max": [
        -393.7957458496094,
        -2254.804443359375,
        383.8638610839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8397244811058044,
        -0.5365661978721619,
        0.08342374861240387
      ],
      "plane_d": -1756.9742431640625,
      "bbox_min": [
        -636.64794921875,
        -2258.078125,
        150.0
      ],
      "bbox_max": [
        -621.508544921875,
        -2254.804443359375,
        281.33367919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8397244811058044,
        -0.5365661978721619,
        0.08342374861240387
      ],
      "plane_d": -1756.9742431640625,
      "bbox_min": [
        -634.6590576171875,
        -2272.45166015625,
        150.0
      ],
      "bbox_max": [
        -596.6500854492188,
        -2257.9169921875,
        394.9552307128906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5089108347892761,
        -0.8510450124740601,
        0.1293531060218811
      ],
      "plane_d": -2284.99560546875,
      "bbox_min": [
        -608.2724609375,
        -2269.94384765625,
        382.9001159667969
      ],
      "bbox_max": [
        -596.6500854492188,
        -2261.97998046875,
        394.9552307128906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8221501111984253,
        -0.5637224912643433,
        0.07928481698036194
      ],
      "plane_d": -1806.1368408203125,
      "bbox_min": [
        -615.7688598632812,
        -2262.677001953125,
        331.1248779296875
      ],
      "bbox_max": [
        -608.2724609375,
        -2259.3193359375,
        385.06915283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.56119704246521,
        -0.8256406784057617,
        0.058097995817661285
      ],
      "plane_d": -2231.885986328125,
      "bbox_min": [
        -752.772216796875,
        -2348.42529296875,
        150.0
      ],
      "bbox_max": [
        -541.8916015625,
        -2221.949951171875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5089108347892761,
        -0.8510450124740601,
        0.1293531060218811
      ],
      "plane_d": -2284.99560546875,
      "bbox_min": [
        -608.2724609375,
        -2312.4736328125,
        318.5225830078125
      ],
      "bbox_max": [
        -541.8916015625,
        -2262.677001953125,
        384.9858703613281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -704.5369873046875,
        -2348.38916015625,
        630.2252807617188
      ],
      "bbox_max": [
        -587.6763916015625,
        -2261.7275390625,
        639.2811889648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -752.772216796875,
        -2348.42529296875,
        639.2811889648438
      ],
      "bbox_max": [
        -587.58447265625,
        -2221.949951171875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -752.772216796875,
        -2348.42529296875,
        639.28125
      ],
      "bbox_max": [
        -587.58447265625,
        -2221.949951171875,
        641.6248779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -750.960693359375,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -639.414794921875,
        -2224.87109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -5704.521484375,
        -4608.80029296875,
        150.0
      ],
      "bbox_max": [
        2026.580078125,
        6871.484375,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5704.521484375,
        -4608.80029296875,
        182.8954315185547
      ],
      "bbox_max": [
        2026.580078125,
        6871.484375,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5704.521484375,
        -4608.80029296875,
        552.5599975585938
      ],
      "bbox_max": [
        2026.580078125,
        5224.01171875,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9105714559555054,
        -0.4126048982143402,
        0.024836042895913124
      ],
      "plane_d": 433.4289855957031,
      "bbox_min": [
        760.3065795898438,
        -3681.71923828125,
        552.5599975585938
      ],
      "bbox_max": [
        2026.580078125,
        -2605.58203125,
        1720.60791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9081138372421265,
        -0.4138675034046173,
        0.0635838732123375
      ],
      "plane_d": 379.5241394042969,
      "bbox_min": [
        1754.619140625,
        -3297.8095703125,
        1156.7398681640625
      ],
      "bbox_max": [
        2026.580078125,
        -2750.126220703125,
        1703.96142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8943387866020203,
        -0.44703900814056396,
        0.017724694684147835
      ],
      "plane_d": 318.7131652832031,
      "bbox_min": [
        1754.619140625,
        -3297.8095703125,
        1156.7398681640625
      ],
      "bbox_max": [
        2026.580078125,
        -2750.126220703125,
        1703.96142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659723997116089,
        0.49964767694473267,
        0.02107161097228527
      ],
      "plane_d": 3356.937255859375,
      "bbox_min": [
        2001.875,
        -3297.8095703125,
        1156.7398681640625
      ],
      "bbox_max": [
        2026.580078125,
        -3275.88916015625,
        1653.20458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        2014.762939453125,
        -3296.4345703125,
        1652.26123046875
      ],
      "bbox_max": [
        2026.580078125,
        -3275.88916015625,
        1653.20458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        2013.76904296875,
        -3296.4443359375,
        1634.694091796875
      ],
      "bbox_max": [
        2026.580078125,
        -3275.88916015625,
        1652.7911376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        2013.76904296875,
        -3296.392822265625,
        1639.1903076171875
      ],
      "bbox_max": [
        2026.580078125,
        -3275.88916015625,
        1652.7911376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06812496483325958,
        -0.997347891330719,
        0.025613870471715927
      ],
      "plane_d": -2915.289306640625,
      "bbox_min": [
        760.3065795898438,
        -3681.71923828125,
        552.5599975585938
      ],
      "bbox_max": [
        2014.793212890625,
        -2605.58203125,
        1720.60791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3725520372390747,
        -0.92739337682724,
        0.03386054188013077
      ],
      "plane_d": -3115.656005859375,
      "bbox_min": [
        760.3065795898438,
        -2838.53125,
        553.19140625
      ],
      "bbox_max": [
        1764.1435546875,
        -2605.58203125,
        1720.60791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3894716799259186,
        -0.9198893308639526,
        0.04599304869771004
      ],
      "plane_d": -3136.525146484375,
      "bbox_min": [
        760.3065795898438,
        -2838.53125,
        621.9722290039062
      ],
      "bbox_max": [
        1600.6016845703125,
        -2605.58203125,
        1720.60791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7266949415206909,
        -0.6864138841629028,
        0.02739434503018856
      ],
      "plane_d": -1257.5203857421875,
      "bbox_min": [
        760.3065795898438,
        -2838.53125,
        621.9722290039062
      ],
      "bbox_max": [
        1296.56396484375,
        -2605.58203125,
        948.8619995117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29879969358444214,
        -0.9538390636444092,
        0.030162015929818153
      ],
      "plane_d": -3092.20263671875,
      "bbox_min": [
        976.0157470703125,
        -2838.53125,
        621.9722290039062
      ],
      "bbox_max": [
        1296.56396484375,
        -2811.343994140625,
        948.8619995117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05928827077150345,
        -0.9979740977287292,
        0.02307876944541931
      ],
      "plane_d": -2906.13037109375,
      "bbox_min": [
        976.0157470703125,
        -2838.53125,
        660.022705078125
      ],
      "bbox_max": [
        1047.982666015625,
        -2833.063232421875,
        898.5689697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7206773161888123,
        -0.6925857067108154,
        0.03080742061138153
      ],
      "plane_d": -1281.2325439453125,
      "bbox_min": [
        760.3065795898438,
        -2670.761474609375,
        676.2077026367188
      ],
      "bbox_max": [
        817.7457275390625,
        -2605.58203125,
        888.5103149414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39029523730278015,
        -0.9200517535209656,
        0.034270964562892914
      ],
      "plane_d": -2129.463623046875,
      "bbox_min": [
        760.3065795898438,
        -2612.369140625,
        678.1928100585938
      ],
      "bbox_max": [
        764.182373046875,
        -2605.58203125,
        888.5103149414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42840009927749634,
        -0.9027422070503235,
        0.039113715291023254
      ],
      "plane_d": -1777.53173828125,
      "bbox_min": [
        1591.5947265625,
        -2676.51708984375,
        1150.0341796875
      ],
      "bbox_max": [
        1600.6016845703125,
        -2649.783935546875,
        1720.60791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40383750200271606,
        -0.9135333299636841,
        0.048705875873565674
      ],
      "plane_d": -1861.72412109375,
      "bbox_min": [
        1591.5947265625,
        -2654.99267578125,
        1693.0775146484375
      ],
      "bbox_max": [
        1600.6016845703125,
        -2649.783935546875,
        1720.60791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4576248228549957,
        -0.8877981305122375,
        0.04892735183238983
      ],
      "plane_d": -1702.181884765625,
      "bbox_min": [
        1278.4931640625,
        -2816.019775390625,
        553.19140625
      ],
      "bbox_max": [
        1764.1435546875,
        -2653.7763671875,
        1720.4039306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4312950074672699,
        -0.9005617499351501,
        0.054527778178453445
      ],
      "plane_d": -1784.802734375,
      "bbox_min": [
        1595.83349609375,
        -2785.55224609375,
        553.19140625
      ],
      "bbox_max": [
        1758.2896728515625,
        -2676.51708984375,
        1718.481201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8943387866020203,
        -0.44703900814056396,
        0.017724694684147835
      ],
      "plane_d": 318.7131652832031,
      "bbox_min": [
        1595.83349609375,
        -2756.008056640625,
        1150.0341796875
      ],
      "bbox_max": [
        1758.2896728515625,
        -2676.51708984375,
        1718.481201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40383750200271606,
        -0.9135333299636841,
        0.048705875873565674
      ],
      "plane_d": -1861.72412109375,
      "bbox_min": [
        1595.83349609375,
        -2750.126220703125,
        1150.0341796875
      ],
      "bbox_max": [
        1754.619140625,
        -2676.51708984375,
        1718.481201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42840009927749634,
        -0.9027422070503235,
        0.039113715291023254
      ],
      "plane_d": -1777.53173828125,
      "bbox_min": [
        1595.83349609375,
        -2750.126220703125,
        1150.0341796875
      ],
      "bbox_max": [
        1754.619140625,
        -2676.51708984375,
        1437.47314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29879969358444214,
        -0.9538390636444092,
        0.030162015929818153
      ],
      "plane_d": -3092.20263671875,
      "bbox_min": [
        1278.4931640625,
        -2816.019775390625,
        602.8902587890625
      ],
      "bbox_max": [
        1403.9776611328125,
        -2782.974853515625,
        948.8619995117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42840009927749634,
        -0.9027422070503235,
        0.039113715291023254
      ],
      "plane_d": -1777.53173828125,
      "bbox_min": [
        1595.83349609375,
        -2762.368408203125,
        1150.0341796875
      ],
      "bbox_max": [
        1764.1435546875,
        -2653.7763671875,
        1720.4039306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40383750200271606,
        -0.9135333299636841,
        0.048705875873565674
      ],
      "plane_d": -1861.72412109375,
      "bbox_min": [
        1600.0574951171875,
        -2727.590576171875,
        1437.4730224609375
      ],
      "bbox_max": [
        1753.397705078125,
        -2653.7763671875,
        1720.4039306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8943387866020203,
        -0.44703900814056396,
        0.017724694684147835
      ],
      "plane_d": 318.7131652832031,
      "bbox_min": [
        1748.0452880859375,
        -2788.801513671875,
        552.5599975585938
      ],
      "bbox_max": [
        1769.0184326171875,
        -2748.426513671875,
        1713.7091064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4312950074672699,
        -0.9005617499351501,
        0.054527778178453445
      ],
      "plane_d": -1784.802734375,
      "bbox_min": [
        1748.0452880859375,
        -2788.801513671875,
        552.5599975585938
      ],
      "bbox_max": [
        1754.750244140625,
        -2781.122802734375,
        679.1740112304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660708069801331,
        0.49953848123550415,
        0.019560152664780617
      ],
      "plane_d": 3358.522216796875,
      "bbox_min": [
        1769.20166015625,
        -3681.504150390625,
        653.6094970703125
      ],
      "bbox_max": [
        2014.793212890625,
        -3295.01806640625,
        1670.210693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659723997116089,
        0.49964767694473267,
        0.02107161097228527
      ],
      "plane_d": 3356.937255859375,
      "bbox_min": [
        1786.37353515625,
        -3673.044677734375,
        1156.7398681640625
      ],
      "bbox_max": [
        2014.793212890625,
        -3295.5869140625,
        1670.210693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        1801.53173828125,
        -3666.802001953125,
        1652.7911376953125
      ],
      "bbox_max": [
        2014.793212890625,
        -3296.392822265625,
        1670.210693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1790.0635986328125,
        -3671.369873046875,
        1314.2698974609375
      ],
      "bbox_max": [
        2014.762939453125,
        -3295.5869140625,
        1662.3399658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        1800.7913818359375,
        -3666.360595703125,
        1644.8177490234375
      ],
      "bbox_max": [
        2014.762939453125,
        -3295.5869140625,
        1662.3399658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9155784845352173,
        -0.4009268283843994,
        0.03120390512049198
      ],
      "plane_d": 474.5985412597656,
      "bbox_min": [
        979.433349609375,
        -3665.183349609375,
        562.148193359375
      ],
      "bbox_max": [
        2001.875,
        -2758.224609375,
        1712.567626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        979.433349609375,
        -3665.183349609375,
        623.7822265625
      ],
      "bbox_max": [
        1959.78662109375,
        -2811.343994140625,
        1584.1126708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05928827077150345,
        -0.9979740977287292,
        0.02307876944541931
      ],
      "plane_d": -2906.13037109375,
      "bbox_min": [
        979.433349609375,
        -2834.50732421875,
        655.3497314453125
      ],
      "bbox_max": [
        1078.9036865234375,
        -2832.7783203125,
        898.5689697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7294062972068787,
        -0.6833374500274658,
        0.03188285231590271
      ],
      "plane_d": -1250.1822509765625,
      "bbox_min": [
        -860.804443359375,
        -4608.80029296875,
        644.5755004882812
      ],
      "bbox_max": [
        1802.312255859375,
        -1959.4697265625,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06812496483325958,
        -0.997347891330719,
        0.025613870471715927
      ],
      "plane_d": -2915.289306640625,
      "bbox_min": [
        979.433349609375,
        -3685.36279296875,
        644.5755004882812
      ],
      "bbox_max": [
        1802.312255859375,
        -2812.84619140625,
        1670.4556884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08063693344593048,
        -0.9962690472602844,
        0.030752675607800484
      ],
      "plane_d": -2933.128662109375,
      "bbox_min": [
        993.19775390625,
        -2812.98291015625,
        1640.0830078125
      ],
      "bbox_max": [
        994.8046875,
        -2812.84619140625,
        1644.060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660708069801331,
        0.49953848123550415,
        0.019560152664780617
      ],
      "plane_d": 3358.522216796875,
      "bbox_min": [
        1766.830322265625,
        -3685.36279296875,
        644.5755004882812
      ],
      "bbox_max": [
        1802.312255859375,
        -3651.407470703125,
        1670.4556884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659723997116089,
        0.49964767694473267,
        0.02107161097228527
      ],
      "plane_d": 3356.937255859375,
      "bbox_min": [
        1766.830322265625,
        -3685.36279296875,
        644.5755004882812
      ],
      "bbox_max": [
        1802.312255859375,
        -3665.942138671875,
        1670.4556884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        1766.830322265625,
        -3685.36279296875,
        644.5755004882812
      ],
      "bbox_max": [
        1802.312255859375,
        -3666.360595703125,
        1670.4556884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8598151206970215,
        0.5105383396148682,
        0.008278584107756615
      ],
      "plane_d": 3395.324462890625,
      "bbox_min": [
        1766.830322265625,
        -3685.36279296875,
        644.5755004882812
      ],
      "bbox_max": [
        1769.20166015625,
        -3681.504150390625,
        653.609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        1787.1900634765625,
        -3676.184326171875,
        1310.1553955078125
      ],
      "bbox_max": [
        1801.53173828125,
        -3665.942138671875,
        1662.478759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1787.1900634765625,
        -3676.184326171875,
        1310.1553955078125
      ],
      "bbox_max": [
        1790.171875,
        -3671.2265625,
        1314.85400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        1771.999755859375,
        -3676.04736328125,
        1310.715087890625
      ],
      "bbox_max": [
        1800.7913818359375,
        -3651.407470703125,
        1655.017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1771.999755859375,
        -3676.04736328125,
        1310.715087890625
      ],
      "bbox_max": [
        1790.0635986328125,
        -3651.407470703125,
        1395.6650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05558627471327782,
        -0.9981671571731567,
        0.023929543793201447
      ],
      "plane_d": -2500.691162109375,
      "bbox_min": [
        -860.804443359375,
        -4608.80029296875,
        645.2726440429688
      ],
      "bbox_max": [
        1799.25146484375,
        -1959.4697265625,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18212848901748657,
        -0.982732355594635,
        0.03265484794974327
      ],
      "plane_d": -2444.977783203125,
      "bbox_min": [
        -860.804443359375,
        -2518.948486328125,
        699.5957641601562
      ],
      "bbox_max": [
        546.915771484375,
        -1959.4697265625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -860.804443359375,
        -2319.727783203125,
        864.093994140625
      ],
      "bbox_max": [
        -752.1456298828125,
        -2170.46875,
        1402.14111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -860.804443359375,
        -2315.933837890625,
        864.3192749023438
      ],
      "bbox_max": [
        -755.8292236328125,
        -2170.46875,
        1131.8846435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -776.570068359375,
        -2315.933837890625,
        864.4051513671875
      ],
      "bbox_max": [
        -755.8292236328125,
        -2260.681396484375,
        1049.9979248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.785592257976532,
        0.6162072420120239,
        -0.05597551912069321
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -776.570068359375,
        -2280.1435546875,
        864.9730834960938
      ],
      "bbox_max": [
        -768.0801391601562,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -776.570068359375,
        -2275.6953125,
        864.9730834960938
      ],
      "bbox_max": [
        -770.2198486328125,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7176309823989868,
        0.6963256597518921,
        0.011679554358124733
      ],
      "plane_d": 2144.92041015625,
      "bbox_min": [
        -776.570068359375,
        -2315.933837890625,
        864.4051513671875
      ],
      "bbox_max": [
        -755.8292236328125,
        -2260.681396484375,
        1017.7451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350937843323,
        0.26420632004737854,
        0.028835229575634003
      ],
      "plane_d": 1318.23193359375,
      "bbox_min": [
        -776.570068359375,
        -2273.465576171875,
        864.4051513671875
      ],
      "bbox_max": [
        -770.2131958007812,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -776.570068359375,
        -2273.465576171875,
        864.970947265625
      ],
      "bbox_max": [
        -770.2131958007812,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7370969653129578,
        0.6752943992614746,
        0.02579813450574875
      ],
      "plane_d": 2074.2548828125,
      "bbox_min": [
        -808.562255859375,
        -2260.681396484375,
        864.3192749023438
      ],
      "bbox_max": [
        -776.570068359375,
        -2222.119384765625,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025795936584,
        0.34713056683540344,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -786.48876953125,
        -2319.727783203125,
        864.093994140625
      ],
      "bbox_max": [
        -752.1456298828125,
        -2260.1357421875,
        1402.14111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7176309823989868,
        0.6963256597518921,
        0.011679554358124733
      ],
      "plane_d": 2144.92041015625,
      "bbox_min": [
        -776.570068359375,
        -2319.727783203125,
        864.093994140625
      ],
      "bbox_max": [
        -752.1456298828125,
        -2260.1357421875,
        1009.4588012695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350937843323,
        0.26420632004737854,
        0.028835229575634003
      ],
      "plane_d": 1318.23193359375,
      "bbox_min": [
        -776.570068359375,
        -2264.861572265625,
        864.093994140625
      ],
      "bbox_max": [
        -772.55126953125,
        -2260.1357421875,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -781.7940673828125,
        -2518.948486328125,
        699.5957641601562
      ],
      "bbox_max": [
        546.915771484375,
        -1959.4697265625,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36469170451164246,
        -0.3489462733268738,
        0.8632707595825195
      ],
      "plane_d": -1642.7313232421875,
      "bbox_min": [
        -629.8267211914062,
        -2061.09716796875,
        817.476806640625
      ],
      "bbox_max": [
        -528.131103515625,
        -1959.4697265625,
        871.233154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4237554669380188,
        -0.9054881930351257,
        0.022859251126646996
      ],
      "plane_d": -2065.258056640625,
      "bbox_min": [
        -781.7940673828125,
        -2518.948486328125,
        699.5957641601562
      ],
      "bbox_max": [
        546.915771484375,
        -2251.306396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.043660908937454224,
        -0.9987923502922058,
        0.02252989076077938
      ],
      "plane_d": -2507.651123046875,
      "bbox_min": [
        -781.7940673828125,
        -2518.778076171875,
        699.6304321289062
      ],
      "bbox_max": [
        546.915771484375,
        -2251.306396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7370969653129578,
        0.6752943992614746,
        0.02579813450574875
      ],
      "plane_d": 2074.2548828125,
      "bbox_min": [
        -781.7940673828125,
        -2425.207275390625,
        790.674560546875
      ],
      "bbox_max": [
        -191.0,
        -2251.306396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350937843323,
        0.26420632004737854,
        0.028835229575634003
      ],
      "plane_d": 1318.23193359375,
      "bbox_min": [
        -776.570068359375,
        -2260.681396484375,
        864.07958984375
      ],
      "bbox_max": [
        -773.8370971679688,
        -2259.91748046875,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5994062423706055,
        -0.7998847365379333,
        0.029941599816083908
      ],
      "plane_d": -2178.19677734375,
      "bbox_min": [
        -427.0450439453125,
        -2425.207275390625,
        790.674560546875
      ],
      "bbox_max": [
        -191.0,
        -2360.5,
        846.5617065429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2402.0,
      "bbox_min": [
        -235.0,
        -2425.207275390625,
        790.674560546875
      ],
      "bbox_max": [
        -191.0,
        -2360.5,
        815.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2385.0,
      "bbox_min": [
        -215.0,
        -2402.0,
        790.674560546875
      ],
      "bbox_max": [
        -191.0,
        -2360.5,
        803.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -210.5,
        -2385.0,
        790.674560546875
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -210.5,
        -2360.5,
        797.5
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -210.5,
        -2385.0,
        790.674560546875
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2385.0,
        791.9916381835938
      ],
      "bbox_max": [
        -195.5,
        -2371.5,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2373.0,
      "bbox_min": [
        -210.5,
        -2385.0,
        791.9916381835938
      ],
      "bbox_max": [
        -195.5,
        -2371.5,
        797.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        792.3419189453125
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -199.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        792.3419189453125
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 207.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        793.5038452148438
      ],
      "bbox_max": [
        -207.0,
        -2371.5,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2385.0,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2373.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857492983341217,
        -0.0,
        -0.5144957900047302
      ],
      "plane_d": 238.81179809570312,
      "bbox_min": [
        -210.5,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2377.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2380.5,
      "bbox_min": [
        -200.0,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2377.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -196.09799194335938,
        -2377.82421875,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2377.0,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.857492983341217,
        0.0,
        -0.5144957900047302
      ],
      "plane_d": 586.9539794921875,
      "bbox_min": [
        -210.5,
        -2380.5,
        794.2235717773438
      ],
      "bbox_max": [
        -206.0,
        -2377.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2380.5,
      "bbox_min": [
        -210.5,
        -2380.5,
        794.5628051757812
      ],
      "bbox_max": [
        -206.0,
        -2380.5,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -210.5,
        -2402.0,
        793.7828369140625
      ],
      "bbox_max": [
        -195.5,
        -2390.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2402.0,
        793.7828369140625
      ],
      "bbox_max": [
        -195.5,
        -2390.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2402.0,
        794.5731201171875
      ],
      "bbox_max": [
        -195.5,
        -2390.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2397.5,
      "bbox_min": [
        -210.5,
        -2397.5,
        794.5731201171875
      ],
      "bbox_max": [
        -195.5,
        -2394.0,
        797.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.857492983341217,
        -0.0,
        -0.5144957900047302
      ],
      "plane_d": 238.81179809570312,
      "bbox_min": [
        -206.97726440429688,
        -2397.5,
        794.6056518554688
      ],
      "bbox_max": [
        -198.26341247558594,
        -2394.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.857492983341217,
        0.0,
        -0.5144957900047302
      ],
      "plane_d": 586.9539794921875,
      "bbox_min": [
        -206.97726440429688,
        -2397.5,
        795.8712158203125
      ],
      "bbox_max": [
        -206.0,
        -2394.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -217.5,
      "bbox_min": [
        -235.0,
        -2425.207275390625,
        795.5740356445312
      ],
      "bbox_max": [
        -191.0,
        -2407.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2419.0,
      "bbox_min": [
        -213.88975524902344,
        -2425.207275390625,
        795.5740356445312
      ],
      "bbox_max": [
        -191.0,
        -2407.0,
        803.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -208.76077270507812,
        -2419.0,
        795.5740356445312
      ],
      "bbox_max": [
        -195.5,
        -2407.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -200.0,
        -2419.0,
        795.5740356445312
      ],
      "bbox_max": [
        -195.5,
        -2407.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2414.5,
      "bbox_min": [
        -200.0,
        -2414.5,
        796.3643188476562
      ],
      "bbox_max": [
        -195.5,
        -2411.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857492983341217,
        -0.0,
        -0.5144957900047302
      ],
      "plane_d": 238.81179809570312,
      "bbox_min": [
        -200.0,
        -2414.5,
        796.56787109375
      ],
      "bbox_max": [
        -199.4407196044922,
        -2411.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.0,
        -0.768221378326416
      ],
      "plane_d": 491.1495361328125,
      "bbox_min": [
        -213.88975524902344,
        -2425.207275390625,
        797.3652954101562
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2407.25,
      "bbox_min": [
        -235.0,
        -2418.680908203125,
        800.0
      ],
      "bbox_max": [
        -217.5,
        -2407.25,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 235.0,
      "bbox_min": [
        -235.0,
        -2418.680908203125,
        800.0
      ],
      "bbox_max": [
        -217.5,
        -2407.25,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -800.0,
      "bbox_min": [
        -225.79293823242188,
        -2418.680908203125,
        800.0
      ],
      "bbox_max": [
        -217.5,
        -2407.25,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16672015190124512,
        -0.9851060509681702,
        0.0420771948993206
      ],
      "plane_d": -2461.554931640625,
      "bbox_min": [
        -775.0046997070312,
        -2497.438232421875,
        750.2604370117188
      ],
      "bbox_max": [
        192.06858825683594,
        -2297.716796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025795936584,
        0.34713056683540344,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -775.0046997070312,
        -2497.438232421875,
        750.2604370117188
      ],
      "bbox_max": [
        182.40977478027344,
        -2297.716796875,
        1411.5374755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -765.3306274414062,
        -2497.438232421875,
        750.2604370117188
      ],
      "bbox_max": [
        182.40977478027344,
        -2311.351806640625,
        1257.8922119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -765.3306274414062,
        -2325.078125,
        1051.602294921875
      ],
      "bbox_max": [
        -743.9637451171875,
        -2312.703125,
        1257.8922119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7176309823989868,
        0.6963256597518921,
        0.011679554358124733
      ],
      "plane_d": 2144.92041015625,
      "bbox_min": [
        -762.6567993164062,
        -2497.438232421875,
        750.2604370117188
      ],
      "bbox_max": [
        182.40977478027344,
        -2311.351806640625,
        1060.670166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1616773158311844,
        -0.9864528775215149,
        0.027771705761551857
      ],
      "plane_d": -2454.997314453125,
      "bbox_min": [
        -235.0,
        -2497.438232421875,
        750.2604370117188
      ],
      "bbox_max": [
        182.40977478027344,
        -2417.304931640625,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6726728081703186,
        0.0,
        -0.7399401068687439
      ],
      "plane_d": 735.466796875,
      "bbox_min": [
        -213.6124267578125,
        -2425.2783203125,
        797.4924926757812
      ],
      "bbox_max": [
        -195.5,
        -2421.775146484375,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -195.55975341796875,
        -2425.2783203125,
        797.4924926757812
      ],
      "bbox_max": [
        -195.5,
        -2425.196044921875,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -195.5,
        -2425.2783203125,
        797.4924926757812
      ],
      "bbox_max": [
        -195.5,
        -2425.20703125,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2425.0,
      "bbox_min": [
        -235.0,
        -2426.4404296875,
        800.6658325195312
      ],
      "bbox_max": [
        -217.5,
        -2417.304931640625,
        815.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 235.0,
      "bbox_min": [
        -235.0,
        -2424.69384765625,
        802.4406127929688
      ],
      "bbox_max": [
        -235.0,
        -2417.304931640625,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -762.6567993164062,
        -2313.075927734375,
        1017.7451171875
      ],
      "bbox_max": [
        -761.0499267578125,
        -2311.351806640625,
        1060.670166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -762.6567993164062,
        -2312.703125,
        1049.9979248046875
      ],
      "bbox_max": [
        -761.962646484375,
        -2311.351806640625,
        1060.670166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0943203866481781,
        -0.9947079420089722,
        0.04074132815003395
      ],
      "plane_d": -2462.647705078125,
      "bbox_min": [
        -771.4268188476562,
        -2478.035400390625,
        783.7666015625
      ],
      "bbox_max": [
        -78.703857421875,
        -2307.923095703125,
        1480.5965576171875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8306585550308228,
        0.5565486550331116,
        0.01612250879406929
      ],
      "plane_d": 1888.747802734375,
      "bbox_min": [
        -771.4268188476562,
        -2467.271484375,
        801.370849609375
      ],
      "bbox_max": [
        -195.8740692138672,
        -2307.923095703125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -703.9307861328125,
        -2437.622802734375,
        865.6229248046875
      ],
      "bbox_max": [
        -665.3473510742188,
        -2371.319091796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.838594913482666,
        0.5422794818878174,
        0.05188118666410446
      ],
      "plane_d": 1814.8121337890625,
      "bbox_min": [
        -698.2745361328125,
        -2437.622802734375,
        1258.9176025390625
      ],
      "bbox_max": [
        -665.3473510742188,
        -2407.66796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8297061324119568,
        0.5531379580497742,
        0.07500854879617691
      ],
      "plane_d": 1800.5321044921875,
      "bbox_min": [
        -697.61474609375,
        -2432.476806640625,
        1457.0142822265625
      ],
      "bbox_max": [
        -680.15087890625,
        -2409.47900390625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -771.4268188476562,
        -2408.3671875,
        865.894287109375
      ],
      "bbox_max": [
        -685.0712890625,
        -2307.923095703125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -767.986572265625,
        -2408.3671875,
        1118.72021484375
      ],
      "bbox_max": [
        -685.0712890625,
        -2313.14404296875,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -738.92578125,
        -2408.3671875,
        1178.7537841796875
      ],
      "bbox_max": [
        -685.0712890625,
        -2333.139892578125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.838594913482666,
        0.5422794818878174,
        0.05188118666410446
      ],
      "plane_d": 1814.8121337890625,
      "bbox_min": [
        -738.92578125,
        -2408.3671875,
        1258.9176025390625
      ],
      "bbox_max": [
        -685.0712890625,
        -2339.8720703125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025795936584,
        0.34713056683540344,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -767.986572265625,
        -2317.737060546875,
        1257.8922119140625
      ],
      "bbox_max": [
        -765.3306274414062,
        -2313.14404296875,
        1420.5723876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025795936584,
        0.34713056683540344,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -771.4268188476562,
        -2317.737060546875,
        1305.910888671875
      ],
      "bbox_max": [
        -767.23583984375,
        -2307.923095703125,
        1420.5723876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.430268257856369,
        -0.8978968262672424,
        0.09300856292247772
      ],
      "plane_d": -2403.1669921875,
      "bbox_min": [
        -733.7510986328125,
        -2467.271484375,
        801.370849609375
      ],
      "bbox_max": [
        -195.8740692138672,
        -2332.134033203125,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5384513735771179,
        -0.8420933485031128,
        0.03080403432250023
      ],
      "plane_d": -2256.63623046875,
      "bbox_min": [
        -394.64996337890625,
        -2461.870361328125,
        801.370849609375
      ],
      "bbox_max": [
        -195.8740692138672,
        -2394.941162109375,
        876.422607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5994062423706055,
        -0.7998847365379333,
        0.029941599816083908
      ],
      "plane_d": -2178.19677734375,
      "bbox_min": [
        -394.64996337890625,
        -2461.870361328125,
        801.370849609375
      ],
      "bbox_max": [
        -195.8740692138672,
        -2394.941162109375,
        876.422607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2461.5,
      "bbox_min": [
        -200.085205078125,
        -2461.870361328125,
        801.370849609375
      ],
      "bbox_max": [
        -195.8740692138672,
        -2461.5,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7863183617591858,
        0.0,
        0.6178215742111206
      ],
      "plane_d": -652.812744140625,
      "bbox_min": [
        -200.085205078125,
        -2461.870361328125,
        801.9824829101562
      ],
      "bbox_max": [
        -197.00942993164062,
        -2461.5,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -804.0,
      "bbox_min": [
        -198.5,
        -2461.641357421875,
        804.0
      ],
      "bbox_max": [
        -197.00942993164062,
        -2461.5,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 230.0,
      "bbox_min": [
        -235.0,
        -2445.0,
        801.8832397460938
      ],
      "bbox_max": [
        -215.0,
        -2424.1884765625,
        815.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 815.0,
      "bbox_min": [
        -235.0,
        -2425.0,
        815.0
      ],
      "bbox_max": [
        -230.2054443359375,
        -2424.1884765625,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 805.0,
      "bbox_min": [
        -230.0,
        -2445.0,
        801.8832397460938
      ],
      "bbox_max": [
        -215.0,
        -2425.4619140625,
        805.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2440.0,
      "bbox_min": [
        -225.0,
        -2445.0,
        801.8832397460938
      ],
      "bbox_max": [
        -215.0,
        -2426.308349609375,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -225.0,
      "bbox_min": [
        -225.0,
        -2440.0,
        801.9068603515625
      ],
      "bbox_max": [
        -225.0,
        -2426.308349609375,
        805.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -733.7510986328125,
        -2407.66796875,
        1138.888427734375
      ],
      "bbox_max": [
        -685.0712890625,
        -2332.134033203125,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -733.7510986328125,
        -2333.139892578125,
        1156.9888916015625
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.134033203125,
        1178.7537841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -733.7510986328125,
        -2332.605712890625,
        1156.9888916015625
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.134033203125,
        1165.040771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -804.0,
      "bbox_min": [
        -200.0576934814453,
        -2478.035400390625,
        800.735595703125
      ],
      "bbox_max": [
        -138.0,
        -2461.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 191.5,
      "bbox_min": [
        -200.0576934814453,
        -2475.38720703125,
        800.735595703125
      ],
      "bbox_max": [
        -191.5,
        -2461.5,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2461.5,
      "bbox_min": [
        -197.00942993164062,
        -2461.5,
        800.735595703125
      ],
      "bbox_max": [
        -191.5,
        -2461.5,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -144.0,
        -2478.035400390625,
        816.0
      ],
      "bbox_max": [
        -138.0,
        -2477.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        -144.0,
        -2478.035400390625,
        816.0
      ],
      "bbox_max": [
        -138.0,
        -2477.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -144.0,
      "bbox_min": [
        -144.0,
        -2477.701416015625,
        816.0
      ],
      "bbox_max": [
        -144.0,
        -2477.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38716989755630493,
        -0.9217076897621155,
        0.02354820817708969
      ],
      "plane_d": -2126.6396484375,
      "bbox_min": [
        -682.7564697265625,
        -4608.80029296875,
        645.2726440429688
      ],
      "bbox_max": [
        1799.25146484375,
        -2431.766357421875,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35056573152542114,
        -0.9358264207839966,
        0.03650654852390289
      ],
      "plane_d": -2202.912841796875,
      "bbox_min": [
        546.5700073242188,
        -2605.58203125,
        699.4942016601562
      ],
      "bbox_max": [
        775.06298828125,
        -2497.324462890625,
        1637.255126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4237554669380188,
        -0.9054881930351257,
        0.022859251126646996
      ],
      "plane_d": -2065.258056640625,
      "bbox_min": [
        546.5700073242188,
        -2519.44775390625,
        699.4942016601562
      ],
      "bbox_max": [
        547.6314086914062,
        -2516.287841796875,
        811.3943481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7914848923683167,
        0.6107789874076843,
        -0.022378742694854736
      ],
      "plane_d": 3637.23583984375,
      "bbox_min": [
        -682.7564697265625,
        -4608.80029296875,
        645.2726440429688
      ],
      "bbox_max": [
        1799.25146484375,
        -2431.766357421875,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7589735984802246,
        0.6511198282241821,
        -0.001435855752788484
      ],
      "plane_d": 3757.080322265625,
      "bbox_min": [
        1002.39794921875,
        -4598.2626953125,
        645.2726440429688
      ],
      "bbox_max": [
        1799.25146484375,
        -3656.015869140625,
        1763.11181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7015435695648193,
        0.7094086408615112,
        0.0676460936665535
      ],
      "plane_d": 3858.47607421875,
      "bbox_min": [
        1002.39794921875,
        -4598.2626953125,
        682.8560791015625
      ],
      "bbox_max": [
        1799.25146484375,
        -3671.165283203125,
        1761.0574951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660708069801331,
        0.49953848123550415,
        0.019560152664780617
      ],
      "plane_d": 3358.522216796875,
      "bbox_min": [
        1002.39794921875,
        -4598.2626953125,
        682.8560791015625
      ],
      "bbox_max": [
        1799.25146484375,
        -3671.165283203125,
        1761.0574951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        1675.942626953125,
        -3883.381103515625,
        1201.9404296875
      ],
      "bbox_max": [
        1799.25146484375,
        -3671.24169921875,
        1680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659723997116089,
        0.49964767694473267,
        0.02107161097228527
      ],
      "plane_d": 3356.937255859375,
      "bbox_min": [
        1717.91259765625,
        -3792.250244140625,
        1201.9404296875
      ],
      "bbox_max": [
        1771.896240234375,
        -3701.942626953125,
        1288.141357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6350630521774292,
        0.762075662612915,
        0.12623634934425354
      ],
      "plane_d": 3811.68212890625,
      "bbox_min": [
        1675.942626953125,
        -3883.381103515625,
        1660.62744140625
      ],
      "bbox_max": [
        1680.0,
        -3877.904296875,
        1680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.779249370098114,
        0.6240484714508057,
        0.05773917958140373
      ],
      "plane_d": 957.9458618164062,
      "bbox_min": [
        1002.39794921875,
        -4598.2626953125,
        682.8561401367188
      ],
      "bbox_max": [
        1797.7379150390625,
        -3671.165283203125,
        1761.0574951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8785086870193481,
        0.4433222711086273,
        0.17801031470298767
      ],
      "plane_d": 2773.586669921875,
      "bbox_min": [
        1002.39794921875,
        -4598.2626953125,
        1207.396728515625
      ],
      "bbox_max": [
        1717.91259765625,
        -3778.021240234375,
        1761.0574951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6350630521774292,
        0.762075662612915,
        0.12623634934425354
      ],
      "plane_d": 3811.68212890625,
      "bbox_min": [
        1383.4669189453125,
        -4180.0,
        1207.396728515625
      ],
      "bbox_max": [
        1717.91259765625,
        -3778.021240234375,
        1720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7489288449287415,
        0.6362079381942749,
        0.1853240579366684
      ],
      "plane_d": 3389.09228515625,
      "bbox_min": [
        1383.4669189453125,
        -4180.0,
        1207.610595703125
      ],
      "bbox_max": [
        1717.91259765625,
        -3778.875,
        1720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1664.4010009765625,
        -3827.30908203125,
        1207.610595703125
      ],
      "bbox_max": [
        1717.91259765625,
        -3778.875,
        1261.520263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4963834583759308,
        0.3309214413166046,
        0.8025550246238708
      ],
      "plane_d": -569.6696166992188,
      "bbox_min": [
        1664.4010009765625,
        -3827.30908203125,
        1207.610595703125
      ],
      "bbox_max": [
        1717.91259765625,
        -3778.875,
        1258.5145263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5140525698661804,
        0.5640233159065247,
        0.6462411284446716
      ],
      "plane_d": 473.2470703125,
      "bbox_min": [
        1701.264892578125,
        -3792.250244140625,
        1207.610595703125
      ],
      "bbox_max": [
        1717.91259765625,
        -3778.875,
        1218.6199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7831375598907471,
        0.5788978934288025,
        0.22709693014621735
      ],
      "plane_d": 3144.185546875,
      "bbox_min": [
        1496.0010986328125,
        -4022.9189453125,
        1568.70751953125
      ],
      "bbox_max": [
        1560.0,
        -3980.0,
        1680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44197332859039307,
        0.8725138306617737,
        0.2082766443490982
      ],
      "plane_d": 3812.1787109375,
      "bbox_min": [
        1515.475830078125,
        -4000.1982421875,
        1207.396728515625
      ],
      "bbox_max": [
        1709.8927001953125,
        -3778.021240234375,
        1680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7831375598907471,
        0.5788978934288025,
        0.22709693014621735
      ],
      "plane_d": 3144.185546875,
      "bbox_min": [
        1515.475830078125,
        -4000.1982421875,
        1577.947021484375
      ],
      "bbox_max": [
        1560.0,
        -3967.00244140625,
        1680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        1654.0455322265625,
        -3877.904296875,
        1207.396728515625
      ],
      "bbox_max": [
        1709.8927001953125,
        -3778.021240234375,
        1660.62744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1675.306640625,
        -3814.59033203125,
        1207.396728515625
      ],
      "bbox_max": [
        1708.9287109375,
        -3778.021240234375,
        1269.523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4963834583759308,
        0.3309214413166046,
        0.8025550246238708
      ],
      "plane_d": -569.6696166992188,
      "bbox_min": [
        1692.298095703125,
        -3794.8583984375,
        1207.396728515625
      ],
      "bbox_max": [
        1707.4495849609375,
        -3778.021240234375,
        1227.87939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5140525698661804,
        0.5640233159065247,
        0.6462411284446716
      ],
      "plane_d": 473.2470703125,
      "bbox_min": [
        1700.344482421875,
        -3785.8525390625,
        1207.396728515625
      ],
      "bbox_max": [
        1707.4495849609375,
        -3778.021240234375,
        1219.04345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.88088059425354,
        0.43405717611312866,
        0.18879587948322296
      ],
      "plane_d": 2722.86279296875,
      "bbox_min": [
        1269.7293701171875,
        -4287.13525390625,
        1358.498291015625
      ],
      "bbox_max": [
        1400.0,
        -4154.10400390625,
        1720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7489288449287415,
        0.6362079381942749,
        0.1853240579366684
      ],
      "plane_d": 3389.09228515625,
      "bbox_min": [
        1373.6865234375,
        -4180.0,
        1563.9017333984375
      ],
      "bbox_max": [
        1400.0,
        -4154.10400390625,
        1720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6763855814933777,
        0.7353199124336243,
        -0.042511679232120514
      ],
      "plane_d": 4126.3173828125,
      "bbox_min": [
        1002.39794921875,
        -4598.2626953125,
        1578.7645263671875
      ],
      "bbox_max": [
        1360.0,
        -4260.0,
        1761.0574951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1704.3438720703125,
        -3792.250244140625,
        1210.9613037109375
      ],
      "bbox_max": [
        1771.4212646484375,
        -3702.49658203125,
        1288.010498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660708069801331,
        0.49953848123550415,
        0.019560152664780617
      ],
      "plane_d": 3358.522216796875,
      "bbox_min": [
        1002.39794921875,
        -4598.2626953125,
        645.2726440429688
      ],
      "bbox_max": [
        1797.6087646484375,
        -3656.015869140625,
        1763.11181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659723997116089,
        0.49964767694473267,
        0.02107161097228527
      ],
      "plane_d": 3356.937255859375,
      "bbox_min": [
        1765.1552734375,
        -3709.990234375,
        645.2726440429688
      ],
      "bbox_max": [
        1787.2939453125,
        -3676.04736328125,
        1310.715087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8598151206970215,
        0.5105383396148682,
        0.008278584107756615
      ],
      "plane_d": 3395.324462890625,
      "bbox_min": [
        1765.539306640625,
        -3687.543701171875,
        645.2726440429688
      ],
      "bbox_max": [
        1766.907470703125,
        -3685.287353515625,
        648.6484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44197332859039307,
        0.8725138306617737,
        0.2082766443490982
      ],
      "plane_d": 3812.1787109375,
      "bbox_min": [
        1002.39794921875,
        -4598.2626953125,
        658.3070068359375
      ],
      "bbox_max": [
        1713.8681640625,
        -3725.074462890625,
        1763.11181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.88088059425354,
        0.43405717611312866,
        0.18879587948322296
      ],
      "plane_d": 2722.86279296875,
      "bbox_min": [
        1002.39794921875,
        -4598.2626953125,
        658.3070068359375
      ],
      "bbox_max": [
        1713.8681640625,
        -3725.074462890625,
        1763.11181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7831375598907471,
        0.5788978934288025,
        0.22709693014621735
      ],
      "plane_d": 3144.185546875,
      "bbox_min": [
        1350.5107421875,
        -4165.50537109375,
        658.3070068359375
      ],
      "bbox_max": [
        1713.8681640625,
        -3725.074462890625,
        1591.4462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6872478723526001,
        0.7258203625679016,
        0.029583144932985306
      ],
      "plane_d": 1514.38623046875,
      "bbox_min": [
        1651.71337890625,
        -3835.62158203125,
        658.3070068359375
      ],
      "bbox_max": [
        1713.8681640625,
        -3725.074462890625,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1651.71337890625,
        -3835.62158203125,
        1258.5145263671875
      ],
      "bbox_max": [
        1665.51171875,
        -3826.013671875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7489288449287415,
        0.6362079381942749,
        0.1853240579366684
      ],
      "plane_d": 3389.09228515625,
      "bbox_min": [
        1350.5107421875,
        -4165.50537109375,
        1407.345458984375
      ],
      "bbox_max": [
        1496.001220703125,
        -4022.9189453125,
        1568.70751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6763855814933777,
        0.7353199124336243,
        -0.042511679232120514
      ],
      "plane_d": 4126.3173828125,
      "bbox_min": [
        1002.39794921875,
        -4598.2626953125,
        1220.9613037109375
      ],
      "bbox_max": [
        1269.7293701171875,
        -4287.13525390625,
        1763.11181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8785086870193481,
        0.4433222711086273,
        0.17801031470298767
      ],
      "plane_d": 2773.586669921875,
      "bbox_min": [
        1199.9169921875,
        -4368.81494140625,
        1220.9613037109375
      ],
      "bbox_max": [
        1269.7293701171875,
        -4287.13525390625,
        1358.498291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8635953068733215,
        0.4744468927383423,
        0.17059697210788727
      ],
      "plane_d": 2898.794677734375,
      "bbox_min": [
        1237.76220703125,
        -4313.42529296875,
        1269.789306640625
      ],
      "bbox_max": [
        1269.7293701171875,
        -4287.13525390625,
        1358.498291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        1566.2449951171875,
        -3878.915771484375,
        1197.6212158203125
      ],
      "bbox_max": [
        1706.7816162109375,
        -3739.0,
        1412.5794677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1651.71337890625,
        -3835.62158203125,
        1201.7625732421875
      ],
      "bbox_max": [
        1706.7816162109375,
        -3755.53125,
        1313.169677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4963834583759308,
        0.3309214413166046,
        0.8025550246238708
      ],
      "plane_d": -569.6696166992188,
      "bbox_min": [
        1651.71337890625,
        -3835.62158203125,
        1201.7625732421875
      ],
      "bbox_max": [
        1706.7816162109375,
        -3755.53125,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5140525698661804,
        0.5640233159065247,
        0.6462411284446716
      ],
      "plane_d": 473.2470703125,
      "bbox_min": [
        1679.88720703125,
        -3785.498779296875,
        1201.7625732421875
      ],
      "bbox_max": [
        1706.7816162109375,
        -3755.53125,
        1228.4547119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1269.7891845703125,
      "bbox_min": [
        1566.2449951171875,
        -3878.915771484375,
        1197.6212158203125
      ],
      "bbox_max": [
        1689.1883544921875,
        -3739.0,
        1338.7508544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4963834583759308,
        0.3309214413166046,
        0.8025550246238708
      ],
      "plane_d": -569.6696166992188,
      "bbox_min": [
        1627.584716796875,
        -3835.62158203125,
        1197.6212158203125
      ],
      "bbox_max": [
        1689.1883544921875,
        -3739.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5140525698661804,
        0.5640233159065247,
        0.6462411284446716
      ],
      "plane_d": 473.2470703125,
      "bbox_min": [
        1653.150390625,
        -3777.63720703125,
        1197.6212158203125
      ],
      "bbox_max": [
        1689.1883544921875,
        -3739.0,
        1240.7548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6350630521774292,
        0.762075662612915,
        0.12623634934425354
      ],
      "plane_d": 3811.68212890625,
      "bbox_min": [
        1636.295166015625,
        -3859.893310546875,
        1269.789306640625
      ],
      "bbox_max": [
        1654.0455322265625,
        -3835.62158203125,
        1338.7508544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8595661520957947,
        0.49833256006240845,
        0.11318434029817581
      ],
      "plane_d": 3187.451904296875,
      "bbox_min": [
        1694.231201171875,
        -3786.952880859375,
        1269.523193359375
      ],
      "bbox_max": [
        1797.6087646484375,
        -3656.015869140625,
        1653.70166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914428472518921,
        0.6615005731582642,
        -0.29038578271865845
      ],
      "plane_d": 4048.059814453125,
      "bbox_min": [
        1694.231201171875,
        -3780.7255859375,
        1269.523193359375
      ],
      "bbox_max": [
        1787.1900634765625,
        -3656.015869140625,
        1392.5159912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18212848901748657,
        -0.982732355594635,
        0.03265484794974327
      ],
      "plane_d": -2444.977783203125,
      "bbox_min": [
        -682.7564697265625,
        -2519.6005859375,
        699.463134765625
      ],
      "bbox_max": [
        547.9561767578125,
        -2431.766357421875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1616773158311844,
        -0.9864528775215149,
        0.027771705761551857
      ],
      "plane_d": -2454.997314453125,
      "bbox_min": [
        212.83778381347656,
        -2503.37060546875,
        745.7415771484375
      ],
      "bbox_max": [
        218.717041015625,
        -2502.583984375,
        771.159912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4237554669380188,
        -0.9054881930351257,
        0.022859251126646996
      ],
      "plane_d": -2065.258056640625,
      "bbox_min": [
        217.53436279296875,
        -2519.6005859375,
        699.463134765625
      ],
      "bbox_max": [
        547.9561767578125,
        -2502.8486328125,
        811.3943481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.038124386221170425,
        -0.9989581108093262,
        0.02508561499416828
      ],
      "plane_d": -2511.24755859375,
      "bbox_min": [
        217.53436279296875,
        -2504.015869140625,
        743.809326171875
      ],
      "bbox_max": [
        231.30743408203125,
        -2502.8486328125,
        771.159912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1616773158311844,
        -0.9864528775215149,
        0.027771705761551857
      ],
      "plane_d": -2454.997314453125,
      "bbox_min": [
        217.53436279296875,
        -2503.46533203125,
        745.6693725585938
      ],
      "bbox_max": [
        218.717041015625,
        -2502.8486328125,
        771.159912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8306585550308228,
        0.5565486550331116,
        0.01612250879406929
      ],
      "plane_d": 1888.747802734375,
      "bbox_min": [
        -682.7564697265625,
        -2502.8486328125,
        746.3408203125
      ],
      "bbox_max": [
        218.717041015625,
        -2431.766357421875,
        1480.5965576171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8198854923248291,
        0.5702467560768127,
        0.05105101317167282
      ],
      "plane_d": 1870.3758544921875,
      "bbox_min": [
        -682.7564697265625,
        -2448.8642578125,
        1276.7486572265625
      ],
      "bbox_max": [
        -657.9453125,
        -2431.766357421875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8297061324119568,
        0.5531379580497742,
        0.07500854879617691
      ],
      "plane_d": 1800.5321044921875,
      "bbox_min": [
        -682.7564697265625,
        -2443.513427734375,
        1445.6971435546875
      ],
      "bbox_max": [
        -671.77001953125,
        -2431.766357421875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16672015190124512,
        -0.9851060509681702,
        0.0420771948993206
      ],
      "plane_d": -2461.554931640625,
      "bbox_min": [
        -251.7679443359375,
        -2502.8486328125,
        746.3408203125
      ],
      "bbox_max": [
        218.717041015625,
        -2471.127197265625,
        862.629638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1616773158311844,
        -0.9864528775215149,
        0.027771705761551857
      ],
      "plane_d": -2454.997314453125,
      "bbox_min": [
        182.11636352539062,
        -2502.8486328125,
        746.3408203125
      ],
      "bbox_max": [
        218.717041015625,
        -2497.27294921875,
        771.159912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.430268257856369,
        -0.8978968262672424,
        0.09300856292247772
      ],
      "plane_d": -2403.1669921875,
      "bbox_min": [
        -251.7679443359375,
        -2476.238037109375,
        809.7320556640625
      ],
      "bbox_max": [
        -241.98291015625,
        -2471.127197265625,
        862.629638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -142.0,
      "bbox_min": [
        -199.08656311035156,
        -2486.058349609375,
        795.732177734375
      ],
      "bbox_max": [
        -140.0,
        -2474.939208984375,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 816.0,
      "bbox_min": [
        -142.0,
        -2485.567626953125,
        816.0
      ],
      "bbox_max": [
        -140.0,
        -2485.0,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -142.0,
        -2485.52392578125,
        817.5
      ],
      "bbox_max": [
        -140.0,
        -2485.0,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -142.0,
        -2485.0,
        816.0
      ],
      "bbox_max": [
        -140.0,
        -2477.77685546875,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 816.0,
      "bbox_min": [
        -142.0,
        -2485.0,
        816.0
      ],
      "bbox_max": [
        -140.0,
        -2477.812744140625,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -804.0,
      "bbox_min": [
        -199.08656311035156,
        -2485.478515625,
        802.1988525390625
      ],
      "bbox_max": [
        -142.0,
        -2474.939208984375,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7863183617591858,
        0.0,
        0.6178215742111206
      ],
      "plane_d": -652.812744140625,
      "bbox_min": [
        -199.08656311035156,
        -2482.8330078125,
        803.2534790039062
      ],
      "bbox_max": [
        -198.5,
        -2474.939208984375,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 816.0,
      "bbox_min": [
        -170.0,
        -2485.478515625,
        816.0
      ],
      "bbox_max": [
        -142.0,
        -2477.5,
        817.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -170.0,
        -2485.43505859375,
        816.0
      ],
      "bbox_max": [
        -142.0,
        -2477.5,
        817.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -144.0,
      "bbox_min": [
        -170.0,
        -2485.3896484375,
        816.0
      ],
      "bbox_max": [
        -144.0,
        -2477.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 164.0,
      "bbox_min": [
        -170.0,
        -2484.4990234375,
        816.0
      ],
      "bbox_max": [
        -164.0,
        -2477.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        -170.0,
        -2484.23193359375,
        816.0
      ],
      "bbox_max": [
        -164.0,
        -2477.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2477.5,
      "bbox_min": [
        -170.0,
        -2477.5,
        816.0
      ],
      "bbox_max": [
        -164.0,
        -2477.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 816.0,
      "bbox_min": [
        -140.0,
        -2485.65673828125,
        816.0
      ],
      "bbox_max": [
        -138.0,
        -2477.88818359375,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -140.0,
        -2485.65673828125,
        816.0
      ],
      "bbox_max": [
        -138.0,
        -2477.88818359375,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        -138.0,
        -2485.65673828125,
        816.0
      ],
      "bbox_max": [
        -138.0,
        -2477.99951171875,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9987671971321106,
        -0.046698663383722305,
        0.01683316007256508
      ],
      "plane_d": -920.8641967773438,
      "bbox_min": [
        -675.7212524414062,
        -4392.64306640625,
        696.475830078125
      ],
      "bbox_max": [
        755.9525146484375,
        -2442.319091796875,
        1832.025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7837581038475037,
        0.6171848773956299,
        0.06932444870471954
      ],
      "plane_d": 1857.939453125,
      "bbox_min": [
        -675.7212524414062,
        -4031.08349609375,
        696.475830078125
      ],
      "bbox_max": [
        720.0778198242188,
        -2442.319091796875,
        1832.025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8509166240692139,
        0.5241855978965759,
        0.03420881927013397
      ],
      "plane_d": 1648.3133544921875,
      "bbox_min": [
        -675.7212524414062,
        -4018.696044921875,
        832.4061279296875
      ],
      "bbox_max": [
        720.0778198242188,
        -2442.319091796875,
        1817.6278076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8467844724655151,
        0.5311331748962402,
        0.02921772189438343
      ],
      "plane_d": 1677.30810546875,
      "bbox_min": [
        -675.7212524414062,
        -3796.41357421875,
        844.7754516601562
      ],
      "bbox_max": [
        337.63714599609375,
        -2442.319091796875,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7525275945663452,
        0.6564691066741943,
        0.05244596675038338
      ],
      "plane_d": 2210.693359375,
      "bbox_min": [
        -675.7212524414062,
        -3796.41357421875,
        844.7754516601562
      ],
      "bbox_max": [
        337.63714599609375,
        -2442.319091796875,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7238329648971558,
        0.6886298656463623,
        0.043066371232271194
      ],
      "plane_d": 2345.906494140625,
      "bbox_min": [
        -632.611083984375,
        -3781.800048828125,
        869.5489501953125
      ],
      "bbox_max": [
        251.97702026367188,
        -2869.818359375,
        1741.628173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16805893182754517,
        -0.7668494582176208,
        0.6194337010383606
      ],
      "plane_d": -3160.62744140625,
      "bbox_min": [
        -632.611083984375,
        -3781.800048828125,
        1045.5322265625
      ],
      "bbox_max": [
        239.99160766601562,
        -2914.067626953125,
        1741.628173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.760502815246582,
        0.6348288655281067,
        0.136483833193779
      ],
      "plane_d": 1999.9285888671875,
      "bbox_min": [
        110.609375,
        -3781.800048828125,
        1496.750732421875
      ],
      "bbox_max": [
        239.99160766601562,
        -3635.988037109375,
        1741.628173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7437502145767212,
        0.6592581272125244,
        0.1105182021856308
      ],
      "plane_d": 2135.147705078125,
      "bbox_min": [
        110.609375,
        -3760.123046875,
        1496.750732421875
      ],
      "bbox_max": [
        236.71875,
        -3642.2841796875,
        1703.1519775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9319621920585632,
        -0.34370651841163635,
        0.11537816375494003
      ],
      "plane_d": -1553.7806396484375,
      "bbox_min": [
        110.609375,
        -3649.01513671875,
        1496.750732421875
      ],
      "bbox_max": [
        137.665771484375,
        -3642.2841796875,
        1703.1519775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1419980823993683,
        0.9854755401611328,
        0.09313669800758362
      ],
      "plane_d": 3530.583740234375,
      "bbox_min": [
        110.609375,
        -3781.800048828125,
        1517.2542724609375
      ],
      "bbox_max": [
        239.99160766601562,
        -3635.988037109375,
        1741.628173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9319621920585632,
        -0.34370651841163635,
        0.11537816375494003
      ],
      "plane_d": -1553.7806396484375,
      "bbox_min": [
        110.609375,
        -3649.01513671875,
        1557.621337890625
      ],
      "bbox_max": [
        131.10858154296875,
        -3635.988037109375,
        1703.1519775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9500696659088135,
        -0.30839189887046814,
        0.04756174609065056
      ],
      "plane_d": -1326.0494384765625,
      "bbox_min": [
        -548.6903686523438,
        -3644.93798828125,
        871.5138549804688
      ],
      "bbox_max": [
        172.2946319580078,
        -2869.818359375,
        1496.750732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16805893182754517,
        -0.7668494582176208,
        0.6194337010383606
      ],
      "plane_d": -3160.62744140625,
      "bbox_min": [
        -548.6903686523438,
        -2976.867431640625,
        1285.45166015625
      ],
      "bbox_max": [
        -458.80450439453125,
        -2869.818359375,
        1405.2808837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9820936322212219,
        -0.1862727701663971,
        0.028186162933707237
      ],
      "plane_d": -872.0990600585938,
      "bbox_min": [
        -675.7212524414062,
        -3796.41357421875,
        844.7754516601562
      ],
      "bbox_max": [
        337.63714599609375,
        -2442.319091796875,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9500696659088135,
        -0.30839189887046814,
        0.04756174609065056
      ],
      "plane_d": -1326.0494384765625,
      "bbox_min": [
        -675.7212524414062,
        -3644.93798828125,
        844.7754516601562
      ],
      "bbox_max": [
        176.252197265625,
        -2442.319091796875,
        1702.0457763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5784722566604614,
        0.815333366394043,
        0.024523701518774033
      ],
      "plane_d": 2574.393798828125,
      "bbox_min": [
        -675.7212524414062,
        -3644.93798828125,
        844.7754516601562
      ],
      "bbox_max": [
        176.252197265625,
        -2442.319091796875,
        1702.0457763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5775443911552429,
        0.8160061836242676,
        0.024013595655560493
      ],
      "plane_d": 2576.89306640625,
      "bbox_min": [
        -532.1365356445312,
        -3644.93798828125,
        852.8427734375
      ],
      "bbox_max": [
        176.252197265625,
        -2833.345947265625,
        1702.0457763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8440337181091309,
        0.5237486362457275,
        0.11530200392007828
      ],
      "plane_d": 1527.4400634765625,
      "bbox_min": [
        -532.1365356445312,
        -3644.93798828125,
        1328.684326171875
      ],
      "bbox_max": [
        176.252197265625,
        -2833.657958984375,
        1702.0457763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8434123396873474,
        0.5291796922683716,
        0.09286854416131973
      ],
      "plane_d": 1580.055908203125,
      "bbox_min": [
        -532.1365356445312,
        -3644.93798828125,
        1328.684326171875
      ],
      "bbox_max": [
        176.252197265625,
        -2833.657958984375,
        1702.0457763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5382782816886902,
        0.8385637402534485,
        0.08406741917133331
      ],
      "plane_d": 2561.375,
      "bbox_min": [
        -532.1365356445312,
        -3644.93798828125,
        1328.684326171875
      ],
      "bbox_max": [
        176.252197265625,
        -2833.657958984375,
        1702.0457763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9482414126396179,
        -0.303896427154541,
        0.09211452305316925
      ],
      "plane_d": -1376.096435546875,
      "bbox_min": [
        -532.1365356445312,
        -3644.93798828125,
        1328.684326171875
      ],
      "bbox_max": [
        176.252197265625,
        -2858.148681640625,
        1702.0457763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9319621920585632,
        -0.34370651841163635,
        0.11537816375494003
      ],
      "plane_d": -1553.7806396484375,
      "bbox_min": [
        -532.1365356445312,
        -3644.93798828125,
        1328.684326171875
      ],
      "bbox_max": [
        153.35205078125,
        -2858.148681640625,
        1702.0457763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16805893182754517,
        -0.7668494582176208,
        0.6194337010383606
      ],
      "plane_d": -3160.62744140625,
      "bbox_min": [
        -532.1365356445312,
        -2947.761474609375,
        1328.684326171875
      ],
      "bbox_max": [
        -430.1038818359375,
        -2858.148681640625,
        1420.9122314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5380130410194397,
        0.8274743556976318,
        0.16071178019046783
      ],
      "plane_d": 2416.71533203125,
      "bbox_min": [
        -527.7708129882812,
        -3171.47509765625,
        1354.7957763671875
      ],
      "bbox_max": [
        -40.82177734375,
        -2833.657958984375,
        1453.7174072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16805893182754517,
        -0.7668494582176208,
        0.6194337010383606
      ],
      "plane_d": -3160.62744140625,
      "bbox_min": [
        -527.7708129882812,
        -2916.282958984375,
        1375.4412841796875
      ],
      "bbox_max": [
        -426.1293640136719,
        -2854.998046875,
        1425.1324462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16805893182754517,
        -0.7668494582176208,
        0.6194337010383606
      ],
      "plane_d": -3160.62744140625,
      "bbox_min": [
        -526.5921630859375,
        -3031.18994140625,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2833.657958984375,
        1453.7174072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -306.4403381347656,
        -3031.18994140625,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2983.164306640625,
        1447.936279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16805893182754517,
        -0.7668494582176208,
        0.6194337010383606
      ],
      "plane_d": -3160.62744140625,
      "bbox_min": [
        -518.608642578125,
        -3024.712158203125,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2833.345947265625,
        1454.1353759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -306.5947570800781,
        -3024.712158203125,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2982.995849609375,
        1431.2838134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9373313784599304,
        0.34786927700042725,
        0.019921978935599327
      ],
      "plane_d": 1415.8299560546875,
      "bbox_min": [
        -675.7212524414062,
        -3024.712158203125,
        844.7754516601562
      ],
      "bbox_max": [
        -234.29946899414062,
        -2442.319091796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -675.7212524414062,
        -2860.449951171875,
        866.076171875
      ],
      "bbox_max": [
        -479.3180236816406,
        -2442.319091796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8313450217247009,
        0.5555300712585449,
        0.01586890034377575
      ],
      "plane_d": 1886.90283203125,
      "bbox_min": [
        -675.7212524414062,
        -2860.449951171875,
        866.076171875
      ],
      "bbox_max": [
        -479.3180236816406,
        -2442.319091796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9314306974411011,
        0.3556700348854065,
        0.0770426094532013
      ],
      "plane_d": 1355.5810546875,
      "bbox_min": [
        -675.7212524414062,
        -2860.449951171875,
        1283.4403076171875
      ],
      "bbox_max": [
        -479.3180236816406,
        -2442.319091796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321792721748352,
        0.32900410890579224,
        0.15099084377288818
      ],
      "plane_d": 1178.5648193359375,
      "bbox_min": [
        -675.7212524414062,
        -2858.27001953125,
        1283.4403076171875
      ],
      "bbox_max": [
        -482.4688415527344,
        -2442.319091796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8198854923248291,
        0.5702467560768127,
        0.05105101317167282
      ],
      "plane_d": 1870.3758544921875,
      "bbox_min": [
        -675.7212524414062,
        -2852.865966796875,
        1283.4403076171875
      ],
      "bbox_max": [
        -490.27947998046875,
        -2442.319091796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8297061324119568,
        0.5531379580497742,
        0.07500854879617691
      ],
      "plane_d": 1800.5321044921875,
      "bbox_min": [
        -675.7212524414062,
        -2852.865966796875,
        1341.0208740234375
      ],
      "bbox_max": [
        -490.27947998046875,
        -2442.319091796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16805893182754517,
        -0.7668494582176208,
        0.6194337010383606
      ],
      "plane_d": -3160.62744140625,
      "bbox_min": [
        -518.491943359375,
        -2852.865966796875,
        1437.6243896484375
      ],
      "bbox_max": [
        -490.27947998046875,
        -2813.591064453125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16805893182754517,
        -0.7668494582176208,
        0.6194337010383606
      ],
      "plane_d": -3160.62744140625,
      "bbox_min": [
        -511.1015625,
        -2858.27001953125,
        1433.0533447265625
      ],
      "bbox_max": [
        -482.4688415527344,
        -2813.591064453125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -502.12994384765625,
        -2860.449951171875,
        1386.6339111328125
      ],
      "bbox_max": [
        -479.3180236816406,
        -2806.955322265625,
        1479.110595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16805893182754517,
        -0.7668494582176208,
        0.6194337010383606
      ],
      "plane_d": -3160.62744140625,
      "bbox_min": [
        -502.12994384765625,
        -2860.449951171875,
        1431.2093505859375
      ],
      "bbox_max": [
        -479.3180236816406,
        -2816.757568359375,
        1479.110595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -498.223876953125,
        -3024.712158203125,
        844.7754516601562
      ],
      "bbox_max": [
        -234.29946899414062,
        -2648.854736328125,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3401496112346649,
        0.9401360750198364,
        0.02103203907608986
      ],
      "plane_d": 2779.226806640625,
      "bbox_min": [
        -498.223876953125,
        -3024.712158203125,
        864.816162109375
      ],
      "bbox_max": [
        -234.29946899414062,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -498.223876953125,
        -3024.712158203125,
        864.816162109375
      ],
      "bbox_max": [
        -234.29946899414062,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6857488751411438,
        0.7124960422515869,
        0.1486532837152481
      ],
      "plane_d": 2121.40576171875,
      "bbox_min": [
        -498.223876953125,
        -3024.712158203125,
        1313.6531982421875
      ],
      "bbox_max": [
        -244.5576171875,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -498.223876953125,
        -3024.712158203125,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16805893182754517,
        -0.7668494582176208,
        0.6194337010383606
      ],
      "plane_d": -3160.62744140625,
      "bbox_min": [
        -498.223876953125,
        -2902.92626953125,
        1363.39306640625
      ],
      "bbox_max": [
        -402.65911865234375,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -498.223876953125,
        -2825.358642578125,
        1363.39306640625
      ],
      "bbox_max": [
        -458.1455383300781,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3677068054676056,
        0.9267826676368713,
        0.07658688724040985
      ],
      "plane_d": 2678.439697265625,
      "bbox_min": [
        -498.223876953125,
        -2820.93603515625,
        1363.39306640625
      ],
      "bbox_max": [
        -458.1455383300781,
        -2806.955322265625,
        1405.229248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16805893182754517,
        -0.7668494582176208,
        0.6194337010383606
      ],
      "plane_d": -3160.62744140625,
      "bbox_min": [
        -477.76031494140625,
        -2937.93310546875,
        1313.6531982421875
      ],
      "bbox_max": [
        -331.759765625,
        -2820.6962890625,
        1475.0743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3677068054676056,
        0.9267826676368713,
        0.07658688724040985
      ],
      "plane_d": 2678.439697265625,
      "bbox_min": [
        -477.76031494140625,
        -2935.67578125,
        1313.6531982421875
      ],
      "bbox_max": [
        -331.759765625,
        -2820.6962890625,
        1475.0743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -477.76031494140625,
        -2935.67578125,
        1313.6531982421875
      ],
      "bbox_max": [
        -331.759765625,
        -2820.6962890625,
        1475.0743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -355.0424499511719,
        -2919.97998046875,
        1384.2762451171875
      ],
      "bbox_max": [
        -350.9110412597656,
        -2911.1865234375,
        1402.115478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -360.3669128417969,
        -2937.93310546875,
        1375.4600830078125
      ],
      "bbox_max": [
        -341.54644775390625,
        -2906.77197265625,
        1432.8883056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9150537252426147,
        0.36777904629707336,
        0.16557550430297852
      ],
      "plane_d": 1164.4708251953125,
      "bbox_min": [
        -350.9110412597656,
        -2937.93310546875,
        1375.4600830078125
      ],
      "bbox_max": [
        -341.54644775390625,
        -2919.97998046875,
        1415.600341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388457655906677,
        0.6731600761413574,
        0.031021639704704285
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -430.2678527832031,
        -2993.197509765625,
        864.816162109375
      ],
      "bbox_max": [
        -257.4031982421875,
        -2830.660888671875,
        1465.511474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3677068054676056,
        0.9267826676368713,
        0.07658688724040985
      ],
      "plane_d": 2678.439697265625,
      "bbox_min": [
        -430.2678527832031,
        -2932.19970703125,
        1313.6531982421875
      ],
      "bbox_max": [
        -331.759765625,
        -2830.660888671875,
        1465.511474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9150537252426147,
        0.36777904629707336,
        0.16557550430297852
      ],
      "plane_d": 1164.4708251953125,
      "bbox_min": [
        -424.3450622558594,
        -2932.19970703125,
        1313.6531982421875
      ],
      "bbox_max": [
        -331.759765625,
        -2839.9580078125,
        1465.511474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16805893182754517,
        -0.7668494582176208,
        0.6194337010383606
      ],
      "plane_d": -3160.62744140625,
      "bbox_min": [
        -424.3450622558594,
        -2874.215087890625,
        1431.2955322265625
      ],
      "bbox_max": [
        -390.809814453125,
        -2839.9580078125,
        1465.511474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -424.3450622558594,
        -2847.37158203125,
        1431.2955322265625
      ],
      "bbox_max": [
        -415.3903503417969,
        -2839.9580078125,
        1465.511474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -360.6916809082031,
        -2913.74560546875,
        1383.4925537109375
      ],
      "bbox_max": [
        -351.9558410644531,
        -2905.960205078125,
        1433.3387451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -423.2957458496094,
        -2932.19970703125,
        864.816162109375
      ],
      "bbox_max": [
        -318.201171875,
        -2833.093017578125,
        1464.7442626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910527229309082,
        0.41264408826828003,
        0.025789525359869003
      ],
      "plane_d": 1473.680908203125,
      "bbox_min": [
        -423.2957458496094,
        -2932.19970703125,
        864.816162109375
      ],
      "bbox_max": [
        -326.9071960449219,
        -2833.093017578125,
        1464.7442626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3677068054676056,
        0.9267826676368713,
        0.07658688724040985
      ],
      "plane_d": 2678.439697265625,
      "bbox_min": [
        -423.2957458496094,
        -2932.19970703125,
        1307.5714111328125
      ],
      "bbox_max": [
        -331.759765625,
        -2833.093017578125,
        1464.7442626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -418.51580810546875,
        -2932.19970703125,
        1307.5714111328125
      ],
      "bbox_max": [
        -331.759765625,
        -2842.56201171875,
        1464.7442626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -418.51580810546875,
        -2873.185546875,
        1434.8194580078125
      ],
      "bbox_max": [
        -378.988037109375,
        -2842.56201171875,
        1464.7442626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16805893182754517,
        -0.7668494582176208,
        0.6194337010383606
      ],
      "plane_d": -3160.62744140625,
      "bbox_min": [
        -415.390380859375,
        -2873.185546875,
        1439.4560546875
      ],
      "bbox_max": [
        -378.988037109375,
        -2847.37158203125,
        1464.7442626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5604902505874634,
        -0.8216592073440552,
        0.10357100516557693
      ],
      "plane_d": -2468.90185546875,
      "bbox_min": [
        -359.39111328125,
        -2658.112548828125,
        844.7754516601562
      ],
      "bbox_max": [
        -352.09356689453125,
        -2648.854736328125,
        856.48974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1419980823993683,
        0.9854755401611328,
        0.09313669800758362
      ],
      "plane_d": 3530.583740234375,
      "bbox_min": [
        236.71875,
        -3796.41357421875,
        1517.2542724609375
      ],
      "bbox_max": [
        330.9205017089844,
        -3760.123046875,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.171890527009964,
        0.9826100468635559,
        0.0702224150300026
      ],
      "plane_d": 3547.499755859375,
      "bbox_min": [
        236.71875,
        -3784.984130859375,
        1517.2542724609375
      ],
      "bbox_max": [
        328.59930419921875,
        -3760.123046875,
        1640.2244873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12320823967456818,
        0.9910323619842529,
        0.0517178438603878
      ],
      "plane_d": 3629.03662109375,
      "bbox_min": [
        284.8941955566406,
        -3760.00537109375,
        859.5145263671875
      ],
      "bbox_max": [
        337.63714599609375,
        -3742.513916015625,
        1080.64501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6409114003181458,
        0.7633273005485535,
        0.08101856708526611
      ],
      "plane_d": 2492.2646484375,
      "bbox_min": [
        328.0792236328125,
        -4018.696044921875,
        832.4061279296875
      ],
      "bbox_max": [
        720.0778198242188,
        -3748.705322265625,
        1817.6278076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1419980823993683,
        0.9854755401611328,
        0.09313669800758362
      ],
      "plane_d": 3530.583740234375,
      "bbox_min": [
        330.1453552246094,
        -4018.696044921875,
        832.4061279296875
      ],
      "bbox_max": [
        720.0778198242188,
        -3792.596923828125,
        1774.517333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8076764345169067,
        0.5888927578926086,
        0.029395628720521927
      ],
      "plane_d": 1760.45068359375,
      "bbox_min": [
        717.0300903320312,
        -4018.696044921875,
        832.4061279296875
      ],
      "bbox_max": [
        720.0778198242188,
        -4014.394775390625,
        837.2236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17268598079681396,
        0.9841879606246948,
        0.03941702842712402
      ],
      "plane_d": 3599.984130859375,
      "bbox_min": [
        328.0792236328125,
        -3796.810302734375,
        1080.6446533203125
      ],
      "bbox_max": [
        440.13232421875,
        -3760.00537109375,
        1718.41796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1419980823993683,
        0.9854755401611328,
        0.09313669800758362
      ],
      "plane_d": 3530.583740234375,
      "bbox_min": [
        328.59930419921875,
        -3796.810302734375,
        1640.2244873046875
      ],
      "bbox_max": [
        372.306640625,
        -3784.984130859375,
        1718.41796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1419980823993683,
        0.9854755401611328,
        0.09313669800758362
      ],
      "plane_d": 3530.583740234375,
      "bbox_min": [
        426.9809875488281,
        -3812.21435546875,
        1771.9530029296875
      ],
      "bbox_max": [
        429.236328125,
        -3811.61572265625,
        1774.9140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6415850520133972,
        0.763245701789856,
        0.0763196349143982
      ],
      "plane_d": 2498.803955078125,
      "bbox_min": [
        429.236328125,
        -3906.921142578125,
        1520.6715087890625
      ],
      "bbox_max": [
        569.706298828125,
        -3795.950927734375,
        1774.9140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.171890527009964,
        0.9826100468635559,
        0.0702224150300026
      ],
      "plane_d": 3547.499755859375,
      "bbox_min": [
        429.236328125,
        -3812.21435546875,
        1520.6715087890625
      ],
      "bbox_max": [
        440.13232421875,
        -3795.950927734375,
        1774.9140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6409114003181458,
        0.7633273005485535,
        0.08101856708526611
      ],
      "plane_d": 2492.2646484375,
      "bbox_min": [
        -362.4698791503906,
        -4018.696044921875,
        832.4083251953125
      ],
      "bbox_max": [
        719.990966796875,
        -2614.790283203125,
        1541.1749267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6077371835708618,
        0.7909682989120483,
        0.07088473439216614
      ],
      "plane_d": 2627.199462890625,
      "bbox_min": [
        578.5888061523438,
        -4018.696044921875,
        832.4083251953125
      ],
      "bbox_max": [
        719.990966796875,
        -3843.89892578125,
        923.2786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8076764345169067,
        0.5888927578926086,
        0.029395628720521927
      ],
      "plane_d": 1760.45068359375,
      "bbox_min": [
        696.728759765625,
        -4018.696044921875,
        832.4083251953125
      ],
      "bbox_max": [
        719.990966796875,
        -3986.5517578125,
        837.2236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5375874042510986,
        -0.8341876268386841,
        0.12300780415534973
      ],
      "plane_d": -2511.1875,
      "bbox_min": [
        -362.4698791503906,
        -2715.917724609375,
        834.7764892578125
      ],
      "bbox_max": [
        -241.3089599609375,
        -2614.790283203125,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -885.4474487304688,
      "bbox_min": [
        -362.4698791503906,
        -2715.917724609375,
        834.7764892578125
      ],
      "bbox_max": [
        -241.3089599609375,
        -2614.790283203125,
        885.4474487304688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5633555054664612,
        0.8184596300125122,
        0.11293553560972214
      ],
      "plane_d": 2242.135498046875,
      "bbox_min": [
        -362.4698791503906,
        -2715.917724609375,
        834.7764892578125
      ],
      "bbox_max": [
        -241.3089599609375,
        -2614.790283203125,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8689243793487549,
        0.41837501525878906,
        0.2644478976726532
      ],
      "plane_d": 566.2352905273438,
      "bbox_min": [
        -362.4698791503906,
        -2715.917724609375,
        834.7764892578125
      ],
      "bbox_max": [
        -241.3089599609375,
        -2614.790283203125,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1262851357460022,
        -0.9829915761947632,
        0.13334013521671295
      ],
      "plane_d": -2811.5068359375,
      "bbox_min": [
        -362.4698791503906,
        -2715.917724609375,
        834.7764892578125
      ],
      "bbox_max": [
        -241.3089599609375,
        -2639.94140625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5604902505874634,
        -0.8216592073440552,
        0.10357100516557693
      ],
      "plane_d": -2468.90185546875,
      "bbox_min": [
        -362.4698791503906,
        -2710.77294921875,
        843.2679443359375
      ],
      "bbox_max": [
        -248.13571166992188,
        -2639.94140625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9434628486633301,
        -0.32140111923217773,
        0.08111273497343063
      ],
      "plane_d": -1258.9459228515625,
      "bbox_min": [
        -362.4698791503906,
        -2710.77294921875,
        844.3678588867188
      ],
      "bbox_max": [
        -248.13571166992188,
        -2639.94140625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022255789488554,
        -0.9675591588020325,
        0.25166231393814087
      ],
      "plane_d": -2846.35498046875,
      "bbox_min": [
        -270.802978515625,
        -2710.77294921875,
        866.2379760742188
      ],
      "bbox_max": [
        -248.13571166992188,
        -2705.255126953125,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7403071522712708,
        0.3129737675189972,
        0.5949727892875671
      ],
      "plane_d": 619.6898193359375,
      "bbox_min": [
        -282.3660583496094,
        -4031.08349609375,
        696.475830078125
      ],
      "bbox_max": [
        680.53076171875,
        -2483.3291015625,
        1832.025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8246843814849854,
        -0.4889775812625885,
        0.28424733877182007
      ],
      "plane_d": -1631.2696533203125,
      "bbox_min": [
        167.85601806640625,
        -4031.08349609375,
        696.475830078125
      ],
      "bbox_max": [
        680.53076171875,
        -2516.287841796875,
        1832.025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17600783705711365,
        0.971106767654419,
        0.1611611247062683
      ],
      "plane_d": 2872.85693359375,
      "bbox_min": [
        172.98614501953125,
        -3599.88330078125,
        696.475830078125
      ],
      "bbox_max": [
        680.53076171875,
        -2516.287841796875,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7322627902030945,
        -0.6772246956825256,
        0.07181940227746964
      ],
      "plane_d": -2071.12744140625,
      "bbox_min": [
        185.49929809570312,
        -3599.88330078125,
        765.2738647460938
      ],
      "bbox_max": [
        680.53076171875,
        -3131.2197265625,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2501010000705719,
        0.9651679396629333,
        0.07681389153003693
      ],
      "plane_d": 2907.327392578125,
      "bbox_min": [
        209.39527893066406,
        -3599.88330078125,
        765.2738647460938
      ],
      "bbox_max": [
        680.53076171875,
        -3131.2197265625,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.700647234916687,
        -0.7095323801040649,
        0.07521316409111023
      ],
      "plane_d": -2197.34130859375,
      "bbox_min": [
        347.40338134765625,
        -3599.88330078125,
        767.9185791015625
      ],
      "bbox_max": [
        680.53076171875,
        -3165.675048828125,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7064646482467651,
        -0.7041506767272949,
        0.07127003371715546
      ],
      "plane_d": -2172.34130859375,
      "bbox_min": [
        347.40338134765625,
        -3599.88330078125,
        767.9185791015625
      ],
      "bbox_max": [
        680.53076171875,
        -3165.675048828125,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4468574523925781,
        -0.891202986240387,
        0.07794603705406189
      ],
      "plane_d": -2968.193115234375,
      "bbox_min": [
        347.40338134765625,
        -3599.88330078125,
        767.9185791015625
      ],
      "bbox_max": [
        680.53076171875,
        -3165.675048828125,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4089178442955017,
        0.9066630601882935,
        0.10367407649755478
      ],
      "plane_d": 2649.07568359375,
      "bbox_min": [
        347.40338134765625,
        -3599.88330078125,
        767.9185791015625
      ],
      "bbox_max": [
        680.53076171875,
        -3165.675048828125,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6002287864685059,
        -0.7393360733985901,
        0.305135577917099
      ],
      "plane_d": -2594.850341796875,
      "bbox_min": [
        412.399169921875,
        -3599.88330078125,
        767.9185791015625
      ],
      "bbox_max": [
        680.53076171875,
        -3272.55126953125,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41525304317474365,
        0.8970658779144287,
        0.15112093091011047
      ],
      "plane_d": 2562.340087890625,
      "bbox_min": [
        443.237060546875,
        -3599.88330078125,
        767.9185791015625
      ],
      "bbox_max": [
        680.53076171875,
        -3272.55126953125,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1269.789306640625,
      "bbox_min": [
        443.237060546875,
        -3599.88330078125,
        767.9185791015625
      ],
      "bbox_max": [
        680.53076171875,
        -3272.55126953125,
        1325.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.4358859956264496,
        -0.8992010354995728,
        0.03795750439167023
      ],
      "plane_d": -2970.5244140625,
      "bbox_min": [
        540.466552734375,
        -3599.88330078125,
        767.9185791015625
      ],
      "bbox_max": [
        680.53076171875,
        -3272.55126953125,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.451077401638031,
        0.8152586817741394,
        0.3631562292575836
      ],
      "plane_d": 2002.1014404296875,
      "bbox_min": [
        540.466552734375,
        -3460.0,
        1062.68310546875
      ],
      "bbox_max": [
        631.365478515625,
        -3296.8681640625,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4176563620567322,
        0.8973091244697571,
        0.14282727241516113
      ],
      "plane_d": 2570.820556640625,
      "bbox_min": [
        556.066650390625,
        -3460.0,
        1062.68310546875
      ],
      "bbox_max": [
        631.365478515625,
        -3296.8681640625,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3458.0,
      "bbox_min": [
        597.0,
        -3460.0,
        1269.5
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1269.789306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 623.0,
      "bbox_min": [
        597.0,
        -3460.0,
        1269.5
      ],
      "bbox_max": [
        625.0,
        -3458.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3460.0,
      "bbox_min": [
        623.0,
        -3460.0,
        1269.5
      ],
      "bbox_max": [
        625.0,
        -3458.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        625.0,
        -3460.0,
        1269.5
      ],
      "bbox_max": [
        625.0,
        -3458.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 597.0,
      "bbox_min": [
        597.0,
        -3460.0,
        1269.5
      ],
      "bbox_max": [
        599.0,
        -3458.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3460.0,
      "bbox_min": [
        597.0,
        -3460.0,
        1269.5
      ],
      "bbox_max": [
        599.0,
        -3458.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -599.0,
      "bbox_min": [
        599.0,
        -3460.0,
        1269.5
      ],
      "bbox_max": [
        599.0,
        -3458.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 623.0,
      "bbox_min": [
        597.0,
        -3427.0,
        1269.5
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3427.0,
      "bbox_min": [
        623.0,
        -3427.0,
        1269.5
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        625.0,
        -3427.0,
        1269.5
      ],
      "bbox_max": [
        625.0,
        -3426.23291015625,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3427.0,
      "bbox_min": [
        597.0,
        -3427.0,
        1269.5
      ],
      "bbox_max": [
        599.0,
        -3425.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -599.0,
      "bbox_min": [
        599.0,
        -3427.0,
        1269.5
      ],
      "bbox_max": [
        599.0,
        -3425.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4521629512310028,
        0.8910648822784424,
        0.039396364241838455
      ],
      "plane_d": 2628.0009765625,
      "bbox_min": [
        576.892822265625,
        -3309.138427734375,
        768.9717407226562
      ],
      "bbox_max": [
        642.1612548828125,
        -3272.55126953125,
        856.1787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9984285831451416,
        -0.0,
        0.056038569658994675
      ],
      "plane_d": -623.9652709960938,
      "bbox_min": [
        576.892822265625,
        -3279.874267578125,
        773.9254150390625
      ],
      "bbox_max": [
        581.5094604492188,
        -3272.55126953125,
        856.1787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1290.5,
      "bbox_min": [
        471.41265869140625,
        -3473.5,
        1269.789306640625
      ],
      "bbox_max": [
        628.3717651367188,
        -3296.49169921875,
        1325.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1288.0,
      "bbox_min": [
        471.41265869140625,
        -3473.5,
        1269.789306640625
      ],
      "bbox_max": [
        628.3717651367188,
        -3296.49169921875,
        1290.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 619.0,
      "bbox_min": [
        594.0,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        628.3717651367188,
        -3420.5,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3473.5,
      "bbox_min": [
        619.0,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        628.3717651367188,
        -3420.5,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3420.5,
      "bbox_min": [
        619.0,
        -3420.5,
        1288.0
      ],
      "bbox_max": [
        622.9442138671875,
        -3420.5,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -602.0,
      "bbox_min": [
        594.0,
        -3466.8583984375,
        1288.0
      ],
      "bbox_max": [
        602.0,
        -3420.5,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 594.0,
      "bbox_min": [
        594.0,
        -3460.36376953125,
        1288.0
      ],
      "bbox_max": [
        602.0,
        -3420.5,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3420.5,
      "bbox_min": [
        594.0,
        -3420.5,
        1288.0
      ],
      "bbox_max": [
        602.0,
        -3420.5,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 597.0,
      "bbox_min": [
        471.41265869140625,
        -3460.0,
        1269.789306640625
      ],
      "bbox_max": [
        625.0,
        -3296.49169921875,
        1288.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 623.0,
      "bbox_min": [
        597.0,
        -3460.0,
        1269.789306640625
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1288.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3458.0,
      "bbox_min": [
        623.0,
        -3460.0,
        1269.789306640625
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3460.0,
      "bbox_min": [
        623.0,
        -3460.0,
        1269.789306640625
      ],
      "bbox_max": [
        625.0,
        -3458.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        625.0,
        -3460.0,
        1269.789306640625
      ],
      "bbox_max": [
        625.0,
        -3458.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3425.0,
      "bbox_min": [
        623.0,
        -3427.0,
        1269.789306640625
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        625.0,
        -3427.0,
        1269.789306640625
      ],
      "bbox_max": [
        625.0,
        -3426.457275390625,
        1270.4896240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3460.0,
      "bbox_min": [
        597.0,
        -3460.0,
        1269.789306640625
      ],
      "bbox_max": [
        599.0,
        -3458.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -599.0,
      "bbox_min": [
        599.0,
        -3460.0,
        1269.789306640625
      ],
      "bbox_max": [
        599.0,
        -3458.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3425.0,
      "bbox_min": [
        597.0,
        -3427.0,
        1269.789306640625
      ],
      "bbox_max": [
        599.0,
        -3425.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3427.0,
      "bbox_min": [
        597.0,
        -3427.0,
        1269.789306640625
      ],
      "bbox_max": [
        599.0,
        -3425.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -599.0,
      "bbox_min": [
        599.0,
        -3427.0,
        1269.789306640625
      ],
      "bbox_max": [
        599.0,
        -3425.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9397253394126892,
        -0.3419305086135864,
        0.0
      ],
      "plane_d": -1575.276123046875,
      "bbox_min": [
        471.41265869140625,
        -3302.900390625,
        1270.0
      ],
      "bbox_max": [
        477.82110595703125,
        -3296.49169921875,
        1286.167236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3421252369880676,
        -0.9396543502807617,
        0.0
      ],
      "plane_d": -2939.195068359375,
      "bbox_min": [
        471.41265869140625,
        -3302.387451171875,
        1270.0
      ],
      "bbox_max": [
        476.4112854003906,
        -3296.49169921875,
        1286.167236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3419538140296936,
        0.9397167563438416,
        0.0
      ],
      "plane_d": 2937.482421875,
      "bbox_min": [
        471.92584228515625,
        -3300.977783203125,
        1270.0
      ],
      "bbox_max": [
        476.4112854003906,
        -3296.49169921875,
        1286.0291748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9396525621414185,
        0.34213024377822876,
        0.0
      ],
      "plane_d": 1573.9007568359375,
      "bbox_min": [
        471.92584228515625,
        -3300.977783203125,
        1270.0
      ],
      "bbox_max": [
        475.89849853515625,
        -3297.9013671875,
        1283.468505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1272.5,
      "bbox_min": [
        473.3350524902344,
        -3300.977783203125,
        1272.5
      ],
      "bbox_max": [
        475.89849853515625,
        -3298.414306640625,
        1272.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8724951148033142,
        0.31755173206329346,
        0.37136679887771606
      ],
      "plane_d": 987.968017578125,
      "bbox_min": [
        471.92584228515625,
        -3300.29345703125,
        1270.0
      ],
      "bbox_max": [
        474.0194091796875,
        -3297.9013671875,
        1272.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1272.5,
      "bbox_min": [
        472.8653564453125,
        -3300.29345703125,
        1272.5
      ],
      "bbox_max": [
        474.0194091796875,
        -3298.2431640625,
        1272.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3175051808357239,
        0.872515857219696,
        0.37135758996009827
      ],
      "plane_d": 2254.3984375,
      "bbox_min": [
        472.6097106933594,
        -3299.09814453125,
        1270.0
      ],
      "bbox_max": [
        476.4112854003906,
        -3296.49169921875,
        1272.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8724951148033142,
        0.31755173206329346,
        0.37136679887771606
      ],
      "plane_d": 987.968017578125,
      "bbox_min": [
        472.6097106933594,
        -3299.09814453125,
        1270.0
      ],
      "bbox_max": [
        476.0694580078125,
        -3296.49169921875,
        1272.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1272.5,
      "bbox_min": [
        473.54931640625,
        -3299.09814453125,
        1272.5
      ],
      "bbox_max": [
        476.0694580078125,
        -3297.7734375,
        1272.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8724951148033142,
        0.31755173206329346,
        0.37136679887771606
      ],
      "plane_d": 987.968017578125,
      "bbox_min": [
        471.41265869140625,
        -3301.44775390625,
        1270.0
      ],
      "bbox_max": [
        475.214599609375,
        -3299.7802734375,
        1272.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1272.5,
      "bbox_min": [
        472.69427490234375,
        -3301.44775390625,
        1272.5
      ],
      "bbox_max": [
        475.214599609375,
        -3300.12255859375,
        1272.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1272.5,
      "bbox_min": [
        474.70159912109375,
        -3302.900390625,
        1270.0
      ],
      "bbox_max": [
        477.82110595703125,
        -3297.6884765625,
        1272.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3175051808357239,
        0.872515857219696,
        0.37135758996009827
      ],
      "plane_d": 2254.3984375,
      "bbox_min": [
        474.70159912109375,
        -3302.900390625,
        1270.0
      ],
      "bbox_max": [
        477.82110595703125,
        -3297.6884765625,
        1272.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31757652759552,
        -0.8724797368049622,
        0.3713816702365875
      ],
      "plane_d": -3202.166748046875,
      "bbox_min": [
        474.70159912109375,
        -3302.900390625,
        1270.0
      ],
      "bbox_max": [
        476.1111145019531,
        -3301.44775390625,
        1272.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3427.0,
      "bbox_min": [
        595.0,
        -3467.5,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3417.5,
        1325.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -599.0,
      "bbox_min": [
        595.0,
        -3427.0,
        1290.5
      ],
      "bbox_max": [
        623.2128295898438,
        -3417.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3425.0,
      "bbox_min": [
        595.0,
        -3427.0,
        1290.5
      ],
      "bbox_max": [
        599.0,
        -3417.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 597.0,
      "bbox_min": [
        595.0,
        -3427.0,
        1290.5
      ],
      "bbox_max": [
        599.0,
        -3425.0,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1293.0,
      "bbox_min": [
        597.0,
        -3427.0,
        1293.0
      ],
      "bbox_max": [
        599.0,
        -3425.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1324.0,
      "bbox_min": [
        597.0,
        -3427.0,
        1324.0
      ],
      "bbox_max": [
        599.0,
        -3425.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": 73.62823486328125,
      "bbox_min": [
        595.0,
        -3427.0,
        1290.5
      ],
      "bbox_max": [
        597.0,
        -3425.0,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1293.0,
      "bbox_min": [
        596.5,
        -3427.0,
        1293.0
      ],
      "bbox_max": [
        597.0,
        -3425.0,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1324.0,
      "bbox_min": [
        595.0,
        -3427.0,
        1324.0
      ],
      "bbox_max": [
        597.0,
        -3425.0,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 595.0,
      "bbox_min": [
        595.0,
        -3427.0,
        1324.0
      ],
      "bbox_max": [
        595.0,
        -3425.0,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1324.0,
      "bbox_min": [
        595.0,
        -3425.0,
        1290.5
      ],
      "bbox_max": [
        599.0,
        -3417.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3417.5,
      "bbox_min": [
        595.0,
        -3417.5,
        1324.0
      ],
      "bbox_max": [
        599.0,
        -3417.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2699.3603515625,
      "bbox_min": [
        595.5,
        -3425.0,
        1290.5
      ],
      "bbox_max": [
        599.0,
        -3423.5,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": 73.62823486328125,
      "bbox_min": [
        595.5,
        -3425.0,
        1290.5
      ],
      "bbox_max": [
        599.0,
        -3423.5,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -601.0,
      "bbox_min": [
        599.0,
        -3427.0,
        1290.5
      ],
      "bbox_max": [
        623.2128295898438,
        -3417.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1324.0,
      "bbox_min": [
        599.0,
        -3427.0,
        1290.5
      ],
      "bbox_max": [
        601.0,
        -3417.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3417.5,
      "bbox_min": [
        599.0,
        -3417.5,
        1324.0
      ],
      "bbox_max": [
        601.0,
        -3417.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.0,
        0.3713906705379486
      ],
      "plane_d": -1036.829833984375,
      "bbox_min": [
        599.0,
        -3427.0,
        1290.5
      ],
      "bbox_max": [
        600.5,
        -3423.5,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2699.3603515625,
      "bbox_min": [
        599.0,
        -3427.0,
        1290.5
      ],
      "bbox_max": [
        600.5,
        -3423.5,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1293.0,
      "bbox_min": [
        599.0,
        -3427.0,
        1293.0
      ],
      "bbox_max": [
        599.5,
        -3424.5,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1293.0,
      "bbox_min": [
        621.5,
        -3427.0,
        1290.5
      ],
      "bbox_max": [
        623.2128295898438,
        -3423.5,
        1295.68115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": 97.76861572265625,
      "bbox_min": [
        621.5,
        -3427.0,
        1290.5
      ],
      "bbox_max": [
        622.5,
        -3423.5,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 623.0,
      "bbox_min": [
        623.0,
        -3427.0,
        1293.0
      ],
      "bbox_max": [
        623.008056640625,
        -3425.0,
        1295.68115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3425.0,
      "bbox_min": [
        623.0,
        -3425.0,
        1293.0
      ],
      "bbox_max": [
        623.008056640625,
        -3425.0,
        1293.1011962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 623.0,
      "bbox_min": [
        595.0,
        -3467.5,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3427.0,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3460.0,
      "bbox_min": [
        623.0,
        -3467.5,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3427.0,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3458.0,
      "bbox_min": [
        623.0,
        -3460.0,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3427.0,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        623.0,
        -3460.0,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3458.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1293.0,
      "bbox_min": [
        623.0,
        -3460.0,
        1293.0
      ],
      "bbox_max": [
        625.0,
        -3458.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1324.0,
      "bbox_min": [
        623.0,
        -3460.0,
        1324.0
      ],
      "bbox_max": [
        624.1311645507812,
        -3458.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.0,
        0.3713906705379486
      ],
      "plane_d": -1060.9703369140625,
      "bbox_min": [
        625.0,
        -3460.0,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3458.0,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1293.0,
      "bbox_min": [
        625.0,
        -3460.0,
        1293.0
      ],
      "bbox_max": [
        625.5,
        -3458.0,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1324.0,
      "bbox_min": [
        623.0,
        -3458.0,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3427.0,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3450.5,
      "bbox_min": [
        623.0,
        -3450.5,
        1324.0
      ],
      "bbox_max": [
        623.1583251953125,
        -3450.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2730.0,
      "bbox_min": [
        623.0,
        -3458.0,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3427.0,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.0,
        0.3713906705379486
      ],
      "plane_d": -1060.9703369140625,
      "bbox_min": [
        623.0,
        -3458.0,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3456.57470703125,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1293.0,
      "bbox_min": [
        623.0,
        -3458.0,
        1293.0
      ],
      "bbox_max": [
        625.5,
        -3457.5,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1293.0,
      "bbox_min": [
        623.0,
        -3427.5,
        1293.0
      ],
      "bbox_max": [
        623.2640380859375,
        -3427.0,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1324.0,
      "bbox_min": [
        623.0,
        -3467.5,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3460.0,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3467.5,
      "bbox_min": [
        623.0,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        624.8992309570312,
        -3467.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -3693.20166015625,
      "bbox_min": [
        623.0,
        -3461.5,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3460.0,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.0,
        0.3713906705379486
      ],
      "plane_d": -1060.9703369140625,
      "bbox_min": [
        623.0,
        -3461.5,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3460.0,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1293.0,
      "bbox_min": [
        623.0,
        -3460.5,
        1293.0
      ],
      "bbox_max": [
        625.5,
        -3460.0,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1324.0,
      "bbox_min": [
        595.0,
        -3467.5,
        1290.5
      ],
      "bbox_max": [
        623.0,
        -3427.0,
        1325.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 621.0,
      "bbox_min": [
        595.0,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        623.0,
        -3427.0,
        1325.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3450.5,
      "bbox_min": [
        621.0,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        623.0,
        -3434.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3467.5,
      "bbox_min": [
        621.0914916992188,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        623.0,
        -3467.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3434.5,
      "bbox_min": [
        621.0,
        -3434.5,
        1324.0
      ],
      "bbox_max": [
        621.5198364257812,
        -3434.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -601.0,
      "bbox_min": [
        595.0,
        -3451.188720703125,
        1324.0
      ],
      "bbox_max": [
        601.0,
        -3427.0,
        1325.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 595.0,
      "bbox_min": [
        595.0,
        -3450.5,
        1324.0
      ],
      "bbox_max": [
        601.0,
        -3427.0,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3434.5,
      "bbox_min": [
        595.0,
        -3450.5,
        1324.0
      ],
      "bbox_max": [
        601.0,
        -3434.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3450.5,
      "bbox_min": [
        600.1514892578125,
        -3450.5,
        1324.0
      ],
      "bbox_max": [
        601.0,
        -3450.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": 97.76861572265625,
      "bbox_min": [
        595.5,
        -3461.5,
        1290.5
      ],
      "bbox_max": [
        623.0,
        -3427.0,
        1303.56298828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2730.0,
      "bbox_min": [
        621.5,
        -3461.5,
        1290.5
      ],
      "bbox_max": [
        623.0,
        -3427.0,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1293.0,
      "bbox_min": [
        621.5,
        -3461.5,
        1290.5
      ],
      "bbox_max": [
        623.0,
        -3457.5,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -3693.20166015625,
      "bbox_min": [
        621.5,
        -3461.5,
        1290.5
      ],
      "bbox_max": [
        623.0,
        -3460.5,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -3662.56201171875,
      "bbox_min": [
        621.5,
        -3428.5,
        1290.5
      ],
      "bbox_max": [
        623.0,
        -3427.0,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1293.0,
      "bbox_min": [
        622.5,
        -3427.5,
        1293.0
      ],
      "bbox_max": [
        623.0,
        -3427.0,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": 73.62823486328125,
      "bbox_min": [
        595.5,
        -3428.5,
        1290.5
      ],
      "bbox_max": [
        600.5,
        -3427.0,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.0,
        0.3713906705379486
      ],
      "plane_d": -1036.829833984375,
      "bbox_min": [
        599.5,
        -3428.5,
        1290.5
      ],
      "bbox_max": [
        600.5,
        -3427.0,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1293.0,
      "bbox_min": [
        595.5,
        -3461.5,
        1290.5
      ],
      "bbox_max": [
        600.5,
        -3456.5,
        1303.56298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2730.0,
      "bbox_min": [
        595.5,
        -3461.5,
        1290.5
      ],
      "bbox_max": [
        600.5,
        -3456.5,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.0,
        0.3713906705379486
      ],
      "plane_d": -1036.829833984375,
      "bbox_min": [
        595.5,
        -3461.5,
        1290.5
      ],
      "bbox_max": [
        600.5,
        -3456.5,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": 73.62823486328125,
      "bbox_min": [
        595.5,
        -3461.5,
        1290.5
      ],
      "bbox_max": [
        600.5,
        -3456.5,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -3693.20166015625,
      "bbox_min": [
        596.6708984375,
        -3461.5,
        1290.5
      ],
      "bbox_max": [
        600.5,
        -3460.5,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3458.0,
      "bbox_min": [
        597.0,
        -3460.0,
        1293.0
      ],
      "bbox_max": [
        599.0,
        -3458.0,
        1303.56298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -599.0,
      "bbox_min": [
        597.0,
        -3460.0,
        1293.0
      ],
      "bbox_max": [
        599.0,
        -3458.0,
        1303.56298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 597.0,
      "bbox_min": [
        597.0,
        -3460.0,
        1293.0
      ],
      "bbox_max": [
        599.0,
        -3458.0,
        1299.62890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3460.0,
      "bbox_min": [
        597.0,
        -3460.0,
        1293.0
      ],
      "bbox_max": [
        599.0,
        -3460.0,
        1298.716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8477569818496704,
        0.5120195150375366,
        0.13836194574832916
      ],
      "plane_d": 1066.26025390625,
      "bbox_min": [
        468.0013427734375,
        -3320.449951171875,
        1086.939697265625
      ],
      "bbox_max": [
        556.066650390625,
        -3279.474853515625,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1269.789306640625,
      "bbox_min": [
        468.0013427734375,
        -3320.449951171875,
        1269.789306640625
      ],
      "bbox_max": [
        540.466552734375,
        -3279.474853515625,
        1269.789306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3458.0,
      "bbox_min": [
        594.0,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        621.854248046875,
        -3450.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1288.0,
      "bbox_min": [
        594.0,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        621.854248046875,
        -3458.0,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1290.5,
      "bbox_min": [
        594.0,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        621.854248046875,
        -3458.0,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 594.0,
      "bbox_min": [
        594.0,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        602.0,
        -3459.331787109375,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -602.0,
      "bbox_min": [
        594.718505859375,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        602.0,
        -3465.82666015625,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3473.5,
      "bbox_min": [
        594.718505859375,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        602.0,
        -3473.5,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3460.0,
      "bbox_min": [
        595.5,
        -3467.5,
        1290.5
      ],
      "bbox_max": [
        621.854248046875,
        -3458.0,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 597.0,
      "bbox_min": [
        597.0,
        -3460.0,
        1294.7825927734375
      ],
      "bbox_max": [
        599.0,
        -3458.0,
        1315.776123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -599.0,
      "bbox_min": [
        599.0,
        -3460.0,
        1298.716796875
      ],
      "bbox_max": [
        599.0,
        -3458.0,
        1315.776123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -3693.20166015625,
      "bbox_min": [
        595.5,
        -3467.5,
        1290.5
      ],
      "bbox_max": [
        621.854248046875,
        -3460.32958984375,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": 73.62823486328125,
      "bbox_min": [
        595.5,
        -3461.5,
        1290.5
      ],
      "bbox_max": [
        596.7098999023438,
        -3460.32958984375,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1293.0,
      "bbox_min": [
        596.5,
        -3460.5,
        1293.0
      ],
      "bbox_max": [
        596.7098999023438,
        -3460.32958984375,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3467.5,
      "bbox_min": [
        621.0,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        621.854248046875,
        -3466.80615234375,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 621.0,
      "bbox_min": [
        621.0,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        621.0914916992188,
        -3466.80615234375,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1324.0,
      "bbox_min": [
        621.0,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        621.0914916992188,
        -3467.42578125,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1324.0,
      "bbox_min": [
        597.8502807617188,
        -3454.292724609375,
        1324.0
      ],
      "bbox_max": [
        601.0,
        -3450.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -601.0,
      "bbox_min": [
        597.8502807617188,
        -3454.292724609375,
        1324.0
      ],
      "bbox_max": [
        601.0,
        -3450.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3450.5,
      "bbox_min": [
        597.8502807617188,
        -3450.5,
        1324.0
      ],
      "bbox_max": [
        600.9141845703125,
        -3450.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1324.0,
      "bbox_min": [
        594.0,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        601.0,
        -3450.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 595.0,
      "bbox_min": [
        595.0,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        601.0,
        -3450.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -601.0,
      "bbox_min": [
        595.0,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        601.0,
        -3450.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3467.5,
      "bbox_min": [
        595.0,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        601.0,
        -3450.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3450.5,
      "bbox_min": [
        595.0,
        -3450.5,
        1324.0
      ],
      "bbox_max": [
        598.776611328125,
        -3450.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 597.0,
      "bbox_min": [
        594.0,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        599.0,
        -3458.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3460.0,
      "bbox_min": [
        597.0,
        -3460.0,
        1309.84814453125
      ],
      "bbox_max": [
        599.0,
        -3458.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3458.0,
      "bbox_min": [
        597.0,
        -3460.0,
        1312.5372314453125
      ],
      "bbox_max": [
        599.0,
        -3458.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -599.0,
      "bbox_min": [
        599.0,
        -3460.0,
        1313.0867919921875
      ],
      "bbox_max": [
        599.0,
        -3458.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1290.5,
      "bbox_min": [
        594.0,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        596.2626342773438,
        -3470.775390625,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 594.0,
      "bbox_min": [
        594.0,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        596.2626342773438,
        -3470.775390625,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3473.5,
      "bbox_min": [
        594.0,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        596.2626342773438,
        -3472.634765625,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1288.0,
      "bbox_min": [
        594.0,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        594.718505859375,
        -3472.634765625,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9846072793006897,
        0.1437329351902008,
        0.09944567084312439
      ],
      "plane_d": -181.7301788330078,
      "bbox_min": [
        347.40338134765625,
        -3307.10595703125,
        768.7883911132812
      ],
      "bbox_max": [
        581.7977905273438,
        -3165.675048828125,
        1284.37939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.58553147315979,
        0.7935402989387512,
        0.1656704992055893
      ],
      "plane_d": 2091.965087890625,
      "bbox_min": [
        347.40338134765625,
        -3307.10595703125,
        771.9529418945312
      ],
      "bbox_max": [
        581.6201782226562,
        -3165.675048828125,
        1284.37939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9681522846221924,
        0.16537931561470032,
        0.18796522915363312
      ],
      "plane_d": -197.4302215576172,
      "bbox_min": [
        347.40338134765625,
        -3307.10595703125,
        771.9529418945312
      ],
      "bbox_max": [
        581.6201782226562,
        -3165.675048828125,
        1284.37939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9984285831451416,
        -0.0,
        0.056038569658994675
      ],
      "plane_d": -623.9652709960938,
      "bbox_min": [
        471.142822265625,
        -3302.174560546875,
        771.9529418945312
      ],
      "bbox_max": [
        581.6201782226562,
        -3253.98388671875,
        1284.37939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1269.789306640625,
      "bbox_min": [
        471.142822265625,
        -3302.174560546875,
        1269.789306640625
      ],
      "bbox_max": [
        521.4730834960938,
        -3256.23486328125,
        1284.37939453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1272.5,
      "bbox_min": [
        480.3050842285156,
        -3278.46826171875,
        1270.0
      ],
      "bbox_max": [
        486.71368408203125,
        -3272.059814453125,
        1284.37939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31758207082748413,
        -0.8725006580352783,
        0.37132760882377625
      ],
      "plane_d": -3178.0234375,
      "bbox_min": [
        480.3050842285156,
        -3278.46826171875,
        1270.0
      ],
      "bbox_max": [
        486.71368408203125,
        -3272.059814453125,
        1272.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31761807203292847,
        0.8724203109741211,
        0.3714855909347534
      ],
      "plane_d": 2229.7275390625,
      "bbox_min": [
        480.3050842285156,
        -3278.46826171875,
        1270.0
      ],
      "bbox_max": [
        486.71368408203125,
        -3272.059814453125,
        1272.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8724565505981445,
        -0.317593514919281,
        0.3714216649532318
      ],
      "plane_d": -1936.0703125,
      "bbox_min": [
        480.3050842285156,
        -3278.46826171875,
        1270.0
      ],
      "bbox_max": [
        486.71368408203125,
        -3272.059814453125,
        1272.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8724552989006042,
        0.31758204102516174,
        0.3714340925216675
      ],
      "plane_d": 987.962890625,
      "bbox_min": [
        480.3050842285156,
        -3276.758056640625,
        1270.0
      ],
      "bbox_max": [
        482.61279296875,
        -3272.059814453125,
        1272.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9396815896034241,
        -0.34205055236816406,
        0.0
      ],
      "plane_d": -1575.6507568359375,
      "bbox_min": [
        482.2276916503906,
        -3276.545654296875,
        1272.5
      ],
      "bbox_max": [
        484.7911376953125,
        -3273.982177734375,
        1284.37939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3420468866825104,
        -0.9396829009056091,
        0.0
      ],
      "plane_d": -2913.326416015625,
      "bbox_min": [
        482.2276916503906,
        -3276.545654296875,
        1272.5
      ],
      "bbox_max": [
        484.7911376953125,
        -3273.982177734375,
        1284.37939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3420272767543793,
        0.9396900534629822,
        0.0
      ],
      "plane_d": 2911.359619140625,
      "bbox_min": [
        482.2276916503906,
        -3275.861572265625,
        1272.5
      ],
      "bbox_max": [
        484.7911376953125,
        -3273.982177734375,
        1284.2423095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9397011995315552,
        0.3419966697692871,
        0.0
      ],
      "plane_d": 1573.4837646484375,
      "bbox_min": [
        482.2276916503906,
        -3275.861572265625,
        1272.5
      ],
      "bbox_max": [
        482.91168212890625,
        -3273.982177734375,
        1281.6815185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5087763071060181,
        0.8604527115821838,
        0.027711892500519753
      ],
      "plane_d": 2994.49951171875,
      "bbox_min": [
        502.7161560058594,
        -3209.931640625,
        777.6998901367188
      ],
      "bbox_max": [
        506.8655090332031,
        -3205.48681640625,
        845.927001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8477569818496704,
        0.5120195150375366,
        0.13836194574832916
      ],
      "plane_d": 1066.26025390625,
      "bbox_min": [
        518.335693359375,
        -3307.10595703125,
        1086.939697265625
      ],
      "bbox_max": [
        556.066650390625,
        -3283.8076171875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1269.789306640625,
      "bbox_min": [
        518.335693359375,
        -3307.10595703125,
        1269.789306640625
      ],
      "bbox_max": [
        532.4071044921875,
        -3283.8076171875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07370751351118088,
        0.9552657604217529,
        0.2864168584346771
      ],
      "plane_d": 2811.425048828125,
      "bbox_min": [
        496.205322265625,
        -3283.8076171875,
        1071.7021484375
      ],
      "bbox_max": [
        552.81494140625,
        -3226.122802734375,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9681522846221924,
        0.16537931561470032,
        0.18796522915363312
      ],
      "plane_d": -197.4302215576172,
      "bbox_min": [
        518.335693359375,
        -3283.8076171875,
        1071.7427978515625
      ],
      "bbox_max": [
        552.81494140625,
        -3239.8798828125,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9900595545768738,
        0.0,
        0.14064913988113403
      ],
      "plane_d": -691.5790405273438,
      "bbox_min": [
        554.9752197265625,
        -3279.874267578125,
        768.7883911132812
      ],
      "bbox_max": [
        581.7977905273438,
        -3224.194580078125,
        1010.4617309570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9984285831451416,
        -0.0,
        0.056038569658994675
      ],
      "plane_d": -623.9652709960938,
      "bbox_min": [
        576.892822265625,
        -3279.874267578125,
        768.7883911132812
      ],
      "bbox_max": [
        581.7977905273438,
        -3224.194580078125,
        856.1787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4867294132709503,
        -0.7350980639457703,
        0.47193774580955505
      ],
      "plane_d": -2854.24267578125,
      "bbox_min": [
        524.50341796875,
        -3556.55908203125,
        1147.8895263671875
      ],
      "bbox_max": [
        645.9032592773438,
        -3493.141357421875,
        1182.6954345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09954273700714111,
        0.992695689201355,
        0.06816569715738297
      ],
      "plane_d": 3178.8984375,
      "bbox_min": [
        496.205322265625,
        -3241.13134765625,
        765.2738647460938
      ],
      "bbox_max": [
        581.9744262695312,
        -3184.464111328125,
        1112.6033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9984285831451416,
        -0.0,
        0.056038569658994675
      ],
      "plane_d": -623.9652709960938,
      "bbox_min": [
        503.064453125,
        -3229.878662109375,
        765.8486328125
      ],
      "bbox_max": [
        581.9627685546875,
        -3196.521240234375,
        856.1787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5087763071060181,
        0.8604527115821838,
        0.027711892500519753
      ],
      "plane_d": 2994.49951171875,
      "bbox_min": [
        503.064453125,
        -3209.931640625,
        777.4321899414062
      ],
      "bbox_max": [
        508.15106201171875,
        -3204.718017578125,
        845.927001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9846072793006897,
        0.1437329351902008,
        0.09944567084312439
      ],
      "plane_d": -181.7301788330078,
      "bbox_min": [
        541.5631713867188,
        -3241.13134765625,
        1010.4617309570312
      ],
      "bbox_max": [
        554.9752197265625,
        -3229.893310546875,
        1112.6033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9681522846221924,
        0.16537931561470032,
        0.18796522915363312
      ],
      "plane_d": -197.4302215576172,
      "bbox_min": [
        541.5631713867188,
        -3241.13134765625,
        1070.563720703125
      ],
      "bbox_max": [
        549.2824096679688,
        -3235.458251953125,
        1112.6033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9984285831451416,
        -0.0,
        0.056038569658994675
      ],
      "plane_d": -623.9652709960938,
      "bbox_min": [
        578.0961303710938,
        -3201.6396484375,
        765.2738647460938
      ],
      "bbox_max": [
        581.9744262695312,
        -3190.77392578125,
        834.740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9973583221435547,
        0.06245340034365654,
        0.03709162771701813
      ],
      "plane_d": -409.3241882324219,
      "bbox_min": [
        581.52197265625,
        -3194.569091796875,
        765.2738647460938
      ],
      "bbox_max": [
        581.9744262695312,
        -3190.77392578125,
        773.7025146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5106800198554993,
        0.8478036522865295,
        0.14295069873332977
      ],
      "plane_d": 2857.370849609375,
      "bbox_min": [
        496.205322265625,
        -3245.832275390625,
        696.475830078125
      ],
      "bbox_max": [
        581.7504272460938,
        -2516.287841796875,
        1147.5496826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038648247718811,
        0.8632845282554626,
        0.029325762763619423
      ],
      "plane_d": 2999.75341796875,
      "bbox_min": [
        528.6437377929688,
        -3245.832275390625,
        762.5039672851562
      ],
      "bbox_max": [
        581.7504272460938,
        -3162.15771484375,
        1147.5496826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07370751351118088,
        0.9552657604217529,
        0.2864168584346771
      ],
      "plane_d": 2811.425048828125,
      "bbox_min": [
        529.61572265625,
        -3245.832275390625,
        1066.623046875
      ],
      "bbox_max": [
        546.996826171875,
        -3220.680908203125,
        1147.5496826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39029523730278015,
        -0.9200517535209656,
        0.034270964562892914
      ],
      "plane_d": -2129.463623046875,
      "bbox_min": [
        496.205322265625,
        -3242.880615234375,
        696.475830078125
      ],
      "bbox_max": [
        579.1474609375,
        -2516.287841796875,
        1136.1912841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4237554669380188,
        -0.9054881930351257,
        0.022859251126646996
      ],
      "plane_d": -2065.258056640625,
      "bbox_min": [
        546.915771484375,
        -2533.9248046875,
        696.5499267578125
      ],
      "bbox_max": [
        578.4073486328125,
        -2516.287841796875,
        811.3943481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09954273700714111,
        0.992695689201355,
        0.06816569715738297
      ],
      "plane_d": 3178.8984375,
      "bbox_min": [
        496.205322265625,
        -3242.880615234375,
        976.5902099609375
      ],
      "bbox_max": [
        546.996826171875,
        -3216.295654296875,
        1136.1912841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9681522846221924,
        0.16537931561470032,
        0.18796522915363312
      ],
      "plane_d": -197.4302215576172,
      "bbox_min": [
        535.5631713867188,
        -3245.86376953125,
        1033.870849609375
      ],
      "bbox_max": [
        551.649658203125,
        -3220.680908203125,
        1147.671142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9846072793006897,
        0.1437329351902008,
        0.09944567084312439
      ],
      "plane_d": -181.7301788330078,
      "bbox_min": [
        546.996826171875,
        -3235.458251953125,
        1033.870849609375
      ],
      "bbox_max": [
        551.649658203125,
        -3220.680908203125,
        1070.563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.783856213092804,
        0.6171746850013733,
        0.06829895824193954
      ],
      "plane_d": 1859.4244384765625,
      "bbox_min": [
        560.656494140625,
        -4028.1416015625,
        1541.1749267578125
      ],
      "bbox_max": [
        664.2568359375,
        -3906.921142578125,
        1756.1932373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6327277421951294,
        0.771410346031189,
        0.06768848747015
      ],
      "plane_d": 2549.050537109375,
      "bbox_min": [
        560.656494140625,
        -3914.939697265625,
        1541.1749267578125
      ],
      "bbox_max": [
        569.706298828125,
        -3906.921142578125,
        1715.6435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8054807782173157,
        0.5523382425308228,
        0.21476304531097412
      ],
      "plane_d": 1383.29052734375,
      "bbox_min": [
        -282.3660583496094,
        -2925.689697265625,
        803.9765625
      ],
      "bbox_max": [
        44.51416778564453,
        -2483.3291015625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -885.4473876953125,
      "bbox_min": [
        -282.3660583496094,
        -2925.689697265625,
        809.5252075195312
      ],
      "bbox_max": [
        44.51416778564453,
        -2631.072265625,
        920.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.26160192489624023,
        0.9247593879699707,
        0.27637779712677
      ],
      "plane_d": 2175.628173828125,
      "bbox_min": [
        -211.42047119140625,
        -2925.689697265625,
        809.5252075195312
      ],
      "bbox_max": [
        44.51416778564453,
        -2631.072265625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39022088050842285,
        -0.7511724829673767,
        0.5324167609214783
      ],
      "plane_d": -2652.04638671875,
      "bbox_min": [
        -169.5,
        -2925.689697265625,
        810.3937377929688
      ],
      "bbox_max": [
        44.51416778564453,
        -2661.5,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164135575294495,
        -0.9401665925979614,
        0.1123996302485466
      ],
      "plane_d": -2832.044921875,
      "bbox_min": [
        -169.5,
        -2925.689697265625,
        810.3937377929688
      ],
      "bbox_max": [
        44.51416778564453,
        -2661.5,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.507418692111969,
        -0.7326852679252625,
        0.45353996753692627
      ],
      "plane_d": -2537.18505859375,
      "bbox_min": [
        -169.5,
        -2924.48193359375,
        810.3937377929688
      ],
      "bbox_max": [
        44.51416778564453,
        -2661.5,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5551269054412842,
        -0.8123753666877747,
        0.17855116724967957
      ],
      "plane_d": -2520.319091796875,
      "bbox_min": [
        -169.5,
        -2906.363525390625,
        810.3937377929688
      ],
      "bbox_max": [
        44.51416778564453,
        -2661.5,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7958733439445496,
        -0.47819983959198,
        0.3713630437850952
      ],
      "plane_d": -1720.8792724609375,
      "bbox_min": [
        -169.5,
        -2865.630615234375,
        885.0
      ],
      "bbox_max": [
        -31.250652313232422,
        -2661.5,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.0,
        0.3713906705379486
      ],
      "plane_d": -200.08673095703125,
      "bbox_min": [
        -143.5,
        -2852.239501953125,
        885.0
      ],
      "bbox_max": [
        -31.250652313232422,
        -2661.5,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": -461.91717529296875,
      "bbox_min": [
        -143.5,
        -2666.5,
        885.0
      ],
      "bbox_max": [
        -138.5,
        -2661.5,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -2804.4638671875,
      "bbox_min": [
        -143.5,
        -2666.5,
        885.0
      ],
      "bbox_max": [
        -138.5,
        -2661.5,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2142.4599609375,
      "bbox_min": [
        -143.5,
        -2661.678955078125,
        885.0
      ],
      "bbox_max": [
        -138.5,
        -2661.5,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47815585136413574,
        -0.7958678007125854,
        0.3714316487312317
      ],
      "plane_d": -2581.730712890625,
      "bbox_min": [
        -38.11168670654297,
        -2852.239501953125,
        885.0
      ],
      "bbox_max": [
        -31.250652313232422,
        -2845.378662109375,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4781661629676819,
        0.7958673238754272,
        0.3714190721511841
      ],
      "plane_d": 1919.6636962890625,
      "bbox_min": [
        -38.11168670654297,
        -2849.664306640625,
        885.0
      ],
      "bbox_max": [
        -31.250652313232422,
        -2845.378662109375,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7958720922470093,
        0.47814229130744934,
        0.37143996357917786
      ],
      "plane_d": 1058.6922607421875,
      "bbox_min": [
        -33.887123107910156,
        -2849.664306640625,
        885.0
      ],
      "bbox_max": [
        -31.250652313232422,
        -2845.378662109375,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4782145023345947,
        0.7958632111549377,
        0.37136587500572205
      ],
      "plane_d": 1919.697021484375,
      "bbox_min": [
        -169.5,
        -2865.630615234375,
        885.0
      ],
      "bbox_max": [
        -53.53700256347656,
        -2663.672119140625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4782295823097229,
        -0.7958368062973022,
        0.3714030683040619
      ],
      "plane_d": -2581.61328125,
      "bbox_min": [
        -60.39803695678711,
        -2865.630615234375,
        885.0
      ],
      "bbox_max": [
        -53.53700256347656,
        -2858.76953125,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.795860767364502,
        -0.4781908392906189,
        0.3714016377925873
      ],
      "plane_d": -1745.0277099609375,
      "bbox_min": [
        -60.39803695678711,
        -2865.630615234375,
        885.0
      ],
      "bbox_max": [
        -53.53700256347656,
        -2858.76953125,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7958558797836304,
        0.47819802165031433,
        0.3714028000831604
      ],
      "plane_d": 1083.023681640625,
      "bbox_min": [
        -56.17348098754883,
        -2863.05517578125,
        885.0
      ],
      "bbox_max": [
        -53.53700256347656,
        -2858.76953125,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -2804.4638671875,
      "bbox_min": [
        -169.5,
        -2666.5,
        885.0
      ],
      "bbox_max": [
        -164.5,
        -2663.672119140625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": -486.05755615234375,
      "bbox_min": [
        -169.5,
        -2666.5,
        885.0
      ],
      "bbox_max": [
        -169.32101440429688,
        -2665.086669921875,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499540239572525,
        0.8658553957939148,
        0.02745842933654785
      ],
      "plane_d": 2413.8603515625,
      "bbox_min": [
        -10.90380859375,
        -2809.56689453125,
        810.5975952148438
      ],
      "bbox_max": [
        -6.884873867034912,
        -2807.21484375,
        820.5166625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5873186588287354,
        0.808143138885498,
        0.04428848996758461
      ],
      "plane_d": 2238.9775390625,
      "bbox_min": [
        -10.90380859375,
        -2808.1181640625,
        810.8114013671875
      ],
      "bbox_max": [
        -9.408008575439453,
        -2807.21484375,
        820.5166625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14437326788902283,
        0.977375328540802,
        0.1545761078596115
      ],
      "plane_d": 2438.747314453125,
      "bbox_min": [
        -211.42047119140625,
        -2665.169921875,
        822.1439819335938
      ],
      "bbox_max": [
        -132.919921875,
        -2654.5947265625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.0,
        0.3713906705379486
      ],
      "plane_d": -175.9463348388672,
      "bbox_min": [
        -164.67898559570312,
        -2663.856689453125,
        885.0
      ],
      "bbox_max": [
        -164.5,
        -2661.5,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8067750930786133,
        -0.3633389174938202,
        0.46593865752220154
      ],
      "plane_d": -1509.4693603515625,
      "bbox_min": [
        -282.3660583496094,
        -2902.1630859375,
        824.204833984375
      ],
      "bbox_max": [
        -68.19921875,
        -2656.7822265625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.507418692111969,
        -0.7326852679252625,
        0.45353996753692627
      ],
      "plane_d": -2537.18505859375,
      "bbox_min": [
        -91.89059448242188,
        -2902.1630859375,
        829.2857055664062
      ],
      "bbox_max": [
        -68.19921875,
        -2867.525634765625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14437326788902283,
        0.977375328540802,
        0.1545761078596115
      ],
      "plane_d": 2438.747314453125,
      "bbox_min": [
        -282.3660583496094,
        -2723.082275390625,
        824.204833984375
      ],
      "bbox_max": [
        -160.121337890625,
        -2656.7822265625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1262851357460022,
        -0.9829915761947632,
        0.13334013521671295
      ],
      "plane_d": -2811.5068359375,
      "bbox_min": [
        -248.13571166992188,
        -2721.14453125,
        830.1307983398438
      ],
      "bbox_max": [
        -205.5291290283203,
        -2710.77294921875,
        866.2379760742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -901.4473876953125,
      "bbox_min": [
        -221.643310546875,
        -2711.95166015625,
        885.4474487304688
      ],
      "bbox_max": [
        -188.15866088867188,
        -2657.9775390625,
        901.4474487304688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9466864466667175,
        -0.12172307074069977,
        -0.2982756495475769
      ],
      "plane_d": -268.43695068359375,
      "bbox_min": [
        -221.643310546875,
        -2711.95166015625,
        885.4474487304688
      ],
      "bbox_max": [
        -188.15866088867188,
        -2657.9775390625,
        901.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.021952424198389053,
        -0.9542263746261597,
        -0.29827821254730225
      ],
      "plane_d": -2323.260498046875,
      "bbox_min": [
        -218.94351196289062,
        -2711.95166015625,
        885.4474487304688
      ],
      "bbox_max": [
        -188.15866088867188,
        -2657.9775390625,
        901.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1394767165184021,
        0.9442327618598938,
        -0.298279732465744
      ],
      "plane_d": 2752.389404296875,
      "bbox_min": [
        -208.3954620361328,
        -2665.51318359375,
        885.4474487304688
      ],
      "bbox_max": [
        -188.15866088867188,
        -2657.9775390625,
        901.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 166.0,
      "bbox_min": [
        -201.3208770751953,
        -2871.031005859375,
        885.4474487304688
      ],
      "bbox_max": [
        -28.847665786743164,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2665.0,
      "bbox_min": [
        -201.3208770751953,
        -2712.09521484375,
        885.4474487304688
      ],
      "bbox_max": [
        -166.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -168.0,
      "bbox_min": [
        -170.0,
        -2665.0,
        885.4474487304688
      ],
      "bbox_max": [
        -166.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2663.0,
      "bbox_min": [
        -168.0,
        -2665.0,
        885.4474487304688
      ],
      "bbox_max": [
        -166.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -168.0,
        -2665.0,
        887.5
      ],
      "bbox_max": [
        -166.0,
        -2663.0,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -168.0,
        -2665.0,
        920.0
      ],
      "bbox_max": [
        -166.0,
        -2663.0,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -887.5,
      "bbox_min": [
        -168.0,
        -2665.0,
        887.5
      ],
      "bbox_max": [
        -166.0,
        -2663.0,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -168.0,
        -2663.0,
        885.4474487304688
      ],
      "bbox_max": [
        -166.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -168.0,
        -2663.0,
        918.5
      ],
      "bbox_max": [
        -166.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2655.5,
      "bbox_min": [
        -168.0,
        -2655.5,
        918.5
      ],
      "bbox_max": [
        -166.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2142.4599609375,
      "bbox_min": [
        -168.0,
        -2663.0,
        885.4474487304688
      ],
      "bbox_max": [
        -166.0,
        -2661.678955078125,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -887.5,
      "bbox_min": [
        -168.0,
        -2663.0,
        887.5
      ],
      "bbox_max": [
        -166.0,
        -2662.5,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -170.0,
        -2665.0,
        885.4474487304688
      ],
      "bbox_max": [
        -168.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2655.5,
      "bbox_min": [
        -170.0,
        -2655.5,
        918.5
      ],
      "bbox_max": [
        -168.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2142.4599609375,
      "bbox_min": [
        -169.32101440429688,
        -2662.5,
        885.4474487304688
      ],
      "bbox_max": [
        -168.0,
        -2661.678955078125,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -170.0,
        -2672.5,
        885.4474487304688
      ],
      "bbox_max": [
        -166.0,
        -2665.0,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2672.5,
      "bbox_min": [
        -170.0,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -166.0,
        -2672.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -887.5,
      "bbox_min": [
        -169.32101440429688,
        -2666.321044921875,
        885.4474487304688
      ],
      "bbox_max": [
        -166.0,
        -2665.0,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5151067972183228,
        -0.8571260571479797,
        0.0
      ],
      "plane_d": -2424.921875,
      "bbox_min": [
        -63.916900634765625,
        -2871.031005859375,
        885.4474487304688
      ],
      "bbox_max": [
        -51.732017517089844,
        -2854.3994140625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8572120070457458,
        -0.5149638056755066,
        0.0
      ],
      "plane_d": -1523.7626953125,
      "bbox_min": [
        -63.916900634765625,
        -2864.6025390625,
        885.4474487304688
      ],
      "bbox_max": [
        -55.59528732299805,
        -2854.3994140625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.514945924282074,
        0.8572226762771606,
        0.0
      ],
      "plane_d": 2423.20751953125,
      "bbox_min": [
        -62.201942443847656,
        -2863.572265625,
        885.4474487304688
      ],
      "bbox_max": [
        -55.59528732299805,
        -2854.3994140625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -58.339805603027344,
        -2863.572265625,
        887.5
      ],
      "bbox_max": [
        -55.59528732299805,
        -2860.827880859375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -58.33970260620117,
        -2863.572265625,
        920.0
      ],
      "bbox_max": [
        -55.59528732299805,
        -2860.827880859375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -887.5,
      "bbox_min": [
        -58.339805603027344,
        -2863.572265625,
        887.5
      ],
      "bbox_max": [
        -55.59532165527344,
        -2860.827880859375,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -62.201942443847656,
        -2861.85791015625,
        885.4474487304688
      ],
      "bbox_max": [
        -56.6253547668457,
        -2854.3994140625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -62.201942443847656,
        -2861.85791015625,
        918.5
      ],
      "bbox_max": [
        -56.62539291381836,
        -2854.3994140625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5150478482246399,
        0.8571614623069763,
        0.0
      ],
      "plane_d": 2415.526611328125,
      "bbox_min": [
        -62.201942443847656,
        -2855.4287109375,
        918.5
      ],
      "bbox_max": [
        -60.48876190185547,
        -2854.3994140625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4782145023345947,
        0.7958632111549377,
        0.37136587500572205
      ],
      "plane_d": 1919.697021484375,
      "bbox_min": [
        -59.01997756958008,
        -2861.857666015625,
        885.4474487304688
      ],
      "bbox_max": [
        -56.6253547668457,
        -2859.695556640625,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -887.5,
      "bbox_min": [
        -58.597164154052734,
        -2861.857666015625,
        887.5
      ],
      "bbox_max": [
        -56.6253547668457,
        -2860.399169921875,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -63.916900634765625,
        -2864.6025390625,
        885.4474487304688
      ],
      "bbox_max": [
        -57.30973815917969,
        -2855.4287109375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5150478482246399,
        0.8571614623069763,
        0.0
      ],
      "plane_d": 2415.526611328125,
      "bbox_min": [
        -63.916900634765625,
        -2856.459228515625,
        918.5
      ],
      "bbox_max": [
        -62.201942443847656,
        -2855.4287109375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -887.5,
      "bbox_min": [
        -60.152442932128906,
        -2863.82958984375,
        885.4474487304688
      ],
      "bbox_max": [
        -57.30986022949219,
        -2860.7255859375,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -59.02387619018555,
        -2871.031005859375,
        918.5
      ],
      "bbox_max": [
        -51.732017517089844,
        -2862.5419921875,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5150534510612488,
        -0.8571580648422241,
        0.0
      ],
      "plane_d": -2432.5166015625,
      "bbox_min": [
        -55.16118621826172,
        -2871.031005859375,
        918.5
      ],
      "bbox_max": [
        -51.732017517089844,
        -2868.970458984375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.795860767364502,
        -0.4781908392906189,
        0.3714016377925873
      ],
      "plane_d": -1745.0277099609375,
      "bbox_min": [
        -58.441917419433594,
        -2865.385009765625,
        885.4474487304688
      ],
      "bbox_max": [
        -57.480712890625,
        -2863.82958984375,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2663.0,
      "bbox_min": [
        -142.0,
        -2665.0,
        885.4474487304688
      ],
      "bbox_max": [
        -138.67898559570312,
        -2661.678955078125,
        914.863525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        -142.0,
        -2665.0,
        885.4474487304688
      ],
      "bbox_max": [
        -138.67898559570312,
        -2663.0,
        913.1650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -887.5,
      "bbox_min": [
        -142.0,
        -2665.0,
        887.5
      ],
      "bbox_max": [
        -140.0,
        -2663.0,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.0,
        0.3713906705379486
      ],
      "plane_d": -200.08673095703125,
      "bbox_min": [
        -140.0,
        -2665.0,
        885.4474487304688
      ],
      "bbox_max": [
        -138.67898559570312,
        -2663.0,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -887.5,
      "bbox_min": [
        -140.0,
        -2665.0,
        887.5
      ],
      "bbox_max": [
        -139.5,
        -2663.0,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -887.5,
      "bbox_min": [
        -142.0,
        -2663.0,
        885.4474487304688
      ],
      "bbox_max": [
        -138.67898559570312,
        -2661.678955078125,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5150331258773804,
        0.8571703433990479,
        0.0
      ],
      "plane_d": 2423.052490234375,
      "bbox_min": [
        -142.0,
        -2856.60986328125,
        885.4474487304688
      ],
      "bbox_max": [
        -28.847665786743164,
        -2665.0,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5150179266929626,
        -0.8571793437004089,
        0.0
      ],
      "plane_d": -2425.07861328125,
      "bbox_min": [
        -36.053470611572266,
        -2856.60986328125,
        885.4474487304688
      ],
      "bbox_max": [
        -28.847665786743164,
        -2846.75634765625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8571618795394897,
        0.5150470733642578,
        0.0
      ],
      "plane_d": 1495.998046875,
      "bbox_min": [
        -36.053470611572266,
        -2850.18115234375,
        885.4474487304688
      ],
      "bbox_max": [
        -32.17672348022461,
        -2846.75634765625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -36.053470611572266,
        -2850.18115234375,
        887.5
      ],
      "bbox_max": [
        -33.30890655517578,
        -2847.436767578125,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -36.05342483520508,
        -2850.180908203125,
        920.0
      ],
      "bbox_max": [
        -33.30890655517578,
        -2847.436767578125,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -887.5,
      "bbox_min": [
        -36.053470611572266,
        -2850.18115234375,
        887.5
      ],
      "bbox_max": [
        -33.30891418457031,
        -2847.436767578125,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7958720922470093,
        0.47814229130744934,
        0.37143996357917786
      ],
      "plane_d": 1058.6922607421875,
      "bbox_min": [
        -34.339088439941406,
        -2849.15087890625,
        885.4474487304688
      ],
      "bbox_max": [
        -32.17672348022461,
        -2846.75634765625,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -887.5,
      "bbox_min": [
        -34.33905029296875,
        -2849.15087890625,
        887.5
      ],
      "bbox_max": [
        -32.880523681640625,
        -2847.17919921875,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -34.339088439941406,
        -2849.15087890625,
        918.5
      ],
      "bbox_max": [
        -32.69523239135742,
        -2847.0654296875,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -34.33908462524414,
        -2849.15087890625,
        920.0
      ],
      "bbox_max": [
        -33.218177795410156,
        -2847.379638671875,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -35.023521423339844,
        -2856.60986328125,
        885.4474487304688
      ],
      "bbox_max": [
        -28.847665786743164,
        -2848.470703125,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -35.02347183227539,
        -2856.60986328125,
        918.5
      ],
      "bbox_max": [
        -28.847665786743164,
        -2849.096435546875,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5150240063667297,
        -0.857175886631012,
        0.0
      ],
      "plane_d": -2432.56884765625,
      "bbox_min": [
        -31.16071319580078,
        -2856.60986328125,
        918.5
      ],
      "bbox_max": [
        -28.847665786743164,
        -2855.22021484375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -887.5,
      "bbox_min": [
        -35.023521423339844,
        -2850.60986328125,
        885.4474487304688
      ],
      "bbox_max": [
        -31.496259689331055,
        -2848.470703125,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -142.0,
        -2848.466796875,
        918.5
      ],
      "bbox_max": [
        -34.24418258666992,
        -2667.072509765625,
        920.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2672.5,
      "bbox_min": [
        -141.78041076660156,
        -2842.0380859375,
        918.5
      ],
      "bbox_max": [
        -37.56859588623047,
        -2672.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5150486826896667,
        0.8571609258651733,
        0.0
      ],
      "plane_d": 2415.525390625,
      "bbox_min": [
        -39.915992736816406,
        -2842.0380859375,
        918.5
      ],
      "bbox_max": [
        -37.56859588623047,
        -2840.627685546875,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -887.5,
      "bbox_min": [
        -36.31084060668945,
        -2848.466796875,
        885.4474487304688
      ],
      "bbox_max": [
        -33.206912994384766,
        -2845.624267578125,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7958720922470093,
        0.47814229130744934,
        0.37143996357917786
      ],
      "plane_d": 1058.6922607421875,
      "bbox_min": [
        -34.1679801940918,
        -2847.17919921875,
        885.4474487304688
      ],
      "bbox_max": [
        -33.206912994384766,
        -2845.624267578125,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -142.0,
        -2868.970458984375,
        885.4474487304688
      ],
      "bbox_max": [
        -31.160676956176758,
        -2672.134521484375,
        920.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -142.0,
        -2857.639892578125,
        918.5
      ],
      "bbox_max": [
        -31.160676956176758,
        -2672.134521484375,
        920.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5150240063667297,
        -0.857175886631012,
        0.0
      ],
      "plane_d": -2432.56884765625,
      "bbox_min": [
        -32.87483215332031,
        -2857.639892578125,
        918.5
      ],
      "bbox_max": [
        -31.160676956176758,
        -2856.60986328125,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2672.5,
      "bbox_min": [
        -142.0,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -141.7803955078125,
        -2672.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -60.48876190185547,
        -2868.970458984375,
        918.5
      ],
      "bbox_max": [
        -50.018218994140625,
        -2853.368896484375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.857166588306427,
        0.5150394439697266,
        0.0
      ],
      "plane_d": 1519.9764404296875,
      "bbox_min": [
        -60.48876190185547,
        -2868.970458984375,
        918.5
      ],
      "bbox_max": [
        -50.018218994140625,
        -2853.368896484375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5150478482246399,
        0.8571614623069763,
        0.0
      ],
      "plane_d": 2415.526611328125,
      "bbox_min": [
        -60.48876190185547,
        -2868.970458984375,
        918.5
      ],
      "bbox_max": [
        -50.018218994140625,
        -2853.368896484375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5150534510612488,
        -0.8571580648422241,
        0.0
      ],
      "plane_d": -2432.5166015625,
      "bbox_min": [
        -51.732017517089844,
        -2868.970458984375,
        918.5
      ],
      "bbox_max": [
        -50.018218994140625,
        -2867.940673828125,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7958733439445496,
        -0.47819983959198,
        0.3713630437850952
      ],
      "plane_d": -1720.8792724609375,
      "bbox_min": [
        -57.305843353271484,
        -2863.67431640625,
        885.4474487304688
      ],
      "bbox_max": [
        -34.34300231933594,
        -2847.33447265625,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -887.5,
      "bbox_min": [
        -37.866092681884766,
        -2851.993896484375,
        885.4474487304688
      ],
      "bbox_max": [
        -34.34300231933594,
        -2847.33447265625,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47815585136413574,
        -0.7958678007125854,
        0.3714316487312317
      ],
      "plane_d": -2581.730712890625,
      "bbox_min": [
        -35.475276947021484,
        -2851.993896484375,
        885.4474487304688
      ],
      "bbox_max": [
        -34.34300231933594,
        -2850.60986328125,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4782145023345947,
        0.7958632111549377,
        0.37136587500572205
      ],
      "plane_d": 1919.697021484375,
      "bbox_min": [
        -57.305843353271484,
        -2863.67431640625,
        885.4474487304688
      ],
      "bbox_max": [
        -53.782596588134766,
        -2859.01513671875,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4782295823097229,
        -0.7958368062973022,
        0.3714030683040619
      ],
      "plane_d": -2581.61328125,
      "bbox_min": [
        -55.33778381347656,
        -2863.67431640625,
        885.4474487304688
      ],
      "bbox_max": [
        -53.782596588134766,
        -2862.713134765625,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -166.0,
        -2672.5,
        885.4474487304688
      ],
      "bbox_max": [
        -142.0,
        -2655.5,
        920.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -166.0,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -164.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2655.5,
      "bbox_min": [
        -166.0,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -164.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2672.5,
      "bbox_min": [
        -166.0,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -164.0,
        -2672.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -144.0,
      "bbox_min": [
        -144.0,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -142.0,
        -2662.53662109375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -144.0,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -142.0,
        -2663.725830078125,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2672.5,
      "bbox_min": [
        -144.0,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -142.0,
        -2672.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": -461.91717529296875,
      "bbox_min": [
        -166.0,
        -2666.321044921875,
        885.4474487304688
      ],
      "bbox_max": [
        -142.0,
        -2661.678955078125,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -887.5,
      "bbox_min": [
        -143.32101440429688,
        -2666.321044921875,
        885.4474487304688
      ],
      "bbox_max": [
        -142.0,
        -2661.678955078125,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2142.4599609375,
      "bbox_min": [
        -143.32101440429688,
        -2662.5,
        885.4474487304688
      ],
      "bbox_max": [
        -142.0,
        -2661.678955078125,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -2804.4638671875,
      "bbox_min": [
        -166.0,
        -2666.321044921875,
        885.4474487304688
      ],
      "bbox_max": [
        -164.67898559570312,
        -2665.5,
        887.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 191.5,
      "bbox_min": [
        -191.5,
        -2492.481689453125,
        803.9765625
      ],
      "bbox_max": [
        -191.5,
        -2492.259033203125,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43512478470802307,
        0.8503791093826294,
        0.2958408296108246
      ],
      "plane_d": 2149.4951171875,
      "bbox_min": [
        -38.091575622558594,
        -3997.394775390625,
        803.1861572265625
      ],
      "bbox_max": [
        616.0787963867188,
        -2807.56298828125,
        1827.77685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7833710312843323,
        0.6178421974182129,
        0.06782949715852737
      ],
      "plane_d": 1863.1636962890625,
      "bbox_min": [
        -38.091575622558594,
        -3997.394775390625,
        803.1861572265625
      ],
      "bbox_max": [
        616.0787963867188,
        -2807.56298828125,
        1827.77685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6327277421951294,
        0.771410346031189,
        0.06768848747015
      ],
      "plane_d": 2549.050537109375,
      "bbox_min": [
        554.5967407226562,
        -3919.642822265625,
        1714.6058349609375
      ],
      "bbox_max": [
        560.6563720703125,
        -3914.3642578125,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6327277421951294,
        0.771410346031189,
        0.06768848747015
      ],
      "plane_d": 2549.050537109375,
      "bbox_min": [
        -38.091575622558594,
        -3944.7900390625,
        803.1861572265625
      ],
      "bbox_max": [
        580.78759765625,
        -2807.56298828125,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.783856213092804,
        0.6171746850013733,
        0.06829895824193954
      ],
      "plane_d": 1859.4244384765625,
      "bbox_min": [
        555.60498046875,
        -3944.7900390625,
        1715.6435546875
      ],
      "bbox_max": [
        580.78759765625,
        -3914.939697265625,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -885.4474487304688,
      "bbox_min": [
        -38.091575622558594,
        -3305.422119140625,
        803.1861572265625
      ],
      "bbox_max": [
        492.5228271484375,
        -2807.56298828125,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5551269054412842,
        -0.8123753666877747,
        0.17855116724967957
      ],
      "plane_d": -2520.319091796875,
      "bbox_min": [
        12.945999145507812,
        -2898.948974609375,
        803.2691650390625
      ],
      "bbox_max": [
        79.60877227783203,
        -2855.791015625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9736523628234863,
        -0.03027019277215004,
        0.22601918876171112
      ],
      "plane_d": -345.6151123046875,
      "bbox_min": [
        60.3037109375,
        -2871.634765625,
        803.2691650390625
      ],
      "bbox_max": [
        79.60877227783203,
        -2855.791015625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9736523628234863,
        -0.03027019277215004,
        0.22601918876171112
      ],
      "plane_d": -345.6151123046875,
      "bbox_min": [
        71.75244140625,
        -2859.235595703125,
        803.1861572265625
      ],
      "bbox_max": [
        79.65071868896484,
        -2855.12451171875,
        837.57421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.42698726058006287,
        0.9038631319999695,
        0.02670924738049507
      ],
      "plane_d": 2528.235595703125,
      "bbox_min": [
        71.75244140625,
        -2858.506103515625,
        803.1861572265625
      ],
      "bbox_max": [
        79.65071868896484,
        -2855.12451171875,
        837.57421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3420272767543793,
        0.9396900534629822,
        0.0
      ],
      "plane_d": 2911.359619140625,
      "bbox_min": [
        -38.091575622558594,
        -3305.422119140625,
        918.5
      ],
      "bbox_max": [
        492.5228271484375,
        -2839.97802734375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3420468866825104,
        -0.9396829009056091,
        0.0
      ],
      "plane_d": -2913.326416015625,
      "bbox_min": [
        465.60345458984375,
        -3305.422119140625,
        1281.5438232421875
      ],
      "bbox_max": [
        491.83868408203125,
        -3271.4169921875,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9397011995315552,
        0.3419966697692871,
        0.0
      ],
      "plane_d": 1573.4837646484375,
      "bbox_min": [
        475.1802978515625,
        -3279.11083984375,
        1281.5438232421875
      ],
      "bbox_max": [
        491.83868408203125,
        -3271.4169921875,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9396815896034241,
        -0.34205055236816406,
        0.0
      ],
      "plane_d": -1575.6507568359375,
      "bbox_min": [
        482.2278747558594,
        -3279.11083984375,
        1284.2423095703125
      ],
      "bbox_max": [
        491.83868408203125,
        -3273.982177734375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1323.5,
      "bbox_min": [
        482.2278747558594,
        -3276.54541015625,
        1323.5
      ],
      "bbox_max": [
        484.7911682128906,
        -3273.982177734375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1325.0,
      "bbox_min": [
        482.2278747558594,
        -3276.54541015625,
        1325.0
      ],
      "bbox_max": [
        484.7911682128906,
        -3273.982177734375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1323.5,
      "bbox_min": [
        484.1072082519531,
        -3279.11083984375,
        1323.5
      ],
      "bbox_max": [
        491.83868408203125,
        -3274.666259765625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1325.0,
      "bbox_min": [
        484.1072082519531,
        -3279.11083984375,
        1323.5
      ],
      "bbox_max": [
        491.83868408203125,
        -3274.666259765625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9396865963935852,
        -0.3420366942882538,
        0.0
      ],
      "plane_d": -1583.107666015625,
      "bbox_min": [
        491.1546630859375,
        -3279.11083984375,
        1323.5
      ],
      "bbox_max": [
        491.83868408203125,
        -3277.231689453125,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1323.5,
      "bbox_min": [
        475.1802978515625,
        -3275.861328125,
        1323.5
      ],
      "bbox_max": [
        482.91168212890625,
        -3271.4169921875,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1325.0,
      "bbox_min": [
        475.1802978515625,
        -3275.861328125,
        1323.5
      ],
      "bbox_max": [
        482.91168212890625,
        -3271.4169921875,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9396947026252747,
        0.3420146405696869,
        0.0
      ],
      "plane_d": 1566.03955078125,
      "bbox_min": [
        475.1802978515625,
        -3273.2958984375,
        1323.5
      ],
      "bbox_max": [
        475.8641662597656,
        -3271.4169921875,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3419538140296936,
        0.9397167563438416,
        0.0
      ],
      "plane_d": 2937.482421875,
      "bbox_min": [
        465.60345458984375,
        -3305.422119140625,
        1283.3314208984375
      ],
      "bbox_max": [
        491.1546630859375,
        -3273.2958984375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9396525621414185,
        0.34213024377822876,
        0.0
      ],
      "plane_d": 1573.9007568359375,
      "bbox_min": [
        465.60345458984375,
        -3305.422119140625,
        1283.3314208984375
      ],
      "bbox_max": [
        482.9465026855469,
        -3295.849609375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3421252369880676,
        -0.9396543502807617,
        0.0
      ],
      "plane_d": -2939.195068359375,
      "bbox_min": [
        472.6507873535156,
        -3305.422119140625,
        1283.468505859375
      ],
      "bbox_max": [
        482.9465026855469,
        -3298.414306640625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9397253394126892,
        -0.3419305086135864,
        0.0
      ],
      "plane_d": -1575.276123046875,
      "bbox_min": [
        473.3351745605469,
        -3303.54345703125,
        1286.0291748046875
      ],
      "bbox_max": [
        482.9465026855469,
        -3298.414306640625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1325.0,
      "bbox_min": [
        473.3351745605469,
        -3300.977783203125,
        1323.5
      ],
      "bbox_max": [
        475.8984680175781,
        -3298.414306640625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1323.5,
      "bbox_min": [
        473.3351745605469,
        -3300.977783203125,
        1323.5
      ],
      "bbox_max": [
        475.8984680175781,
        -3298.414306640625,
        1323.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1323.5,
      "bbox_min": [
        475.2145080566406,
        -3303.54345703125,
        1323.5
      ],
      "bbox_max": [
        482.9465026855469,
        -3299.09814453125,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1325.0,
      "bbox_min": [
        475.2145080566406,
        -3303.54345703125,
        1323.5
      ],
      "bbox_max": [
        482.9465026855469,
        -3299.09814453125,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9396978616714478,
        -0.3420056402683258,
        0.0
      ],
      "plane_d": -1583.010986328125,
      "bbox_min": [
        482.2619323730469,
        -3303.54345703125,
        1323.5
      ],
      "bbox_max": [
        482.9465026855469,
        -3301.66259765625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1323.5,
      "bbox_min": [
        472.6507873535156,
        -3305.422119140625,
        1323.5
      ],
      "bbox_max": [
        482.2619323730469,
        -3300.29345703125,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9396978616714478,
        -0.3420056402683258,
        0.0
      ],
      "plane_d": -1583.010986328125,
      "bbox_min": [
        481.5782165527344,
        -3305.422119140625,
        1323.5
      ],
      "bbox_max": [
        482.2619323730469,
        -3303.54345703125,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1323.5,
      "bbox_min": [
        465.60345458984375,
        -3302.1728515625,
        1323.5
      ],
      "bbox_max": [
        474.0193786621094,
        -3295.849609375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9396963119506836,
        0.34201014041900635,
        0.0
      ],
      "plane_d": 1566.025146484375,
      "bbox_min": [
        465.60345458984375,
        -3299.60791015625,
        1323.5
      ],
      "bbox_max": [
        466.9713439941406,
        -3295.849609375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34201404452323914,
        0.9396949410438538,
        0.0
      ],
      "plane_d": 2935.3818359375,
      "bbox_min": [
        466.9713439941406,
        -3301.66259765625,
        1323.5
      ],
      "bbox_max": [
        491.1546630859375,
        -3273.2958984375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1323.5,
      "bbox_min": [
        466.9713439941406,
        -3301.66259765625,
        1323.5
      ],
      "bbox_max": [
        483.6302490234375,
        -3293.9697265625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1325.0,
      "bbox_min": [
        466.9713439941406,
        -3301.66259765625,
        1323.5
      ],
      "bbox_max": [
        483.6302490234375,
        -3293.9697265625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9396963119506836,
        0.34201014041900635,
        0.0
      ],
      "plane_d": 1566.025146484375,
      "bbox_min": [
        466.9713439941406,
        -3301.66259765625,
        1323.5
      ],
      "bbox_max": [
        483.6302490234375,
        -3293.9697265625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9396978616714478,
        -0.3420056402683258,
        0.0
      ],
      "plane_d": -1583.010986328125,
      "bbox_min": [
        482.9465026855469,
        -3301.66259765625,
        1323.5
      ],
      "bbox_max": [
        483.6302490234375,
        -3299.783935546875,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1325.0,
      "bbox_min": [
        474.49603271484375,
        -3280.989990234375,
        1323.5
      ],
      "bbox_max": [
        491.1546630859375,
        -3273.2958984375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1323.5,
      "bbox_min": [
        474.49603271484375,
        -3280.989990234375,
        1323.5
      ],
      "bbox_max": [
        491.1546630859375,
        -3273.2958984375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34200307726860046,
        -0.9396988153457642,
        0.0
      ],
      "plane_d": -2915.39990234375,
      "bbox_min": [
        474.49603271484375,
        -3280.989990234375,
        1323.5
      ],
      "bbox_max": [
        491.1546630859375,
        -3273.2958984375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9396947026252747,
        0.3420146405696869,
        0.0
      ],
      "plane_d": 1566.03955078125,
      "bbox_min": [
        474.49603271484375,
        -3280.989990234375,
        1323.5
      ],
      "bbox_max": [
        491.1546630859375,
        -3273.2958984375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9396865963935852,
        -0.3420366942882538,
        0.0
      ],
      "plane_d": -1583.107666015625,
      "bbox_min": [
        490.4706726074219,
        -3280.989990234375,
        1323.5
      ],
      "bbox_max": [
        491.1546630859375,
        -3279.11083984375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1323.5,
      "bbox_min": [
        -38.091575622558594,
        -3277.231689453125,
        918.5
      ],
      "bbox_max": [
        492.5228271484375,
        -2839.97802734375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1325.0,
      "bbox_min": [
        475.8641662597656,
        -3277.231689453125,
        1323.5
      ],
      "bbox_max": [
        492.5228271484375,
        -3269.537841796875,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3420146107673645,
        0.9396947026252747,
        0.0
      ],
      "plane_d": 2909.381103515625,
      "bbox_min": [
        475.8641662597656,
        -3277.231689453125,
        1323.5
      ],
      "bbox_max": [
        492.5228271484375,
        -3269.537841796875,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9396865963935852,
        -0.3420366942882538,
        0.0
      ],
      "plane_d": -1583.107666015625,
      "bbox_min": [
        475.8641662597656,
        -3277.231689453125,
        1323.5
      ],
      "bbox_max": [
        492.5228271484375,
        -3269.537841796875,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9396947026252747,
        0.3420146405696869,
        0.0
      ],
      "plane_d": 1566.03955078125,
      "bbox_min": [
        475.8641662597656,
        -3271.4169921875,
        1323.5
      ],
      "bbox_max": [
        476.5481262207031,
        -3269.537841796875,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -38.091575622558594,
        -2855.534423828125,
        918.5
      ],
      "bbox_max": [
        -27.731870651245117,
        -2839.97802734375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8571664690971375,
        0.5150395035743713,
        0.0
      ],
      "plane_d": 1493.976806640625,
      "bbox_min": [
        -38.091575622558594,
        -2855.534423828125,
        918.5
      ],
      "bbox_max": [
        -27.731870651245117,
        -2839.97802734375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -38.091575622558594,
        -2855.534423828125,
        918.5
      ],
      "bbox_max": [
        -27.731870651245117,
        -2839.97802734375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5150240063667297,
        -0.857175886631012,
        0.0
      ],
      "plane_d": -2432.56884765625,
      "bbox_min": [
        -38.091575622558594,
        -2855.534423828125,
        918.5
      ],
      "bbox_max": [
        -27.731870651245117,
        -2839.97802734375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5150486826896667,
        0.8571609258651733,
        0.0
      ],
      "plane_d": 2415.525390625,
      "bbox_min": [
        -38.091575622558594,
        -2840.94189453125,
        918.5
      ],
      "bbox_max": [
        -36.487510681152344,
        -2839.97802734375,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 816.0,
      "bbox_min": [
        -196.81251525878906,
        -2672.5,
        795.8539428710938
      ],
      "bbox_max": [
        -138.0,
        -2483.38818359375,
        920.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -170.0,
        -2672.5,
        816.0
      ],
      "bbox_max": [
        -138.0,
        -2484.188232421875,
        920.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -144.0,
      "bbox_min": [
        -170.0,
        -2527.5,
        816.0
      ],
      "bbox_max": [
        -138.0,
        -2484.188232421875,
        817.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        -144.0,
        -2527.5,
        816.0
      ],
      "bbox_max": [
        -138.0,
        -2485.613037109375,
        817.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2510.5,
      "bbox_min": [
        -144.0,
        -2527.5,
        816.0
      ],
      "bbox_max": [
        -138.0,
        -2494.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2527.5,
      "bbox_min": [
        -144.0,
        -2527.5,
        816.0
      ],
      "bbox_max": [
        -138.0,
        -2527.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2494.5,
      "bbox_min": [
        -144.0,
        -2494.5,
        816.0
      ],
      "bbox_max": [
        -138.0,
        -2494.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        -170.0,
        -2527.5,
        816.0
      ],
      "bbox_max": [
        -164.0,
        -2484.188232421875,
        817.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 164.0,
      "bbox_min": [
        -170.0,
        -2527.5,
        816.0
      ],
      "bbox_max": [
        -164.0,
        -2484.455322265625,
        817.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2510.5,
      "bbox_min": [
        -170.0,
        -2527.5,
        816.0
      ],
      "bbox_max": [
        -164.0,
        -2494.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2527.5,
      "bbox_min": [
        -170.0,
        -2527.5,
        816.0
      ],
      "bbox_max": [
        -164.0,
        -2527.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2494.5,
      "bbox_min": [
        -170.0,
        -2494.5,
        816.0
      ],
      "bbox_max": [
        -164.0,
        -2494.5,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        -144.0,
        -2672.5,
        910.6422729492188
      ],
      "bbox_max": [
        -138.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -144.0,
        -2672.5,
        910.6422729492188
      ],
      "bbox_max": [
        -138.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -144.0,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -138.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -144.0,
      "bbox_min": [
        -144.0,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -138.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2655.5,
      "bbox_min": [
        -144.0,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -138.0,
        -2655.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2672.5,
      "bbox_min": [
        -138.7563934326172,
        -2672.5,
        918.5
      ],
      "bbox_max": [
        -138.0,
        -2672.5,
        920.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        -142.0,
        -2665.0,
        910.6422729492188
      ],
      "bbox_max": [
        -140.0,
        -2663.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2663.0,
      "bbox_min": [
        -142.0,
        -2665.0,
        910.6422729492188
      ],
      "bbox_max": [
        -140.0,
        -2663.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2665.0,
      "bbox_min": [
        -142.0,
        -2665.0,
        913.1650390625
      ],
      "bbox_max": [
        -140.0,
        -2663.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -142.0,
      "bbox_min": [
        -142.0,
        -2665.0,
        914.8635864257812
      ],
      "bbox_max": [
        -142.0,
        -2663.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        -196.81251525878906,
        -2520.0,
        795.8539428710938
      ],
      "bbox_max": [
        -140.0,
        -2483.38818359375,
        816.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2487.0,
      "bbox_min": [
        -142.0,
        -2520.0,
        795.94287109375
      ],
      "bbox_max": [
        -140.0,
        -2487.0,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2518.0,
      "bbox_min": [
        -142.0,
        -2520.0,
        799.209228515625
      ],
      "bbox_max": [
        -140.0,
        -2518.0,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2520.0,
      "bbox_min": [
        -142.0,
        -2520.0,
        799.4199829101562
      ],
      "bbox_max": [
        -140.0,
        -2520.0,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 166.0,
      "bbox_min": [
        -196.81251525878906,
        -2520.0,
        799.5082397460938
      ],
      "bbox_max": [
        -166.0,
        -2483.38818359375,
        816.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -168.0,
      "bbox_min": [
        -196.81251525878906,
        -2520.0,
        799.5082397460938
      ],
      "bbox_max": [
        -166.0,
        -2483.38818359375,
        816.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2485.0,
      "bbox_min": [
        -168.0,
        -2520.0,
        799.5082397460938
      ],
      "bbox_max": [
        -166.0,
        -2485.0,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2487.0,
      "bbox_min": [
        -168.0,
        -2520.0,
        799.718994140625
      ],
      "bbox_max": [
        -166.0,
        -2487.0,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2518.0,
      "bbox_min": [
        -168.0,
        -2520.0,
        802.9852905273438
      ],
      "bbox_max": [
        -166.0,
        -2518.0,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2520.0,
      "bbox_min": [
        -168.0,
        -2520.0,
        803.196044921875
      ],
      "bbox_max": [
        -166.0,
        -2520.0,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -804.0,
      "bbox_min": [
        -196.81251525878906,
        -2492.27783203125,
        803.0697021484375
      ],
      "bbox_max": [
        -191.5,
        -2483.38818359375,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 191.5,
      "bbox_min": [
        -191.5,
        -2492.27783203125,
        803.0697021484375
      ],
      "bbox_max": [
        -191.5,
        -2483.624755859375,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.88288414478302,
        0.4690592586994171,
        0.02233842946588993
      ],
      "plane_d": 1373.8875732421875,
      "bbox_min": [
        694.700927734375,
        -4392.64306640625,
        832.4060668945312
      ],
      "bbox_max": [
        755.9525146484375,
        -4018.57470703125,
        1530.9232177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8076764345169067,
        0.5888927578926086,
        0.029395628720521927
      ],
      "plane_d": 1760.45068359375,
      "bbox_min": [
        719.990966796875,
        -4018.696044921875,
        832.4060668945312
      ],
      "bbox_max": [
        720.1486206054688,
        -4018.57470703125,
        837.2236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8981509208679199,
        0.43765097856521606,
        0.042266909033060074
      ],
      "plane_d": 1045.4000244140625,
      "bbox_min": [
        568.4853515625,
        -4608.80029296875,
        658.838134765625
      ],
      "bbox_max": [
        1702.236572265625,
        -2525.15283203125,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2819767892360687,
        0.9591768980026245,
        0.02165084145963192
      ],
      "plane_d": 4007.063232421875,
      "bbox_min": [
        642.281005859375,
        -4608.80029296875,
        831.4278564453125
      ],
      "bbox_max": [
        1002.39794921875,
        -4028.1416015625,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3351188898086548,
        0.9419505000114441,
        0.02060665562748909
      ],
      "plane_d": 3891.733154296875,
      "bbox_min": [
        762.14111328125,
        -4608.80029296875,
        1520.6715087890625
      ],
      "bbox_max": [
        1002.39794921875,
        -4435.98388671875,
        1816.467529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9132217168807983,
        0.39547187089920044,
        0.09812255203723907
      ],
      "plane_d": 748.1595458984375,
      "bbox_min": [
        938.798095703125,
        -4598.2626953125,
        1578.7645263671875
      ],
      "bbox_max": [
        1002.39794921875,
        -4504.81396484375,
        1794.0506591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6763855814933777,
        0.7353199124336243,
        -0.042511679232120514
      ],
      "plane_d": 4126.3173828125,
      "bbox_min": [
        979.21533203125,
        -4608.80029296875,
        1578.7645263671875
      ],
      "bbox_max": [
        1002.39794921875,
        -4596.400390625,
        1765.3458251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9132217168807983,
        0.39547187089920044,
        0.09812255203723907
      ],
      "plane_d": 748.1595458984375,
      "bbox_min": [
        938.798095703125,
        -4507.3974609375,
        1660.364990234375
      ],
      "bbox_max": [
        954.2808837890625,
        -4499.61279296875,
        1794.0506591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8815944790840149,
        0.47145190834999084,
        0.022898972034454346
      ],
      "plane_d": 1384.6318359375,
      "bbox_min": [
        762.14111328125,
        -4435.98388671875,
        867.4931640625
      ],
      "bbox_max": [
        775.1337890625,
        -4424.40771484375,
        1520.6715087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8815944790840149,
        0.47145190834999084,
        0.022898972034454346
      ],
      "plane_d": 1384.6318359375,
      "bbox_min": [
        642.281005859375,
        -4443.63818359375,
        831.4278564453125
      ],
      "bbox_max": [
        872.90966796875,
        -4028.1416015625,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8828872442245483,
        0.46655192971229553,
        0.05328568443655968
      ],
      "plane_d": 1315.7022705078125,
      "bbox_min": [
        679.9492797851562,
        -4440.6171875,
        1520.6715087890625
      ],
      "bbox_max": [
        762.14111328125,
        -4296.572265625,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.988831639289856,
        0.1297459900379181,
        0.07333618402481079
      ],
      "plane_d": -247.9786376953125,
      "bbox_min": [
        679.9492797851562,
        -4319.85498046875,
        1794.4674072265625
      ],
      "bbox_max": [
        683.11962890625,
        -4296.572265625,
        1814.7427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.88288414478302,
        0.4690592586994171,
        0.02233842946588993
      ],
      "plane_d": 1373.8875732421875,
      "bbox_min": [
        642.281005859375,
        -4443.63818359375,
        831.4278564453125
      ],
      "bbox_max": [
        872.90966796875,
        -4028.1416015625,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.993552029132843,
        0.10424546152353287,
        0.044577501714229584
      ],
      "plane_d": -309.21697998046875,
      "bbox_min": [
        679.71435546875,
        -4435.98388671875,
        1520.6715087890625
      ],
      "bbox_max": [
        762.14111328125,
        -4294.8466796875,
        1814.8580322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.988831639289856,
        0.1297459900379181,
        0.07333618402481079
      ],
      "plane_d": -247.9786376953125,
      "bbox_min": [
        679.71435546875,
        -4298.9931640625,
        1793.12841796875
      ],
      "bbox_max": [
        681.7706909179688,
        -4294.8466796875,
        1814.8580322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8828872442245483,
        0.46655192971229553,
        0.05328568443655968
      ],
      "plane_d": 1315.7022705078125,
      "bbox_min": [
        694.1695556640625,
        -4435.98388671875,
        1520.6715087890625
      ],
      "bbox_max": [
        762.14111328125,
        -4309.533203125,
        1543.8734130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44666528701782227,
        -0.14888805150985718,
        0.8822259306907654
      ],
      "plane_d": -1359.3262939453125,
      "bbox_min": [
        786.47900390625,
        -4352.4951171875,
        1197.09619140625
      ],
      "bbox_max": [
        872.90966796875,
        -4168.02490234375,
        1256.812744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6043979525566101,
        0.36455777287483215,
        0.7083789706230164
      ],
      "plane_d": 1161.4814453125,
      "bbox_min": [
        786.47900390625,
        -4274.20458984375,
        1197.09619140625
      ],
      "bbox_max": [
        859.7396240234375,
        -4168.02490234375,
        1254.7398681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.434790700674057,
        -0.0790519118309021,
        0.8970550894737244
      ],
      "plane_d": -1089.6480712890625,
      "bbox_min": [
        786.47900390625,
        -4274.20458984375,
        1220.9613037109375
      ],
      "bbox_max": [
        859.7396240234375,
        -4224.4111328125,
        1254.7398681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9662607908248901,
        0.2561880648136139,
        0.02660275809466839
      ],
      "plane_d": 1823.3367919921875,
      "bbox_min": [
        810.385986328125,
        -4147.142578125,
        831.4278564453125
      ],
      "bbox_max": [
        812.9754028320312,
        -4137.3095703125,
        848.35400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9616368412971497,
        0.2738252878189087,
        0.01656172424554825
      ],
      "plane_d": 1901.0960693359375,
      "bbox_min": [
        779.6024169921875,
        -4256.21533203125,
        848.1504516601562
      ],
      "bbox_max": [
        786.47900390625,
        -4251.77490234375,
        1220.9613037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.988831639289856,
        0.1297459900379181,
        0.07333618402481079
      ],
      "plane_d": -247.9786376953125,
      "bbox_min": [
        642.281005859375,
        -4443.63818359375,
        1520.6715087890625
      ],
      "bbox_max": [
        765.4669189453125,
        -4028.1416015625,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.993552029132843,
        0.10424546152353287,
        0.044577501714229584
      ],
      "plane_d": -309.21697998046875,
      "bbox_min": [
        642.281005859375,
        -4309.533203125,
        1530.9232177734375
      ],
      "bbox_max": [
        694.700927734375,
        -4028.1416015625,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7833710312843323,
        0.6178421974182129,
        0.06782949715852737
      ],
      "plane_d": 1863.1636962890625,
      "bbox_min": [
        642.281005859375,
        -4033.44873046875,
        1551.4266357421875
      ],
      "bbox_max": [
        664.2568359375,
        -4028.1416015625,
        1832.32373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3351188898086548,
        0.9419505000114441,
        0.02060665562748909
      ],
      "plane_d": 3891.733154296875,
      "bbox_min": [
        757.1337280273438,
        -4443.63818359375,
        1520.6715087890625
      ],
      "bbox_max": [
        765.4669189453125,
        -4435.98388671875,
        1817.5452880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9224879145622253,
        0.3844912052154541,
        0.034389905631542206
      ],
      "plane_d": 788.9979858398438,
      "bbox_min": [
        568.4853515625,
        -4598.2626953125,
        658.838134765625
      ],
      "bbox_max": [
        1702.236572265625,
        -2525.15283203125,
        1764.44482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2819767892360687,
        0.9591768980026245,
        0.02165084145963192
      ],
      "plane_d": 4007.063232421875,
      "bbox_min": [
        810.7130737304688,
        -4598.2626953125,
        826.0635986328125
      ],
      "bbox_max": [
        1002.39794921875,
        -4099.87548828125,
        1764.44482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9132217168807983,
        0.39547187089920044,
        0.09812255203723907
      ],
      "plane_d": 748.1595458984375,
      "bbox_min": [
        950.15869140625,
        -4598.2626953125,
        1553.4356689453125
      ],
      "bbox_max": [
        1002.39794921875,
        -4492.5625,
        1667.355712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2747311294078827,
        0.9593874216079712,
        0.06401930004358292
      ],
      "plane_d": 3949.091064453125,
      "bbox_min": [
        950.15869140625,
        -4499.61279296875,
        1553.4356689453125
      ],
      "bbox_max": [
        960.24755859375,
        -4492.5625,
        1667.355712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9616368412971497,
        0.2738252878189087,
        0.01656172424554825
      ],
      "plane_d": 1901.0960693359375,
      "bbox_min": [
        810.7130737304688,
        -4301.4326171875,
        826.0635986328125
      ],
      "bbox_max": [
        885.4208984375,
        -4099.87548828125,
        1265.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6043979525566101,
        0.36455777287483215,
        0.7083789706230164
      ],
      "plane_d": 1161.4814453125,
      "bbox_min": [
        810.7130737304688,
        -4301.4326171875,
        1186.416015625
      ],
      "bbox_max": [
        885.4208984375,
        -4129.29150390625,
        1265.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.434790700674057,
        -0.0790519118309021,
        0.8970550894737244
      ],
      "plane_d": -1089.6480712890625,
      "bbox_min": [
        835.8153686523438,
        -4301.4326171875,
        1247.5322265625
      ],
      "bbox_max": [
        885.4208984375,
        -4213.328125,
        1265.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44666528701782227,
        -0.14888805150985718,
        0.8822259306907654
      ],
      "plane_d": -1359.3262939453125,
      "bbox_min": [
        859.7396240234375,
        -4301.4326171875,
        1254.7398681640625
      ],
      "bbox_max": [
        885.4208984375,
        -4274.20458984375,
        1265.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9662607908248901,
        0.2561880648136139,
        0.02660275809466839
      ],
      "plane_d": 1823.3367919921875,
      "bbox_min": [
        812.9542846679688,
        -4138.9873046875,
        826.0635986328125
      ],
      "bbox_max": [
        822.922607421875,
        -4099.87548828125,
        907.962646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49489134550094604,
        0.8684111833572388,
        0.03073418140411377
      ],
      "plane_d": 2349.123291015625,
      "bbox_min": [
        568.4853515625,
        -4598.2626953125,
        658.838134765625
      ],
      "bbox_max": [
        1702.236572265625,
        -2525.15283203125,
        1764.350830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48610720038414,
        0.8734968304634094,
        0.026513127610087395
      ],
      "plane_d": 2384.339599609375,
      "bbox_min": [
        618.569580078125,
        -4598.2626953125,
        658.838134765625
      ],
      "bbox_max": [
        1702.236572265625,
        -3313.746337890625,
        1764.350830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2924555540084839,
        0.9559801816940308,
        0.023905904963612556
      ],
      "plane_d": 2949.833984375,
      "bbox_min": [
        618.569580078125,
        -4598.2626953125,
        658.838134765625
      ],
      "bbox_max": [
        1702.236572265625,
        -3313.746337890625,
        1764.350830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6872478723526001,
        0.7258203625679016,
        0.029583144932985306
      ],
      "plane_d": 1514.38623046875,
      "bbox_min": [
        618.569580078125,
        -4598.2626953125,
        658.838134765625
      ],
      "bbox_max": [
        1702.236572265625,
        -3313.746337890625,
        1764.350830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3783358633518219,
        0.9254153370857239,
        0.02163885533809662
      ],
      "plane_d": 3686.921875,
      "bbox_min": [
        618.569580078125,
        -4598.2626953125,
        699.2479858398438
      ],
      "bbox_max": [
        1699.3291015625,
        -3318.746826171875,
        1764.350830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.779249370098114,
        0.6240484714508057,
        0.05773917958140373
      ],
      "plane_d": 957.9458618164062,
      "bbox_min": [
        798.8544921875,
        -4598.2626953125,
        743.0841064453125
      ],
      "bbox_max": [
        1699.3291015625,
        -3498.41943359375,
        1764.350830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853616952896118,
        -0.16747599840164185,
        0.03184564411640167
      ],
      "plane_d": 146.53125,
      "bbox_min": [
        798.8544921875,
        -4598.2626953125,
        784.8514404296875
      ],
      "bbox_max": [
        1676.256591796875,
        -3498.41943359375,
        1764.350830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1269.789306640625,
      "bbox_min": [
        798.8544921875,
        -4598.2626953125,
        784.8514404296875
      ],
      "bbox_max": [
        1676.256591796875,
        -3498.41943359375,
        1764.350830078125
      ],
      "face_count": 19
    },
    {
      "plane_normal": [
        -0.9855049252510071,
        -0.16633455455303192,
        0.033359821885824203
      ],
      "plane_d": 149.46546936035156,
      "bbox_min": [
        798.8544921875,
        -4173.95458984375,
        784.8514404296875
      ],
      "bbox_max": [
        1676.256591796875,
        -3498.41943359375,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4357794523239136,
        0.8783008456230164,
        0.19668203592300415
      ],
      "plane_d": 3390.929931640625,
      "bbox_min": [
        798.8544921875,
        -4173.95458984375,
        784.8514404296875
      ],
      "bbox_max": [
        1676.256591796875,
        -3498.41943359375,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2072485238313675,
        0.7593603134155273,
        0.6167818903923035
      ],
      "plane_d": 2200.4560546875,
      "bbox_min": [
        798.8544921875,
        -4173.95458984375,
        784.8514404296875
      ],
      "bbox_max": [
        1676.256591796875,
        -3498.41943359375,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3373933732509613,
        0.6430913209915161,
        0.6874586343765259
      ],
      "plane_d": 1001.8839111328125,
      "bbox_min": [
        798.8544921875,
        -4173.95458984375,
        784.8514404296875
      ],
      "bbox_max": [
        1676.256591796875,
        -3498.41943359375,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05422192066907883,
        0.022580765187740326,
        0.9982735514640808
      ],
      "plane_d": -1118.32470703125,
      "bbox_min": [
        798.8544921875,
        -4173.95458984375,
        784.8514404296875
      ],
      "bbox_max": [
        1676.256591796875,
        -3498.41943359375,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9874967336654663,
        -0.152632474899292,
        0.03941529616713524
      ],
      "plane_d": 195.71043395996094,
      "bbox_min": [
        798.8544921875,
        -4138.837890625,
        784.8514404296875
      ],
      "bbox_max": [
        1676.256591796875,
        -3498.41943359375,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43120837211608887,
        -0.0444025956094265,
        0.9011589884757996
      ],
      "plane_d": -901.566650390625,
      "bbox_min": [
        798.8544921875,
        -4100.1611328125,
        784.8514404296875
      ],
      "bbox_max": [
        1676.256591796875,
        -3498.41943359375,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19453094899654388,
        0.7714401483535767,
        0.6058363914489746
      ],
      "plane_d": 1751.4652099609375,
      "bbox_min": [
        798.8544921875,
        -4063.91845703125,
        784.8514404296875
      ],
      "bbox_max": [
        1676.256591796875,
        -3498.41943359375,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2915181517601013,
        0.6615181565284729,
        0.6909491419792175
      ],
      "plane_d": 1127.093994140625,
      "bbox_min": [
        798.8544921875,
        -4063.91845703125,
        784.8514404296875
      ],
      "bbox_max": [
        1676.256591796875,
        -3541.93896484375,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36287030577659607,
        -0.10208143293857574,
        0.9262313842773438
      ],
      "plane_d": -1222.2777099609375,
      "bbox_min": [
        798.8544921875,
        -4063.91845703125,
        784.8514404296875
      ],
      "bbox_max": [
        1676.256591796875,
        -3622.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5140525698661804,
        0.5640233159065247,
        0.6462411284446716
      ],
      "plane_d": 473.2470703125,
      "bbox_min": [
        798.8544921875,
        -4000.0,
        784.8514404296875
      ],
      "bbox_max": [
        1676.256591796875,
        -3622.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1020.0,
      "bbox_min": [
        1000.4169311523438,
        -3647.5,
        1152.5
      ],
      "bbox_max": [
        1020.0,
        -3622.5,
        1258.16650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3622.5,
      "bbox_min": [
        1000.4169311523438,
        -3622.5,
        1152.5
      ],
      "bbox_max": [
        1020.0,
        -3622.5,
        1195.88916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3982.5,
      "bbox_min": [
        819.3652954101562,
        -4000.0,
        1130.0
      ],
      "bbox_max": [
        1653.150390625,
        -3647.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -4000.0,
        1130.0
      ],
      "bbox_max": [
        867.5,
        -3982.5,
        1158.5390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -3982.5,
        1130.0
      ],
      "bbox_max": [
        867.5,
        -3975.0,
        1162.65966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.021193169057369232,
        0.24223682284355164,
        0.9699856638908386
      ],
      "plane_d": -252.5858154296875,
      "bbox_min": [
        819.3652954101562,
        -3778.016845703125,
        1169.8922119140625
      ],
      "bbox_max": [
        834.4505615234375,
        -3713.948486328125,
        1185.662841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15874899923801422,
        0.26544034481048584,
        0.9509680271148682
      ],
      "plane_d": -257.1575927734375,
      "bbox_min": [
        819.3652954101562,
        -3778.016845703125,
        1170.238525390625
      ],
      "bbox_max": [
        834.4505615234375,
        -3715.138916015625,
        1185.662841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3735.0,
      "bbox_min": [
        855.0,
        -3857.5,
        1190.0
      ],
      "bbox_max": [
        892.5,
        -3735.0,
        1243.483642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -872.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        872.5,
        -3781.5,
        1231.6224365234375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3781.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        872.5,
        -3781.5,
        1231.6224365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3784.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        872.5,
        -3781.5,
        1231.4744873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        869.5,
        -3784.5,
        1194.0
      ],
      "bbox_max": [
        869.5,
        -3781.5,
        1230.186767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3805.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        872.5,
        -3805.5,
        1230.4398193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3808.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        872.5,
        -3805.5,
        1230.2918701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        869.5,
        -3808.5,
        1194.0
      ],
      "bbox_max": [
        869.5,
        -3805.5,
        1229.0042724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3831.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        872.5,
        -3831.5,
        1229.15869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3834.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        872.5,
        -3831.5,
        1229.0108642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        869.5,
        -3834.5,
        1194.0
      ],
      "bbox_max": [
        869.5,
        -3831.5,
        1227.72314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3854.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        872.5,
        -3854.5,
        1228.025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        872.5,
        -3854.5,
        1227.8775634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3857.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        872.5,
        -3857.5,
        1227.8775634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4963834583759308,
        0.3309214413166046,
        0.8025550246238708
      ],
      "plane_d": -569.6696166992188,
      "bbox_min": [
        892.5,
        -3864.5,
        1190.0
      ],
      "bbox_max": [
        1653.150390625,
        -3647.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -917.5,
      "bbox_min": [
        892.5,
        -3864.5,
        1190.0
      ],
      "bbox_max": [
        1012.5,
        -3647.5,
        1260.977294921875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3781.5,
      "bbox_min": [
        892.5,
        -3857.5,
        1190.0
      ],
      "bbox_max": [
        917.5,
        -3725.0,
        1253.155029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3784.5,
      "bbox_min": [
        914.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1253.0072021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.5,
      "bbox_min": [
        914.5,
        -3784.5,
        1194.0
      ],
      "bbox_max": [
        914.5,
        -3781.5,
        1251.719482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3805.5,
      "bbox_min": [
        914.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        917.5,
        -3805.5,
        1251.972412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3808.5,
      "bbox_min": [
        914.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        917.5,
        -3805.5,
        1251.8245849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.5,
      "bbox_min": [
        914.5,
        -3808.5,
        1194.0
      ],
      "bbox_max": [
        914.5,
        -3805.5,
        1250.536865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3831.5,
      "bbox_min": [
        914.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        917.5,
        -3831.5,
        1250.69140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3834.5,
      "bbox_min": [
        914.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        917.5,
        -3831.5,
        1250.5435791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.5,
      "bbox_min": [
        914.5,
        -3834.5,
        1194.0
      ],
      "bbox_max": [
        914.5,
        -3831.5,
        1249.2559814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3854.5,
      "bbox_min": [
        914.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        917.5,
        -3854.5,
        1249.55810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3857.5,
      "bbox_min": [
        914.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        917.5,
        -3854.5,
        1249.4102783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.5,
      "bbox_min": [
        914.5,
        -3857.5,
        1194.0
      ],
      "bbox_max": [
        914.5,
        -3854.5,
        1248.12255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3735.0,
      "bbox_min": [
        892.5,
        -3735.0,
        1190.0
      ],
      "bbox_max": [
        900.0,
        -3735.0,
        1247.0723876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3770.5,
      "bbox_min": [
        924.0,
        -3864.5,
        1238.0
      ],
      "bbox_max": [
        989.5,
        -3770.5,
        1260.977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3864.5,
      "bbox_min": [
        924.0,
        -3864.5,
        1238.0
      ],
      "bbox_max": [
        989.5,
        -3770.5,
        1260.977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7371541857719421,
        0.6757246851921082,
        0.0
      ],
      "plane_d": 1834.623291015625,
      "bbox_min": [
        924.0,
        -3864.5,
        1238.0
      ],
      "bbox_max": [
        989.5,
        -3770.5,
        1260.7532958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        924.0,
        -3864.5,
        1238.0
      ],
      "bbox_max": [
        986.7500610351562,
        -3770.5,
        1260.7532958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -978.5,
      "bbox_min": [
        924.0,
        -3864.5,
        1238.0
      ],
      "bbox_max": [
        986.7500610351562,
        -3782.5,
        1260.7532958984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        -0.0
      ],
      "plane_d": -1756.4737548828125,
      "bbox_min": [
        924.0,
        -3864.5,
        1238.0
      ],
      "bbox_max": [
        934.0,
        -3852.5,
        1256.960693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1012.5,
      "bbox_min": [
        1012.5,
        -3649.51123046875,
        1257.5
      ],
      "bbox_max": [
        1012.5,
        -3647.5,
        1257.8046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19393526017665863,
        0.1695787012577057,
        0.966246485710144
      ],
      "plane_d": -344.73529052734375,
      "bbox_min": [
        892.742431640625,
        -4063.91845703125,
        1231.6805419921875
      ],
      "bbox_max": [
        998.5626831054688,
        -3966.9541015625,
        1265.828857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3982.5,
      "bbox_min": [
        895.8646850585938,
        -3982.5,
        1231.6805419921875
      ],
      "bbox_max": [
        915.989013671875,
        -3982.5,
        1239.564697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3982.5,
      "bbox_min": [
        905.3214111328125,
        -3982.5,
        1237.423583984375
      ],
      "bbox_max": [
        976.8275756835938,
        -3982.5,
        1263.3992919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19393526017665863,
        0.1695787012577057,
        0.966246485710144
      ],
      "plane_d": -344.73529052734375,
      "bbox_min": [
        838.8035278320312,
        -4100.1611328125,
        1217.6522216796875
      ],
      "bbox_max": [
        971.2003784179688,
        -3707.922119140625,
        1264.935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3982.5,
      "bbox_min": [
        896.4446411132812,
        -3982.5,
        1233.176025390625
      ],
      "bbox_max": [
        905.3214111328125,
        -3982.5,
        1237.423583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3725.0,
      "bbox_min": [
        867.72119140625,
        -3811.810302734375,
        1232.11962890625
      ],
      "bbox_max": [
        924.0,
        -3725.0,
        1256.608642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3735.0,
      "bbox_min": [
        874.2041625976562,
        -3811.810302734375,
        1234.72900390625
      ],
      "bbox_max": [
        924.0,
        -3735.0,
        1256.608642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 924.0,
      "bbox_min": [
        914.5,
        -3811.810302734375,
        1251.57177734375
      ],
      "bbox_max": [
        924.0,
        -3781.5,
        1256.608642578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3784.5,
      "bbox_min": [
        914.5,
        -3784.5,
        1251.57177734375
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1255.6982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3781.5,
      "bbox_min": [
        914.5,
        -3784.5,
        1251.719482421875
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1255.6982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -917.5,
      "bbox_min": [
        917.5,
        -3784.5,
        1253.0072021484375
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1255.6982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3982.5,
      "bbox_min": [
        838.8035278320312,
        -3982.5,
        1217.6522216796875
      ],
      "bbox_max": [
        957.4013671875,
        -3717.5,
        1262.3441162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 924.0,
      "bbox_min": [
        838.8035278320312,
        -3864.5,
        1217.6522216796875
      ],
      "bbox_max": [
        937.4022216796875,
        -3717.5,
        1258.5887451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        -0.0
      ],
      "plane_d": -1756.4737548828125,
      "bbox_min": [
        924.0,
        -3864.5,
        1252.766845703125
      ],
      "bbox_max": [
        937.4022216796875,
        -3852.5,
        1258.5887451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3864.5,
      "bbox_min": [
        934.0,
        -3864.5,
        1256.960693359375
      ],
      "bbox_max": [
        937.4022216796875,
        -3864.5,
        1258.5887451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3742.5,
      "bbox_min": [
        838.8035278320312,
        -3742.5,
        1217.6522216796875
      ],
      "bbox_max": [
        855.0,
        -3717.5,
        1251.3533935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3717.5,
      "bbox_min": [
        838.8035278320312,
        -3717.5,
        1218.65185546875
      ],
      "bbox_max": [
        855.0,
        -3717.5,
        1250.787841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3735.0,
      "bbox_min": [
        855.0,
        -3857.5,
        1225.5396728515625
      ],
      "bbox_max": [
        917.5,
        -3725.0,
        1257.349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3725.0,
      "bbox_min": [
        855.0,
        -3725.0,
        1226.032470703125
      ],
      "bbox_max": [
        881.566650390625,
        -3725.0,
        1252.4005126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -872.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1226.4420166015625
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1257.349365234375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1226.4420166015625
      ],
      "bbox_max": [
        872.5,
        -3781.5,
        1254.3170166015625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3808.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1226.4420166015625
      ],
      "bbox_max": [
        872.5,
        -3781.5,
        1254.3170166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3805.5,
      "bbox_min": [
        869.5,
        -3805.5,
        1229.0042724609375
      ],
      "bbox_max": [
        872.5,
        -3781.5,
        1253.72900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3784.5,
      "bbox_min": [
        869.5,
        -3784.5,
        1230.0389404296875
      ],
      "bbox_max": [
        872.5,
        -3781.5,
        1253.25390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3781.5,
      "bbox_min": [
        869.5,
        -3781.5,
        1230.186767578125
      ],
      "bbox_max": [
        872.5,
        -3781.5,
        1253.18603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3831.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1226.4420166015625
      ],
      "bbox_max": [
        872.5,
        -3831.5,
        1254.3170166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3854.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1226.4420166015625
      ],
      "bbox_max": [
        872.5,
        -3854.5,
        1241.7569580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3857.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1226.4420166015625
      ],
      "bbox_max": [
        872.5,
        -3857.5,
        1240.1087646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.5,
      "bbox_min": [
        914.5,
        -3857.5,
        1247.9747314453125
      ],
      "bbox_max": [
        917.5,
        -3805.5,
        1257.349365234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3857.5,
      "bbox_min": [
        914.5,
        -3857.5,
        1247.9747314453125
      ],
      "bbox_max": [
        917.5,
        -3805.5,
        1257.349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3854.5,
      "bbox_min": [
        914.5,
        -3857.5,
        1248.12255859375
      ],
      "bbox_max": [
        917.5,
        -3805.5,
        1257.349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -917.5,
      "bbox_min": [
        917.5,
        -3857.5,
        1249.4102783203125
      ],
      "bbox_max": [
        917.5,
        -3854.5,
        1257.349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3834.5,
      "bbox_min": [
        914.5,
        -3834.5,
        1249.108154296875
      ],
      "bbox_max": [
        917.5,
        -3805.5,
        1256.8292236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3831.5,
      "bbox_min": [
        914.5,
        -3834.5,
        1249.2559814453125
      ],
      "bbox_max": [
        917.5,
        -3805.5,
        1256.8292236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -917.5,
      "bbox_min": [
        917.5,
        -3834.5,
        1250.5435791015625
      ],
      "bbox_max": [
        917.5,
        -3831.5,
        1256.8292236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3808.5,
      "bbox_min": [
        914.5,
        -3808.5,
        1250.38916015625
      ],
      "bbox_max": [
        917.5,
        -3805.5,
        1256.240966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3805.5,
      "bbox_min": [
        914.5,
        -3808.5,
        1250.536865234375
      ],
      "bbox_max": [
        917.5,
        -3805.5,
        1256.240966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -917.5,
      "bbox_min": [
        917.5,
        -3808.5,
        1251.8245849609375
      ],
      "bbox_max": [
        917.5,
        -3805.5,
        1256.240966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.927715003490448,
        -0.2117890864610672,
        0.30739253759384155
      ],
      "plane_d": -395.4433898925781,
      "bbox_min": [
        823.5496826171875,
        -4138.837890625,
        1145.9613037109375
      ],
      "bbox_max": [
        933.3511962890625,
        -3719.15283203125,
        1263.6993408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19468311965465546,
        0.2906641364097595,
        0.9368098378181458
      ],
      "plane_d": -175.06005859375,
      "bbox_min": [
        823.5496826171875,
        -4104.01220703125,
        1145.9613037109375
      ],
      "bbox_max": [
        933.3511962890625,
        -3719.15283203125,
        1263.6993408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1548786461353302,
        0.2819673717021942,
        0.9468405246734619
      ],
      "plane_d": -186.59478759765625,
      "bbox_min": [
        828.1298828125,
        -4104.01220703125,
        1145.9613037109375
      ],
      "bbox_max": [
        933.3511962890625,
        -3769.71923828125,
        1263.6993408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19393526017665863,
        0.1695787012577057,
        0.966246485710144
      ],
      "plane_d": -344.73529052734375,
      "bbox_min": [
        862.638671875,
        -4104.01220703125,
        1145.9613037109375
      ],
      "bbox_max": [
        933.3511962890625,
        -3957.92822265625,
        1263.6993408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -892.5,
      "bbox_min": [
        867.5,
        -4000.0,
        1150.0892333984375
      ],
      "bbox_max": [
        897.4816284179688,
        -3975.0,
        1235.85009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -3997.879638671875,
        1150.0892333984375
      ],
      "bbox_max": [
        867.5,
        -3980.05419921875,
        1160.747802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3982.5,
      "bbox_min": [
        892.5,
        -3982.5,
        1223.00439453125
      ],
      "bbox_max": [
        897.4816284179688,
        -3982.5,
        1235.85009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        867.5,
        -3980.05419921875,
        1159.8828125
      ],
      "bbox_max": [
        877.2393798828125,
        -3975.0,
        1187.773681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -3980.05419921875,
        1159.8828125
      ],
      "bbox_max": [
        867.5,
        -3975.0,
        1165.85302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        867.5,
        -3982.40966796875,
        1159.8828125
      ],
      "bbox_max": [
        892.201904296875,
        -3975.0,
        1233.47412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -3982.40966796875,
        1159.8828125
      ],
      "bbox_max": [
        867.5,
        -3977.258544921875,
        1164.296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        889.7421875,
        -3975.0,
        1232.9803466796875
      ],
      "bbox_max": [
        892.5,
        -3975.0,
        1235.1414794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3982.5,
      "bbox_min": [
        892.5,
        -3982.5,
        1234.8502197265625
      ],
      "bbox_max": [
        897.5386962890625,
        -3982.5,
        1236.98583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        823.5496826171875,
        -3742.5,
        1177.39990234375
      ],
      "bbox_max": [
        830.0,
        -3719.15283203125,
        1225.9552001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15874899923801422,
        0.26544034481048584,
        0.9509680271148682
      ],
      "plane_d": -257.1575927734375,
      "bbox_min": [
        823.5496826171875,
        -3742.5,
        1177.39990234375
      ],
      "bbox_max": [
        823.732421875,
        -3741.89453125,
        1177.55224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        869.5,
        -3981.591064453125,
        1232.373046875
      ],
      "bbox_max": [
        892.5,
        -3831.5,
        1254.9051513671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -872.5,
      "bbox_min": [
        872.5,
        -3857.5,
        1240.1087646484375
      ],
      "bbox_max": [
        872.5,
        -3854.5,
        1254.9051513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3834.5,
      "bbox_min": [
        869.5,
        -3834.5,
        1245.0093994140625
      ],
      "bbox_max": [
        872.5,
        -3831.5,
        1254.3848876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -892.5,
      "bbox_min": [
        890.458251953125,
        -3981.591064453125,
        1234.7171630859375
      ],
      "bbox_max": [
        892.5,
        -3975.0,
        1241.303466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19393526017665863,
        0.1695787012577057,
        0.966246485710144
      ],
      "plane_d": -344.73529052734375,
      "bbox_min": [
        867.5,
        -4138.837890625,
        1148.92431640625
      ],
      "bbox_max": [
        929.3295288085938,
        -3981.55078125,
        1263.5679931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -892.5,
      "bbox_min": [
        892.5,
        -4000.0,
        1224.0787353515625
      ],
      "bbox_max": [
        892.5,
        -3983.987548828125,
        1237.921630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -892.5,
      "bbox_min": [
        892.5,
        -4000.0,
        1235.1112060546875
      ],
      "bbox_max": [
        892.5,
        -3982.5,
        1243.5650634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -892.5,
      "bbox_min": [
        892.5,
        -3982.5,
        1236.1361083984375
      ],
      "bbox_max": [
        892.5,
        -3981.55078125,
        1237.138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -892.5,
      "bbox_min": [
        892.5,
        -4000.0,
        1236.7901611328125
      ],
      "bbox_max": [
        899.7266845703125,
        -3975.0,
        1259.21484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        830.0,
        -3742.5,
        1212.8668212890625
      ],
      "bbox_max": [
        830.0,
        -3723.50341796875,
        1249.9954833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1252.8448486328125
      ],
      "bbox_max": [
        870.14013671875,
        -3854.833740234375,
        1254.7769775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36287030577659607,
        -0.10208143293857574,
        0.9262313842773438
      ],
      "plane_d": -1222.2777099609375,
      "bbox_min": [
        830.0,
        -4173.95458984375,
        1249.6859130859375
      ],
      "bbox_max": [
        1012.5,
        -3647.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1002.5,
      "bbox_min": [
        881.566650390625,
        -3864.5,
        1252.4005126953125
      ],
      "bbox_max": [
        1005.585205078125,
        -3647.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 924.0,
      "bbox_min": [
        914.5,
        -3864.5,
        1255.46728515625
      ],
      "bbox_max": [
        989.5,
        -3770.5,
        1269.789306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3864.5,
      "bbox_min": [
        951.9163818359375,
        -3864.5,
        1258.9661865234375
      ],
      "bbox_max": [
        986.7500610351562,
        -3782.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -978.5,
      "bbox_min": [
        978.5,
        -3852.5,
        1258.9661865234375
      ],
      "bbox_max": [
        986.7500610351562,
        -3782.5,
        1269.789306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3791.5,
      "bbox_min": [
        978.5,
        -3845.0,
        1259.1697998046875
      ],
      "bbox_max": [
        986.7500610351562,
        -3791.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.0,
      "bbox_min": [
        978.5,
        -3845.0,
        1260.3798828125
      ],
      "bbox_max": [
        985.3749389648438,
        -3845.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.0,
      "bbox_min": [
        985.3749389648438,
        -3845.0,
        1260.7532958984375
      ],
      "bbox_max": [
        989.5,
        -3845.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3791.5,
      "bbox_min": [
        986.7500610351562,
        -3791.5,
        1259.617919921875
      ],
      "bbox_max": [
        989.5,
        -3791.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -917.5,
      "bbox_min": [
        914.5,
        -3784.5,
        1255.46728515625
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1262.30908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3781.5,
      "bbox_min": [
        914.5,
        -3784.5,
        1255.46728515625
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1262.30908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.5,
      "bbox_min": [
        914.5,
        -3784.5,
        1255.46728515625
      ],
      "bbox_max": [
        914.5,
        -3781.5,
        1261.1337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3725.0,
      "bbox_min": [
        881.566650390625,
        -3735.0,
        1252.4005126953125
      ],
      "bbox_max": [
        900.0,
        -3725.0,
        1261.6800537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3735.0,
      "bbox_min": [
        886.6094360351562,
        -3735.0,
        1252.900634765625
      ],
      "bbox_max": [
        900.0,
        -3735.0,
        1260.577880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3647.5,
      "bbox_min": [
        997.1614379882812,
        -3647.5,
        1256.926025390625
      ],
      "bbox_max": [
        1002.5,
        -3647.5,
        1257.52392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43120837211608887,
        -0.0444025956094265,
        0.9011589884757996
      ],
      "plane_d": -901.566650390625,
      "bbox_min": [
        875.4683837890625,
        -3982.5,
        1252.0693359375
      ],
      "bbox_max": [
        1002.0364990234375,
        -3725.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3864.5,
      "bbox_min": [
        937.4022216796875,
        -3982.5,
        1258.5887451171875
      ],
      "bbox_max": [
        1002.0364990234375,
        -3864.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3982.5,
      "bbox_min": [
        976.8275146484375,
        -3982.5,
        1263.3992919921875
      ],
      "bbox_max": [
        1002.0364990234375,
        -3982.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3725.0,
      "bbox_min": [
        875.4683837890625,
        -3725.0,
        1252.0693359375
      ],
      "bbox_max": [
        883.4843139648438,
        -3725.0,
        1255.209716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3808.5,
      "bbox_min": [
        914.5,
        -3831.5,
        1256.01025390625
      ],
      "bbox_max": [
        917.5,
        -3805.5,
        1259.3333740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.5,
      "bbox_min": [
        914.5,
        -3808.5,
        1256.01025390625
      ],
      "bbox_max": [
        914.5,
        -3805.5,
        1258.48876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.5,
      "bbox_min": [
        914.5,
        -3784.5,
        1259.6644287109375
      ],
      "bbox_max": [
        915.5610961914062,
        -3782.53173828125,
        1261.2188720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3725.0,
      "bbox_min": [
        883.4843139648438,
        -3864.5,
        1255.209716796875
      ],
      "bbox_max": [
        959.9423828125,
        -3725.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 924.0,
      "bbox_min": [
        888.875244140625,
        -3864.5,
        1256.219482421875
      ],
      "bbox_max": [
        959.9423828125,
        -3735.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        924.0,
        -3864.5,
        1264.7454833984375
      ],
      "bbox_max": [
        959.9423828125,
        -3770.94970703125,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3781.5,
      "bbox_min": [
        914.5,
        -3784.5,
        1261.0201416015625
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1266.1251220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -917.5,
      "bbox_min": [
        914.5,
        -3784.5,
        1261.0201416015625
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1266.1251220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3784.5,
      "bbox_min": [
        914.5,
        -3784.5,
        1261.0201416015625
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1264.05908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3982.5,
      "bbox_min": [
        830.0,
        -4000.0,
        1249.6859130859375
      ],
      "bbox_max": [
        993.137939453125,
        -3717.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -892.5,
      "bbox_min": [
        867.5,
        -4000.0,
        1257.4610595703125
      ],
      "bbox_max": [
        892.5,
        -3982.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -3988.988037109375,
        1257.4610595703125
      ],
      "bbox_max": [
        867.5,
        -3982.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 924.0,
      "bbox_min": [
        830.0,
        -3982.5,
        1249.6859130859375
      ],
      "bbox_max": [
        959.0245361328125,
        -3717.5,
        1269.789306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3735.0,
      "bbox_min": [
        830.0,
        -3982.5,
        1249.6859130859375
      ],
      "bbox_max": [
        917.5,
        -3717.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        830.0,
        -3735.0,
        1249.6859130859375
      ],
      "bbox_max": [
        830.0,
        -3728.8173828125,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -855.0,
      "bbox_min": [
        853.26513671875,
        -3725.0,
        1250.693603515625
      ],
      "bbox_max": [
        855.0,
        -3717.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -855.0,
      "bbox_min": [
        855.0,
        -3742.5,
        1251.1837158203125
      ],
      "bbox_max": [
        855.0,
        -3735.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        867.5,
        -3982.5,
        1253.023193359375
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -3982.5,
        1257.2913818359375
      ],
      "bbox_max": [
        892.5,
        -3975.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -892.5,
      "bbox_min": [
        892.5,
        -3982.5,
        1258.6494140625
      ],
      "bbox_max": [
        892.5,
        -3975.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -872.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1253.023193359375
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1269.789306640625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1253.023193359375
      ],
      "bbox_max": [
        872.5,
        -3781.5,
        1269.789306640625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3781.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1253.023193359375
      ],
      "bbox_max": [
        872.5,
        -3781.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3784.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1253.091064453125
      ],
      "bbox_max": [
        872.5,
        -3784.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3805.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1253.5660400390625
      ],
      "bbox_max": [
        872.5,
        -3805.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3808.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1253.6337890625
      ],
      "bbox_max": [
        872.5,
        -3808.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3831.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1254.1541748046875
      ],
      "bbox_max": [
        872.5,
        -3831.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3834.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1254.2220458984375
      ],
      "bbox_max": [
        872.5,
        -3834.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3854.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1254.67431640625
      ],
      "bbox_max": [
        872.5,
        -3854.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3857.5,
      "bbox_min": [
        869.5,
        -3857.5,
        1254.7421875
      ],
      "bbox_max": [
        872.5,
        -3857.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3831.5,
      "bbox_min": [
        914.5,
        -3857.5,
        1256.5982666015625
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.5,
      "bbox_min": [
        914.5,
        -3857.5,
        1256.5982666015625
      ],
      "bbox_max": [
        917.5,
        -3831.5,
        1269.789306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3834.5,
      "bbox_min": [
        914.5,
        -3857.5,
        1256.6661376953125
      ],
      "bbox_max": [
        917.5,
        -3831.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -917.5,
      "bbox_min": [
        917.5,
        -3834.5,
        1256.7677001953125
      ],
      "bbox_max": [
        917.5,
        -3831.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -917.5,
      "bbox_min": [
        917.5,
        -3857.5,
        1257.281494140625
      ],
      "bbox_max": [
        917.5,
        -3854.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.5,
      "bbox_min": [
        914.5,
        -3808.5,
        1258.1580810546875
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1269.789306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3805.5,
      "bbox_min": [
        914.5,
        -3808.5,
        1258.48876953125
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -917.5,
      "bbox_min": [
        917.5,
        -3808.5,
        1259.3333740234375
      ],
      "bbox_max": [
        917.5,
        -3805.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3784.5,
      "bbox_min": [
        914.5,
        -3784.5,
        1260.80322265625
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -917.5,
      "bbox_min": [
        917.5,
        -3784.5,
        1264.05908203125
      ],
      "bbox_max": [
        917.5,
        -3781.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3647.5,
      "bbox_min": [
        997.4312744140625,
        -3647.5,
        1257.466064453125
      ],
      "bbox_max": [
        1000.7955932617188,
        -3647.5,
        1258.2454833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3647.5,
      "bbox_min": [
        1002.5,
        -3647.5,
        1257.383544921875
      ],
      "bbox_max": [
        1012.5,
        -3647.5,
        1263.2503662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3647.5,
      "bbox_min": [
        997.7568969726562,
        -3647.5,
        1257.4366455078125
      ],
      "bbox_max": [
        1002.5,
        -3647.5,
        1259.89013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1020.0,
      "bbox_min": [
        1020.0,
        -3647.5,
        1258.0242919921875
      ],
      "bbox_max": [
        1020.0,
        -3641.208251953125,
        1265.7705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5140525698661804,
        0.5640233159065247,
        0.6462411284446716
      ],
      "plane_d": 473.2470703125,
      "bbox_min": [
        1590.0380859375,
        -3752.958984375,
        1180.9613037109375
      ],
      "bbox_max": [
        1624.234375,
        -3672.49853515625,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4963834583759308,
        0.3309214413166046,
        0.8025550246238708
      ],
      "plane_d": -569.6696166992188,
      "bbox_min": [
        1590.0380859375,
        -3752.958984375,
        1261.404541015625
      ],
      "bbox_max": [
        1608.263916015625,
        -3743.1083984375,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3647.5,
      "bbox_min": [
        997.7839965820312,
        -3655.540771484375,
        1249.8753662109375
      ],
      "bbox_max": [
        1020.0,
        -3634.58935546875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1020.0,
      "bbox_min": [
        1020.0,
        -3647.5,
        1249.8753662109375
      ],
      "bbox_max": [
        1020.0,
        -3634.58935546875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1002.5,
      "bbox_min": [
        1002.5,
        -3655.540771484375,
        1259.89013671875
      ],
      "bbox_max": [
        1012.5,
        -3647.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 995.0,
      "bbox_min": [
        813.1619262695312,
        -3733.3193359375,
        1152.5
      ],
      "bbox_max": [
        1000.9984130859375,
        -3613.7265625,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.682898998260498,
        0.6571949124336243,
        0.31897294521331787
      ],
      "plane_d": 1311.3497314453125,
      "bbox_min": [
        995.0,
        -3647.5,
        1253.5289306640625
      ],
      "bbox_max": [
        1000.981201171875,
        -3637.697509765625,
        1258.9525146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2449347823858261,
        0.16798976063728333,
        0.954875111579895
      ],
      "plane_d": -833.1099853515625,
      "bbox_min": [
        995.0,
        -3649.088623046875,
        1258.2454833984375
      ],
      "bbox_max": [
        997.7565307617188,
        -3647.5,
        1259.2320556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.682898998260498,
        0.6571949124336243,
        0.31897294521331787
      ],
      "plane_d": 1311.3497314453125,
      "bbox_min": [
        971.6315307617188,
        -3639.660400390625,
        1242.7796630859375
      ],
      "bbox_max": [
        995.0,
        -3613.7265625,
        1259.4564208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.021193169057369232,
        0.24223682284355164,
        0.9699856638908386
      ],
      "plane_d": -252.5858154296875,
      "bbox_min": [
        813.1619262695312,
        -3715.4716796875,
        1160.7587890625
      ],
      "bbox_max": [
        823.9547119140625,
        -3676.84375,
        1170.4290771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15874899923801422,
        0.26544034481048584,
        0.9509680271148682
      ],
      "plane_d": -257.1575927734375,
      "bbox_min": [
        813.1619262695312,
        -3715.4716796875,
        1161.210205078125
      ],
      "bbox_max": [
        821.7115478515625,
        -3678.334716796875,
        1170.4290771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -855.0,
      "bbox_min": [
        830.0,
        -3720.91552734375,
        1206.5272216796875
      ],
      "bbox_max": [
        855.0,
        -3717.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43120837211608887,
        -0.0444025956094265,
        0.9011589884757996
      ],
      "plane_d": -901.566650390625,
      "bbox_min": [
        830.0,
        -3717.5,
        1207.435302734375
      ],
      "bbox_max": [
        858.0565185546875,
        -3671.887451171875,
        1228.2294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9873557686805725,
        -0.14738401770591736,
        0.05836522951722145
      ],
      "plane_d": 197.87875366210938,
      "bbox_min": [
        818.4602661132812,
        -3719.15283203125,
        1169.6192626953125
      ],
      "bbox_max": [
        830.0,
        -3673.193603515625,
        1216.6224365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43120837211608887,
        -0.0444025956094265,
        0.9011589884757996
      ],
      "plane_d": -901.566650390625,
      "bbox_min": [
        823.4071044921875,
        -3703.49609375,
        1213.338623046875
      ],
      "bbox_max": [
        830.0,
        -3673.193603515625,
        1216.6224365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3647.5,
      "bbox_min": [
        1000.1948852539062,
        -3647.73193359375,
        1265.4273681640625
      ],
      "bbox_max": [
        1002.9671020507812,
        -3647.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -4000.0,
        1202.7003173828125
      ],
      "bbox_max": [
        867.5,
        -3986.544921875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7831375598907471,
        0.5788978934288025,
        0.22709693014621735
      ],
      "plane_d": 3144.185546875,
      "bbox_min": [
        830.0,
        -4598.2626953125,
        1269.789306640625
      ],
      "bbox_max": [
        1566.2449951171875,
        -3622.5,
        1764.350830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.88088059425354,
        0.43405717611312866,
        0.18879587948322296
      ],
      "plane_d": 2722.86279296875,
      "bbox_min": [
        1249.8150634765625,
        -4288.96484375,
        1269.789306640625
      ],
      "bbox_max": [
        1566.2449951171875,
        -3878.915771484375,
        1421.9434814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44197332859039307,
        0.8725138306617737,
        0.2082766443490982
      ],
      "plane_d": 3812.1787109375,
      "bbox_min": [
        1485.552734375,
        -3942.123291015625,
        1269.789306640625
      ],
      "bbox_max": [
        1566.2449951171875,
        -3878.915771484375,
        1421.9434814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1012.5,
      "bbox_min": [
        830.0,
        -4598.2626953125,
        1269.789306640625
      ],
      "bbox_max": [
        1403.209716796875,
        -3622.5,
        1764.350830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1002.5,
      "bbox_min": [
        830.0,
        -4598.2626953125,
        1269.789306640625
      ],
      "bbox_max": [
        1012.5,
        -3622.5,
        1764.350830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6763855814933777,
        0.7353199124336243,
        -0.042511679232120514
      ],
      "plane_d": 4126.3173828125,
      "bbox_min": [
        1002.5,
        -4598.06396484375,
        1269.789306640625
      ],
      "bbox_max": [
        1012.5,
        -3622.5,
        1763.7960205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3622.5,
      "bbox_min": [
        1002.5,
        -3647.5,
        1269.789306640625
      ],
      "bbox_max": [
        1012.5,
        -3622.5,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3647.5,
      "bbox_min": [
        1002.5,
        -3647.5,
        1269.789306640625
      ],
      "bbox_max": [
        1012.5,
        -3647.5,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6763855814933777,
        0.7353199124336243,
        -0.042511679232120514
      ],
      "plane_d": 4126.3173828125,
      "bbox_min": [
        830.0,
        -4598.2626953125,
        1269.789306640625
      ],
      "bbox_max": [
        1002.5,
        -3622.5,
        1764.350830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -892.5,
      "bbox_min": [
        867.5,
        -4000.0,
        1269.789306640625
      ],
      "bbox_max": [
        892.5,
        -3982.5,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -3987.632568359375,
        1269.789306640625
      ],
      "bbox_max": [
        867.5,
        -3982.5,
        1296.781494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3725.0,
      "bbox_min": [
        830.0,
        -3982.5,
        1269.789306640625
      ],
      "bbox_max": [
        1002.5,
        -3622.5,
        1362.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3735.0,
      "bbox_min": [
        830.0,
        -3982.5,
        1269.789306640625
      ],
      "bbox_max": [
        1002.5,
        -3725.0,
        1362.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -855.0,
      "bbox_min": [
        830.0,
        -3735.0,
        1269.789306640625
      ],
      "bbox_max": [
        972.5,
        -3725.0,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        830.0,
        -3735.0,
        1269.789306640625
      ],
      "bbox_max": [
        830.0,
        -3725.0,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 972.5,
      "bbox_min": [
        935.0,
        -3735.0,
        1270.0
      ],
      "bbox_max": [
        972.5,
        -3725.0,
        1350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -935.0,
      "bbox_min": [
        935.0,
        -3735.0,
        1270.0
      ],
      "bbox_max": [
        972.5,
        -3725.0,
        1350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3727.5,
      "bbox_min": [
        935.0,
        -3732.5,
        1270.0
      ],
      "bbox_max": [
        972.5,
        -3727.5,
        1345.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3732.5,
      "bbox_min": [
        935.0,
        -3732.5,
        1270.0
      ],
      "bbox_max": [
        972.5,
        -3727.5,
        1345.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        947.5,
        -3732.5,
        1270.0
      ],
      "bbox_max": [
        960.0,
        -3727.5,
        1285.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -947.5,
      "bbox_min": [
        947.5,
        -3732.5,
        1270.0
      ],
      "bbox_max": [
        960.0,
        -3727.5,
        1285.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1285.0,
      "bbox_min": [
        947.5,
        -3732.5,
        1285.0
      ],
      "bbox_max": [
        960.0,
        -3727.5,
        1285.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3742.5,
      "bbox_min": [
        830.0,
        -3982.5,
        1269.789306640625
      ],
      "bbox_max": [
        997.5,
        -3735.0,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        830.0,
        -3742.5,
        1269.789306640625
      ],
      "bbox_max": [
        855.0,
        -3735.0,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -855.0,
      "bbox_min": [
        855.0,
        -3742.5,
        1269.789306640625
      ],
      "bbox_max": [
        855.0,
        -3735.0,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1298.0,
      "bbox_min": [
        852.692626953125,
        -3982.5,
        1269.789306640625
      ],
      "bbox_max": [
        997.5,
        -3770.5,
        1362.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1295.0,
      "bbox_min": [
        867.5,
        -3982.5,
        1269.789306640625
      ],
      "bbox_max": [
        997.5,
        -3770.5,
        1298.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -919.5,
      "bbox_min": [
        867.5,
        -3982.5,
        1295.0
      ],
      "bbox_max": [
        983.5,
        -3770.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -3982.5,
        1295.0
      ],
      "bbox_max": [
        919.5,
        -3779.5,
        1298.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3779.5,
      "bbox_min": [
        867.5,
        -3779.5,
        1295.0
      ],
      "bbox_max": [
        919.5,
        -3779.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        867.5,
        -3982.5,
        1295.0
      ],
      "bbox_max": [
        892.5,
        -3975.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -892.5,
      "bbox_min": [
        892.5,
        -3982.5,
        1295.0
      ],
      "bbox_max": [
        892.5,
        -3975.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 949.5,
      "bbox_min": [
        919.5,
        -3864.5,
        1295.0
      ],
      "bbox_max": [
        983.5,
        -3770.5,
        1298.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 967.5,
      "bbox_min": [
        949.5,
        -3864.5,
        1295.0
      ],
      "bbox_max": [
        983.5,
        -3770.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -978.5,
      "bbox_min": [
        967.5,
        -3864.5,
        1295.0
      ],
      "bbox_max": [
        983.5,
        -3770.5,
        1298.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7371541857719421,
        0.6757246851921082,
        -0.0
      ],
      "plane_d": 1834.6231689453125,
      "bbox_min": [
        967.5,
        -3864.5,
        1295.0
      ],
      "bbox_max": [
        978.5,
        -3770.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7371541857719421,
        -0.6757246851921082,
        0.0
      ],
      "plane_d": -3324.53466796875,
      "bbox_min": [
        967.5,
        -3864.5,
        1295.0
      ],
      "bbox_max": [
        978.5,
        -3817.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -974.0,
      "bbox_min": [
        967.5,
        -3837.5,
        1295.0
      ],
      "bbox_max": [
        978.5,
        -3817.5,
        1298.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 970.9999389648438,
      "bbox_min": [
        967.5,
        -3835.0,
        1295.0
      ],
      "bbox_max": [
        974.0,
        -3819.0,
        1298.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3832.0,
      "bbox_min": [
        971.0,
        -3832.0,
        1295.0
      ],
      "bbox_max": [
        974.0,
        -3822.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3822.5,
      "bbox_min": [
        971.0,
        -3822.5,
        1295.0
      ],
      "bbox_max": [
        974.0,
        -3822.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3835.0,
      "bbox_min": [
        967.5,
        -3835.0,
        1295.0
      ],
      "bbox_max": [
        971.0,
        -3819.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3819.0,
      "bbox_min": [
        967.5,
        -3819.0,
        1295.0
      ],
      "bbox_max": [
        971.0,
        -3819.0,
        1298.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 4011.506103515625,
      "bbox_min": [
        974.0,
        -3837.5,
        1295.0
      ],
      "bbox_max": [
        978.5,
        -3817.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.911921501159668,
        -0.41036465764045715
      ],
      "plane_d": -2949.837890625,
      "bbox_min": [
        974.0,
        -3818.85009765625,
        1295.0
      ],
      "bbox_max": [
        978.5,
        -3817.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -983.5,
      "bbox_min": [
        978.5,
        -3802.5,
        1295.0
      ],
      "bbox_max": [
        983.5,
        -3791.5,
        1298.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3797.0,
      "bbox_min": [
        978.5,
        -3802.5,
        1295.0
      ],
      "bbox_max": [
        983.5,
        -3791.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3791.5,
      "bbox_min": [
        978.5,
        -3791.5,
        1295.0
      ],
      "bbox_max": [
        983.5,
        -3791.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3802.5,
      "bbox_min": [
        978.5,
        -3802.5,
        1295.0
      ],
      "bbox_max": [
        983.5,
        -3802.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1296.5,
      "bbox_min": [
        949.5,
        -3864.5,
        1295.0
      ],
      "bbox_max": [
        967.5,
        -3770.5,
        1298.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3864.5,
      "bbox_min": [
        949.5,
        -3864.5,
        1295.0
      ],
      "bbox_max": [
        967.5,
        -3819.0,
        1296.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -3818.999755859375,
      "bbox_min": [
        951.5,
        -3819.71240234375,
        1295.0
      ],
      "bbox_max": [
        967.5,
        -3819.0,
        1296.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9032860398292542,
        -0.4290388226509094
      ],
      "plane_d": -2894.0439453125,
      "bbox_min": [
        951.5,
        -3819.71240234375,
        1295.0
      ],
      "bbox_max": [
        960.0,
        -3819.0,
        1296.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 958.5,
      "bbox_min": [
        953.0,
        -3819.71240234375,
        1295.0
      ],
      "bbox_max": [
        960.0,
        -3819.0,
        1296.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        960.0,
        -3819.71240234375,
        1295.0
      ],
      "bbox_max": [
        960.0,
        -3819.0,
        1296.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -953.0,
      "bbox_min": [
        953.0,
        -3819.71240234375,
        1295.0
      ],
      "bbox_max": [
        953.0,
        -3819.0,
        1296.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        949.5,
        -3864.5,
        1296.5
      ],
      "bbox_max": [
        967.5,
        -3770.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3770.5,
      "bbox_min": [
        949.5,
        -3770.5,
        1296.5
      ],
      "bbox_max": [
        967.5,
        -3770.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3864.5,
      "bbox_min": [
        949.5,
        -3864.5,
        1296.5
      ],
      "bbox_max": [
        967.5,
        -3787.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.5,
      "bbox_min": [
        949.5,
        -3835.0,
        1296.5
      ],
      "bbox_max": [
        967.5,
        -3787.5,
        1298.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.8865849375724792,
        0.4625660479068756
      ],
      "plane_d": 2780.83154296875,
      "bbox_min": [
        949.5,
        -3817.5,
        1296.5
      ],
      "bbox_max": [
        950.5,
        -3806.21728515625,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3817.5,
      "bbox_min": [
        949.5,
        -3817.5,
        1296.5
      ],
      "bbox_max": [
        950.5,
        -3817.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -951.5,
      "bbox_min": [
        950.5,
        -3835.0,
        1296.5
      ],
      "bbox_max": [
        967.5,
        -3817.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3817.5,
      "bbox_min": [
        950.5,
        -3817.5,
        1296.5
      ],
      "bbox_max": [
        951.5,
        -3817.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3819.0,
      "bbox_min": [
        951.5,
        -3820.4248046875,
        1296.5
      ],
      "bbox_max": [
        967.5,
        -3817.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 958.5,
      "bbox_min": [
        953.0,
        -3819.0,
        1296.5
      ],
      "bbox_max": [
        958.5,
        -3817.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -953.0,
      "bbox_min": [
        953.0,
        -3819.0,
        1296.5
      ],
      "bbox_max": [
        953.0,
        -3817.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9032860398292542,
        -0.4290388226509094
      ],
      "plane_d": -2894.0439453125,
      "bbox_min": [
        951.5,
        -3820.4248046875,
        1296.5
      ],
      "bbox_max": [
        960.0,
        -3819.0,
        1298.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 958.5,
      "bbox_min": [
        953.0,
        -3820.4248046875,
        1296.5
      ],
      "bbox_max": [
        960.0,
        -3819.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        960.0,
        -3820.4248046875,
        1296.5
      ],
      "bbox_max": [
        960.0,
        -3819.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -953.0,
      "bbox_min": [
        953.0,
        -3820.4248046875,
        1296.5
      ],
      "bbox_max": [
        953.0,
        -3819.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1296.5,
      "bbox_min": [
        919.5,
        -3864.5,
        1295.0
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1298.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 924.0,
      "bbox_min": [
        924.0,
        -3864.5,
        1295.0
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1296.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        924.0,
        -3864.5,
        1295.0
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1296.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        924.0,
        -3864.5,
        1295.0
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1296.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3770.5,
      "bbox_min": [
        934.0,
        -3864.5,
        1295.0
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1296.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3864.5,
      "bbox_min": [
        934.0,
        -3864.5,
        1295.0
      ],
      "bbox_max": [
        949.5,
        -3864.5,
        1296.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -925.5,
      "bbox_min": [
        919.5,
        -3864.5,
        1296.5
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1298.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 924.0,
      "bbox_min": [
        919.5,
        -3854.300048828125,
        1296.5
      ],
      "bbox_max": [
        925.5,
        -3780.699951171875,
        1298.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        924.0,
        -3854.300048828125,
        1296.5
      ],
      "bbox_max": [
        925.5,
        -3780.699951171875,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        924.0,
        -3854.300048828125,
        1296.5
      ],
      "bbox_max": [
        925.5,
        -3852.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3789.5,
      "bbox_min": [
        919.5,
        -3806.0,
        1296.5
      ],
      "bbox_max": [
        924.0,
        -3789.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3806.0,
      "bbox_min": [
        919.5,
        -3806.0,
        1296.5
      ],
      "bbox_max": [
        924.0,
        -3806.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -932.5,
      "bbox_min": [
        925.5,
        -3864.5,
        1296.5
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1297.5,
      "bbox_min": [
        925.5,
        -3862.699951171875,
        1296.5
      ],
      "bbox_max": [
        932.5,
        -3772.300048828125,
        1298.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        925.5,
        -3862.699951171875,
        1296.5
      ],
      "bbox_max": [
        932.5,
        -3772.300048828125,
        1297.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        925.5,
        -3860.666748046875,
        1296.5
      ],
      "bbox_max": [
        932.5,
        -3772.300048828125,
        1297.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3850.0,
      "bbox_min": [
        925.5,
        -3852.5,
        1296.5
      ],
      "bbox_max": [
        932.5,
        -3845.5,
        1297.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3852.5,
      "bbox_min": [
        925.5,
        -3852.5,
        1296.5
      ],
      "bbox_max": [
        932.5,
        -3852.5,
        1297.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.5,
      "bbox_min": [
        925.5,
        -3845.5,
        1296.5
      ],
      "bbox_max": [
        932.5,
        -3845.5,
        1297.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3802.5,
      "bbox_min": [
        925.5,
        -3809.0,
        1296.5
      ],
      "bbox_max": [
        929.5001220703125,
        -3792.5,
        1297.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3792.5,
      "bbox_min": [
        925.5,
        -3792.5,
        1296.5
      ],
      "bbox_max": [
        929.5,
        -3792.5,
        1297.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3809.0,
      "bbox_min": [
        925.5,
        -3809.0,
        1296.5
      ],
      "bbox_max": [
        929.5001220703125,
        -3809.0,
        1297.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3809.0,
      "bbox_min": [
        926.8336181640625,
        -3843.0,
        1296.5
      ],
      "bbox_max": [
        932.5,
        -3809.0,
        1297.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 2035.406982421875,
      "bbox_min": [
        930.5,
        -3843.0,
        1296.5
      ],
      "bbox_max": [
        932.5,
        -3809.0,
        1297.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -3375.37451171875,
      "bbox_min": [
        930.5,
        -3843.0,
        1296.5
      ],
      "bbox_max": [
        932.5,
        -3841.0,
        1297.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -926.5,
      "bbox_min": [
        925.5,
        -3862.699951171875,
        1297.5
      ],
      "bbox_max": [
        932.5,
        -3772.300048828125,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3839.0,
      "bbox_min": [
        925.5,
        -3855.5,
        1297.5
      ],
      "bbox_max": [
        926.5,
        -3779.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3792.5,
      "bbox_min": [
        925.5,
        -3813.0,
        1297.5
      ],
      "bbox_max": [
        926.5,
        -3779.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3813.0,
      "bbox_min": [
        925.5,
        -3813.0,
        1297.5
      ],
      "bbox_max": [
        926.5,
        -3802.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3802.5,
      "bbox_min": [
        925.5,
        -3802.5,
        1297.5
      ],
      "bbox_max": [
        926.5,
        -3802.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        925.5,
        -3787.5,
        1297.5
      ],
      "bbox_max": [
        926.5,
        -3787.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7592566013336182,
        0.650791347026825,
        0.0
      ],
      "plane_d": 1804.4818115234375,
      "bbox_min": [
        925.5,
        -3855.5,
        1297.5
      ],
      "bbox_max": [
        926.5,
        -3843.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        925.5,
        -3855.5,
        1297.5
      ],
      "bbox_max": [
        926.5,
        -3854.300048828125,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.5,
      "bbox_min": [
        925.5,
        -3852.5,
        1297.5
      ],
      "bbox_max": [
        926.5,
        -3843.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3843.0,
      "bbox_min": [
        925.5,
        -3843.0,
        1297.5
      ],
      "bbox_max": [
        926.5,
        -3843.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3852.5,
      "bbox_min": [
        925.5,
        -3852.5,
        1297.5
      ],
      "bbox_max": [
        926.5,
        -3850.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3850.0,
      "bbox_min": [
        925.5,
        -3850.0,
        1297.5
      ],
      "bbox_max": [
        926.5,
        -3850.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        926.5,
        -3862.699951171875,
        1297.5
      ],
      "bbox_max": [
        932.5,
        -3772.300048828125,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        926.5,
        -3860.666748046875,
        1297.5
      ],
      "bbox_max": [
        932.5,
        -3772.300048828125,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7592566013336182,
        0.650791347026825,
        0.0
      ],
      "plane_d": 1804.4818115234375,
      "bbox_min": [
        926.5,
        -3860.666748046875,
        1297.5
      ],
      "bbox_max": [
        932.5,
        -3787.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3843.0,
      "bbox_min": [
        926.5,
        -3852.5,
        1297.5
      ],
      "bbox_max": [
        932.5,
        -3787.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3850.0,
      "bbox_min": [
        926.5,
        -3852.5,
        1297.5
      ],
      "bbox_max": [
        932.5,
        -3845.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3852.5,
      "bbox_min": [
        926.5,
        -3852.5,
        1297.5
      ],
      "bbox_max": [
        932.5,
        -3852.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.5,
      "bbox_min": [
        926.5,
        -3845.5,
        1297.5
      ],
      "bbox_max": [
        932.5,
        -3845.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3511234521865845,
        -0.0,
        0.936329185962677
      ],
      "plane_d": -1540.320068359375,
      "bbox_min": [
        926.5,
        -3802.5,
        1297.5
      ],
      "bbox_max": [
        932.5,
        -3787.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3792.5,
      "bbox_min": [
        926.5,
        -3802.5,
        1297.5
      ],
      "bbox_max": [
        926.8334350585938,
        -3787.5,
        1297.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3802.5,
      "bbox_min": [
        926.5,
        -3802.5,
        1297.5
      ],
      "bbox_max": [
        926.8333129882812,
        -3802.5,
        1297.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        926.5,
        -3787.5,
        1297.5
      ],
      "bbox_max": [
        926.8334350585938,
        -3787.5,
        1297.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3864.5,
      "bbox_min": [
        932.5,
        -3864.5,
        1296.5
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        932.5,
        -3864.5,
        1296.5
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1298.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        932.5,
        -3772.300048828125,
        1296.5
      ],
      "bbox_max": [
        934.0,
        -3770.5,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3863.0,
      "bbox_min": [
        932.5,
        -3864.5,
        1296.5
      ],
      "bbox_max": [
        949.5,
        -3843.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        932.7500610351562,
        -3864.5,
        1296.5
      ],
      "bbox_max": [
        934.0,
        -3863.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7592566013336182,
        0.650791347026825,
        0.0
      ],
      "plane_d": 1804.4818115234375,
      "bbox_min": [
        932.5,
        -3863.0,
        1296.5
      ],
      "bbox_max": [
        934.5,
        -3843.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        932.5,
        -3863.0,
        1296.5
      ],
      "bbox_max": [
        932.7500610351562,
        -3862.699951171875,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        -0.8944272994995117,
        0.0
      ],
      "plane_d": -3856.7705078125,
      "bbox_min": [
        932.5,
        -3852.5,
        1296.5
      ],
      "bbox_max": [
        934.0,
        -3843.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -934.0,
      "bbox_min": [
        932.5,
        -3845.5,
        1296.5
      ],
      "bbox_max": [
        934.0,
        -3843.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        0.8944272994995117,
        -0.0
      ],
      "plane_d": 3020.033935546875,
      "bbox_min": [
        932.5,
        -3845.5,
        1296.5
      ],
      "bbox_max": [
        934.0,
        -3843.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3843.0,
      "bbox_min": [
        932.5,
        -3845.5,
        1296.5
      ],
      "bbox_max": [
        933.0,
        -3843.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        0.8944272994995117,
        -0.0
      ],
      "plane_d": 3026.294921875,
      "bbox_min": [
        932.5,
        -3852.5,
        1296.5
      ],
      "bbox_max": [
        934.0,
        -3850.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        -0.8944272994995117,
        0.0
      ],
      "plane_d": -3863.031494140625,
      "bbox_min": [
        932.5,
        -3852.5,
        1296.5
      ],
      "bbox_max": [
        934.0,
        -3850.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3852.5,
      "bbox_min": [
        932.5,
        -3852.5,
        1296.5
      ],
      "bbox_max": [
        933.0,
        -3850.0,
        1298.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 924.0,
      "bbox_min": [
        867.5,
        -3982.5,
        1269.789306640625
      ],
      "bbox_max": [
        989.5,
        -3770.5,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3770.5,
      "bbox_min": [
        924.0,
        -3864.5,
        1269.789306640625
      ],
      "bbox_max": [
        989.5,
        -3770.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3864.5,
      "bbox_min": [
        924.0,
        -3864.5,
        1269.789306640625
      ],
      "bbox_max": [
        989.5,
        -3770.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        -0.0
      ],
      "plane_d": -1756.4737548828125,
      "bbox_min": [
        924.0,
        -3864.5,
        1269.789306640625
      ],
      "bbox_max": [
        989.5,
        -3770.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        924.0,
        -3864.5,
        1269.789306640625
      ],
      "bbox_max": [
        989.5,
        -3770.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7371541857719421,
        0.6757246851921082,
        0.0
      ],
      "plane_d": 1834.623291015625,
      "bbox_min": [
        967.5,
        -3864.5,
        1269.789306640625
      ],
      "bbox_max": [
        989.5,
        -3770.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7371541857719421,
        -0.6757246851921082,
        0.0
      ],
      "plane_d": -3324.53466796875,
      "bbox_min": [
        967.5,
        -3864.5,
        1269.789306640625
      ],
      "bbox_max": [
        989.5,
        -3782.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -978.5,
      "bbox_min": [
        978.5,
        -3852.5,
        1269.789306640625
      ],
      "bbox_max": [
        986.7500610351562,
        -3782.5,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3791.5,
      "bbox_min": [
        978.5,
        -3845.0,
        1269.789306640625
      ],
      "bbox_max": [
        986.7500610351562,
        -3791.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.0,
      "bbox_min": [
        978.5,
        -3845.0,
        1269.789306640625
      ],
      "bbox_max": [
        985.3749389648438,
        -3845.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.0,
      "bbox_min": [
        985.3749389648438,
        -3845.0,
        1269.789306640625
      ],
      "bbox_max": [
        989.5,
        -3845.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -3982.5,
        1269.789306640625
      ],
      "bbox_max": [
        892.5,
        -3975.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -892.5,
      "bbox_min": [
        892.5,
        -3982.5,
        1269.789306640625
      ],
      "bbox_max": [
        892.5,
        -3975.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3831.5,
      "bbox_min": [
        869.0,
        -3858.0,
        1269.789306640625
      ],
      "bbox_max": [
        918.0,
        -3781.0,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.5,
      "bbox_min": [
        869.0,
        -3858.0,
        1269.789306640625
      ],
      "bbox_max": [
        918.0,
        -3831.5,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3854.5,
      "bbox_min": [
        914.5,
        -3858.0,
        1269.789306640625
      ],
      "bbox_max": [
        918.0,
        -3831.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -917.5,
      "bbox_min": [
        914.5,
        -3858.0,
        1269.789306640625
      ],
      "bbox_max": [
        918.0,
        -3854.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3857.5,
      "bbox_min": [
        914.5,
        -3858.0,
        1269.789306640625
      ],
      "bbox_max": [
        917.5,
        -3857.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3858.0,
      "bbox_min": [
        914.5,
        -3858.0,
        1292.0
      ],
      "bbox_max": [
        917.5,
        -3857.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        914.5,
        -3858.0,
        1292.0
      ],
      "bbox_max": [
        917.5,
        -3857.5,
        1292.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -918.0,
      "bbox_min": [
        917.5,
        -3858.0,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3854.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        917.5,
        -3858.0,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3854.5,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -917.5,
      "bbox_min": [
        917.5,
        -3834.5,
        1269.789306640625
      ],
      "bbox_max": [
        918.0,
        -3831.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -918.0,
      "bbox_min": [
        917.5,
        -3834.5,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3831.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        917.5,
        -3834.5,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3831.5,
        1292.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3854.0,
      "bbox_min": [
        914.5,
        -3854.5,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3834.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        914.5,
        -3854.5,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3854.0,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        914.5,
        -3835.0,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3834.5,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -918.0,
      "bbox_min": [
        918.0,
        -3835.0,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3834.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -872.5,
      "bbox_min": [
        869.0,
        -3858.0,
        1269.789306640625
      ],
      "bbox_max": [
        914.5,
        -3831.5,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3854.5,
      "bbox_min": [
        869.0,
        -3858.0,
        1269.789306640625
      ],
      "bbox_max": [
        872.5,
        -3831.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        869.0,
        -3858.0,
        1269.789306640625
      ],
      "bbox_max": [
        872.5,
        -3854.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3857.5,
      "bbox_min": [
        869.5,
        -3858.0,
        1269.789306640625
      ],
      "bbox_max": [
        872.5,
        -3857.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3858.0,
      "bbox_min": [
        869.5,
        -3858.0,
        1292.0
      ],
      "bbox_max": [
        872.5,
        -3857.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        869.5,
        -3858.0,
        1292.0
      ],
      "bbox_max": [
        872.5,
        -3857.5,
        1292.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.0,
      "bbox_min": [
        869.0,
        -3858.0,
        1292.0
      ],
      "bbox_max": [
        869.5,
        -3854.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        869.0,
        -3858.0,
        1292.0
      ],
      "bbox_max": [
        869.5,
        -3854.5,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        869.0,
        -3834.5,
        1269.789306640625
      ],
      "bbox_max": [
        869.5,
        -3831.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.0,
      "bbox_min": [
        869.0,
        -3834.5,
        1292.0
      ],
      "bbox_max": [
        869.5,
        -3831.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        869.0,
        -3834.5,
        1292.0
      ],
      "bbox_max": [
        869.5,
        -3831.5,
        1292.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3854.0,
      "bbox_min": [
        869.0,
        -3854.5,
        1292.0
      ],
      "bbox_max": [
        872.5,
        -3834.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        869.0,
        -3854.5,
        1292.0
      ],
      "bbox_max": [
        872.5,
        -3854.0,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        869.0,
        -3835.0,
        1292.0
      ],
      "bbox_max": [
        872.5,
        -3834.5,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.0,
      "bbox_min": [
        869.0,
        -3835.0,
        1292.0
      ],
      "bbox_max": [
        869.0,
        -3834.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        872.5,
        -3858.0,
        1292.0
      ],
      "bbox_max": [
        914.5,
        -3831.5,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        914.0,
        -3858.0,
        1292.0
      ],
      "bbox_max": [
        914.5,
        -3831.5,
        1295.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3854.0,
      "bbox_min": [
        914.0,
        -3858.0,
        1292.0
      ],
      "bbox_max": [
        914.5,
        -3835.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3858.0,
      "bbox_min": [
        914.0,
        -3858.0,
        1292.0
      ],
      "bbox_max": [
        914.5,
        -3858.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3835.0,
      "bbox_min": [
        914.0,
        -3835.0,
        1292.0
      ],
      "bbox_max": [
        914.5,
        -3835.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -873.0,
      "bbox_min": [
        872.5,
        -3858.0,
        1292.0
      ],
      "bbox_max": [
        873.0,
        -3831.5,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        872.5,
        -3858.0,
        1292.0
      ],
      "bbox_max": [
        873.0,
        -3831.5,
        1295.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3808.5,
      "bbox_min": [
        914.5,
        -3831.5,
        1269.789306640625
      ],
      "bbox_max": [
        918.0,
        -3805.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -917.5,
      "bbox_min": [
        917.5,
        -3808.5,
        1269.789306640625
      ],
      "bbox_max": [
        918.0,
        -3805.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -918.0,
      "bbox_min": [
        917.5,
        -3808.5,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3805.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        917.5,
        -3808.5,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3805.5,
        1292.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3831.0,
      "bbox_min": [
        914.5,
        -3831.5,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3808.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        914.5,
        -3831.5,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3831.0,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        914.5,
        -3809.0,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3808.5,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        869.0,
        -3808.5,
        1269.789306640625
      ],
      "bbox_max": [
        869.5,
        -3805.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.0,
      "bbox_min": [
        869.0,
        -3808.5,
        1292.0
      ],
      "bbox_max": [
        869.5,
        -3805.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        869.0,
        -3808.5,
        1292.0
      ],
      "bbox_max": [
        869.5,
        -3805.5,
        1292.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3831.0,
      "bbox_min": [
        869.0,
        -3831.5,
        1292.0
      ],
      "bbox_max": [
        872.5,
        -3808.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        869.0,
        -3831.5,
        1292.0
      ],
      "bbox_max": [
        872.5,
        -3831.0,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        869.0,
        -3809.0,
        1292.0
      ],
      "bbox_max": [
        872.5,
        -3808.5,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        914.0,
        -3831.5,
        1292.0
      ],
      "bbox_max": [
        914.5,
        -3805.5,
        1295.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3809.0,
      "bbox_min": [
        872.5,
        -3809.0,
        1292.0
      ],
      "bbox_max": [
        873.0,
        -3809.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -872.5,
      "bbox_min": [
        869.0,
        -3805.5,
        1269.789306640625
      ],
      "bbox_max": [
        918.0,
        -3781.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3784.5,
      "bbox_min": [
        869.0,
        -3805.5,
        1269.789306640625
      ],
      "bbox_max": [
        872.5,
        -3781.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3781.5,
      "bbox_min": [
        869.0,
        -3784.5,
        1269.789306640625
      ],
      "bbox_max": [
        872.5,
        -3781.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        869.0,
        -3784.5,
        1269.789306640625
      ],
      "bbox_max": [
        869.5,
        -3781.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 869.0,
      "bbox_min": [
        869.0,
        -3784.5,
        1292.0
      ],
      "bbox_max": [
        869.5,
        -3781.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        869.0,
        -3784.5,
        1292.0
      ],
      "bbox_max": [
        869.5,
        -3781.5,
        1292.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3781.0,
      "bbox_min": [
        869.0,
        -3781.5,
        1292.0
      ],
      "bbox_max": [
        872.5,
        -3781.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        869.0,
        -3781.5,
        1292.0
      ],
      "bbox_max": [
        872.5,
        -3781.0,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        869.0,
        -3805.5,
        1292.0
      ],
      "bbox_max": [
        872.5,
        -3805.0,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        869.0,
        -3785.0,
        1292.0
      ],
      "bbox_max": [
        872.5,
        -3784.5,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3781.5,
      "bbox_min": [
        914.5,
        -3784.5,
        1269.789306640625
      ],
      "bbox_max": [
        918.0,
        -3781.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -917.5,
      "bbox_min": [
        917.5,
        -3784.5,
        1269.789306640625
      ],
      "bbox_max": [
        918.0,
        -3781.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -918.0,
      "bbox_min": [
        917.5,
        -3784.5,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3781.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        917.5,
        -3784.5,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3781.5,
        1292.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3781.0,
      "bbox_min": [
        914.5,
        -3781.5,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3781.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        914.5,
        -3781.5,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3781.0,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        914.5,
        -3805.5,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3805.0,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        914.5,
        -3785.0,
        1292.0
      ],
      "bbox_max": [
        918.0,
        -3784.5,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1291.9998779296875,
      "bbox_min": [
        872.5,
        -3805.5,
        1292.0
      ],
      "bbox_max": [
        873.0,
        -3781.0,
        1295.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3785.0,
      "bbox_min": [
        872.5,
        -3805.0,
        1292.0
      ],
      "bbox_max": [
        873.0,
        -3781.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3781.0,
      "bbox_min": [
        872.5,
        -3781.0,
        1292.0
      ],
      "bbox_max": [
        873.0,
        -3781.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3805.0,
      "bbox_min": [
        872.5,
        -3805.0,
        1292.0
      ],
      "bbox_max": [
        873.0,
        -3805.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        914.0,
        -3805.5,
        1292.0
      ],
      "bbox_max": [
        914.5,
        -3781.0,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3785.0,
      "bbox_min": [
        914.0,
        -3805.0,
        1292.0
      ],
      "bbox_max": [
        914.5,
        -3781.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3781.0,
      "bbox_min": [
        914.0,
        -3781.0,
        1292.0
      ],
      "bbox_max": [
        914.5,
        -3781.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3805.0,
      "bbox_min": [
        914.0,
        -3805.0,
        1292.0
      ],
      "bbox_max": [
        914.5,
        -3805.0,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5070201754570007,
        0.8619343042373657
      ],
      "plane_d": -3044.149169921875,
      "bbox_min": [
        989.5,
        -3845.0,
        1270.0
      ],
      "bbox_max": [
        997.5,
        -3791.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -997.5,
      "bbox_min": [
        989.5,
        -3845.0,
        1270.0
      ],
      "bbox_max": [
        997.5,
        -3791.5,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3791.5,
      "bbox_min": [
        989.5,
        -3791.5,
        1270.0
      ],
      "bbox_max": [
        997.5,
        -3791.5,
        1295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9958931803703308,
        0.0,
        0.09053574502468109
      ],
      "plane_d": 747.915771484375,
      "bbox_min": [
        852.692626953125,
        -3982.5,
        1298.0
      ],
      "bbox_max": [
        983.5,
        -3770.5,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1303.4998779296875,
      "bbox_min": [
        869.0,
        -3982.5,
        1298.0
      ],
      "bbox_max": [
        983.5,
        -3770.5,
        1362.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -870.5,
      "bbox_min": [
        869.0,
        -3982.5,
        1298.0
      ],
      "bbox_max": [
        983.5,
        -3770.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9958931803703308,
        0.09053574502468109
      ],
      "plane_d": -3959.67138671875,
      "bbox_min": [
        869.0,
        -3975.0,
        1298.0
      ],
      "bbox_max": [
        870.5,
        -3781.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9958931803703308,
        0.09053574502468109
      ],
      "plane_d": 3648.45458984375,
      "bbox_min": [
        869.0,
        -3782.0,
        1298.0
      ],
      "bbox_max": [
        870.5,
        -3781.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        869.0,
        -3975.0,
        1298.0
      ],
      "bbox_max": [
        870.5,
        -3975.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9958931803703308,
        -0.0,
        0.09053574502468109
      ],
      "plane_d": -1031.745361328125,
      "bbox_min": [
        870.5,
        -3982.5,
        1298.0
      ],
      "bbox_max": [
        983.5,
        -3770.5,
        1303.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 916.5,
      "bbox_min": [
        870.5,
        -3982.5,
        1298.0
      ],
      "bbox_max": [
        918.0,
        -3781.5,
        1303.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3806.0,
      "bbox_min": [
        916.5,
        -3858.0,
        1298.0
      ],
      "bbox_max": [
        918.0,
        -3781.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9958931803703308,
        0.09053574502468109
      ],
      "plane_d": -3959.67138671875,
      "bbox_min": [
        916.5,
        -3858.0,
        1298.0
      ],
      "bbox_max": [
        918.0,
        -3857.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9958931803703308,
        0.09053574502468109
      ],
      "plane_d": 3648.45458984375,
      "bbox_min": [
        916.5,
        -3789.5,
        1298.0
      ],
      "bbox_max": [
        918.0,
        -3781.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3789.5,
      "bbox_min": [
        916.5,
        -3789.5,
        1298.0
      ],
      "bbox_max": [
        918.0,
        -3789.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3856.5,
      "bbox_min": [
        870.5,
        -3982.5,
        1298.0
      ],
      "bbox_max": [
        916.5,
        -3781.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9958931803703308,
        0.09053574502468109
      ],
      "plane_d": -3959.67138671875,
      "bbox_min": [
        870.5,
        -3982.5,
        1298.0
      ],
      "bbox_max": [
        916.5,
        -3857.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        870.5,
        -3982.5,
        1298.0
      ],
      "bbox_max": [
        892.5,
        -3975.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -892.5,
      "bbox_min": [
        892.5,
        -3982.5,
        1298.0
      ],
      "bbox_max": [
        892.5,
        -3975.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3783.0,
      "bbox_min": [
        870.5,
        -3852.61572265625,
        1298.0
      ],
      "bbox_max": [
        916.5,
        -3781.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9958931803703308,
        0.09053574502468109
      ],
      "plane_d": 3648.45458984375,
      "bbox_min": [
        870.5,
        -3782.0,
        1298.0
      ],
      "bbox_max": [
        916.5,
        -3781.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3827.984619140625,
      "bbox_min": [
        871.5,
        -3852.61572265625,
        1298.0
      ],
      "bbox_max": [
        915.0,
        -3784.5,
        1303.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3852.61572265625,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1298.0
      ],
      "bbox_max": [
        906.61572265625,
        -3827.984619140625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660241961479187,
        0.5000020861625671,
        0.0
      ],
      "plane_d": 2682.327880859375,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1298.0
      ],
      "bbox_max": [
        906.61572265625,
        -3827.984619140625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8659989833831787,
        -0.500045895576477,
        0.0
      ],
      "plane_d": -2707.104736328125,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1298.0
      ],
      "bbox_max": [
        906.61572265625,
        -3827.984619140625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660402297973633,
        0.4999743700027466,
        0.0
      ],
      "plane_d": 1133.236328125,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1298.0
      ],
      "bbox_max": [
        906.61572265625,
        -3827.984619140625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660150170326233,
        -0.5000181198120117,
        -0.0
      ],
      "plane_d": -1158.05810546875,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1298.0
      ],
      "bbox_max": [
        906.61572265625,
        -3827.984619140625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000181198120117,
        -0.8660150170326233,
        -0.0
      ],
      "plane_d": -2890.906982421875,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1298.0
      ],
      "bbox_max": [
        906.61572265625,
        -3827.984619140625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 881.984375,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1298.0
      ],
      "bbox_max": [
        906.61572265625,
        -3827.984619140625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        3.699182707350701e-05,
        0.0
      ],
      "plane_d": -906.4735107421875,
      "bbox_min": [
        885.284423828125,
        -3852.61572265625,
        1298.0
      ],
      "bbox_max": [
        906.61572265625,
        -3827.984619140625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999040365219116,
        0.8660310506820679,
        0.0
      ],
      "plane_d": 2866.362060546875,
      "bbox_min": [
        885.284423828125,
        -3852.61572265625,
        1298.0
      ],
      "bbox_max": [
        903.315673828125,
        -3827.984619140625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999040365219116,
        0.8660310506820679,
        0.0
      ],
      "plane_d": 3760.64501953125,
      "bbox_min": [
        885.284423828125,
        -3852.61572265625,
        1298.0
      ],
      "bbox_max": [
        903.3154296875,
        -3827.984619140625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000341534614563,
        -0.8660057783126831,
        0.0
      ],
      "plane_d": -3785.21826171875,
      "bbox_min": [
        897.60009765625,
        -3852.61572265625,
        1298.0
      ],
      "bbox_max": [
        903.3154296875,
        -3849.315673828125,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9998886585235596,
        -0.0,
        0.01492371130734682
      ],
      "plane_d": -893.7736206054688,
      "bbox_min": [
        871.5,
        -3787.5,
        1298.0
      ],
      "bbox_max": [
        915.0,
        -3784.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9998886585235596,
        0.0,
        0.01492371130734682
      ],
      "plane_d": 852.031982421875,
      "bbox_min": [
        871.5,
        -3787.5,
        1298.0
      ],
      "bbox_max": [
        874.5,
        -3784.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9998886585235596,
        0.01492371130734682
      ],
      "plane_d": 3764.70751953125,
      "bbox_min": [
        871.5,
        -3787.5,
        1298.0
      ],
      "bbox_max": [
        874.5,
        -3784.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998886585235596,
        0.01492371130734682
      ],
      "plane_d": -3806.449462890625,
      "bbox_min": [
        871.5,
        -3787.5,
        1298.0
      ],
      "bbox_max": [
        874.5,
        -3787.41796875,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9998886585235596,
        -0.0,
        0.01492371130734682
      ],
      "plane_d": -934.2691040039062,
      "bbox_min": [
        912.0,
        -3787.5,
        1298.0
      ],
      "bbox_max": [
        915.0,
        -3784.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9998886585235596,
        0.0,
        0.01492371130734682
      ],
      "plane_d": 892.5274658203125,
      "bbox_min": [
        912.0,
        -3787.5,
        1298.0
      ],
      "bbox_max": [
        915.0,
        -3784.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9998886585235596,
        0.01492371130734682
      ],
      "plane_d": 3764.70751953125,
      "bbox_min": [
        912.0,
        -3787.5,
        1298.0
      ],
      "bbox_max": [
        915.0,
        -3784.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998886585235596,
        0.01492371130734682
      ],
      "plane_d": -3806.449462890625,
      "bbox_min": [
        912.0,
        -3787.5,
        1298.0
      ],
      "bbox_max": [
        915.0,
        -3787.41796875,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 949.5,
      "bbox_min": [
        924.0,
        -3864.5,
        1298.0
      ],
      "bbox_max": [
        983.5,
        -3770.5,
        1303.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -978.5,
      "bbox_min": [
        949.5,
        -3864.5,
        1298.0
      ],
      "bbox_max": [
        983.5,
        -3770.5,
        1303.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 967.5,
      "bbox_min": [
        949.5,
        -3864.5,
        1298.0
      ],
      "bbox_max": [
        978.5,
        -3770.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7371541857719421,
        0.6757246851921082,
        -0.0
      ],
      "plane_d": 1834.6231689453125,
      "bbox_min": [
        967.5,
        -3864.5,
        1298.0
      ],
      "bbox_max": [
        978.5,
        -3770.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7371541857719421,
        -0.6757246851921082,
        0.0
      ],
      "plane_d": -3324.53466796875,
      "bbox_min": [
        967.5,
        -3864.5,
        1298.0
      ],
      "bbox_max": [
        978.5,
        -3818.85009765625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -974.0,
      "bbox_min": [
        967.5,
        -3836.0,
        1298.0
      ],
      "bbox_max": [
        978.5,
        -3818.85009765625,
        1303.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 970.9999389648438,
      "bbox_min": [
        967.5,
        -3835.0,
        1298.0
      ],
      "bbox_max": [
        974.0,
        -3819.0,
        1303.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3832.0,
      "bbox_min": [
        971.0,
        -3832.0,
        1298.0
      ],
      "bbox_max": [
        974.0,
        -3822.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3822.5,
      "bbox_min": [
        971.0,
        -3822.5,
        1298.0
      ],
      "bbox_max": [
        974.0,
        -3822.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3819.0,
      "bbox_min": [
        967.5,
        -3835.0,
        1298.0
      ],
      "bbox_max": [
        971.0,
        -3819.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3835.0,
      "bbox_min": [
        967.5,
        -3835.0,
        1298.0
      ],
      "bbox_max": [
        971.0,
        -3835.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 4011.506103515625,
      "bbox_min": [
        974.0,
        -3836.0,
        1298.0
      ],
      "bbox_max": [
        978.5,
        -3818.85009765625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.911921501159668,
        -0.41036465764045715
      ],
      "plane_d": -2949.837890625,
      "bbox_min": [
        974.0,
        -3821.324951171875,
        1298.0
      ],
      "bbox_max": [
        978.5,
        -3818.85009765625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        949.5,
        -3864.5,
        1298.0
      ],
      "bbox_max": [
        967.5,
        -3770.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3770.5,
      "bbox_min": [
        949.5,
        -3770.5,
        1298.0
      ],
      "bbox_max": [
        967.5,
        -3770.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3864.5,
      "bbox_min": [
        949.5,
        -3864.5,
        1298.0
      ],
      "bbox_max": [
        967.5,
        -3787.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.5,
      "bbox_min": [
        949.5,
        -3835.0,
        1298.0
      ],
      "bbox_max": [
        967.5,
        -3787.5,
        1303.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3817.5,
      "bbox_min": [
        949.5,
        -3817.5,
        1298.0
      ],
      "bbox_max": [
        950.5,
        -3805.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3814.5,
      "bbox_min": [
        949.5,
        -3814.5,
        1298.0
      ],
      "bbox_max": [
        950.5,
        -3805.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3805.5,
      "bbox_min": [
        949.5,
        -3814.5,
        1298.0
      ],
      "bbox_max": [
        950.5,
        -3805.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8865849375724792,
        0.4625660479068756
      ],
      "plane_d": 2780.83154296875,
      "bbox_min": [
        949.5,
        -3814.5,
        1298.0
      ],
      "bbox_max": [
        950.5,
        -3805.5,
        1299.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8865849375724792,
        0.4625660479068756
      ],
      "plane_d": -3974.94580078125,
      "bbox_min": [
        949.5,
        -3806.21728515625,
        1298.0
      ],
      "bbox_max": [
        950.5,
        -3805.5,
        1299.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3835.0,
      "bbox_min": [
        950.5,
        -3835.0,
        1298.0
      ],
      "bbox_max": [
        967.5,
        -3817.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -951.5,
      "bbox_min": [
        950.5,
        -3835.0,
        1298.0
      ],
      "bbox_max": [
        967.5,
        -3817.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3817.5,
      "bbox_min": [
        950.5,
        -3817.5,
        1298.0
      ],
      "bbox_max": [
        951.5,
        -3817.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3819.0,
      "bbox_min": [
        951.5,
        -3820.89990234375,
        1298.0
      ],
      "bbox_max": [
        967.5,
        -3817.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3817.5,
      "bbox_min": [
        951.5,
        -3819.0,
        1298.0
      ],
      "bbox_max": [
        967.5,
        -3817.5,
        1303.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 958.5,
      "bbox_min": [
        953.0,
        -3819.0,
        1298.0
      ],
      "bbox_max": [
        958.5,
        -3817.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -953.0,
      "bbox_min": [
        953.0,
        -3819.0,
        1298.0
      ],
      "bbox_max": [
        953.0,
        -3817.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 958.5,
      "bbox_min": [
        951.5,
        -3820.89990234375,
        1298.0
      ],
      "bbox_max": [
        960.0,
        -3819.0,
        1303.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        958.5,
        -3820.89990234375,
        1298.0
      ],
      "bbox_max": [
        960.0,
        -3819.0,
        1303.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3820.89990234375,
      "bbox_min": [
        958.5,
        -3820.89990234375,
        1298.0
      ],
      "bbox_max": [
        960.0,
        -3820.4248046875,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9032860398292542,
        -0.4290388226509094
      ],
      "plane_d": -2894.0439453125,
      "bbox_min": [
        958.5,
        -3820.89990234375,
        1298.0
      ],
      "bbox_max": [
        960.0,
        -3820.4248046875,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9032860398292542,
        0.4290388226509094
      ],
      "plane_d": -4010.403076171875,
      "bbox_min": [
        958.5,
        -3820.89990234375,
        1303.0
      ],
      "bbox_max": [
        960.0,
        -3820.662353515625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -953.0,
      "bbox_min": [
        951.5,
        -3820.89990234375,
        1298.0
      ],
      "bbox_max": [
        953.0,
        -3819.0,
        1303.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3820.89990234375,
      "bbox_min": [
        951.5,
        -3820.89990234375,
        1298.0
      ],
      "bbox_max": [
        953.0,
        -3820.4248046875,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9032860398292542,
        -0.4290388226509094
      ],
      "plane_d": -2894.0439453125,
      "bbox_min": [
        951.5,
        -3820.89990234375,
        1298.0
      ],
      "bbox_max": [
        953.0,
        -3820.4248046875,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9032860398292542,
        0.4290388226509094
      ],
      "plane_d": -4010.403076171875,
      "bbox_min": [
        951.5,
        -3820.89990234375,
        1303.0
      ],
      "bbox_max": [
        953.0,
        -3820.662353515625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -983.5,
      "bbox_min": [
        978.5,
        -3802.5,
        1298.0
      ],
      "bbox_max": [
        983.5,
        -3791.5,
        1303.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3797.0,
      "bbox_min": [
        978.5,
        -3802.5,
        1298.0
      ],
      "bbox_max": [
        983.5,
        -3791.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3791.5,
      "bbox_min": [
        978.5,
        -3791.5,
        1298.0
      ],
      "bbox_max": [
        983.5,
        -3791.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        978.5,
        -3802.5,
        1298.0
      ],
      "bbox_max": [
        983.5,
        -3797.0,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3802.5,
      "bbox_min": [
        978.5,
        -3802.5,
        1298.0
      ],
      "bbox_max": [
        983.5,
        -3802.5,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -925.5,
      "bbox_min": [
        924.0,
        -3864.5,
        1298.0
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1303.5
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1302.0,
      "bbox_min": [
        924.5,
        -3854.300048828125,
        1298.0
      ],
      "bbox_max": [
        925.5,
        -3780.699951171875,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        924.5,
        -3854.300048828125,
        1298.0
      ],
      "bbox_max": [
        925.5,
        -3780.699951171875,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        924.5,
        -3802.5,
        1298.0
      ],
      "bbox_max": [
        925.5,
        -3780.699951171875,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9908301830291748,
        -0.1351132094860077
      ],
      "plane_d": 3943.0087890625,
      "bbox_min": [
        924.5,
        -3802.5,
        1298.0
      ],
      "bbox_max": [
        925.5,
        -3792.5,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        924.5,
        -3801.95458984375,
        1302.0
      ],
      "bbox_max": [
        925.5,
        -3780.699951171875,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9908301830291748,
        -0.1351132094860077
      ],
      "plane_d": 3943.0087890625,
      "bbox_min": [
        924.5,
        -3801.95458984375,
        1302.0
      ],
      "bbox_max": [
        925.5,
        -3793.04541015625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9908301830291748,
        -0.1351132094860077
      ],
      "plane_d": -3582.346435546875,
      "bbox_min": [
        924.5,
        -3793.25,
        1302.0
      ],
      "bbox_max": [
        925.5,
        -3793.04541015625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6000000238418579,
        0.800000011920929
      ],
      "plane_d": 1261.8001708984375,
      "bbox_min": [
        924.5,
        -3854.300048828125,
        1302.0
      ],
      "bbox_max": [
        925.5,
        -3839.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        924.5,
        -3854.300048828125,
        1302.0
      ],
      "bbox_max": [
        925.5,
        -3853.10009765625,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1302.0,
      "bbox_min": [
        924.0,
        -3853.10009765625,
        1298.0
      ],
      "bbox_max": [
        924.5,
        -3781.89990234375,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9908301830291748,
        -0.1351132094860077
      ],
      "plane_d": 3943.0087890625,
      "bbox_min": [
        924.0,
        -3853.10009765625,
        1298.0
      ],
      "bbox_max": [
        924.5,
        -3781.89990234375,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        924.0,
        -3853.10009765625,
        1298.0
      ],
      "bbox_max": [
        924.5,
        -3852.5,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        924.0,
        -3793.04541015625,
        1298.0
      ],
      "bbox_max": [
        924.5,
        -3781.89990234375,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9908301830291748,
        -0.1351132094860077
      ],
      "plane_d": -3582.346435546875,
      "bbox_min": [
        924.0,
        -3793.04541015625,
        1298.0
      ],
      "bbox_max": [
        924.5,
        -3792.5,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        924.0,
        -3782.5,
        1302.0
      ],
      "bbox_max": [
        924.5,
        -3781.89990234375,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9908301830291748,
        -0.1351132094860077
      ],
      "plane_d": 3943.0087890625,
      "bbox_min": [
        924.0,
        -3801.95458984375,
        1302.0
      ],
      "bbox_max": [
        924.5,
        -3801.75,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6000000238418579,
        0.800000011920929
      ],
      "plane_d": 1261.8001708984375,
      "bbox_min": [
        924.0,
        -3853.10009765625,
        1302.0
      ],
      "bbox_max": [
        924.5,
        -3839.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        924.0,
        -3853.10009765625,
        1302.0
      ],
      "bbox_max": [
        924.5,
        -3852.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -926.5,
      "bbox_min": [
        925.5,
        -3864.5,
        1298.0
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1301.5,
      "bbox_min": [
        925.5,
        -3855.5,
        1298.0
      ],
      "bbox_max": [
        926.5,
        -3779.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3843.0,
      "bbox_min": [
        925.5,
        -3855.5,
        1298.0
      ],
      "bbox_max": [
        926.5,
        -3779.5,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7592566013336182,
        0.650791347026825,
        0.0
      ],
      "plane_d": 1804.4818115234375,
      "bbox_min": [
        925.5,
        -3855.5,
        1298.0
      ],
      "bbox_max": [
        926.5,
        -3845.5,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        925.5,
        -3855.5,
        1298.0
      ],
      "bbox_max": [
        926.5,
        -3854.300048828125,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3850.0,
      "bbox_min": [
        925.5,
        -3852.5,
        1298.0
      ],
      "bbox_max": [
        926.5,
        -3845.5,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3852.5,
      "bbox_min": [
        925.5,
        -3852.5,
        1298.0
      ],
      "bbox_max": [
        926.5,
        -3852.5,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.5,
      "bbox_min": [
        925.5,
        -3845.5,
        1298.0
      ],
      "bbox_max": [
        926.5,
        -3845.5,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        925.5,
        -3839.0,
        1298.0
      ],
      "bbox_max": [
        926.5,
        -3779.5,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3813.0,
      "bbox_min": [
        925.5,
        -3839.0,
        1298.0
      ],
      "bbox_max": [
        926.5,
        -3787.5,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3839.0,
      "bbox_min": [
        925.5,
        -3839.0,
        1298.0
      ],
      "bbox_max": [
        926.5,
        -3839.0,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        925.5,
        -3787.5,
        1298.0
      ],
      "bbox_max": [
        926.5,
        -3787.5,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.5,
      "bbox_min": [
        925.5,
        -3855.5,
        1301.5
      ],
      "bbox_max": [
        926.5,
        -3779.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        925.5,
        -3843.0,
        1301.5
      ],
      "bbox_max": [
        926.5,
        -3779.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        925.5,
        -3843.0,
        1301.5
      ],
      "bbox_max": [
        926.5,
        -3787.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3843.0,
      "bbox_min": [
        925.5,
        -3843.0,
        1301.5
      ],
      "bbox_max": [
        926.5,
        -3843.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7592566013336182,
        0.650791347026825,
        0.0
      ],
      "plane_d": 1804.4818115234375,
      "bbox_min": [
        925.5,
        -3855.5,
        1301.5
      ],
      "bbox_max": [
        926.5,
        -3850.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        925.5,
        -3855.5,
        1301.5
      ],
      "bbox_max": [
        926.5,
        -3854.300048828125,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3852.5,
      "bbox_min": [
        925.5,
        -3852.5,
        1301.5
      ],
      "bbox_max": [
        926.5,
        -3850.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3850.0,
      "bbox_min": [
        925.5,
        -3850.0,
        1301.5
      ],
      "bbox_max": [
        926.5,
        -3850.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -928.0,
      "bbox_min": [
        926.5,
        -3864.5,
        1298.0
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162277936935425,
        -0.0,
        0.9486833810806274
      ],
      "plane_d": -1527.6964111328125,
      "bbox_min": [
        926.5,
        -3857.300048828125,
        1298.0
      ],
      "bbox_max": [
        928.0,
        -3777.699951171875,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1300.5,
      "bbox_min": [
        926.5,
        -3857.300048828125,
        1298.0
      ],
      "bbox_max": [
        928.0,
        -3777.699951171875,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7592566013336182,
        0.650791347026825,
        0.0
      ],
      "plane_d": 1804.4818115234375,
      "bbox_min": [
        926.5,
        -3857.300048828125,
        1300.5
      ],
      "bbox_max": [
        928.0,
        -3777.699951171875,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        926.5,
        -3857.300048828125,
        1300.5
      ],
      "bbox_max": [
        928.0,
        -3855.5,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        926.5,
        -3852.5,
        1300.5
      ],
      "bbox_max": [
        928.0,
        -3777.699951171875,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3843.0,
      "bbox_min": [
        926.5,
        -3852.5,
        1300.5
      ],
      "bbox_max": [
        928.0,
        -3787.5,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3850.0,
      "bbox_min": [
        926.5,
        -3852.5,
        1300.5
      ],
      "bbox_max": [
        928.0,
        -3845.5,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3852.5,
      "bbox_min": [
        926.5,
        -3852.5,
        1300.5
      ],
      "bbox_max": [
        928.0,
        -3852.5,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.5,
      "bbox_min": [
        926.5,
        -3845.5,
        1300.5
      ],
      "bbox_max": [
        928.0,
        -3845.5,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3813.0,
      "bbox_min": [
        926.5,
        -3839.0,
        1300.5
      ],
      "bbox_max": [
        928.0,
        -3787.5,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3839.0,
      "bbox_min": [
        926.5,
        -3839.0,
        1300.5
      ],
      "bbox_max": [
        928.0,
        -3839.0,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        926.5,
        -3787.5,
        1300.5
      ],
      "bbox_max": [
        928.0,
        -3787.5,
        1301.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7592566013336182,
        0.650791347026825,
        0.0
      ],
      "plane_d": 1804.4818115234375,
      "bbox_min": [
        926.5,
        -3857.300048828125,
        1298.0
      ],
      "bbox_max": [
        928.0,
        -3777.699951171875,
        1300.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        926.5,
        -3857.300048828125,
        1298.0
      ],
      "bbox_max": [
        928.0,
        -3855.5,
        1300.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        926.5,
        -3852.5,
        1298.0
      ],
      "bbox_max": [
        928.0,
        -3777.699951171875,
        1300.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.5,
      "bbox_min": [
        926.5,
        -3852.5,
        1298.0
      ],
      "bbox_max": [
        928.0,
        -3787.5,
        1300.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        926.5,
        -3843.0,
        1298.0
      ],
      "bbox_max": [
        928.0,
        -3787.5,
        1300.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3843.0,
      "bbox_min": [
        926.5,
        -3843.0,
        1298.0
      ],
      "bbox_max": [
        928.0,
        -3843.0,
        1300.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3852.5,
      "bbox_min": [
        926.5,
        -3852.5,
        1298.0
      ],
      "bbox_max": [
        928.0,
        -3850.0,
        1300.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3850.0,
      "bbox_min": [
        926.5,
        -3850.0,
        1298.0
      ],
      "bbox_max": [
        928.0,
        -3850.0,
        1300.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7592566013336182,
        0.650791347026825,
        0.0
      ],
      "plane_d": 1804.4818115234375,
      "bbox_min": [
        926.5,
        -3857.300048828125,
        1301.0
      ],
      "bbox_max": [
        928.0,
        -3777.699951171875,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        926.5,
        -3857.300048828125,
        1301.0
      ],
      "bbox_max": [
        928.0,
        -3855.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        926.5,
        -3852.5,
        1301.0
      ],
      "bbox_max": [
        928.0,
        -3777.699951171875,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.5,
      "bbox_min": [
        926.5,
        -3852.5,
        1301.0
      ],
      "bbox_max": [
        928.0,
        -3787.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        926.5,
        -3843.0,
        1301.0
      ],
      "bbox_max": [
        928.0,
        -3787.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3843.0,
      "bbox_min": [
        926.5,
        -3843.0,
        1301.0
      ],
      "bbox_max": [
        928.0,
        -3843.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3852.5,
      "bbox_min": [
        926.5,
        -3852.5,
        1301.0
      ],
      "bbox_max": [
        928.0,
        -3850.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3850.0,
      "bbox_min": [
        926.5,
        -3850.0,
        1301.0
      ],
      "bbox_max": [
        928.0,
        -3850.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3770.5,
      "bbox_min": [
        928.0,
        -3864.5,
        1298.0
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3864.5,
      "bbox_min": [
        928.0,
        -3864.5,
        1298.0
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        928.0,
        -3864.5,
        1298.0
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1303.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        928.0,
        -3777.699951171875,
        1298.0
      ],
      "bbox_max": [
        934.0,
        -3770.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3863.0,
      "bbox_min": [
        928.0,
        -3864.5,
        1298.0
      ],
      "bbox_max": [
        949.5,
        -3843.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        932.75,
        -3864.5,
        1298.0
      ],
      "bbox_max": [
        934.0,
        -3863.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7592566013336182,
        0.650791347026825,
        0.0
      ],
      "plane_d": 1804.4818115234375,
      "bbox_min": [
        928.0,
        -3863.0,
        1298.0
      ],
      "bbox_max": [
        934.5,
        -3843.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        928.0,
        -3863.0,
        1298.0
      ],
      "bbox_max": [
        932.75,
        -3857.300048828125,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.5,
      "bbox_min": [
        928.0,
        -3852.5,
        1298.0
      ],
      "bbox_max": [
        934.0,
        -3843.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3843.0,
      "bbox_min": [
        928.0,
        -3845.5,
        1298.0
      ],
      "bbox_max": [
        934.0,
        -3843.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -934.0,
      "bbox_min": [
        933.0,
        -3845.5,
        1298.0
      ],
      "bbox_max": [
        934.0,
        -3843.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        0.8944272994995117,
        -0.0
      ],
      "plane_d": 3020.033935546875,
      "bbox_min": [
        933.0,
        -3845.5,
        1298.0
      ],
      "bbox_max": [
        934.0,
        -3843.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        -0.8944272994995117,
        0.0
      ],
      "plane_d": -3856.7705078125,
      "bbox_min": [
        933.0,
        -3845.5,
        1298.0
      ],
      "bbox_max": [
        934.0,
        -3845.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3852.5,
      "bbox_min": [
        928.0,
        -3852.5,
        1298.0
      ],
      "bbox_max": [
        934.0,
        -3850.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3850.0,
      "bbox_min": [
        928.0,
        -3852.5,
        1298.0
      ],
      "bbox_max": [
        934.0,
        -3850.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -934.0,
      "bbox_min": [
        933.0,
        -3852.5,
        1298.0
      ],
      "bbox_max": [
        934.0,
        -3850.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        0.8944272994995117,
        -0.0
      ],
      "plane_d": 3026.294921875,
      "bbox_min": [
        933.0,
        -3852.5,
        1298.0
      ],
      "bbox_max": [
        934.0,
        -3850.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        -0.8944272994995117,
        0.0
      ],
      "plane_d": -3863.031494140625,
      "bbox_min": [
        933.0,
        -3852.5,
        1298.0
      ],
      "bbox_max": [
        934.0,
        -3852.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6726728081703186,
        -0.0,
        0.7399401068687439
      ],
      "plane_d": -1631.2315673828125,
      "bbox_min": [
        869.5,
        -3982.5,
        1303.5
      ],
      "bbox_max": [
        983.5,
        -3770.5,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -276.478759765625,
      "bbox_min": [
        869.5,
        -3982.5,
        1303.5
      ],
      "bbox_max": [
        983.5,
        -3770.5,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1325.0,
      "bbox_min": [
        912.5000610351562,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        983.5,
        -3770.5,
        1325.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 924.0,
      "bbox_min": [
        912.5000610351562,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        983.5,
        -3770.5,
        1325.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -978.4999389648438,
      "bbox_min": [
        924.0,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        983.5,
        -3770.5,
        1325.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7295363545417786,
        0.0,
        -0.6839420795440674
      ],
      "plane_d": 223.78759765625,
      "bbox_min": [
        924.0,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        978.5,
        -3770.5,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6092077493667603,
        -0.5076730847358704,
        0.6092077493667603
      ],
      "plane_d": -2194.0107421875,
      "bbox_min": [
        924.0,
        -3854.974853515625,
        1312.800048828125
      ],
      "bbox_max": [
        935.4375,
        -3780.025146484375,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1316.0,
      "bbox_min": [
        924.0,
        -3854.974853515625,
        1312.800048828125
      ],
      "bbox_max": [
        935.4375,
        -3780.025146484375,
        1325.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6092076897621155,
        0.5076730251312256,
        0.6092076897621155
      ],
      "plane_d": 1682.072998046875,
      "bbox_min": [
        925.0,
        -3854.340087890625,
        1316.0
      ],
      "bbox_max": [
        935.4375,
        -3780.10009765625,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1323.5,
      "bbox_min": [
        925.0000610351562,
        -3854.340087890625,
        1316.0
      ],
      "bbox_max": [
        935.4375,
        -3780.659912109375,
        1325.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3832.5,
      "bbox_min": [
        925.0000610351562,
        -3854.340087890625,
        1316.0
      ],
      "bbox_max": [
        934.03125,
        -3780.659912109375,
        1323.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3847.5,
      "bbox_min": [
        925.0000610351562,
        -3854.340087890625,
        1316.0
      ],
      "bbox_max": [
        934.03125,
        -3847.5,
        1323.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": -3484.203857421875,
      "bbox_min": [
        934.0,
        -3854.340087890625,
        1323.4666748046875
      ],
      "bbox_max": [
        934.03125,
        -3854.300048828125,
        1323.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3788.0,
      "bbox_min": [
        925.0000610351562,
        -3803.0,
        1316.0
      ],
      "bbox_max": [
        934.03125,
        -3780.659912109375,
        1323.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3803.0,
      "bbox_min": [
        925.0000610351562,
        -3803.0,
        1316.0
      ],
      "bbox_max": [
        933.0,
        -3803.0,
        1323.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": 1403.60400390625,
      "bbox_min": [
        934.0,
        -3780.699951171875,
        1323.4666748046875
      ],
      "bbox_max": [
        934.03125,
        -3780.659912109375,
        1323.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": 1403.60400390625,
      "bbox_min": [
        934.0,
        -3782.5,
        1323.5
      ],
      "bbox_max": [
        935.4375,
        -3780.699951171875,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        924.0,
        -3782.5,
        1312.800048828125
      ],
      "bbox_max": [
        926.9999389648438,
        -3780.025146484375,
        1316.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6092076897621155,
        0.5076730251312256,
        0.6092076897621155
      ],
      "plane_d": 1682.072998046875,
      "bbox_min": [
        924.0,
        -3782.5,
        1315.0
      ],
      "bbox_max": [
        926.9999389648438,
        -3780.025146484375,
        1316.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": 1403.60400390625,
      "bbox_min": [
        934.5,
        -3853.699951171875,
        1324.0
      ],
      "bbox_max": [
        968.5999755859375,
        -3781.300048828125,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5725722312927246,
        0.5248578786849976,
        0.629829466342926
      ],
      "plane_d": 596.7872924804688,
      "bbox_min": [
        967.5,
        -3853.699951171875,
        1324.0
      ],
      "bbox_max": [
        968.5999755859375,
        -3781.300048828125,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5725721716880798,
        -0.5248578786849976,
        0.629829466342926
      ],
      "plane_d": -3410.502685546875,
      "bbox_min": [
        967.5,
        -3853.699951171875,
        1324.0
      ],
      "bbox_max": [
        968.5999755859375,
        -3852.5,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -954.5,
      "bbox_min": [
        954.5,
        -3832.0,
        1324.0
      ],
      "bbox_max": [
        963.0,
        -3822.0,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3832.0,
      "bbox_min": [
        954.5,
        -3832.0,
        1324.0
      ],
      "bbox_max": [
        963.0,
        -3822.0,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3822.0,
      "bbox_min": [
        954.5,
        -3822.0,
        1324.0
      ],
      "bbox_max": [
        963.0,
        -3822.0,
        1325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 949.5,
      "bbox_min": [
        924.0,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        978.5,
        -3770.5,
        1324.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 967.5,
      "bbox_min": [
        949.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        978.5,
        -3770.5,
        1324.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7371541857719421,
        0.6757246851921082,
        -0.0
      ],
      "plane_d": 1834.6231689453125,
      "bbox_min": [
        967.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        978.5,
        -3770.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7371541857719421,
        -0.6757246851921082,
        0.0
      ],
      "plane_d": -3324.53466796875,
      "bbox_min": [
        967.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        978.5,
        -3770.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5725722312927246,
        0.5248578786849976,
        0.629829466342926
      ],
      "plane_d": 596.7872924804688,
      "bbox_min": [
        967.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        978.5,
        -3770.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5725721716880798,
        -0.5248578786849976,
        0.629829466342926
      ],
      "plane_d": -3410.502685546875,
      "bbox_min": [
        967.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        978.5,
        -3819.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1307.0,
      "bbox_min": [
        967.5,
        -3835.0,
        1303.5
      ],
      "bbox_max": [
        978.5,
        -3819.0,
        1307.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 971.0,
      "bbox_min": [
        967.5,
        -3835.0,
        1303.5
      ],
      "bbox_max": [
        978.5,
        -3819.0,
        1307.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1305.0,
      "bbox_min": [
        974.0,
        -3833.25,
        1303.5
      ],
      "bbox_max": [
        978.5,
        -3821.324951171875,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -974.0,
      "bbox_min": [
        974.0,
        -3833.25,
        1303.5
      ],
      "bbox_max": [
        978.5,
        -3821.324951171875,
        1305.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 4011.506103515625,
      "bbox_min": [
        974.0,
        -3833.25,
        1303.5
      ],
      "bbox_max": [
        978.5,
        -3821.324951171875,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.911921501159668,
        -0.41036465764045715
      ],
      "plane_d": -2949.837890625,
      "bbox_min": [
        974.0,
        -3822.0,
        1303.5
      ],
      "bbox_max": [
        978.5,
        -3821.324951171875,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3835.0,
      "bbox_min": [
        967.5,
        -3835.0,
        1303.5
      ],
      "bbox_max": [
        971.0,
        -3819.0,
        1307.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": 1403.60400390625,
      "bbox_min": [
        949.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        967.5,
        -3770.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9899495244026184,
        -0.1414213627576828
      ],
      "plane_d": 3940.140625,
      "bbox_min": [
        949.5,
        -3804.0,
        1303.5
      ],
      "bbox_max": [
        967.5,
        -3770.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.5,
      "bbox_min": [
        950.5,
        -3804.0,
        1303.5
      ],
      "bbox_max": [
        967.5,
        -3791.0,
        1324.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1306.5,
      "bbox_min": [
        950.5,
        -3801.5,
        1306.5
      ],
      "bbox_max": [
        967.5,
        -3793.5,
        1306.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3770.5,
      "bbox_min": [
        949.5,
        -3793.9287109375,
        1303.5
      ],
      "bbox_max": [
        967.5,
        -3770.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        949.5,
        -3793.9287109375,
        1303.5
      ],
      "bbox_max": [
        967.5,
        -3787.5,
        1324.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.5,
      "bbox_min": [
        950.5,
        -3793.9287109375,
        1303.5
      ],
      "bbox_max": [
        950.5,
        -3787.5,
        1324.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3864.5,
      "bbox_min": [
        949.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        967.5,
        -3801.071533203125,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3817.5,
      "bbox_min": [
        949.5,
        -3835.0,
        1303.5
      ],
      "bbox_max": [
        967.5,
        -3801.071533203125,
        1324.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3835.0,
      "bbox_min": [
        951.5,
        -3835.0,
        1303.5
      ],
      "bbox_max": [
        967.5,
        -3817.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3822.0,
      "bbox_min": [
        951.5,
        -3835.0,
        1303.5
      ],
      "bbox_max": [
        967.5,
        -3817.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -952.9999389648438,
      "bbox_min": [
        951.5,
        -3822.0,
        1303.5
      ],
      "bbox_max": [
        967.5,
        -3817.5,
        1307.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9032860398292542,
        0.4290388226509094
      ],
      "plane_d": -4010.403076171875,
      "bbox_min": [
        951.5,
        -3822.0,
        1303.5
      ],
      "bbox_max": [
        953.0,
        -3819.0,
        1307.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3819.0,
      "bbox_min": [
        951.5,
        -3819.0,
        1305.0
      ],
      "bbox_max": [
        953.0,
        -3819.0,
        1307.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1306.9998779296875,
      "bbox_min": [
        951.5,
        -3822.0,
        1307.0
      ],
      "bbox_max": [
        953.0,
        -3819.0,
        1307.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 958.5,
      "bbox_min": [
        953.0,
        -3822.0,
        1303.5
      ],
      "bbox_max": [
        967.5,
        -3817.5,
        1307.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -959.9999389648438,
      "bbox_min": [
        958.5,
        -3822.0,
        1303.5
      ],
      "bbox_max": [
        967.5,
        -3819.0,
        1307.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9032860398292542,
        0.4290388226509094
      ],
      "plane_d": -4010.403076171875,
      "bbox_min": [
        958.5,
        -3822.0,
        1303.5
      ],
      "bbox_max": [
        960.0,
        -3819.0,
        1307.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3819.0,
      "bbox_min": [
        958.5,
        -3819.0,
        1303.5
      ],
      "bbox_max": [
        960.0,
        -3819.0,
        1307.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1307.0,
      "bbox_min": [
        960.0,
        -3822.0,
        1307.0
      ],
      "bbox_max": [
        967.5,
        -3819.0,
        1307.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3819.0,
      "bbox_min": [
        953.0,
        -3822.0,
        1305.0
      ],
      "bbox_max": [
        958.5,
        -3817.5,
        1307.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1305.0,
      "bbox_min": [
        953.0,
        -3819.0,
        1305.0
      ],
      "bbox_max": [
        958.5,
        -3817.5,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1306.9998779296875,
      "bbox_min": [
        953.0,
        -3822.0,
        1307.0
      ],
      "bbox_max": [
        958.5,
        -3819.0,
        1307.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1307.0,
      "bbox_min": [
        951.5,
        -3835.0,
        1307.0
      ],
      "bbox_max": [
        967.5,
        -3822.0,
        1324.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 963.0,
      "bbox_min": [
        954.5,
        -3832.0,
        1307.0
      ],
      "bbox_max": [
        963.0,
        -3822.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -954.5,
      "bbox_min": [
        954.5,
        -3832.0,
        1307.0
      ],
      "bbox_max": [
        954.5,
        -3822.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.5,
      "bbox_min": [
        949.5,
        -3817.5,
        1303.5
      ],
      "bbox_max": [
        950.5,
        -3801.071533203125,
        1324.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.8865849375724792,
        -0.4625660479068756
      ],
      "plane_d": 3984.94873046875,
      "bbox_min": [
        949.5,
        -3814.5,
        1303.5
      ],
      "bbox_max": [
        950.5,
        -3813.0,
        1306.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3814.5,
      "bbox_min": [
        949.5,
        -3814.5,
        1303.5
      ],
      "bbox_max": [
        950.5,
        -3814.5,
        1303.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3807.0,
      "bbox_min": [
        949.5,
        -3807.0,
        1303.5
      ],
      "bbox_max": [
        950.5,
        -3805.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3805.5,
      "bbox_min": [
        949.5,
        -3807.0,
        1303.5
      ],
      "bbox_max": [
        950.5,
        -3805.5,
        1306.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8865849375724792,
        -0.4625660479068756
      ],
      "plane_d": -2770.828369140625,
      "bbox_min": [
        949.5,
        -3807.0,
        1303.75
      ],
      "bbox_max": [
        950.5,
        -3805.5,
        1306.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -925.5,
      "bbox_min": [
        924.0,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1324.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1309.0,
      "bbox_min": [
        924.5,
        -3854.300048828125,
        1303.5
      ],
      "bbox_max": [
        925.5,
        -3780.699951171875,
        1314.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        924.5,
        -3854.300048828125,
        1309.0
      ],
      "bbox_max": [
        925.5,
        -3780.699951171875,
        1314.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        924.5,
        -3781.89990234375,
        1309.0
      ],
      "bbox_max": [
        925.5,
        -3780.699951171875,
        1314.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9908301830291748,
        -0.1351132094860077
      ],
      "plane_d": 3943.0087890625,
      "bbox_min": [
        924.5,
        -3854.300048828125,
        1303.5
      ],
      "bbox_max": [
        925.5,
        -3780.699951171875,
        1309.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3841.0,
      "bbox_min": [
        924.5,
        -3841.0,
        1303.5
      ],
      "bbox_max": [
        925.5,
        -3811.0,
        1309.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3811.0,
      "bbox_min": [
        924.5,
        -3841.0,
        1303.5
      ],
      "bbox_max": [
        925.5,
        -3811.0,
        1309.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6000000238418579,
        -0.800000011920929
      ],
      "plane_d": 3350.60009765625,
      "bbox_min": [
        924.5,
        -3841.0,
        1307.5
      ],
      "bbox_max": [
        925.5,
        -3811.0,
        1309.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.6000000238418579,
        -0.800000011920929
      ],
      "plane_d": -1240.5999755859375,
      "bbox_min": [
        924.5,
        -3813.0,
        1307.5
      ],
      "bbox_max": [
        925.5,
        -3811.0,
        1309.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        924.5,
        -3794.0,
        1303.5
      ],
      "bbox_max": [
        925.5,
        -3780.699951171875,
        1309.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9908301830291748,
        -0.1351132094860077
      ],
      "plane_d": -3582.346435546875,
      "bbox_min": [
        924.5,
        -3794.0,
        1303.5
      ],
      "bbox_max": [
        925.5,
        -3793.25,
        1309.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1309.0,
      "bbox_min": [
        924.0,
        -3853.10009765625,
        1303.5
      ],
      "bbox_max": [
        924.5,
        -3781.89990234375,
        1313.3333740234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        924.0,
        -3853.10009765625,
        1309.0
      ],
      "bbox_max": [
        924.5,
        -3781.89990234375,
        1313.3333740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        924.0,
        -3782.5,
        1309.0
      ],
      "bbox_max": [
        924.5,
        -3781.89990234375,
        1313.3333740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9908301830291748,
        -0.1351132094860077
      ],
      "plane_d": 3943.0087890625,
      "bbox_min": [
        924.0,
        -3853.10009765625,
        1303.5
      ],
      "bbox_max": [
        924.5,
        -3781.89990234375,
        1309.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3841.0,
      "bbox_min": [
        924.0,
        -3841.0,
        1303.5
      ],
      "bbox_max": [
        924.5,
        -3811.0,
        1309.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3811.0,
      "bbox_min": [
        924.0,
        -3841.0,
        1303.5
      ],
      "bbox_max": [
        924.5,
        -3811.0,
        1309.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6000000238418579,
        -0.800000011920929
      ],
      "plane_d": 3350.60009765625,
      "bbox_min": [
        924.0,
        -3841.0,
        1307.5
      ],
      "bbox_max": [
        924.5,
        -3811.0,
        1309.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.6000000238418579,
        -0.800000011920929
      ],
      "plane_d": -1240.5999755859375,
      "bbox_min": [
        924.0,
        -3813.0,
        1307.5
      ],
      "bbox_max": [
        924.5,
        -3811.0,
        1309.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9908301830291748,
        -0.1351132094860077
      ],
      "plane_d": -3582.346435546875,
      "bbox_min": [
        924.0,
        -3794.0,
        1303.5
      ],
      "bbox_max": [
        924.5,
        -3781.89990234375,
        1309.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        924.0,
        -3782.5,
        1303.5
      ],
      "bbox_max": [
        924.5,
        -3781.89990234375,
        1309.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 935.5,
      "bbox_min": [
        925.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1321.5,
      "bbox_min": [
        935.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1324.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 946.0,
      "bbox_min": [
        935.5,
        -3856.699951171875,
        1321.5
      ],
      "bbox_max": [
        949.5,
        -3778.300048828125,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": 1403.60400390625,
      "bbox_min": [
        946.0,
        -3856.699951171875,
        1321.5
      ],
      "bbox_max": [
        949.5,
        -3778.300048828125,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": -3484.203857421875,
      "bbox_min": [
        946.0,
        -3856.699951171875,
        1321.5
      ],
      "bbox_max": [
        949.5,
        -3787.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6747682690620422,
        -0.7380296587944031
      ],
      "plane_d": 3576.696044921875,
      "bbox_min": [
        946.0,
        -3855.234375,
        1321.5
      ],
      "bbox_max": [
        949.5,
        -3787.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9899495244026184,
        -0.1414213627576828
      ],
      "plane_d": -3578.526123046875,
      "bbox_min": [
        947.5,
        -3818.5,
        1321.5
      ],
      "bbox_max": [
        949.5,
        -3787.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        947.5,
        -3791.357177734375,
        1321.5
      ],
      "bbox_max": [
        949.5,
        -3787.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9899495244026184,
        -0.1414213627576828
      ],
      "plane_d": 3940.140625,
      "bbox_min": [
        947.5,
        -3791.357177734375,
        1321.5
      ],
      "bbox_max": [
        949.5,
        -3791.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3818.5,
      "bbox_min": [
        947.6143188476562,
        -3818.5,
        1321.5
      ],
      "bbox_max": [
        948.5,
        -3818.5,
        1322.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        946.0,
        -3818.5,
        1321.5
      ],
      "bbox_max": [
        947.6428833007812,
        -3787.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3818.5,
      "bbox_min": [
        946.0,
        -3818.5,
        1321.5
      ],
      "bbox_max": [
        947.642822265625,
        -3818.5,
        1322.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -938.0,
      "bbox_min": [
        935.5,
        -3856.699951171875,
        1321.5
      ],
      "bbox_max": [
        946.0,
        -3778.300048828125,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": 1403.60400390625,
      "bbox_min": [
        935.5,
        -3856.699951171875,
        1321.5
      ],
      "bbox_max": [
        938.0,
        -3778.300048828125,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": -3484.203857421875,
      "bbox_min": [
        935.5,
        -3856.699951171875,
        1321.5
      ],
      "bbox_max": [
        938.0,
        -3787.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6747682690620422,
        -0.7380296587944031
      ],
      "plane_d": 3576.696044921875,
      "bbox_min": [
        935.5,
        -3855.234375,
        1321.5
      ],
      "bbox_max": [
        938.0,
        -3787.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        935.5,
        -3818.5,
        1321.5
      ],
      "bbox_max": [
        938.0,
        -3787.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3818.5,
      "bbox_min": [
        935.5,
        -3818.5,
        1321.5
      ],
      "bbox_max": [
        938.0,
        -3818.5,
        1322.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": 1403.60400390625,
      "bbox_min": [
        938.0,
        -3856.699951171875,
        1321.5
      ],
      "bbox_max": [
        946.0,
        -3778.300048828125,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": -3484.203857421875,
      "bbox_min": [
        938.0,
        -3856.699951171875,
        1321.5
      ],
      "bbox_max": [
        946.0,
        -3787.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6747682690620422,
        -0.7380296587944031
      ],
      "plane_d": 3576.696044921875,
      "bbox_min": [
        938.0,
        -3855.234375,
        1321.5
      ],
      "bbox_max": [
        946.0,
        -3787.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        938.0,
        -3787.5,
        1321.5
      ],
      "bbox_max": [
        946.0,
        -3787.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3770.5,
      "bbox_min": [
        935.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1321.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3864.5,
      "bbox_min": [
        935.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1321.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6747682690620422,
        -0.7380296587944031
      ],
      "plane_d": 3576.696044921875,
      "bbox_min": [
        935.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1321.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": -3484.203857421875,
      "bbox_min": [
        935.5,
        -3864.5,
        1315.0
      ],
      "bbox_max": [
        949.5,
        -3856.699951171875,
        1321.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": 1403.60400390625,
      "bbox_min": [
        935.5,
        -3863.0,
        1303.5
      ],
      "bbox_max": [
        949.5,
        -3770.5,
        1321.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        935.5,
        -3863.0,
        1303.5
      ],
      "bbox_max": [
        949.5,
        -3787.5,
        1321.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9983712434768677,
        0.0,
        -0.05704978480935097
      ],
      "plane_d": 1021.4906616210938,
      "bbox_min": [
        935.5,
        -3863.0,
        1303.5
      ],
      "bbox_max": [
        949.5,
        -3791.357177734375,
        1321.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3863.0,
      "bbox_min": [
        947.6428833007812,
        -3863.0,
        1303.5
      ],
      "bbox_max": [
        949.5,
        -3791.357177734375,
        1321.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9899495244026184,
        -0.1414213627576828
      ],
      "plane_d": -3578.526123046875,
      "bbox_min": [
        947.6428833007812,
        -3803.642822265625,
        1306.5
      ],
      "bbox_max": [
        949.5,
        -3791.357177734375,
        1321.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9899495244026184,
        -0.1414213627576828
      ],
      "plane_d": 3940.140625,
      "bbox_min": [
        947.6428833007812,
        -3793.5,
        1306.5
      ],
      "bbox_max": [
        949.5,
        -3791.357177734375,
        1321.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3863.0,
      "bbox_min": [
        935.5,
        -3863.0,
        1303.5
      ],
      "bbox_max": [
        948.6714477539062,
        -3863.0,
        1314.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.768221378326416,
        -0.6401844024658203,
        0.0
      ],
      "plane_d": -1756.473876953125,
      "bbox_min": [
        925.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        935.5,
        -3770.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.768221378326416,
        0.6401844024658203,
        0.0
      ],
      "plane_d": 3131.333984375,
      "bbox_min": [
        925.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        935.5,
        -3770.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6185574531555176,
        0.5301920771598816,
        -0.5798990726470947
      ],
      "plane_d": 2232.3095703125,
      "bbox_min": [
        925.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        935.5,
        -3770.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6092077493667603,
        -0.5076730847358704,
        0.6092077493667603
      ],
      "plane_d": -2194.0107421875,
      "bbox_min": [
        926.0624389648438,
        -3864.5,
        1312.495849609375
      ],
      "bbox_max": [
        935.5,
        -3853.699951171875,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": -3484.203857421875,
      "bbox_min": [
        934.0,
        -3864.5,
        1312.495849609375
      ],
      "bbox_max": [
        935.5,
        -3853.699951171875,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3864.5,
      "bbox_min": [
        934.0,
        -3864.5,
        1312.495849609375
      ],
      "bbox_max": [
        935.5,
        -3864.5,
        1315.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6092076897621155,
        0.5076730251312256,
        0.6092076897621155
      ],
      "plane_d": 1682.072998046875,
      "bbox_min": [
        925.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        935.5,
        -3770.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7592566013336182,
        0.650791347026825,
        0.0
      ],
      "plane_d": 1804.4818115234375,
      "bbox_min": [
        925.5,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        935.5,
        -3770.5,
        1324.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3864.5,
      "bbox_min": [
        934.0,
        -3864.5,
        1303.5
      ],
      "bbox_max": [
        935.5,
        -3864.5,
        1314.095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6747682690620422,
        -0.7380296587944031
      ],
      "plane_d": 3576.696044921875,
      "bbox_min": [
        925.5,
        -3863.0,
        1303.5
      ],
      "bbox_max": [
        935.5,
        -3770.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": 1403.60400390625,
      "bbox_min": [
        925.5,
        -3863.0,
        1303.5
      ],
      "bbox_max": [
        935.5,
        -3770.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3770.5,
      "bbox_min": [
        925.5,
        -3863.0,
        1303.5
      ],
      "bbox_max": [
        935.5,
        -3770.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1310.5999755859375,
      "bbox_min": [
        925.5,
        -3863.0,
        1303.5
      ],
      "bbox_max": [
        935.5,
        -3787.5,
        1324.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3825.099853515625,
      "bbox_min": [
        925.5,
        -3863.0,
        1310.5999755859375
      ],
      "bbox_max": [
        935.5,
        -3787.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3835.099853515625,
      "bbox_min": [
        925.5,
        -3863.0,
        1310.5999755859375
      ],
      "bbox_max": [
        935.5,
        -3825.099853515625,
        1314.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3863.0,
      "bbox_min": [
        925.5,
        -3863.0,
        1310.5999755859375
      ],
      "bbox_max": [
        935.5,
        -3835.099853515625,
        1314.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -4025.36962890625,
      "bbox_min": [
        927.2042846679688,
        -3852.199951171875,
        1310.5999755859375
      ],
      "bbox_max": [
        931.2518310546875,
        -3843.5,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1311.0,
      "bbox_min": [
        927.2042846679688,
        -3845.0,
        1311.0
      ],
      "bbox_max": [
        931.2518310546875,
        -3843.5,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -4031.630615234375,
      "bbox_min": [
        927.2042846679688,
        -3852.199951171875,
        1310.5999755859375
      ],
      "bbox_max": [
        931.2518310546875,
        -3850.300048828125,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271206855774,
        0.4472135603427887
      ],
      "plane_d": 2857.694580078125,
      "bbox_min": [
        927.2042846679688,
        -3852.0,
        1310.5999755859375
      ],
      "bbox_max": [
        931.2518310546875,
        -3850.300048828125,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1311.0,
      "bbox_min": [
        927.2042846679688,
        -3852.0,
        1311.0
      ],
      "bbox_max": [
        931.2518310546875,
        -3850.5,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3835.89990234375,
      "bbox_min": [
        926.427734375,
        -3838.0,
        1310.5999755859375
      ],
      "bbox_max": [
        931.61865234375,
        -3835.099853515625,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1311.4000244140625,
      "bbox_min": [
        926.427734375,
        -3835.89990234375,
        1311.4000244140625
      ],
      "bbox_max": [
        931.61865234375,
        -3835.099853515625,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4345989525318146,
        -0.0,
        0.9006240963935852
      ],
      "plane_d": -1586.0067138671875,
      "bbox_min": [
        926.427734375,
        -3835.89990234375,
        1311.4530029296875
      ],
      "bbox_max": [
        931.61865234375,
        -3835.099853515625,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.777115523815155,
        0.0,
        0.6293579936027527
      ],
      "plane_d": -105.64801025390625,
      "bbox_min": [
        926.427734375,
        -3835.89990234375,
        1311.796142578125
      ],
      "bbox_max": [
        927.6865234375,
        -3835.099853515625,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3838.0,
      "bbox_min": [
        926.427734375,
        -3838.0,
        1310.5999755859375
      ],
      "bbox_max": [
        931.61865234375,
        -3835.89990234375,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4345989525318146,
        -0.0,
        0.9006240963935852
      ],
      "plane_d": -1586.0067138671875,
      "bbox_min": [
        926.427734375,
        -3838.0,
        1311.4530029296875
      ],
      "bbox_max": [
        931.61865234375,
        -3835.89990234375,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.777115523815155,
        0.0,
        0.6293579936027527
      ],
      "plane_d": -105.64801025390625,
      "bbox_min": [
        926.427734375,
        -3838.0,
        1311.796142578125
      ],
      "bbox_max": [
        927.6865234375,
        -3835.89990234375,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271206855774,
        0.4472135603427887
      ],
      "plane_d": 2851.43359375,
      "bbox_min": [
        925.5,
        -3852.199951171875,
        1310.5999755859375
      ],
      "bbox_max": [
        927.5945434570312,
        -3835.099853515625,
        1311.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1311.0,
      "bbox_min": [
        926.0,
        -3845.0,
        1311.0
      ],
      "bbox_max": [
        927.2042846679688,
        -3843.5,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -4031.630615234375,
      "bbox_min": [
        925.7999877929688,
        -3852.199951171875,
        1310.5999755859375
      ],
      "bbox_max": [
        927.5945434570312,
        -3850.300048828125,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271206855774,
        0.4472135603427887
      ],
      "plane_d": 2857.694580078125,
      "bbox_min": [
        925.7999877929688,
        -3852.0,
        1310.5999755859375
      ],
      "bbox_max": [
        927.5945434570312,
        -3850.300048828125,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1311.0,
      "bbox_min": [
        926.0,
        -3852.0,
        1311.0
      ],
      "bbox_max": [
        927.2042846679688,
        -3850.5,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3835.89990234375,
      "bbox_min": [
        925.5,
        -3835.89990234375,
        1310.5999755859375
      ],
      "bbox_max": [
        927.594482421875,
        -3835.099853515625,
        1311.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1311.4000244140625,
      "bbox_min": [
        925.5,
        -3835.89990234375,
        1311.4000244140625
      ],
      "bbox_max": [
        926.8140258789062,
        -3835.099853515625,
        1311.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271206855774,
        0.4472135603427887
      ],
      "plane_d": 2851.43359375,
      "bbox_min": [
        930.927978515625,
        -3852.199951171875,
        1310.5999755859375
      ],
      "bbox_max": [
        933.7000122070312,
        -3843.300048828125,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -4025.36962890625,
      "bbox_min": [
        930.927978515625,
        -3852.199951171875,
        1310.5999755859375
      ],
      "bbox_max": [
        933.7000122070312,
        -3843.5,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3999907076358795,
        -0.799981415271759,
        0.4472552537918091
      ],
      "plane_d": -4035.424072265625,
      "bbox_min": [
        931.2518310546875,
        -3845.199951171875,
        1310.5999755859375
      ],
      "bbox_max": [
        933.7000122070312,
        -3843.5,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1311.0,
      "bbox_min": [
        931.2518310546875,
        -3845.0,
        1311.0
      ],
      "bbox_max": [
        933.5,
        -3843.5,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -4031.630615234375,
      "bbox_min": [
        930.927978515625,
        -3852.199951171875,
        1310.5999755859375
      ],
      "bbox_max": [
        933.7000122070312,
        -3850.300048828125,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -1421.244873046875,
      "bbox_min": [
        931.2518310546875,
        -3852.199951171875,
        1310.5999755859375
      ],
      "bbox_max": [
        933.7000122070312,
        -3850.5,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3999907076358795,
        -0.799981415271759,
        0.4472552537918091
      ],
      "plane_d": -4041.02392578125,
      "bbox_min": [
        931.2518310546875,
        -3852.199951171875,
        1310.5999755859375
      ],
      "bbox_max": [
        933.7000122070312,
        -3850.5,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1311.0,
      "bbox_min": [
        931.2518310546875,
        -3852.0,
        1311.0
      ],
      "bbox_max": [
        933.5,
        -3850.5,
        1311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7771530747413635,
        0.0,
        -0.6293116211891174
      ],
      "plane_d": 101.30230712890625,
      "bbox_min": [
        925.5,
        -3835.099853515625,
        1310.5999755859375
      ],
      "bbox_max": [
        931.61865234375,
        -3825.099853515625,
        1313.3504638671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.777115523815155,
        0.0,
        0.6293579936027527
      ],
      "plane_d": -105.64801025390625,
      "bbox_min": [
        926.427734375,
        -3835.099853515625,
        1311.796142578125
      ],
      "bbox_max": [
        927.6865234375,
        -3833.5,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3825.89990234375,
      "bbox_min": [
        926.427734375,
        -3828.0,
        1310.5999755859375
      ],
      "bbox_max": [
        931.61865234375,
        -3825.099853515625,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1311.4000244140625,
      "bbox_min": [
        926.427734375,
        -3825.89990234375,
        1311.4000244140625
      ],
      "bbox_max": [
        931.61865234375,
        -3825.099853515625,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4345989525318146,
        -0.0,
        0.9006240963935852
      ],
      "plane_d": -1586.0067138671875,
      "bbox_min": [
        926.427734375,
        -3825.89990234375,
        1311.4530029296875
      ],
      "bbox_max": [
        931.61865234375,
        -3825.099853515625,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.777115523815155,
        0.0,
        0.6293579936027527
      ],
      "plane_d": -105.64801025390625,
      "bbox_min": [
        926.427734375,
        -3825.89990234375,
        1311.796142578125
      ],
      "bbox_max": [
        927.6865234375,
        -3825.099853515625,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3828.0,
      "bbox_min": [
        926.427734375,
        -3828.0,
        1310.5999755859375
      ],
      "bbox_max": [
        931.61865234375,
        -3825.89990234375,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4345989525318146,
        -0.0,
        0.9006240963935852
      ],
      "plane_d": -1586.0067138671875,
      "bbox_min": [
        926.427734375,
        -3828.0,
        1311.4530029296875
      ],
      "bbox_max": [
        931.61865234375,
        -3825.89990234375,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.777115523815155,
        0.0,
        0.6293579936027527
      ],
      "plane_d": -105.64801025390625,
      "bbox_min": [
        926.427734375,
        -3828.0,
        1311.796142578125
      ],
      "bbox_max": [
        927.6865234375,
        -3825.89990234375,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3825.89990234375,
      "bbox_min": [
        925.5,
        -3825.89990234375,
        1310.5999755859375
      ],
      "bbox_max": [
        927.594482421875,
        -3825.099853515625,
        1311.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1311.4000244140625,
      "bbox_min": [
        925.5,
        -3825.89990234375,
        1311.4000244140625
      ],
      "bbox_max": [
        926.8140258789062,
        -3825.099853515625,
        1311.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3814.5,
      "bbox_min": [
        925.5,
        -3825.099853515625,
        1310.5999755859375
      ],
      "bbox_max": [
        935.5,
        -3787.5,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7771530747413635,
        0.0,
        -0.6293116211891174
      ],
      "plane_d": 101.30230712890625,
      "bbox_min": [
        925.5,
        -3825.099853515625,
        1310.5999755859375
      ],
      "bbox_max": [
        931.61865234375,
        -3814.5,
        1313.3504638671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.777115523815155,
        0.0,
        0.6293579936027527
      ],
      "plane_d": -105.64801025390625,
      "bbox_min": [
        926.427734375,
        -3825.099853515625,
        1311.796142578125
      ],
      "bbox_max": [
        927.6865234375,
        -3823.5,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3815.300048828125,
      "bbox_min": [
        926.427734375,
        -3817.5,
        1310.5999755859375
      ],
      "bbox_max": [
        931.61865234375,
        -3814.5,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1311.4000244140625,
      "bbox_min": [
        926.427734375,
        -3815.300048828125,
        1311.4000244140625
      ],
      "bbox_max": [
        931.61865234375,
        -3814.5,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4345989525318146,
        -0.0,
        0.9006240963935852
      ],
      "plane_d": -1586.0067138671875,
      "bbox_min": [
        926.427734375,
        -3815.300048828125,
        1311.4530029296875
      ],
      "bbox_max": [
        931.61865234375,
        -3814.5,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.777115523815155,
        0.0,
        0.6293579936027527
      ],
      "plane_d": -105.64801025390625,
      "bbox_min": [
        926.427734375,
        -3815.300048828125,
        1311.796142578125
      ],
      "bbox_max": [
        927.6865234375,
        -3814.5,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3817.5,
      "bbox_min": [
        926.427734375,
        -3817.5,
        1310.5999755859375
      ],
      "bbox_max": [
        931.61865234375,
        -3815.300048828125,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4345989525318146,
        -0.0,
        0.9006240963935852
      ],
      "plane_d": -1586.0067138671875,
      "bbox_min": [
        926.427734375,
        -3817.5,
        1311.4530029296875
      ],
      "bbox_max": [
        931.61865234375,
        -3815.300048828125,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.777115523815155,
        0.0,
        0.6293579936027527
      ],
      "plane_d": -105.64801025390625,
      "bbox_min": [
        926.427734375,
        -3817.5,
        1311.796142578125
      ],
      "bbox_max": [
        927.6865234375,
        -3815.300048828125,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3815.300048828125,
      "bbox_min": [
        925.5,
        -3815.300048828125,
        1310.5999755859375
      ],
      "bbox_max": [
        927.594482421875,
        -3814.5,
        1311.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1311.4000244140625,
      "bbox_min": [
        925.5,
        -3815.300048828125,
        1311.4000244140625
      ],
      "bbox_max": [
        926.8140258789062,
        -3814.5,
        1311.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        925.5,
        -3814.5,
        1310.5999755859375
      ],
      "bbox_max": [
        935.5,
        -3787.5,
        1324.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.4345989525318146,
        -0.0,
        0.9006240963935852
      ],
      "plane_d": -1586.0067138671875,
      "bbox_min": [
        926.427734375,
        -3814.5,
        1311.4530029296875
      ],
      "bbox_max": [
        931.61865234375,
        -3813.0,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.777115523815155,
        0.0,
        0.6293579936027527
      ],
      "plane_d": -105.64801025390625,
      "bbox_min": [
        926.427734375,
        -3814.5,
        1311.796142578125
      ],
      "bbox_max": [
        927.6865234375,
        -3813.0,
        1313.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3787.5,
      "bbox_min": [
        925.5,
        -3863.0,
        1303.5
      ],
      "bbox_max": [
        935.5,
        -3787.5,
        1310.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3863.0,
      "bbox_min": [
        925.5,
        -3863.0,
        1303.5
      ],
      "bbox_max": [
        935.5,
        -3813.0,
        1310.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7771530747413635,
        0.0,
        -0.6293116211891174
      ],
      "plane_d": 101.30230712890625,
      "bbox_min": [
        925.5,
        -3852.5,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3813.0,
        1310.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7158097624778748,
        0.0,
        -0.6982952952384949
      ],
      "plane_d": 1579.1669921875,
      "bbox_min": [
        925.5,
        -3852.5,
        1303.89697265625
      ],
      "bbox_max": [
        930.927978515625,
        -3813.0,
        1310.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3823.5,
      "bbox_min": [
        927.5945434570312,
        -3852.5,
        1308.7327880859375
      ],
      "bbox_max": [
        930.927978515625,
        -3813.0,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3833.5,
      "bbox_min": [
        927.5945434570312,
        -3852.5,
        1308.7327880859375
      ],
      "bbox_max": [
        930.927978515625,
        -3828.0,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271206855774,
        0.4472135603427887
      ],
      "plane_d": 2851.43359375,
      "bbox_min": [
        927.5945434570312,
        -3852.5,
        1308.7327880859375
      ],
      "bbox_max": [
        930.927978515625,
        -3838.0,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3843.0,
      "bbox_min": [
        927.5945434570312,
        -3852.5,
        1308.7327880859375
      ],
      "bbox_max": [
        930.927978515625,
        -3843.0,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.5,
      "bbox_min": [
        928.1797485351562,
        -3845.5,
        1308.7327880859375
      ],
      "bbox_max": [
        930.4420166015625,
        -3845.5,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3852.5,
      "bbox_min": [
        928.1797485351562,
        -3852.5,
        1308.7327880859375
      ],
      "bbox_max": [
        930.4420166015625,
        -3850.0,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3850.0,
      "bbox_min": [
        928.1797485351562,
        -3850.0,
        1308.7327880859375
      ],
      "bbox_max": [
        930.4420166015625,
        -3850.0,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3838.0,
      "bbox_min": [
        927.5946044921875,
        -3838.0,
        1308.73291015625
      ],
      "bbox_max": [
        930.9279174804688,
        -3838.0,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3828.0,
      "bbox_min": [
        927.5946044921875,
        -3828.0,
        1308.73291015625
      ],
      "bbox_max": [
        930.9279174804688,
        -3828.0,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3813.0,
      "bbox_min": [
        927.5946044921875,
        -3817.5,
        1308.73291015625
      ],
      "bbox_max": [
        930.9279174804688,
        -3813.0,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3817.5,
      "bbox_min": [
        927.5946044921875,
        -3817.5,
        1308.73291015625
      ],
      "bbox_max": [
        930.9279174804688,
        -3817.5,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3843.0,
      "bbox_min": [
        925.5,
        -3852.5,
        1303.89697265625
      ],
      "bbox_max": [
        929.4158935546875,
        -3843.0,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.5,
      "bbox_min": [
        925.5,
        -3845.5,
        1303.89697265625
      ],
      "bbox_max": [
        929.4158935546875,
        -3845.5,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3852.5,
      "bbox_min": [
        925.5,
        -3852.5,
        1303.89697265625
      ],
      "bbox_max": [
        929.4158935546875,
        -3850.0,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4000256359577179,
        0.8000512719154358,
        0.447098970413208
      ],
      "plane_d": 2115.67333984375,
      "bbox_min": [
        925.5,
        -3852.5,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3843.0,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        0.8944272994995117,
        -0.0
      ],
      "plane_d": 3020.033935546875,
      "bbox_min": [
        925.5,
        -3852.5,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3843.0,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3843.0,
      "bbox_min": [
        925.5,
        -3852.5,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3843.0,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -4025.36962890625,
      "bbox_min": [
        925.5,
        -3852.5,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3843.5,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3999907076358795,
        -0.799981415271759,
        0.4472552537918091
      ],
      "plane_d": -4035.424072265625,
      "bbox_min": [
        925.5,
        -3845.5,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3843.5,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        -0.8944272994995117,
        0.0
      ],
      "plane_d": -3856.7705078125,
      "bbox_min": [
        925.5,
        -3845.5,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3843.5,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3845.5,
      "bbox_min": [
        925.5,
        -3845.5,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3843.5,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -934.0,
      "bbox_min": [
        934.0,
        -3845.0,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3843.5,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -4031.630615234375,
      "bbox_min": [
        925.5,
        -3852.5,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3850.0,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -1421.244873046875,
      "bbox_min": [
        925.5,
        -3852.5,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3850.0,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3999907076358795,
        -0.799981415271759,
        0.4472552537918091
      ],
      "plane_d": -4041.02392578125,
      "bbox_min": [
        925.5,
        -3852.5,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3850.0,
        1310.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        0.8944272994995117,
        -0.0
      ],
      "plane_d": 3026.294921875,
      "bbox_min": [
        925.5,
        -3852.5,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3850.0,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        -0.8944272994995117,
        0.0
      ],
      "plane_d": -3863.031494140625,
      "bbox_min": [
        925.5,
        -3852.5,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3850.0,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3852.5,
      "bbox_min": [
        925.5,
        -3852.5,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3850.0,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -934.0,
      "bbox_min": [
        925.5,
        -3852.0,
        1303.5
      ],
      "bbox_max": [
        934.0,
        -3850.0,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3850.0,
      "bbox_min": [
        925.5,
        -3850.0,
        1303.5
      ],
      "bbox_max": [
        933.0,
        -3850.0,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1305.0,
      "bbox_min": [
        978.5,
        -3797.0,
        1303.5
      ],
      "bbox_max": [
        983.5,
        -3791.5,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -983.5,
      "bbox_min": [
        978.5,
        -3797.0,
        1303.5
      ],
      "bbox_max": [
        983.5,
        -3791.5,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3791.5,
      "bbox_min": [
        978.5,
        -3797.0,
        1303.5
      ],
      "bbox_max": [
        983.5,
        -3791.5,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3797.0,
      "bbox_min": [
        978.5,
        -3797.0,
        1303.5
      ],
      "bbox_max": [
        983.5,
        -3797.0,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9998886585235596,
        -0.0,
        0.01492371130734682
      ],
      "plane_d": -934.2691040039062,
      "bbox_min": [
        912.5000610351562,
        -3787.41796875,
        1303.5
      ],
      "bbox_max": [
        914.9179077148438,
        -3784.58203125,
        1305.88232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9998886585235596,
        0.01492371130734682
      ],
      "plane_d": 3764.70751953125,
      "bbox_min": [
        912.5000610351562,
        -3787.41796875,
        1303.5
      ],
      "bbox_max": [
        914.9179077148438,
        -3784.58203125,
        1305.88232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -892.5,
      "bbox_min": [
        892.5,
        -3982.5,
        1303.5
      ],
      "bbox_max": [
        892.5,
        -3975.0,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5198025107383728,
        -0.5522071123123169,
        -0.6518226265907288
      ],
      "plane_d": -1734.3382568359375,
      "bbox_min": [
        869.8992309570312,
        -3875.85546875,
        1307.7818603515625
      ],
      "bbox_max": [
        905.0226440429688,
        -3820.4677734375,
        1344.5704345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33148935437202454,
        -0.5522053241729736,
        -0.7649732828140259
      ],
      "plane_d": -1417.9088134765625,
      "bbox_min": [
        869.8992309570312,
        -3875.85546875,
        1307.7818603515625
      ],
      "bbox_max": [
        905.0226440429688,
        -3820.4677734375,
        1344.5704345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6937717795372009,
        -0.468140184879303,
        -0.5472891330718994
      ],
      "plane_d": -1703.802490234375,
      "bbox_min": [
        869.8992309570312,
        -3875.85546875,
        1307.7818603515625
      ],
      "bbox_max": [
        905.0226440429688,
        -3820.4677734375,
        1344.5704345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5873504877090454,
        -0.7066451907157898,
        0.3945527970790863
      ],
      "plane_d": -3757.26904296875,
      "bbox_min": [
        869.8992309570312,
        -3875.85546875,
        1307.7818603515625
      ],
      "bbox_max": [
        905.0226440429688,
        -3820.4677734375,
        1344.5704345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6241137981414795,
        0.7066444754600525,
        -0.33337000012397766
      ],
      "plane_d": 3706.0908203125,
      "bbox_min": [
        869.8992309570312,
        -3860.531982421875,
        1307.7818603515625
      ],
      "bbox_max": [
        892.3897705078125,
        -3820.4677734375,
        1343.3607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6241137981414795,
        -0.7066444754600525,
        -0.33337002992630005
      ],
      "plane_d": -1721.6453857421875,
      "bbox_min": [
        870.2333984375,
        -3860.531982421875,
        1310.1973876953125
      ],
      "bbox_max": [
        892.3897705078125,
        -3838.0498046875,
        1343.3607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5379993319511414,
        0.1949409544467926,
        -0.8200942873954773
      ],
      "plane_d": 1347.471435546875,
      "bbox_min": [
        887.9554443359375,
        -3842.9501953125,
        1313.5301513671875
      ],
      "bbox_max": [
        892.3897705078125,
        -3838.0498046875,
        1316.465087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6718602776527405,
        0.03878645598888397,
        -0.7396615743637085
      ],
      "plane_d": 522.832763671875,
      "bbox_min": [
        887.9554443359375,
        -3842.9501953125,
        1313.5301513671875
      ],
      "bbox_max": [
        892.3897705078125,
        -3838.0498046875,
        1316.465087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5379992127418518,
        -0.1949385702610016,
        -0.8200950622558594
      ],
      "plane_d": -149.85986328125,
      "bbox_min": [
        887.9554443359375,
        -3842.9501953125,
        1313.5301513671875
      ],
      "bbox_max": [
        892.3897705078125,
        -3838.0498046875,
        1316.465087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4715118110179901,
        -0.19493846595287323,
        -0.8600439429283142
      ],
      "plane_d": -38.141845703125,
      "bbox_min": [
        887.9554443359375,
        -3842.9501953125,
        1313.5301513671875
      ],
      "bbox_max": [
        892.3897705078125,
        -3838.0498046875,
        1316.465087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4715111553668976,
        0.19494083523750305,
        -0.8600438237190247
      ],
      "plane_d": 1459.18994140625,
      "bbox_min": [
        887.9554443359375,
        -3842.92529296875,
        1313.5301513671875
      ],
      "bbox_max": [
        892.3897705078125,
        -3838.0498046875,
        1316.465087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.67186039686203,
        -0.038785167038440704,
        -0.7396616339683533
      ],
      "plane_d": 224.91888427734375,
      "bbox_min": [
        887.9554443359375,
        -3842.92529296875,
        1313.5301513671875
      ],
      "bbox_max": [
        892.3897705078125,
        -3838.0751953125,
        1316.465087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4101139307022095,
        0.1652708202600479,
        -0.8969348073005676
      ],
      "plane_d": 1448.4075927734375,
      "bbox_min": [
        887.9554443359375,
        -3842.92529296875,
        1313.5301513671875
      ],
      "bbox_max": [
        892.1132202148438,
        -3838.0751953125,
        1316.465087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36310628056526184,
        0.11042936891317368,
        -0.9251806735992432
      ],
      "plane_d": 1316.77685546875,
      "bbox_min": [
        887.9554443359375,
        -3842.92529296875,
        1313.5301513671875
      ],
      "bbox_max": [
        892.1132202148438,
        -3838.0751953125,
        1316.465087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3376634418964386,
        0.038769595324993134,
        -0.9404681921005249
      ],
      "plane_d": 1084.31884765625,
      "bbox_min": [
        887.9554443359375,
        -3842.92529296875,
        1313.5301513671875
      ],
      "bbox_max": [
        892.1132202148438,
        -3838.0751953125,
        1316.465087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.537996232509613,
        0.19495174288749695,
        0.8200937509536743
      ],
      "plane_d": 149.4195556640625,
      "bbox_min": [
        887.9554443359375,
        -3842.92529296875,
        1313.5301513671875
      ],
      "bbox_max": [
        892.1132202148438,
        -3838.0751953125,
        1316.465087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464272141456604,
        0.11041920632123947,
        -0.7549433708190918
      ],
      "plane_d": 840.6734619140625,
      "bbox_min": [
        888.3880004882812,
        -3842.236572265625,
        1313.6102294921875
      ],
      "bbox_max": [
        891.8365478515625,
        -3839.243408203125,
        1315.5892333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3376634418964386,
        -0.03876829519867897,
        -0.9404681324958801
      ],
      "plane_d": 786.5344848632812,
      "bbox_min": [
        888.3880004882812,
        -3842.236572265625,
        1313.6102294921875
      ],
      "bbox_max": [
        891.83642578125,
        -3840.5,
        1315.589111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5994213819503784,
        -0.1652565449476242,
        -0.7831885814666748
      ],
      "plane_d": -139.0738525390625,
      "bbox_min": [
        889.3093872070312,
        -3842.236572265625,
        1314.0377197265625
      ],
      "bbox_max": [
        891.83642578125,
        -3840.5,
        1315.589111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464263796806335,
        -0.11041845381259918,
        -0.7549442052841187
      ],
      "plane_d": -7.45172119140625,
      "bbox_min": [
        889.3093872070312,
        -3842.236572265625,
        1314.0377197265625
      ],
      "bbox_max": [
        891.83642578125,
        -3840.5,
        1315.589111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41011515259742737,
        -0.16526910662651062,
        -0.8969345688819885
      ],
      "plane_d": 178.967529296875,
      "bbox_min": [
        889.3093872070312,
        -3842.236572265625,
        1314.0377197265625
      ],
      "bbox_max": [
        890.54052734375,
        -3840.5,
        1314.374267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5994143486022949,
        0.1652730256319046,
        0.7831904292106628
      ],
      "plane_d": 138.638671875,
      "bbox_min": [
        887.9554443359375,
        -3842.92529296875,
        1313.5301513671875
      ],
      "bbox_max": [
        892.1132202148438,
        -3838.0751953125,
        1316.465087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464272141456604,
        0.11041920632123947,
        -0.7549433708190918
      ],
      "plane_d": 840.6734619140625,
      "bbox_min": [
        890.8473510742188,
        -3839.498046875,
        1314.874267578125
      ],
      "bbox_max": [
        891.6030883789062,
        -3839.01806640625,
        1315.4306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5994221568107605,
        0.1652582436800003,
        -0.7831876873970032
      ],
      "plane_d": 1130.2662353515625,
      "bbox_min": [
        890.90234375,
        -3839.018310546875,
        1314.9638671875
      ],
      "bbox_max": [
        891.1907958984375,
        -3838.763427734375,
        1315.1846923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6464234590530396,
        -0.11043132096529007,
        0.7549448609352112
      ],
      "plane_d": -841.2152099609375,
      "bbox_min": [
        887.9554443359375,
        -3842.92529296875,
        1313.5301513671875
      ],
      "bbox_max": [
        891.5657348632812,
        -3838.0751953125,
        1316.005126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5994108319282532,
        -0.165276899933815,
        0.7831922173500061
      ],
      "plane_d": -1130.843994140625,
      "bbox_min": [
        887.9554443359375,
        -3842.92529296875,
        1313.5301513671875
      ],
      "bbox_max": [
        891.1492919921875,
        -3838.0751953125,
        1315.7222900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3631051480770111,
        0.11043810844421387,
        0.9251800775527954
      ],
      "plane_d": -469.0255126953125,
      "bbox_min": [
        887.9554443359375,
        -3842.92529296875,
        1313.5301513671875
      ],
      "bbox_max": [
        890.7028198242188,
        -3838.0751953125,
        1315.4866943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3376634418964386,
        -0.03876829519867897,
        -0.9404681324958801
      ],
      "plane_d": 786.5344848632812,
      "bbox_min": [
        888.1893310546875,
        -3840.713134765625,
        1313.5301513671875
      ],
      "bbox_max": [
        888.5291748046875,
        -3840.5,
        1313.652099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5380017161369324,
        -0.19495171308517456,
        0.8200902342796326
      ],
      "plane_d": -1347.9951171875,
      "bbox_min": [
        887.9554443359375,
        -3841.212158203125,
        1313.967041015625
      ],
      "bbox_max": [
        890.7028198242188,
        -3838.0751953125,
        1315.4866943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4715152382850647,
        -0.1949509084224701,
        0.860039234161377
      ],
      "plane_d": -1459.7088623046875,
      "bbox_min": [
        887.9554443359375,
        -3841.212158203125,
        1313.967041015625
      ],
      "bbox_max": [
        890.283203125,
        -3838.0751953125,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.410110205411911,
        -0.1652764081954956,
        0.8969355821609497
      ],
      "plane_d": -1448.9232177734375,
      "bbox_min": [
        887.9554443359375,
        -3841.212158203125,
        1313.967041015625
      ],
      "bbox_max": [
        890.283203125,
        -3838.78076171875,
        1314.8028564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3631051182746887,
        -0.11043811589479446,
        0.9251800775527954
      ],
      "plane_d": -1317.3006591796875,
      "bbox_min": [
        887.9554443359375,
        -3841.212158203125,
        1313.967041015625
      ],
      "bbox_max": [
        890.283203125,
        -3839.283447265625,
        1314.8028564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33766084909439087,
        -0.038774434477090836,
        0.9404688477516174
      ],
      "plane_d": -1084.83056640625,
      "bbox_min": [
        887.9554443359375,
        -3841.212158203125,
        1313.967041015625
      ],
      "bbox_max": [
        890.283203125,
        -3839.787841796875,
        1314.8028564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33766087889671326,
        0.03877443075180054,
        0.9404689073562622
      ],
      "plane_d": -787.0042724609375,
      "bbox_min": [
        887.9554443359375,
        -3841.212158203125,
        1313.967041015625
      ],
      "bbox_max": [
        890.283203125,
        -3840.5,
        1314.8028564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41011515259742737,
        -0.16526910662651062,
        -0.8969345688819885
      ],
      "plane_d": 178.967529296875,
      "bbox_min": [
        870.2333984375,
        -3860.531982421875,
        1310.1973876953125
      ],
      "bbox_max": [
        890.28955078125,
        -3840.5,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3631073832511902,
        -0.110428586602211,
        -0.9251802563667297
      ],
      "plane_d": 468.57025146484375,
      "bbox_min": [
        870.2333984375,
        -3860.531982421875,
        1310.1973876953125
      ],
      "bbox_max": [
        890.28955078125,
        -3840.5,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4101068675518036,
        0.16527250409126282,
        0.8969377875328064
      ],
      "plane_d": -179.4560546875,
      "bbox_min": [
        870.2333984375,
        -3860.531982421875,
        1310.1973876953125
      ],
      "bbox_max": [
        890.28955078125,
        -3840.5,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1575266718864441,
        -0.46814268827438354,
        -0.8694985508918762
      ],
      "plane_d": -802.760009765625,
      "bbox_min": [
        875.451416015625,
        -3855.68359375,
        1310.1973876953125
      ],
      "bbox_max": [
        878.1557006835938,
        -3852.661865234375,
        1311.5841064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024375267326831818,
        -0.312801331281662,
        -0.9495057463645935
      ],
      "plane_d": 17.5645751953125,
      "bbox_min": [
        875.1987915039062,
        -3854.78369140625,
        1310.369140625
      ],
      "bbox_max": [
        875.9702758789062,
        -3853.241455078125,
        1310.8905029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1575266718864441,
        -0.46814268827438354,
        -0.8694985508918762
      ],
      "plane_d": -802.760009765625,
      "bbox_min": [
        870.2333984375,
        -3860.531982421875,
        1310.4271240234375
      ],
      "bbox_max": [
        877.1245727539062,
        -3853.437255859375,
        1312.96923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024375267326831818,
        -0.312801331281662,
        -0.9495057463645935
      ],
      "plane_d": 17.5645751953125,
      "bbox_min": [
        870.2333984375,
        -3859.013916015625,
        1310.4271240234375
      ],
      "bbox_max": [
        875.9702758789062,
        -3853.437255859375,
        1312.13818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47152096033096313,
        0.19495095312595367,
        0.8600360155105591
      ],
      "plane_d": 37.718505859375,
      "bbox_min": [
        886.3081665039062,
        -3844.605712890625,
        1313.44580078125
      ],
      "bbox_max": [
        890.0347290039062,
        -3840.5,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33766087889671326,
        0.03877443075180054,
        0.9404689073562622
      ],
      "plane_d": -787.0042724609375,
      "bbox_min": [
        886.3081665039062,
        -3842.200927734375,
        1313.44580078125
      ],
      "bbox_max": [
        888.6189575195312,
        -3840.5,
        1314.2347412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8571716547012329,
        2.051517367362976e-05,
        -0.5150308609008789
      ],
      "plane_d": 1434.46826171875,
      "bbox_min": [
        884.62841796875,
        -3846.400146484375,
        1312.4095458984375
      ],
      "bbox_max": [
        884.8380126953125,
        -3843.98828125,
        1312.7581787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8571716547012329,
        2.051517367362976e-05,
        -0.5150308609008789
      ],
      "plane_d": 1434.46826171875,
      "bbox_min": [
        884.602294921875,
        -3846.699951171875,
        1310.478271484375
      ],
      "bbox_max": [
        887.906005859375,
        -3843.87451171875,
        1313.6805419921875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3846.699951171875,
      "bbox_min": [
        884.602294921875,
        -3846.699951171875,
        1310.478271484375
      ],
      "bbox_max": [
        887.906005859375,
        -3846.699951171875,
        1313.6805419921875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.024374594911932945,
        0.3127957284450531,
        -0.9495076537132263
      ],
      "plane_d": 2420.17333984375,
      "bbox_min": [
        869.8992309570312,
        -3857.284912109375,
        1307.7818603515625
      ],
      "bbox_max": [
        890.2894897460938,
        -3820.4677734375,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36310628056526184,
        0.11042936891317368,
        -0.9251806735992432
      ],
      "plane_d": 1316.77685546875,
      "bbox_min": [
        869.8992309570312,
        -3857.284912109375,
        1307.7818603515625
      ],
      "bbox_max": [
        890.2894897460938,
        -3820.4677734375,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4101139307022095,
        0.1652708202600479,
        -0.8969348073005676
      ],
      "plane_d": 1448.4075927734375,
      "bbox_min": [
        869.8992309570312,
        -3857.284912109375,
        1307.7818603515625
      ],
      "bbox_max": [
        890.2894897460938,
        -3820.4677734375,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3376634418964386,
        0.038769595324993134,
        -0.9404681921005249
      ],
      "plane_d": 1084.31884765625,
      "bbox_min": [
        869.8992309570312,
        -3857.284912109375,
        1307.7818603515625
      ],
      "bbox_max": [
        890.2894897460938,
        -3820.4677734375,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3376634418964386,
        -0.03876829519867897,
        -0.9404681324958801
      ],
      "plane_d": 786.5344848632812,
      "bbox_min": [
        869.8992309570312,
        -3857.284912109375,
        1307.7818603515625
      ],
      "bbox_max": [
        890.2894897460938,
        -3820.4677734375,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3631073832511902,
        -0.110428586602211,
        -0.9251802563667297
      ],
      "plane_d": 468.57025146484375,
      "bbox_min": [
        869.8992309570312,
        -3857.284912109375,
        1307.7818603515625
      ],
      "bbox_max": [
        890.2894897460938,
        -3820.4677734375,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3631051182746887,
        -0.11043811589479446,
        0.9251800775527954
      ],
      "plane_d": -1317.3006591796875,
      "bbox_min": [
        869.8992309570312,
        -3857.284912109375,
        1307.7818603515625
      ],
      "bbox_max": [
        890.2894897460938,
        -3820.4677734375,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15753163397312164,
        0.4681376516819,
        -0.8695003390312195
      ],
      "plane_d": 2793.02294921875,
      "bbox_min": [
        872.217041015625,
        -3839.49609375,
        1307.884765625
      ],
      "bbox_max": [
        890.2894897460938,
        -3825.50341796875,
        1314.7919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4715111553668976,
        0.19494083523750305,
        -0.8600438237190247
      ],
      "plane_d": 1459.18994140625,
      "bbox_min": [
        888.6077270507812,
        -3838.763427734375,
        1314.2548828125
      ],
      "bbox_max": [
        890.2894897460938,
        -3836.351806640625,
        1314.7919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04768304154276848,
        -0.10983971506357193,
        -0.9928048849105835
      ],
      "plane_d": 918.1209716796875,
      "bbox_min": [
        869.8992309570312,
        -3857.284912109375,
        1307.7818603515625
      ],
      "bbox_max": [
        890.0347290039062,
        -3820.738525390625,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024375267326831818,
        -0.312801331281662,
        -0.9495057463645935
      ],
      "plane_d": 17.5645751953125,
      "bbox_min": [
        869.9437255859375,
        -3857.284912109375,
        1308.2762451171875
      ],
      "bbox_max": [
        890.0347290039062,
        -3820.738525390625,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.023941127583384514,
        0.31303927302360535,
        0.9494383335113525
      ],
      "plane_d": -17.4273681640625,
      "bbox_min": [
        869.9437255859375,
        -3857.042724609375,
        1308.2762451171875
      ],
      "bbox_max": [
        890.0347290039062,
        -3820.738525390625,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15718364715576172,
        -0.4684928059577942,
        0.8693721294403076
      ],
      "plane_d": -2795.00634765625,
      "bbox_min": [
        869.9437255859375,
        -3847.749267578125,
        1308.2762451171875
      ],
      "bbox_max": [
        890.0347290039062,
        -3820.738525390625,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0481853149831295,
        -0.10992397367954254,
        0.9927712678909302
      ],
      "plane_d": -1763.0047607421875,
      "bbox_min": [
        869.9437255859375,
        -3847.749267578125,
        1308.2762451171875
      ],
      "bbox_max": [
        890.0347290039062,
        -3826.2001953125,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4715152382850647,
        -0.1949509084224701,
        0.860039234161377
      ],
      "plane_d": -1459.7088623046875,
      "bbox_min": [
        872.10498046875,
        -3847.749267578125,
        1308.2762451171875
      ],
      "bbox_max": [
        890.0347290039062,
        -3826.2001953125,
        1315.21630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33766084909439087,
        -0.038774434477090836,
        0.9404688477516174
      ],
      "plane_d": -1084.83056640625,
      "bbox_min": [
        872.10498046875,
        -3847.749267578125,
        1308.2762451171875
      ],
      "bbox_max": [
        888.6188354492188,
        -3833.250732421875,
        1314.234619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33766087889671326,
        0.03877443075180054,
        0.9404689073562622
      ],
      "plane_d": -787.0042724609375,
      "bbox_min": [
        872.10498046875,
        -3847.749267578125,
        1308.2762451171875
      ],
      "bbox_max": [
        887.9554443359375,
        -3840.5,
        1313.967041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8571716547012329,
        2.051517367362976e-05,
        -0.5150308609008789
      ],
      "plane_d": 1434.46826171875,
      "bbox_min": [
        884.76806640625,
        -3843.9951171875,
        1312.42431640625
      ],
      "bbox_max": [
        884.8291015625,
        -3842.944091796875,
        1312.52587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8571872711181641,
        2.205165628765826e-06,
        -0.5150048732757568
      ],
      "plane_d": 1434.377685546875,
      "bbox_min": [
        884.8077392578125,
        -3843.9912109375,
        1312.2236328125
      ],
      "bbox_max": [
        884.9496459960938,
        -3840.5,
        1312.4598388671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8571872711181641,
        2.205165628765826e-06,
        -0.5150048732757568
      ],
      "plane_d": 1434.377685546875,
      "bbox_min": [
        884.8291015625,
        -3843.9775390625,
        1311.8546142578125
      ],
      "bbox_max": [
        885.1713256835938,
        -3838.05615234375,
        1312.42431640625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3833.69970703125,
      "bbox_min": [
        884.55029296875,
        -3834.599853515625,
        1312.7581787109375
      ],
      "bbox_max": [
        885.9910888671875,
        -3833.699951171875,
        1313.5125732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8571709394454956,
        -1.0895269952015951e-05,
        -0.5150319933891296
      ],
      "plane_d": 1434.348388671875,
      "bbox_min": [
        884.55029296875,
        -3834.599853515625,
        1312.7581787109375
      ],
      "bbox_max": [
        884.62841796875,
        -3833.699951171875,
        1312.88818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8269209861755371,
        -0.3128008246421814,
        -0.46728700399398804
      ],
      "plane_d": -1330.948974609375,
      "bbox_min": [
        870.36083984375,
        -3875.85546875,
        1311.3729248046875
      ],
      "bbox_max": [
        905.0226440429688,
        -3840.5,
        1340.4117431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1575266718864441,
        -0.46814268827438354,
        -0.8694985508918762
      ],
      "plane_d": -802.760009765625,
      "bbox_min": [
        870.36083984375,
        -3875.85546875,
        1311.3729248046875
      ],
      "bbox_max": [
        905.0226440429688,
        -3840.5,
        1340.4117431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11617179214954376,
        -0.6955613493919373,
        0.7090123891830444
      ],
      "plane_d": -3743.6982421875,
      "bbox_min": [
        892.6578979492188,
        -3873.61376953125,
        1320.266357421875
      ],
      "bbox_max": [
        905.0226440429688,
        -3852.419921875,
        1340.2764892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5994213819503784,
        -0.1652565449476242,
        -0.7831885814666748
      ],
      "plane_d": -139.0738525390625,
      "bbox_min": [
        892.6578979492188,
        -3873.61376953125,
        1320.266357421875
      ],
      "bbox_max": [
        905.0226440429688,
        -3852.419921875,
        1340.2764892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5379992127418518,
        -0.1949385702610016,
        -0.8200950622558594
      ],
      "plane_d": -149.85986328125,
      "bbox_min": [
        892.6578979492188,
        -3873.61376953125,
        1320.266357421875
      ],
      "bbox_max": [
        905.0226440429688,
        -3852.419921875,
        1340.2764892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14234745502471924,
        -0.8204143047332764,
        0.553766667842865
      ],
      "plane_d": -3788.922607421875,
      "bbox_min": [
        892.6578979492188,
        -3873.61376953125,
        1323.93408203125
      ],
      "bbox_max": [
        905.0226440429688,
        -3852.419921875,
        1340.2764892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464263796806335,
        -0.11041845381259918,
        -0.7549442052841187
      ],
      "plane_d": -7.45172119140625,
      "bbox_min": [
        899.545654296875,
        -3865.5,
        1323.93408203125
      ],
      "bbox_max": [
        905.0226440429688,
        -3852.419921875,
        1340.2764892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31379979848861694,
        -0.46467113494873047,
        0.828015923500061
      ],
      "plane_d": -3189.373779296875,
      "bbox_min": [
        904.044677734375,
        -3865.5,
        1339.8031005859375
      ],
      "bbox_max": [
        905.0226440429688,
        -3864.375732421875,
        1340.2764892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5197157859802246,
        0.5526195168495178,
        0.6515422463417053
      ],
      "plane_d": 1735.7353515625,
      "bbox_min": [
        870.399658203125,
        -3875.85546875,
        1311.3729248046875
      ],
      "bbox_max": [
        904.843017578125,
        -3840.5,
        1340.4117431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14234745502471924,
        -0.8204143047332764,
        0.553766667842865
      ],
      "plane_d": -3788.922607421875,
      "bbox_min": [
        881.0609130859375,
        -3875.85546875,
        1316.495361328125
      ],
      "bbox_max": [
        894.5737915039062,
        -3857.018310546875,
        1334.1971435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4221769869327545,
        -0.8203184008598328,
        0.3858035206794739
      ],
      "plane_d": -3318.58740234375,
      "bbox_min": [
        881.0609130859375,
        -3875.85546875,
        1325.76318359375
      ],
      "bbox_max": [
        882.998046875,
        -3875.406005859375,
        1327.2835693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4221769869327545,
        -0.8203184008598328,
        0.3858035206794739
      ],
      "plane_d": -3318.58740234375,
      "bbox_min": [
        870.972900390625,
        -3875.57763671875,
        1312.8974609375
      ],
      "bbox_max": [
        888.7088623046875,
        -3856.922119140625,
        1327.2835693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6805790662765503,
        -0.6955103278160095,
        0.2303857058286667
      ],
      "plane_d": -2404.8681640625,
      "bbox_min": [
        870.972900390625,
        -3873.1640625,
        1319.7017822265625
      ],
      "bbox_max": [
        871.400634765625,
        -3872.72802734375,
        1320.369873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8270716071128845,
        0.3130333423614502,
        0.4668647050857544
      ],
      "plane_d": 1332.052734375,
      "bbox_min": [
        870.399658203125,
        -3872.907470703125,
        1311.3729248046875
      ],
      "bbox_max": [
        904.843017578125,
        -3840.5,
        1340.4117431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464263796806335,
        -0.11041845381259918,
        -0.7549442052841187
      ],
      "plane_d": -7.45172119140625,
      "bbox_min": [
        899.545654296875,
        -3865.3037109375,
        1323.93408203125
      ],
      "bbox_max": [
        904.843017578125,
        -3851.767333984375,
        1340.4117431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31379979848861694,
        -0.46467113494873047,
        0.828015923500061
      ],
      "plane_d": -3189.373779296875,
      "bbox_min": [
        904.044677734375,
        -3865.3037109375,
        1340.058349609375
      ],
      "bbox_max": [
        904.843017578125,
        -3864.27685546875,
        1340.4117431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15717488527297974,
        0.4684818983078003,
        0.8693795204162598
      ],
      "plane_d": 803.4276123046875,
      "bbox_min": [
        870.399658203125,
        -3872.907470703125,
        1311.3729248046875
      ],
      "bbox_max": [
        900.5994873046875,
        -3840.5,
        1325.3974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6805790662765503,
        -0.6955103278160095,
        0.2303857058286667
      ],
      "plane_d": -2404.8681640625,
      "bbox_min": [
        871.0113525390625,
        -3872.907470703125,
        1320.1248779296875
      ],
      "bbox_max": [
        871.277587890625,
        -3872.706298828125,
        1320.369873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.537996232509613,
        0.19495174288749695,
        0.8200937509536743
      ],
      "plane_d": 149.4195556640625,
      "bbox_min": [
        878.0218505859375,
        -3859.443115234375,
        1311.619873046875
      ],
      "bbox_max": [
        900.5994873046875,
        -3840.5,
        1325.3974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8571724891662598,
        -0.0,
        0.5150294899940491
      ],
      "plane_d": -1446.58837890625,
      "bbox_min": [
        883.2919311523438,
        -3858.379638671875,
        1311.62451171875
      ],
      "bbox_max": [
        899.1651611328125,
        -3840.5,
        1323.7054443359375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3846.699951171875,
      "bbox_min": [
        883.2919311523438,
        -3858.379638671875,
        1311.62451171875
      ],
      "bbox_max": [
        896.455810546875,
        -3840.5,
        1320.66748046875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.5379992127418518,
        -0.1949385702610016,
        -0.8200950622558594
      ],
      "plane_d": -149.85986328125,
      "bbox_min": [
        886.5247802734375,
        -3846.699951171875,
        1313.6805419921875
      ],
      "bbox_max": [
        895.1671752929688,
        -3840.5,
        1319.1285400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5994213819503784,
        -0.1652565449476242,
        -0.7831885814666748
      ],
      "plane_d": -139.0738525390625,
      "bbox_min": [
        886.5247802734375,
        -3846.699951171875,
        1313.6805419921875
      ],
      "bbox_max": [
        895.1671752929688,
        -3840.5,
        1319.1285400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464263796806335,
        -0.11041845381259918,
        -0.7549442052841187
      ],
      "plane_d": -7.45172119140625,
      "bbox_min": [
        886.5247802734375,
        -3846.699951171875,
        1313.6805419921875
      ],
      "bbox_max": [
        895.1671752929688,
        -3840.5,
        1319.1285400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.67186039686203,
        -0.038785167038440704,
        -0.7396616339683533
      ],
      "plane_d": 224.91888427734375,
      "bbox_min": [
        886.5247802734375,
        -3846.699951171875,
        1313.6805419921875
      ],
      "bbox_max": [
        893.6358642578125,
        -3840.5,
        1317.2760009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41011515259742737,
        -0.16526910662651062,
        -0.8969345688819885
      ],
      "plane_d": 178.967529296875,
      "bbox_min": [
        886.5247802734375,
        -3846.699951171875,
        1313.6805419921875
      ],
      "bbox_max": [
        890.28955078125,
        -3842.9501953125,
        1315.4312744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4715118110179901,
        -0.19493846595287323,
        -0.8600439429283142
      ],
      "plane_d": -38.141845703125,
      "bbox_min": [
        887.6517333984375,
        -3846.699951171875,
        1314.19580078125
      ],
      "bbox_max": [
        890.28955078125,
        -3842.9501953125,
        1315.4312744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5379992127418518,
        -0.1949385702610016,
        -0.8200950622558594
      ],
      "plane_d": -149.85986328125,
      "bbox_min": [
        883.2919311523438,
        -3858.379638671875,
        1313.43408203125
      ],
      "bbox_max": [
        895.0338134765625,
        -3846.699951171875,
        1320.66748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464263796806335,
        -0.11041845381259918,
        -0.7549442052841187
      ],
      "plane_d": -7.45172119140625,
      "bbox_min": [
        883.2919311523438,
        -3858.379638671875,
        1313.43408203125
      ],
      "bbox_max": [
        895.0338134765625,
        -3846.699951171875,
        1319.13818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5379992127418518,
        -0.1949385702610016,
        -0.8200950622558594
      ],
      "plane_d": -149.85986328125,
      "bbox_min": [
        894.109130859375,
        -3857.126220703125,
        1318.906494140625
      ],
      "bbox_max": [
        899.1651611328125,
        -3844.4013671875,
        1323.7054443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5994213819503784,
        -0.1652565449476242,
        -0.7831885814666748
      ],
      "plane_d": -139.0738525390625,
      "bbox_min": [
        894.2542724609375,
        -3857.01806640625,
        1318.906494140625
      ],
      "bbox_max": [
        899.1651611328125,
        -3844.4013671875,
        1323.7054443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464263796806335,
        -0.11041845381259918,
        -0.7549442052841187
      ],
      "plane_d": -7.45172119140625,
      "bbox_min": [
        895.0280151367188,
        -3852.174072265625,
        1318.906494140625
      ],
      "bbox_max": [
        898.855712890625,
        -3844.4013671875,
        1323.20166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5994143486022949,
        0.1652730256319046,
        0.7831904292106628
      ],
      "plane_d": 138.638671875,
      "bbox_min": [
        878.0218505859375,
        -3859.443115234375,
        1311.619873046875
      ],
      "bbox_max": [
        900.5994873046875,
        -3840.5,
        1325.3974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5994213819503784,
        -0.1652565449476242,
        -0.7831885814666748
      ],
      "plane_d": -139.0738525390625,
      "bbox_min": [
        895.5643920898438,
        -3853.439208984375,
        1319.3294677734375
      ],
      "bbox_max": [
        900.3335571289062,
        -3844.9677734375,
        1324.4075927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464263796806335,
        -0.11041845381259918,
        -0.7549442052841187
      ],
      "plane_d": -7.45172119140625,
      "bbox_min": [
        895.5643920898438,
        -3853.142578125,
        1319.3294677734375
      ],
      "bbox_max": [
        900.3335571289062,
        -3844.9677734375,
        1324.4075927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6464233994483948,
        0.11043132096529007,
        0.7549448013305664
      ],
      "plane_d": 7.00775146484375,
      "bbox_min": [
        878.0218505859375,
        -3859.443115234375,
        1311.619873046875
      ],
      "bbox_max": [
        900.5994873046875,
        -3840.5,
        1325.3974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6718626618385315,
        0.038783423602581024,
        0.7396596670150757
      ],
      "plane_d": -225.41082763671875,
      "bbox_min": [
        878.0218505859375,
        -3859.443115234375,
        1311.619873046875
      ],
      "bbox_max": [
        893.3464965820312,
        -3840.5,
        1318.03271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41011515259742737,
        -0.16526910662651062,
        -0.8969345688819885
      ],
      "plane_d": 178.967529296875,
      "bbox_min": [
        879.0513916015625,
        -3857.122314453125,
        1311.619873046875
      ],
      "bbox_max": [
        885.630859375,
        -3847.58056640625,
        1314.1678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4715118110179901,
        -0.19493846595287323,
        -0.8600439429283142
      ],
      "plane_d": -38.141845703125,
      "bbox_min": [
        882.843994140625,
        -3857.122314453125,
        1313.898681640625
      ],
      "bbox_max": [
        883.4320678710938,
        -3855.756103515625,
        1314.1678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47152096033096313,
        0.19495095312595367,
        0.8600360155105591
      ],
      "plane_d": 37.718505859375,
      "bbox_min": [
        882.12841796875,
        -3859.443115234375,
        1314.299072265625
      ],
      "bbox_max": [
        890.0347290039062,
        -3842.92529296875,
        1318.03271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1306.0,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1303.5
      ],
      "bbox_max": [
        905.9466552734375,
        -3829.76806640625,
        1315.0621337890625
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3852.61572265625,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1303.5
      ],
      "bbox_max": [
        905.9466552734375,
        -3829.76806640625,
        1306.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660241961479187,
        0.5000020861625671,
        0.0
      ],
      "plane_d": 2682.327880859375,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1303.5
      ],
      "bbox_max": [
        905.9466552734375,
        -3829.76806640625,
        1306.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660150170326233,
        -0.5000181198120117,
        -0.0
      ],
      "plane_d": -1158.05810546875,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1303.5
      ],
      "bbox_max": [
        905.9466552734375,
        -3829.76806640625,
        1306.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000181198120117,
        -0.8660150170326233,
        -0.0
      ],
      "plane_d": -2890.906982421875,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1303.5
      ],
      "bbox_max": [
        905.9466552734375,
        -3829.76806640625,
        1306.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 881.984375,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1303.5
      ],
      "bbox_max": [
        905.9466552734375,
        -3829.76806640625,
        1306.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000341534614563,
        -0.8660057783126831,
        0.0
      ],
      "plane_d": -3785.21826171875,
      "bbox_min": [
        885.284423828125,
        -3852.61572265625,
        1303.5
      ],
      "bbox_max": [
        905.9466552734375,
        -3829.76806640625,
        1306.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8659989833831787,
        -0.500045895576477,
        0.0
      ],
      "plane_d": -2707.104736328125,
      "bbox_min": [
        885.284423828125,
        -3849.315673828125,
        1303.5
      ],
      "bbox_max": [
        905.9466552734375,
        -3829.76806640625,
        1306.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8401622176170349,
        0.4850705862045288,
        0.24255697429180145
      ],
      "plane_d": 2285.4462890625,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3831.284423828125,
        1315.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4054.337646484375,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3831.284423828125,
        1315.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8401567339897156,
        -0.4850881099700928,
        0.24254131317138672
      ],
      "plane_d": -1440.2386474609375,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3831.284423828125,
        1315.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8401616811752319,
        -0.4850744605064392,
        0.2425515502691269
      ],
      "plane_d": -2920.953125,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3831.284423828125,
        1315.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1308.0,
      "bbox_min": [
        881.984375,
        -3837.5361328125,
        1306.0
      ],
      "bbox_max": [
        886.74853515625,
        -3831.284423828125,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.68598473072052,
        0.68598473072052,
        0.2425900548696518
      ],
      "plane_d": 1704.08837890625,
      "bbox_min": [
        881.984375,
        -3837.5361328125,
        1306.0
      ],
      "bbox_max": [
        886.74853515625,
        -3831.284423828125,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25108346343040466,
        -0.9370731115341187,
        0.2425924688577652
      ],
      "plane_d": -3690.923828125,
      "bbox_min": [
        881.984375,
        -3837.5361328125,
        1306.0
      ],
      "bbox_max": [
        883.984375,
        -3836.685791015625,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8401427865028381,
        0.4850882887840271,
        0.24258919060230255
      ],
      "plane_d": 804.7308959960938,
      "bbox_min": [
        881.984375,
        -3852.61572265625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3833.7314453125,
        1315.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1308.0,
      "bbox_min": [
        881.984375,
        -3849.315673828125,
        1306.0
      ],
      "bbox_max": [
        886.74853515625,
        -3843.064208984375,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6859846711158752,
        -0.6859846711158752,
        0.2425900399684906
      ],
      "plane_d": -3564.685546875,
      "bbox_min": [
        881.984375,
        -3849.315673828125,
        1306.0
      ],
      "bbox_max": [
        886.74853515625,
        -3843.064208984375,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25108692049980164,
        0.9370861053466797,
        0.24253863096237183
      ],
      "plane_d": 3506.483642578125,
      "bbox_min": [
        881.984375,
        -3843.914306640625,
        1306.0
      ],
      "bbox_max": [
        883.984375,
        -3843.064208984375,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3844.5,
      "bbox_min": [
        888.91259765625,
        -3852.61572265625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3833.7314453125,
        1315.0621337890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8571696281433105,
        -0.0,
        -0.5150341987609863
      ],
      "plane_d": 1437.7919921875,
      "bbox_min": [
        888.91259765625,
        -3844.5,
        1306.0
      ],
      "bbox_max": [
        896.2021484375,
        -3833.7314453125,
        1312.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3766965866088867,
        0.0,
        -0.9263367056846619
      ],
      "plane_d": 1547.4166259765625,
      "bbox_min": [
        888.91259765625,
        -3844.5,
        1307.0018310546875
      ],
      "bbox_max": [
        896.2021484375,
        -3836.0,
        1312.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5150126814842224,
        0.0,
        -0.8571826815605164
      ],
      "plane_d": 660.01904296875,
      "bbox_min": [
        888.91259765625,
        -3844.5,
        1307.0018310546875
      ],
      "bbox_max": [
        896.2021484375,
        -3836.0,
        1312.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.994769275188446,
        0.0,
        -0.10214781016111374
      ],
      "plane_d": -757.6213989257812,
      "bbox_min": [
        888.91259765625,
        -3844.5,
        1307.419921875
      ],
      "bbox_max": [
        896.2021484375,
        -3836.0,
        1312.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3835.999755859375,
      "bbox_min": [
        888.91259765625,
        -3836.0,
        1307.419921875
      ],
      "bbox_max": [
        892.7755737304688,
        -3836.0,
        1312.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.936329185962677,
        0.0,
        0.3511234521865845
      ],
      "plane_d": 375.7020568847656,
      "bbox_min": [
        891.0,
        -3834.5,
        1306.0
      ],
      "bbox_max": [
        891.9248046875,
        -3833.7314453125,
        1306.883544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3834.5,
      "bbox_min": [
        891.0,
        -3834.5,
        1306.0
      ],
      "bbox_max": [
        891.9248046875,
        -3834.5,
        1306.883544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3848.5,
      "bbox_min": [
        891.0,
        -3852.61572265625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3844.5,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3846.0,
      "bbox_min": [
        891.0,
        -3848.5,
        1306.0
      ],
      "bbox_max": [
        897.5,
        -3844.5,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.936329185962677,
        0.0,
        0.3511234521865845
      ],
      "plane_d": 375.7020568847656,
      "bbox_min": [
        891.0,
        -3848.5,
        1306.0
      ],
      "bbox_max": [
        897.5,
        -3846.0,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.936329185962677,
        0.0,
        0.3511234521865845
      ],
      "plane_d": -1298.922607421875,
      "bbox_min": [
        892.5,
        -3848.5,
        1306.0
      ],
      "bbox_max": [
        897.5,
        -3846.0,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1310.0,
      "bbox_min": [
        892.5,
        -3848.5,
        1310.0
      ],
      "bbox_max": [
        896.0,
        -3846.0,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1309.5,
      "bbox_min": [
        893.5,
        -3846.0,
        1308.0
      ],
      "bbox_max": [
        895.10009765625,
        -3844.5,
        1309.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -895.10009765625,
      "bbox_min": [
        895.10009765625,
        -3846.0,
        1308.0
      ],
      "bbox_max": [
        895.10009765625,
        -3844.5,
        1309.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 3418.894775390625,
      "bbox_min": [
        891.0,
        -3852.61572265625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3850.61572265625,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1307.9998779296875,
      "bbox_min": [
        891.0,
        -3852.61572265625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3850.61572265625,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9370661973953247,
        0.2511959671974182,
        0.24250248074531555
      ],
      "plane_d": 1485.979248046875,
      "bbox_min": [
        891.0,
        -3852.61572265625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3850.61572265625,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9370473027229309,
        0.2511909008026123,
        0.2425812929868698
      ],
      "plane_d": -190.16290283203125,
      "bbox_min": [
        896.680419921875,
        -3852.61572265625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3850.61572265625,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8401674032211304,
        -0.4851302206516266,
        0.2424197494983673
      ],
      "plane_d": -2942.95556640625,
      "bbox_min": [
        901.8515625,
        -3849.315673828125,
        1306.0
      ],
      "bbox_max": [
        905.4019775390625,
        -3844.405029296875,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8401501178741455,
        0.48509252071380615,
        0.2425554096698761
      ],
      "plane_d": 2307.477294921875,
      "bbox_min": [
        901.8515625,
        -3849.315673828125,
        1306.0
      ],
      "bbox_max": [
        904.5762939453125,
        -3844.405029296875,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1308.0,
      "bbox_min": [
        901.8515625,
        -3849.315673828125,
        1306.0
      ],
      "bbox_max": [
        904.5762939453125,
        -3845.48388671875,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6860393285751343,
        -0.6859249472618103,
        0.24260465800762177
      ],
      "plane_d": -2337.47314453125,
      "bbox_min": [
        901.8515625,
        -3849.315673828125,
        1306.0
      ],
      "bbox_max": [
        903.3154296875,
        -3847.769287109375,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9998886585235596,
        0.01492371130734682
      ],
      "plane_d": 3764.70751953125,
      "bbox_min": [
        870.36083984375,
        -3864.46044921875,
        1303.5
      ],
      "bbox_max": [
        932.5000610351562,
        -3784.58203125,
        1345.3497314453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9998886585235596,
        -0.0,
        0.01492371130734682
      ],
      "plane_d": -934.2691040039062,
      "bbox_min": [
        871.5820922851562,
        -3864.46044921875,
        1303.5
      ],
      "bbox_max": [
        932.5000610351562,
        -3784.58203125,
        1345.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998886585235596,
        0.01492371130734682
      ],
      "plane_d": -3806.449462890625,
      "bbox_min": [
        871.5820922851562,
        -3864.46044921875,
        1303.5
      ],
      "bbox_max": [
        914.88232421875,
        -3784.58203125,
        1345.3497314453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071607708930969,
        0.7070528864860535
      ],
      "plane_d": 1735.16259765625,
      "bbox_min": [
        872.0454711914062,
        -3786.972900390625,
        1331.5
      ],
      "bbox_max": [
        874.0,
        -3785.0,
        1333.333251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5300033688545227,
        0.8479955792427063
      ],
      "plane_d": 876.4476318359375,
      "bbox_min": [
        872.1909790039062,
        -3786.972900390625,
        1333.10009765625
      ],
      "bbox_max": [
        873.9761352539062,
        -3786.599853515625,
        1333.333251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9998886585235596,
        0.0,
        0.01492371130734682
      ],
      "plane_d": 892.5274658203125,
      "bbox_min": [
        873.97265625,
        -3787.41796875,
        1303.5
      ],
      "bbox_max": [
        914.5,
        -3784.58203125,
        1333.333251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071607708930969,
        0.7070528864860535
      ],
      "plane_d": 1735.16259765625,
      "bbox_min": [
        912.5,
        -3786.972900390625,
        1331.5
      ],
      "bbox_max": [
        914.5,
        -3785.0,
        1333.333251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5300033688545227,
        0.8479955792427063
      ],
      "plane_d": 876.4476318359375,
      "bbox_min": [
        912.5238647460938,
        -3786.972900390625,
        1333.10009765625
      ],
      "bbox_max": [
        914.4761352539062,
        -3786.599853515625,
        1333.333251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03996013477444649,
        0.8472556471824646,
        -0.5296801328659058
      ],
      "plane_d": 3879.40966796875,
      "bbox_min": [
        873.97265625,
        -3787.0,
        1331.5
      ],
      "bbox_max": [
        912.52734375,
        -3785.0,
        1333.333251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.313723623752594e-05,
        0.5300028920173645,
        0.8479958176612854
      ],
      "plane_d": 876.43408203125,
      "bbox_min": [
        873.97265625,
        -3786.973876953125,
        1333.10009765625
      ],
      "bbox_max": [
        883.9921875,
        -3786.599853515625,
        1333.333251953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9992004632949829,
        -0.03390716016292572,
        0.021187448874115944
      ],
      "plane_d": -1039.939208984375,
      "bbox_min": [
        883.9906005859375,
        -3786.973876953125,
        1333.255859375
      ],
      "bbox_max": [
        883.9921875,
        -3786.93896484375,
        1333.3330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03998080641031265,
        0.8472549915313721,
        -0.5296797156333923
      ],
      "plane_d": 3950.81396484375,
      "bbox_min": [
        873.9761352539062,
        -3787.0,
        1331.5
      ],
      "bbox_max": [
        912.52734375,
        -3785.0,
        1333.333251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.0861628513557662e-07,
        0.5300033688545227,
        0.8479955792427063
      ],
      "plane_d": 876.4478759765625,
      "bbox_min": [
        902.5078125,
        -3786.973876953125,
        1333.10009765625
      ],
      "bbox_max": [
        912.52734375,
        -3786.599853515625,
        1333.333251953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9992004036903381,
        -0.03390785679221153,
        0.021187884733080864
      ],
      "plane_d": 745.129150390625,
      "bbox_min": [
        902.5078125,
        -3786.973876953125,
        1333.255859375
      ],
      "bbox_max": [
        902.5093994140625,
        -3786.93896484375,
        1333.3330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -873.9999389648438,
      "bbox_min": [
        873.9761352539062,
        -3787.0,
        1331.5
      ],
      "bbox_max": [
        912.5238647460938,
        -3785.0,
        1333.10009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071607708930969,
        0.7070528864860535
      ],
      "plane_d": 1735.16259765625,
      "bbox_min": [
        912.5,
        -3786.599853515625,
        1331.5
      ],
      "bbox_max": [
        912.5238647460938,
        -3785.0,
        1333.10009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8989795446395874,
        -0.10984016209840775,
        -0.42399394512176514
      ],
      "plane_d": -672.552490234375,
      "bbox_min": [
        871.71923828125,
        -3864.46044921875,
        1311.3154296875
      ],
      "bbox_max": [
        913.303466796875,
        -3786.972900390625,
        1345.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8989804983139038,
        0.10984257608652115,
        -0.42399129271507263
      ],
      "plane_d": 171.134521484375,
      "bbox_min": [
        871.71923828125,
        -3864.46044921875,
        1311.3154296875
      ],
      "bbox_max": [
        913.303466796875,
        -3786.972900390625,
        1345.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8269209861755371,
        -0.3128008246421814,
        -0.46728700399398804
      ],
      "plane_d": -1330.948974609375,
      "bbox_min": [
        871.71923828125,
        -3864.46044921875,
        1311.3154296875
      ],
      "bbox_max": [
        913.303466796875,
        -3786.972900390625,
        1345.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8270716071128845,
        0.3130333423614502,
        0.4668647050857544
      ],
      "plane_d": 1332.052734375,
      "bbox_min": [
        871.71923828125,
        -3864.46044921875,
        1311.3154296875
      ],
      "bbox_max": [
        913.303466796875,
        -3786.972900390625,
        1345.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31379979848861694,
        -0.46467113494873047,
        0.828015923500061
      ],
      "plane_d": -3189.373779296875,
      "bbox_min": [
        900.33349609375,
        -3864.46044921875,
        1324.407470703125
      ],
      "bbox_max": [
        911.382080078125,
        -3845.60693359375,
        1343.98193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464263796806335,
        -0.11041845381259918,
        -0.7549442052841187
      ],
      "plane_d": -7.45172119140625,
      "bbox_min": [
        900.33349609375,
        -3854.030029296875,
        1324.407470703125
      ],
      "bbox_max": [
        911.382080078125,
        -3845.60693359375,
        1343.98193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4206838309764862,
        -0.16314196586608887,
        0.8924179673194885
      ],
      "plane_d": -2211.1826171875,
      "bbox_min": [
        910.5625,
        -3854.030029296875,
        1343.7503662109375
      ],
      "bbox_max": [
        911.382080078125,
        -3851.76904296875,
        1343.98193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4206838309764862,
        -0.16314196586608887,
        0.8924179673194885
      ],
      "plane_d": -2211.1826171875,
      "bbox_min": [
        902.8680419921875,
        -3853.923583984375,
        1325.9305419921875
      ],
      "bbox_max": [
        913.303466796875,
        -3838.238525390625,
        1345.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.42100927233695984,
        0.16318099200725555,
        0.8922572731971741
      ],
      "plane_d": -958.020263671875,
      "bbox_min": [
        912.85107421875,
        -3840.5,
        1344.90478515625
      ],
      "bbox_max": [
        913.303466796875,
        -3838.238525390625,
        1345.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3137572407722473,
        0.4646637439727783,
        0.8280361890792847
      ],
      "plane_d": 379.74853515625,
      "bbox_min": [
        902.6567993164062,
        -3840.5,
        1325.9302978515625
      ],
      "bbox_max": [
        910.99658203125,
        -3825.0537109375,
        1343.974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6718602776527405,
        0.03878645598888397,
        -0.7396615743637085
      ],
      "plane_d": 522.832763671875,
      "bbox_min": [
        902.6567993164062,
        -3840.5,
        1325.9302978515625
      ],
      "bbox_max": [
        904.6035766601562,
        -3831.298828125,
        1327.264404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464272141456604,
        0.11041920632123947,
        -0.7549433708190918
      ],
      "plane_d": 840.6734619140625,
      "bbox_min": [
        902.6567993164062,
        -3833.657958984375,
        1325.9302978515625
      ],
      "bbox_max": [
        903.73291015625,
        -3831.298828125,
        1326.7413330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6937709450721741,
        0.46813440322875977,
        -0.5472951531410217
      ],
      "plane_d": 1891.96923828125,
      "bbox_min": [
        871.71923828125,
        -3852.540771484375,
        1311.3154296875
      ],
      "bbox_max": [
        910.5625,
        -3786.972900390625,
        1343.974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3833.699951171875,
      "bbox_min": [
        871.71923828125,
        -3852.540771484375,
        1311.3154296875
      ],
      "bbox_max": [
        910.5625,
        -3786.972900390625,
        1343.974609375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.4715111553668976,
        0.19494083523750305,
        -0.8600438237190247
      ],
      "plane_d": 1459.18994140625,
      "bbox_min": [
        885.6347045898438,
        -3852.540771484375,
        1313.5125732421875
      ],
      "bbox_max": [
        904.579833984375,
        -3833.699951171875,
        1327.7890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4101139307022095,
        0.1652708202600479,
        -0.8969348073005676
      ],
      "plane_d": 1448.4075927734375,
      "bbox_min": [
        885.6347045898438,
        -3852.540771484375,
        1313.5125732421875
      ],
      "bbox_max": [
        904.579833984375,
        -3833.699951171875,
        1327.7890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8571724891662598,
        -0.0,
        0.5150294899940491
      ],
      "plane_d": -1446.58837890625,
      "bbox_min": [
        890.8538818359375,
        -3851.76708984375,
        1315.0205078125
      ],
      "bbox_max": [
        903.945068359375,
        -3834.685546875,
        1326.5775146484375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.5379993319511414,
        0.1949409544467926,
        -0.8200942873954773
      ],
      "plane_d": 1347.471435546875,
      "bbox_min": [
        890.8538818359375,
        -3844.4013671875,
        1315.0205078125
      ],
      "bbox_max": [
        895.2953491210938,
        -3838.563232421875,
        1318.906494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464263796806335,
        -0.11041845381259918,
        -0.7549442052841187
      ],
      "plane_d": -7.45172119140625,
      "bbox_min": [
        892.3897705078125,
        -3844.4013671875,
        1316.053955078125
      ],
      "bbox_max": [
        895.2953491210938,
        -3840.5,
        1318.906494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.67186039686203,
        -0.038785167038440704,
        -0.7396616339683533
      ],
      "plane_d": 224.91888427734375,
      "bbox_min": [
        892.3897705078125,
        -3843.109619140625,
        1316.053955078125
      ],
      "bbox_max": [
        895.2953491210938,
        -3840.5,
        1318.78173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6718602776527405,
        0.03878645598888397,
        -0.7396615743637085
      ],
      "plane_d": 522.832763671875,
      "bbox_min": [
        895.1671752929688,
        -3851.76708984375,
        1318.693115234375
      ],
      "bbox_max": [
        903.945068359375,
        -3838.46923828125,
        1326.5775146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.67186039686203,
        -0.038785167038440704,
        -0.7396616339683533
      ],
      "plane_d": 224.91888427734375,
      "bbox_min": [
        895.2421264648438,
        -3847.342529296875,
        1318.693115234375
      ],
      "bbox_max": [
        903.945068359375,
        -3840.5,
        1326.5775146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8571509718894958,
        1.3823939298163168e-05,
        0.5150652527809143
      ],
      "plane_d": -1446.563232421875,
      "bbox_min": [
        890.48974609375,
        -3841.0234375,
        1314.873046875
      ],
      "bbox_max": [
        904.0343017578125,
        -3833.699951171875,
        1326.631103515625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5379993319511414,
        0.1949409544467926,
        -0.8200942873954773
      ],
      "plane_d": 1347.471435546875,
      "bbox_min": [
        890.48974609375,
        -3838.646484375,
        1314.873046875
      ],
      "bbox_max": [
        891.2481079101562,
        -3837.602294921875,
        1315.52734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6718602776527405,
        0.03878645598888397,
        -0.7396615743637085
      ],
      "plane_d": 522.832763671875,
      "bbox_min": [
        895.1302490234375,
        -3841.0234375,
        1318.7620849609375
      ],
      "bbox_max": [
        904.0343017578125,
        -3834.18310546875,
        1326.631103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464272141456604,
        0.11041920632123947,
        -0.7549433708190918
      ],
      "plane_d": 840.6734619140625,
      "bbox_min": [
        895.1302490234375,
        -3841.0234375,
        1318.78173828125
      ],
      "bbox_max": [
        904.0343017578125,
        -3834.18408203125,
        1326.631103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.857175350189209,
        -1.2785068975063041e-05,
        0.515024721622467
      ],
      "plane_d": -1446.6337890625,
      "bbox_min": [
        890.2191162109375,
        -3838.261474609375,
        1314.7919921875
      ],
      "bbox_max": [
        902.9573364257812,
        -3833.699951171875,
        1325.9840087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6464272141456604,
        0.11041920632123947,
        -0.7549433708190918
      ],
      "plane_d": 840.6734619140625,
      "bbox_min": [
        890.2191162109375,
        -3838.261474609375,
        1314.7919921875
      ],
      "bbox_max": [
        895.1303100585938,
        -3833.699951171875,
        1319.21044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6718602776527405,
        0.03878645598888397,
        -0.7396615743637085
      ],
      "plane_d": 522.832763671875,
      "bbox_min": [
        894.984619140625,
        -3835.963623046875,
        1318.9678955078125
      ],
      "bbox_max": [
        902.9573364257812,
        -3833.699951171875,
        1325.9840087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464272141456604,
        0.11041920632123947,
        -0.7549433708190918
      ],
      "plane_d": 840.6734619140625,
      "bbox_min": [
        894.984619140625,
        -3835.963623046875,
        1318.9678955078125
      ],
      "bbox_max": [
        902.7921142578125,
        -3833.699951171875,
        1325.859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5994221568107605,
        0.1652582436800003,
        -0.7831876873970032
      ],
      "plane_d": 1130.2662353515625,
      "bbox_min": [
        889.9465942382812,
        -3837.36279296875,
        1314.9091796875
      ],
      "bbox_max": [
        893.4501342773438,
        -3833.699951171875,
        1318.0360107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5379993319511414,
        0.1949409544467926,
        -0.8200942873954773
      ],
      "plane_d": 1347.471435546875,
      "bbox_min": [
        889.8438720703125,
        -3834.70263671875,
        1315.3626708984375
      ],
      "bbox_max": [
        890.4043579101562,
        -3833.699951171875,
        1315.9013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.410110205411911,
        -0.1652764081954956,
        0.8969355821609497
      ],
      "plane_d": -1448.9232177734375,
      "bbox_min": [
        885.6347045898438,
        -3836.39501953125,
        1313.930419921875
      ],
      "bbox_max": [
        888.3704223632812,
        -3833.699951171875,
        1314.6846923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8571724891662598,
        -0.0,
        0.5150294899940491
      ],
      "plane_d": -1446.58837890625,
      "bbox_min": [
        895.3726196289062,
        -3844.27490234375,
        1316.7618408203125
      ],
      "bbox_max": [
        896.455810546875,
        -3833.699951171875,
        1318.564697265625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.03996013477444649,
        0.8472556471824646,
        -0.5296801328659058
      ],
      "plane_d": 3879.40966796875,
      "bbox_min": [
        871.71923828125,
        -3833.699951171875,
        1311.373046875
      ],
      "bbox_max": [
        910.5625,
        -3786.978759765625,
        1343.974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14243587851524353,
        0.8203388452529907,
        0.5538557767868042
      ],
      "plane_d": 2512.352294921875,
      "bbox_min": [
        871.71923828125,
        -3833.699951171875,
        1311.373046875
      ],
      "bbox_max": [
        910.5625,
        -3805.144775390625,
        1343.974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42211151123046875,
        0.8204054832458496,
        0.38569003343582153
      ],
      "plane_d": 2982.70263671875,
      "bbox_min": [
        871.71923828125,
        -3833.699951171875,
        1311.373046875
      ],
      "bbox_max": [
        910.5625,
        -3805.144775390625,
        1343.974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5197948217391968,
        0.5522056221961975,
        -0.6518298387527466
      ],
      "plane_d": 2507.17529296875,
      "bbox_min": [
        871.71923828125,
        -3833.699951171875,
        1311.373046875
      ],
      "bbox_max": [
        910.5625,
        -3805.144775390625,
        1343.974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33149731159210205,
        0.5522077083587646,
        -0.7649680972099304
      ],
      "plane_d": 2823.57568359375,
      "bbox_min": [
        871.71923828125,
        -3833.699951171875,
        1311.373046875
      ],
      "bbox_max": [
        910.5625,
        -3805.144775390625,
        1343.974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15753163397312164,
        0.4681376516819,
        -0.8695003390312195
      ],
      "plane_d": 2793.02294921875,
      "bbox_min": [
        871.71923828125,
        -3833.699951171875,
        1311.373046875
      ],
      "bbox_max": [
        910.5625,
        -3805.422607421875,
        1343.974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4101139307022095,
        0.1652708202600479,
        -0.8969348073005676
      ],
      "plane_d": 1448.4075927734375,
      "bbox_min": [
        871.7257690429688,
        -3833.699951171875,
        1311.373046875
      ],
      "bbox_max": [
        910.5625,
        -3805.422607421875,
        1343.974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464272141456604,
        0.11041920632123947,
        -0.7549433708190918
      ],
      "plane_d": 840.6734619140625,
      "bbox_min": [
        898.56689453125,
        -3833.657958984375,
        1323.63720703125
      ],
      "bbox_max": [
        902.8677978515625,
        -3825.714599609375,
        1326.0947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5994221568107605,
        0.1652582436800003,
        -0.7831876873970032
      ],
      "plane_d": 1130.2662353515625,
      "bbox_min": [
        898.56689453125,
        -3827.857666015625,
        1323.63720703125
      ],
      "bbox_max": [
        900.177734375,
        -3825.714599609375,
        1324.6051025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6938103437423706,
        -0.46848976612091064,
        0.5469410419464111
      ],
      "plane_d": -1893.311767578125,
      "bbox_min": [
        871.7257690429688,
        -3833.699951171875,
        1311.83154296875
      ],
      "bbox_max": [
        904.044677734375,
        -3805.422607421875,
        1340.058349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5994221568107605,
        0.1652582436800003,
        -0.7831876873970032
      ],
      "plane_d": 1130.2662353515625,
      "bbox_min": [
        892.9568481445312,
        -3827.857666015625,
        1320.2662353515625
      ],
      "bbox_max": [
        899.545654296875,
        -3822.381591796875,
        1323.93408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5379993319511414,
        0.1949409544467926,
        -0.8200942873954773
      ],
      "plane_d": 1347.471435546875,
      "bbox_min": [
        892.9568481445312,
        -3823.98193359375,
        1320.2662353515625
      ],
      "bbox_max": [
        894.85693359375,
        -3822.381591796875,
        1321.407958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5197308659553528,
        -0.5526170134544373,
        0.6515322923660278
      ],
      "plane_d": -2508.8994140625,
      "bbox_min": [
        871.7257690429688,
        -3833.699951171875,
        1311.83154296875
      ],
      "bbox_max": [
        903.4203491210938,
        -3805.422607421875,
        1334.1971435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6718626618385315,
        -0.03878342732787132,
        0.7396596670150757
      ],
      "plane_d": -523.3063354492188,
      "bbox_min": [
        871.7257690429688,
        -3833.699951171875,
        1311.83154296875
      ],
      "bbox_max": [
        903.4203491210938,
        -3805.422607421875,
        1327.2835693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6464234590530396,
        -0.11043132096529007,
        0.7549448609352112
      ],
      "plane_d": -841.2152099609375,
      "bbox_min": [
        871.7257690429688,
        -3833.699951171875,
        1311.83154296875
      ],
      "bbox_max": [
        903.34375,
        -3805.422607421875,
        1327.2835693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6464272141456604,
        0.11041920632123947,
        -0.7549433708190918
      ],
      "plane_d": 840.6734619140625,
      "bbox_min": [
        890.4046630859375,
        -3833.699951171875,
        1315.901611328125
      ],
      "bbox_max": [
        899.7994384765625,
        -3824.2783203125,
        1324.0865478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5994108319282532,
        -0.165276899933815,
        0.7831922173500061
      ],
      "plane_d": -1130.843994140625,
      "bbox_min": [
        871.7257690429688,
        -3833.699951171875,
        1311.83154296875
      ],
      "bbox_max": [
        899.823974609375,
        -3805.422607421875,
        1327.2835693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5994221568107605,
        0.1652582436800003,
        -0.7831876873970032
      ],
      "plane_d": 1130.2662353515625,
      "bbox_min": [
        888.8484497070312,
        -3833.699951171875,
        1315.53369140625
      ],
      "bbox_max": [
        894.9541625976562,
        -3822.724609375,
        1321.1751708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5379993319511414,
        0.1949409544467926,
        -0.8200942873954773
      ],
      "plane_d": 1347.471435546875,
      "bbox_min": [
        888.8484497070312,
        -3833.699951171875,
        1315.53369140625
      ],
      "bbox_max": [
        894.5738525390625,
        -3822.724609375,
        1320.9466552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5379993319511414,
        0.1949409544467926,
        -0.8200942873954773
      ],
      "plane_d": 1347.471435546875,
      "bbox_min": [
        871.7257690429688,
        -3833.699951171875,
        1311.83154296875
      ],
      "bbox_max": [
        894.55615234375,
        -3805.422607421875,
        1327.2835693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15718364715576172,
        -0.4684928059577942,
        0.8693721294403076
      ],
      "plane_d": -2795.00634765625,
      "bbox_min": [
        871.7257690429688,
        -3833.699951171875,
        1311.83154296875
      ],
      "bbox_max": [
        894.55615234375,
        -3808.850341796875,
        1321.766357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4715152382850647,
        -0.1949509084224701,
        0.860039234161377
      ],
      "plane_d": -1459.7088623046875,
      "bbox_min": [
        878.0218505859375,
        -3833.699951171875,
        1311.83154296875
      ],
      "bbox_max": [
        889.58642578125,
        -3821.556884765625,
        1318.03271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3651326298713684e-05,
        -0.5300138592720032,
        -0.8479889631271362
      ],
      "plane_d": -877.427978515625,
      "bbox_min": [
        872.107421875,
        -3795.82080078125,
        1332.1810302734375
      ],
      "bbox_max": [
        881.8134155273438,
        -3787.085205078125,
        1338.490478515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8480491638183594,
        0.5299175381660461
      ],
      "plane_d": -3927.656005859375,
      "bbox_min": [
        872.5999755859375,
        -3795.579833984375,
        1337.5999755859375
      ],
      "bbox_max": [
        873.60009765625,
        -3795.079833984375,
        1338.400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9922616481781006,
        -0.12416519969701767
      ],
      "plane_d": -3592.368896484375,
      "bbox_min": [
        872.107421875,
        -3787.10009765625,
        1332.1810302734375
      ],
      "bbox_max": [
        874.0,
        -3787.085205078125,
        1332.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3651326298713684e-05,
        -0.5300138592720032,
        -0.8479889631271362
      ],
      "plane_d": -877.427978515625,
      "bbox_min": [
        877.8637084960938,
        -3795.9189453125,
        1333.62109375
      ],
      "bbox_max": [
        883.8385009765625,
        -3789.2138671875,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.039961110800504684,
        -0.8473718166351318,
        0.5294942855834961
      ],
      "plane_d": -3889.60888671875,
      "bbox_min": [
        877.8637084960938,
        -3795.9189453125,
        1337.75048828125
      ],
      "bbox_max": [
        883.592041015625,
        -3795.224365234375,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -873.9999389648438,
      "bbox_min": [
        872.0454711914062,
        -3787.10009765625,
        1331.5
      ],
      "bbox_max": [
        874.0,
        -3786.985595703125,
        1332.483154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9922616481781006,
        -0.12416519969701767
      ],
      "plane_d": -3592.368896484375,
      "bbox_min": [
        872.0454711914062,
        -3787.10009765625,
        1331.5
      ],
      "bbox_max": [
        874.0,
        -3787.0,
        1332.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.313723623752594e-05,
        0.5300028920173645,
        0.8479958176612854
      ],
      "plane_d": 876.43408203125,
      "bbox_min": [
        879.5651245117188,
        -3790.938232421875,
        1332.4178466796875
      ],
      "bbox_max": [
        883.9921875,
        -3786.972900390625,
        1335.3477783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9992004632949829,
        -0.03390716016292572,
        0.021187448874115944
      ],
      "plane_d": -1039.939208984375,
      "bbox_min": [
        883.8270874023438,
        -3790.938232421875,
        1332.51171875
      ],
      "bbox_max": [
        883.9921875,
        -3786.972900390625,
        1335.3477783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.0861628513557662e-07,
        0.5300033688545227,
        0.8479955792427063
      ],
      "plane_d": 876.4478759765625,
      "bbox_min": [
        902.5078125,
        -3795.9189453125,
        1331.5
      ],
      "bbox_max": [
        914.5,
        -3786.972900390625,
        1338.6119384765625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        7.227063179016113e-07,
        -0.5300142765045166,
        -0.8479887247085571
      ],
      "plane_d": -877.4425048828125,
      "bbox_min": [
        902.5078125,
        -3795.9189453125,
        1331.5
      ],
      "bbox_max": [
        914.5,
        -3786.972900390625,
        1338.6119384765625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.03998178243637085,
        -0.8473711013793945,
        0.5294938683509827
      ],
      "plane_d": -3961.01513671875,
      "bbox_min": [
        902.5078125,
        -3795.9189453125,
        1332.23046875
      ],
      "bbox_max": [
        914.4088745117188,
        -3786.972900390625,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03998080641031265,
        0.8472549915313721,
        -0.5296797156333923
      ],
      "plane_d": 3950.81396484375,
      "bbox_min": [
        902.5078125,
        -3795.9189453125,
        1332.23046875
      ],
      "bbox_max": [
        912.5,
        -3786.972900390625,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992004036903381,
        -0.03390785679221153,
        0.021187884733080864
      ],
      "plane_d": 745.129150390625,
      "bbox_min": [
        902.5078125,
        -3795.9189453125,
        1332.51171875
      ],
      "bbox_max": [
        902.907958984375,
        -3786.972900390625,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 912.4999389648438,
      "bbox_min": [
        912.5,
        -3787.10009765625,
        1332.23046875
      ],
      "bbox_max": [
        912.5,
        -3786.985595703125,
        1332.483154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8480491638183594,
        0.5299175381660461
      ],
      "plane_d": -3927.656005859375,
      "bbox_min": [
        912.89990234375,
        -3795.59033203125,
        1337.5999755859375
      ],
      "bbox_max": [
        914.4088745117188,
        -3795.079833984375,
        1338.406494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.039961110800504684,
        -0.8473718166351318,
        0.5294942855834961
      ],
      "plane_d": -3887.990234375,
      "bbox_min": [
        914.10009765625,
        -3795.59033203125,
        1337.5999755859375
      ],
      "bbox_max": [
        914.4088745117188,
        -3795.079833984375,
        1338.406494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9922616481781006,
        -0.12416519969701767
      ],
      "plane_d": -3592.368896484375,
      "bbox_min": [
        912.5,
        -3787.10009765625,
        1331.5
      ],
      "bbox_max": [
        914.5,
        -3786.9892578125,
        1332.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 912.4999389648438,
      "bbox_min": [
        912.5,
        -3787.10009765625,
        1331.5
      ],
      "bbox_max": [
        912.5,
        -3786.9892578125,
        1332.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1306.0,
      "bbox_min": [
        886.9197998046875,
        -3846.13232421875,
        1303.5
      ],
      "bbox_max": [
        906.61572265625,
        -3827.984619140625,
        1315.0621337890625
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3827.984619140625,
      "bbox_min": [
        886.9197998046875,
        -3845.7021484375,
        1303.5
      ],
      "bbox_max": [
        906.61572265625,
        -3827.984619140625,
        1306.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660402297973633,
        0.4999743700027466,
        0.0
      ],
      "plane_d": 1133.236328125,
      "bbox_min": [
        886.9197998046875,
        -3845.7021484375,
        1303.5
      ],
      "bbox_max": [
        906.61572265625,
        -3827.984619140625,
        1306.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        3.699182707350701e-05,
        0.0
      ],
      "plane_d": -906.4735107421875,
      "bbox_min": [
        886.9197998046875,
        -3845.7021484375,
        1303.5
      ],
      "bbox_max": [
        906.61572265625,
        -3827.984619140625,
        1306.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999040365219116,
        0.8660310506820679,
        0.0
      ],
      "plane_d": 2866.362060546875,
      "bbox_min": [
        886.9197998046875,
        -3845.7021484375,
        1303.5
      ],
      "bbox_max": [
        906.61572265625,
        -3827.984619140625,
        1306.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999040365219116,
        0.8660310506820679,
        0.0
      ],
      "plane_d": 3760.64501953125,
      "bbox_min": [
        886.9197998046875,
        -3845.7021484375,
        1303.5
      ],
      "bbox_max": [
        906.61572265625,
        -3827.984619140625,
        1306.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3836.0,
      "bbox_min": [
        889.3628540039062,
        -3840.72216796875,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3827.984619140625,
        1315.0621337890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.994769275188446,
        0.0,
        -0.10214781016111374
      ],
      "plane_d": -757.6213989257812,
      "bbox_min": [
        892.7756958007812,
        -3840.72216796875,
        1307.0018310546875
      ],
      "bbox_max": [
        896.2021484375,
        -3836.0,
        1310.7763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5150126814842224,
        0.0,
        -0.8571826815605164
      ],
      "plane_d": 660.01904296875,
      "bbox_min": [
        892.7756958007812,
        -3839.121337890625,
        1307.0018310546875
      ],
      "bbox_max": [
        895.94677734375,
        -3836.0,
        1308.2894287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3766965866088867,
        0.0,
        -0.9263367056846619
      ],
      "plane_d": 1547.4166259765625,
      "bbox_min": [
        892.7756958007812,
        -3836.62109375,
        1307.0018310546875
      ],
      "bbox_max": [
        893.8037109375,
        -3836.0,
        1307.419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3832.0,
      "bbox_min": [
        891.0,
        -3836.0,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3827.984619140625,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3834.5,
      "bbox_min": [
        891.0,
        -3836.0,
        1306.0
      ],
      "bbox_max": [
        897.5,
        -3832.0,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.936329185962677,
        0.0,
        0.3511234521865845
      ],
      "plane_d": -1298.922607421875,
      "bbox_min": [
        891.0,
        -3834.5,
        1306.0
      ],
      "bbox_max": [
        897.5,
        -3832.0,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.936329185962677,
        0.0,
        0.3511234521865845
      ],
      "plane_d": 375.7020568847656,
      "bbox_min": [
        891.0,
        -3834.5,
        1306.0
      ],
      "bbox_max": [
        896.0,
        -3832.0,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1310.0,
      "bbox_min": [
        892.5,
        -3834.5,
        1310.0
      ],
      "bbox_max": [
        896.0,
        -3832.0,
        1310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1309.5,
      "bbox_min": [
        893.5,
        -3836.0,
        1308.0
      ],
      "bbox_max": [
        895.10009765625,
        -3834.5,
        1309.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 893.5,
      "bbox_min": [
        893.5,
        -3836.0,
        1308.0
      ],
      "bbox_max": [
        895.10009765625,
        -3834.5,
        1309.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -895.10009765625,
      "bbox_min": [
        895.10009765625,
        -3836.0,
        1308.0
      ],
      "bbox_max": [
        895.10009765625,
        -3834.5,
        1309.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 3396.93896484375,
      "bbox_min": [
        891.0,
        -3829.984619140625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3827.984619140625,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": -4032.382568359375,
      "bbox_min": [
        891.0,
        -3829.984619140625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3827.984619140625,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1308.0,
      "bbox_min": [
        891.0,
        -3829.984619140625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3827.984619140625,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9370402097702026,
        -0.2511889934539795,
        0.2426101565361023
      ],
      "plane_d": -443.49365234375,
      "bbox_min": [
        891.0,
        -3829.984619140625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3827.984619140625,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9370661973953247,
        -0.2511959671974182,
        0.24250248074531555
      ],
      "plane_d": -2119.393310546875,
      "bbox_min": [
        896.680419921875,
        -3829.984619140625,
        1306.0
      ],
      "bbox_max": [
        897.60009765625,
        -3827.984619140625,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8401899933815002,
        0.4850507378578186,
        0.24250061810016632
      ],
      "plane_d": 782.7047119140625,
      "bbox_min": [
        901.8515625,
        -3846.13232421875,
        1306.0
      ],
      "bbox_max": [
        906.61572265625,
        -3831.284423828125,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8401526212692261,
        -0.48506924510002136,
        0.24259306490421295
      ],
      "plane_d": -1418.281982421875,
      "bbox_min": [
        901.8515625,
        -3846.13232421875,
        1306.0
      ],
      "bbox_max": [
        906.61572265625,
        -3831.284423828125,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1308.0,
      "bbox_min": [
        901.8515625,
        -3837.5361328125,
        1306.0
      ],
      "bbox_max": [
        906.615478515625,
        -3831.284423828125,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6859846711158752,
        0.6859846711158752,
        0.2425900399684906
      ],
      "plane_d": 2931.040771484375,
      "bbox_min": [
        901.8515625,
        -3837.5361328125,
        1306.0
      ],
      "bbox_max": [
        906.615478515625,
        -3831.284423828125,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2511158287525177,
        -0.937079668045044,
        0.24253328144550323
      ],
      "plane_d": -4139.98876953125,
      "bbox_min": [
        904.61572265625,
        -3837.5361328125,
        1306.0
      ],
      "bbox_max": [
        906.615478515625,
        -3836.685791015625,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8401674032211304,
        -0.4851302206516266,
        0.2424197494983673
      ],
      "plane_d": -2942.95556640625,
      "bbox_min": [
        903.7960205078125,
        -3846.13232421875,
        1306.0
      ],
      "bbox_max": [
        906.61572265625,
        -3843.064208984375,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8401501178741455,
        0.48509252071380615,
        0.2425554096698761
      ],
      "plane_d": 2307.477294921875,
      "bbox_min": [
        903.7960205078125,
        -3846.13232421875,
        1306.0
      ],
      "bbox_max": [
        906.61572265625,
        -3843.064208984375,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.251090407371521,
        0.9370990991592407,
        0.24248480796813965
      ],
      "plane_d": 3057.506591796875,
      "bbox_min": [
        903.7960205078125,
        -3846.13232421875,
        1306.0
      ],
      "bbox_max": [
        906.61572265625,
        -3843.064208984375,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1308.0,
      "bbox_min": [
        903.7960205078125,
        -3846.13232421875,
        1308.0
      ],
      "bbox_max": [
        905.85693359375,
        -3843.646484375,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 924.5,
      "bbox_min": [
        914.39697265625,
        -3847.5,
        1316.0
      ],
      "bbox_max": [
        932.5000610351562,
        -3785.0,
        1338.6119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1323.5,
      "bbox_min": [
        924.5,
        -3847.5,
        1316.0
      ],
      "bbox_max": [
        932.5000610351562,
        -3788.0,
        1323.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1316.0,
      "bbox_min": [
        924.5,
        -3847.5,
        1316.0
      ],
      "bbox_max": [
        932.5000610351562,
        -3788.0,
        1323.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3832.5,
      "bbox_min": [
        924.5,
        -3847.5,
        1316.0
      ],
      "bbox_max": [
        932.5000610351562,
        -3788.0,
        1323.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3847.5,
      "bbox_min": [
        924.5,
        -3847.5,
        1316.0
      ],
      "bbox_max": [
        932.5000610351562,
        -3847.5,
        1323.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3788.0,
      "bbox_min": [
        924.5,
        -3803.0,
        1316.0
      ],
      "bbox_max": [
        932.5000610351562,
        -3788.0,
        1323.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3803.0,
      "bbox_min": [
        924.5,
        -3803.0,
        1316.0
      ],
      "bbox_max": [
        932.5000610351562,
        -3803.0,
        1323.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        2.067535831429268e-07,
        0.5300033092498779,
        0.8479955196380615
      ],
      "plane_d": 876.4473876953125,
      "bbox_min": [
        914.39697265625,
        -3795.918701171875,
        1331.5
      ],
      "bbox_max": [
        924.4921875,
        -3785.0,
        1338.6119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -7.22706431588449e-07,
        -0.5300142765045166,
        -0.8479887247085571
      ],
      "plane_d": -877.4412841796875,
      "bbox_min": [
        914.39697265625,
        -3795.918701171875,
        1331.5
      ],
      "bbox_max": [
        924.4921875,
        -3785.0,
        1338.6119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.03996013477444649,
        0.8472556471824646,
        -0.5296801328659058
      ],
      "plane_d": 3877.791259765625,
      "bbox_min": [
        914.39697265625,
        -3795.918701171875,
        1331.5
      ],
      "bbox_max": [
        924.4921875,
        -3785.0,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9992003440856934,
        -0.033903203904628754,
        0.021195320412516594
      ],
      "plane_d": -1080.40234375,
      "bbox_min": [
        914.39697265625,
        -3795.918701171875,
        1332.51171875
      ],
      "bbox_max": [
        924.4921875,
        -3786.938720703125,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.039961110800504684,
        -0.8473718166351318,
        0.5294942855834961
      ],
      "plane_d": -3887.990234375,
      "bbox_min": [
        914.39697265625,
        -3795.918701171875,
        1337.6065673828125
      ],
      "bbox_max": [
        924.092041015625,
        -3795.08984375,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071607708930969,
        0.7070528864860535
      ],
      "plane_d": 1735.16259765625,
      "bbox_min": [
        914.4761352539062,
        -3787.10009765625,
        1331.5
      ],
      "bbox_max": [
        914.5,
        -3785.0,
        1333.10009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9922616481781006,
        -0.12416519969701767
      ],
      "plane_d": -3592.368896484375,
      "bbox_min": [
        914.488037109375,
        -3787.10009765625,
        1331.5
      ],
      "bbox_max": [
        914.5,
        -3787.0,
        1332.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15718364715576172,
        -0.4684928059577942,
        0.8693721294403076
      ],
      "plane_d": -2795.00634765625,
      "bbox_min": [
        870.399658203125,
        -3821.688720703125,
        1313.124267578125
      ],
      "bbox_max": [
        871.8388671875,
        -3807.73583984375,
        1320.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33149731159210205,
        0.5522077083587646,
        -0.7649680972099304
      ],
      "plane_d": 2823.57568359375,
      "bbox_min": [
        870.972900390625,
        -3808.418212890625,
        1319.7017822265625
      ],
      "bbox_max": [
        871.8369140625,
        -3807.73583984375,
        1320.5743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42211151123046875,
        0.8204054832458496,
        0.38569003343582153
      ],
      "plane_d": 2982.70263671875,
      "bbox_min": [
        870.972900390625,
        -3808.293701171875,
        1319.7017822265625
      ],
      "bbox_max": [
        871.8369140625,
        -3807.73583984375,
        1320.5743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6805947422981262,
        0.6954851150512695,
        0.23041538894176483
      ],
      "plane_d": 2937.224853515625,
      "bbox_min": [
        870.972900390625,
        -3808.293701171875,
        1319.7017822265625
      ],
      "bbox_max": [
        871.400634765625,
        -3807.8359375,
        1320.369873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3312719166278839,
        -0.552604615688324,
        0.7647791504859924
      ],
      "plane_d": -2825.53125,
      "bbox_min": [
        871.277587890625,
        -3808.850341796875,
        1320.061279296875
      ],
      "bbox_max": [
        871.8388671875,
        -3807.90087890625,
        1320.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42211151123046875,
        0.8204054832458496,
        0.38569003343582153
      ],
      "plane_d": 2982.70263671875,
      "bbox_min": [
        871.277587890625,
        -3808.092529296875,
        1320.369873046875
      ],
      "bbox_max": [
        871.8388671875,
        -3807.90087890625,
        1320.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -3982.268310546875,
        1298.0
      ],
      "bbox_max": [
        867.5,
        -3975.0,
        1336.2239990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024374594911932945,
        0.3127957284450531,
        -0.9495076537132263
      ],
      "plane_d": 2420.17333984375,
      "bbox_min": [
        852.692626953125,
        -3872.83056640625,
        1308.381103515625
      ],
      "bbox_max": [
        873.2337036132812,
        -3784.990966796875,
        1356.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024375267326831818,
        -0.312801331281662,
        -0.9495057463645935
      ],
      "plane_d": 17.5645751953125,
      "bbox_min": [
        852.692626953125,
        -3872.83056640625,
        1308.381103515625
      ],
      "bbox_max": [
        873.2337036132812,
        -3784.990966796875,
        1356.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04817994311451912,
        0.1099231019616127,
        0.9927717447280884
      ],
      "plane_d": -918.677978515625,
      "bbox_min": [
        852.692626953125,
        -3872.83056640625,
        1308.381103515625
      ],
      "bbox_max": [
        873.2337036132812,
        -3784.990966796875,
        1356.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.98545902967453,
        -0.16317488253116608,
        0.047373950481414795
      ],
      "plane_d": 151.62124633789062,
      "bbox_min": [
        852.692626953125,
        -3855.9462890625,
        1308.7177734375
      ],
      "bbox_max": [
        856.0970458984375,
        -3838.239501953125,
        1310.7633056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0481853149831295,
        -0.10992397367954254,
        0.9927712678909302
      ],
      "plane_d": -1763.0047607421875,
      "bbox_min": [
        852.716552734375,
        -3872.83056640625,
        1308.381103515625
      ],
      "bbox_max": [
        873.2337036132812,
        -3784.990966796875,
        1356.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.985464334487915,
        0.16319337487220764,
        0.04720210283994675
      ],
      "plane_d": 1405.2681884765625,
      "bbox_min": [
        852.716552734375,
        -3840.5,
        1308.9493408203125
      ],
      "bbox_max": [
        856.0971069335938,
        -3825.0537109375,
        1310.763427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.023941127583384514,
        0.31303927302360535,
        0.9494383335113525
      ],
      "plane_d": -17.4273681640625,
      "bbox_min": [
        855.00537109375,
        -3872.83056640625,
        1309.30322265625
      ],
      "bbox_max": [
        873.2337036132812,
        -3784.990966796875,
        1356.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8784042596817017,
        -0.4647880494594574,
        0.11125610768795013
      ],
      "plane_d": -1186.0286865234375,
      "bbox_min": [
        855.00537109375,
        -3866.781005859375,
        1310.5924072265625
      ],
      "bbox_max": [
        863.212158203125,
        -3853.923583984375,
        1315.03857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6805790662765503,
        -0.6955103278160095,
        0.2303857058286667
      ],
      "plane_d": -2404.8681640625,
      "bbox_min": [
        861.52294921875,
        -3872.83056640625,
        1314.5087890625
      ],
      "bbox_max": [
        871.01953125,
        -3865.3037109375,
        1320.21484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5873505473136902,
        0.7066451907157898,
        0.3945528268814087
      ],
      "plane_d": 1670.4725341796875,
      "bbox_min": [
        865.3037109375,
        -3841.266845703125,
        1343.3607177734375
      ],
      "bbox_max": [
        873.2337036132812,
        -3839.733154296875,
        1356.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5873504877090454,
        -0.7066451907157898,
        0.3945527970790863
      ],
      "plane_d": -3757.26904296875,
      "bbox_min": [
        865.3037109375,
        -3841.266845703125,
        1343.3607177734375
      ],
      "bbox_max": [
        873.2337036132812,
        -3840.5,
        1356.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.023936456069350243,
        -0.31304171681404114,
        0.9494377374649048
      ],
      "plane_d": -2421.89453125,
      "bbox_min": [
        855.00537109375,
        -3832.135009765625,
        1309.30322265625
      ],
      "bbox_max": [
        872.6726684570312,
        -3784.990966796875,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15753163397312164,
        0.4681376516819,
        -0.8695003390312195
      ],
      "plane_d": 2793.02294921875,
      "bbox_min": [
        861.52294921875,
        -3821.986328125,
        1312.13818359375
      ],
      "bbox_max": [
        870.404296875,
        -3814.21923828125,
        1315.038330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6805947422981262,
        0.6954851150512695,
        0.23041538894176483
      ],
      "plane_d": 2937.224853515625,
      "bbox_min": [
        861.52294921875,
        -3822.243408203125,
        1312.5721435546875
      ],
      "bbox_max": [
        872.6726684570312,
        -3784.990966796875,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15753163397312164,
        0.4681376516819,
        -0.8695003390312195
      ],
      "plane_d": 2793.02294921875,
      "bbox_min": [
        863.2117919921875,
        -3819.594970703125,
        1313.447265625
      ],
      "bbox_max": [
        870.972900390625,
        -3808.16943359375,
        1319.7017822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03998080641031265,
        0.8472549915313721,
        -0.5296797156333923
      ],
      "plane_d": 3949.19482421875,
      "bbox_min": [
        862.0078125,
        -3795.9189453125,
        1330.9014892578125
      ],
      "bbox_max": [
        872.6726684570312,
        -3784.990966796875,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.227063179016113e-07,
        -0.5300142765045166,
        -0.8479887247085571
      ],
      "plane_d": -877.4425048828125,
      "bbox_min": [
        862.0078125,
        -3795.9189453125,
        1332.2999267578125
      ],
      "bbox_max": [
        872.6726684570312,
        -3786.594482421875,
        1338.6119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.03998178243637085,
        -0.8473711013793945,
        0.5294938683509827
      ],
      "plane_d": -3959.39599609375,
      "bbox_min": [
        862.407958984375,
        -3795.9189453125,
        1333.0946044921875
      ],
      "bbox_max": [
        872.6726684570312,
        -3786.594482421875,
        1338.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071607708930969,
        0.7070528864860535
      ],
      "plane_d": 1735.16259765625,
      "bbox_min": [
        872.0,
        -3786.599853515625,
        1333.0946044921875
      ],
      "bbox_max": [
        872.1909790039062,
        -3786.594482421875,
        1333.10009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8480491638183594,
        0.5299175381660461
      ],
      "plane_d": -3927.656005859375,
      "bbox_min": [
        872.39990234375,
        -3795.579833984375,
        1337.5999755859375
      ],
      "bbox_max": [
        872.6726684570312,
        -3795.079833984375,
        1338.400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071607708930969,
        0.7070528864860535
      ],
      "plane_d": 1735.16259765625,
      "bbox_min": [
        871.9910888671875,
        -3787.10009765625,
        1330.9014892578125
      ],
      "bbox_max": [
        872.1904907226562,
        -3784.990966796875,
        1333.10009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9998886585235596,
        0.01492371130734682
      ],
      "plane_d": 3764.70751953125,
      "bbox_min": [
        871.9910888671875,
        -3787.10009765625,
        1330.9014892578125
      ],
      "bbox_max": [
        872.1182250976562,
        -3784.990966796875,
        1333.10009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 871.9999389648438,
      "bbox_min": [
        871.9910888671875,
        -3787.10009765625,
        1330.9014892578125
      ],
      "bbox_max": [
        872.1182250976562,
        -3784.990966796875,
        1333.10009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9922616481781006,
        -0.12416519969701767
      ],
      "plane_d": -3592.368896484375,
      "bbox_min": [
        872.0,
        -3787.10009765625,
        1330.99951171875
      ],
      "bbox_max": [
        872.1182250976562,
        -3787.0,
        1332.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998886585235596,
        0.01492371130734682
      ],
      "plane_d": -3806.449462890625,
      "bbox_min": [
        872.0,
        -3787.007568359375,
        1330.99951171875
      ],
      "bbox_max": [
        872.0454711914062,
        -3787.0,
        1331.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9998886585235596,
        0.0,
        0.01492371130734682
      ],
      "plane_d": 852.031982421875,
      "bbox_min": [
        871.9910888671875,
        -3787.009033203125,
        1330.9014892578125
      ],
      "bbox_max": [
        872.0,
        -3784.990966796875,
        1331.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998886585235596,
        0.01492371130734682
      ],
      "plane_d": -3806.449462890625,
      "bbox_min": [
        871.9910888671875,
        -3787.009033203125,
        1330.9014892578125
      ],
      "bbox_max": [
        872.0,
        -3787.0,
        1331.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 995.0,
      "bbox_min": [
        830.0,
        -3725.0,
        1269.789306640625
      ],
      "bbox_max": [
        1002.5,
        -3622.5,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3622.5,
      "bbox_min": [
        995.0,
        -3647.5,
        1269.789306640625
      ],
      "bbox_max": [
        1002.5,
        -3622.5,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        830.0,
        -3725.0,
        1269.789306640625
      ],
      "bbox_max": [
        855.0,
        -3717.5,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -855.0,
      "bbox_min": [
        855.0,
        -3725.0,
        1269.789306640625
      ],
      "bbox_max": [
        855.0,
        -3717.5,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        910.0,
        -3715.0,
        1270.0
      ],
      "bbox_max": [
        915.0,
        -3710.0,
        1270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7489288449287415,
        0.6362079381942749,
        0.1853240579366684
      ],
      "plane_d": 3389.09228515625,
      "bbox_min": [
        1012.5,
        -4578.5986328125,
        1269.789306640625
      ],
      "bbox_max": [
        1403.209716796875,
        -3622.5,
        1763.13037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.88088059425354,
        0.43405717611312866,
        0.18879587948322296
      ],
      "plane_d": 2722.86279296875,
      "bbox_min": [
        1324.10791015625,
        -4177.52783203125,
        1269.789306640625
      ],
      "bbox_max": [
        1350.5107421875,
        -4138.1943359375,
        1426.417724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1020.0,
      "bbox_min": [
        1012.5,
        -4578.5986328125,
        1269.789306640625
      ],
      "bbox_max": [
        1020.0,
        -3622.5,
        1763.13037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3647.5,
      "bbox_min": [
        1012.5,
        -4578.5986328125,
        1269.789306640625
      ],
      "bbox_max": [
        1020.0,
        -3622.5,
        1763.13037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3622.5,
      "bbox_min": [
        1012.5,
        -3622.5,
        1269.789306640625
      ],
      "bbox_max": [
        1020.0,
        -3622.5,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6763855814933777,
        0.7353199124336243,
        -0.042511679232120514
      ],
      "plane_d": 4126.3173828125,
      "bbox_min": [
        1012.5,
        -4578.5986328125,
        1758.157470703125
      ],
      "bbox_max": [
        1012.7789916992188,
        -4578.0556640625,
        1763.13037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6043979525566101,
        0.36455777287483215,
        0.7083789706230164
      ],
      "plane_d": 1161.4814453125,
      "bbox_min": [
        823.5826416015625,
        -4289.5556640625,
        1145.9613037109375
      ],
      "bbox_max": [
        917.3206787109375,
        -3980.81982421875,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1269.7891845703125,
      "bbox_min": [
        853.9423217773438,
        -4289.5556640625,
        1257.294677734375
      ],
      "bbox_max": [
        917.3206787109375,
        -4161.1279296875,
        1269.789306640625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.434790700674057,
        -0.0790519118309021,
        0.8970550894737244
      ],
      "plane_d": -1089.6480712890625,
      "bbox_min": [
        853.9423217773438,
        -4289.5556640625,
        1257.294677734375
      ],
      "bbox_max": [
        899.1680297851562,
        -4161.1279296875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19393526017665863,
        0.1695787012577057,
        0.966246485710144
      ],
      "plane_d": -344.73529052734375,
      "bbox_min": [
        877.14208984375,
        -4289.5556640625,
        1264.756103515625
      ],
      "bbox_max": [
        899.1680297851562,
        -4161.1279296875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44666528701782227,
        -0.14888805150985718,
        0.8822259306907654
      ],
      "plane_d": -1359.3262939453125,
      "bbox_min": [
        881.4633178710938,
        -4289.5556640625,
        1264.756103515625
      ],
      "bbox_max": [
        892.37939453125,
        -4280.025390625,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9442156553268433,
        0.1135261207818985,
        0.3091418147087097
      ],
      "plane_d": 912.37890625,
      "bbox_min": [
        862.638671875,
        -4199.14404296875,
        1145.9613037109375
      ],
      "bbox_max": [
        896.9005126953125,
        -3980.81982421875,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19393526017665863,
        0.1695787012577057,
        0.966246485710144
      ],
      "plane_d": -344.73529052734375,
      "bbox_min": [
        877.14208984375,
        -4199.14404296875,
        1252.2049560546875
      ],
      "bbox_max": [
        896.9005126953125,
        -4090.610595703125,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -4000.0,
        1204.74951171875
      ],
      "bbox_max": [
        867.5,
        -3980.81982421875,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -3986.72607421875,
        1305.617919921875
      ],
      "bbox_max": [
        867.5,
        -3976.525634765625,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        867.5,
        -3978.600341796875,
        1328.2003173828125
      ],
      "bbox_max": [
        868.3491821289062,
        -3975.0,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        867.5,
        -3975.0,
        1336.2239990234375
      ],
      "bbox_max": [
        868.3491821289062,
        -3975.0,
        1362.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33050450682640076,
        0.9427840113639832,
        0.04387516900897026
      ],
      "plane_d": 3678.2255859375,
      "bbox_min": [
        618.569580078125,
        -3678.788818359375,
        722.1446533203125
      ],
      "bbox_max": [
        1131.030517578125,
        -3318.746826171875,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9874967336654663,
        -0.152632474899292,
        0.03941529616713524
      ],
      "plane_d": 195.71043395996094,
      "bbox_min": [
        795.9359130859375,
        -3678.788818359375,
        783.4901123046875
      ],
      "bbox_max": [
        913.3961791992188,
        -3640.341796875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.985414981842041,
        -0.16721226274967194,
        0.03158261999487877
      ],
      "plane_d": 147.77157592773438,
      "bbox_min": [
        795.9359130859375,
        -3678.788818359375,
        783.4901123046875
      ],
      "bbox_max": [
        913.3961791992188,
        -3640.341796875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7698917984962463,
        -0.3619711697101593,
        0.5255886912345886
      ],
      "plane_d": -1327.8792724609375,
      "bbox_min": [
        799.6431274414062,
        -3678.788818359375,
        866.916015625
      ],
      "bbox_max": [
        913.3961791992188,
        -3640.341796875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9855049252510071,
        -0.16633455455303192,
        0.033359821885824203
      ],
      "plane_d": 149.46546936035156,
      "bbox_min": [
        799.6431274414062,
        -3678.788818359375,
        866.916015625
      ],
      "bbox_max": [
        913.3961791992188,
        -3640.341796875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853616952896118,
        -0.16747599840164185,
        0.03184564411640167
      ],
      "plane_d": 146.53125,
      "bbox_min": [
        799.6431274414062,
        -3678.788818359375,
        866.916015625
      ],
      "bbox_max": [
        913.3961791992188,
        -3640.341796875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9873557686805725,
        -0.14738401770591736,
        0.05836522951722145
      ],
      "plane_d": 197.87875366210938,
      "bbox_min": [
        811.8483276367188,
        -3678.788818359375,
        1158.8548583984375
      ],
      "bbox_max": [
        913.3961791992188,
        -3640.341796875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1269.789306640625,
      "bbox_min": [
        862.091064453125,
        -3660.834716796875,
        1269.789306640625
      ],
      "bbox_max": [
        913.3961791992188,
        -3640.341796875,
        1269.789306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.021193169057369232,
        0.24223682284355164,
        0.9699856638908386
      ],
      "plane_d": -252.5858154296875,
      "bbox_min": [
        811.8483276367188,
        -3678.788818359375,
        1158.8548583984375
      ],
      "bbox_max": [
        817.8761596679688,
        -3669.109375,
        1161.51953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15874899923801422,
        0.26544034481048584,
        0.9509680271148682
      ],
      "plane_d": -257.1575927734375,
      "bbox_min": [
        811.8483276367188,
        -3678.788818359375,
        1159.2908935546875
      ],
      "bbox_max": [
        814.2550659179688,
        -3670.51025390625,
        1161.51953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43120837211608887,
        -0.0444025956094265,
        0.9011589884757996
      ],
      "plane_d": -901.566650390625,
      "bbox_min": [
        819.1124877929688,
        -3676.818115234375,
        1195.2711181640625
      ],
      "bbox_max": [
        833.2885131835938,
        -3667.064208984375,
        1218.2603759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9873557686805725,
        -0.14738401770591736,
        0.05836522951722145
      ],
      "plane_d": 197.87875366210938,
      "bbox_min": [
        819.1124877929688,
        -3676.818115234375,
        1195.2711181640625
      ],
      "bbox_max": [
        823.4071044921875,
        -3669.749267578125,
        1213.338623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9144766330718994,
        -0.1948431432247162,
        0.3546387553215027
      ],
      "plane_d": -393.5171813964844,
      "bbox_min": [
        819.6045532226562,
        -3676.810791015625,
        1205.30517578125
      ],
      "bbox_max": [
        823.4071044921875,
        -3669.749267578125,
        1213.338623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7648679614067078,
        0.6427456736564636,
        0.04307040572166443
      ],
      "plane_d": 1503.0753173828125,
      "bbox_min": [
        618.569580078125,
        -3670.808837890625,
        745.2877197265625
      ],
      "bbox_max": [
        1004.6134033203125,
        -3318.746826171875,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4704536199569702,
        -0.881197452545166,
        0.04652363061904907
      ],
      "plane_d": -2884.796875,
      "bbox_min": [
        618.569580078125,
        -3670.808837890625,
        746.9754638671875
      ],
      "bbox_max": [
        1000.55810546875,
        -3318.746826171875,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4407716691493988,
        0.8971563577651978,
        0.028826633468270302
      ],
      "plane_d": 2663.601318359375,
      "bbox_min": [
        618.569580078125,
        -3661.598388671875,
        746.9754638671875
      ],
      "bbox_max": [
        1000.55810546875,
        -3318.746826171875,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41525304317474365,
        0.8970658779144287,
        0.15112093091011047
      ],
      "plane_d": 2562.340087890625,
      "bbox_min": [
        618.569580078125,
        -3661.598388671875,
        746.9754638671875
      ],
      "bbox_max": [
        1000.55810546875,
        -3318.746826171875,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7507568001747131,
        0.6519565582275391,
        0.1063809022307396
      ],
      "plane_d": 1483.8448486328125,
      "bbox_min": [
        618.569580078125,
        -3661.598388671875,
        746.9754638671875
      ],
      "bbox_max": [
        1000.55810546875,
        -3318.746826171875,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.451077401638031,
        0.8152586817741394,
        0.3631562292575836
      ],
      "plane_d": 2002.1014404296875,
      "bbox_min": [
        618.569580078125,
        -3661.598388671875,
        746.9754638671875
      ],
      "bbox_max": [
        1000.55810546875,
        -3318.746826171875,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7598468661308289,
        0.634856104850769,
        0.13996553421020508
      ],
      "plane_d": 1377.916015625,
      "bbox_min": [
        618.569580078125,
        -3661.598388671875,
        746.9754638671875
      ],
      "bbox_max": [
        1000.55810546875,
        -3318.746826171875,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1269.7891845703125,
      "bbox_min": [
        618.569580078125,
        -3661.598388671875,
        783.2615356445312
      ],
      "bbox_max": [
        976.9523315429688,
        -3318.746826171875,
        1325.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.4867294132709503,
        -0.7350980639457703,
        0.47193774580955505
      ],
      "plane_d": -2854.24267578125,
      "bbox_min": [
        624.8507690429688,
        -3657.13916015625,
        783.2615356445312
      ],
      "bbox_max": [
        976.9523315429688,
        -3425.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.682898998260498,
        0.6571949124336243,
        0.31897294521331787
      ],
      "plane_d": 1311.3497314453125,
      "bbox_min": [
        624.8507690429688,
        -3657.13916015625,
        783.2615356445312
      ],
      "bbox_max": [
        976.9523315429688,
        -3425.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2449347823858261,
        0.16798976063728333,
        0.954875111579895
      ],
      "plane_d": -833.1099853515625,
      "bbox_min": [
        624.8507690429688,
        -3657.13916015625,
        783.2615356445312
      ],
      "bbox_max": [
        971.6315307617188,
        -3425.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4358859956264496,
        -0.8992010354995728,
        0.03795750439167023
      ],
      "plane_d": -2970.5244140625,
      "bbox_min": [
        624.8507690429688,
        -3657.13916015625,
        783.2615356445312
      ],
      "bbox_max": [
        798.377197265625,
        -3425.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -686.0,
      "bbox_min": [
        624.8507690429688,
        -3493.0,
        1269.5
      ],
      "bbox_max": [
        693.0,
        -3425.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 646.5,
      "bbox_min": [
        624.8507690429688,
        -3493.0,
        1269.5
      ],
      "bbox_max": [
        686.0,
        -3425.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3493.0,
      "bbox_min": [
        646.5,
        -3493.0,
        1269.5
      ],
      "bbox_max": [
        686.0,
        -3436.5,
        1269.789306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3436.5,
      "bbox_min": [
        646.5,
        -3446.5,
        1269.5
      ],
      "bbox_max": [
        686.0,
        -3436.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1951.96826171875,
      "bbox_min": [
        646.5,
        -3446.5,
        1269.5
      ],
      "bbox_max": [
        686.0,
        -3436.5,
        1269.789306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7249994277954102,
        0.6887494921684265,
        0.0
      ],
      "plane_d": 2842.4873046875,
      "bbox_min": [
        646.5,
        -3446.5,
        1269.5
      ],
      "bbox_max": [
        656.0,
        -3436.5,
        1269.789306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3425.0,
      "bbox_min": [
        624.8507690429688,
        -3425.0,
        1269.5
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -692.9999389648438,
      "bbox_min": [
        693.0,
        -3452.4765625,
        1269.5
      ],
      "bbox_max": [
        693.0,
        -3449.5,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.985414981842041,
        -0.16721226274967194,
        0.03158261999487877
      ],
      "plane_d": 147.77157592773438,
      "bbox_min": [
        795.4458618164062,
        -3657.13916015625,
        783.2615356445312
      ],
      "bbox_max": [
        798.377197265625,
        -3652.90087890625,
        891.35791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7698917984962463,
        -0.3619711697101593,
        0.5255886912345886
      ],
      "plane_d": -1327.8792724609375,
      "bbox_min": [
        816.192138671875,
        -3661.598388671875,
        1211.3790283203125
      ],
      "bbox_max": [
        862.091064453125,
        -3620.1201171875,
        1269.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1305.0,
      "bbox_min": [
        621.0,
        -3500.0,
        1269.789306640625
      ],
      "bbox_max": [
        693.0,
        -3417.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1288.0,
      "bbox_min": [
        622.7457275390625,
        -3500.0,
        1269.789306640625
      ],
      "bbox_max": [
        693.0,
        -3420.5,
        1305.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -646.5,
      "bbox_min": [
        622.7457275390625,
        -3493.0,
        1288.0
      ],
      "bbox_max": [
        686.0,
        -3420.5,
        1305.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1290.5,
      "bbox_min": [
        622.7457275390625,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        646.5,
        -3420.5,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3420.5,
      "bbox_min": [
        622.7457275390625,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        646.5,
        -3420.5,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3473.5,
      "bbox_min": [
        628.1732788085938,
        -3473.5,
        1288.0
      ],
      "bbox_max": [
        646.5,
        -3473.5,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25766265392303467,
        0.0,
        0.9662349224090576
      ],
      "plane_d": -1092.4251708984375,
      "bbox_min": [
        622.9568481445312,
        -3470.0,
        1290.5
      ],
      "bbox_max": [
        646.5,
        -3423.5,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1299.5,
      "bbox_min": [
        622.9568481445312,
        -3470.0,
        1290.5
      ],
      "bbox_max": [
        646.5,
        -3423.5,
        1303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 639.0,
      "bbox_min": [
        639.0,
        -3470.0,
        1299.5
      ],
      "bbox_max": [
        646.5,
        -3447.0,
        1303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957900047302,
        0.8574929237365723,
        0.0
      ],
      "plane_d": 3288.3994140625,
      "bbox_min": [
        639.0,
        -3470.0,
        1299.5
      ],
      "bbox_max": [
        646.5,
        -3447.0,
        1303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4705882668495178,
        -0.8823530077934265,
        -0.0
      ],
      "plane_d": -2757.52978515625,
      "bbox_min": [
        639.0,
        -3470.0,
        1299.5
      ],
      "bbox_max": [
        646.5,
        -3466.0,
        1303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1293.0,
      "bbox_min": [
        622.9568481445312,
        -3457.160400390625,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3423.5,
        1297.2666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        -0.0,
        0.3713906705379486
      ],
      "plane_d": -1060.9703369140625,
      "bbox_min": [
        622.9568481445312,
        -3457.160400390625,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3423.5,
        1293.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2699.3603515625,
      "bbox_min": [
        622.9568481445312,
        -3456.57470703125,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3423.5,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -3662.56201171875,
      "bbox_min": [
        623.2640380859375,
        -3456.57470703125,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3427.5,
        1293.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2730.0,
      "bbox_min": [
        626.4251708984375,
        -3456.57470703125,
        1290.5
      ],
      "bbox_max": [
        626.5,
        -3456.5,
        1290.68701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        623.0,
        -3427.0,
        1293.0
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1297.2666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3425.0,
      "bbox_min": [
        623.0,
        -3427.0,
        1293.0
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1297.2666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3427.0,
      "bbox_min": [
        623.0,
        -3427.0,
        1293.0
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1297.2666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 623.0,
      "bbox_min": [
        623.0,
        -3427.0,
        1293.1011962890625
      ],
      "bbox_max": [
        623.0,
        -3425.0,
        1296.7332763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 623.0,
      "bbox_min": [
        623.0,
        -3427.0,
        1296.7332763671875
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3425.0,
      "bbox_min": [
        623.0,
        -3427.0,
        1296.7332763671875
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3427.0,
      "bbox_min": [
        623.0,
        -3427.0,
        1296.7332763671875
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        625.0,
        -3427.0,
        1297.2666015625
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1303.5,
      "bbox_min": [
        646.5,
        -3493.0,
        1288.0
      ],
      "bbox_max": [
        686.0,
        -3436.5,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -686.0,
      "bbox_min": [
        646.5,
        -3493.0,
        1303.5
      ],
      "bbox_max": [
        686.0,
        -3444.0,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5144957900047302,
        0.8574929237365723
      ],
      "plane_d": 654.181396484375,
      "bbox_min": [
        646.5,
        -3493.0,
        1303.5
      ],
      "bbox_max": [
        686.0,
        -3444.0,
        1305.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3493.0,
      "bbox_min": [
        646.5,
        -3493.0,
        1303.5
      ],
      "bbox_max": [
        686.0,
        -3444.0,
        1305.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1951.96826171875,
      "bbox_min": [
        646.5,
        -3446.5,
        1303.5
      ],
      "bbox_max": [
        686.0,
        -3444.0,
        1305.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7250016331672668,
        0.6887471675872803,
        -5.527531811821973e-06
      ],
      "plane_d": 2842.488037109375,
      "bbox_min": [
        646.5,
        -3446.5,
        1303.5
      ],
      "bbox_max": [
        648.875,
        -3444.0,
        1305.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -686.0,
      "bbox_min": [
        646.5,
        -3493.0,
        1288.0
      ],
      "bbox_max": [
        686.0,
        -3436.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 683.5,
      "bbox_min": [
        646.5,
        -3493.0,
        1288.0
      ],
      "bbox_max": [
        686.0,
        -3436.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3493.0,
      "bbox_min": [
        683.5,
        -3493.0,
        1288.0
      ],
      "bbox_max": [
        686.0,
        -3444.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1951.9683837890625,
      "bbox_min": [
        683.5,
        -3446.5,
        1288.0
      ],
      "bbox_max": [
        686.0,
        -3444.0,
        1303.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        646.5,
        -3493.0,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3436.5,
        1303.5
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3493.0,
      "bbox_min": [
        646.5,
        -3493.0,
        1288.0
      ],
      "bbox_max": [
        650.0,
        -3442.815673828125,
        1303.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7249979376792908,
        0.6887509822845459,
        0.0
      ],
      "plane_d": 2842.491455078125,
      "bbox_min": [
        646.5,
        -3468.0,
        1288.0
      ],
      "bbox_max": [
        650.0,
        -3442.815673828125,
        1303.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.5144957900047302,
        0.8574929237365723
      ],
      "plane_d": 654.181396484375,
      "bbox_min": [
        648.875,
        -3444.0,
        1302.7894287109375
      ],
      "bbox_max": [
        650.0,
        -3442.815673828125,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 2168.0458984375,
      "bbox_min": [
        646.5,
        -3468.0,
        1290.5
      ],
      "bbox_max": [
        650.0,
        -3449.0,
        1298.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": -3587.246337890625,
      "bbox_min": [
        646.5,
        -3468.0,
        1290.5
      ],
      "bbox_max": [
        650.0,
        -3449.0,
        1298.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": -2151.12744140625,
      "bbox_min": [
        646.5,
        -3468.0,
        1293.5
      ],
      "bbox_max": [
        650.0,
        -3449.0,
        1298.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3468.0,
      "bbox_min": [
        646.5,
        -3468.0,
        1293.5
      ],
      "bbox_max": [
        650.0,
        -3449.0,
        1295.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3449.0,
      "bbox_min": [
        646.5,
        -3449.0,
        1293.5
      ],
      "bbox_max": [
        650.0,
        -3449.0,
        1295.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5144957900047302,
        0.8574929237365723
      ],
      "plane_d": 654.181396484375,
      "bbox_min": [
        650.0,
        -3493.0,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3436.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3491.5,
      "bbox_min": [
        650.0,
        -3493.0,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3436.5,
        1303.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3493.0,
      "bbox_min": [
        650.0,
        -3493.0,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3491.5,
        1303.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7848905920982361,
        0.0,
        -0.6196345090866089
      ],
      "plane_d": 287.88946533203125,
      "bbox_min": [
        657.0,
        -3493.0,
        1296.833251953125
      ],
      "bbox_max": [
        666.0,
        -3491.5,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7848905920982361,
        0.0,
        -0.6196345090866089
      ],
      "plane_d": 1326.2998046875,
      "bbox_min": [
        659.5,
        -3493.0,
        1296.833251953125
      ],
      "bbox_max": [
        666.0,
        -3491.5,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        659.5,
        -3493.0,
        1300.0
      ],
      "bbox_max": [
        663.5,
        -3491.5,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01624949462711811,
        -0.5443580746650696,
        -0.8386954665184021
      ],
      "plane_d": -772.0562744140625,
      "bbox_min": [
        650.0,
        -3491.5,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3436.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3436.5,
      "bbox_min": [
        650.0,
        -3444.0,
        1297.0
      ],
      "bbox_max": [
        683.5,
        -3436.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1951.96826171875,
      "bbox_min": [
        650.0,
        -3444.0,
        1297.0
      ],
      "bbox_max": [
        683.5,
        -3436.5,
        1303.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7250016331672668,
        0.6887471675872803,
        -5.527531811821973e-06
      ],
      "plane_d": 2842.488037109375,
      "bbox_min": [
        650.0,
        -3442.815673828125,
        1297.0
      ],
      "bbox_max": [
        676.26953125,
        -3436.5,
        1302.7894287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1297.0,
      "bbox_min": [
        667.2396850585938,
        -3436.76953125,
        1297.0
      ],
      "bbox_max": [
        676.26953125,
        -3436.5,
        1297.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1302.0,
      "bbox_min": [
        650.0,
        -3491.5,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3436.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -651.5,
      "bbox_min": [
        650.0,
        -3491.5,
        1302.0
      ],
      "bbox_max": [
        683.5,
        -3443.886474609375,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7302713990211487,
        -0.6831571459770203,
        0.0
      ],
      "plane_d": -2828.8359375,
      "bbox_min": [
        650.0,
        -3446.5,
        1302.0
      ],
      "bbox_max": [
        651.5,
        -3444.396728515625,
        1303.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3446.5,
      "bbox_min": [
        650.0,
        -3446.5,
        1302.0
      ],
      "bbox_max": [
        651.5,
        -3446.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3482.999755859375,
      "bbox_min": [
        651.5,
        -3491.5,
        1302.0
      ],
      "bbox_max": [
        683.5,
        -3481.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1302.5,
      "bbox_min": [
        654.5,
        -3483.0,
        1302.0
      ],
      "bbox_max": [
        682.2000732421875,
        -3481.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 441.9417724609375,
      "bbox_min": [
        654.5,
        -3483.0,
        1302.5
      ],
      "bbox_max": [
        682.0000610351562,
        -3481.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": 1384.51513671875,
      "bbox_min": [
        654.5,
        -3483.0,
        1302.5
      ],
      "bbox_max": [
        655.5,
        -3481.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 1116.944091796875,
      "bbox_min": [
        681.60009765625,
        -3483.0,
        1302.5
      ],
      "bbox_max": [
        682.0000610351562,
        -3481.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 1116.944091796875,
      "bbox_min": [
        682.0000610351562,
        -3483.0,
        1302.0
      ],
      "bbox_max": [
        682.2000732421875,
        -3481.5,
        1302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -651.89990234375,
      "bbox_min": [
        651.5,
        -3491.5,
        1302.0
      ],
      "bbox_max": [
        683.5,
        -3483.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3483.89990234375,
      "bbox_min": [
        681.60009765625,
        -3483.89990234375,
        1302.0
      ],
      "bbox_max": [
        683.5,
        -3483.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 1116.944091796875,
      "bbox_min": [
        681.60009765625,
        -3483.89990234375,
        1302.0
      ],
      "bbox_max": [
        682.2000732421875,
        -3483.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1302.5,
      "bbox_min": [
        654.5,
        -3467.0,
        1302.0
      ],
      "bbox_max": [
        682.2000732421875,
        -3465.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 441.9417724609375,
      "bbox_min": [
        654.5,
        -3467.0,
        1302.5
      ],
      "bbox_max": [
        682.0000610351562,
        -3465.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": 1384.51513671875,
      "bbox_min": [
        654.5,
        -3467.0,
        1302.5
      ],
      "bbox_max": [
        655.5,
        -3465.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 1116.944091796875,
      "bbox_min": [
        681.60009765625,
        -3467.0,
        1302.5
      ],
      "bbox_max": [
        682.0000610351562,
        -3465.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 1116.944091796875,
      "bbox_min": [
        682.0000610351562,
        -3467.0,
        1302.0
      ],
      "bbox_max": [
        682.2000732421875,
        -3465.5,
        1302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3480.5,
      "bbox_min": [
        681.60009765625,
        -3481.5,
        1302.0
      ],
      "bbox_max": [
        683.5,
        -3467.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3467.89990234375,
      "bbox_min": [
        681.60009765625,
        -3467.89990234375,
        1302.0
      ],
      "bbox_max": [
        683.5,
        -3467.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 1116.944091796875,
      "bbox_min": [
        681.60009765625,
        -3467.89990234375,
        1302.0
      ],
      "bbox_max": [
        682.2000732421875,
        -3467.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1302.5,
      "bbox_min": [
        654.5,
        -3451.0,
        1302.0
      ],
      "bbox_max": [
        682.2000732421875,
        -3449.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 441.9417724609375,
      "bbox_min": [
        654.5,
        -3451.0,
        1302.5
      ],
      "bbox_max": [
        682.0000610351562,
        -3449.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": 1384.51513671875,
      "bbox_min": [
        654.5,
        -3451.0,
        1302.5
      ],
      "bbox_max": [
        655.5,
        -3449.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 1116.944091796875,
      "bbox_min": [
        681.60009765625,
        -3451.0,
        1302.5
      ],
      "bbox_max": [
        682.0000610351562,
        -3449.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 1116.944091796875,
      "bbox_min": [
        682.0000610351562,
        -3451.0,
        1302.0
      ],
      "bbox_max": [
        682.2000732421875,
        -3449.5,
        1302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3464.5,
      "bbox_min": [
        681.60009765625,
        -3465.5,
        1302.0
      ],
      "bbox_max": [
        683.5,
        -3451.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3451.89990234375,
      "bbox_min": [
        681.60009765625,
        -3451.89990234375,
        1302.0
      ],
      "bbox_max": [
        683.5,
        -3451.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 1116.944091796875,
      "bbox_min": [
        681.60009765625,
        -3451.89990234375,
        1302.0
      ],
      "bbox_max": [
        682.2000732421875,
        -3451.0,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872039437294006,
        -0.7264645099639893,
        1.1068995263485704e-05
      ],
      "plane_d": -2034.43359375,
      "bbox_min": [
        651.5,
        -3449.5,
        1302.0
      ],
      "bbox_max": [
        683.5,
        -3443.886474609375,
        1303.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3448.5,
      "bbox_min": [
        651.5,
        -3449.5,
        1302.0
      ],
      "bbox_max": [
        683.5,
        -3443.886474609375,
        1303.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -651.89990234375,
      "bbox_min": [
        651.89990234375,
        -3448.5,
        1302.0
      ],
      "bbox_max": [
        651.89990234375,
        -3446.5,
        1303.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7302713990211487,
        -0.6831571459770203,
        0.0
      ],
      "plane_d": -2828.8359375,
      "bbox_min": [
        651.5,
        -3444.396728515625,
        1302.0
      ],
      "bbox_max": [
        651.977294921875,
        -3443.886474609375,
        1302.362060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3436.5,
      "bbox_min": [
        650.0,
        -3491.5,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3436.5,
        1302.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1951.9683837890625,
      "bbox_min": [
        650.0,
        -3491.5,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3436.5,
        1302.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.5787469744682312,
        -0.8155071139335632
      ],
      "plane_d": -931.3486328125,
      "bbox_min": [
        650.0,
        -3491.5,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3436.5,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1297.0,
      "bbox_min": [
        650.0,
        -3442.815673828125,
        1297.0
      ],
      "bbox_max": [
        676.341064453125,
        -3436.5,
        1301.4332275390625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7250016331672668,
        0.6887471675872803,
        -5.527531811821973e-06
      ],
      "plane_d": 2842.488037109375,
      "bbox_min": [
        650.0,
        -3442.815673828125,
        1297.0
      ],
      "bbox_max": [
        656.0,
        -3436.5,
        1301.4332275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7249979376792908,
        0.6887509822845459,
        0.0
      ],
      "plane_d": 2842.491455078125,
      "bbox_min": [
        650.0,
        -3491.5,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3436.5,
        1302.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1290.4998779296875,
      "bbox_min": [
        654.3375244140625,
        -3438.25,
        1290.5
      ],
      "bbox_max": [
        677.75,
        -3436.5,
        1297.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1297.0,
      "bbox_min": [
        654.3375244140625,
        -3438.25,
        1297.0
      ],
      "bbox_max": [
        677.75,
        -3436.841064453125,
        1297.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7302743196487427,
        -0.6831540465354919,
        0.0
      ],
      "plane_d": -2828.8271484375,
      "bbox_min": [
        650.0,
        -3491.5,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3438.25,
        1302.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7259408235549927,
        0.6877572536468506,
        0.0
      ],
      "plane_d": 1892.7816162109375,
      "bbox_min": [
        652.192138671875,
        -3442.072509765625,
        1290.5
      ],
      "bbox_max": [
        657.25,
        -3438.25,
        1297.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1297.0,
      "bbox_min": [
        652.192138671875,
        -3442.072509765625,
        1297.0
      ],
      "bbox_max": [
        657.25,
        -3438.25,
        1297.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1290.5,
      "bbox_min": [
        650.0,
        -3491.5,
        1290.0
      ],
      "bbox_max": [
        652.0,
        -3446.5,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -652.0,
      "bbox_min": [
        650.0,
        -3466.0,
        1290.0
      ],
      "bbox_max": [
        652.0,
        -3451.0,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3451.0,
      "bbox_min": [
        650.0,
        -3466.0,
        1290.0
      ],
      "bbox_max": [
        652.0,
        -3451.0,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3466.0,
      "bbox_min": [
        650.0,
        -3466.0,
        1290.0
      ],
      "bbox_max": [
        652.0,
        -3466.0,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3448.5,
      "bbox_min": [
        650.0,
        -3491.5,
        1301.5999755859375
      ],
      "bbox_max": [
        651.89990234375,
        -3446.5,
        1302.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3446.5,
      "bbox_min": [
        650.0,
        -3448.5,
        1301.5999755859375
      ],
      "bbox_max": [
        651.89990234375,
        -3446.5,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1301.5999755859375,
      "bbox_min": [
        650.0,
        -3448.5,
        1301.5999755859375
      ],
      "bbox_max": [
        651.89990234375,
        -3446.5,
        1301.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3489.5,
      "bbox_min": [
        650.0,
        -3491.5,
        1301.5999755859375
      ],
      "bbox_max": [
        651.89990234375,
        -3489.5,
        1302.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1301.5999755859375,
      "bbox_min": [
        650.0,
        -3491.5,
        1301.5999755859375
      ],
      "bbox_max": [
        651.89990234375,
        -3489.5,
        1301.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1289.0,
      "bbox_min": [
        651.0,
        -3466.0,
        1288.0
      ],
      "bbox_max": [
        654.0,
        -3451.0,
        1289.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -653.0,
      "bbox_min": [
        651.0,
        -3466.0,
        1289.0
      ],
      "bbox_max": [
        653.0,
        -3451.0,
        1289.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3451.0,
      "bbox_min": [
        651.0,
        -3466.0,
        1289.0
      ],
      "bbox_max": [
        653.0,
        -3451.0,
        1289.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1289.5,
      "bbox_min": [
        651.0,
        -3466.0,
        1289.0
      ],
      "bbox_max": [
        653.0,
        -3451.0,
        1289.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3466.0,
      "bbox_min": [
        651.0,
        -3466.0,
        1289.0
      ],
      "bbox_max": [
        653.0,
        -3451.0,
        1289.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        651.0,
        -3466.0,
        1289.0
      ],
      "bbox_max": [
        651.0,
        -3451.0,
        1289.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3451.0,
      "bbox_min": [
        652.0,
        -3466.0,
        1288.0
      ],
      "bbox_max": [
        654.0,
        -3451.0,
        1288.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1288.5,
      "bbox_min": [
        652.0,
        -3466.0,
        1288.0
      ],
      "bbox_max": [
        654.0,
        -3451.0,
        1288.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3466.0,
      "bbox_min": [
        652.0,
        -3466.0,
        1288.0
      ],
      "bbox_max": [
        654.0,
        -3451.0,
        1288.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        652.0,
        -3466.0,
        1288.0
      ],
      "bbox_max": [
        652.0,
        -3451.0,
        1288.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.230209082365036,
        -0.9731411933898926,
        0.0
      ],
      "plane_d": -3510.58203125,
      "bbox_min": [
        656.114013671875,
        -3483.89990234375,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3438.25,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9432709813117981,
        -0.3320240080356598,
        0.0
      ],
      "plane_d": -1775.648193359375,
      "bbox_min": [
        656.114013671875,
        -3446.485595703125,
        1288.0
      ],
      "bbox_max": [
        682.618408203125,
        -3438.25,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2792888283729553,
        0.6579123139381409,
        -0.6993920207023621
      ],
      "plane_d": 3355.552978515625,
      "bbox_min": [
        656.114013671875,
        -3446.0986328125,
        1288.0
      ],
      "bbox_max": [
        672.199951171875,
        -3438.25,
        1300.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9205074906349182,
        -0.39072489738464355,
        -0.00012681299995165318
      ],
      "plane_d": -740.7097778320312,
      "bbox_min": [
        656.114013671875,
        -3446.0986328125,
        1295.72265625
      ],
      "bbox_max": [
        661.582275390625,
        -3440.32763671875,
        1300.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9204936623573303,
        0.39075762033462524,
        -3.9387759898090735e-05
      ],
      "plane_d": 737.0474243164062,
      "bbox_min": [
        656.114013671875,
        -3446.0986328125,
        1295.72265625
      ],
      "bbox_max": [
        661.582275390625,
        -3440.32763671875,
        1300.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3200397193431854,
        0.7540257573127747,
        0.5736024975776672
      ],
      "plane_d": 2060.69189453125,
      "bbox_min": [
        656.114013671875,
        -3446.0986328125,
        1295.72265625
      ],
      "bbox_max": [
        661.582275390625,
        -3440.32763671875,
        1300.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13979041576385498,
        -0.329321950674057,
        0.9338124394416809
      ],
      "plane_d": -2439.86572265625,
      "bbox_min": [
        656.696533203125,
        -3446.0986328125,
        1295.72265625
      ],
      "bbox_max": [
        661.582275390625,
        -3441.700439453125,
        1300.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32006049156188965,
        -0.7540068626403809,
        -0.5736156702041626
      ],
      "plane_d": -2063.82373046875,
      "bbox_min": [
        657.003662109375,
        -3446.0986328125,
        1295.72265625
      ],
      "bbox_max": [
        661.582275390625,
        -3442.423583984375,
        1298.999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.18856710195541382,
        0.9820603728294373
      ],
      "plane_d": -1915.0023193359375,
      "bbox_min": [
        659.800048828125,
        -3444.5,
        1288.0
      ],
      "bbox_max": [
        672.199951171875,
        -3438.25,
        1289.800048828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3444.5,
      "bbox_min": [
        659.800048828125,
        -3444.5,
        1288.0
      ],
      "bbox_max": [
        670.0,
        -3438.25,
        1289.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9432708621025085,
        -0.3320239782333374,
        -0.0
      ],
      "plane_d": -519.2112426757812,
      "bbox_min": [
        659.800048828125,
        -3444.5,
        1288.0
      ],
      "bbox_max": [
        662.0,
        -3438.25,
        1289.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7313312292098999,
        0.6820225119590759,
        0.0
      ],
      "plane_d": 2845.07568359375,
      "bbox_min": [
        670.417724609375,
        -3446.485595703125,
        1288.0
      ],
      "bbox_max": [
        682.618408203125,
        -3438.25,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6820065379142761,
        -0.7313461899757385,
        -0.0
      ],
      "plane_d": -2056.446533203125,
      "bbox_min": [
        678.777587890625,
        -3446.485595703125,
        1288.0
      ],
      "bbox_max": [
        682.618408203125,
        -3442.694091796875,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.986820638179779,
        0.161818265914917,
        0.0
      ],
      "plane_d": 1227.271240234375,
      "bbox_min": [
        678.777587890625,
        -3446.485595703125,
        1288.0
      ],
      "bbox_max": [
        682.618408203125,
        -3442.694091796875,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6871962547302246,
        -0.7264718413352966,
        0.0
      ],
      "plane_d": -2034.4498291015625,
      "bbox_min": [
        678.777587890625,
        -3446.485595703125,
        1288.0
      ],
      "bbox_max": [
        682.618408203125,
        -3442.694091796875,
        1302.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1300.0631103515625,
      "bbox_min": [
        679.3438720703125,
        -3445.8173828125,
        1300.0631103515625
      ],
      "bbox_max": [
        682.618408203125,
        -3442.694091796875,
        1300.0631103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7313312292098999,
        -0.6820225119590759,
        0.0
      ],
      "plane_d": -2849.07568359375,
      "bbox_min": [
        678.777587890625,
        -3446.485595703125,
        1288.0
      ],
      "bbox_max": [
        682.249755859375,
        -3443.068603515625,
        1300.0631103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1300.0631103515625,
      "bbox_min": [
        678.777587890625,
        -3446.485595703125,
        1300.0631103515625
      ],
      "bbox_max": [
        682.249755859375,
        -3443.068603515625,
        1300.0631103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9204897284507751,
        0.3907667398452759,
        8.294370672956575e-06
      ],
      "plane_d": 1963.18994140625,
      "bbox_min": [
        670.417724609375,
        -3446.298583984375,
        1288.0
      ],
      "bbox_max": [
        680.162109375,
        -3438.25,
        1301.02880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3200828433036804,
        -0.7540095448493958,
        -0.573599636554718
      ],
      "plane_d": -1637.668701171875,
      "bbox_min": [
        670.417724609375,
        -3446.298583984375,
        1288.0
      ],
      "bbox_max": [
        680.162109375,
        -3438.25,
        1301.02880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27923837304115295,
        0.6578962206840515,
        -0.6994273662567139
      ],
      "plane_d": 2983.6962890625,
      "bbox_min": [
        670.417724609375,
        -3446.298583984375,
        1288.33544921875
      ],
      "bbox_max": [
        680.162109375,
        -3438.25,
        1301.02880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6872039437294006,
        -0.7264645099639893,
        1.1068995263485704e-05
      ],
      "plane_d": -2034.43359375,
      "bbox_min": [
        670.417724609375,
        -3446.298583984375,
        1295.72265625
      ],
      "bbox_max": [
        679.3439331054688,
        -3440.527587890625,
        1301.02880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13979041576385498,
        -0.329321950674057,
        0.9338124394416809
      ],
      "plane_d": -2253.730712890625,
      "bbox_min": [
        670.417724609375,
        -3446.298583984375,
        1295.72265625
      ],
      "bbox_max": [
        675.885986328125,
        -3441.900390625,
        1300.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9205191135406494,
        -0.39069756865501404,
        1.6525180399185047e-05
      ],
      "plane_d": -1967.003662109375,
      "bbox_min": [
        674.099853515625,
        -3446.298583984375,
        1295.72265625
      ],
      "bbox_max": [
        675.885986328125,
        -3442.09033203125,
        1300.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1290.5,
      "bbox_min": [
        674.25,
        -3443.068603515625,
        1288.33544921875
      ],
      "bbox_max": [
        680.162109375,
        -3438.25,
        1299.6485595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6871998906135559,
        -0.7264684438705444,
        0.0
      ],
      "plane_d": -2034.435546875,
      "bbox_min": [
        674.25,
        -3441.2373046875,
        1288.33544921875
      ],
      "bbox_max": [
        677.4078979492188,
        -3438.25,
        1290.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6871962547302246,
        -0.7264718413352966,
        0.0
      ],
      "plane_d": -2034.4498291015625,
      "bbox_min": [
        674.25,
        -3443.068603515625,
        1290.5
      ],
      "bbox_max": [
        680.162109375,
        -3438.25,
        1299.6485595703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1297.0,
      "bbox_min": [
        674.25,
        -3442.339599609375,
        1290.5
      ],
      "bbox_max": [
        680.162109375,
        -3438.25,
        1297.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.726024866104126,
        0.6876684427261353,
        0.0
      ],
      "plane_d": 2859.849365234375,
      "bbox_min": [
        678.5732421875,
        -3442.339599609375,
        1290.5
      ],
      "bbox_max": [
        680.162109375,
        -3440.662109375,
        1297.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1290.5,
      "bbox_min": [
        674.25,
        -3443.068603515625,
        1288.0
      ],
      "bbox_max": [
        679.3438720703125,
        -3438.25,
        1291.8272705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6871962547302246,
        -0.7264718413352966,
        0.0
      ],
      "plane_d": -2034.4498291015625,
      "bbox_min": [
        674.25,
        -3443.068603515625,
        1288.0
      ],
      "bbox_max": [
        679.3438720703125,
        -3438.25,
        1290.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6871962547302246,
        -0.7264718413352966,
        0.0
      ],
      "plane_d": -2034.4498291015625,
      "bbox_min": [
        678.5732421875,
        -3443.068603515625,
        1290.5
      ],
      "bbox_max": [
        679.3438720703125,
        -3441.90625,
        1291.8272705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.726024866104126,
        0.6876684427261353,
        0.0
      ],
      "plane_d": 2859.849365234375,
      "bbox_min": [
        678.5732421875,
        -3442.339599609375,
        1290.5
      ],
      "bbox_max": [
        678.9837036132812,
        -3441.90625,
        1291.2987060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6871962547302246,
        -0.7264718413352966,
        0.0
      ],
      "plane_d": -2034.4498291015625,
      "bbox_min": [
        681.60009765625,
        -3483.89990234375,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3446.027099609375,
        1302.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3464.5,
      "bbox_min": [
        681.60009765625,
        -3483.89990234375,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3448.5,
        1302.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1291.0,
      "bbox_min": [
        681.60009765625,
        -3483.89990234375,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3464.5,
        1302.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9284818768501282,
        0.0,
        0.3713776469230652
      ],
      "plane_d": 154.5189208984375,
      "bbox_min": [
        681.60009765625,
        -3483.89990234375,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3464.5,
        1291.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3480.5,
      "bbox_min": [
        681.60009765625,
        -3483.89990234375,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3467.89990234375,
        1291.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3483.89990234375,
      "bbox_min": [
        681.60009765625,
        -3483.89990234375,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3483.89990234375,
        1291.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3467.89990234375,
      "bbox_min": [
        681.60009765625,
        -3467.89990234375,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3467.89990234375,
        1291.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1300.5,
      "bbox_min": [
        682.2000732421875,
        -3483.89990234375,
        1300.5
      ],
      "bbox_max": [
        683.5,
        -3464.5,
        1302.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3467.89990234375,
      "bbox_min": [
        682.2000732421875,
        -3483.89990234375,
        1300.5
      ],
      "bbox_max": [
        683.5,
        -3464.5,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 1116.944091796875,
      "bbox_min": [
        682.2000732421875,
        -3467.89990234375,
        1300.5
      ],
      "bbox_max": [
        682.800048828125,
        -3464.5,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3480.5,
      "bbox_min": [
        682.2000732421875,
        -3483.89990234375,
        1300.5
      ],
      "bbox_max": [
        683.5,
        -3480.5,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3483.89990234375,
      "bbox_min": [
        682.2000732421875,
        -3483.89990234375,
        1300.5
      ],
      "bbox_max": [
        683.5,
        -3480.5,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 1116.944091796875,
      "bbox_min": [
        682.2000732421875,
        -3483.89990234375,
        1300.5
      ],
      "bbox_max": [
        682.800048828125,
        -3480.5,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3448.5,
      "bbox_min": [
        681.60009765625,
        -3451.89990234375,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3448.5,
        1302.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1291.0,
      "bbox_min": [
        681.60009765625,
        -3451.89990234375,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3448.5,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284818768501282,
        0.0,
        0.3713776469230652
      ],
      "plane_d": 154.5189208984375,
      "bbox_min": [
        681.60009765625,
        -3451.89990234375,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3448.5,
        1291.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3451.89990234375,
      "bbox_min": [
        681.60009765625,
        -3451.89990234375,
        1288.0
      ],
      "bbox_max": [
        683.5,
        -3451.89990234375,
        1291.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1300.5,
      "bbox_min": [
        682.2000732421875,
        -3451.89990234375,
        1300.5
      ],
      "bbox_max": [
        683.5,
        -3448.5,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3451.89990234375,
      "bbox_min": [
        682.2000732421875,
        -3451.89990234375,
        1300.5
      ],
      "bbox_max": [
        683.5,
        -3448.5,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 1116.944091796875,
      "bbox_min": [
        682.2000732421875,
        -3451.89990234375,
        1300.5
      ],
      "bbox_max": [
        682.800048828125,
        -3448.5,
        1302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 646.5,
      "bbox_min": [
        623.405029296875,
        -3500.0,
        1269.789306640625
      ],
      "bbox_max": [
        693.0,
        -3425.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -686.0,
      "bbox_min": [
        646.5,
        -3500.0,
        1269.789306640625
      ],
      "bbox_max": [
        693.0,
        -3436.5,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3493.0,
      "bbox_min": [
        646.5,
        -3500.0,
        1269.789306640625
      ],
      "bbox_max": [
        686.0,
        -3436.5,
        1288.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3436.5,
      "bbox_min": [
        646.5,
        -3446.5,
        1269.789306640625
      ],
      "bbox_max": [
        686.0,
        -3436.5,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1951.96826171875,
      "bbox_min": [
        646.5,
        -3446.5,
        1269.789306640625
      ],
      "bbox_max": [
        686.0,
        -3436.5,
        1288.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7249994277954102,
        0.6887494921684265,
        0.0
      ],
      "plane_d": 2842.4873046875,
      "bbox_min": [
        646.5,
        -3446.5,
        1269.789306640625
      ],
      "bbox_max": [
        656.0,
        -3436.5,
        1288.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1286.5,
      "bbox_min": [
        655.0,
        -3500.0,
        1286.5
      ],
      "bbox_max": [
        686.0,
        -3493.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 655.0,
      "bbox_min": [
        655.0,
        -3500.0,
        1286.5
      ],
      "bbox_max": [
        655.0,
        -3493.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5186123251914978,
        0.8550094962120056
      ],
      "plane_d": 703.5186767578125,
      "bbox_min": [
        686.0,
        -3500.0,
        1269.789306640625
      ],
      "bbox_max": [
        693.0,
        -3449.97705078125,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -692.9999389648438,
      "bbox_min": [
        686.0,
        -3500.0,
        1269.789306640625
      ],
      "bbox_max": [
        693.0,
        -3449.97705078125,
        1288.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.5189781785011292,
        -0.8547875881195068
      ],
      "plane_d": -706.35986328125,
      "bbox_min": [
        686.0,
        -3500.0,
        1269.789306640625
      ],
      "bbox_max": [
        693.0,
        -3452.4765625,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1286.5,
      "bbox_min": [
        686.0,
        -3500.0,
        1286.5
      ],
      "bbox_max": [
        693.0,
        -3480.0,
        1288.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3500.0,
      "bbox_min": [
        686.0,
        -3500.0,
        1286.5
      ],
      "bbox_max": [
        693.0,
        -3500.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3425.0,
      "bbox_min": [
        623.405029296875,
        -3427.0,
        1269.789306640625
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        623.6098022460938,
        -3427.0,
        1269.789306640625
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3427.0,
      "bbox_min": [
        623.6098022460938,
        -3427.0,
        1270.4896240234375
      ],
      "bbox_max": [
        625.0,
        -3427.0,
        1288.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7863183617591858,
        -0.0,
        0.6178215742111206
      ],
      "plane_d": -1326.0135498046875,
      "bbox_min": [
        621.0,
        -3493.0,
        1305.0
      ],
      "bbox_max": [
        683.5,
        -3417.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 648.5,
      "bbox_min": [
        621.0,
        -3493.0,
        1305.0
      ],
      "bbox_max": [
        661.0,
        -3417.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1312.0,
      "bbox_min": [
        648.5,
        -3493.0,
        1305.0
      ],
      "bbox_max": [
        661.0,
        -3446.5,
        1312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3446.5,
      "bbox_min": [
        648.5,
        -3493.0,
        1305.0
      ],
      "bbox_max": [
        661.0,
        -3446.5,
        1312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3493.0,
      "bbox_min": [
        648.5,
        -3493.0,
        1305.0
      ],
      "bbox_max": [
        661.0,
        -3493.0,
        1312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1324.0,
      "bbox_min": [
        621.0,
        -3467.5,
        1305.0
      ],
      "bbox_max": [
        627.0,
        -3417.5,
        1325.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -627.0,
      "bbox_min": [
        621.0,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        627.0,
        -3417.5,
        1325.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 621.0,
      "bbox_min": [
        621.0,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        627.0,
        -3417.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3417.5,
      "bbox_min": [
        621.0,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        627.0,
        -3417.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3434.5,
      "bbox_min": [
        621.4006958007812,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        627.0,
        -3434.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3450.5,
      "bbox_min": [
        623.0392456054688,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        627.0,
        -3450.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3467.5,
      "bbox_min": [
        624.7801513671875,
        -3467.5,
        1324.0
      ],
      "bbox_max": [
        627.0,
        -3467.5,
        1325.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3427.0,
      "bbox_min": [
        623.0,
        -3460.0,
        1305.0
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3425.0,
      "bbox_min": [
        623.0,
        -3427.0,
        1305.0
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 623.0,
      "bbox_min": [
        623.0,
        -3427.0,
        1305.0
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        625.0,
        -3427.0,
        1305.0
      ],
      "bbox_max": [
        625.0,
        -3425.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3458.0,
      "bbox_min": [
        623.9263305664062,
        -3460.0,
        1310.4761962890625
      ],
      "bbox_max": [
        625.0,
        -3458.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        624.1311645507812,
        -3460.0,
        1310.4761962890625
      ],
      "bbox_max": [
        625.0,
        -3458.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3460.0,
      "bbox_min": [
        624.1311645507812,
        -3460.0,
        1313.05615234375
      ],
      "bbox_max": [
        625.0,
        -3460.0,
        1324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7863183617591858,
        0.0,
        0.6178215742111206
      ],
      "plane_d": -278.63751220703125,
      "bbox_min": [
        671.0,
        -3493.0,
        1305.0
      ],
      "bbox_max": [
        683.5,
        -3446.5,
        1312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1312.0,
      "bbox_min": [
        671.0,
        -3493.0,
        1305.0
      ],
      "bbox_max": [
        683.5,
        -3446.5,
        1312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -683.5,
      "bbox_min": [
        671.0,
        -3493.0,
        1305.0
      ],
      "bbox_max": [
        683.5,
        -3446.5,
        1312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3446.5,
      "bbox_min": [
        671.0,
        -3493.0,
        1305.0
      ],
      "bbox_max": [
        683.5,
        -3446.5,
        1312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3493.0,
      "bbox_min": [
        671.0,
        -3493.0,
        1305.0
      ],
      "bbox_max": [
        683.5,
        -3493.0,
        1312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14844179153442383,
        0.9888140559196472,
        -0.014554573222994804
      ],
      "plane_d": 3743.525634765625,
      "bbox_min": [
        659.6268920898438,
        -3670.808837890625,
        783.349609375
      ],
      "bbox_max": [
        850.137451171875,
        -3571.96337890625,
        1250.02685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9874967336654663,
        -0.152632474899292,
        0.03941529616713524
      ],
      "plane_d": 195.71043395996094,
      "bbox_min": [
        795.6347045898438,
        -3670.808837890625,
        783.349609375
      ],
      "bbox_max": [
        850.137451171875,
        -3645.51611328125,
        1250.02685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.985414981842041,
        -0.16721226274967194,
        0.03158261999487877
      ],
      "plane_d": 147.77157592773438,
      "bbox_min": [
        795.6347045898438,
        -3670.808837890625,
        783.349609375
      ],
      "bbox_max": [
        850.137451171875,
        -3645.51611328125,
        1250.02685546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7698917984962463,
        -0.3619711697101593,
        0.5255886912345886
      ],
      "plane_d": -1327.8792724609375,
      "bbox_min": [
        816.192138671875,
        -3670.27978515625,
        1206.57275390625
      ],
      "bbox_max": [
        850.137451171875,
        -3645.51611328125,
        1250.02685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43120837211608887,
        -0.0444025956094265,
        0.9011589884757996
      ],
      "plane_d": -901.566650390625,
      "bbox_min": [
        816.192138671875,
        -3670.27978515625,
        1206.57275390625
      ],
      "bbox_max": [
        830.1616821289062,
        -3645.51611328125,
        1217.0018310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9144766330718994,
        -0.1948431432247162,
        0.3546387553215027
      ],
      "plane_d": -393.5171813964844,
      "bbox_min": [
        816.192138671875,
        -3670.27978515625,
        1206.57275390625
      ],
      "bbox_max": [
        821.9633178710938,
        -3645.51611328125,
        1212.946533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15874899923801422,
        0.26544034481048584,
        0.9509680271148682
      ],
      "plane_d": -257.1575927734375,
      "bbox_min": [
        798.377197265625,
        -3670.808837890625,
        891.35791015625
      ],
      "bbox_max": [
        816.6090698242188,
        -3646.8544921875,
        1159.5113525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9855049252510071,
        -0.16633455455303192,
        0.033359821885824203
      ],
      "plane_d": 149.46546936035156,
      "bbox_min": [
        798.377197265625,
        -3663.281494140625,
        891.35791015625
      ],
      "bbox_max": [
        800.9530639648438,
        -3652.90087890625,
        915.6940307617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.021193169057369232,
        0.24223682284355164,
        0.9699856638908386
      ],
      "plane_d": -252.5858154296875,
      "bbox_min": [
        808.0264892578125,
        -3670.51025390625,
        1153.3768310546875
      ],
      "bbox_max": [
        816.6090698242188,
        -3646.8544921875,
        1159.2908935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4468574523925781,
        -0.891202986240387,
        0.07794603705406189
      ],
      "plane_d": -2968.193115234375,
      "bbox_min": [
        659.6268920898438,
        -3652.90087890625,
        785.132080078125
      ],
      "bbox_max": [
        798.377197265625,
        -3571.96337890625,
        1021.3223266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4407716691493988,
        0.8971563577651978,
        0.028826633468270302
      ],
      "plane_d": 2663.601318359375,
      "bbox_min": [
        639.3869018554688,
        -3325.69189453125,
        765.8990478515625
      ],
      "bbox_max": [
        674.9246826171875,
        -3313.746337890625,
        949.6392211914062
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: cabdr1",
      "entity_class": "CSlidingDoor",
      "piece_name": "cabdr1",
      "offset": 461,
      "centroid": [
        -204.49999237060547,
        -2452.7999267578125,
        786.0
      ],
      "bbox_min": [
        -209.0,
        -2453.199951171875,
        780.0
      ],
      "bbox_max": [
        -199.99998474121094,
        -2452.39990234375,
        792.0
      ],
      "dimensions_source": {
        "span_x": 9.000015258789062,
        "span_y": 0.800048828125,
        "height_z": 12.0,
        "door_width": 9.000015258789062,
        "door_depth": 0.800048828125,
        "leaf_depth": 0.760048828125,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -209.0,
          -2453.199951171875,
          780.0
        ],
        [
          -209.0,
          -2452.39990234375,
          792.0
        ],
        [
          -209.0,
          -2453.199951171875,
          792.0
        ],
        [
          -209.0,
          -2452.39990234375,
          780.0
        ],
        [
          -199.99998474121094,
          -2453.199951171875,
          780.0
        ],
        [
          -199.99998474121094,
          -2452.39990234375,
          792.0
        ],
        [
          -199.99998474121094,
          -2453.199951171875,
          792.0
        ],
        [
          -199.99998474121094,
          -2452.39990234375,
          780.0
        ]
      ],
      "plane_distance": 780.0,
      "authentic_texture": "chkptdoor1"
    },
    {
      "tag": "CSlidingDoor piece: 2dr3",
      "entity_class": "CSlidingDoor",
      "piece_name": "2dr3",
      "offset": 6138,
      "centroid": [
        924.75,
        -3797.5,
        1303.5
      ],
      "bbox_min": [
        924.5,
        -3802.5,
        1298.0
      ],
      "bbox_max": [
        925.0,
        -3792.5,
        1309.0
      ],
      "dimensions_source": {
        "span_x": 0.5,
        "span_y": 10.0,
        "height_z": 11.0,
        "door_width": 10.0,
        "door_depth": 0.5,
        "leaf_depth": 0.46,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          924.5,
          -3802.5,
          1298.0
        ],
        [
          924.5,
          -3792.5,
          1309.0
        ],
        [
          924.5,
          -3802.5,
          1309.0
        ],
        [
          924.5,
          -3792.5,
          1298.0
        ],
        [
          925.0,
          -3802.5,
          1298.0
        ],
        [
          925.0,
          -3792.5,
          1309.0
        ],
        [
          925.0,
          -3802.5,
          1309.0
        ],
        [
          925.0,
          -3792.5,
          1298.0
        ]
      ],
      "plane_distance": -3802.5,
      "authentic_texture": "chkptdoor1"
    },
    {
      "tag": "CSlidingDoor piece: 2dr4",
      "entity_class": "CSlidingDoor",
      "piece_name": "2dr4",
      "offset": 7237,
      "centroid": [
        972.5,
        -3827.25,
        1299.25
      ],
      "bbox_min": [
        971.5,
        -3832.0,
        1295.0
      ],
      "bbox_max": [
        973.5,
        -3822.5,
        1303.5
      ],
      "dimensions_source": {
        "span_x": 2.0,
        "span_y": 9.5,
        "height_z": 8.5,
        "door_width": 9.5,
        "door_depth": 2.0,
        "leaf_depth": 1.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          971.5,
          -3832.0,
          1295.0
        ],
        [
          971.5,
          -3822.5,
          1303.5
        ],
        [
          971.5,
          -3832.0,
          1303.5
        ],
        [
          971.5,
          -3822.5,
          1295.0
        ],
        [
          973.5,
          -3832.0,
          1295.0
        ],
        [
          973.5,
          -3822.5,
          1303.5
        ],
        [
          973.5,
          -3832.0,
          1303.5
        ],
        [
          973.5,
          -3822.5,
          1295.0
        ]
      ],
      "plane_distance": 971.5,
      "authentic_texture": "chkptdoor1"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 8296,
      "centroid": [
        958.75,
        -3827.0,
        1325.0
      ],
      "bbox_min": [
        954.5,
        -3832.0,
        1325.0
      ],
      "bbox_max": [
        963.0,
        -3822.0,
        1325.0
      ],
      "dimensions_source": {
        "span_x": 8.5,
        "span_y": 10.0,
        "height_z": 0.0,
        "door_width": 10.0,
        "door_depth": 8.5,
        "leaf_depth": 8.5,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          954.5,
          -3832.0,
          1325.0
        ],
        [
          963.0,
          -3832.0,
          1325.0
        ],
        [
          954.5,
          -3822.0,
          1325.0
        ],
        [
          963.0,
          -3822.0,
          1325.0
        ]
      ],
      "plane_distance": -1325.0,
      "authentic_texture": "chkptroofgrate1-t"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 8983,
      "centroid": [
        -217.5,
        -2442.5,
        795.5
      ],
      "bbox_min": [
        -220.0,
        -2445.0,
        795.5
      ],
      "bbox_max": [
        -215.0,
        -2440.0,
        795.5
      ],
      "dimensions_source": {
        "span_x": 5.0,
        "span_y": 5.0,
        "height_z": 0.0,
        "door_width": 5.0,
        "door_depth": 5.0,
        "leaf_depth": 5.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -220.0,
          -2445.0,
          795.5
        ],
        [
          -220.0,
          -2440.0,
          795.5
        ],
        [
          -215.0,
          -2445.0,
          795.5
        ],
        [
          -215.0,
          -2440.0,
          795.5
        ]
      ],
      "plane_distance": 795.5,
      "authentic_texture": "chkptroofgrate1-t"
    },
    {
      "tag": "CSlidingDoor piece: m9gate",
      "entity_class": "CSlidingDoor",
      "piece_name": "m9gate",
      "offset": 14432,
      "centroid": [
        953.75,
        -3730.0,
        1277.5
      ],
      "bbox_min": [
        947.5,
        -3732.0,
        1270.0
      ],
      "bbox_max": [
        960.0,
        -3728.0,
        1285.0
      ],
      "dimensions_source": {
        "span_x": 12.5,
        "span_y": 4.0,
        "height_z": 15.0,
        "door_width": 12.5,
        "door_depth": 4.0,
        "leaf_depth": 3.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          947.5,
          -3732.0,
          1270.0
        ],
        [
          947.5,
          -3728.0,
          1285.0
        ],
        [
          947.5,
          -3732.0,
          1285.0
        ],
        [
          947.5,
          -3728.0,
          1270.0
        ],
        [
          960.0,
          -3732.0,
          1270.0
        ],
        [
          960.0,
          -3728.0,
          1285.0
        ],
        [
          960.0,
          -3732.0,
          1285.0
        ],
        [
          960.0,
          -3728.0,
          1270.0
        ]
      ],
      "plane_distance": -3732.0,
      "authentic_texture": "spkwaffle1"
    }
  ],
  "tutorial_messages": []
}